import { defineComponent, computed, ref, onMounted, onUnmounted, watch, nextTick, resolveComponent, openBlock, createBlock, createSlots, withCtx, renderSlot, createElementVNode, createElementBlock, Fragment, renderList, mergeProps, createTextVNode, toDisplayString, withModifiers, normalizeStyle, withDirectives, vShow, createVNode, createCommentVNode, unref, normalizeClass, withKeys, onBeforeUnmount, inject, createApp, onBeforeMount, resolveDynamicComponent, getCurrentInstance, toRaw, provide, reactive, markRaw, h, vModelText, toRefs, onUpdated, watchEffect, useSlots, createStaticVNode, normalizeProps } from 'vue';
import antd, { Button, Modal, DatePicker, message, Input, Select, Divider, Spin, Cascader, Checkbox, Tooltip, Popconfirm, Table, Switch, RadioGroup, AutoComplete, Popover, Textarea, Pagination, Alert, notification, Avatar, Collapse, Dropdown, Menu, Breadcrumb, BreadcrumbItem, Image, Tabs, Radio } from 'ant-design-vue';
import _, { debounce, cloneDeep, isEqual, omit } from 'lodash';
import { LeftOutlined, DownOutlined, PlusOutlined, UpOutlined, FormOutlined, ClockCircleFilled, EllipsisOutlined, CheckOutlined, ClockCircleOutlined, ToTopOutlined, CheckCircleOutlined, MinusCircleOutlined, CloseOutlined, ArrowRightOutlined, UserOutlined, RetweetOutlined, LinkOutlined, UploadOutlined, CaretDownFilled, InfoCircleOutlined, RightOutlined, ExclamationCircleFilled, SearchOutlined, HomeFilled, CopyOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import { createI18n } from 'vue-i18n';
import axios from 'axios';
import 'core-js/modules/es.array.push.js';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { AgGridVue } from '@ag-grid-community/vue3';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { CsvExportModule } from '@ag-grid-community/csv-export';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { MultiFilterModule } from '@ag-grid-enterprise/multi-filter';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { ViewportRowModelModule } from '@ag-grid-enterprise/viewport-row-model';
import { LicenseManager } from '@ag-grid-enterprise/core';
import * as $math from 'mathjs';
import Sortable from 'sortablejs';
import { FkColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode, Navigation, Thumbs, Autoplay, Pagination as Pagination$1 } from 'swiper';
import { useRoute, useRouter } from 'vue-router';

/**
 * 参数说明:
 * visible: boolean, 是否显示弹框
 * btns: IBtnItem[], 自定义底部按钮组(不传则展示默认按钮, 默认按钮参考antd按钮组件)
 *       示例: [{ text: '上传', type: 'primary', onClick: (ev) => {
                    visibleRef.value = true;
                    // 提交
                    // submitUpload(submitData);
                  }
                }]
                // onClick: 按钮点击事件(不传则默认关闭弹框)
 * 支持传入antd按钮相关参数
 */
var script$1N = defineComponent({
    name: 'ScModal',
    components: {
        'a-button': Button,
        'a-modal': Modal,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        btns: {
            type: Array,
        },
        draggable: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }) {
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        const handleClick = (ev, item) => {
            if (!item.onClick) {
                visibleRef.value = false;
            }
        };
        const bindFlag = ref(false);
        const keyup = (e) => {
            if (visibleRef.value && e.keyCode === 13)
                emit('enter');
        };
        onMounted(() => {
            if (!bindFlag.value) {
                document.addEventListener('keyup', keyup);
                bindFlag.value = true;
            }
        });
        onUnmounted(() => {
            document.removeEventListener('keyup', keyup);
            bindFlag.value = false;
        });
        const getStyle = (dom, attr) => {
            return getComputedStyle(dom, null)[attr];
        };
        const drag = (wrap) => {
            if (!wrap)
                return;
            const dialogHeaderEl = wrap.querySelector('.ant-modal-header');
            const dragDom = wrap.querySelector('.ant-modal');
            if (!dialogHeaderEl || !dragDom)
                return;
            dragDom.setAttribute('data-drag', 'drag');
            dialogHeaderEl.style.cursor = 'move';
            dialogHeaderEl.onmousedown = (e) => {
                if (e.button)
                    return;
                // 鼠标按下，计算当前元素距离可视区的距离
                const disX = e.clientX;
                const disY = e.clientY;
                const screenWidth = document.body.clientWidth; // body当前宽度
                const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
                const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
                const dragDomHeight = dragDom.offsetHeight; // 对话框高度
                const minDragDomLeft = dragDom.offsetLeft;
                const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
                const minDragDomTop = dragDom.offsetTop;
                const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;
                // 获取到的值带px 正则匹配替换
                const domLeft = getStyle(dragDom, 'left');
                const domTop = getStyle(dragDom, 'top');
                let styL = domLeft;
                let styT = domTop;
                // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
                if (domLeft.includes('%')) {
                    styL =
                        +document.body.clientWidth * (+domLeft.replace(/%/g, '') / 100);
                    styT =
                        +document.body.clientHeight * (+domTop.replace(/%/g, '') / 100);
                }
                else {
                    styL = +domLeft.replace(/px/g, '');
                    styT = +domTop.replace(/px/g, '');
                }
                const PerFrameMaxDuration = 8; // ≈ 120 fps
                const mousemove = debounce((e) => {
                    // 通过事件委托，计算移动的距离
                    let left = e.clientX - disX;
                    let top = e.clientY - disY;
                    // 边界处理
                    if (-left > minDragDomLeft) {
                        left = -minDragDomLeft;
                    }
                    else if (left > maxDragDomLeft) {
                        left = maxDragDomLeft;
                    }
                    if (-top > minDragDomTop) {
                        top = -minDragDomTop;
                    }
                    else if (top > maxDragDomTop) {
                        top = maxDragDomTop;
                    }
                    // 移动当前元素
                    dragDom.style.cssText += `;left:${left + styL}px;top:${top +
                        styT}px;`;
                }, PerFrameMaxDuration);
                const mouseup = () => {
                    document.removeEventListener('mousemove', mousemove);
                    document.removeEventListener('mouseup', mouseup);
                };
                document.addEventListener('mousemove', mousemove);
                document.addEventListener('mouseup', mouseup);
            };
        };
        const ModalTransitionDuration = 300; // 动画时间
        watch(() => props.visible, async (v) => {
            if (v && props.draggable) {
                await nextTick();
                window.setTimeout(() => {
                    const dragWraps = document.querySelectorAll('.ant-modal-wrap');
                    for (const wrap of dragWraps) {
                        const display = getStyle(wrap, 'display');
                        const dragged = wrap
                            .querySelector('.ant-modal')
                            ?.getAttribute('data-drag');
                        if (display !== 'none') {
                            // 拖拽位置
                            dragged === null && drag(wrap);
                        }
                    }
                }, ModalTransitionDuration);
            }
        }, {
            immediate: true,
        });
        return {
            visibleRef,
            handleClick,
        };
    },
});

const _hoisted_1$1k = { class: "sc-modal-footer" };

function render$1B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createBlock(_component_a_modal, {
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
    class: "sc-modal",
    centered: true,
    destroyOnClose: "",
    maskClosable: false
  }, createSlots({
    title: withCtx(() => [
      renderSlot(_ctx.$slots, "title")
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$props.btns)
      ? {
          name: "footer",
          fn: withCtx(() => [
            createElementVNode("div", _hoisted_1$1k, [
              renderSlot(_ctx.$slots, "footer"),
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.$props.btns, (item, index) => {
                return (openBlock(), createBlock(_component_a_button, mergeProps({ key: index }, { ...item }, {
                  onClick: $event => (_ctx.handleClick($event, item))
                }), {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(item.text), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["visible"]))
}

script$1N.render = render$1B;
script$1N.__file = "packages/modal/src/Modal.vue";

var script$1M = /*#__PURE__*/ defineComponent({
    __name: 'BasicForm',
    props: {
        showButtons: { type: Boolean, required: false },
        labelAlign: { type: String, required: false, default: 'left' },
        labelSpan: { type: Number, required: false, default: 2 },
        wrapperSpan: { type: Number, required: false, default: 22 },
        isEditing: { type: Boolean, required: false, default: false },
        formItems: { type: Array, required: true },
        formData: { type: null, required: true },
        buttonStyle: { type: null, required: false },
        autoUnpack: { type: Boolean, required: false, default: true },
        showButton: { type: Boolean, required: false, default: true },
        colon: { type: Boolean, required: false, default: true },
        showMoreIndex: { type: Number, required: false },
        highlightDifference: { type: Boolean, required: false, default: false },
        highlightKeys: { type: Array, required: false },
        excludeKeys: { type: Array, required: false, default: () => [] },
        onSubmit: { type: Function, required: true },
        onCancel: { type: Function, required: false }
    },
    emits: ["update:isEditing", "update:formData", "update:highlightKeys"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const isEditing = ref(props.isEditing);
        const cachedFormData = ref({});
        const formModel = computed({
            get: () => props.formData,
            set: (fd) => {
                emit('update:formData', fd);
            },
        });
        const formRef = ref();
        const showEdit = ref(false);
        const showColon = computed(() => (isEditing.value ? props.colon : false));
        const isShowMore = ref(false);
        const validateErrorKeys = new Set();
        const isHighLight = (key) => {
            if (!props.highlightDifference)
                return false;
            // const formItem = props.formItems.find((item) => item.key === key);
            return (Object.hasOwn(cachedFormData.value, key) &&
                !isEqual(cachedFormData.value[key], formModel.value[key]));
        };
        const updateHighlightKeys = () => {
            const keys = props.formItems
                .map((fi) => fi.key)
                .filter((key) => isHighLight(key));
            emit('update:highlightKeys', keys);
        };
        const handleEditStart = (key, go) => {
            Object.keys(formModel.value).forEach((key) => {
                if (!isHighLight(key)) {
                    cachedFormData.value[key] = formModel.value[key];
                }
            });
            setTimeout(() => {
                if (!validateErrorKeys.size || validateErrorKeys.has(key)) {
                    go();
                }
            }, 40);
        };
        const handleSingleEditOk = async ({ key, value, }) => {
            try {
                await formRef.value.validateFields([key]);
                const cachedData = cloneDeep(cachedFormData.value);
                const ret = await props.onSubmit({ [key]: value }, cachedData);
                formModel.value[key] = value;
                updateHighlightKeys();
                validateErrorKeys.delete(key);
                if (ret) {
                    cachedFormData.value[key] = formModel.value[key];
                }
                return true;
            }
            catch {
                validateErrorKeys.add(key);
                throw new Error();
            }
        };
        const handleSingleEditCancel = async (payload) => {
            formRef.value.clearValidate([payload.key]);
            validateErrorKeys.delete(payload.key);
            const lastValue = cachedFormData.value[payload.key];
            updateHighlightKeys();
            if (lastValue) {
                formModel.value[payload.key] = lastValue;
            }
            props.onCancel?.(cloneDeep(cachedFormData.value), payload.key);
        };
        const mapFn = (item) => ({
            ...item,
            isText: !isEditing.value,
            isSingleEdit: !isEditing.value && item.isSingleEdit !== false && item.type !== 'Text',
        });
        const getVisibleFormItems = () => {
            if (!props.excludeKeys || !props.excludeKeys.length) {
                return props.formItems;
            }
            return props.formItems.filter((f) => !props.excludeKeys.includes(f.key));
        };
        const computedFormItems = computed(() => {
            const visibleFormItems = getVisibleFormItems();
            if (!isEditing.value && props.showMoreIndex) {
                return visibleFormItems.slice(0, props.showMoreIndex).map(mapFn);
            }
            return visibleFormItems.map(mapFn);
        });
        const restFormItem = computed(() => {
            const visibleFormItems = getVisibleFormItems();
            if (!isEditing.value && props.showMoreIndex) {
                return visibleFormItems.slice(props.showMoreIndex).map(mapFn);
            }
            return [];
        });
        const handleEdit = () => {
            isEditing.value = true;
            cachedFormData.value = cloneDeep(props.formData);
            emit('update:isEditing', true);
        };
        const handleSubmit = () => {
            const keys = computedFormItems.value
                .filter((fi) => !fi.isText && fi.type !== 'Text')
                .map((fi) => fi.key);
            formRef.value
                .validate(keys)
                .then(() => {
                if (props.autoUnpack) {
                    props.formItems.forEach((fi) => {
                        if (Array.isArray(fi.newKeys) &&
                            Array.isArray(formModel.value[fi.key]) &&
                            !fi.newKeys.includes(fi.key)) {
                            const val = formModel.value[fi.key];
                            fi.newKeys.forEach((key, index) => {
                                formModel.value[key] = val[index];
                            });
                        }
                    });
                }
                // isEditing.value = false;
                // emit('update:isEditing', false);
                // emit('submit');
                const ret = props.onSubmit(formModel.value, cloneDeep(cachedFormData.value));
                if (ret instanceof Promise) {
                    ret
                        .then(() => {
                        isEditing.value = false;
                        emit('update:isEditing', false);
                        cachedFormData.value = cloneDeep(formModel.value);
                    })
                        .catch(() => void 0);
                }
                else {
                    isEditing.value = false;
                    emit('update:isEditing', false);
                    cachedFormData.value = cloneDeep(formModel.value);
                }
            })
                .catch(() => void 0);
        };
        const handleCancel = () => {
            formRef.value?.clearValidate();
            formModel.value = cloneDeep(cachedFormData.value);
            isEditing.value = false;
            emit('update:isEditing', false);
            props.onCancel?.(cloneDeep(cachedFormData.value));
        };
        watch(() => props.isEditing, (e) => {
            isEditing.value = e;
            if (e) {
                cachedFormData.value = cloneDeep(props.formData);
            }
        });
        watch(() => props.highlightKeys, (keys, lastKeys) => {
            if (!keys || !lastKeys)
                return;
            if (!keys.length) {
                cachedFormData.value = cloneDeep(props.formData);
                return;
            }
            const ks = [];
            lastKeys.forEach((key) => {
                if (!keys.includes(key)) {
                    ks.push(key);
                }
            });
            ks.forEach((k) => {
                cachedFormData.value[k] = props.formData[k];
            });
        });
        expose({
            formRef,
            cancel: () => {
                if (props.isEditing) {
                    formRef.value?.clearValidate();
                    emit('update:formData', cloneDeep(cachedFormData.value));
                }
            },
            getFieldsValue: () => {
                const ret = cloneDeep(formModel.value);
                if (props.autoUnpack) {
                    props.formItems.forEach((fi) => {
                        if (Array.isArray(fi.newKeys) &&
                            Array.isArray(ret[fi.key]) &&
                            !fi.newKeys.includes(fi.key)) {
                            const val = ret[fi.key];
                            fi.newKeys.forEach((key, index) => {
                                ret[key] = val[index];
                            });
                        }
                    });
                }
                return ret;
            },
        });
        return (_ctx, _cache) => {
            const _component_a_button = resolveComponent("a-button");
            const _component_a_col = resolveComponent("a-col");
            const _component_a_form = resolveComponent("a-form");
            return (openBlock(), createElementBlock("div", {
                class: "sc-basic-form-wrapper",
                onMouseenter: _cache[3] || (_cache[3] = withModifiers(($event) => (showEdit.value = true), ["stop"])),
                onMouseleave: _cache[4] || (_cache[4] = withModifiers(($event) => (showEdit.value = false), ["stop"]))
            }, [
                (props.showButton)
                    ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: "sc-basic-form-button",
                        style: normalizeStyle(__props.buttonStyle),
                        onMouseenter: _cache[0] || (_cache[0] = withModifiers(($event) => (showEdit.value = true), ["stop"])),
                        onMouseleave: _cache[1] || (_cache[1] = withModifiers(($event) => (showEdit.value = false), ["stop"]))
                    }, [
                        (!isEditing.value)
                            ? withDirectives((openBlock(), createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                onClick: handleEdit
                            }, {
                                default: withCtx(() => [
                                    createTextVNode("编辑")
                                ]),
                                _: 1 /* STABLE */
                            }, 512 /* NEED_PATCH */)), [
                                [vShow, showEdit.value]
                            ])
                            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                createVNode(_component_a_button, {
                                    type: "link",
                                    onClick: handleSubmit
                                }, {
                                    default: withCtx(() => [
                                        createTextVNode("保存")
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                createVNode(_component_a_button, {
                                    type: "text",
                                    onClick: handleCancel
                                }, {
                                    default: withCtx(() => [
                                        createTextVNode("取消")
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ], 64 /* STABLE_FRAGMENT */))
                    ], 36 /* STYLE, HYDRATE_EVENTS */))
                    : createCommentVNode("v-if", true),
                createVNode(_component_a_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    labelAlign: __props.labelAlign,
                    labelCol: { span: props.labelSpan },
                    wrapperCol: { span: props.wrapperSpan },
                    model: unref(formModel),
                    colon: unref(showColon)
                }, {
                    default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(computedFormItems), (item) => {
                            return (openBlock(), createBlock(unref(script$1v), {
                                key: item.key,
                                item: item,
                                isCols: "",
                                "high-light": isHighLight(item.key),
                                value: unref(formModel)[item.key],
                                "onUpdate:value": ($event) => ((unref(formModel)[item.key]) = $event),
                                isSingleEdit: item.isSingleEdit,
                                "always-show-controller": item.alwaysShowController,
                                "on-single-editing-ok": handleSingleEditOk,
                                "on-single-editing-cancel": handleSingleEditCancel,
                                "on-single-edit-start": handleEditStart
                            }, null, 8 /* PROPS */, ["item", "high-light", "value", "onUpdate:value", "isSingleEdit", "always-show-controller"]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        (unref(restFormItem)?.length)
                            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                (__props.showMoreIndex && !isEditing.value)
                                    ? (openBlock(), createBlock(_component_a_col, {
                                        key: 0,
                                        span: 24
                                    }, {
                                        default: withCtx(() => [
                                            createElementVNode("div", {
                                                onClick: _cache[2] || (_cache[2] = ($event) => (isShowMore.value = !isShowMore.value)),
                                                class: "sc-basic-form-show-more"
                                            }, [
                                                createElementVNode("span", null, toDisplayString(!isShowMore.value ? '更多信息' : '收起更多'), 1 /* TEXT */),
                                                createVNode(unref(LeftOutlined), {
                                                    class: normalizeClass(["icon", { rotation: isShowMore.value }])
                                                }, null, 8 /* PROPS */, ["class"])
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : createCommentVNode("v-if", true),
                                (isShowMore.value)
                                    ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(unref(restFormItem), (item) => {
                                        return (openBlock(), createBlock(unref(script$1v), {
                                            key: item.key,
                                            item: item,
                                            isCols: "",
                                            "high-light": isHighLight(item.key),
                                            value: unref(formModel)[item.key],
                                            "onUpdate:value": ($event) => ((unref(formModel)[item.key]) = $event),
                                            isSingleEdit: item.isSingleEdit,
                                            "always-show-controller": item.alwaysShowController,
                                            "on-single-editing-ok": handleSingleEditOk,
                                            "on-single-editing-cancel": handleSingleEditCancel,
                                            "on-single-edit-start": handleEditStart
                                        }, null, 8 /* PROPS */, ["item", "high-light", "value", "onUpdate:value", "isSingleEdit", "always-show-controller"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                    : createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                            : createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["labelAlign", "labelCol", "wrapperCol", "model", "colon"])
            ], 32 /* HYDRATE_EVENTS */));
        };
    }
});

script$1M.__file = "packages/form/BasicForm.vue";

var script$1L = defineComponent({
    name: 'ScDatePicker',
    props: {
        value: {
            type: String,
            default: '',
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD',
        },
    },
    setup(props, context) {
        const valueRef = computed({
            get: () => (props.value ? dayjs(props.value).format(props.format) : null),
            set: (val) => {
                context.emit('update:value', val ? dayjs(val).format(props.format) : '');
            },
        });
        // const handleOpenChange = (status: boolean) => {
        //   let timerId = 0;
        //   status &&
        //     nextTick(() => {
        //       timerId = setInterval(() => {
        //         const panel: any = datePickerRef.value.$el.querySelector(
        //           '.ant-calendar-picker-container',
        //         );
        //         if (panel && panel.style) {
        //           const top = parseFloat(panel.style.top);
        //           if (top === 32 || top === -330) clearInterval(timerId);
        //           if (top >= -20) {
        //             panel.style.top = '32px';
        //           } else {
        //             panel.style.top = '-330px';
        //           }
        //         }
        //       }, 10);
        //     });
        // };
        return {
            valueRef,
            // datePickerRef,
            // handleOpenChange,
        };
    },
});

function render$1A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_date_picker = resolveComponent("a-date-picker");

  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" @openChange=\"handleOpenChange\" "),
    createVNode(_component_a_date_picker, {
      class: "sc-date-picker",
      value: _ctx.valueRef,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.valueRef) = $event)),
      allowClear: "",
      "value-format": _ctx.$props.format
    }, null, 8 /* PROPS */, ["value", "value-format"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}

script$1L.render = render$1A;
script$1L.__file = "packages/range-picker/DatePicker.vue";

/**
 * 时间范围对象
 */
class RangeItem {
    key;
    label;
    value;
    constructor({ key, label, value, }) {
        this.key = key;
        this.label = label;
        this.value = value;
    }
}
window.dayjs = dayjs;
const getRawRanges = () => {
    return {
        today: new RangeItem({
            key: 'today',
            label: '今天',
            value: [dayjs().startOf('day'), dayjs()],
        }),
        yesterday: new RangeItem({
            key: 'yesterday',
            label: '昨天',
            value: [
                dayjs()
                    .startOf('day')
                    .subtract(1, 'days'),
                dayjs()
                    .endOf('day')
                    .subtract(1, 'days'),
            ],
        }),
        thisWeek: new RangeItem({
            key: 'thisWeek',
            label: '本周',
            value: [dayjs().startOf('week'), dayjs()],
        }),
        preWeek: new RangeItem({
            key: 'preWeek',
            label: '上周',
            value: [
                dayjs()
                    .startOf('week')
                    .subtract(1, 'week'),
                dayjs()
                    .endOf('week')
                    .subtract(1, 'week'),
            ],
        }),
        thisMonth: new RangeItem({
            key: 'thisMonth',
            label: '本月',
            value: [dayjs().startOf('month'), dayjs()],
        }),
        preMonth: new RangeItem({
            key: 'preMonth',
            label: '上月',
            value: [
                dayjs()
                    .startOf('month')
                    .subtract(1, 'month'),
                dayjs()
                    .startOf('month')
                    .subtract(1, 'day'),
            ],
        }),
        thisYear: new RangeItem({
            key: 'thisYear',
            label: '今年',
            value: [dayjs().startOf('year'), dayjs()],
        }),
        lastYear: new RangeItem({
            key: 'lastYear',
            label: '去年',
            value: [
                dayjs()
                    .startOf('year')
                    .subtract(1, 'year'),
                dayjs()
                    .endOf('year')
                    .subtract(1, 'year'),
            ],
        }),
        lastThirty: new RangeItem({
            key: 'lastThirty',
            label: '最近30天',
            value: [dayjs().subtract(29, 'days'), dayjs()],
        }),
        lastSixty: new RangeItem({
            key: 'today',
            label: '最近60天',
            value: [dayjs().subtract(59, 'days'), dayjs()],
        }),
        lastNinety: new RangeItem({
            key: 'today',
            label: '最近90天',
            value: [dayjs().subtract(89, 'days'), dayjs()],
        }),
    };
};

const _hoisted_1$1j = /*#__PURE__*/ createElementVNode("div", null, null, -1 /* HOISTED */);
var script$1K = /*#__PURE__*/ defineComponent({
    __name: 'scRangePicker',
    props: {
        ranges: { type: Object, required: false },
        tag: { type: String, required: false, default: '' },
        width: { type: String, required: false, default: '250px' },
        value: { type: Array, required: true },
        format: { type: String, required: false, default: 'YYYY-MM-DD' },
        showTime: { type: Boolean, required: false, default: false }
    },
    emits: ['update:tag', 'update:value', 'change'],
    setup(__props, { expose, emit }) {
        const props = __props;
        const computedRanges = computed(() => {
            return (props.ranges ??
                Object.values(getRawRanges()).reduce((curr, prev) => {
                    curr[prev.label] = prev.value;
                    return curr;
                }, {}));
        });
        const rangePickerRef = ref();
        const wrapperRef = ref();
        const selectedValues = ref();
        function handleOpenChange(open) {
            if (open) {
                nextTick(() => {
                    // move ok button to footer extra
                    const okButton = wrapperRef.value?.querySelector('.ant-picker-ok');
                    const extra = wrapperRef.value?.querySelector('.ant-picker-footer-extra');
                    if (extra && okButton) {
                        extra.appendChild(okButton);
                    }
                });
            }
        }
        function handleChange(dates, dateStrings) {
            const realStrings = dateStrings.filter(Boolean);
            if (realStrings.length === 2) {
                emit('update:value', dateStrings);
                emit('change', dateStrings);
                emit('update:tag', dateStrings.join('至'));
            }
            else if (realStrings.length === 0) {
                emit('update:value', undefined);
                emit('change', undefined);
                emit('update:tag', undefined);
            }
        }
        watch(() => props.value, (v) => {
            selectedValues.value = v?.map((item) => dayjs(item));
        }, { immediate: true });
        expose({
            focus: () => {
                rangePickerRef.value.focus();
            },
            blur: () => {
                rangePickerRef.value.blur();
            },
        });
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("div", {
                ref_key: "wrapperRef",
                ref: wrapperRef,
                class: normalizeClass(["rangePicker", { 'show-time': __props.showTime }])
            }, [
                createVNode(unref(DatePicker).RangePicker, mergeProps({
                    ref_key: "rangePickerRef",
                    ref: rangePickerRef,
                    dropdownClassName: "newRangePickerClassName",
                    value: selectedValues.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((selectedValues).value = $event)),
                    onOpenChange: handleOpenChange,
                    onChange: handleChange,
                    getPopupContainer: (triggerNode) => triggerNode.parentElement,
                    format: __props.format,
                    ranges: unref(computedRanges),
                    showTime: __props.showTime
                }, { ..._ctx.$attrs }), createSlots({ _: 2 /* DYNAMIC */ }, [
                    (__props.showTime)
                        ? {
                            name: "renderExtraFooter",
                            fn: withCtx(() => [
                                _hoisted_1$1j
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "getPopupContainer", "format", "ranges", "showTime"])
            ], 2 /* CLASS */));
        };
    }
});

script$1K.__file = "packages/range-picker/scRangePicker.vue";

script$1K.install = (Vue) => {
    Vue.component(script$1L.name, script$1L);
    // Vue.component(NewRangePicker.name, NewRangePicker);
    Vue.component(script$1K.name, script$1K);
};

var script$1J = defineComponent({
    name: 'ScDatePicker',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        tag: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        digit: {
            type: Number,
            default: 2,
        },
        label: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
        prefix: {
            type: String,
            default: '',
        },
    },
    setup(props, context) {
        const startValueRef = ref(props.value[0]);
        const endValueRef = ref(props.value[1]);
        watch(() => props.value, (val) => ([startValueRef.value, endValueRef.value] = val));
        const placeholderRef = computed(() => {
            const p = props.placeholder.split('|');
            return [p[0] || '', p[1] || ''];
        });
        const isEmpty = (val) => val === '' || val === undefined;
        const getInputGroupTag = (v) => {
            if (!isEmpty(v[0]) && isEmpty(v[1]))
                return '≥ ' + v[0];
            if (isEmpty(v[0]) && !isEmpty(v[1]))
                return '≤ ' + v[1];
            if (isEmpty(v[0]) && isEmpty(v[1]))
                return '';
            if (v[1] === v[0])
                return '= ' + v[0];
            return v.join(' ~ ');
        };
        const getInputGroupVal = (v) => {
            if (!isEmpty(v[0]) && isEmpty(v[1]))
                return [v[0], ''];
            if (isEmpty(v[0]) && !isEmpty(v[1]))
                return ['', v[1]];
            if (isEmpty(v[0]) && isEmpty(v[1]))
                return ['', ''];
            return [v[0], v[1]];
        };
        const handleInput = (i, e) => {
            const reg = props.digit === 0
                ? RegExp('^(\\d*)', 'g')
                : RegExp('^\\d*(\\.?\\d{0,' + props.digit + '})', 'g');
            e.target.value = e.target.value.match(reg)[0] || null;
            // 小数替换.XX 替换为 0.XX
            e.target.value = e.target.value.replace(/^\./g, '0.');
            i === 0
                ? (startValueRef.value = e.target.value)
                : (endValueRef.value = e.target.value);
            const val = [startValueRef.value, endValueRef.value];
            context.emit('update:tag', getInputGroupTag(val));
            context.emit('update:value', getInputGroupVal(val));
            context.emit('change', getInputGroupVal(val));
        };
        const handleBlur = (i) => {
            const val = [startValueRef.value, endValueRef.value];
            if (isEmpty(val[0]) || isEmpty(val[1]))
                return;
            if (Number(val[0]) > Number(val[1])) {
                i === 0 ? (startValueRef.value = '') : (endValueRef.value = '');
                val[i] = '';
                message.warn(`${props.label}的上限不能低于下限`);
                const newVal = getInputGroupVal(val);
                context.emit('update:tag', getInputGroupTag(val));
                context.emit('update:value', newVal);
                context.emit('change', newVal);
                context.emit('blur', newVal);
            }
        };
        return {
            endValueRef,
            startValueRef,
            placeholderRef,
            handleInput,
            handleBlur,
        };
    },
});

const _hoisted_1$1i = /*#__PURE__*/createElementVNode("span", null, "~", -1 /* HOISTED */);

function render$1z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = resolveComponent("a-input");
  const _component_a_input_group = resolveComponent("a-input-group");

  return (openBlock(), createBlock(_component_a_input_group, {
    compact: "",
    class: "sc-input-group sc-form-item-width"
  }, {
    default: withCtx(() => [
      createVNode(_component_a_input, mergeProps({
        allowClear: "",
        maxlength: 11
      }, { ..._ctx.$props }, {
        placeholder: _ctx.placeholderRef[0],
        onInput: _cache[0] || (_cache[0] = $event => (_ctx.handleInput(0, $event))),
        onBlur: _cache[1] || (_cache[1] = $event => (_ctx.handleBlur(0))),
        value: _ctx.startValueRef,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.startValueRef) = $event))
      }), null, 16 /* FULL_PROPS */, ["placeholder", "value"]),
      _hoisted_1$1i,
      createVNode(_component_a_input, mergeProps({
        allowClear: "",
        maxlength: 11
      }, { ..._ctx.$props }, {
        placeholder: _ctx.placeholderRef[1],
        onInput: _cache[3] || (_cache[3] = $event => (_ctx.handleInput(1, $event))),
        onBlur: _cache[4] || (_cache[4] = $event => (_ctx.handleBlur(1))),
        value: _ctx.endValueRef,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => ((_ctx.endValueRef) = $event))
      }), null, 16 /* FULL_PROPS */, ["placeholder", "value"])
    ]),
    _: 1 /* STABLE */
  }))
}

script$1J.render = render$1z;
script$1J.__file = "packages/form/src/components/InputGroup.vue";

var script$1I = defineComponent({
    name: 'InputGroups',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        space: {
            type: String,
            default: '~',
        },
        groupNum: {
            type: Number,
            default: 3,
        },
        tag: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        digit: {
            type: Number,
            default: 2,
        },
        label: {
            type: String,
            default: '',
        },
        suffix: {
            type: [String, Array],
            default: '',
        },
        prefix: {
            type: [String, Array],
            default: '',
        },
        preText: {
            type: String,
            default: '',
        },
        sufText: {
            type: String,
            default: '',
        },
        width: {
            type: String,
            default: '',
        },
        verifyEmpty: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, context) {
        const valueRefs = ref(props.value);
        watch(() => props.value, (val) => {
            valueRefs.value = val;
        });
        const placeholderRef = computed(() => {
            const p = props.placeholder.split('|');
            return p;
        });
        const isEmpty = (val) => val === '' || val === undefined;
        const getInputGroupTag = (val) => {
            if (val.every((v) => isEmpty(v)))
                return '';
            return val.join(` , `);
        };
        const handleInput = (i, e) => {
            const reg = props.digit === 0
                ? RegExp('^(\\d*)', 'g')
                : RegExp('^\\d*(\\.?\\d{0,' + props.digit + '})', 'g');
            e.target.value = e.target.value.match(reg)[0] || null;
            const val = [...valueRefs.value];
            context.emit('update:tag', getInputGroupTag(val));
            context.emit('update:value', val);
            context.emit('change', val);
        };
        const handleBlur = (i) => {
            const val = [...valueRefs.value];
            if (props.verifyEmpty && val.every((v) => !isEmpty(v)))
                return;
            context.emit('update:tag', getInputGroupTag(val));
            context.emit('update:value', val);
            context.emit('change', val);
            context.emit('blur', val);
        };
        return {
            placeholderRef,
            handleInput,
            handleBlur,
            valueRefs,
        };
    },
});

const _hoisted_1$1h = ["innerHTML"];
const _hoisted_2$12 = ["innerHTML"];

function render$1y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = resolveComponent("a-input");
  const _component_a_input_group = resolveComponent("a-input-group");

  return (openBlock(), createBlock(_component_a_input_group, {
    compact: "",
    class: "sc-input-groups sc-form-item-width"
  }, {
    default: withCtx(() => [
      createCommentVNode(" 表单后面前面文本内容 "),
      (_ctx.preText)
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "sc-form-prev-text",
            innerHTML: _ctx.preText
          }, null, 8 /* PROPS */, _hoisted_1$1h))
        : createCommentVNode("v-if", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groupNum, (item, index) => {
        return (openBlock(), createElementBlock(Fragment, { key: item }, [
          createVNode(_component_a_input, mergeProps({
            allowClear: "",
            maxlength: 8,
            onInput: $event => (_ctx.handleInput(index, $event)),
            onBlur: $event => (_ctx.handleBlur(index))
          }, { ..._ctx.$props }, {
            style: { width: _ctx.width },
            placeholder: _ctx.placeholderRef[index] || '',
            value: _ctx.valueRefs[index],
            "onUpdate:value": $event => ((_ctx.valueRefs[index]) = $event),
            prefix: typeof _ctx.prefix == 'object' ? _ctx.prefix[index] : _ctx.prefix,
            suffix: typeof _ctx.suffix == 'object' ? _ctx.suffix[index] : _ctx.suffix
          }), null, 16 /* FULL_PROPS */, ["onInput", "onBlur", "style", "placeholder", "value", "onUpdate:value", "prefix", "suffix"]),
          (index != _ctx.groupNum - 1)
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(`sc-input-group-space ${_ctx.space ? '' : 'sc-no-space'}`)
              }, [
                renderSlot(_ctx.$slots, "space", {}, () => [
                  createTextVNode(toDisplayString(_ctx.space), 1 /* TEXT */)
                ])
              ], 2 /* CLASS */))
            : createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */)),
      createCommentVNode(" 表单后面添加文本内容 "),
      (_ctx.sufText)
        ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "sc-form-suff-text",
            innerHTML: _ctx.sufText
          }, null, 8 /* PROPS */, _hoisted_2$12))
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }))
}

script$1I.render = render$1y;
script$1I.__file = "packages/form/src/components/InputGroups.vue";

const { TextArea: TextArea$1 } = Input;
var script$1H = defineComponent({
    name: 'TextArea',
    components: {
        'a-textarea': TextArea$1,
        'a-button': Button,
    },
    props: {
        isExtraEle: {
            type: Boolean,
            default: false,
        },
        minWidth: {
            type: Number,
            default: 180,
        },
        textAreaPlace: {
            type: String,
            default: '',
        },
        parentWidth: {
            type: Number,
            default: 270,
        },
        handleList: {
            type: Array,
        },
        maxCount: {
            type: Number,
            default: 500,
        },
        label: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit }) {
        const value = ref('');
        const numOfValue = ref(0);
        const textAreaW = ref(props.minWidth);
        const handles = ref([]);
        const minW = ref(props.minWidth);
        handles.value = props.handleList || [];
        if (props.isExtraEle) {
            minW.value =
                props.minWidth < props.parentWidth ? props.parentWidth : props.minWidth;
        }
        const onClose = () => {
            emit('onCloseTextarea', false);
        };
        watch(() => props.handleList, (newVal) => {
            handles.value.splice(0);
            handles.value.push(...(newVal || []));
        }, {
            deep: true,
        });
        const onOk = () => {
            const val = value.value.trim().split('\n');
            const _val = [];
            // 获取每一项去除空格后的数组，filter中return的是符不符合条件，返回的是原数组中值；
            val.forEach((item) => {
                item = item.trim();
                if (item)
                    return _val.push(item);
            });
            if (_val.length > props.maxCount) {
                message.warn(`最多支持输入${props.maxCount}个${props.label}`);
                return;
            }
            emit('onInpsValueChange', _val);
            onClose();
        };
        const onValueChange = (e) => {
            const target = e.target.value;
            const val = target.trim().split('\n');
            const _val = val.filter((item) => {
                item = item.trim();
                if (item)
                    return item;
            });
            numOfValue.value = _val.length;
        };
        const onClear = () => {
            value.value = '';
            numOfValue.value = 0;
        };
        return {
            value,
            numOfValue,
            onOk,
            onClose,
            onClear,
            onValueChange,
            textAreaW,
            handles,
            minW,
        };
    },
});

const _hoisted_1$1g = { class: "multi-textarea" };
const _hoisted_2$11 = {
  key: 0,
  class: "multi-textarea-slot"
};
const _hoisted_3$P = { class: "multi-textarea-extra" };
const _hoisted_4$F = { class: "multi-textarea-extra-link" };

function render$1x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_textarea = resolveComponent("a-textarea");
  const _component_a_button = resolveComponent("a-button");

  return (openBlock(), createElementBlock("div", _hoisted_1$1g, [
    createVNode(_component_a_textarea, {
      value: _ctx.value,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      placeholder: _ctx.textAreaPlace,
      class: "draggable-textarea",
      onChange: _ctx.onValueChange,
      rows: 8
    }, null, 8 /* PROPS */, ["value", "placeholder", "onChange"]),
    (_ctx.isExtraEle)
      ? (openBlock(), createElementBlock("div", _hoisted_2$11, [
          renderSlot(_ctx.$slots, "extraEle")
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_3$P, [
      createElementVNode("div", null, [
        createElementVNode("span", _hoisted_4$F, "共 " + toDisplayString(_ctx.numOfValue) + " 个", 1 /* TEXT */),
        createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onClear && _ctx.onClear(...args)))
        }, "清空")
      ]),
      createElementVNode("div", null, [
        createElementVNode("a", {
          class: "multi-textarea-extra-link",
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.onClose && _ctx.onClose(...args)))
        }, "取消"),
        createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.onOk,
          size: "small"
        }, {
          default: withCtx(() => [
            createTextVNode("确认")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ]))
}

script$1H.render = render$1x;
script$1H.__file = "packages/multi-select/textArea.vue";

const { Option: Option$1 } = Select;
const multiSelectProps$1 = {
    optionData: {
        type: Array,
        default: [],
    },
    mode: {
        type: String,
        default: 'default',
    },
    textAreaPlace: {
        type: String,
        default: 'default',
    },
    isSelectAll: {
        type: Boolean,
        default: false,
    },
    isClear: {
        type: Boolean,
        default: false,
    },
    showTextArea: {
        type: Boolean,
        default: false,
    },
    isCustomOption: {
        type: Boolean,
        default: false,
    },
    width: {
        type: String,
        default: '',
    },
    textAreaMinWidth: {
        type: Number,
    },
    selectDropMinWidth: {
        type: Number,
        default: 130,
    },
    isDropdownExtra: {
        type: Boolean,
        default: false,
    },
    isExtraEle: {
        type: Boolean,
        default: false,
    },
    onOk: {
        type: Function,
    },
    maxCount: {
        type: Number,
        default: 500,
    },
    label: {
        type: String,
        default: '',
    },
};
var script$1G = defineComponent({
    name: 'MultiSelect',
    components: {
        'a-select': Select,
        'a-select-option': Option$1,
        'a-divider': Divider,
        'a-button': Button,
        TextArea: script$1H,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes;
        },
    },
    props: multiSelectProps$1,
    setup(props, { emit }) {
        const optionData = ref(props.optionData);
        const selectedValues = ref([]);
        const textAreaVisible = ref(false);
        const isShowSelect = ref();
        const textAreaNode = ref();
        const suffixNode = ref();
        const scMutilSelect = ref();
        const isRight = ref(false);
        const handleList = ref(['br']);
        const parentWidth = ref(0);
        const selectedData = ref([]);
        const initComp = () => {
            const el = scMutilSelect.value;
            const w = window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            const lw = el ? el.getBoundingClientRect().left : 0;
            parentWidth.value = el ? el.getBoundingClientRect().width : 0;
            const minW = props.textAreaMinWidth ? props.textAreaMinWidth : 180;
            const rw = w - lw - minW;
            isRight.value = 500 - minW > rw;
            if (isRight.value) {
                handleList.value = ['bl'];
            }
            else {
                handleList.value = ['br'];
            }
        };
        const onValuesChange = (value) => {
            const data = optionData.value.filter((item) => {
                if (value.includes(props.showTextArea ? item.name : item.id)) {
                    return item;
                }
            });
            const newData = Array.from(new Set([...selectedData.value, ...data]));
            selectedData.value = newData.filter((item) => {
                if (value.includes(props.showTextArea ? item.name : item.id)) {
                    return item;
                }
            });
            const name = selectedData.value.map((item) => item.name);
            const id = selectedData.value.map((item) => item.id);
            emit('onOk', { name, id });
            selectedValues.value = value;
        };
        const selectAll = () => {
            const val = optionData.value.map((item) => item.name);
            onValuesChange(val);
        };
        const clearAll = () => {
            onValuesChange([]);
        };
        const onSelect = () => {
            onValuesChange(selectedValues.value);
            isShowSelect.value = false;
        };
        const onCloseTextarea = (visiable) => {
            textAreaVisible.value = visiable;
        };
        const onInpsValueChange = (val) => {
            selectedValues.value = val;
            emit('onOk', { name: val });
        };
        const onSeleceVisibleChange = (open) => {
            isShowSelect.value = open;
        };
        const getSelectContainer = () => {
            return scMutilSelect.value;
        };
        const changeTexeArea = () => {
            if (!textAreaVisible.value) {
                initComp();
            }
            textAreaVisible.value = !textAreaVisible.value;
            if (textAreaVisible.value &&
                !document.querySelector('.sc-ui-multi-select-textarea')) {
                setTimeout(() => {
                    textAreaNode.value = document.querySelector('.sc-ui-multi-select-textarea');
                }, 200);
            }
        };
        function otherClose(e) {
            if (textAreaNode.value &&
                suffixNode.value &&
                !textAreaNode.value.contains(e.target) &&
                !suffixNode.value.contains(e.target)) {
                textAreaVisible.value = false;
            }
        }
        onMounted(() => {
            initComp();
            document.addEventListener('click', otherClose);
        });
        onUnmounted(() => {
            document.removeEventListener('click', otherClose);
        });
        return {
            textAreaVisible,
            isShowSelect,
            selectedValues,
            selectAll,
            clearAll,
            onSelect,
            onValuesChange,
            onCloseTextarea,
            onInpsValueChange,
            onSeleceVisibleChange,
            getSelectContainer,
            changeTexeArea,
            isRight,
            handleList,
            textAreaNode,
            suffixNode,
            scMutilSelect,
            parentWidth,
            ...props,
        };
    },
});

const _hoisted_1$1f = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_2$10 = [
  _hoisted_1$1f
];

function render$1w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_a_divider = resolveComponent("a-divider");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_TextArea = resolveComponent("TextArea");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createElementBlock("div", {
    ref: "scMutilSelect",
    class: "multi-select-wrapper",
    style: normalizeStyle({ width: _ctx.width })
  }, [
    createVNode(_component_a_select, mergeProps({
      class: ["multi-select", _ctx.showTextArea ? ' is-show-textarea' : ''],
      placeholder: "请选择",
      value: _ctx.selectedValues,
      maxTagCount: 5,
      maxTagTextLength: 6,
      allowClear: true,
      dropdownStyle: { 'min-width': _ctx.selectDropMinWidth + 'px' },
      onDropdownVisibleChange: _ctx.onSeleceVisibleChange,
      onChange: _ctx.onValuesChange,
      open: _ctx.isShowSelect,
      getPopupContainer: _ctx.getSelectContainer
    }, { ..._ctx.$props, ..._ctx.$attrs }, { optionFilterProp: "key" }), createSlots({
      default: withCtx(() => [
        (_ctx.isCustomOption)
          ? renderSlot(_ctx.$slots, "customOption", { key: 0 })
          : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.optionData, (item) => {
              return (openBlock(), createBlock(_component_a_select_option, {
                key: item.name,
                value: _ctx.showTextArea ? item.name : item.id
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(item.name), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
            }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 2 /* DYNAMIC */
    }, [
      (_ctx.mode === 'multiple')
        ? {
            name: "dropdownRender",
            fn: withCtx(({ menuNode: menu }) => [
              createVNode(_component_v_nodes, { vnodes: menu }, null, 8 /* PROPS */, ["vnodes"]),
              (_ctx.isDropdownExtra)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "multi-select-drapExtra",
                    onMousedown: _cache[0] || (_cache[0] = (e) => e.preventDefault())
                  }, [
                    renderSlot(_ctx.$slots, "dropdownExtra")
                  ], 32 /* HYDRATE_EVENTS */))
                : createCommentVNode("v-if", true),
              createVNode(_component_a_divider, { class: "multi-select-divider" }),
              createElementVNode("div", {
                class: "multi-select-extra",
                onMousedown: _cache[3] || (_cache[3] = (e) => e.preventDefault())
              }, [
                createElementVNode("div", null, [
                  (_ctx.isSelectAll)
                    ? (openBlock(), createElementBlock("a", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
                        class: "multi-select-extra-link"
                      }, "全选"))
                    : createCommentVNode("v-if", true),
                  (_ctx.isClear)
                    ? (openBlock(), createElementBlock("a", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
                      }, "清空"))
                    : createCommentVNode("v-if", true)
                ]),
                createVNode(_component_a_button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.onSelect
                }, {
                  default: withCtx(() => [
                    createTextVNode("确认 ")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ], 32 /* HYDRATE_EVENTS */)
            ]),
            key: "0"
          }
        : undefined
    ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class", "value", "dropdownStyle", "onDropdownVisibleChange", "onChange", "open", "getPopupContainer"]),
    (_ctx.showTextArea && _ctx.mode === 'multiple')
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          ref: "suffixNode",
          class: "multi-select-suffix",
          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.changeTexeArea && _ctx.changeTexeArea(...args)))
        }, _hoisted_2$10, 512 /* NEED_PATCH */))
      : createCommentVNode("v-if", true),
    (_ctx.showTextArea && _ctx.mode === 'multiple')
      ? (openBlock(), createBlock(_component_a_modal, {
          key: 1,
          wrapClassName: 
        _ctx.isRight
          ? 'sc-ui-multi-select-textarea multi-select-textarea-right'
          : 'sc-ui-multi-select-textarea'
      ,
          mask: false,
          closable: false,
          footer: null,
          visible: _ctx.textAreaVisible,
          "onUpdate:visible": _cache[5] || (_cache[5] = $event => ((_ctx.textAreaVisible) = $event)),
          getContainer: _ctx.getSelectContainer
        }, {
          default: withCtx(() => [
            createVNode(_component_TextArea, {
              onOnCloseTextarea: _ctx.onCloseTextarea,
              onOnInpsValueChange: _ctx.onInpsValueChange,
              isExtraEle: _ctx.isExtraEle,
              minWidth: _ctx.textAreaMinWidth,
              parentWidth: _ctx.parentWidth,
              handleList: _ctx.handleList,
              textAreaPlace: _ctx.textAreaPlace,
              maxCount: _ctx.maxCount,
              label: _ctx.label
            }, {
              extraEle: withCtx(() => [
                renderSlot(_ctx.$slots, "extraEle")
              ]),
              _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["onOnCloseTextarea", "onOnInpsValueChange", "isExtraEle", "minWidth", "parentWidth", "handleList", "textAreaPlace", "maxCount", "label"])
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["wrapClassName", "visible", "getContainer"]))
      : createCommentVNode("v-if", true)
  ], 4 /* STYLE */))
}

script$1G.render = render$1w;
script$1G.__file = "packages/multi-select/multiSelect.vue";

const { TextArea } = Input;
var script$1F = defineComponent({
    name: 'TextArea',
    components: {
        'a-textarea': TextArea,
        'a-button': Button,
    },
    props: {
        isExtraEle: {
            type: Boolean,
            default: false,
        },
        minWidth: {
            type: Number,
            default: 180,
        },
        textAreaPlace: {
            type: String,
            default: '',
        },
        parentWidth: {
            type: Number,
            default: 270,
        },
        maxCount: {
            type: Number,
            default: 500,
        },
        label: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit }) {
        const value = ref('');
        const numOfValue = ref(0);
        const textAreaW = ref(props.minWidth);
        const minW = ref(props.minWidth);
        if (props.isExtraEle) {
            minW.value =
                props.minWidth < props.parentWidth ? props.parentWidth : props.minWidth;
        }
        const onClose = () => {
            emit('onCloseTextarea', false);
        };
        const onOk = () => {
            const val = value.value.trim().split('\n');
            const _val = [];
            // 获取每一项去除空格后的数组，filter中return的是符不符合条件，返回的是原数组中值；
            val.forEach((item) => {
                item = item.trim();
                if (item)
                    return _val.push(item);
            });
            if (_val.length > props.maxCount) {
                message.warn(`最多支持输入${props.maxCount}个${props.label}`);
                return;
            }
            emit('onInpsValueChange', _val);
            onClose();
        };
        const onValueChange = (e) => {
            const target = e.target.value;
            const val = target.trim().split('\n');
            const _val = val.filter((item) => {
                item = item.trim();
                if (item)
                    return item;
            });
            numOfValue.value = _val.length;
        };
        const onClear = () => {
            value.value = '';
            numOfValue.value = 0;
        };
        return {
            value,
            numOfValue,
            onOk,
            onClose,
            onClear,
            onValueChange,
            textAreaW,
            minW,
        };
    },
});

const _hoisted_1$1e = { class: "multi-textarea" };
const _hoisted_2$$ = {
  key: 0,
  class: "multi-textarea-slot"
};
const _hoisted_3$O = { class: "multi-textarea-extra" };
const _hoisted_4$E = { class: "multi-textarea-extra-link" };

function render$1v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_textarea = resolveComponent("a-textarea");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_space = resolveComponent("a-space");

  return (openBlock(), createElementBlock("div", _hoisted_1$1e, [
    createVNode(_component_a_textarea, {
      value: _ctx.value,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      placeholder: _ctx.textAreaPlace,
      class: "draggable-textarea",
      onChange: _ctx.onValueChange,
      onKeydown: withKeys(withModifiers(_ctx.onOk, ["ctrl"]), ["enter"]),
      rows: 8
    }, null, 8 /* PROPS */, ["value", "placeholder", "onChange", "onKeydown"]),
    (_ctx.isExtraEle)
      ? (openBlock(), createElementBlock("div", _hoisted_2$$, [
          renderSlot(_ctx.$slots, "extraEle")
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_3$O, [
      createElementVNode("div", null, [
        createElementVNode("span", _hoisted_4$E, "共 " + toDisplayString(_ctx.numOfValue) + " 个", 1 /* TEXT */),
        createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onClear && _ctx.onClear(...args)))
        }, "清空")
      ]),
      createVNode(_component_a_space, null, {
        default: withCtx(() => [
          createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onOk,
            size: "small"
          }, {
            default: withCtx(() => [
              createTextVNode("确认")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          createVNode(_component_a_button, {
            size: "small",
            onClick: _ctx.onClose
          }, {
            default: withCtx(() => [
              createTextVNode("取消")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}

script$1F.render = render$1v;
script$1F.__file = "packages/multi-search/src/textArea.vue";

const _hoisted_1$1d = /*#__PURE__*/ createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_2$_ = [
    _hoisted_1$1d
];
const __default__ = {
    name: 'multi-search',
};
var script$1E = /*#__PURE__*/ defineComponent({
    ...__default__,
    props: {
        overlayStyle: { type: null, required: false },
        placeholder: { type: String, required: false },
        label: { type: String, required: false },
        maxRows: { type: Number, required: false, default: 200 }
    },
    emits: ["ok"],
    setup(__props, { emit }) {
        const props = __props;
        const visible = ref(false);
        function handleOk(value) {
            emit('ok', value);
        }
        return (_ctx, _cache) => {
            const _component_a_dropdown = resolveComponent("a-dropdown");
            return (openBlock(), createBlock(_component_a_dropdown, {
                trigger: ['click'],
                getPopupContainer: (ele) => ele.parentNode,
                visible: visible.value,
                placement: "bottomRight",
                onVisibleChange: _cache[2] || (_cache[2] = (v) => (visible.value = v)),
                overlayStyle: __props.overlayStyle,
                overlayClassName: "multi-search-dropdown"
            }, {
                overlay: withCtx(() => [
                    createVNode(script$1F, {
                        onClick: _cache[0] || (_cache[0] = withModifiers(() => { }, ["stop"])),
                        onOnCloseTextarea: _cache[1] || (_cache[1] = ($event) => (visible.value = false)),
                        onOnInpsValueChange: handleOk,
                        minWidth: 180,
                        textAreaPlace: __props.placeholder,
                        maxCount: props.maxRows,
                        label: __props.label
                    }, {
                        extraEle: withCtx(() => [
                            renderSlot(_ctx.$slots, "extraEle")
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["textAreaPlace", "maxCount", "label"])
                ]),
                default: withCtx(() => [
                    renderSlot(_ctx.$slots, "default", {}, () => [
                        createElementVNode("div", {
                            ref: "suffixNode",
                            class: "multi-select-suffix",
                            style: normalizeStyle({ pointerEvents: _ctx.$attrs.disabled ? 'none' : 'auto' })
                        }, _hoisted_2$_, 4 /* STYLE */)
                    ])
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["getPopupContainer", "visible", "overlayStyle"]));
        };
    }
});

script$1E.__file = "packages/multi-search/src/multiSearch.vue";

script$1E.install = (Vue) => {
    Vue.component(script$1E.name, script$1E);
};

function useElementWidth() {
    const elRef = ref();
    const width = ref(100);
    const resizeObserver = new ResizeObserver((entries) => {
        const el = entries[0];
        width.value = el.contentRect.width;
    });
    const unwatch = watch(elRef, (el) => {
        if (el) {
            resizeObserver.observe(el);
            unwatch();
        }
    });
    onBeforeUnmount(() => {
        resizeObserver.disconnect();
    });
    return [elRef, computed(() => `${width.value}px`)];
}

const { Option } = Select;
const multiSelectProps = {
    optionData: {
        type: Array,
        default: () => [],
    },
    mode: {
        type: String,
        default: 'multiple',
    },
    placeholder: {
        type: String,
        default: '',
    },
    isSelectAll: {
        type: [Boolean],
        default: false,
    },
    isClear: {
        type: [Boolean],
        default: false,
    },
    isCustomOption: {
        type: [Boolean],
        default: false,
    },
    width: {
        type: String,
        default: '',
    },
    isDropdownExtra: {
        type: [Boolean],
        default: false,
    },
    isExtraEle: {
        type: [Boolean],
        default: false,
    },
    onOk: {
        type: Function,
    },
    maxCount: {
        type: Number,
        default: 500,
    },
    label: {
        type: String,
        default: '',
    },
    keywords: {
        type: String,
        default: '',
    },
    value: {
        type: Array,
        default: () => [],
    },
    selectProps: {
        type: Object,
    },
    maxTagCount: {
        type: Number,
        default: 6,
    },
};
var script$1D = defineComponent({
    name: 'NewMultiSelect',
    components: {
        'a-select': Select,
        'a-select-option': Option,
        'a-divider': Divider,
        'a-button': Button,
        MultiSearch: script$1E,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes;
        },
    },
    props: multiSelectProps,
    setup(props, { emit }) {
        const dropdownVisible = ref(false);
        const selectedValues = ref([]);
        const isShowSelect = ref();
        const textAreaNode = ref();
        const suffixNode = ref();
        ref(0);
        const [scMutilSelect, scMutilSelectWidth] = useElementWidth();
        const isRight = ref(false);
        const handleList = ref(['br']);
        const selectedData = ref([]);
        const placeholderRef = computed(() => {
            const p = props.placeholder.split('|');
            return [p[0] || '', p[1] || ''];
        });
        const onValuesChange = (value) => {
            selectedValues.value = value;
            emit('update:value', selectedValues.value);
            emit('change', selectedValues.value);
        };
        const showTextArea = computed(() => props.selectProps && props.selectProps.showTextArea);
        let searchValue = '';
        const onSelectSearch = (value) => {
            searchValue = value;
            emit('search', value);
        };
        const onSelectBlur = () => {
            if (props.selectProps && props.selectProps.isInput) {
                const option = props.optionData.find((op) => op.name === searchValue);
                option && selectedValues.value.push(option.id);
                onValuesChange([...new Set([...selectedValues.value])]);
            }
            searchValue = '';
            emit('blur');
        };
        const onSelectFocus = () => {
            emit('focus');
        };
        const onSelectKeyup = (event) => {
            if (event.key === 'Escape') {
                // 取消输入，还原初始值
                searchValue = '';
            }
            emit('keyup', event);
        };
        const selectAll = () => {
            const val = [];
            if (props.selectProps && props.selectProps.filterOption && searchValue) {
                // 开启前端过滤后的option
                props.optionData.map((item) => {
                    item.name &&
                        item.name.indexOf(searchValue) > -1 &&
                        !item.disabled &&
                        val.push(item.id);
                });
            }
            else {
                props.optionData.map((item) => {
                    !item.disabled && val.push(item.id);
                });
            }
            const newVal = [...new Set([...props.value, ...val])];
            onValuesChange(newVal);
        };
        const clearAll = () => {
            onValuesChange([]);
        };
        const onSelect = () => {
            const value = selectedValues.value;
            const data = props.optionData.filter((item) => {
                if (value.includes(item.id)) {
                    return item;
                }
            });
            const newData = Array.from(new Set([...selectedData.value, ...data]));
            selectedData.value = newData.filter((item) => {
                if (value.includes(item.id)) {
                    return item;
                }
            });
            const name = selectedData.value.map((item) => item.name);
            const id = selectedData.value.map((item) => item.id);
            emit('onOk', { name, id });
            isShowSelect.value = false;
        };
        const getTextAreaValue = inject('getTextAreaValue', Function, true);
        const filterTextArea = async (value) => {
            const filterValue = await getTextAreaValue(props.keywords, value);
            if (filterValue && filterValue.length > 0) {
                selectedValues.value = filterValue;
            }
            else {
                selectedValues.value = value;
            }
            // 清空 已有的值和tags，清空tags是重点
            emit('update:value', []);
            emit('update:value', selectedValues.value);
            emit('change', selectedValues.value);
        };
        const onInpsValueChange = (val) => {
            emit('onOk', { name: val, id: val });
            // 异步过滤val
            filterTextArea(val);
        };
        const onSelectVisibleChange = (open) => {
            isShowSelect.value = open;
        };
        const getSelectContainer = () => {
            return scMutilSelect.value;
        };
        const filterOption = (input, option) => {
            return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        };
        return {
            placeholderRef,
            isShowSelect,
            selectedValues,
            selectAll,
            clearAll,
            onSelect,
            onValuesChange,
            onInpsValueChange,
            onSelectVisibleChange,
            getSelectContainer,
            isRight,
            handleList,
            textAreaNode,
            suffixNode,
            scMutilSelect,
            scMutilSelectWidth,
            onSelectSearch,
            onSelectBlur,
            onSelectFocus,
            onSelectKeyup,
            showTextArea,
            filterOption,
            dropdownVisible,
        };
    },
});

function render$1u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_a_divider = resolveComponent("a-divider");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_MultiSearch = resolveComponent("MultiSearch");

  return (openBlock(), createElementBlock("div", {
    ref: "scMutilSelect",
    class: "multi-select-wrapper",
    style: normalizeStyle({ width: _ctx.width })
  }, [
    createVNode(_component_a_select, mergeProps({
      style: { width: _ctx.width },
      class: ["multi-select", _ctx.showTextArea ? ' is-show-textarea' : ''],
      showSearch: "",
      allowClear: "",
      showArrow: false,
      filterOption: _ctx.filterOption,
      optionFilterProp: "title",
      onFocus: _ctx.onSelectFocus,
      onChange: _ctx.onValuesChange,
      onSearch: _ctx.onSelectSearch,
      onBlur: _ctx.onSelectBlur,
      onKeyup: _ctx.onSelectKeyup,
      open: _ctx.isShowSelect
    }, { ..._ctx.selectProps }, {
      maxTagCount: _ctx.maxTagCount,
      value: _ctx.value,
      placeholder: _ctx.placeholderRef[0],
      onDropdownVisibleChange: _ctx.onSelectVisibleChange,
      getPopupContainer: _ctx.getSelectContainer,
      mode: "multiple"
    }), createSlots({
      default: withCtx(() => [
        (_ctx.isCustomOption)
          ? renderSlot(_ctx.$slots, "customOption", { key: 0 })
          : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.optionData, (item) => {
              return (openBlock(), createBlock(_component_a_select_option, {
                key: item.id,
                value: item.id,
                title: item.name,
                disabled: item.disabled
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(item.name), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "title", "disabled"]))
            }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 2 /* DYNAMIC */
    }, [
      (_ctx.mode === 'multiple')
        ? {
            name: "dropdownRender",
            fn: withCtx(({ menuNode: menu }) => [
              createVNode(_component_v_nodes, { vnodes: menu }, null, 8 /* PROPS */, ["vnodes"]),
              (_ctx.isDropdownExtra)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "multi-select-drapExtra",
                    onMousedown: _cache[0] || (_cache[0] = (e) => e.preventDefault())
                  }, [
                    renderSlot(_ctx.$slots, "dropdownExtra")
                  ], 32 /* HYDRATE_EVENTS */))
                : createCommentVNode("v-if", true),
              createVNode(_component_a_divider, { class: "multi-select-divider" }),
              createElementVNode("div", {
                class: "multi-select-extra",
                onMousedown: _cache[3] || (_cache[3] = (e) => e.preventDefault())
              }, [
                createElementVNode("div", null, [
                  (_ctx.isSelectAll)
                    ? (openBlock(), createElementBlock("a", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
                        class: "multi-select-extra-link"
                      }, "全选"))
                    : createCommentVNode("v-if", true),
                  (_ctx.isClear)
                    ? (openBlock(), createElementBlock("a", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
                      }, "清空"))
                    : createCommentVNode("v-if", true)
                ]),
                createVNode(_component_a_button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.onSelect
                }, {
                  default: withCtx(() => [
                    createTextVNode("确认 ")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ], 32 /* HYDRATE_EVENTS */)
            ]),
            key: "0"
          }
        : undefined
    ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["style", "class", "filterOption", "onFocus", "onChange", "onSearch", "onBlur", "onKeyup", "open", "maxTagCount", "value", "placeholder", "onDropdownVisibleChange", "getPopupContainer"]),
    (_ctx.showTextArea)
      ? (openBlock(), createBlock(_component_MultiSearch, {
          key: 0,
          "overlay-style": { width: _ctx.scMutilSelectWidth },
          placeholder: _ctx.placeholderRef[1],
          onOk: _ctx.onInpsValueChange
        }, null, 8 /* PROPS */, ["overlay-style", "placeholder", "onOk"]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" <a-modal\r\n      :wrapClassName=\"\r\n        isRight\r\n          ? 'sc-ui-multi-select-textarea multi-select-textarea-right'\r\n          : 'sc-ui-multi-select-textarea'\r\n      \"\r\n      :mask=\"false\"\r\n      :closable=\"false\"\r\n      :footer=\"null\"\r\n      v-if=\"showTextArea && mode === 'multiple'\"\r\n      v-model:visible=\"textAreaVisible\"\r\n      :getContainer=\"getSelectContainer\"\r\n    >\r\n      \r\n    </a-modal> ")
  ], 4 /* STYLE */))
}

script$1D.render = render$1u;
script$1D.__file = "packages/multi-select/NewMultiSelect.vue";

script$1G.install = (Vue) => {
    Vue.component(script$1G.name, script$1G);
    Vue.component(script$1D.name, script$1D);
};

var script$1C = defineComponent({
    name: 'ScMultiInput',
    components: {
        MultiSearch: script$1E,
    },
    props: {
        width: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        classRef: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        maxCount: {
            type: Number,
            default: 500,
        },
        label: {
            type: String,
            default: '',
        },
        inputProps: {
            type: Object,
        },
    },
    setup(props, { emit }) {
        const textareaValue = ref(props.value.split(/[ |,|，]/).join('\n'));
        const numOfValue = ref(0);
        const [multiInputRef, scMutilSelectWidth] = useElementWidth();
        const valueRef = ref(props.value);
        const isRight = ref(false);
        const handleList = ref(['br']);
        const dropdownVisible = ref(false);
        watch(() => dropdownVisible.value, (val) => {
            if (dropdownVisible.value)
                textareaValue.value = props.value.split(/[ |,|，]/).join('\n');
        });
        watch(() => props.value, (val) => {
            valueRef.value = val;
            textareaValue.value = val.split(/[ |,|，]/).join('\n');
        });
        const placeholderRef = computed(() => {
            const p = props.placeholder.split('|');
            return [p[0] || '', p[1] || ''];
        });
        const handleInput = () => {
            const val = valueRef.value;
            emit('update:value', val);
        };
        const onBlur = () => {
            emit('blur');
        };
        const onFocus = () => {
            emit('focus');
        };
        const onChange = () => {
            emit('change');
        };
        const onValueChange = (e) => {
            const target = e.target.value;
            const val = target.trim().split('\n');
            const _val = val.filter((item) => {
                item = item.trim();
                if (item)
                    return item;
            });
            numOfValue.value = _val.length;
        };
        const onClose = () => {
            dropdownVisible.value = false;
        };
        const onClear = () => {
            // 清空
            textareaValue.value = '';
        };
        const onInpsValueChange = (val) => {
            valueRef.value = val.join(',') || '';
            emit('update:value', valueRef.value);
        };
        return {
            handleList,
            dropdownVisible,
            onClose,
            onChange,
            onFocus,
            onBlur,
            multiInputRef,
            scMutilSelectWidth,
            handleInput,
            valueRef,
            isRight,
            onInpsValueChange,
            onValueChange,
            textareaValue,
            numOfValue,
            placeholderRef,
            onClear,
        };
    },
});

function render$1t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = resolveComponent("a-input");
  const _component_MultiSearch = resolveComponent("MultiSearch");

  return (openBlock(), createElementBlock("div", {
    ref: "multiInputRef",
    class: "sc-multi-wrapper multi-select-wrapper",
    style: normalizeStyle({ width: _ctx.width })
  }, [
    createVNode(_component_a_input, mergeProps({ allowClear: "" }, { inputProps: _ctx.inputProps }, {
      class: ["sc-input-show-count sc-multi-input", _ctx.classRef],
      value: _ctx.valueRef,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.valueRef) = $event)),
      placeholder: _ctx.placeholderRef[0],
      onFocus: _ctx.onFocus,
      onChange: _ctx.onChange,
      onBlur: _ctx.onBlur,
      onInput: _ctx.handleInput,
      autocomplete: "off"
    }), null, 16 /* FULL_PROPS */, ["class", "value", "placeholder", "onFocus", "onChange", "onBlur", "onInput"]),
    createVNode(_component_MultiSearch, {
      "overlay-style": { width: _ctx.scMutilSelectWidth },
      placeholder: _ctx.placeholderRef[1],
      onOk: _ctx.onInpsValueChange
    }, null, 8 /* PROPS */, ["overlay-style", "placeholder", "onOk"])
  ], 4 /* STYLE */))
}

script$1C.render = render$1t;
script$1C.__file = "packages/multi-input/src/multiInput.vue";

script$1C.install = (Vue) => {
    Vue.component(script$1C.name, script$1C);
};

const I18N_LOCALE_KEY = 'SKYCORE_I18N_LOCALE';
const languageList = [
    { key: 'zh-CN', name: '简体中文', message: {} },
    { key: 'en-US', name: 'English', message: {} },
];
const fallbackLocale = languageList[0].key;
const modules = import.meta.glob(['../**/zh-CN.ts', '../**/en-US.ts']);
Object.keys(modules).forEach((modulePath) => {
    // eslint-disable-next-line
    modules[modulePath]().then((module) => {
        const messageData = module.default;
        const matchedKey = modulePath
            .split('/')
            .reverse()[0]
            .replace('.ts', '');
        const matchedLang = languageList.find((lang) => lang.key === matchedKey);
        if (matchedLang) {
            Object.assign(matchedLang.message, messageData);
        }
    });
});
const storedLocale = localStorage.getItem(I18N_LOCALE_KEY);
const matchedStoredLocale = storedLocale && languageList.map((lang) => lang.key).includes(storedLocale)
    ? storedLocale
    : '';
const presetLocale = matchedStoredLocale || navigator.language || fallbackLocale;
const messages = Object.fromEntries(languageList.map(({ key, message }) => [key, message]));
const i18n = createI18n({
    locale: presetLocale,
    messages,
    fallbackLocale,
});

/**
 * @description 获取 url 查询参数
 * @param key? 参数名，可选，
 * @return string | object | number | undefined , key 不传则返回包含所有参数的对象
 */
const getQuery = (key) => {
    const result = {};
    const search = decodeURIComponent(window.location.search);
    const tempArr = search && search.indexOf('?') === 0 ? search.split('?')[1].split('&') : [];
    tempArr.forEach((item) => {
        if (item) {
            const itemArr = item.split('=');
            // 临时数据类型转换
            const isNumber = itemArr[1].length < 11 && /^\d+$/.test(itemArr[1]);
            result[itemArr[0]] = isNumber ? parseInt(itemArr[1], 10) : itemArr[1];
        }
    });
    return key ? result[key] : result;
};

const { global: { t }, } = i18n;
message.config({ maxCount: 1 });
let requestCount = 0;
const prevent = (e) => e.stopImmediatePropagation();
const loading$1 = () => {
    if (requestCount === 0) {
        nextTick().then(() => {
            const dom = document.createElement('div');
            dom.setAttribute('id', 'loading');
            dom.addEventListener('mousedown', prevent);
            dom.addEventListener('touchstart', prevent);
            document.body.appendChild(dom);
            createApp(Spin).mount(dom);
        });
    }
    requestCount += 1;
};
const hideLoading = () => {
    requestCount -= 1;
    const loadingDom = document.getElementById('loading');
    if (requestCount === 0 && loadingDom) {
        document.body.removeChild(loadingDom);
    }
};
const isDev = import.meta.env.DEV;
const env = getQuery('proxy') || import.meta.env.VITE_API_ENV;
// 根据 env 参数切换接口环境，仅在开发环境生效；proxy 保留参数，不要在业务接口中使用
const envSet = new Set(['mock', 'dev', 'qa', 'pro']);
const envUrlDic = {
    mock: '/mock',
    dev: '/dev',
    qa: '/qa',
    pro: '/pro',
};
const getBaseUrl = (config = {}) => {
    let baseURL = '';
    if (isDev) {
        const envInner = env || config.proxyEnv || 'mock';
        if (envInner && envSet.has(envInner)) {
            // TODO 地址填充
            baseURL = envUrlDic[envInner];
        }
    }
    else if (process.env.NODE_ENV === 'production' && process.env.CLIENT === 'electron') {
        let baseURLInner = '';
        if ((config.url || '').startsWith('/ram'))
            baseURLInner = '/1713234-0-default';
        if ((config.url || '').startsWith('/pdm'))
            baseURLInner = '/1783640-0-default';
        if ((config.url || '').startsWith('/common'))
            baseURLInner = '/1963470-0-default';
        if ((config.url || '').startsWith('/oms'))
            baseURLInner = '/2076887-0-default';
        if ((config.url || '').startsWith('/crm'))
            baseURLInner = '/2186502-0-default';
        if ((config.url || '').startsWith('/pms'))
            baseURLInner = '/2373963-0-default';
        baseURL = import.meta.env.VITE_API_PREFIX + baseURLInner;
    }
    return baseURL;
};
const triggerDownload = (url, filename = '') => {
    const link = document.createElement('a');
    link.style.display = 'none';
    // a 标签的 download 属性就是下载下来的文件名
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const preview = (uuid) => {
    return `${getBaseUrl()}/common/api/file/preview-file/${uuid}`;
};
const commonHeader = () => ({
    'x-requested-with': 'XMLHttpRequest',
    Authorization: localStorage.getItem('Authorization') || false,
});
/**
 * 请求
 * @param isDownload 只有响应类型是Blob时使用，true: 下载 false: 预览 undefined(不传): 按常规接口处理
 */
const http = (config, isDownload) => {
    return new Promise((resolve, reject) => {
        config.validateStatus = status => {
            return status < 500;
        };
        config.headers = {
            ...commonHeader(),
            ...config.headers,
        };
        config.baseURL = getBaseUrl(config);
        if (config.proxyEnv) {
            delete config.proxyEnv;
        }
        if (!config.method)
            config.method = 'post';
        if (config.loading !== false) {
            loading$1();
        }
        if (isDownload !== undefined) {
            config.responseType = 'blob';
        }
        axios(config)
            .then((response) => {
            const { headers } = response;
            const res = response.data;
            if (response.status === 200) {
                // mock 不校验 code
                if (env === 'mock') {
                    resolve(res.data);
                    return;
                }
                if (isDownload !== undefined && res instanceof Blob) {
                    const mimeType = headers['content-type'] ?? 'application/pdf';
                    const objectURL = window.URL.createObjectURL(new Blob([res], { type: mimeType }));
                    if (isDownload) {
                        const filename = decodeURIComponent(headers['content-disposition']?.split(';')[1].split('=')[1]);
                        triggerDownload(objectURL, filename);
                    }
                    else {
                        window.open(objectURL);
                    }
                    // 释放的 URL 对象以及移除 a 标签
                    URL.revokeObjectURL(objectURL);
                    resolve(res);
                    return;
                }
                if (typeof res === 'object') {
                    if (res.code === 200) {
                        resolve(res.data);
                        return;
                    }
                    // 未登录或登录信息失效
                    if (res.code === 10203001 || res.code === 10203003) {
                        let params = '';
                        if (res?.data?.isRedirectToOriginalPage) {
                            params = `?redirectUrl=${encodeURIComponent(window.location.href)}`;
                        }
                        window.location.replace(`/#/login${params}`);
                        window.location.reload();
                        return;
                    }
                }
            }
            if (headers.redirect_url) {
                window.location.href = headers.redirect_url;
            }
            const errorRes = {
                message: t('message.commonRequestFailed'),
                ...(res || {}),
            };
            message.error(errorRes.message);
            reject(response);
        })
            .catch(response => {
            message.error(response?.data?.message || t('message.commonRequestFailed'));
        })
            .finally(() => {
            if (config.loading !== false) {
                hideLoading();
            }
        });
    });
};

const baseUrl$9 = process.env.VUE_APP_URL;
const urls$8 = {
    getBigAreaAndProvince: '/common/location/get-all-area-and-province',
    getCityAndCounty: '/common/api/area/list-area',
};
let cityData = [];
// 获取城市列表
const fetchCitiesList = () => {
    if (cityData.length) {
        return Promise.resolve(cityData);
    }
    return http({
        url: urls$8.getCityAndCounty,
        withCredentials: true,
        baseURL: baseUrl$9,
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
    }).then((data) => (cityData = data));
};

let loading = false;
const sharedCityData = ref([]);
const refreshCityData = () => {
    if (loading || sharedCityData.value.length)
        return;
    loading = true;
    fetchCitiesList().then((data) => {
        sharedCityData.value = data;
    });
};

var script$1B = defineComponent({
    name: 'ScCascader',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        tag: {
            type: String,
            default: '',
        },
        isCityPicker: {
            type: [Boolean],
            default: false,
        },
        isTimePicker: {
            type: [Boolean],
            default: false,
        },
        showSearch: {
            type: [Boolean],
            default: false,
        },
        changeOnSelect: {
            type: [Boolean],
            default: true,
        },
        options: {
            type: Array,
            default: () => [],
        },
        //城市选择 1 只显示省份，2 显示省和市
        cityLevel: {
            type: Number,
            default: 0,
            validator: (v) => v <= 2 && v >= 0,
        },
    },
    methods: {
        focus() {
            if (this.$refs.cascaderRef) {
                this.$refs.cascaderRef.focus();
            }
        },
    },
    setup(props, { emit }) {
        const optionsRef = ref(props.options);
        const valueRef = ref(props.value);
        const connector = ref(' / ');
        const initValueRef = () => {
            const val = [...valueRef.value];
            valueRef.value.length = 0;
            valueRef.value.push(...val);
        };
        watch(() => props.value, () => {
            valueRef.value = props.value;
        }, { immediate: true, deep: true });
        // 初始化大区-省份-城市结构数
        // 输出areaTreeData
        const initCityTreeData = () => {
            const province = {};
            const cities = {};
            cityData.map((city) => {
                if (city.level === 1) {
                    optionsRef.value.push({ value: city.code, label: city.name });
                }
                else if (city.level === 2) {
                    if (!province[city.parentCode])
                        province[city.parentCode] = [];
                    province[city.parentCode].push({
                        value: city.code,
                        label: city.name,
                    });
                }
                else if (city.level === 3) {
                    if (!cities[city.parentCode])
                        cities[city.parentCode] = [];
                    cities[city.parentCode].push({ value: city.code, label: city.name });
                }
            });
            Object.keys(province).map((code) => {
                province[code].forEach((city) => {
                    city.children = cities[city.value];
                });
            });
            optionsRef.value.forEach((prov) => {
                prov.children = province[prov.value];
            });
        };
        let cityData = [];
        const initAreaData = async () => {
            cityData = sharedCityData.value;
            if (props.cityLevel === 1 || props.cityLevel === 2) {
                cityData = cityData.filter((e) => e.level <= props.cityLevel);
            }
            initCityTreeData();
            initValueRef();
        };
        watch(() => sharedCityData.value, (d) => {
            if (props.isCityPicker && d.length) {
                initAreaData();
            }
        }, { immediate: true });
        const initTimeData = () => {
            optionsRef.value.length = 0;
            const minute = [...new Array(60)].map((e, i) => {
                const value = i < 10 ? '0' + i : '' + i;
                return {
                    label: value,
                    value,
                };
            });
            [...new Array(24)].map((e, i) => {
                const value = i < 10 ? '0' + i : '' + i;
                optionsRef.value.push({
                    label: value,
                    value,
                    children: minute,
                });
            });
        };
        onBeforeMount(() => {
            if (props.isCityPicker) {
                connector.value = '-';
                refreshCityData();
            }
            else if (props.isTimePicker) {
                connector.value = ':';
                initTimeData();
            }
        });
        // 手动更改选择回调
        const handleChange = (value, selectedOptions) => {
            // 自动选择分钟
            if (props.isTimePicker && value.length === 1) {
                value.push('00');
                selectedOptions.push({ label: '00', value: '00' });
            }
            const tags = selectedOptions?.map((e) => e.label)?.join(connector.value) ?? '';
            // 必须先emit tags，后emit value
            emit('update:tag', tags);
            emit('update:value', value);
        };
        return { optionsRef, valueRef, handleChange, connector };
    },
});

function render$1s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_cascader = resolveComponent("a-cascader");

  return (openBlock(), createBlock(_component_a_cascader, mergeProps({
    ref: "cascaderRef",
    class: "sc-cascader",
    dropdownClassName: "sc-cascader-popup"
  }, { ..._ctx.$props }, {
    options: _ctx.optionsRef,
    value: _ctx.valueRef,
    "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.valueRef) = $event)),
    onChange: _ctx.handleChange,
    displayRender: ({ labels }) => labels.join(_ctx.connector),
    getPopupContainer: (triggerNode) => triggerNode.parentNode,
    showSearch: _ctx.showSearch
  }), null, 16 /* FULL_PROPS */, ["options", "value", "onChange", "displayRender", "getPopupContainer", "showSearch"]))
}

script$1B.render = render$1s;
script$1B.__file = "packages/cascader/src/Cascader.vue";

if (!Array.prototype.remove) {
  Array.prototype.remove = function (o) {
    const index = this.indexOf(o);
    if (index > -1) {
      this.splice(index, 1);
    }
  };
}
var script$1A = defineComponent({
  name: 'ScMultipleCascader',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tag: {
      type: String,
      default: ''
    },
    checkAll: {
      type: [Boolean],
      default: false
    },
    multiple: {
      type: [Boolean],
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {
    emit
  }) {
    const optionsRef = computed(() => props.options);
    const valueRef = computed(() => props.value);
    const tagsRef = ref([]);
    const refCascader = ref();
    const initMultiple = () => {
      if (optionsRef.value.length === 0) return;
      // 递归遍历
      const deepForEach = (arr, parents) => {
        arr.forEach(item => {
          const propsCheckbox = {
            checked: item.checked,
            indeterminate: item.indeterminate,
            disabled: item.disabled,
            onClick: event => {
              event.stopPropagation();
            },
            onChange: event => {
              onCheckboxChange(event.target.checked, item, parents);
            }
          };
          item.label = createVNode(Checkbox, mergeProps({
            'checked': item.checked,
            "onUpdate:checked": $event => item.checked = $event
          }, propsCheckbox), {
            default: () => [item.name]
          });
          item.fullName = [...parents.map(it => it.name).reverse(), item.name].join('-');
          item.children && deepForEach(item.children, [item, ...parents]);
        });
      };
      deepForEach(optionsRef.value, []);
    };
    const onCheckboxChange = (checked, self, parents) => {
      const checkedValue = [];
      const unCheckedValue = [];
      checked ? checkedValue.push([self.value, self.fullName]) : unCheckedValue.push([self.value, self.fullName]);
      // 更新自己状态
      self.checked = checked;
      self.indeterminate = false;
      // 所有子集
      const deepForEach = arr => {
        arr.forEach(item => {
          item.checked && unCheckedValue.push([item.value, item.fullName]);
          item.checked = checked;
          item.indeterminate = false;
          item.children && deepForEach(item.children);
        });
      };
      self.children && deepForEach(self.children);
      // 所有父级
      parents.map(item => {
        // 兄弟是否全选
        const hasIndeter = item.children.some(it => it.indeterminate);
        const hasChecked = item.children.filter(it => it.checked);
        const _IsCheckedAll = hasChecked.length === item.children.length;
        const _IsCheckedNone = hasChecked.length === 0 && !hasIndeter;
        if (_IsCheckedAll) {
          // checked 一定是 true
          checkedValue.splice(0, 1, [item.value, item.fullName]);
          unCheckedValue.push(...item.children.map(it => [it.value, it.fullName]));
          item.checked = true;
          item.indeterminate = false;
        } else if (_IsCheckedNone) {
          // checked 一定是 false
          unCheckedValue.push([item.value, item.fullName]);
          item.checked = false;
          item.indeterminate = false;
        } else {
          // checked 是 true or false
          if (!checked) {
            const notInValue = hasChecked.filter(it => !valueRef.value.includes(it.value));
            checkedValue.push(...notInValue.map(it => [it.value, it.fullName]));
            valueRef.value.includes(item.value) && unCheckedValue.push([item.value, item.fullName]);
          }
          item.checked = false;
          item.indeterminate = true;
        }
      });
      valueRef.value.push(...checkedValue.map(v => v[0]));
      unCheckedValue.map(v => valueRef.value.remove(v[0]));
      tagsRef.value.push(...checkedValue.map(v => v[1]));
      unCheckedValue.map(v => tagsRef.value.remove(v[1]));
      nextTick(setLabelText);
      initMultiple();
      emit('update:tag', tagsRef.value.toString());
      emit('update:value', valueRef.value);
      emit('change', valueRef.value);
    };
    const setLabelText = () => {
      const labelDom = refCascader.value.$el.nextElementSibling && refCascader.value.$el.nextElementSibling.children[0];
      labelDom && labelDom.className === 'ant-cascader-picker-label' && (labelDom.innerHTML = tagsRef.value.toString());
    };
    // 下拉选项开启和关闭
    const popupVisibleRef = ref(false);
    const addEvent = val => {
      if (val) {
        setTimeout(() => {
          document.addEventListener('click', handleClosePopup);
        }, 100);
      } else {
        document.removeEventListener('click', handleClosePopup);
      }
    };
    watch(() => popupVisibleRef.value, addEvent);
    const handleClosePopup = e => {
      const stopPropagation = target => {
        if (target.className && target.className.includes && target.className.includes('ant-cascader-menu-item')) return true;
        if (target.parentNode) return stopPropagation(target.parentNode);
        return false;
      };
      if (!stopPropagation(e.target)) popupVisibleRef.value = false;
    };
    const handleOpenPopup = () => {
      setLabelText();
      popupVisibleRef.value = true;
    };
    watch(() => [props.options[0].checked, props.options[0].indeterminate], initMultiple, {
      immediate: true
    });
    return () => {
      const cascaderProps = {
        ref: refCascader,
        class: 'sc-cascader',
        popupClassName: 'sc-cascader-popup',
        expandTrigger: 'hover',
        changeOnSelect: true,
        value: valueRef.value,
        popupVisible: popupVisibleRef.value,
        options: optionsRef.value,
        getPopupContainer: triggerNode => triggerNode.parentNode
      };
      const divProps = {
        onClick: handleOpenPopup
      };
      let cascaderVnode = createVNode(Cascader, cascaderProps, null);
      if (props.checkAll) {
        cascaderProps.options = optionsRef.value[0].children;
        cascaderVnode = createVNode(Fragment, null, [optionsRef.value[0].label, createVNode(Cascader, cascaderProps, {
          default: () => [createVNode("div", {
            "class": "sc-cascader-multiple-label"
          }, [createVNode(DownOutlined, null, null)])]
        })]);
      }
      return createVNode("div", mergeProps({
        "class": "sc-cascader-multiple"
      }, divProps), [cascaderVnode]);
    };
  }
});

script$1A.__file = "packages/cascader/src/MultipleCascader.vue";

script$1B.install = (Vue) => {
    Vue.component(script$1B.name, script$1B);
    Vue.component(script$1A.name, script$1A);
};

var script$1z = defineComponent({
    name: 'ScCheckbox',
    props: {
        value: {
            type: [String, Number, Boolean, Array],
            default: '',
        },
        checked: {
            type: [Boolean],
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        unCheckedVal: {
            type: [String, Number, Boolean],
        },
    },
    emits: ['change', 'update:value'],
    setup(props, { emit }) {
        const valueRef = computed(() => props.value);
        const checkedRef = computed(() => props.value === props.options[0].id);
        const handleChange = (val) => {
            if (props.options.length === 1 && val.target) {
                const unCheckedVal = props.unCheckedVal !== undefined
                    ? props.unCheckedVal
                    : !props.options[0].id;
                val = val.target.checked ? props.options[0].id : unCheckedVal;
            }
            emit('update:value', val);
            emit('change', val);
        };
        return { valueRef, checkedRef, handleChange };
    },
});

function render$1r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_checkbox_group = resolveComponent("a-checkbox-group");

  return (_ctx.options.length === 1)
    ? (openBlock(), createBlock(_component_a_checkbox, mergeProps({ key: 0 }, { ..._ctx.$attrs }, {
        checked: _ctx.checkedRef,
        "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.checkedRef) = $event)),
        disabled: _ctx.options[0].disabled,
        onChange: _ctx.handleChange
      }), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.options[0].name), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */, ["checked", "disabled", "onChange"]))
    : (openBlock(), createBlock(_component_a_checkbox_group, mergeProps({ key: 1 }, { ..._ctx.$attrs }, {
        value: _ctx.valueRef,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.valueRef) = $event)),
        onChange: _ctx.handleChange
      }), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (o) => {
            return (openBlock(), createBlock(_component_a_checkbox, {
              value: o.id,
              key: o.id,
              disabled: o.disabled
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */, ["value", "onChange"]))
}

script$1z.render = render$1r;
script$1z.__file = "packages/checkbox/src/Checkbox.vue";

script$1z.install = (Vue) => {
    Vue.component(script$1z.name, script$1z);
};

const baseUrl$8 = process.env.VUE_APP_URL;
const uploadApi = (param, url, _baseUrl) => {
    return http({
        url: url,
        withCredentials: true,
        baseURL: _baseUrl ? _baseUrl : baseUrl$8,
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryLQRO3VkrvkJzSqMs',
            processData: false,
            contentType: false,
        },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error(res.data || res.data.message || '系统错误，请稍后重试...');
        }
    });
};

var script$1y = defineComponent({
    name: 'ScUpload',
    inheritAttrs: false,
    components: {
        PlusOutlined,
    },
    props: {
        acceptType: {
            type: String,
            default: 'image/jpg,image/jpeg,image/png',
        },
        size: {
            type: Number,
            default: 1024 * 1024,
        },
        fileList: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
        url: {
            type: String,
            default: '/fs/upload-customer-contract?appName=stock-out-vue',
        },
        baseUrl: {
            type: String,
            default: process.env.VUE_APP_URL,
        },
        uploadClass: {
            // 自定义样式
            type: String,
            default: '',
        },
        maxName: {
            type: Number,
            default: 20,
        },
        showCustomizeList: {
            type: Boolean,
            default: true,
        },
        max: {
            // 最大上传数量
            type: Number,
        },
        desc: {
            type: String,
            default: '',
        },
        msgArr: {
            type: Array,
            default: () => [],
        },
        fileName: {
            type: String,
            default: 'file',
        },
        hideUpload: {
            type: Boolean,
            default: false,
        },
        // text, picture , picture-card, input
        listType: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit, attrs }) {
        const uploadRef = ref();
        // 类名
        const classNameRef = ref([]);
        const initClassName = () => {
            if (props.hideUpload) {
                classNameRef.value.push('is-hide-upload');
            }
            else {
                const index = classNameRef.value.findIndex((e) => e === 'is-hide-upload');
                index > -1 && classNameRef.value.splice(index, 1);
            }
            props.listType && classNameRef.value.push('is-' + props.listType);
        };
        // 上传
        const customRequest = async (options, item) => {
            let params = new FormData();
            params.append(props.fileName, options.file);
            const res = await uploadApi(params, props.url, props.baseUrl);
            if (res) {
                if (item) {
                    emit('clickBtn', { ...item, res: res }, 2);
                }
                else {
                    !attrs.onUpload && onUpload(res, options); // 没有自定义的onUpload事件，执行默认方法
                    emit('upload', res, options);
                }
            }
            else {
                message.error('上传服务器错误');
            }
        };
        // 上传文件限制
        const beforeUpload = (file) => {
            if (file.name && file.name.length > props.maxName) {
                if (props.msgArr && props.msgArr[0]) {
                    message.error(props.msgArr[0]);
                }
                else {
                    message.error(`上传的文件名请勿超过${props.maxName}个字`);
                }
                return false;
            }
            if (file.type && props.acceptType.indexOf(file.type) == -1) {
                if (props.desc) {
                    message.error(props.desc);
                }
                else if (props.msgArr && props.msgArr[1]) {
                    message.error(props.msgArr[1]);
                }
                else {
                    message.error('请上传正确的文件格式');
                }
                return false;
            }
            if (file.size && file.size > props.size) {
                if (props.desc) {
                    message.error(props.desc);
                }
                else if (props.msgArr && props.msgArr[1]) {
                    message.error(props.msgArr[2]);
                }
                else {
                    message.error(`上传的文件大小请勿超过${props.size / 1024 / 1024}M`);
                }
                return false;
            }
        };
        const handlerClick = (item, type) => {
            emit('clickBtn', item, type);
        };
        // ################ 图片上传处理开始 ##################
        const previewVisible = ref(false);
        const previewImage = ref('');
        const getBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        };
        const handleCancel = () => {
            previewVisible.value = false;
        };
        const handlePreview = async (file) => {
            if (props.listType !== 'picture-card')
                return;
            if (!file.url && !file.preview) {
                file.preview = (await getBase64(file.originFileObj));
            }
            previewImage.value = file.url || file.preview;
            previewVisible.value = true;
        };
        const fileListRef = computed({
            get: () => props.fileList,
            set: (val) => emit('update:fileList', val),
        });
        const onUpload = (data, options) => {
            message.success('上传成功');
            fileListRef.value.push({
                uid: data,
                url: '/fs/preview?uuid=' + data,
                name: data,
                file: options.file,
                status: 'done',
            });
            const fileIds = fileListRef.value.map((file) => file.uid);
            emit('update:value', fileIds);
            emit('uploaded', fileIds);
        };
        const handleChange = ({ fileList }) => {
            // 临时用类型判断
            const newFileList = props.listType !== 'picture-card'
                ? fileList
                : fileList.filter((file) => file.status === 'done');
            fileListRef.value.splice(0);
            fileListRef.value.push(...newFileList);
            // 手动上传时，依赖该事件
            const fileIds = fileListRef.value.map((file) => file.uid);
            emit('update:value', fileIds);
        };
        // 粘贴上传--------------
        const pasteUpload = (event) => {
            if (props.hideUpload || props.listType !== 'picture-card')
                return;
            const items = event.clipboardData && event.clipboardData.items;
            if (!(items && items.length))
                return;
            let file = null;
            // 检索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
            if (file)
                customRequest({ file });
        };
        const addPasteEvent = () => {
            uploadRef.value.addEventListener('paste', pasteUpload);
        };
        const removePasteEvent = () => {
            uploadRef.value.removeEventListener('paste', pasteUpload);
        };
        watch(() => props.hideUpload, initClassName, { immediate: true });
        onMounted(addPasteEvent);
        onBeforeUnmount(removePasteEvent);
        // ################ 图片上传处理结束 ##################
        return {
            customRequest,
            handlerClick,
            beforeUpload,
            previewVisible,
            previewImage,
            handleCancel,
            handlePreview,
            onUpload,
            fileListRef,
            handleChange,
            classNameRef,
            uploadRef,
        };
    },
});

const _hoisted_1$1c = { key: 0 };
const _hoisted_2$Z = /*#__PURE__*/createElementVNode("div", { class: "ant-upload-text" }, "上传", -1 /* HOISTED */);
const _hoisted_3$N = ["title"];
const _hoisted_4$D = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_5$v = { key: 0 };
const _hoisted_6$o = ["src"];

function render$1q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_plus_outlined = resolveComponent("plus-outlined");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_upload = resolveComponent("a-upload");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["sc-upload", _ctx.classNameRef]),
    ref: "uploadRef"
  }, [
    createVNode(_component_a_upload, mergeProps({
      "file-list": _ctx.fileListRef,
      accept: _ctx.acceptType,
      showUploadList: !_ctx.showCustomizeList,
      customRequest: _ctx.customRequest,
      beforeUpload: _ctx.beforeUpload,
      onPreview: _ctx.handlePreview,
      onChange: _ctx.handleChange
    }, { ..._ctx.$props, ..._ctx.$attrs }, { name: "file" }), {
      default: withCtx(() => [
        (!_ctx.hideUpload && !(_ctx.max && _ctx.fileListRef.length >= _ctx.max))
          ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              (_ctx.listType === 'picture-card')
                ? (openBlock(), createElementBlock("div", _hoisted_1$1c, [
                    createVNode(_component_plus_outlined),
                    _hoisted_2$Z
                  ]))
                : (_ctx.listType === 'input')
                  ? (openBlock(), createElementBlock("div", {
                      key: 1,
                      class: "upload-input-box",
                      title: _ctx.fileListRef.length > 0 ? _ctx.fileListRef[0].name : ''
                    }, [
                      createVNode(_component_a_input, {
                        readonly: "",
                        placeholder: _ctx.placeholder,
                        value: _ctx.fileListRef.length > 0 ? _ctx.fileListRef[0].name : ''
                      }, null, 8 /* PROPS */, ["placeholder", "value"]),
                      createVNode(_component_a_button, null, {
                        default: withCtx(() => [
                          createTextVNode("选择文件")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ], 8 /* PROPS */, _hoisted_3$N))
                  : (openBlock(), createBlock(_component_a_button, {
                      key: 2,
                      class: "sc-btn-upload",
                      type: "primary",
                      ghost: ""
                    }, {
                      default: withCtx(() => [
                        _hoisted_4$D,
                        createTextVNode(" 上传 ")
                      ]),
                      _: 1 /* STABLE */
                    }))
            ], 64 /* STABLE_FRAGMENT */))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["file-list", "accept", "showUploadList", "customRequest", "beforeUpload", "onPreview", "onChange"]),
    (_ctx.showCustomizeList)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(['sc-upload-customizeList', _ctx.uploadClass])
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.fileListRef, (item) => {
            return (openBlock(), createElementBlock("div", {
              key: item.uid
            }, [
              createElementVNode("span", null, toDisplayString(item.name), 1 /* TEXT */),
              createElementVNode("div", null, [
                createVNode(_component_a_button, {
                  type: "link",
                  onClick: $event => (_ctx.handlerClick(item, 1))
                }, {
                  default: withCtx(() => [
                    createTextVNode("查看")
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                createVNode(_component_a_upload, mergeProps({
                  accept: _ctx.acceptType,
                  showUploadList: false,
                  customRequest: (options) => _ctx.customRequest(options, item),
                  beforeUpload: _ctx.beforeUpload
                }, { ..._ctx.$props, ..._ctx.$attrs }), {
                  default: withCtx(() => [
                    (!_ctx.hideUpload)
                      ? (openBlock(), createBlock(_component_a_button, {
                          key: 0,
                          type: "link"
                        }, {
                          default: withCtx(() => [
                            createTextVNode("修改")
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["accept", "customRequest", "beforeUpload"]),
                (!_ctx.hideUpload)
                  ? (openBlock(), createBlock(_component_a_button, {
                      key: 0,
                      type: "link",
                      onClick: $event => (_ctx.handlerClick(item, 3))
                    }, {
                      default: withCtx(() => [
                        createTextVNode("删除")
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                  : createCommentVNode("v-if", true)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.fileListRef.length == 0 && _ctx.hideUpload)
            ? (openBlock(), createElementBlock("div", _hoisted_5$v, "-"))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    createVNode(_component_a_modal, {
      visible: _ctx.previewVisible,
      footer: null,
      onCancel: _ctx.handleCancel
    }, {
      default: withCtx(() => [
        createElementVNode("img", {
          style: {"width":"100%"},
          src: _ctx.previewImage
        }, null, 8 /* PROPS */, _hoisted_6$o)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "onCancel"])
  ], 2 /* CLASS */))
}

script$1y.render = render$1q;
script$1y.__file = "packages/upload/src/Upload.vue";

script$1y.install = (Vue) => {
    Vue.component(script$1y.name, script$1y);
};

var script$1x = defineComponent({
    name: 'ScSelect',
    props: {
        value: {
            type: [String, Object],
            default: () => { },
        },
        labelInValue: {
            type: Boolean,
            default: false,
        },
        search: {
            type: Function,
        },
        select: {
            type: Function,
        },
        focus: {
            type: Function,
        },
    },
    setup(props, { emit }) {
        const selectRef = ref();
        const searchValue = ref(''); // 搜索内容
        // 选中值
        const selectValue = computed({
            get: () => props.value,
            set: (val) => {
                emit('update:value', val);
            },
        });
        // 聚焦回调
        const handleFocus = (ev) => {
            if (selectValue.value) {
                if (typeof selectValue.value == 'object') {
                    searchValue.value = selectValue.value.label;
                }
                else {
                    searchValue.value = selectValue.value;
                }
            }
            else {
                searchValue.value = '';
            }
            props.focus && props.focus(ev);
        };
        const isOpen = ref(true);
        const dropdownVisibleChange = (open) => {
            isOpen.value = open;
        };
        // 搜索回调
        const handleSearch = (val) => {
            searchValue.value = val;
            if (isOpen.value) {
                props.search && props.search(val);
            }
        };
        // 选中后回调
        const handleSelect = (option) => {
            props.select && props.select(option);
            selectRef.value.blur();
        };
        return {
            selectRef,
            searchValue,
            selectValue,
            handleFocus,
            handleSearch,
            handleSelect,
            dropdownVisibleChange,
        };
    },
});

function render$1p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_select = resolveComponent("a-select");

  return (openBlock(), createBlock(_component_a_select, mergeProps({
    ref: "selectRef",
    searchValue: _ctx.searchValue,
    labelInValue: _ctx.$props.labelInValue,
    value: _ctx.selectValue,
    "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.selectValue) = $event)),
    onFocus: _ctx.handleFocus,
    onSelect: _ctx.handleSelect,
    onSearch: _ctx.handleSearch,
    onDropdownVisibleChange: _ctx.dropdownVisibleChange
  }, { ..._ctx.$props, ..._ctx.$attrs, ..._ctx.$slots }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["searchValue", "labelInValue", "value", "onFocus", "onSelect", "onSearch", "onDropdownVisibleChange"]))
}

script$1x.render = render$1p;
script$1x.__file = "packages/form/src/components/Select.vue";

const _hoisted_1$1b = ["innerHTML"];
const _hoisted_2$Y = { key: 1 };
var script$1w = /*#__PURE__*/ defineComponent({
    __name: 'vnode-html-renderer',
    props: {
        content: {
            required: true,
            type: Object,
        },
    },
    setup(__props) {
        const props = __props;
        const isString = (content) => !!content && typeof content === 'string';
        const isVNode = (content) => !!content && typeof content == 'object' && content.__v_isVNode;
        return (_ctx, _cache) => {
            return (isString(props.content))
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    innerHTML: props.content
                }, null, 8 /* PROPS */, _hoisted_1$1b))
                : (isVNode(props.content))
                    ? (openBlock(), createElementBlock("div", _hoisted_2$Y, [
                        (openBlock(), createBlock(resolveDynamicComponent(props.content)))
                    ]))
                    : createCommentVNode("v-if", true);
        };
    }
});

script$1w.__file = "packages/vnode-html-renderer/vnode-html-renderer.vue";

script$1w.install = (Vue) => {
    Vue.component('sc-vnode-html-renderer', script$1w);
};

var script$1v = defineComponent({
    name: 'BasicFormItem',
    components: {
        DatePicker: script$1L,
        ScRangePicker: script$1K,
        NewMultiSelect: script$1D,
        InputGroup: script$1J,
        InputGroups: script$1I,
        Cascader: script$1B,
        Checkbox: script$1z,
        Upload: script$1y,
        Tooltip,
        MultiInput: script$1C,
        ScSelect: script$1x,
        VnodeHtmlRenderer: script$1w,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        value: {
            type: [Number, String, Array],
        },
        tag: {
            type: String,
            default: '',
        },
        newKeyClass: {
            type: String,
            default: '',
        },
        updateNewKeyClass: {
            type: Function,
            default: () => null,
        },
        doShowItem: {
            type: Function,
            default: () => null,
        },
        isInline: {
            type: [Boolean],
            default: false,
        },
        isCols: {
            type: [Boolean],
            default: false,
        },
        //单项编辑模式
        isSingleEdit: {
            type: [Boolean],
            default: false,
        },
        alwaysShowController: {
            type: [Boolean],
            default: false,
        },
        /**
         * @returns boolean
         */
        onSingleEditingOk: Function,
        onSingleEditingCancel: Function,
        onSingleEditStart: Function,
        highLight: Boolean,
    },
    module: {},
    setup(props, context) {
        const optionsRef = computed(() => props.item.options);
        //挂载后本地保存值的选项回填
        onMounted(() => {
            const values = Array.isArray(props.value) ? props.value : [props.value];
            if (props.tag &&
                Array.isArray(optionsRef.value) &&
                ['Select', 'ScSelect', 'SelectMultiple', 'MultipleSelect'].indexOf(props.item.type) >= 0) {
                const tags = typeof props.tag === 'string' && props.tag.split('，');
                values.map((v, i) => {
                    tags[i] &&
                        tags[i] !== v &&
                        optionsRef.value.findIndex((op) => op.id === v) === -1 &&
                        optionsRef.value.push({ id: v, name: tags[i] });
                });
            }
            if (props.item.type === 'Cascader' && props.item.props?.isCityPicker) {
                refreshCityData();
            }
        });
        const itemClassRef = computed(() => ((isTextRef.value || '') && 'sc-text-form') +
            ((props.item.extra || '') && ' sc-form-has-extra') +
            ((props.item.desc || '') && ' sc-form-has-desc') +
            ((props.isSingleEdit || '') && ' sc-form-is-single') +
            (' sc-form-' + props.item.type) +
            ((props.item.label === ' ' || '') && ' sc-form-label-blank') +
            (((props.item.props && props.item.props.disabled) || '') &&
                ' sc-form-disabled') +
            ((props.isInline || '') && ' sc-inline-item') +
            ((props.isCols || '') && ' sc-col-item') +
            (' sc-col-item-' + (props.item.column || '1')) +
            (props.highLight ? ' sc-form-item-highlight' : ''));
        const classRef = ref('');
        watch(() => props.newKeyClass, (val) => {
            if (!val)
                classRef.value = '';
        });
        const tagRef = ref('');
        const setValueRef = (val) => {
            const oldTag = (tagRef.value || '').split('，');
            if (!['InputGroup', 'Cascader', 'InputGroups', 'RangePicker'].includes(props.item.type))
                tagRef.value = '';
            classRef.value = props.updateNewKeyClass(val === '' || val === undefined || (Array.isArray(val) && !val.length)
                ? false
                : true);
            if (val) {
                props.doShowItem(props.item.key);
                const options = optionsRef.value;
                const getValText = (v, i = -1) => {
                    if (options) {
                        const op = options.find((o) => o.id === v);
                        return (op && op.name) || oldTag[i] || v.toString();
                    }
                    else {
                        return v.toString();
                    }
                };
                if (props.item.type === 'TreeSelect')
                    tagRef.value = getTreeSelectTag(val);
                if (tagRef.value === '') {
                    if (Array.isArray(val)) {
                        const ex = props.item.type === 'RangePicker' ? ' 至 ' : '，';
                        if (!(props.item.type == 'InputGroup' ||
                            props.item.type == 'InputGroups'))
                            tagRef.value = val.map(getValText).join(ex);
                    }
                    else {
                        tagRef.value = getValText(val);
                    }
                }
            }
            setShowCount(val);
            context.emit('update:value', val);
            context.emit('update:tag', tagRef.value);
        };
        const setTrimVal = (event) => {
            if ((props.item.props && props.item.props.isTrim) === false)
                return;
            const val = event && event.target && event.target.value;
            if (val && val.trim && val !== val.trim())
                setValueRef(val.trim());
        };
        const valueRef = computed({
            get: () => props.value,
            set: setValueRef,
        });
        const getOptions = inject('getOptions', Function, true);
        const updateOptions = async (value = '') => {
            const options = await getOptions(props.item.key, props.item.cascader, value);
            if (options) {
                optionsRef.value.length = 0;
                optionsRef.value.push(...options);
            }
        };
        const onHandleFocus = (event, prop) => {
            oldValueRef.value = valueRef.value;
            // 级联组件逻辑
            props.item.cascader && updateOptions();
            prop && prop(event);
            // setTagCount((props.item.props && props.item.props.maxTagCount) || 6);
        };
        // 计时器
        let timeId = 0;
        // search 和 change事件的event是value
        const onHandleSearch = (value, prop) => {
            // 允许select输入直接赋值
            value &&
                (props.item.type === 'Select' || props.item.type === 'ScSelect') &&
                props.item.props &&
                props.item.props.isInput &&
                (valueRef.value = value);
            if (timeId)
                clearTimeout(timeId);
            timeId = window.setTimeout(() => {
                // 级联组件逻辑
                props.item.cascader && updateOptions(value);
                // item.props.search方法
                prop && prop(value);
            }, 200);
        };
        const childrenCascader = inject('childrenCascader', undefined);
        const clearSelected = inject('clearSelected', Function, true);
        const onHandleChange = (value, prop) => {
            // 清除级联子组件的选择数据
            childrenCascader &&
                childrenCascader[props.item.key] &&
                clearSelected(props.item.key, childrenCascader[props.item.key]);
            formValidate('onFieldChange');
            // 回调事件
            prop && prop(value);
            // 提交事件
            props.item.isSubmit &&
                context.emit('submit', { [props.item.key]: value });
        };
        //点击文本字段，切换到编辑模式
        const isTextRef = ref(props.item.isText);
        const oldValueRef = ref(props.value);
        watch(() => props.item.isText, (val) => (isTextRef.value = val));
        const internalInstance = getCurrentInstance();
        const formItemRef = ref();
        const onHandleEdit = (key) => {
            // 未开启独立编辑，或表单项被禁用，则不启用
            if (!props.isSingleEdit ||
                (props.item.props && props.item.props.disabled))
                return;
            const canEdit = props.onSingleEditStart?.(props.item.key, () => {
                if (canEdit === false)
                    return;
                isTextRef.value = false;
                nextTick(() => {
                    const itemRef = internalInstance && internalInstance.refs[key];
                    if (itemRef && itemRef.focus)
                        itemRef.focus();
                    if (props.item.type === 'RangePicker' && itemRef?.openPanel)
                        itemRef.openPanel(true);
                });
            });
        };
        let flag = true;
        const onHandleBlur = debounce((value, prop) => {
            if (!flag) {
                flag = true;
                return;
            }
            // blurSelectSearchValue();
            // 去除首尾空格
            setTrimVal(value);
            props.item.isSubmit && nextTick(submitFormItem);
            setTagCount((props.item.props && props.item.props.minTagCount) || 5);
            formValidate('onFieldBlur');
            setTrimVal(value);
            const ret = props.onSingleEditingOk?.({
                key: props.item.key,
                value: valueRef.value,
            });
            ret?.then(() => {
                props.item.isText && nextTick(() => (isTextRef.value = true));
            });
            // 回调事件
            typeof prop === 'function' && prop(value);
        }, 100);
        const confirmSingleEditing = (value) => {
            flag = false;
            // 去除首尾空格
            setTrimVal(value);
            const ret = props.onSingleEditingOk?.({
                key: props.item.key,
                value: valueRef.value,
            });
            ret?.then(() => {
                props.item.isText && nextTick(() => (isTextRef.value = true));
            });
        };
        const cancelSingleEditing = () => {
            flag = false;
            props.onSingleEditingCancel?.({
                key: props.item.key,
                value: valueRef.value,
            });
            props.item.isText && nextTick(() => (isTextRef.value = true));
            setTimeout(() => {
                flag = true;
            }, 500);
        };
        // 单组件编辑提交事件
        const submitFormItem = () => {
            if (valueRef.value !== oldValueRef.value) {
                props.item.props &&
                    props.item.props.isInput &&
                    props.item.props.change &&
                    props.item.props.change(valueRef.value, 'blur');
                context.emit('submit', { [props.item.key]: valueRef.value });
            }
        };
        // 单组件编辑-确认和取消输入
        const onHandleKeyup = (event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
                // 确认输入
                event.target.blur();
                context.emit('submit');
                confirmSingleEditing(event);
            }
            else if (event.key === 'Escape') {
                // 取消输入，还原初始值
                valueRef.value = oldValueRef.value;
                event.target.blur();
                cancelSingleEditing();
            }
            event.stopPropagation();
        };
        // 计算Input组件的输入字数
        const setShowCount = (val) => {
            if (props.item.type === 'Input' &&
                props.item.maxlength &&
                props.item.props &&
                props.item.props.showCount) {
                const count = val.length + ' / ' + props.item.maxlength;
                const itemRef = internalInstance && internalInstance.refs[props.item.key];
                if (itemRef)
                    itemRef.$el.setAttribute('data-count', count);
            }
        };
        // 多选下拉组件标签的显示数量
        const maxTagCountRef = ref((props.item.props && props.item.props.minTagCount) || 5);
        const setTagCount = (count) => {
            maxTagCountRef.value = count;
        };
        // 表单验证事件
        const formValidate = (fn) => {
            if (['InputGroup', 'RangePicker'].includes(props.item.type))
                formItemRef.value && formItemRef.value[fn]();
        };
        onMounted(() => {
            if (props.isInline && formItemRef.value.$el.parentNode)
                formItemRef.value.$el.parentNode.style.display = 'flex';
            // 多列模式处理
            if (props.isCols && formItemRef.value) {
                formItemRef.value.$el.parentNode &&
                    ((formItemRef.value.$el.parentNode.style.display = 'flex'),
                        (formItemRef.value.$el.parentNode.style.flexFlow = 'row wrap'));
                if (!props.item.column || props.item.column < 2)
                    return;
                const child = formItemRef.value.$el.children;
                if (child) {
                    if (!child[1]) {
                        child[0].className = child[0].className.replace(/(ant-col-)\d+/g, '$1' + 24);
                        return;
                    }
                    const labelCol = child[0].className.replace(/[^\d]/g, '');
                    const wrapperCol = child[1].className.replace(/[^\d]/g, '');
                    child[0].className = child[0].className.replace(/(ant-col-)\d+/g, '$1' + props.item.column * labelCol);
                    child[1].className = child[1].className.replace(/(ant-col-)\d+/g, '$1' + (wrapperCol - labelCol * (props.item.column - 1)));
                }
            }
        });
        const getNullTag = () => {
            const val = toRaw(valueRef.value);
            if (val === undefined ||
                val === null ||
                ['', ','].includes(val.toString()))
                return '';
            return val;
        };
        // 文本模式tag值
        const textValTagRef = computed(() => {
            // 单选多选
            const optionTag = props.item.options &&
                (() => {
                    if (props.item.type === 'Cascader')
                        return;
                    if (Array.isArray(valueRef.value)) {
                        const op = props.item.options.filter((o) => valueRef.value.includes(o.id));
                        return op.map((o) => o.name).join('，');
                    }
                    else {
                        const op = props.item.options.find((o) => o.id === valueRef.value);
                        return op && op.name;
                    }
                })();
            // 日期 时间
            const arrayTag = getCascaderTag(valueRef.value);
            // 日期 时间
            const cityTag = getCityTag(valueRef.value);
            // TreeSelect
            const treeTag = getTreeSelectTag(valueRef.value);
            // 后缀
            const suffixTag = (valueRef.value &&
                valueRef.value +
                    ((props.item.props && props.item.props.suffix) || '')) ||
                '';
            const ret = optionTag ||
                cityTag ||
                arrayTag ||
                treeTag ||
                suffixTag ||
                getNullTag();
            return typeof props.item.valueFormatter === 'function'
                ? props.item.valueFormatter(ret)
                : ret;
        });
        const getCityTag = (val) => {
            if (props.item.type === 'Cascader' &&
                props.item.props?.isCityPicker &&
                Array.isArray(val)) {
                return val
                    .map((code) => {
                    return sharedCityData.value.find((item) => item.code === code)
                        ?.name;
                })
                    .join('-');
            }
        };
        // 日期 时间和级联,InputGroups,tag
        const getCascaderTag = (val) => {
            if (!val || !Array.isArray(val) || optionsRef.value)
                return '';
            const ex = {
                isTimePicker: ':',
                Cascader: '-',
                RangePicker: ' 至 ',
                InputGroups: '-',
            };
            const key = (props.item.type === 'Cascader' &&
                props.item.props &&
                props.item.props.isTimePicker &&
                'isTimePicker') ||
                props.item.type;
            return val.join(ex[key] || '，');
        };
        const getTreeSelectTag = (val) => {
            const options = optionsRef.value;
            if (props.item.type !== 'TreeSelect' || !options || !options.length)
                return '';
            const deep = (arr) => {
                for (let i = 0; i < arr.length; i++) {
                    const e = arr[i];
                    if (e.id === val) {
                        return e.name;
                    }
                    if (e.children && e.children.length) {
                        const tag = deep(e.children);
                        if (tag)
                            return tag;
                    }
                }
            };
            return deep(options);
        };
        const filterOption = (input, option) => {
            return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        };
        const filterOptionRef = computed(() => {
            if (props.item?.props?.search) {
                return false;
            }
            return filterOption;
        });
        const notFoundContentRef = computed(() => {
            if (props.item?.props?.search) {
                return null;
            }
            return props.item?.props?.notFoundContent;
        });
        return {
            tagRef,
            valueRef,
            classRef,
            itemClassRef,
            optionsRef,
            isTextRef,
            formItemRef,
            oldValueRef,
            maxTagCountRef,
            onHandleFocus,
            onHandleSearch,
            onHandleChange,
            onHandleEdit,
            onHandleBlur,
            confirmSingleEditing,
            cancelSingleEditing,
            onHandleKeyup,
            getNullTag,
            textValTagRef,
            filterOption,
            filterOptionRef,
            notFoundContentRef,
        };
    },
});

const _hoisted_1$1a = /*#__PURE__*/createElementVNode("div", {
  class: "iconfont edit-icon",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_2$X = ["innerHTML"];
const _hoisted_3$M = { class: "sc-form-item-width sc-text-model" };
const _hoisted_4$C = ["innerHTML"];
const _hoisted_5$u = ["innerHTML"];
const _hoisted_6$n = {
  key: 26,
  class: "single-edit-buttons"
};

function render$1o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VnodeHtmlRenderer = resolveComponent("VnodeHtmlRenderer");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_a_input_password = resolveComponent("a-input-password");
  const _component_a_input = resolveComponent("a-input");
  const _component_MultiInput = resolveComponent("MultiInput");
  const _component_a_input_number = resolveComponent("a-input-number");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_ScSelect = resolveComponent("ScSelect");
  const _component_NewMultiSelect = resolveComponent("NewMultiSelect");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_checkbox_group = resolveComponent("a-checkbox-group");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_a_radio = resolveComponent("a-radio");
  const _component_a_radio_group = resolveComponent("a-radio-group");
  const _component_a_radio_button = resolveComponent("a-radio-button");
  const _component_a_switch = resolveComponent("a-switch");
  const _component_a_textarea = resolveComponent("a-textarea");
  const _component_DatePicker = resolveComponent("DatePicker");
  const _component_ScRangePicker = resolveComponent("ScRangePicker");
  const _component_InputGroup = resolveComponent("InputGroup");
  const _component_InputGroups = resolveComponent("InputGroups");
  const _component_Cascader = resolveComponent("Cascader");
  const _component_a_tree_select = resolveComponent("a-tree-select");
  const _component_Upload = resolveComponent("Upload");
  const _component_a_tooltip = resolveComponent("a-tooltip");
  const _component_a_form_item = resolveComponent("a-form-item");

  return (!_ctx.item.isHide)
    ? (openBlock(), createBlock(_component_a_form_item, {
        key: 0,
        name: !_ctx.isTextRef && !(_ctx.item.props && _ctx.item.props.disabled) ? _ctx.item.key : '',
        rules: _ctx.item.rules,
        class: normalizeClass(_ctx.itemClassRef),
        help: _ctx.item.help,
        validateStatus: _ctx.item.validateStatus,
        validateFirst: "",
        labelCol: _ctx.item.labelCol,
        wrapperCol: _ctx.item.wrapperCol,
        ref: "formItemRef",
        labelAlign: _ctx.item.labelAlign || 'left'
      }, createSlots({
        default: withCtx(() => [
          (_ctx.item.preText)
            ? (openBlock(), createBlock(_component_VnodeHtmlRenderer, {
                key: 0,
                class: "sc-form-prev-text",
                content: _ctx.item.preText
              }, null, 8 /* PROPS */, ["content"]))
            : createCommentVNode("v-if", true),
          (_ctx.isTextRef === true && !_ctx.alwaysShowController)
            ? (openBlock(), createElementBlock("div", mergeProps({ key: 1 }, { ...(_ctx.item.props || {}) }, {
                class: ["sc-form-item-width sc-text-field", _ctx.isSingleEdit ? 'sc-single-edit' : ''],
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.onHandleEdit(_ctx.item.key)))
              }), [
                createVNode(_component_Tooltip, {
                  title: 
            _ctx.item.showTip &&
            (_ctx.tag ||
              _ctx.getNullTag() ||
              (_ctx.item.placeholder && _ctx.item.placeholder.split('|')[0])) != '-'
              ? _ctx.tag ||
                _ctx.getNullTag() ||
                (_ctx.item.placeholder && _ctx.item.placeholder.split('|')[0])
              : null
          
                }, {
                  default: withCtx(() => [
                    createElementVNode("span", null, toDisplayString(_ctx.tag || _ctx.textValTagRef), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["title"]),
                _hoisted_1$1a
              ], 16 /* FULL_PROPS */))
            : (_ctx.item.type === 'Input')
              ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                  (_ctx.item.htmlType === 'password')
                    ? (openBlock(), createBlock(_component_a_input_password, mergeProps({
                        key: 0,
                        allowClear: ""
                      }, { ..._ctx.item.props }, {
                        class: ["sc-form-item-width sc-input-show-count", _ctx.classRef],
                        value: _ctx.valueRef,
                        "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.valueRef) = $event)),
                        placeholder: _ctx.item.placeholder,
                        maxlength: _ctx.item.maxlength || 200,
                        onFocus: _cache[2] || (_cache[2] = $event => (_ctx.onHandleFocus($event, null))),
                        onBlur: _ctx.onHandleBlur,
                        onKeyup: _cache[3] || (_cache[3] = $event => (_ctx.onHandleKeyup($event))),
                        ref: _ctx.item.key,
                        style: { width: _ctx.item.width },
                        autocomplete: "off",
                        disabled: _ctx.item.disabled,
                        readonly: _ctx.item.readonly
                      }), null, 16 /* FULL_PROPS */, ["class", "value", "placeholder", "maxlength", "onBlur", "style", "disabled", "readonly"]))
                    : (openBlock(), createBlock(_component_a_input, mergeProps({
                        key: 1,
                        allowClear: ""
                      }, { ..._ctx.item.props }, {
                        class: ["sc-form-item-width sc-input-show-count", _ctx.classRef],
                        value: _ctx.valueRef,
                        "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.valueRef) = $event)),
                        placeholder: _ctx.item.placeholder,
                        maxlength: _ctx.item.maxlength || 200,
                        onFocus: _cache[5] || (_cache[5] = $event => (_ctx.onHandleFocus($event, null))),
                        onBlur: _ctx.onHandleBlur,
                        onKeydown: _cache[6] || (_cache[6] = withModifiers(() => {}, ["stop"])),
                        onKeyup: _cache[7] || (_cache[7] = $event => (_ctx.onHandleKeyup($event))),
                        ref: _ctx.item.key,
                        style: { width: _ctx.item.width },
                        autocomplete: "off",
                        disabled: _ctx.item.disabled,
                        readonly: _ctx.item.readonly
                      }), null, 16 /* FULL_PROPS */, ["class", "value", "placeholder", "maxlength", "onBlur", "style", "disabled", "readonly"]))
                ], 64 /* STABLE_FRAGMENT */))
              : (_ctx.item.type === 'MultiInput')
                ? (openBlock(), createBlock(_component_MultiInput, {
                    key: 3,
                    label: _ctx.item.label,
                    width: "100%",
                    inputProps: _ctx.item.props,
                    class: normalizeClass(["multiple-no-btach sc-form-item-width", _ctx.classRef]),
                    placeholder: _ctx.item.placeholder,
                    value: _ctx.valueRef,
                    "onUpdate:value": _cache[8] || (_cache[8] = $event => ((_ctx.valueRef) = $event)),
                    onFocus: _cache[9] || (_cache[9] = $event => (_ctx.onHandleFocus($event, _ctx.item.props && _ctx.item.props.focus))),
                    onChange: _cache[10] || (_cache[10] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                    onOnOk: _cache[11] || (_cache[11] = $event => (_ctx.item.props && _ctx.item.props.onOnOk && _ctx.item.props.onOnOk())),
                    onBlur: _ctx.onHandleBlur,
                    ref: _ctx.item.key,
                    style: normalizeStyle({ width: _ctx.item.width })
                  }, null, 8 /* PROPS */, ["label", "inputProps", "class", "placeholder", "value", "onBlur", "style"]))
                : (_ctx.item.type === 'InputNumber')
                  ? (openBlock(), createBlock(_component_a_input_number, mergeProps({
                      key: 4,
                      allowClear: ""
                    }, { ..._ctx.item.props }, {
                      class: ["sc-form-item-width", _ctx.classRef],
                      value: _ctx.valueRef,
                      "onUpdate:value": _cache[12] || (_cache[12] = $event => ((_ctx.valueRef) = $event)),
                      placeholder: _ctx.item.placeholder,
                      onFocus: _cache[13] || (_cache[13] = $event => (_ctx.onHandleFocus($event, null))),
                      onBlur: _ctx.onHandleBlur,
                      onKeyup: _cache[14] || (_cache[14] = $event => (_ctx.onHandleKeyup($event))),
                      ref: _ctx.item.key,
                      style: { width: _ctx.item.width },
                      autocomplete: "off",
                      disabled: _ctx.item.disabled,
                      readonly: _ctx.item.readonly
                    }), null, 16 /* FULL_PROPS */, ["class", "value", "placeholder", "onBlur", "style", "disabled", "readonly"]))
                  : (_ctx.item.type === 'Select')
                    ? (openBlock(), createBlock(_component_a_select, mergeProps({
                        key: 5,
                        showSearch: "",
                        filterOption: _ctx.filterOptionRef,
                        allowClear: "",
                        optionFilterProp: "title"
                      }, { ..._ctx.item.props }, {
                        class: ["sc-select sc-form-item-width", _ctx.classRef],
                        notFoundContent: _ctx.notFoundContentRef,
                        value: _ctx.valueRef,
                        "onUpdate:value": _cache[15] || (_cache[15] = $event => ((_ctx.valueRef) = $event)),
                        placeholder: _ctx.item.placeholder,
                        getPopupContainer: (triggerNode) => triggerNode.parentNode,
                        onChange: _cache[16] || (_cache[16] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                        onSearch: _cache[17] || (_cache[17] = $event => (_ctx.onHandleSearch($event, _ctx.item.props && _ctx.item.props.search))),
                        onFocus: _cache[18] || (_cache[18] = $event => (_ctx.onHandleFocus($event, _ctx.item.props && _ctx.item.props.focus))),
                        onBlur: _ctx.onHandleBlur,
                        onKeydown: _cache[19] || (_cache[19] = withModifiers(() => {}, ["stop"])),
                        onKeyup: _cache[20] || (_cache[20] = $event => (_ctx.onHandleKeyup($event))),
                        ref: _ctx.item.key,
                        style: { width: _ctx.item.width }
                      }), {
                        default: withCtx(() => [
                          (_ctx.optionsRef)
                            ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.optionsRef, (o) => {
                                return (openBlock(), createBlock(_component_a_select_option, mergeProps({ ...o }, {
                                  value: o.id,
                                  key: o.id,
                                  title: o.name,
                                  disabled: o.disabled
                                }), {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "title", "disabled"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            : createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 16 /* FULL_PROPS */, ["filterOption", "notFoundContent", "class", "value", "placeholder", "getPopupContainer", "onBlur", "style"]))
                    : (_ctx.item.type === 'ScSelect')
                      ? (openBlock(), createBlock(_component_ScSelect, mergeProps({
                          key: 6,
                          showSearch: "",
                          filterOption: false,
                          allowClear: "",
                          optionFilterProp: "title"
                        }, { ..._ctx.item.props }, {
                          class: ["sc-select sc-form-item-width", _ctx.classRef],
                          value: _ctx.valueRef,
                          "onUpdate:value": _cache[21] || (_cache[21] = $event => ((_ctx.valueRef) = $event)),
                          placeholder: _ctx.item.placeholder,
                          getPopupContainer: (triggerNode) => triggerNode.parentNode,
                          search: (val) => _ctx.onHandleSearch(val, _ctx.item.props && _ctx.item.props.search),
                          focus: (event) => _ctx.onHandleFocus(event, _ctx.item.props && _ctx.item.props.focus),
                          onChange: _cache[22] || (_cache[22] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                          onBlur: _ctx.onHandleBlur,
                          onKeydown: _cache[23] || (_cache[23] = withModifiers(() => {}, ["stop"])),
                          onKeyup: _cache[24] || (_cache[24] = $event => (_ctx.onHandleKeyup($event))),
                          ref: _ctx.item.key,
                          style: { width: _ctx.item.width }
                        }), {
                          default: withCtx(() => [
                            (_ctx.optionsRef)
                              ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.optionsRef, (o) => {
                                  return (openBlock(), createBlock(_component_a_select_option, mergeProps({ ...o }, {
                                    value: o.id,
                                    key: o.id,
                                    title: o.name,
                                    disabled: o.disabled
                                  }), {
                                    default: withCtx(() => [
                                      createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "title", "disabled"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              : createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        }, 16 /* FULL_PROPS */, ["class", "value", "placeholder", "getPopupContainer", "search", "focus", "onBlur", "style"]))
                      : (_ctx.item.type === 'SelectMultiple')
                        ? (openBlock(), createBlock(_component_a_select, mergeProps({
                            key: 7,
                            allowClear: "",
                            filterOption: _ctx.filterOptionRef,
                            optionFilterProp: "title"
                          }, { ..._ctx.item.props }, {
                            maxTagCount: _ctx.maxTagCountRef,
                            maxTagTextLength: 6,
                            class: ["sc-select sc-form-item-width", _ctx.classRef],
                            notFoundContent: _ctx.notFoundContentRef,
                            placeholder: _ctx.item.placeholder,
                            mode: "multiple",
                            value: _ctx.valueRef,
                            "onUpdate:value": _cache[25] || (_cache[25] = $event => ((_ctx.valueRef) = $event)),
                            getPopupContainer: (triggerNode) => triggerNode.parentNode,
                            onFocus: _cache[26] || (_cache[26] = $event => (_ctx.onHandleFocus($event, _ctx.item.props && _ctx.item.props.focus))),
                            onChange: _cache[27] || (_cache[27] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                            onSearch: _cache[28] || (_cache[28] = $event => (_ctx.onHandleSearch($event, _ctx.item.props && _ctx.item.props.search))),
                            onBlur: _ctx.onHandleBlur,
                            ref: _ctx.item.key,
                            style: { width: _ctx.item.width }
                          }), {
                            default: withCtx(() => [
                              (_ctx.optionsRef)
                                ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.optionsRef, (o) => {
                                    return (openBlock(), createBlock(_component_a_select_option, mergeProps({ ...o }, {
                                      value: o.id,
                                      key: o.id,
                                      title: o.name,
                                      disabled: o.disabled
                                    }), {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "title", "disabled"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                : createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          }, 16 /* FULL_PROPS */, ["filterOption", "maxTagCount", "notFoundContent", "class", "placeholder", "value", "getPopupContainer", "onBlur", "style"]))
                        : (_ctx.item.type === 'MultipleSelect')
                          ? (openBlock(), createBlock(_component_NewMultiSelect, {
                              key: 8,
                              isSelectAll: "",
                              isClear: "",
                              label: _ctx.item.label,
                              width: "100%",
                              selectProps: _ctx.item.props,
                              keywords: _ctx.item.key,
                              maxTagCount: _ctx.maxTagCountRef,
                              class: normalizeClass(["multiple-no-btach sc-form-item-width", _ctx.classRef]),
                              placeholder: _ctx.item.placeholder,
                              value: _ctx.valueRef,
                              "onUpdate:value": _cache[29] || (_cache[29] = $event => ((_ctx.valueRef) = $event)),
                              optionData: _ctx.optionsRef,
                              onFocus: _cache[30] || (_cache[30] = $event => (_ctx.onHandleFocus($event, _ctx.item.props && _ctx.item.props.focus))),
                              onChange: _cache[31] || (_cache[31] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                              onSearch: _cache[32] || (_cache[32] = $event => (_ctx.onHandleSearch($event, _ctx.item.props && _ctx.item.props.search))),
                              onOnOk: _cache[33] || (_cache[33] = $event => (_ctx.item.props && _ctx.item.props.onOnOk && _ctx.item.props.onOnOk())),
                              onBlur: _ctx.onHandleBlur,
                              ref: _ctx.item.key,
                              style: normalizeStyle({ width: _ctx.item.width })
                            }, null, 8 /* PROPS */, ["label", "selectProps", "keywords", "maxTagCount", "class", "placeholder", "value", "optionData", "onBlur", "style"]))
                          : (_ctx.item.type === 'CheckboxGroup')
                            ? (openBlock(), createBlock(_component_a_checkbox_group, mergeProps({ key: 9 }, { ..._ctx.item.props }, {
                                value: _ctx.valueRef,
                                "onUpdate:value": _cache[34] || (_cache[34] = $event => ((_ctx.valueRef) = $event)),
                                style: { width: _ctx.item.width }
                              }), {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.optionsRef, (o) => {
                                    return (openBlock(), createBlock(_component_a_checkbox, mergeProps({ ...o }, {
                                      value: o.id,
                                      key: o.id,
                                      disabled: o.disabled
                                    }), {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                              }, 16 /* FULL_PROPS */, ["value", "style"]))
                            : (_ctx.item.type === 'Checkbox')
                              ? (openBlock(), createBlock(_component_Checkbox, mergeProps({ key: 10 }, { ..._ctx.item.props }, {
                                  value: _ctx.valueRef,
                                  "onUpdate:value": _cache[35] || (_cache[35] = $event => ((_ctx.valueRef) = $event)),
                                  style: { width: _ctx.item.width },
                                  options: _ctx.optionsRef,
                                  onChange: _cache[36] || (_cache[36] = (val) => _ctx.onHandleChange(val, _ctx.item.props && _ctx.item.props.change))
                                }), null, 16 /* FULL_PROPS */, ["value", "style", "options"]))
                              : (_ctx.item.type === 'RadioGroup')
                                ? (openBlock(), createBlock(_component_a_radio_group, mergeProps({ key: 11 }, { ..._ctx.item.props }, {
                                    value: _ctx.valueRef,
                                    "onUpdate:value": _cache[37] || (_cache[37] = $event => ((_ctx.valueRef) = $event)),
                                    onChange: _cache[38] || (_cache[38] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                                    style: { width: _ctx.item.width }
                                  }), {
                                    default: withCtx(() => [
                                      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.optionsRef, (o) => {
                                        return (openBlock(), createBlock(_component_a_radio, mergeProps({ ...o }, {
                                          value: o.id,
                                          key: o.id,
                                          disabled: o.disabled
                                        }), {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 16 /* FULL_PROPS */, ["value", "style"]))
                                : (_ctx.item.type === 'RadioButtonGroup')
                                  ? (openBlock(), createBlock(_component_a_radio_group, mergeProps({ key: 12 }, { ..._ctx.item.props }, {
                                      value: _ctx.valueRef,
                                      "onUpdate:value": _cache[39] || (_cache[39] = $event => ((_ctx.valueRef) = $event)),
                                      class: "sc-radio-button"
                                    }), {
                                      default: withCtx(() => [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.optionsRef, (o) => {
                                          return (openBlock(), createBlock(_component_a_radio_button, mergeProps({ ...o }, {
                                            value: o.id,
                                            key: o.id,
                                            disabled: o.disabled
                                          }), {
                                            default: withCtx(() => [
                                              createTextVNode(toDisplayString(o.name), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 16 /* FULL_PROPS */, ["value"]))
                                  : (_ctx.item.type === 'Switch')
                                    ? (openBlock(), createElementBlock(Fragment, { key: 13 }, [
                                        createVNode(_component_a_switch, mergeProps({ ..._ctx.item.props }, {
                                          checked: _ctx.valueRef,
                                          "onUpdate:checked": _cache[40] || (_cache[40] = $event => ((_ctx.valueRef) = $event))
                                        }), null, 16 /* FULL_PROPS */, ["checked"]),
                                        (_ctx.item.props && _ctx.item.props.desc)
                                          ? (openBlock(), createElementBlock("span", {
                                              key: 0,
                                              class: "sc-from-switch-desc",
                                              innerHTML: _ctx.item.props.desc
                                            }, null, 8 /* PROPS */, _hoisted_2$X))
                                          : createCommentVNode("v-if", true)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_ctx.item.type === 'TextArea')
                                      ? (openBlock(), createBlock(_component_a_textarea, mergeProps({
                                          key: 14,
                                          showCount: "",
                                          maxlength: _ctx.item.maxlength || 500,
                                          placeholder: _ctx.item.placeholder
                                        }, { ..._ctx.item.props }, {
                                          class: ["sc-form-item-width", _ctx.classRef],
                                          value: _ctx.valueRef,
                                          "onUpdate:value": _cache[41] || (_cache[41] = $event => ((_ctx.valueRef) = $event)),
                                          onBlur: _ctx.onHandleBlur,
                                          onKeydown: _cache[42] || (_cache[42] = withModifiers(() => {}, ["stop"])),
                                          onKeyup: _ctx.onHandleKeyup,
                                          ref: _ctx.item.key,
                                          style: { width: _ctx.item.width }
                                        }), null, 16 /* FULL_PROPS */, ["maxlength", "placeholder", "class", "value", "onBlur", "onKeyup", "style"]))
                                      : (_ctx.item.type === 'DatePicker')
                                        ? (openBlock(), createBlock(_component_DatePicker, mergeProps({ key: 15 }, { ..._ctx.item.props }, {
                                            class: ["sc-form-item-width", _ctx.classRef],
                                            value: _ctx.valueRef,
                                            "onUpdate:value": _cache[43] || (_cache[43] = $event => ((_ctx.valueRef) = $event)),
                                            getPopupContainer: (triggerNode) => triggerNode.parentNode,
                                            placeholder: _ctx.item.placeholder,
                                            onChange: _ctx.onHandleBlur,
                                            ref: _ctx.item.key,
                                            style: { width: _ctx.item.width }
                                          }), null, 16 /* FULL_PROPS */, ["class", "value", "getPopupContainer", "placeholder", "onChange", "style"]))
                                        : (_ctx.item.type === 'RangePicker')
                                          ? (openBlock(), createBlock(_component_ScRangePicker, mergeProps({ key: 16 }, { ..._ctx.item.props }, {
                                              tag: _ctx.tagRef,
                                              "onUpdate:tag": _cache[44] || (_cache[44] = $event => ((_ctx.tagRef) = $event)),
                                              value: _ctx.valueRef,
                                              "onUpdate:value": _cache[45] || (_cache[45] = $event => ((_ctx.valueRef) = $event)),
                                              class: _ctx.classRef,
                                              onChange: _ctx.onHandleChange,
                                              ref: _ctx.item.key,
                                              style: { width: _ctx.item.width }
                                            }), null, 16 /* FULL_PROPS */, ["tag", "value", "class", "onChange", "style"]))
                                          : (_ctx.item.type === 'InputGroup')
                                            ? (openBlock(), createBlock(_component_InputGroup, mergeProps({
                                                key: 17,
                                                label: _ctx.item.label
                                              }, { ..._ctx.item.props }, {
                                                class: _ctx.classRef,
                                                value: _ctx.valueRef,
                                                "onUpdate:value": _cache[46] || (_cache[46] = $event => ((_ctx.valueRef) = $event)),
                                                tag: _ctx.tagRef,
                                                "onUpdate:tag": _cache[47] || (_cache[47] = $event => ((_ctx.tagRef) = $event)),
                                                placeholder: _ctx.item.placeholder,
                                                ref: _ctx.item.key,
                                                style: { width: _ctx.item.width },
                                                onBlur: _ctx.onHandleBlur,
                                                onChange: _ctx.onHandleChange
                                              }), null, 16 /* FULL_PROPS */, ["label", "class", "value", "tag", "placeholder", "style", "onBlur", "onChange"]))
                                            : (_ctx.item.type === 'InputGroups')
                                              ? (openBlock(), createBlock(_component_InputGroups, mergeProps({
                                                  key: 18,
                                                  label: _ctx.item.label
                                                }, { ..._ctx.item.props }, {
                                                  class: _ctx.classRef,
                                                  value: _ctx.valueRef,
                                                  "onUpdate:value": _cache[48] || (_cache[48] = $event => ((_ctx.valueRef) = $event)),
                                                  tag: _ctx.tagRef,
                                                  "onUpdate:tag": _cache[49] || (_cache[49] = $event => ((_ctx.tagRef) = $event)),
                                                  placeholder: _ctx.item.placeholder,
                                                  ref: _ctx.item.key,
                                                  groupNum: _ctx.item.groupNum,
                                                  style: { width: _ctx.item.width },
                                                  onBlur: _cache[50] || (_cache[50] = $event => (_ctx.onHandleBlur($event, _ctx.item.props && _ctx.item.props.blur))),
                                                  onChange: _cache[51] || (_cache[51] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change)))
                                                }), null, 16 /* FULL_PROPS */, ["label", "class", "value", "tag", "placeholder", "groupNum", "style"]))
                                              : (_ctx.item.type === 'Cascader')
                                                ? (openBlock(), createBlock(_component_Cascader, mergeProps({
                                                    key: 19,
                                                    label: _ctx.item.label
                                                  }, { ..._ctx.item.props }, {
                                                    class: _ctx.classRef,
                                                    value: _ctx.valueRef,
                                                    "onUpdate:value": _cache[52] || (_cache[52] = $event => ((_ctx.valueRef) = $event)),
                                                    tag: _ctx.tagRef,
                                                    "onUpdate:tag": _cache[53] || (_cache[53] = $event => ((_ctx.tagRef) = $event)),
                                                    options: _ctx.optionsRef,
                                                    placeholder: _ctx.item.placeholder,
                                                    ref: _ctx.item.key,
                                                    style: { width: _ctx.item.width },
                                                    autofocus: "",
                                                    onBlur: _cache[54] || (_cache[54] = $event => (_ctx.onHandleBlur($event, _ctx.item.props && _ctx.item.props.blur)))
                                                  }), null, 16 /* FULL_PROPS */, ["label", "class", "value", "tag", "options", "placeholder", "style"]))
                                                : (_ctx.item.type === 'TreeSelect')
                                                  ? (openBlock(), createElementBlock(Fragment, { key: 20 }, [
                                                      createCommentVNode(" :dropdown-style=\"{ maxHeight: '400px', overflow: 'auto' }\" "),
                                                      createVNode(_component_a_tree_select, mergeProps({
                                                        allowClear: "",
                                                        showSearch: "",
                                                        treeDefaultExpandAll: "",
                                                        treeNodeFilterProp: "name"
                                                      }, { ..._ctx.item.props }, {
                                                        dropdownMatchSelectWidth: "",
                                                        listHeight: 400,
                                                        class: _ctx.classRef,
                                                        value: _ctx.valueRef,
                                                        "onUpdate:value": _cache[55] || (_cache[55] = $event => ((_ctx.valueRef) = $event)),
                                                        "tree-data": _ctx.optionsRef,
                                                        fieldNames: { value: 'id', label: 'name' },
                                                        placeholder: _ctx.item.placeholder,
                                                        ref: _ctx.item.key,
                                                        style: { width: _ctx.item.width },
                                                        onChange: _cache[56] || (_cache[56] = $event => (_ctx.onHandleChange($event, _ctx.item.props && _ctx.item.props.change))),
                                                        onSearch: _cache[57] || (_cache[57] = $event => (_ctx.onHandleSearch($event, _ctx.item.props && _ctx.item.props.search)))
                                                      }), null, 16 /* FULL_PROPS */, ["class", "value", "tree-data", "placeholder", "style"])
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : (_ctx.item.type === 'Text')
                                                    ? (openBlock(), createBlock(_component_Tooltip, {
                                                        key: 21,
                                                        title: 
          _ctx.item.showTip &&
          (_ctx.tag ||
            _ctx.valueRef ||
            (_ctx.item.placeholder && _ctx.item.placeholder.split('|')[0])) != '-'
            ? _ctx.tag ||
              _ctx.valueRef ||
              (_ctx.item.placeholder && _ctx.item.placeholder.split('|')[0])
            : null
        
                                                      }, {
                                                        default: withCtx(() => [
                                                          createElementVNode("div", _hoisted_3$M, toDisplayString(_ctx.tag ||
              (_ctx.valueRef &&
                _ctx.valueRef + ((_ctx.item.props && _ctx.item.props.suffix) || '')) ||
              (_ctx.item.placeholder && _ctx.item.placeholder.split('|')[0]) ||
              '-'), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      }, 8 /* PROPS */, ["title"]))
                                                    : (_ctx.item.type === 'Upload')
                                                      ? (openBlock(), createBlock(_component_Upload, mergeProps({
                                                          key: 22,
                                                          placeholder: _ctx.item.placeholder
                                                        }, { ..._ctx.item.props }, {
                                                          value: _ctx.valueRef,
                                                          "onUpdate:value": _cache[58] || (_cache[58] = $event => ((_ctx.valueRef) = $event)),
                                                          tag: _ctx.tagRef,
                                                          "onUpdate:tag": _cache[59] || (_cache[59] = $event => ((_ctx.tagRef) = $event))
                                                        }), null, 16 /* FULL_PROPS */, ["placeholder", "value", "tag"]))
                                                      : (_ctx.item.type === 'Slot')
                                                        ? renderSlot(_ctx.$slots, _ctx.item.key, { key: 23 })
                                                        : createCommentVNode("v-if", true),
          (_ctx.item.sufText)
            ? (openBlock(), createBlock(_component_VnodeHtmlRenderer, {
                key: 24,
                class: "sc-form-suff-text",
                content: _ctx.item.sufText
              }, null, 8 /* PROPS */, ["content"]))
            : createCommentVNode("v-if", true),
          (_ctx.item.desc)
            ? (openBlock(), createBlock(_component_VnodeHtmlRenderer, {
                key: 25,
                class: "sc-form-desc",
                content: _ctx.item.desc
              }, null, 8 /* PROPS */, ["content"]))
            : createCommentVNode("v-if", true),
          (_ctx.isSingleEdit && !_ctx.alwaysShowController && !_ctx.isTextRef)
            ? (openBlock(), createElementBlock("div", _hoisted_6$n, [
                createElementVNode("div", {
                  class: "iconfont single-edit-button",
                  innerHTML: '',
                  onMousedown: _cache[60] || (_cache[60] = (...args) => (_ctx.confirmSingleEditing && _ctx.confirmSingleEditing(...args)))
                }, null, 32 /* HYDRATE_EVENTS */),
                createElementVNode("div", {
                  class: "iconfont single-edit-button",
                  innerHTML: '',
                  onMousedown: _cache[61] || (_cache[61] = (...args) => (_ctx.cancelSingleEditing && _ctx.cancelSingleEditing(...args)))
                }, null, 32 /* HYDRATE_EVENTS */)
              ]))
            : createCommentVNode("v-if", true)
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (_ctx.item.extra)
          ? {
              name: "extra",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, _ctx.item.extra)
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.item.label)
          ? {
              name: "label",
              fn: withCtx(() => [
                createElementVNode("span", null, toDisplayString(_ctx.item.label), 1 /* TEXT */),
                (_ctx.item.labelTipsProps)
                  ? (openBlock(), createBlock(_component_a_tooltip, mergeProps({
                      key: 0,
                      overlayClassName: "sc-tooltip-light"
                    }, { ..._ctx.item.labelTipsProps, title: undefined }), {
                      title: withCtx(() => [
                        createElementVNode("div", {
                          innerHTML: _ctx.item.labelTipsProps.title
                        }, null, 8 /* PROPS */, _hoisted_4$C)
                      ]),
                      default: withCtx(() => [
                        createElementVNode("i", {
                          style: {"margin-left":"4px","margin-right":"2px"},
                          class: normalizeClass('iconfont label-tip ' + (_ctx.item.labelTipsProps.align || '')),
                          innerHTML: _ctx.item.labelTipsProps.icon || ''
                        }, null, 10 /* CLASS, PROPS */, _hoisted_5$u)
                      ]),
                      _: 1 /* STABLE */
                    }, 16 /* FULL_PROPS */))
                  : createCommentVNode("v-if", true)
              ]),
              key: "1"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["name", "rules", "class", "help", "validateStatus", "labelCol", "wrapperCol", "labelAlign"]))
    : createCommentVNode("v-if", true)
}

script$1v.render = render$1o;
script$1v.__file = "packages/form/BasicFormItem.vue";

const VALIDATOR = {
    pattern: {
        integer: /^([1-9]\d*|0)$/,
        float: /^(-?\d+)(\.\d{0,4})?$/,
        number: /^-?\d+(\.\d+)?$/,
        char: /^\w+$/,
        chinese: /^[\u4e00-\u9fa5]+$/,
        email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+$/,
        mobile: /^1(3|4|5|6|7|8|9)[\d]{9}$/,
        telphone: /^((0\d{2,3}-\d{7,8})|(1\d{10}))(-\d+)?$/,
        phone: /^((0\d{2,3}-\d{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/,
        money: /^-?([1-9]\d*|0)(\.\d{1,2})?$/,
        chineseOrNumberOrEnglish: /^[\u4E00-\u9FA5A-Za-z0-9]+$/,
        rate: /^[0-9]+(.[0-9]{1,2})?$/,
        englishUppercase: /^[A-Z]+$/,
        postcode: /^[0-9]\d{5}(?!\d)$/,
        url: /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i, // URL网址
    },
    validate: {
        ranger: async (rule, value) => {
            if (value < (rule.min || 0) || value > rule.max) {
                return Promise.reject(rule.message || `请输入${rule.min} ~ ${rule.max}的数字`);
            }
            else {
                return Promise.resolve();
            }
        },
        inputGroup: async (rule, value) => {
            const index = value.findIndex((v) => !/(^[1-9]\d*$)/.test(v));
            if (index != -1) {
                if (rule.messages && Array.isArray(rule.messages)) {
                    return Promise.reject(rule.messages[index] || `请输入正整数`);
                }
                else {
                    return Promise.reject(rule.message || `请输入正整数`);
                }
            }
            else {
                return Promise.resolve();
            }
        },
        common: async (rule, value) => {
            if (!Array.isArray(value))
                value = [value];
            for (let i = 0; i < value.length; i++) {
                const val = value[i];
                // 必填判断
                if (rule.required && !val) {
                    return Promise.reject(rule.message);
                }
                // 正则判断
                if (rule.pattern && !rule.pattern.test(val)) {
                    return Promise.reject(rule.message);
                }
                // 数字范围判断
                if (rule.min || rule.max) {
                    if (val < (rule.min || 0) || val > rule.max) {
                        return Promise.reject(rule.message || `请输入${rule.min} ~ ${rule.max}的数字`);
                    }
                }
            }
            return Promise.resolve();
        },
    },
    message: {
        integer: '请输入整数',
        float: '请输入4位小数数字',
        number: '请输入数字',
        char: '请输入字母数字或下划线',
        chinese: '请输入中文',
        email: '邮箱格式不正确',
        mobile: '请输入11位手机号码',
        telphone: '请输入0xx(x)-xxxxxxxx格式的固定电话',
        phone: '请输入0xxx-xxxxxxx格式的座机或11位手机号',
        money: '请输入2位小数数字',
        chineseOrNumberOrEnglish: '请输入中英文或数字',
        rate: '请输入正数, 小数点后两位',
        englishUppercase: '请数入英文大写',
        postcode: '请输入正确的邮政编码',
        url: '请输入正确的url地址',
    },
};

script$1v.install = (Vue) => {
    Vue.component(script$1x.name, script$1x);
    Vue.component(script$1v.name, script$1v);
    Vue.component('BasicForm', script$1M);
};

var script$1u = defineComponent({
    name: 'ScModalForm',
    components: {
        BasicFormItem: script$1v,
        Modal: script$1N,
    },
    props: {
        visible: {
            type: [Boolean],
            default: false,
        },
        formItems: {
            type: Array,
            default: () => [],
        },
        formState: {
            type: Object,
            default: () => ({ keywords: {}, tags: {} }),
        },
        type: {
            type: String,
            default: 'muted',
        },
        alertProps: {
            type: Object,
            default: () => ({}),
        },
        message: {
            type: [String, Array],
            default: '',
        },
        content: {
            type: [String, Array],
            default: '',
        },
        getOptions: {
            type: Function,
            default: () => [],
        },
        /**
         * 参数：key: string,当前表单项的key; value: string[] 文本域的值
         * 返回：下拉多选值数组 (number| string)[]
         */
        getTextAreaValue: {
            type: Function,
            default: () => [],
        },
        // 组件内关闭弹窗
        close: {
            type: Function,
            default: (e) => (e.value = false),
        },
        // 未表单验证的提交方法，
        onSubmitValidate: {
            type: Function,
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 表单ref
        const formRef = ref();
        // 表单数据
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => emit('update:formState', val),
        });
        const confirmLoading = ref(false);
        watch(() => visibleRef.value, () => (confirmLoading.value = false), { immediate: true });
        // 提交
        const handleOk = async () => {
            if (props.onSubmitValidate) {
                const cb = (v) => ((confirmLoading.value = false), v && props.close(visibleRef));
                confirmLoading.value = true;
                setTimeout(() => (confirmLoading.value = false), 1000);
                const rs = await props.onSubmitValidate(toRaw(formStateRef.value), formRef.value.validate);
                rs !== false && cb(true);
            }
            else {
                formRef.value
                    .validate()
                    .then(async () => {
                    const cb = (v) => ((confirmLoading.value = false), v && props.close(visibleRef));
                    confirmLoading.value = true;
                    emit('submit', toRaw(formStateRef.value), cb);
                    setTimeout(() => (confirmLoading.value = false), 1000);
                })
                    .catch((error) => {
                    console.log('error', error);
                });
            }
        };
        // 点击事件，仅在目标为A时触发
        const handleClick = (event, item) => {
            if (item.onClick &&
                event &&
                event.target &&
                event.target.nodeName === 'A') {
                item.onClick(event);
            }
        };
        //级联缓存
        const cacheKeywords = {};
        const isChanged = (key, oKeywords) => {
            let rlt = !_.isEqual(cacheKeywords[key], oKeywords);
            if (rlt)
                cacheKeywords[key] = { ..._.cloneDeep(oKeywords) };
            return rlt;
        };
        // 级联事件，获取新的options
        provide('getOptions', (key, cascader, value) => {
            if (typeof cascader === 'string')
                cascader = [cascader];
            // 级联选项的前置keywords条件
            const oKeywords = {};
            cascader.map((k) => (oKeywords[k] = formStateRef.value.keywords[k]));
            // cascader中包含当前组件key的处理,
            if (cascader.indexOf(key) >= 0)
                delete oKeywords[key];
            // search事件,当前组件的value值
            if (value)
                oKeywords[key] = value;
            return isChanged(key, oKeywords) && props.getOptions(key, oKeywords);
        });
        // 依据级联属性cascader（父数组）生成级联子数组childrenCascader
        const childrenCascader = {};
        const createChildrenCascader = () => {
            const cascaderItems = props.formItems.filter((item) => item.cascader);
            cascaderItems.map((item) => {
                const cascader = Array.isArray(item.cascader)
                    ? item.cascader
                    : [item.cascader];
                cascader.map((casKey) => casKey &&
                    casKey !== item.key &&
                    (childrenCascader[casKey] || (childrenCascader[casKey] = [])) &&
                    childrenCascader[casKey].push(item.key));
            });
        };
        createChildrenCascader();
        // 级联事件，清除已选值
        provide('childrenCascader', childrenCascader);
        provide('clearSelected', (key, childrenCascaderKeys) => {
            childrenCascaderKeys.map((k) => {
                delete formStateRef.value.keywords[k];
                delete formStateRef.value.tags[k];
            });
        });
        // 获取下拉多选组件，过滤后文本域值
        provide('getTextAreaValue', (key, value) => {
            return props.getTextAreaValue(key, value);
        });
        return {
            zhCN,
            visibleRef,
            formRef,
            formStateRef,
            toRaw,
            handleOk,
            handleClick,
            confirmLoading,
        };
    },
});

const _hoisted_1$19 = ["innerHTML"];
const _hoisted_2$W = ["innerHTML", "onClick"];
const _hoisted_3$L = {
  key: 1,
  class: "form-tips-wrap"
};
const _hoisted_4$B = ["innerHTML"];
const _hoisted_5$t = ["innerHTML", "onClick"];

function render$1n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_alert = resolveComponent("a-alert");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_a_config_provider = resolveComponent("a-config-provider");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, mergeProps({
    class: "sc-modal-form",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
    width: "740px",
    okText: "添加",
    cancelText: "取消",
    confirmLoading: _ctx.confirmLoading
  }, { ..._ctx.$attrs }, { onOk: _ctx.handleOk }), {
    default: withCtx(() => [
      createVNode(_component_a_config_provider, { locale: _ctx.zhCN }, {
        default: withCtx(() => [
          (_ctx.message)
            ? (openBlock(), createBlock(_component_a_alert, mergeProps({
                key: 0,
                "show-icon": false,
                type: _ctx.type,
                banner: "",
                style: {"margin-top":"-15px","margin-bottom":"5px"}
              }, { ..._ctx.$props.alertProps }), {
                message: withCtx(() => [
                  renderSlot(_ctx.$slots, "default", {}, () => [
                    (typeof _ctx.message === 'string')
                      ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          innerHTML: _ctx.message
                        }, null, 8 /* PROPS */, _hoisted_1$19))
                      : (Array.isArray(_ctx.message))
                        ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.message, (item, index) => {
                            return (openBlock(), createElementBlock("div", {
                              key: index,
                              innerHTML: index + 1 + '、' + (item.text || item),
                              onClick: $event => (_ctx.handleClick($event, item))
                            }, null, 8 /* PROPS */, _hoisted_2$W))
                          }), 128 /* KEYED_FRAGMENT */))
                        : createCommentVNode("v-if", true)
                  ])
                ]),
                _: 3 /* FORWARDED */
              }, 16 /* FULL_PROPS */, ["type"]))
            : createCommentVNode("v-if", true),
          createVNode(_component_a_form, {
            class: "sc-create-model-form",
            labelCol: { span: 6 },
            "wrapper-col": { span: 16 },
            colon: false,
            ref: "formRef",
            model: _ctx.formStateRef.keywords
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItems, (item) => {
                return (openBlock(), createBlock(_component_BasicFormItem, {
                  key: item.key,
                  item: item,
                  value: _ctx.formStateRef.keywords[item.key],
                  "onUpdate:value": $event => ((_ctx.formStateRef.keywords[item.key]) = $event),
                  tag: _ctx.formStateRef.tags[item.key],
                  "onUpdate:tag": $event => ((_ctx.formStateRef.tags[item.key]) = $event)
                }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value", "tag", "onUpdate:tag"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model"]),
          (_ctx.content)
            ? (openBlock(), createElementBlock("div", _hoisted_3$L, [
                (typeof _ctx.content === 'string')
                  ? (openBlock(), createElementBlock("p", {
                      key: 0,
                      innerHTML: _ctx.content
                    }, null, 8 /* PROPS */, _hoisted_4$B))
                  : (Array.isArray(_ctx.content))
                    ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.content, (item, index) => {
                        return (openBlock(), createElementBlock("p", {
                          key: index,
                          innerHTML: index + 1 + '、' + (item.text || item),
                          onClick: $event => (_ctx.handleClick($event, item))
                        }, null, 8 /* PROPS */, _hoisted_5$t))
                      }), 128 /* KEYED_FRAGMENT */))
                    : createCommentVNode("v-if", true)
              ]))
            : createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["locale"])
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["visible", "confirmLoading", "onOk"]))
}

script$1u.render = render$1n;
script$1u.__file = "packages/modal-form/src/ModalForm.vue";

var script$1t = defineComponent({
    props: {
        close: {
            type: Function,
        },
        content: {
            type: [Object, String],
            default: '内容',
        },
        title: {
            type: String,
            default: '提示',
        },
        icon: {
            type: [Object, String],
            default: '',
        },
        btnGroup: {
            type: Array,
            default: () => {
                return [
                    {
                        text: '确定',
                        type: 'primary',
                    },
                    {
                        text: '取消',
                        type: '',
                    },
                ];
            },
        },
        modalConfig: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        'a-button': Button,
        'a-modal': Modal,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes;
        },
    },
    setup() {
        const isVNode = (content) => {
            return typeof content == 'object' && content.__v_isVNode;
        };
        return {
            dialogVisible: true,
            isVNode,
        };
    },
});

const _hoisted_1$18 = { class: "title-text" };
const _hoisted_2$V = ["innerHTML"];
const _hoisted_3$K = { class: "dialog-footer" };

function render$1m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createBlock(_component_a_modal, mergeProps({
    class: "sc-fn-modal",
    visible: _ctx.dialogVisible,
    onCancel: _ctx.close,
    maskClosable: false
  }, { ..._ctx.$props.modalConfig }), {
    title: withCtx(() => [
      (_ctx.isVNode(_ctx.icon))
        ? (openBlock(), createBlock(_component_v_nodes, {
            key: 0,
            vnodes: _ctx.icon
          }, null, 8 /* PROPS */, ["vnodes"]))
        : (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass('sc-' + _ctx.icon)
          }, null, 2 /* CLASS */)),
      createElementVNode("span", _hoisted_1$18, toDisplayString(_ctx.title), 1 /* TEXT */)
    ]),
    footer: withCtx(() => [
      createElementVNode("span", _hoisted_3$K, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.btnGroup, (item, index) => {
          return (openBlock(), createBlock(_component_a_button, {
            key: index,
            type: item.type,
            onClick: $event => (item.click ? item.click(_ctx.close) : _ctx.close())
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(item.btnText), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    default: withCtx(() => [
      (_ctx.isVNode(_ctx.content))
        ? (openBlock(), createBlock(_component_v_nodes, {
            key: 0,
            vnodes: _ctx.content
          }, null, 8 /* PROPS */, ["vnodes"]))
        : (openBlock(), createElementBlock("span", {
            key: 1,
            innerHTML: _ctx.content
          }, null, 8 /* PROPS */, _hoisted_2$V))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["visible", "onCancel"]))
}

script$1t.render = render$1m;
script$1t.__file = "packages/modal/src/ApiModal.vue";

var AllModules = [
    ClientSideRowModelModule,
    InfiniteRowModelModule,
    CsvExportModule,
    ClipboardModule,
    ColumnsToolPanelModule,
    ExcelExportModule,
    FiltersToolPanelModule,
    MasterDetailModule,
    MultiFilterModule,
    MenuModule,
    RangeSelectionModule,
    RichSelectModule,
    RowGroupingModule,
    ServerSideRowModelModule,
    SetFilterModule,
    SideBarModule,
    StatusBarModule,
    ViewportRowModelModule,
];

// Example locale file for English, give this to your locale team to translate

const AG_GRID_LOCALE_CN = {
  // Set Filter
  selectAll: '(选择全部)',
  selectAllSearchResults: '(选择所有搜索结果)',
  searchOoo: '搜索...',
  blanks: '(Blanks)',
  noMatches: '没有匹配到符合条件的数据',

  // Number Filter & Text Filter
  filterOoo: '筛选...',
  equals: '等于',
  notEqual: '不等于',
  empty: 'Choose One',

  // Number Filter
  lessThan: '少于',
  greaterThan: '大于',
  lessThanOrEqual: '小于或等于',
  greaterThanOrEqual: '大于或等于',
  inRange: '在...范围内',
  inRangeStart: 'to',
  inRangeEnd: 'from',

  // Text Filter
  contains: '包含',
  notContains: '不包含',
  startsWith: '以...开始',
  endsWith: '以...结束',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: '且',
  orCondition: '或',

  // Filter Buttons
  applyFilter: '确定',
  resetFilter: '重置',
  clearFilter: '清除',
  cancelFilter: '取消',

  // Filter Titles
  textFilter: 'Text Filter',
  numberFilter: 'Number Filter',
  dateFilter: 'Date Filter',
  setFilter: 'Set Filter',

  // Side Bar
  columns: 'Columns',
  filters: 'Filters',

  // columns tool panel
  pivotMode: 'Pivot Mode',
  groups: 'Row Groups',
  rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
  values: 'Values',
  valueColumnsEmptyMessage: 'Drag here to aggregate',
  pivots: 'Column Labels',
  pivotColumnsEmptyMessage: 'Drag here to set column labels',

  // Header of the Default Group Column
  group: 'Group',

  // Other
  loadingOoo: 'Loading...',
  noRowsToShow: '没有查到符合条件的数据',
  enabled: 'Enabled',

  // Menu
  pinColumn: '固定列',
  pinLeft: '左侧固定',
  pinRight: '右侧固定',
  noPin: '取消固定',
  valueAggregation: 'Value Aggregation',
  autosizeThiscolumn: '重置当前列宽',
  autosizeAllColumns: '重置全部列宽',
  groupBy: 'Group by',
  ungroupBy: 'Un-Group by',
  resetColumns: '重置全部列设置',
  expandAll: '导出全部',
  collapseAll: '关闭全部',
  copy: '复制',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: '复制(包含标题)',
  paste: '粘贴',
  ctrlV: 'Ctrl+V',
  export: '导出',
  csvExport: 'CSV 导出',
  excelExport: 'Excel 导出',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'None',
  count: 'Count',
  avg: 'Average',
  filteredRows: 'Filtered',
  selectedRows: 'Selected',
  totalRows: 'Total Rows',
  totalAndFilteredRows: 'Rows',
  more: 'More',
  to: 'to',
  of: 'of',
  page: 'Page',
  nextPage: 'Next Page',
  lastPage: 'Last Page',
  firstPage: 'First Page',
  previousPage: 'Previous Page',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',

  // ARIA
  ariaHidden: 'hidden',
  ariaVisible: 'visible',
  ariaChecked: 'checked',
  ariaUnchecked: 'unchecked',
  ariaIndeterminate: 'indeterminate',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaInputEditor: 'Input Editor',
  ariaDateFilterInput: 'Date Filter Input',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterValue: 'Filter Value',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterToValue: 'Filter to value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaColumnToggleVisibility: 'column toggle visibility',
  ariaColumnGroupToggleVisibility: 'column group toggle visibility',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaSearch: 'Search',
  ariaSearchFilterValues: 'Search filter values',
};

var script$1s = {
  props: {
    draggingFromParent: Boolean,
    scrolling: Number,
    wrapper: Object,
    area: Object,
    onChangePosition: Function,
    onDragging: Function,
    onStopDrag: Function,
  },
  data() {
    return {
      height: 0,
      dragging: false,
      start: 0,
    };
  },
  watch: {
    'wrapper.height'() {
      this.calculateSize(this);
    },
    'area.height'() {
      this.calculateSize(this);
    },
  },
  methods: {
    startDrag(e) {
      e.preventDefault();
      e.stopPropagation();
      e = e.changedTouches ? e.changedTouches[0] : e;
      // Prepare to drag
      (this.dragging = true), (this.start = e.clientY);
    },
    onDrag(e) {
      if (this.dragging) {
        // Make The Parent being in the Dragging State
        this.onDragging();
        e.preventDefault();
        e.stopPropagation();
        e = e.changedTouches ? e.changedTouches[0] : e;
        const yMovement = e.clientY - this.start;
        const yMovementPercentage = (yMovement / this.wrapper.height) * 100;
        // Update the last e.clientY
        this.start = e.clientY;
        // The next Vertical Value will be
        const next = this.scrolling + yMovementPercentage;
        // Tell the parent to change the position
        this.onChangePosition(next, 'vertical');
      }
    },
    stopDrag() {
      if (this.dragging) {
        // Parent Should Change the Dragging State
        this.onStopDrag();
        this.dragging = false;
      }
    },
    jump(e) {
      const isContainer = e.target === this.$refs.container;
      if (isContainer) {
        // Get the Element Position
        const position = this.$refs.scrollbar.getBoundingClientRect();
        // Calculate the vertical Movement
        const yMovement = e.clientY - position.top;
        const centerize = this.height / 2;
        const yMovementPercentage =
          (yMovement / this.wrapper.height) * 100 - centerize;
        // Update the last e.clientY
        this.start = e.clientY;
        // The next Vertical Value will be
        const next = this.scrolling + yMovementPercentage;
        // Tell the parent to change the position
        this.onChangePosition(next, 'vertical');
      }
    },
    calculateSize(source) {
      // Scrollbar Height
      this.height = (source.wrapper.height / source.area.height) * 100;
    },
    getSize() {
      // The Elements
      const $scrollArea = this.$refs.container.parentElement;
      const $scrollWrapper = $scrollArea.parentElement;
      // Get new Elements Size
      const elementSize = {
        // Scroll Area Height and Width
        scrollAreaHeight: $scrollArea.children[0].clientHeight,
        scrollAreaWidth: $scrollArea.children[0].clientWidth,
        // Scroll Wrapper Height and Width
        scrollWrapperHeight: $scrollWrapper.clientHeight,
        scrollWrapperWidth: $scrollWrapper.clientWidth,
      };
      return elementSize;
    },
  },
  mounted() {
    this.calculateSize(this);
    // Put the Listener
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('touchmove', this.onDrag);
    document.addEventListener('mouseup', this.stopDrag);
    document.addEventListener('touchend', this.stopDrag);
  },
  beforeUnmount() {
    // Remove the Listener
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('touchmove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('touchend', this.stopDrag);
  },
};

function render$1l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", null, [
    ($data.height < 100)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "vue-scrollbar__scrollbar-vertical",
          ref: "container",
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.jump && $options.jump(...args)))
        }, [
          createElementVNode("div", {
            class: normalizeClass(
          'scrollbar' +
            ($data.dragging || $props.draggingFromParent ? '' : ' vue-scrollbar-transition')
        ),
            ref: "scrollbar",
            onTouchstart: _cache[0] || (_cache[0] = (...args) => ($options.startDrag && $options.startDrag(...args))),
            onMousedown: _cache[1] || (_cache[1] = (...args) => ($options.startDrag && $options.startDrag(...args))),
            style: normalizeStyle({
          height: $data.height + '%',
          top: $props.scrolling + '%',
        })
          }, null, 38 /* CLASS, STYLE, HYDRATE_EVENTS */)
        ], 512 /* NEED_PATCH */))
      : createCommentVNode("v-if", true)
  ]))
}

script$1s.render = render$1l;
script$1s.__file = "packages/grid/src/components/VerticalScrollbar.vue";

var script$1r = {
  props: {
    draggingFromParent: Boolean,
    scrolling: Number,
    wrapper: Object,
    area: Object,
    onChangePosition: Function,
    onDragging: Function,
    onStopDrag: Function,
  },
  data() {
    return {
      width: 0,
      dragging: false,
      start: 0,
    };
  },
  watch: {
    'wrapper.width'() {
      this.calculateSize(this);
    },
    'area.width'() {
      this.calculateSize(this);
    },
  },
  methods: {
    startDrag(e) {
      e.preventDefault();
      e.stopPropagation();
      e = e.changedTouches ? e.changedTouches[0] : e;
      // Prepare To Drag
      this.dragging = true;
      this.start = e.clientX;
    },
    onDrag(e) {
      if (this.dragging) {
        // Make The Parent being in the Dragging State
        this.onDragging();
        e.preventDefault();
        e.stopPropagation();
        e = e.changedTouches ? e.changedTouches[0] : e;
        const xMovement = e.clientX - this.start;
        const xMovementPercentage = (xMovement / this.wrapper.width) * 100;
        // Update the last e.clientX
        this.start = e.clientX;
        // The next Horizontal Value will be
        const next = this.scrolling + xMovementPercentage;
        // Tell the parent to change the position
        this.onChangePosition(next, 'horizontal');
      }
    },
    stopDrag() {
      if (this.dragging) {
        // Parent Should Change the Dragging State
        this.onStopDrag();
        this.dragging = false;
      }
    },
    jump(e) {
      const isContainer = e.target === this.$refs.container;
      if (isContainer) {
        // Get the Element Position
        const position = this.$refs.scrollbar.getBoundingClientRect();
        // Calculate the horizontal Movement
        const xMovement = e.clientX - position.left;
        const centerize = this.width / 2;
        const xMovementPercentage =
          (xMovement / this.wrapper.width) * 100 - centerize;
        // Update the last e.clientX
        this.start = e.clientX;
        // The next Horizontal Value will be
        const next = this.scrolling + xMovementPercentage;
        // Tell the parent to change the position
        this.onChangePosition(next, 'horizontal');
      }
    },
    calculateSize(source) {
      // Scrollbar Width
      this.width = (source.wrapper.width / source.area.width) * 100;
    },
  },
  mounted() {
    this.calculateSize(this);
    // Put the Listener
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('touchmove', this.onDrag);
    document.addEventListener('mouseup', this.stopDrag);
    document.addEventListener('touchend', this.stopDrag);
  },
  beforeUnmount() {
    // Remove the Listener
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('touchmove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('touchend', this.stopDrag);
  },
};

function render$1k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", null, [
    ($data.width < 100)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "vue-scrollbar__scrollbar-horizontal",
          ref: "container",
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.jump && $options.jump(...args)))
        }, [
          createElementVNode("div", {
            class: normalizeClass(
          'scrollbar' +
            ($data.dragging || $props.draggingFromParent ? '' : ' vue-scrollbar-transition')
        ),
            ref: "scrollbar",
            onTouchstart: _cache[0] || (_cache[0] = (...args) => ($options.startDrag && $options.startDrag(...args))),
            onMousedown: _cache[1] || (_cache[1] = (...args) => ($options.startDrag && $options.startDrag(...args))),
            style: normalizeStyle({
          width: this.width + '%',
          left: this.scrolling + '%',
        })
          }, null, 38 /* CLASS, STYLE, HYDRATE_EVENTS */)
        ], 512 /* NEED_PATCH */))
      : createCommentVNode("v-if", true)
  ]))
}

script$1r.render = render$1k;
script$1r.__file = "packages/grid/src/components/HorizontalScrollbar.vue";

var script$1q = defineComponent({
  props: {
    classes: String,
    styles: Object,
    speed: {
      type: Number,
      default: 53,
    },
    onMaxScroll: Function,
    areaWidth: Number,
    scrollNext: Number,
    isBarShow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VerticalScrollbar: script$1s,
    HorizontalScrollbar: script$1r,
  },
  data() {
    return {
      ready: false,
      top: 0,
      left: 0,
      scrollAreaHeight: null,
      scrollAreaWidth: 0,
      scrollWrapperHeight: null,
      scrollWrapperWidth: 0,
      vMovement: 0,
      hMovement: 0,
      dragging: false,
      start: { y: 0, x: 0 },
      allowBodyScroll: false,
    };
  },
  methods: {
    scroll(e) {
      // Make sure the content height is not changed
      this.calculateSize(() => {
        // Set the wheel step
        const num = this.speed;
        // DOM events
        const shifted = e.shiftKey;
        const scrollY = e.deltaY > 0 ? num : -num;
        let scrollX = e.deltaX > 0 ? num : -num;
        // Fix Mozilla Shifted Wheel~
        if (shifted && e.deltaX == 0) scrollX = e.deltaY > 0 ? num : -num;
        // Next Value
        const nextY = this.top + scrollY;
        const nextX = this.left + scrollX;
        // Is it Scrollable?
        const canScrollY = this.scrollAreaHeight > this.scrollWrapperHeight;
        const canScrollX = this.scrollAreaWidth > this.scrollWrapperWidth;
        // Vertical Scrolling
        if (canScrollY && !shifted) this.normalizeVertical(nextY);
        // Horizontal Scrolling
        if (shifted && canScrollX) this.normalizeHorizontal(nextX);
      });
      // prevent Default only if scrolled content is not at the top/bottom
      if (!this.allowBodyScroll) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    // DRAG EVENT JUST FOR TOUCH DEVICE~
    startDrag(e) {
      this.touchEvent = e;
      const evt = e.changedTouches ? e.changedTouches[0] : e;
      // Make sure the content height is not changed
      this.calculateSize(() => {
        // Prepare to drag
        (this.dragging = true), (this.start = { y: evt.pageY, x: evt.pageX });
      });
    },
    onDrag(e) {
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();
        // Prevent Click Event When it dragging
        if (this.touchEvent) {
          this.touchEvent.preventDefault();
          this.touchEvent.stopPropagation();
        }
        const evt = e.changedTouches ? e.changedTouches[0] : e;
        // Invers the Movement
        const yMovement = this.start.y - evt.clientY;
        const xMovement = this.start.x - evt.clientX;
        // Update the last e.client
        this.start = { y: evt.clientY, x: evt.clientX };
        // The next Vertical Value will be
        const nextY = this.top + yMovement;
        const nextX = this.left + xMovement;
        this.normalizeVertical(nextY);
        this.normalizeHorizontal(nextX);
      }
    },
    stopDrag() {
      this.dragging = false;
      this.touchEvent = false;
    },
    scrollToY(y) {
      this.normalizeVertical(y);
    },
    scrollToX(x) {
      this.normalizeHorizontal(x);
    },
    normalizeVertical(next) {
      const elementSize = this.getSize();
      // Vertical Scrolling
      const lowerEnd =
        elementSize.scrollAreaHeight - elementSize.scrollWrapperHeight;
      // Max Scroll Down
      const maxBottom = next > lowerEnd;
      if (maxBottom) next = lowerEnd;
      // Max Scroll Up
      const maxTop = next < 0;
      if (maxTop) next = 0;
      // Update the Vertical Value if it's needed
      const shouldScroll = this.top !== next;
      this.allowBodyScroll = !shouldScroll;
      if (shouldScroll) {
        (this.top = next),
          (this.vMovement = (next / elementSize.scrollAreaHeight) * 100);
        if (this.onMaxScroll && (maxTop || maxBottom)) {
          this.onMaxScroll({
            top: maxTop,
            bottom: maxBottom,
            right: false,
            left: false,
          });
        }
      }
    },
    normalizeHorizontal(next) {
      const elementSize = this.getSize();
      // Horizontal Scrolling
      const rightEnd = elementSize.scrollAreaWidth - this.scrollWrapperWidth;
      // Max Scroll Right
      const maxRight = next > rightEnd;
      if (maxRight) next = rightEnd;
      // Max Scroll Left
      const maxLeft = next < 0;
      if (next < 0) next = 0;
      // Update the Horizontal Value
      const shouldScroll = this.left !== next;
      this.allowBodyScroll = !shouldScroll;
      if (shouldScroll) {
        (this.left = next),
          (this.hMovement = (next / elementSize.scrollAreaWidth) * 100);
        if (this.onMaxScroll && (maxRight || maxLeft)) {
          this.onMaxScroll({
            right: maxRight,
            left: maxLeft,
            top: false,
            bottom: false,
          });
        }
        if (this.dragging) {
          this.changeTableHorizontal(next);
        }
      }
    },
    changeTableHorizontal(next) {
      // 更新表格的水平滚动条
      // next * scrollWidth / this.areaWidth  = left
      const table = this.$parent.$el.getElementsByClassName('ag-theme-balham');
      if (table) {
        table.forEach((e) => {
          const el = e.querySelectorAll('[ref=eViewport]')[0];
          const left = (next * el.scrollWidth) / this.scrollAreaWidth;
          el.scrollLeft = left;
        });
      }
    },
    handleChangePosition(movement, orientation) {
      // Make sure the content height is not changed
      this.calculateSize(() => {
        // Convert Percentage to Pixel
        const next = movement / 100;
        if (orientation == 'vertical')
          this.normalizeVertical(next * this.scrollAreaHeight);
        if (orientation == 'horizontal')
          this.normalizeHorizontal(next * this.scrollAreaWidth);
      });
    },
    handleScrollbarDragging() {
      this.dragging = true;
    },
    handleScrollbarStopDrag() {
      this.dragging = false;
    },
    getSize() {
      // The Elements
      const $scrollArea = this.$refs.scrollArea;
      const $scrollWrapper = this.$refs.scrollWrapper;
      // Get new Elements Size
      const elementSize = {
        // Scroll Area Height and Width
        scrollAreaHeight: $scrollArea.children[0].clientHeight,
        scrollAreaWidth: $scrollArea.children[0].clientWidth,
        // Scroll Wrapper Height and Width
        scrollWrapperHeight: $scrollWrapper.clientHeight,
        scrollWrapperWidth: $scrollWrapper.clientWidth,
      };
      return elementSize;
    },
    calculateSize(cb) {
      if (typeof cb !== 'function') cb = null;
      const elementSize = this.getSize();
      if (
        elementSize.scrollWrapperHeight !== this.scrollWrapperHeight ||
        elementSize.scrollWrapperWidth !== this.scrollWrapperWidth ||
        elementSize.scrollAreaHeight !== this.scrollAreaHeight ||
        elementSize.scrollAreaWidth !== this.scrollAreaWidth
      ) {
        // Scroll Area Height and Width
        (this.scrollAreaHeight = elementSize.scrollAreaHeight),
          (this.scrollAreaWidth = elementSize.scrollAreaWidth),
          // Scroll Wrapper Height and Width
          (this.scrollWrapperHeight = elementSize.scrollWrapperHeight),
          (this.scrollWrapperWidth = elementSize.scrollWrapperWidth),
          // Make sure The wrapper is Ready, then render the scrollbar
          (this.ready = true);
        return cb ? cb() : false;
      } else return cb ? cb() : false;
    },
  },
  mounted() {
    this.calculateSize();
    // Attach The Event for Responsive View~
    window.addEventListener('resize', this.calculateSize);
  },
  watch: {
    areaWidth(val, oldVal) {
      this.scrollAreaWidth = val;
      if (oldVal) this.$nextTick(this.calculateSize);
    },
    scrollNext(val) {
      // 更新scroll位置
      if (!this.dragging) {
        this.normalizeHorizontal(val);
      }
    },
  },
  beforeUnmount() {
    // Remove Event
    window.removeEventListener('resize', this.calculateSize);
  },
});

function render$1j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VerticalScrollbar = resolveComponent("VerticalScrollbar");
  const _component_HorizontalScrollbar = resolveComponent("HorizontalScrollbar");

  return (openBlock(), createElementBlock("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.calculateSize && _ctx.calculateSize(...args))),
    class: normalizeClass('vue-scrollbar__wrapper' + (this.classes ? ' ' + this.classes : '')),
    ref: "scrollWrapper",
    style: normalizeStyle(this.styles)
  }, [
    createElementVNode("div", {
      class: normalizeClass(
        'vue-scrollbar__area' +
          (this.dragging ? ' ' : ' vue-scrollbar-transition') +
          (this.isBarShow ? ' show-bar' : ' hide-bar')
      ),
      ref: "scrollArea",
      onWheel: _cache[0] || (_cache[0] = (...args) => (_ctx.scroll && _ctx.scroll(...args))),
      onTouchstart: _cache[1] || (_cache[1] = (...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
      onTouchmove: _cache[2] || (_cache[2] = (...args) => (_ctx.onDrag && _ctx.onDrag(...args))),
      onTouchend: _cache[3] || (_cache[3] = (...args) => (_ctx.stopDrag && _ctx.stopDrag(...args))),
      style: normalizeStyle({
        marginTop: this.top * -1 + 'px',
        marginLeft: this.left * -1 + 'px',
      })
    }, [
      renderSlot(_ctx.$slots, "default"),
      createElementVNode("div", {
        style: normalizeStyle({
          width: _ctx.scrollAreaWidth + 'px',
          height: _ctx.scrollAreaWidth <= _ctx.scrollWrapperWidth ? 0 : '12px',
        })
      }, null, 4 /* STYLE */),
      (_ctx.ready)
        ? (openBlock(), createBlock(_component_VerticalScrollbar, {
            key: 0,
            area: { height: _ctx.scrollAreaHeight },
            wrapper: { height: _ctx.scrollWrapperHeight },
            scrolling: _ctx.vMovement,
            "dragging-from-parent": _ctx.dragging,
            "on-change-position": _ctx.handleChangePosition,
            "on-dragging": _ctx.handleScrollbarDragging,
            "on-stop-drag": _ctx.handleScrollbarStopDrag
          }, null, 8 /* PROPS */, ["area", "wrapper", "scrolling", "dragging-from-parent", "on-change-position", "on-dragging", "on-stop-drag"]))
        : createCommentVNode("v-if", true),
      (_ctx.ready)
        ? (openBlock(), createBlock(_component_HorizontalScrollbar, {
            key: 1,
            area: { width: _ctx.scrollAreaWidth },
            wrapper: { width: _ctx.scrollWrapperWidth },
            scrolling: _ctx.hMovement,
            "dragging-from-parent": _ctx.dragging,
            "on-change-position": _ctx.handleChangePosition,
            "on-dragging": _ctx.handleScrollbarDragging,
            "on-stop-drag": _ctx.handleScrollbarStopDrag
          }, null, 8 /* PROPS */, ["area", "wrapper", "scrolling", "dragging-from-parent", "on-change-position", "on-dragging", "on-stop-drag"]))
        : createCommentVNode("v-if", true)
    ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */)
  ], 6 /* CLASS, STYLE */))
}

script$1q.render = render$1j;
script$1q.__file = "packages/grid/src/components/Scrollbar.vue";

var script$1p = {
  data() {
    return {
      height: 0,
      msg: ``,
      list: [],
    };
  },
  beforeMount() {
    if (this.params.htmlRender) {
      this.height = this.params.htmlRender.height;
      this.msg = this.params.htmlRender.msg;
    }
    if (this.params.filedParams) {
      const tempList = this.params.data[this.params.filedParams.filed] || [];
      this.list = tempList
        .map((e) => e[this.params.filedParams.key])
        .toString();
    }
  },
};

const _hoisted_1$17 = /*#__PURE__*/createElementVNode("div", { class: "ant-tooltip-arrow" }, [
  /*#__PURE__*/createElementVNode("span", { class: "ant-tooltip-arrow-content" })
], -1 /* HOISTED */);
const _hoisted_2$U = {
  class: "ant-tooltip-inner",
  role: "tooltip"
};
const _hoisted_3$J = { class: "updated-recover-tip-content" };
const _hoisted_4$A = { key: 0 };
const _hoisted_5$s = { key: 1 };
const _hoisted_6$m = ["innerHTML"];
const _hoisted_7$k = { key: 3 };
const _hoisted_8$j = /*#__PURE__*/createElementVNode("br", null, null, -1 /* HOISTED */);

function render$1i(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.params.value)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["sc-grid-tooltip ant-tooltip", 
      _ctx.params.colDef.tooltipTheme && _ctx.params.colDef.tooltipTheme == 'light'
        ? 'sc-tooltip-light ant-tooltip-placement-' +
          (_ctx.params.tipPlacement || 'top')
        : 'ant-tooltip-placement-' + (_ctx.params.tipPlacement || 'top')
    ]),
        id: "J_scGridTooltip",
        style: normalizeStyle({
      transform: `translateX(20px) translateY(${_ctx.params.node.rowTop}px)`,
    })
      }, [
        createElementVNode("div", {
          class: "ant-tooltip-content",
          style: normalizeStyle({ top: $data.height })
        }, [
          _hoisted_1$17,
          createElementVNode("div", _hoisted_2$U, [
            createElementVNode("span", _hoisted_3$J, [
              (_ctx.params.customParams)
                ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.params.customParams, (cont, index) => {
                    return (openBlock(), createElementBlock("span", { key: index }, [
                      createTextVNode(toDisplayString(cont.label + _ctx.params.data[cont.field]) + " " + toDisplayString(index % 2 == 0 ? ' | ' : '') + " ", 1 /* TEXT */),
                      (index % 2 == 1)
                        ? (openBlock(), createElementBlock("br", _hoisted_4$A))
                        : createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : (_ctx.params.filedParams)
                  ? (openBlock(), createElementBlock("span", _hoisted_5$s, toDisplayString($data.list), 1 /* TEXT */))
                  : (_ctx.params.htmlRender)
                    ? (openBlock(), createElementBlock("div", {
                        key: 2,
                        innerHTML: $data.msg
                      }, null, 8 /* PROPS */, _hoisted_6$m))
                    : (openBlock(), createElementBlock("span", _hoisted_7$k, [
                        createTextVNode(toDisplayString(_ctx.params.value) + " ", 1 /* TEXT */),
                        _hoisted_8$j
                      ]))
            ])
          ])
        ], 4 /* STYLE */)
      ], 6 /* CLASS, STYLE */))
    : createCommentVNode("v-if", true)
}

script$1p.render = render$1i;
script$1p.__file = "packages/grid/src/components/DefaultTooltip.vue";

const pathname = window.location.pathname || '';
// =================上面的方法废弃了==================
// 获取本地存储大小
const localStorageSize = function () {
    let lsTotal = 0, xLen, x;
    for (x in localStorage) {
        // eslint-disable-next-line no-prototype-builtins
        if (!window.localStorage.hasOwnProperty(x))
            continue;
        xLen = (localStorage[x].length + x.length) * 2;
        lsTotal += xLen;
    }
    return lsTotal / 1024 / 1024;
};
// 获取当前用户
const getUserInfo = () => JSON.parse(localStorage.userInfo || '{}');
const getStateItemKey = () => {
    const { organizationId, userId } = getUserInfo();
    return `${String(organizationId || 0)}+${String(userId || 0)}`;
};
// 缓存数据
function setState(name, data) {
    if (name.indexOf('/') === -1)
        name = pathname + name;
    let m = new Map();
    const k = getStateItemKey();
    // 先查询
    const localData = localStorage.getItem(name);
    if (localData) {
        const localDataParsed = JSON.parse(localData);
        if (Array.isArray(localDataParsed)) {
            m = new Map(localDataParsed);
            // 如有删除，再插入
            if (m.has(k)) {
                m.delete(k);
            }
            // 检查占用，删除最早的
            if (localStorageSize() > 4) {
                m.delete(m.keys().next().value);
            }
        }
    }
    m.set(k, data);
    return localStorage.setItem(name, JSON.stringify([...m]));
}
// 获取缓存数据
function getState(name) {
    if (name.indexOf('/') === -1)
        name = pathname + name;
    const localData = localStorage.getItem(name);
    if (localData) {
        let m = new Map();
        const k = getStateItemKey();
        // 先查询
        if (localData) {
            const localDataParsed = JSON.parse(localData);
            if (Array.isArray(localDataParsed)) {
                m = new Map(localDataParsed);
                if (m.has(k))
                    return m.get(k);
                return '';
            }
        }
    }
    return localData ? JSON.parse(localData) : '';
}
// 清除缓存数据
function removeState(name) {
    if (name.indexOf('/') === -1)
        name = pathname + name;
    return localStorage.removeItem(name);
}
/**
 * @description 获取query
 */
const getQueryKeywords = () => {
    const result = {};
    const search = decodeURIComponent(window.location.search);
    const tempArr = search && search.indexOf('?') === 0 ? search.split('?')[1].split('&') : [];
    tempArr.forEach((item) => {
        if (item) {
            const itemArr = item.split('=');
            // 临时数据类型转换
            const isnum = itemArr[1].length < 11 && /^\d+$/.test(itemArr[1]);
            result[itemArr[0]] = isnum ? parseInt(itemArr[1]) : itemArr[1];
        }
    });
    return result;
};

const math = {
    /**
     * 乘法
     * num1 * num2
     * */
    accMul(num1, num2) {
        if (num1 === null || num2 === null)
            return null;
        num1 = Number(num1);
        num2 = Number(num2);
        if (isNaN(num1) || isNaN(num2))
            return null;
        return Number($math.multiply($math.bignumber(num1), $math.bignumber(num2)));
    },
    /**
     * 除法
     * num1 ÷ num2
     * */
    accDiv(num1, num2) {
        if (num1 === null || num2 === null)
            return null;
        num1 = Number(num1);
        num2 = Number(num2);
        if (isNaN(num1) || isNaN(num2))
            return null;
        return Number($math.divide($math.bignumber(num1), $math.bignumber(num2)));
    },
    /**
     * 加法
     * num1 + num2
     * */
    accAdd(num1, num2) {
        if (num1 === null || num2 === null)
            return null;
        num1 = Number(num1);
        num2 = Number(num2);
        if (isNaN(num1) || isNaN(num2))
            return null;
        return Number($math.add($math.bignumber(num1), $math.bignumber(num2)));
    },
    /**
     * 减法
     * num1 - num2
     * */
    accSub(num1, num2) {
        if (num1 === null || num2 === null)
            return null;
        num1 = Number(num1);
        num2 = Number(num2);
        if (isNaN(num1) || isNaN(num2))
            return null;
        return Number($math.subtract($math.bignumber(num1), $math.bignumber(num2)));
    },
    /**
     * 只入不舍(进一)
     * @param num
     * @param cent
     * @returns
     */
    ceil(num, cent) {
        if (num === null || isNaN(Number(num)))
            return 0;
        cent =
            cent == undefined
                ? num.toLocaleString().split('.')[1]
                    ? num.toLocaleString().split('.')[1].length
                    : 0
                : cent;
        num = Number(num);
        if (cent == 0) {
            return Number($math.ceil(num));
        }
        const powCent = $math.pow(10, cent);
        const n = Number($math.multiply(num, powCent));
        return Number($math.divide($math.ceil(n), powCent));
    },
    /**
     * 只舍不入
     * @param num
     * @param cent
     * @returns
     */
    floor(num, cent) {
        if (num === null || isNaN(Number(num)))
            return 0;
        cent =
            cent == undefined
                ? num.toLocaleString().split('.')[1]
                    ? num.toLocaleString().split('.')[1].length
                    : 0
                : cent;
        num = Number(num);
        if (cent == 0) {
            return Number($math.floor(num));
        }
        const powCent = $math.pow(10, cent);
        num = Number(num);
        const n = Number($math.multiply(num, powCent));
        return Number($math.divide($math.floor(n), powCent));
    },
    /**
     * 四舍五入
     * @param num
     * @param cent
     * @returns
     */
    round(num, cent) {
        if (num === null || isNaN(Number(num)))
            return 0;
        cent =
            cent == undefined
                ? num.toLocaleString().split('.')[1]
                    ? num.toLocaleString().split('.')[1].length
                    : 0
                : cent;
        num = Number(num);
        if (cent == 0) {
            return Number($math.round(num));
        }
        const powCent = $math.pow(10, cent);
        num = Number(num);
        const n = Number($math.multiply(num, powCent));
        return Number($math.divide($math.round(n), powCent));
    },
    /**
     * Correct the given number to specifying significant digits.
     *
     * @param num The input number
     * @param precision An integer specifying the number of significant digits
     *
     * @example strip(0.09999999999999998) === 0.1 // true
     */
    strip(num, precision = 15) {
        return +parseFloat(Number(num).toPrecision(precision));
    },
    /**
     * 千分制格式化方法 (无需千分制格式化可直接使用mathjs中的方法 如：$math.ceil(0.4555, 2) // result: 0.46)
     * num: 数值
     * cent: 保留位数
     * type: 取值方法 - ceil: 有舍必入(进一)，floor: 只舍不入，round: 四舍五入 ...
     *      (如需更多方法可参考mathjs文档:  https://mathjs.org/docs/reference/functions.html)
     * */
    toThousands(params) {
        params = Object.assign({
            num: 0,
            type: 'ceil',
            isThousand: true,
        }, params);
        let num = params.num;
        if (num === null || isNaN(Number(num)))
            return null;
        num = this.strip(params.num);
        const cent = params.cent == undefined
            ? num.toLocaleString().split('.')[1]
                ? num.toLocaleString().split('.')[1].length
                : 0
            : params.cent;
        num = Number(num);
        switch (params.type) {
            case 'ceil':
                num = math.ceil(num, cent);
                break;
            case 'floor':
                num = math.floor(num, cent);
                break;
            case 'round':
                num = $math.round(num, cent);
                break;
        }
        let num1 = '';
        let sign = '';
        if (num < 0) {
            sign = '-';
            num = -num;
        }
        if (params.isThousand && num >= 1000) {
            const re = /\d{1,3}(?=(\d{3})+$)/g;
            num1 = num.toString().replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
                return s1.replace(re, '$&,') + s2;
            });
        }
        else {
            num1 = num.toString();
        }
        if (sign) {
            num1 = sign + num1;
        }
        if (cent > 0) {
            const rs = num1.split('.');
            let c;
            if (rs.length > 1) {
                c = rs[1].length;
            }
            else {
                c = 0;
                num1 += '.';
            }
            for (let i = c; i < cent; i++) {
                num1 += '0';
            }
        }
        return num1;
    },
};

var script$1o = defineComponent({
    name: 'ScPopconfirm',
    components: {
        Popconfirm,
    },
    props: {
        visible: {
            // 是否显示
            type: [Boolean],
            default: false,
        },
        iconCancel: {
            type: [Boolean],
            default: true,
        },
        placement: {
            // 展示方向
            type: String,
            default: 'bottom',
        },
        popTitle: {
            // 标题
            type: String,
        },
        cancelText: {
            // 取消按钮文本
            type: String,
        },
        okText: {
            // 确定按钮文本
            type: String,
        },
        hideCancel: {
            // 是否隐藏取消按钮
            type: [Boolean],
            default: false,
        },
        hideBtn: {
            // 是否隐藏按钮
            type: [Boolean],
            default: false,
        },
        hideIcon: {
            // 是否隐藏提示图标
            type: [Boolean],
            default: true,
        },
        overlayStyle: {
            // 自定义样式
            type: Object,
            default: () => ({}),
        },
        popConfirm: {
            // 确认回调
            type: Function,
        },
        popCancel: {
            // 取消回调
            type: Function,
        },
        popClose: {
            // 关闭回调
            type: Function,
        },
        visibleChange: {
            // 显示/隐藏变化回调
            type: Function,
        },
        overlayClassName: {
            type: String,
        },
    },
    setup(props, { emit }) {
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        const handelPopCancel = (e) => {
            if (props.popCancel && props.popCancel(e) == false) {
                visibleRef.value = true;
            }
            else {
                visibleRef.value = false;
            }
        };
        const handelPopConfirm = (e) => {
            if (props.popConfirm && props.popConfirm(e) == false) {
                visibleRef.value = true;
            }
            else {
                visibleRef.value = false;
            }
        };
        const handelVisibleChange = (visible) => {
            if (props.visibleChange)
                props.visibleChange(visible);
        };
        // 渲染节点固定在触发器的父元素中
        const getPopupContainer = (triggerNode) => {
            return triggerNode.parentNode;
        };
        const handelPopClose = (e) => {
            if (props.popClose && props.popClose(e) == false) {
                visibleRef.value = true;
            }
            else {
                visibleRef.value = false;
            }
        };
        return {
            visibleRef,
            handelPopCancel,
            handelPopConfirm,
            handelPopClose,
            handelVisibleChange,
            getPopupContainer,
        };
    },
});

const _hoisted_1$16 = { class: "sc-popconfirm-title" };
const _hoisted_2$T = ["innerHTML"];

function render$1h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Popconfirm = resolveComponent("Popconfirm", true);

  return (openBlock(), createBlock(_component_Popconfirm, {
    placement: _ctx.$props.placement,
    arrowPointAtCenter: true,
    overlayClassName: 
      `sc-popconfirm
          ${_ctx.$props.hideCancel ? ' popconfirm-hide-cancel' : ''}
          ${_ctx.$props.hideBtn ? ' popconfirm-hide-btn' : ''}
          ${_ctx.$props.hideIcon ? ' popconfirm-hide-icon' : ''}
          ${_ctx.$props.overlayClassName || ''}`
    ,
    cancelText: _ctx.$props.cancelText || '取消',
    okText: _ctx.$props.okText || '确定',
    onCancel: _ctx.handelPopCancel,
    onConfirm: _ctx.handelPopConfirm,
    onVisibleChange: _ctx.handelVisibleChange,
    overlayStyle: _ctx.$props.overlayStyle,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visibleRef) = $event))
  }, {
    title: withCtx(() => [
      createElementVNode("div", _hoisted_1$16, [
        createElementVNode("h3", {
          innerHTML: _ctx.$props.popTitle || ''
        }, null, 8 /* PROPS */, _hoisted_2$T),
        createElementVNode("i", {
          class: "iconfont close-btn",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handelPopClose && _ctx.handelPopClose(...args)))
        }, "")
      ]),
      renderSlot(_ctx.$slots, "content")
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "trigger")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["placement", "overlayClassName", "cancelText", "okText", "onCancel", "onConfirm", "onVisibleChange", "overlayStyle", "visible"]))
}

script$1o.render = render$1h;
script$1o.__file = "packages/popconfirm/src/Popconfirm.vue";

script$1o.install = (Vue) => {
    Vue.component(script$1o.name, script$1o);
};

// 文本格式化
const textFormatter = (params) => {
    if (!params.value) {
        return '-';
    }
};
// 自增序号式化
const incrementFormatter = (params) => {
    if (params.node.rowPinned)
        return '';
    return params.node.rowIndex + 1;
};
// 普通数字格式化
const numberFormatter = (params) => {
    const value = parseInt(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return value;
};
// 2位货币千分位
const currencyFormatter = (params, flag) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return ((flag ? (value < 0 ? '-' : '+') : '') +
        Math.abs(value)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
};
// 4位小数
const floatFormatter = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return value.toFixed(4);
};
// 遇到需要乘 100 的可以配合 valueGetter: formatter.percentValueGetter
// 百分数两位小数
const percentFormatter = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return value.toFixed(2) + '%';
};
// 百分数整数
const percentIntFormatter = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(params.value)) {
        return '-';
    }
    return value.toFixed(0) + '%';
};
// ========getter 方法========
// 百分数乘以 100
const percentValueGetter = (params) => {
    return params.data[params.colDef.field] * 100;
};
// ========单元格样式 方法========
// 负数金额单元格文字颜色
const currencyCellStyle = (params) => {
    if (params.value < 0)
        return { color: '#d22d21' };
    return { color: '#0070dd' };
};
// 百分数单元格颜色
const percentCellStyle = (params) => {
    if (params.value < 0)
        return { color: '#4ab54e' };
    return { color: '#d22d21' };
};
// 负数金额单元格文字颜色
const numberCellStyle = (params) => {
    if (params.value < 0)
        return { color: '#d22d21' };
    if (params.colDef.warning && params.value <= params.colDef.warning)
        return { color: '#f7b11e' };
    return { color: '#666' };
};
// ============以下方法不建议使用===================================
// 折扣需要千分位分割
const discountFormatter = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return math
        .ceil(value, 4)
        .toFixed(4)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
// 价格需要千分位分割
const priceFormatter = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return math
        .ceil(value, 2)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
// 折扣不需要千分位分割
const discountFormatterNoCut = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return math.ceil(value, 4).toFixed(4);
};
// 价格不需要千分位分割
const priceFormatterNoCut = (params) => {
    const value = parseFloat(params.value);
    if (isNaN(value)) {
        return '-';
    }
    return math.ceil(value, 2).toFixed(2);
};
const numberValueSetter = (params) => {
    // 单元格设置价格原始值
    if (isNaN(parseFloat(params.newValue)) || !isFinite(params.newValue)) {
        return false;
    }
    params.data.price = params.newValue;
    return true;
};
// ===============================================
const colourMappings = {
    Permanent: 'Blue',
    Contract: 'Burlywood',
    GTYD: 'Green',
};
function extractValues(mappings) {
    return Object.keys(mappings);
}
function brandSeriesRender(params) {
    const record = params.data;
    if (record.brandName && record.seriesId) {
        return `<span>
          <span
            class="sc-product-brand"
            style="
              color:${record.brandColor};border-color:${record.brandColor}
            "
          >
            ${record.brandName}
          </span>
          <span
            class="series"
            :title="record.seriesName"
          >
            ${record.seriesName}
          </span>
        </span>`;
    }
    else {
        return '-';
    }
}
function colourCellRenderer(params) {
    /**  列定义时
     *  cellRenderer: formatter.colourCellRenderer,
        cellRendererParams: {
          customParams: {
            keyName: 'type', // 要显示的字段，多级的情况下如:permissionPriceMap.level.type  或者permissionPriceMap[1].type
            list: [
              {
                key: 10,  // 显示字段值
                label: '折扣',
                color: '#31B7C6',
              },
              {
                key: 20,  //
                label: '价格',
                color: '#FF8080',
              },
            ],
          },
        },
     */
    const list = params.customParams ? params.customParams.list : [];
    const keyName = params.customParams ? params.customParams.keyName : '';
    //当前行的值
    let keyVal = keyName ? params.data[keyName] : '';
    //处理传过来的多级字段
    if (keyName.includes('.')) {
        const keyList = keyName.split('.');
        let tempKey = params.data;
        for (let i = 0; i < keyList.length; i++) {
            //字段有数组
            if (keyList[i].includes('[')) {
                const j = keyList[i].indexOf('[');
                const k = keyList[i].indexOf(']');
                const index = keyList[i].slice(j + 1, k) * 1;
                if (tempKey[keyList[i].slice(0, j)]) {
                    tempKey = tempKey[keyList[i].slice(0, j)][index];
                }
                else {
                    tempKey = null;
                    break;
                }
            }
            else {
                tempKey = tempKey[keyList[i]];
            }
        }
        keyVal = tempKey;
    }
    const item = list.find((e) => e.key == keyVal);
    if (item) {
        return `<span style="color:${item.color}">${item.label}</span>`;
    }
    else {
        return '-';
    }
}
// 日期格式化
const formatDate = function (date) {
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
};
const formatterDate = (date, config) => {
    const { days, isTime, noSeperator, timeSuffix } = config || {};
    if (days) {
        date = new Date(new Date(date).getTime() + days * 24 * 60 * 60 * 1000);
    }
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m < 10 && (m = '0' + m);
    let d = date.getDate();
    d < 10 && (d = '0' + d);
    if (isTime) {
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        // 格式化补0
        hour < 10 && (hour = '0' + hour);
        minute < 10 && (minute = '0' + minute);
        second < 10 && (second = '0' + second);
        if (!noSeperator) {
            return y + '-' + m + '-' + d + ' ' + hour + ':' + minute + ':' + second;
        }
        else {
            return '' + y + m + d + hour + minute + second;
        }
    }
    else {
        const timeSuffixStr = timeSuffix === 'start'
            ? ' 00:00:00'
            : timeSuffix == 'end'
                ? ' 23:59:59'
                : timeSuffix || '';
        if (!noSeperator) {
            return y + '-' + m + '-' + d + timeSuffixStr;
        }
        else {
            return '' + y + m + d + timeSuffixStr;
        }
    }
};
const colours = extractValues(colourMappings);

var formatter = /*#__PURE__*/Object.freeze({
  __proto__: null,
  textFormatter: textFormatter,
  incrementFormatter: incrementFormatter,
  numberFormatter: numberFormatter,
  currencyFormatter: currencyFormatter,
  floatFormatter: floatFormatter,
  percentFormatter: percentFormatter,
  percentIntFormatter: percentIntFormatter,
  percentValueGetter: percentValueGetter,
  currencyCellStyle: currencyCellStyle,
  percentCellStyle: percentCellStyle,
  numberCellStyle: numberCellStyle,
  discountFormatter: discountFormatter,
  priceFormatter: priceFormatter,
  discountFormatterNoCut: discountFormatterNoCut,
  priceFormatterNoCut: priceFormatterNoCut,
  numberValueSetter: numberValueSetter,
  colourMappings: colourMappings,
  extractValues: extractValues,
  brandSeriesRender: brandSeriesRender,
  colourCellRenderer: colourCellRenderer,
  formatDate: formatDate,
  formatterDate: formatterDate,
  colours: colours
});

/**
 * @description 根据key值给指定属性赋值
 * @param list list
 * @param key key值
 * @param attr 属性名
 * @param value 赋值
 */
const setlistValue = (list, key, attr, value) => {
    const index = list.findIndex((item) => item.key == key);
    if (index > -1) {
        if (attr.indexOf('.') > -1) {
            const arr = attr.split('.');
            const obj = arr[0];
            const objAttr = arr[1];
            list[index][obj][objAttr] = value;
        }
        else {
            list[index][attr] = value;
        }
    }
};
// 手机号校验
const isMobile = function (v) {
    return /^1\d{10}$/.test(v.trim());
};
// 固定电话校验
const isPhone = function (v) {
    const reg = /^((0\d{2,3}-\d{7,8})|(1\d{10}))(-\d+)?$/;
    return reg.test(v);
};

const copy = (value) => {
    const input = document.createElement('textarea');
    document.body.appendChild(input);
    input.value = value;
    input.select();
    document.execCommand('Copy');
    message.success('已复制到剪贴板');
    document.body.removeChild(input);
};

const useInnerGrid$1 = (columnDefs, visible, value, indexField, isMultiSelect, context) => {
    const gridRef = ref();
    const selectedValueRef = ref(JSON.parse(JSON.stringify(value.value)));
    // 弹框是否显示
    const visibleRef = computed({
        get: () => visible.value,
        set: (val) => {
            context.emit('update:visible', val);
        },
    });
    // 表格初始设置
    const gridDefs = {
        getRowNodeId: (data) => data[indexField],
    };
    // 单选模式和多选模式
    const multiSelectModel = () => {
        if (!isMultiSelect) {
            // 单选模式
            gridDefs.rowMultiSelectWithClick = false;
            // columnDefs.splice(0, 1);
        }
        else {
            // 多选模式
            columnDefs.splice(0, 1, {
                field: '',
                headerCheckboxSelection: true,
                checkboxSelection: true,
            });
        }
    };
    multiSelectModel();
    // 表格初始选择
    const onRowDataChanged = (params) => {
        selectedValueRef.value.map((data) => {
            const node = params.api.getRowNode(data[indexField]);
            node && node.setSelected(true);
        });
    };
    const onRowSelected = (params) => {
        const { data, node } = params;
        const selected = node.isSelected();
        const index = selectedValueRef.value.findIndex((e) => e[indexField] === node.id);
        if (selected) {
            if (isMultiSelect) {
                index === -1 && selectedValueRef.value.push(data);
            }
            else {
                selectedValueRef.value.splice(0);
                selectedValueRef.value.push({ ...data, closable: false });
            }
        }
        else {
            // 禁止删除closable:false
            if (isMultiSelect) {
                if (index !== -1 && selectedValueRef.value[index].closable !== false) {
                    selectedValueRef.value.splice(index, 1);
                }
                else {
                    node.setSelected(true);
                    message.warn('默认值禁止删除');
                }
            }
            else {
                index !== -1 && selectedValueRef.value.splice(index, 1);
            }
        }
        // context.emit('update:value', selectedValueRef.value);
    };
    const onClose = (nodeId) => {
        // 表格取消选择
        const node = gridRef.value.gridApi.getRowNode(nodeId);
        node && node.setSelected(false);
        // context.emit('update:value', selectedValueRef.value);
    };
    // 提交
    const handleOk = () => {
        context.emit('submit', selectedValueRef.value);
        visibleRef.value = false;
    };
    return {
        gridDefs,
        columnDefs,
        onRowSelected,
        selectedValueRef,
        onClose,
        gridRef,
        visibleRef,
        indexField,
        onRowDataChanged,
        handleOk,
    };
};

/**
 * @description 输入内容的校验
 * @param value 需要校验的数值
 * @param option 配置需要校验的参数
 */
const writingFormat = (value, option) => {
    const wOption = Object.assign({
        decimals: 0,
        isNegative: true,
    }, option);
    value = String(value);
    let newValue;
    if (wOption.alphabet) {
        if (wOption.alphabet === 'lower') {
            // 只支持输入数字和小写字母
            newValue = value.replace(/[^a-z0-9]/g, '');
        }
        else if (wOption.alphabet === 'upper') {
            // 只支持输入数字和大写字母
            newValue = value.replace(/[^A-Z0-9]/g, '');
        }
        else {
            // 只能输入数字和字母（大小写字母）
            newValue = value.replace(/[\W]/g, '');
        }
    }
    else {
        // 支持输入数字
        newValue = value.replace(/[^\d.-]/g, '');
        // 是否支持负数
        if (wOption.isNegative) {
            newValue = newValue.replace(/-{2,}/g, '-').replace(/-\./g, '-');
            // 负号在不能数字之后
            if (newValue.indexOf('-') > 0) {
                newValue = newValue.replace(/-/g, '');
            }
            // 负号匹配
            newValue = newValue
                .replace('-', '$#$')
                .replace(/-/g, '')
                .replace('$#$', '-');
        }
        else {
            newValue = newValue.replace(/-/g, '');
        }
        // 小数点匹配
        if (wOption.decimals === 0) {
            newValue = newValue.replace(/\./g, '');
        }
        else {
            // 1. .replace('.', '$#$')把字符'.'替换成'$#$', 因为replace对于字符串只匹配一次, 所以只会替换第一个'.'
            // 2. .replace(/\./g, "")把其余的字符'.'替换为空字符串(删除)
            // 3. .replace("$#$", ".") 把字符'$#$'替换回原来的'.'
            newValue = newValue
                .replace(/\.{2,}/g, '.')
                .replace('.', '$#$')
                .replace(/\./g, '')
                .replace('$#$', '.');
            if (newValue.indexOf('.') != -1) {
                const len = newValue.split('.')[1].length;
                if (len > wOption.decimals) {
                    newValue = newValue.substring(0, newValue.length - (len - wOption.decimals));
                }
            }
        }
    }
    return newValue;
};

function cached(fn) {
    const cache = Object.create(null);
    return function cachedFn(str) {
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
const regex = /-(\w)/g;
const camelize = cached((str) => str.replace(regex, (_, c) => (c ? c.toUpperCase() : '')));
function removeNode(node) {
    if (node.parentElement !== null) {
        node.parentElement.removeChild(node);
    }
}
function insertNodeAt(fatherNode, node, position) {
    const refNode = position === 0
        ? fatherNode.children[0]
        : fatherNode.children[position - 1].nextSibling;
    fatherNode.insertBefore(node, refNode);
}
// 默认宽度转换
const BaseWidth = 1920; // 基准宽度
const transferWidth = (originWidth) => {
    if (window.innerWidth > BaseWidth)
        return (window.innerWidth / BaseWidth) * originWidth;
    return originWidth;
};

const listeners = {};
const eventBus = {
    on(key, handler) {
        listeners[key] = handler;
    },
    trigger: (key, e) => {
        const handler = listeners[key];
        if (handler) {
            handler(e);
        }
    },
    off(key) {
        delete listeners[key];
    },
};

const bytesLength = (str) => {
  let count = str.length;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    if (char >= 65 && char <= 90) {
      count += 0.15;
    } else if (char > 255) {
      count++;
    }
  }
  return count;
};

const deepLoop = function(arr, headerGroup = 0) {
  if (arr && Array.isArray(arr)) {
    arr.forEach((e) => {
      if (e.children) {
        this.deepLoop(e.children);
      } else {
        // 默认宽度属性
        if (e.headerName) {
          // 序号列
          if (e.headerName === '序号') {
            e.resizable = false;
            e.suppressMenu = true;
            e.suppressColumnsToolPanel = true;
            e.type = 'centerAligned';
            if (!e.width) e.width = e.minWidth = e.maxWidth = 50;
            // 序号自动自增
            if (!e.field) {
              e.field = '_nos';
              e.valueFormatter = incrementFormatter;
            }
            e.cellRendererFramework = 'CustomIndex';
            e.cellRendererParams = {
              ...e.cellRendererParams,
              tip: e.tip,
            };
          }
          // 操作列 居中
          if (e.headerName === '操作') {
            // 头部居中
            e.headerClass = (e.headerClass || '') + ' ag-header-align-center';
          }
          if (!e.width) e.width = bytesLength(e.headerName) * 6 + 40;
        } else if (e.checkboxSelection) {
          // 多选框列默认属性
          e.resizable = false;
          e.suppressMenu = true;
          e.suppressColumnsToolPanel = true;
          e.width = e.minWidth = e.maxWidth = 42;
          e.hideCheckbox !== true &&
            typeof e.cellClass !== 'function' &&
            (e.cellClass = (e.cellClass || '') + ' sc-show-disabled-checkbox');
        }
        // 列权限
        if (e.disabled) {
          e.suppressColumnsToolPanel = true;
          e.hide = true;
        }

        if (e.dataType) {
          // 数字格式化
          switch (e.dataType) {
            case 'number':
              if (!e.valueFormatter)
                e.valueFormatter = numberFormatter;
              if (!e.type) e.type = 'rightAligned';
              if (!e.cellStyle) e.cellStyle = numberCellStyle;
              break;
            case 'money':
              if (!e.valueFormatter)
                e.valueFormatter = currencyFormatter;
              if (!e.type) e.type = 'rightAligned';
              break;
            case 'symbolMoney':
              if (!e.valueFormatter)
                e.valueFormatter = (params) =>
                  currencyFormatter(params, true);
              if (!e.type) e.type = 'rightAligned';
              if (!e.cellStyle) e.cellStyle = currencyCellStyle;
              break;
            case 'float':
              if (!e.valueFormatter)
                e.valueFormatter = floatFormatter;
              if (!e.type) e.type = 'rightAligned';
              break;
            case 'percent':
              if (!e.valueFormatter)
                e.valueFormatter = percentFormatter;
              if (!e.type) e.type = 'rightAligned';
              break;
            case 'percentInt':
              if (!e.valueFormatter)
                e.valueFormatter = percentIntFormatter;
              if (!e.type) e.type = 'rightAligned';
              break;
            case 'date':
              if (!e.type) e.type = 'centerAligned';
              if (e.width < 95) e.width = 95;
              break;
            case 'dateTime':
              if (!e.type) e.type = 'centerAligned';
              if (e.width < 130) e.width = 130;
              break;
            case 'no':
              if (!e.width < 170) e.width = 170;
              break;
            case 'title':
              if (!e.width < 210) e.width = 210;
              break;
            case 'text':
              if (!e.width < 220) e.width = 220;
              // tips 提示
              !e.cellRendererFramework &&
                ((e.cellRendererFramework = 'CellCommonRenderer'),
                (e.cellRendererParams = {
                  props: {
                    type: 'textCopy',
                    tipPlacement: 'topLeft',
                    hideCopy: () => true,
                    hideTip: ({ value }) => !value,
                    text: ({ value }) => value || '-',
                    title: ({ value }) => value,
                  },
                }));
              break;
            case 'enmu':
              if (!e.valueFormatter)
                e.valueFormatter = numberFormatter;
              if (!e.type) e.type = 'centerAligned';
              break;
            case 'image':
              if (!e.width < 150) e.width = 150;
              // tips 提示
              !e.cellRendererFramework &&
                ((e.cellRendererFramework = 'CellCommonRenderer'),
                (e.cellRendererParams = { props: { type: 'image' } }));
              break;
            default:
              if (!e.valueFormatter && e.field)
                e.valueFormatter = textFormatter;
              if (!e.type) e.type = 'leftAligned';
          }
        }
        if (e.dataGetter) {
          // 枚举或取值
          switch (e.dataGetter) {
            case 'hundred':
              if (!e.valueGetter) e.valueGetter = percentValueGetter;
              break;
          }
        }
        // 默认按文本格式化
        if (!e.valueFormatter && e.field)
          e.valueFormatter = textFormatter;
        // 表头组模式类名,三层表头，双层表头还
        if (headerGroup > 0) {
          const sand = headerGroup === 3 ? 'sandwich' : '';
          e.headerClass = (e.headerClass || '') + ' group-header ' + sand;
        }
        if (e.type === 'centerAligned') {
          // 头部居中
          e.headerClass = (e.headerClass || '') + ' ag-header-align-center';
          // 居中对齐默认类名
          if (typeof e.cellClass !== 'function')
            e.cellClass = (e.cellClass || '') + ' ag-cell-align-center';
        }
        if (e.type === 'rightAligned') {
          // 头部居右
          e.headerClass = (e.headerClass || '') + ' ag-right-aligned-header';
        }
        if (e.editable && typeof e.editable === 'function') {
          const cellClass = e.cellClass;
          e.cellClass = (params) => {
            const rawClass =
              typeof cellClass === 'function' ? cellClass(params) : cellClass;
            const editClass = e.editable(params)
              ? 'sc-fill-cell sc-edit-cell'
              : '';
            return [
              rawClass,
              editClass,
              e.type === 'rightAligned' ? 'ag-right-aligned-cell' : '',
            ].join(' ');
          };
          // 编辑单元格样式
        } else if (e.editable && typeof e.cellClass !== 'function') {
          e.cellClass = (e.cellClass || '') + ' sc-fill-cell sc-edit-cell';
          // 貌似ag-grid 有丢失对齐方式的bug, 所以自己补上类名
          e.type === 'rightAligned' &&
            (e.cellClass = e.cellClass + ' ag-right-aligned-cell');
        }
        // 固定列-不自适应宽度
        if (e.pinned && e.suppressSizeToFit === undefined) {
          e.suppressSizeToFit = true;
        }
        // 前端搜索
        if (e.searchable) {
          e.filter = 'agTextColumnFilter';
          e.filterParams = {
            buttons: ['apply', 'cancel'],
            closeOnApply: true, // 点击buttons后关闭菜单
          };
          e.headerComponent = 'CustomHeader';
          e.headerComponentParams = { filterIcon: 'search' };
          e.width += 24;
        }
        // 前端过滤
        if (e.filterable) {
          e.filter = 'agSetColumnFilter';
          e.filterParams = {
            buttons: ['apply', 'cancel'],
            closeOnApply: true,
          };
          e.headerComponent = 'CustomHeader';
          e.width += 24;
        }
        // 前端排序
        if (e.sortable && e.unSortIcon === undefined) {
          e.unSortIcon = true;
          e.width += 24;
        }

        // 后端排序属性
        if (e.backendSorting) {
          e.headerComponent = 'CustomHeader';
          e.headerComponentParams = {
            ...e.headerComponentParams,
            backendSorting: e.backendSorting,
          };
          e.sortable = true;
          e.unSortIcon = true;
          delete e.backendSorting;
          e.width += 24;
        }
        // 自定义表头组件-排序方法
        if (e.onBackendSorting && typeof e.onBackendSorting === 'function') {
          e.headerComponent = 'CustomHeader';
          e.headerComponentParams = {
            ...e.headerComponentParams,
            onBackendSorting: e.onBackendSorting,
          };
          e.sortable = true;
          e.unSortIcon = true;
          delete e.onBackendSorting;
        }
        // 自定义后端过滤
        if (e.backendFilting) {
          e.headerComponent = 'CustomHeader';
          !e.filter && (e.filter = 'CustomFiter');
          e.headerComponentParams = {
            ...e.headerComponentParams,
            backendFilting: e.backendFilting,
          };
          delete e.backendFilting;
          e.width += 24;
        }
        // 下拉过滤器
        if (e.filter === 'agSetColumnFilter') {
          e.filterParams = {
            buttons: ['apply', 'cancel'],
            closeOnApply: true, // 点击buttons后关闭菜单
            ...e.filterParams,
          };
        }
        if (e.width) e.width = transferWidth(e.width);
        // 列合并
        if (e.rowSpan && typeof e.rowSpan === 'function') {
          let originCellClass;
          if (e.cellClass) originCellClass = e.cellClass;
          e.cellClass = (params) => {
            const originCellClasses = originCellClass
              ? originCellClass(params)
              : '';
            return (
              originCellClasses +
              (e.rowSpan(params) > 1
                ? ' cell-row-span cell-row-span-' + params.data.rowSpan
                : '')
            );
          };
        }
      }
    });
  }
};

const onBackendSorting = function(sort, field) {
  const sortMap = { desc: true, asc: false, null: undefined }; // null 为 undefined
  const sortTagMap = { desc: '降序', asc: '升序', null: '' };
  const setKeywords = this.parent.$parent.setKeywords;
  setKeywords({
    keywords: {
      orderByColumn: sort ? field : undefined,
      orderType: sortMap[sort],
    },
    tags: {
      [field]: sortTagMap[sort] || '',
    },
  });
};

const onBackendFilting = function(data) {
  const setKeywords = this.parent.$parent.setKeywords;
  setKeywords(data);
};

const getTag = (params) => {
  let tag;
  if (typeof params.value === 'boolean') {
    if (params.column.colDef?.cellRendererParams?.props?.text) {
      tag = params?.column.colDef?.cellRendererParams?.props?.text?.(
        params.node,
      );
    } else if (params.column.colDef?.valueFormatter) {
      tag = params.column.colDef?.valueFormatter?.(params.node);
    }
  }
  tag = tag ?? params.value;
  return typeof tag === 'string' ? tag.trim() : tag;
};

const getValue = (params, searchId) => {
  const value = params.node.data[searchId];
  return typeof value === 'string'
    ? value.trim()
    : typeof value === 'boolean'
    ? value + ''
    : value;
};

const getContextMenuItems = function(params, relationSearchId) {
  console.log(params);
  const columnList = params.columnApi.columnModel.primaryColumns;

  let buttonGroup = columnList?.find(
    (item) => item?.colDef.headerName === '操作',
  )?.colDef?.cellRendererParams?.props?.moreBtnList;
  const flatButtonGroup = buttonGroup.flat();

  const customMenu = [];
  flatButtonGroup?.forEach((item) => {
    if (!item.show || item.show(params?.node)) {
      customMenu.push({
        name: item.btnText,
        action: () => {
          item.click(null, params?.node);
        },
        icon: item.iconCode ? `<i class="iconfont">${item.iconCode}</i>` : '',
      });
    }
  });

  const setKeywords = this.setKeywords;
  const colDef = params.column?.colDef;

  const filter =
    colDef?.contentMenus && colDef?.contentMenus?.includes('filter')
      ? [
          {
            name: '筛选: <strong>(' + params.value + ')</strong>',
            action: function() {
              setKeywords({
                keywords: {
                  [colDef.filterField || colDef.field]:
                    typeof params.value === 'string'
                      ? params.value?.trim()
                      : params.value,
                },
                tags: {
                  [colDef.filterField || colDef.field]: getTag(params),
                },
              });
            },
            cssClasses: ['redFont'],
          },
          'separator',
        ]
      : [];

  const defaultMenus =
    colDef?.contentMenus === false
      ? []
      : [...filter, ...['copy', 'copyWithHeaders', 'paste']];
  if (customMenu?.length) {
    customMenu.push('separator');
  }

  const searchId =
    colDef.searchId === null
      ? colDef.searchId
      : colDef.searchId || colDef.filterField || colDef.field;
  let obj;
  if (searchId) {
    obj = {
      keywords: {
        [searchId]: getValue(params, searchId),
      },
      tags: {
        [searchId]: getTag(params),
      },
      key: searchId,
    };
  }
  // else {
  //   obj = {
  //     keywords: {
  //       [colDef.filterField || colDef.field]:
  //         typeof params.value === 'string'
  //           ? params.value?.trim()
  //           : params.value,
  //     },
  //     tags: {
  //       [colDef.filterField || colDef.field]: getTag(params),
  //     },
  //     key: colDef.filterField || colDef.field,
  //   };
  // }
  let menu;
  if (params.value !== undefined && relationSearchId && searchId !== null) {
    return customMenu
      .concat(defaultMenus)
      .concat('separator')
      .concat({
        name: `搜索(以选中值为搜索条件)`,
        action: () => {
          eventBus.trigger(`search:${relationSearchId}`, obj);
        },
        icon: '<i class="iconfont">&#xe61a;</i>',
      });
  } else {
    menu = customMenu.concat(defaultMenus);
  }
  return menu;
};
const getMainMenuItems = function() {
  return [
    'pinSubMenu',
    'separator',
    'autoSizeThis',
    'autoSizeAll',
    'separator',
    'resetColumns',
  ];
};

const resetPinnedHeaderWidth = function(pinnedTimerCount = 0) {
  // 修复固定列头部宽度bug补丁
  this.$nextTick(() => {
    const painedTimerId = setInterval(() => {
      this.painedTimerIds.add(painedTimerId);
      if (pinnedTimerCount++ > 20)
        [...this.painedTimerIds].map((id) => clearInterval(id));
      const pinned = this.$el.querySelector('.ag-pinned-right-header');
      if (pinned && pinned.style) {
        const width = pinned.firstChild.style.width;
        pinned.style.width !== width &&
          [...this.painedTimerIds].map((id) => clearInterval(id));
        pinned.style.width = width;
        pinned.style.minWidth = width;
        pinned.style.maxWidth = width;
      }
    }, 20);
  });
};

const resetColsWidth = function(isLessCol = false) {
  const cols = this.gridColumnApi.getColumnState();
  cols.filter((col) => !col.hide && col.pinned !== 'left').length > 4;
  // 少列表格，自动列宽度
  // if (toFit && isLessCol) this.gridApi.sizeColumnsToFit();
  // 极少列表格，重置右侧固定列
  const rightPinnedCols = cols
    .filter((col) => col.pinned === 'right')
    .map((col) => col.colId);

  if (isLessCol) {
    if (rightPinnedCols.length > 0) {
      this.gridColumnApi.setColumnsPinned(this.rightPinnedCols, null);
    }
  } else {
    // 恢复右侧固定列
    if (rightPinnedCols.length === 0) {
      this.gridColumnApi.setColumnsPinned(this.rightPinnedCols, 'right');
    }
    rightPinnedCols.splice(0);
  }
  return rightPinnedCols;
};

// 获取初始后端合计行数据
const initTotalRowData = function(
  cols,
  total,
  isFullRow = '',
  rowData = null,
) {
  if (!total) {
    // 有rowData  前端合计初始数据, 一行不展示合计
    if (rowData && rowData.length > 1) {
      const totalTitleCol = cols.find((e) => e.totalTitle);
      const totalTitle = totalTitleCol
        ? { [totalTitleCol.field]: totalTitleCol.totalTitle }
        : {};
      total = totalTitle;
      const totalFields = cols
        .filter((e) => e.isTotal)
        .map((e) => e.field || '');
      totalFields.map((k) => (total[k] = 0));
      rowData.map((d) => {
        totalFields.map((k) => {
          k && d[k] && (total[k] += parseFloat(d[k]) || 0);
        });
      });
      isFullRow && (total[isFullRow] = false);
      return [total];
    }
    return [];
  }
  // 有total 后端数据或缓存数据
  isFullRow && (total[isFullRow] = false);
  return [total];
};

// 计算合计行数据
const getTotalRowData = function(
  cols,
  selectedData,
  total,
  isFullRow = '',
) {
  const totalTitleCol = cols.find((e) => e.totalTitle);
  const totalTitle = totalTitleCol
    ? { [totalTitleCol.field]: totalTitleCol.totalTitle }
    : {};
  if (selectedData.length <= 1) {
    if (!total) return [];
    isFullRow && (total[isFullRow] = false);
    return [total];
  } else {
    total = totalTitle;
    isFullRow && (total[isFullRow] = false);
    const totalFields = cols.filter((e) => e.isTotal).map((e) => e.field || '');
    totalFields.map((k) => (total[k] = 0));
    selectedData.map((d) => {
      totalFields.map((k) => {
        k && d[k] && (total[k] += parseFloat(d[k]) || 0);
      });
    });
    return [total];
  }
};

// 初始化列权限
const initShowCols = function(cols, data, state) {
  // 行数据第一行，字段数量少于4(未获取到行数据)退出
  data = data[0] || {};
  if (Object.keys(data).length < 2) return;
  // 配置禁用的列
  const fields = cols.filter((e) => e.disabled).map((e) => e.field) || [];
  // 实际数据与状态数据是否有差异
  let isChange = false;
  fields.map((e) => {
    const hide = data[e] === undefined;
    const index = state.findIndex((d) => d.colId === e);
    if (index > -1 && hide !== state[index].hide) {
      state[index].hide = hide;
      isChange = true;
    }
  });
  // 仅有不一致数据时返回
  if (isChange) return state;
};

// ag-gird控制剪贴板复制回调
const sendToClipboard = window.navigator.clipboard
  ? function(params) {
      if (params.data) {
        // 去除空白行数据
        const newClipText = params.data
          .replace(/\n\s*\n/g, '\n')
          .replace(/^\s*\n|\n\s*$/g, '')
          .replace(/^ *| *$/gm, '');
        // 更新剪贴板数据g
        window.navigator.clipboard.writeText &&
          window.navigator.clipboard.writeText(newClipText);
      }
    }
  : null;

const mergeColumnState = (oldState, newColumnDefs) => {
  const oldSet = new Set(oldState.map((s) => s.colId));
  const diffDefs = [];
  newColumnDefs.forEach((column, index) => {
    if (!oldSet.has(column.field)) {
      diffDefs.push({
        index,
        column,
      });
    }
  });
  const defaultState = {
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
  };
  if (diffDefs.length > 0) {
    for (let i = diffDefs.length - 1; i >= 0; i--) {
      const { index, column } = diffDefs[i];
      const state = {
        ...defaultState,
        colId: column.field,
        pinned: column.pinned,
        width: column.width,
      };
      oldState.splice(index, 0, state);
    }
  }
};

// 图片路径
const ImgCheckWarning =
  'data:image/jpg;base64,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';

var script$1n = defineComponent({
    name: 'CellPopconfirm',
    components: {
        Table,
        Tooltip,
        Popconfirm: script$1o,
    },
    props: {
        cellParams: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        const visibleRef = ref(false);
        // 显示下架信息
        const showVisibleRef = (ev) => {
            visibleRef.value = true;
            ev.stopPropagation();
        };
        // 上架
        const showEditShelfModal = ref(false);
        const shopModelIds = ref([]);
        const toAddShelf = (id) => {
            showEditShelfModal.value = true;
            shopModelIds.value.splice(0);
            shopModelIds.value.push(id);
        };
        // 挂载到纠错弹框中,避免触发关闭纠错弹框事件
        const getContainer = () => {
            return document.getElementsByClassName('mistake-table')[0];
        };
        // 上架成功
        const addShelfSuccess = (params) => {
            emit('addShelfSuccess', params);
        };
        const params = reactive(props.cellParams);
        // tooltips - 显示隐藏的回调
        const handleTipVisibleChange = (visible) => {
            params.tooltip.visibleChange &&
                params.tooltip.visibleChange(visible, params);
        };
        // table - 列表数据
        const dataSource = reactive([]);
        //  table - rowKey
        const getRowKey = (record, index) => {
            return index;
        };
        // 加载动画
        const loading = ref(false);
        // Popconfirm - 显示隐藏的回调
        const handlePopconfirmVisible = (visible) => {
            loading.value = true;
            if (visible && params.props.dataSource) {
                (async () => {
                    const data = await params.props.dataSource(params);
                    dataSource.splice(0);
                    dataSource.push(...data);
                    loading.value = false;
                })();
            }
            params.props.visibleChange && params.props.visibleChange(visible, params);
        };
        // 提示内容
        const valueGetter = () => {
            return ((params.tooltip.valueGetter && params.tooltip.valueGetter(params)) || []);
        };
        return {
            visibleRef,
            showEditShelfModal,
            shopModelIds,
            ImgCheckWarning,
            dataSource,
            loading,
            showVisibleRef,
            toAddShelf,
            getContainer,
            addShelfSuccess,
            handleTipVisibleChange,
            handlePopconfirmVisible,
            getRowKey,
            valueGetter,
        };
    },
});

const _hoisted_1$15 = { class: "sc-popconfirm-cell" };
const _hoisted_2$S = ["innerHTML"];
const _hoisted_3$I = { class: "validate-tips-box warn-tips-box" };
const _hoisted_4$z = ["innerHTML"];
const _hoisted_5$r = ["onClick"];
const _hoisted_6$l = { key: 1 };
const _hoisted_7$j = ["src"];
const _hoisted_8$i = ["innerHTML"];
const _hoisted_9$h = ["innerHTML"];
const _hoisted_10$e = { class: "sc-popconfirm-content off-shelf-info" };
const _hoisted_11$e = {
  key: 0,
  class: "sc-channel sc-channel-spot"
};
const _hoisted_12$d = {
  key: 1,
  class: "sc-channel sc-channel-adjust"
};
const _hoisted_13$9 = {
  key: 2,
  class: "sc-channel sc-channel-future"
};
const _hoisted_14$a = { class: "sc-popconfirm-content sales-area-info" };
const _hoisted_15$a = { class: "validate-tips-box default-tips-box" };
const _hoisted_16$a = ["innerHTML"];
const _hoisted_17$8 = ["onClick"];
const _hoisted_18$6 = { key: 1 };
const _hoisted_19$6 = { key: 1 };
const _hoisted_20$4 = { class: "validate-tips-box warn-tips-box" };
const _hoisted_21$2 = ["innerHTML"];
const _hoisted_22$2 = ["onClick"];
const _hoisted_23$2 = { key: 1 };
const _hoisted_24$2 = ["src"];

function render$1g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_Table = resolveComponent("Table");
  const _component_Popconfirm = resolveComponent("Popconfirm");

  return (openBlock(), createElementBlock("span", _hoisted_1$15, [
    createCommentVNode(" 下架 "),
    (_ctx.cellParams.props.offShelfPop)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createCommentVNode(" 已上架 "),
          (_ctx.cellParams.props.onShelf && _ctx.cellParams.props.onShelf(_ctx.cellParams))
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                innerHTML: 
          _ctx.cellParams.props.text
            ? _ctx.cellParams.props.text(_ctx.cellParams)
            : _ctx.cellParams.value
        
              }, null, 8 /* PROPS */, _hoisted_2$S))
            : (
          _ctx.cellParams.tooltip &&
            _ctx.cellParams.tooltip.isWarn &&
            _ctx.cellParams.tooltip.isWarn(_ctx.cellParams)
        )
              ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createCommentVNode(" 现货/调仓库存不足，期货下架 "),
                  createElementVNode("span", null, [
                    createVNode(_component_Tooltip, mergeProps({
                      placement: _ctx.cellParams.tooltip.warnPlacement || 'top',
                      overlayClassName: "sc-tooltip-light",
                      onVisibleChange: _ctx.handleTipVisibleChange
                    }, { ..._ctx.cellParams.tooltip.props }), {
                      title: withCtx(() => [
                        createElementVNode("div", _hoisted_3$I, [
                          (_ctx.cellParams.tooltip.warnTitle)
                            ? (openBlock(), createElementBlock("p", {
                                key: 0,
                                innerHTML: 
                  typeof _ctx.cellParams.tooltip.warnTitle == 'string'
                    ? _ctx.cellParams.tooltip.warnTitle
                    : _ctx.cellParams.tooltip.warnTitle(_ctx.cellParams)
                
                              }, null, 8 /* PROPS */, _hoisted_4$z))
                            : createCommentVNode("v-if", true),
                          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.valueGetter(), (item, index) => {
                            return (openBlock(), createElementBlock("p", { key: index }, [
                              createElementVNode("label", null, toDisplayString(item.label) + ":", 1 /* TEXT */),
                              (!!item.value)
                                ? (openBlock(), createElementBlock("span", {
                                    key: 0,
                                    class: normalizeClass(
                    `validate-value validate-value-${_ctx.cellParams.tooltip
                      .valueAlign || 'left'}`
                  )
                                  }, [
                                    createTextVNode(toDisplayString(item.value) + " ", 1 /* TEXT */),
                                    (!item.hideBtn)
                                      ? (openBlock(), createElementBlock("a", {
                                          key: 0,
                                          onClick: $event => (
                      _ctx.cellParams.tooltip.useTipsValue(item.value, _ctx.cellParams)
                    )
                                        }, " 使用 ", 8 /* PROPS */, _hoisted_5$r))
                                      : createCommentVNode("v-if", true)
                                  ], 2 /* CLASS */))
                                : (openBlock(), createElementBlock("span", _hoisted_6$l, "-"))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      default: withCtx(() => [
                        createElementVNode("img", {
                          width: "18",
                          class: normalizeClass(
              `warn-tooltip-img warn-align-${_ctx.cellParams.tooltip.align ||
                'left'}`
            ),
                          src: _ctx.ImgCheckWarning
                        }, null, 10 /* CLASS, PROPS */, _hoisted_7$j)
                      ]),
                      _: 1 /* STABLE */
                    }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"]),
                    createElementVNode("span", {
                      innerHTML: 
            _ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value
          
                    }, null, 8 /* PROPS */, _hoisted_8$i)
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                  createCommentVNode(" 型号下架、现货/调仓没有库存且期货下架 "),
                  createElementVNode("span", null, [
                    createElementVNode("span", {
                      innerHTML: 
            _ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value
          
                    }, null, 8 /* PROPS */, _hoisted_9$h),
                    createVNode(_component_Popconfirm, {
                      placement: "bottomLeft",
                      overlayClassName: 'sc-grid-popconfirm',
                      overlayStyle: 
            Object.assign(
              { width: '400px' },
              _ctx.cellParams.props.overlayStyle || {},
            )
          ,
                      visible: _ctx.visibleRef,
                      "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visibleRef) = $event)),
                      "arrow-point-at-center": false,
                      popTitle: _ctx.cellParams.props.popTitle || '下架信息',
                      hideCancel: true,
                      popConfirm: 
            () => {
              _ctx.cellParams.props.toAddShelf(_ctx.cellParams.data.shopModelId);
            }
          ,
                      okText: "去上架",
                      onVisibleChange: _ctx.handlePopconfirmVisible
                    }, {
                      content: withCtx(() => [
                        createElementVNode("div", _hoisted_10$e, [
                          createVNode(_component_Table, mergeProps({
                            dataSource: _ctx.dataSource,
                            columns: _ctx.cellParams.props.columns(_ctx.cellParams),
                            pagination: false,
                            rowKey: _ctx.getRowKey,
                            bordered: "",
                            loading: _ctx.loading
                          }, { ..._ctx.cellParams.props.tableConfig }), {
                            channel: withCtx(({ record }) => [
                              (record.channelId == 1)
                                ? (openBlock(), createElementBlock("span", _hoisted_11$e, "现货"))
                                : (record.channelId == 2)
                                  ? (openBlock(), createElementBlock("span", _hoisted_12$d, "调仓"))
                                  : (record.channelId == 3)
                                    ? (openBlock(), createElementBlock("span", _hoisted_13$9, "期货"))
                                    : createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          }, 16 /* FULL_PROPS */, ["dataSource", "columns", "rowKey", "loading"])
                        ])
                      ]),
                      trigger: withCtx(() => [
                        createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showVisibleRef && _ctx.showVisibleRef(...args))),
                          style: {"margin-left":"5px"}
                        }, "查看")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["overlayStyle", "visible", "popTitle", "popConfirm", "onVisibleChange"])
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.cellParams.props.salesAreaPop)
        ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createCommentVNode(" 限区 "),
            (_ctx.cellParams.props.salesArea(_ctx.cellParams))
              ? (openBlock(), createBlock(_component_Popconfirm, {
                  key: 0,
                  placement: "bottomLeft",
                  overlayClassName: 'sc-grid-popconfirm',
                  overlayStyle: 
          Object.assign({ width: '450px' }, _ctx.cellParams.props.overlayStyle || {})
        ,
                  visible: _ctx.visibleRef,
                  "onUpdate:visible": _cache[3] || (_cache[3] = $event => ((_ctx.visibleRef) = $event)),
                  "arrow-point-at-center": false,
                  hideBtn: true,
                  popTitle: 
          `<a class='sc-product-brand' 
          style='color: ${_ctx.cellParams.data.brandColor};border-color: ${
            _ctx.cellParams.data.brandColor
          };'
          >
            ${_ctx.cellParams.data.brandName || '-'}
          </a>
          ${_ctx.cellParams.data.seriesName || '-'} 限区政策`
        ,
                  onVisibleChange: _ctx.handlePopconfirmVisible,
                  trigger: "hover"
                }, {
                  content: withCtx(() => [
                    createElementVNode("div", _hoisted_14$a, [
                      createVNode(_component_Table, mergeProps({
                        dataSource: _ctx.dataSource,
                        columns: _ctx.cellParams.props.columns(_ctx.cellParams),
                        pagination: false,
                        rowKey: _ctx.getRowKey,
                        bordered: "",
                        scroll: { y: _ctx.dataSource.length <= 10 ? false : 300 },
                        loading: _ctx.loading
                      }, { ..._ctx.cellParams.props.tableConfig }), null, 16 /* FULL_PROPS */, ["dataSource", "columns", "rowKey", "scroll", "loading"])
                    ])
                  ]),
                  trigger: withCtx(() => [
                    createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.showVisibleRef && _ctx.showVisibleRef(...args))),
                      class: "sales-area-trigger"
                    }, toDisplayString(_ctx.cellParams.props.salesAreaText || '[限区]'), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["overlayStyle", "visible", "popTitle", "onVisibleChange"]))
              : createCommentVNode("v-if", true),
            createElementVNode("span", null, toDisplayString(_ctx.cellParams.props.text
          ? _ctx.cellParams.props.text(_ctx.cellParams)
          : _ctx.cellParams.value), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.cellParams.props.warningPop)
          ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createCommentVNode(" 添加警告提示 "),
              (
          _ctx.cellParams.props.showTip ||
            (_ctx.cellParams.props.onShowTip &&
              _ctx.cellParams.props.onShowTip(_ctx.cellParams))
        )
                ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
                    key: 0,
                    placement: _ctx.cellParams.tooltip.placement || 'right',
                    overlayClassName: "sc-tooltip-light",
                    onVisibleChange: _ctx.handleTipVisibleChange
                  }, { ..._ctx.cellParams.tooltip.props }), {
                    title: withCtx(() => [
                      createElementVNode("div", _hoisted_15$a, [
                        (
                _ctx.cellParams.tooltip.title ||
                  (_ctx.cellParams.tooltip.titleGetter &&
                    _ctx.cellParams.tooltip.titleGetter(_ctx.cellParams))
              )
                          ? (openBlock(), createElementBlock("p", {
                              key: 0,
                              innerHTML: 
                _ctx.cellParams.tooltip.title ||
                  (_ctx.cellParams.tooltip.titleGetter &&
                    _ctx.cellParams.tooltip.titleGetter(_ctx.cellParams))
              
                            }, null, 8 /* PROPS */, _hoisted_16$a))
                          : createCommentVNode("v-if", true),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.valueGetter(), (item, index) => {
                          return (openBlock(), createElementBlock("p", { key: index }, [
                            createElementVNode("label", null, toDisplayString(item.label) + ":", 1 /* TEXT */),
                            (!!item.value)
                              ? (openBlock(), createElementBlock("span", {
                                  key: 0,
                                  class: normalizeClass(
                  `validate-value validate-value-${_ctx.cellParams.tooltip
                    .valueAlign || 'left'}`
                )
                                }, [
                                  createTextVNode(toDisplayString(item.value) + " ", 1 /* TEXT */),
                                  (!item.hideBtn)
                                    ? (openBlock(), createElementBlock("a", {
                                        key: 0,
                                        onClick: $event => (
                    _ctx.cellParams.tooltip.useTipsValue(item.value, _ctx.cellParams)
                  )
                                      }, toDisplayString(item.btnText || '使用'), 9 /* TEXT, PROPS */, _hoisted_17$8))
                                    : createCommentVNode("v-if", true)
                                ], 2 /* CLASS */))
                              : (openBlock(), createElementBlock("span", _hoisted_18$6, "-"))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    default: withCtx(() => [
                      createElementVNode("div", null, toDisplayString(_ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"]))
                : (openBlock(), createElementBlock("div", _hoisted_19$6, toDisplayString(_ctx.cellParams.props.text
            ? _ctx.cellParams.props.text(_ctx.cellParams)
            : _ctx.cellParams.value), 1 /* TEXT */)),
              (
          _ctx.cellParams.tooltip &&
            _ctx.cellParams.tooltip.isWarn &&
            _ctx.cellParams.tooltip.isWarn(_ctx.cellParams)
        )
                ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
                    key: 2,
                    placement: _ctx.cellParams.tooltip.warnPlacement || 'top',
                    overlayClassName: "sc-tooltip-light",
                    onVisibleChange: _ctx.handleTipVisibleChange
                  }, { ..._ctx.cellParams.tooltip.props }), {
                    title: withCtx(() => [
                      createElementVNode("div", _hoisted_20$4, [
                        (
                _ctx.cellParams.tooltip.warnTitle ||
                  (_ctx.cellParams.tooltip.warnTitleGetter &&
                    _ctx.cellParams.tooltip.warnTitleGetter(_ctx.cellParams))
              )
                          ? (openBlock(), createElementBlock("p", {
                              key: 0,
                              innerHTML: 
                _ctx.cellParams.tooltip.warnTitle ||
                  (_ctx.cellParams.tooltip.warnTitleGetter &&
                    _ctx.cellParams.tooltip.warnTitleGetter(_ctx.cellParams))
              
                            }, null, 8 /* PROPS */, _hoisted_21$2))
                          : createCommentVNode("v-if", true),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.valueGetter(), (item, index) => {
                          return (openBlock(), createElementBlock("p", { key: index }, [
                            createElementVNode("label", null, toDisplayString(item.label) + ":", 1 /* TEXT */),
                            (!!item.value)
                              ? (openBlock(), createElementBlock("span", {
                                  key: 0,
                                  class: normalizeClass(
                  `validate-value validate-value-${_ctx.cellParams.tooltip
                    .valueAlign || 'left'}`
                )
                                }, [
                                  createTextVNode(toDisplayString(item.value) + " ", 1 /* TEXT */),
                                  (!item.hideBtn)
                                    ? (openBlock(), createElementBlock("a", {
                                        key: 0,
                                        onClick: $event => (
                    _ctx.cellParams.tooltip.useTipsValue(item.value, _ctx.cellParams)
                  )
                                      }, toDisplayString(item.btnText || '使用'), 9 /* TEXT, PROPS */, _hoisted_22$2))
                                    : createCommentVNode("v-if", true)
                                ], 2 /* CLASS */))
                              : (openBlock(), createElementBlock("span", _hoisted_23$2, "-"))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    default: withCtx(() => [
                      createElementVNode("img", {
                        width: "18",
                        class: normalizeClass(
            `warn-tooltip-img warn-align-${_ctx.cellParams.tooltip.align || 'left'}`
          ),
                        src: _ctx.ImgCheckWarning
                      }, null, 10 /* CLASS, PROPS */, _hoisted_24$2)
                    ]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"]))
                : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : createCommentVNode("v-if", true)
  ]))
}

script$1n.render = render$1g;
script$1n.__file = "packages/grid/src/components/CellCommonRenderer/CellPopconfirm.vue";

var script$1m = defineComponent({
    name: 'PackSpecificationTip',
    components: {
        Tooltip,
    },
    props: {
        cellParams: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const params = reactive(props.cellParams);
        // 推荐购买数量
        const recommendCount = ref(0);
        // 显示隐藏的回调
        const handleTipVisibleChange = (visible) => {
            if (visible) {
                recommendCount.value = params.tooltip.getRecommendQuantity(params);
            }
            params.tooltip.visibleChange &&
                params.tooltip.visibleChange(visible, params);
        };
        onMounted(() => {
            params.tooltip &&
                params.tooltip.getRecommendQuantity &&
                (recommendCount.value = params.tooltip.getRecommendQuantity(params));
        });
        return {
            ImgCheckWarning,
            params,
            recommendCount,
            handleTipVisibleChange,
        };
    },
});

const _hoisted_1$14 = { class: "validate-tips-box warn-tips-box" };
const _hoisted_2$R = ["innerHTML"];
const _hoisted_3$H = /*#__PURE__*/createElementVNode("label", null, "单位包装数量：", -1 /* HOISTED */);
const _hoisted_4$y = { class: "validate-value" };
const _hoisted_5$q = /*#__PURE__*/createElementVNode("label", null, "最小起购数量：", -1 /* HOISTED */);
const _hoisted_6$k = { class: "validate-value" };
const _hoisted_7$i = /*#__PURE__*/createElementVNode("label", null, "推荐购买数量：", -1 /* HOISTED */);
const _hoisted_8$h = { class: "validate-value" };
const _hoisted_9$g = ["src"];
const _hoisted_10$d = { class: "validate-tips-box default-tips-box" };
const _hoisted_11$d = ["innerHTML"];
const _hoisted_12$c = /*#__PURE__*/createElementVNode("label", null, "单位包装数量：", -1 /* HOISTED */);
const _hoisted_13$8 = { class: "validate-value" };
const _hoisted_14$9 = /*#__PURE__*/createElementVNode("label", null, "最小起购数量：", -1 /* HOISTED */);
const _hoisted_15$9 = { class: "validate-value" };
const _hoisted_16$9 = { key: 1 };
const _hoisted_17$7 = /*#__PURE__*/createElementVNode("label", null, "推荐购买数量：", -1 /* HOISTED */);
const _hoisted_18$5 = { class: "validate-value" };
const _hoisted_19$5 = { key: 2 };

function render$1f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");

  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" 包装规格校验提示 "),
    (
      _ctx.params.tooltip && _ctx.params.tooltip.isWarn && _ctx.params.tooltip.isWarn(_ctx.params)
    )
      ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
          key: 0,
          placement: _ctx.params.tooltip.warnPlacement || 'top',
          overlayClassName: "sc-tooltip-light",
          onVisibleChange: _ctx.handleTipVisibleChange
        }, { ..._ctx.params.tooltip.props }), {
          title: withCtx(() => [
            createElementVNode("div", _hoisted_1$14, [
              (_ctx.params.tooltip.warnTitle)
                ? (openBlock(), createElementBlock("p", {
                    key: 0,
                    innerHTML: 
            typeof _ctx.params.tooltip.warnTitle == 'string'
              ? _ctx.params.tooltip.warnTitle
              : _ctx.params.tooltip.warnTitle(_ctx.params)
          
                  }, null, 8 /* PROPS */, _hoisted_2$R))
                : createCommentVNode("v-if", true),
              createElementVNode("p", null, [
                _hoisted_3$H,
                createElementVNode("span", _hoisted_4$y, toDisplayString(_ctx.params.data.leastPackCount || '-') + toDisplayString(_ctx.params.data.unit || ''), 1 /* TEXT */)
              ]),
              createElementVNode("p", null, [
                _hoisted_5$q,
                createElementVNode("span", _hoisted_6$k, toDisplayString(_ctx.params.data.leastSaleCount || '-') + toDisplayString(_ctx.params.data.unit || ''), 1 /* TEXT */)
              ]),
              createElementVNode("p", null, [
                _hoisted_7$i,
                createElementVNode("span", _hoisted_8$h, toDisplayString(_ctx.recommendCount) + toDisplayString(_ctx.params.data.unit || ''), 1 /* TEXT */),
                createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.params.tooltip.useRecommendCount(_ctx.recommendCount, _ctx.params)))
                }, " 使用 ")
              ])
            ])
          ]),
          default: withCtx(() => [
            createElementVNode("img", {
              width: "18",
              class: normalizeClass(`warn-tooltip-img warn-align-${_ctx.params.tooltip.align || 'left'}`),
              src: _ctx.ImgCheckWarning
            }, null, 10 /* CLASS, PROPS */, _hoisted_9$g)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"]))
      : createCommentVNode("v-if", true),
    (!_ctx.params.props.noCellTooltip)
      ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
          key: 1,
          placement: _ctx.params.tooltip.placement || 'right',
          overlayClassName: "sc-tooltip-light",
          onVisibleChange: _ctx.handleTipVisibleChange
        }, { ..._ctx.params.tooltip.props }), {
          title: withCtx(() => [
            createElementVNode("div", _hoisted_10$d, [
              (_ctx.params.tooltip.title)
                ? (openBlock(), createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.params.tooltip.title
                  }, null, 8 /* PROPS */, _hoisted_11$d))
                : createCommentVNode("v-if", true),
              createElementVNode("p", null, [
                _hoisted_12$c,
                createElementVNode("span", _hoisted_13$8, toDisplayString(_ctx.params.data.leastPackCount || '-') + toDisplayString(_ctx.params.data.unit || ''), 1 /* TEXT */)
              ]),
              createElementVNode("p", null, [
                _hoisted_14$9,
                createElementVNode("span", _hoisted_15$9, toDisplayString(_ctx.params.data.leastSaleCount || '-') + toDisplayString(_ctx.params.data.unit || ''), 1 /* TEXT */)
              ]),
              (_ctx.params.tooltip.getRecommendQuantity(_ctx.params) > 0)
                ? (openBlock(), createElementBlock("p", _hoisted_16$9, [
                    _hoisted_17$7,
                    createElementVNode("span", _hoisted_18$5, toDisplayString(_ctx.params.tooltip.getRecommendQuantity(_ctx.params)) + toDisplayString(_ctx.params.data.unit || ''), 1 /* TEXT */),
                    createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = $event => (
              _ctx.params.tooltip.useRecommendCount(
                _ctx.params.tooltip.getRecommendQuantity(_ctx.params),
                _ctx.params,
              )
            ))
                    }, " 使用 ")
                  ]))
                : createCommentVNode("v-if", true)
            ])
          ]),
          default: withCtx(() => [
            createElementVNode("div", null, toDisplayString(_ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"]))
      : (openBlock(), createElementBlock("div", _hoisted_19$5, toDisplayString(_ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value), 1 /* TEXT */))
  ], 64 /* STABLE_FRAGMENT */))
}

script$1m.render = render$1f;
script$1m.__file = "packages/grid/src/components/CellCommonRenderer/PackSpecificationTip.vue";

var script$1l = defineComponent({
    name: 'PriceDiscountTip',
    components: {
        Tooltip,
    },
    props: {
        cellParams: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const params = reactive(props.cellParams);
        // 提示内容
        const valueGetter = () => {
            return ((params.tooltip.valueGetter && params.tooltip.valueGetter(params)) || []);
        };
        // 显示隐藏的回调
        const handleTipVisibleChange = (visible) => {
            params.tooltip.visibleChange &&
                params.tooltip.visibleChange(visible, params);
        };
        return {
            ImgCheckWarning,
            params,
            valueGetter,
            handleTipVisibleChange,
        };
    },
});

const _hoisted_1$13 = { class: "validate-tips-box warn-tips-box" };
const _hoisted_2$Q = ["innerHTML"];
const _hoisted_3$G = ["onClick"];
const _hoisted_4$x = { key: 1 };
const _hoisted_5$p = ["src"];
const _hoisted_6$j = { class: "validate-tips-box default-tips-box" };
const _hoisted_7$h = ["innerHTML"];
const _hoisted_8$g = ["onClick"];
const _hoisted_9$f = { key: 1 };

function render$1e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");

  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" 折扣、价格校验提示 "),
    (
      _ctx.params.tooltip && _ctx.params.tooltip.isWarn && _ctx.params.tooltip.isWarn(_ctx.params)
    )
      ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
          key: 0,
          placement: _ctx.params.tooltip.warnPlacement || 'top',
          overlayClassName: "sc-tooltip-light",
          onVisibleChange: _ctx.handleTipVisibleChange
        }, { ..._ctx.params.tooltip.props }), {
          title: withCtx(() => [
            createElementVNode("div", _hoisted_1$13, [
              (_ctx.params.tooltip.warnTitle)
                ? (openBlock(), createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.params.tooltip.warnTitle
                  }, null, 8 /* PROPS */, _hoisted_2$Q))
                : createCommentVNode("v-if", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.valueGetter(), (item, index) => {
                return (openBlock(), createElementBlock("p", { key: index }, [
                  createElementVNode("label", null, toDisplayString(item.label) + ":", 1 /* TEXT */),
                  (!!item.value)
                    ? (openBlock(), createElementBlock("span", {
                        key: 0,
                        class: normalizeClass(
              `validate-value validate-value-${_ctx.params.tooltip.valueAlign ||
                'left'}`
            )
                      }, [
                        createTextVNode(toDisplayString(item.value) + " ", 1 /* TEXT */),
                        (!item.hideBtn)
                          ? (openBlock(), createElementBlock("a", {
                              key: 0,
                              onClick: $event => (_ctx.params.tooltip.useTipsValue(item.value, _ctx.params))
                            }, " 使用 ", 8 /* PROPS */, _hoisted_3$G))
                          : createCommentVNode("v-if", true)
                      ], 2 /* CLASS */))
                    : (openBlock(), createElementBlock("span", _hoisted_4$x, "-"))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          default: withCtx(() => [
            createElementVNode("img", {
              width: "18",
              class: normalizeClass(`warn-tooltip-img warn-align-${_ctx.params.tooltip.align || 'left'}`),
              src: _ctx.ImgCheckWarning
            }, null, 10 /* CLASS, PROPS */, _hoisted_5$p)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"]))
      : createCommentVNode("v-if", true),
    createVNode(_component_Tooltip, mergeProps({
      placement: _ctx.params.tooltip.placement || 'right',
      overlayClassName: "sc-tooltip-light",
      onVisibleChange: _ctx.handleTipVisibleChange
    }, { ..._ctx.params.tooltip.props }), {
      title: withCtx(() => [
        createElementVNode("div", _hoisted_6$j, [
          (_ctx.params.tooltip.title)
            ? (openBlock(), createElementBlock("p", {
                key: 0,
                innerHTML: _ctx.params.tooltip.title
              }, null, 8 /* PROPS */, _hoisted_7$h))
            : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.valueGetter(), (item, index) => {
            return (openBlock(), createElementBlock("p", { key: index }, [
              createElementVNode("label", null, toDisplayString(item.label) + ":", 1 /* TEXT */),
              (!!item.value)
                ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass(
              `validate-value validate-value-${_ctx.params.tooltip.valueAlign ||
                'left'}`
            )
                  }, [
                    createTextVNode(toDisplayString(item.value) + " ", 1 /* TEXT */),
                    (!item.hideBtn)
                      ? (openBlock(), createElementBlock("a", {
                          key: 0,
                          onClick: $event => (_ctx.params.tooltip.useTipsValue(item.value, _ctx.params))
                        }, " 使用 ", 8 /* PROPS */, _hoisted_8$g))
                      : createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : (openBlock(), createElementBlock("span", _hoisted_9$f, "-"))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      default: withCtx(() => [
        createElementVNode("div", null, toDisplayString(_ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["placement", "onVisibleChange"])
  ], 64 /* STABLE_FRAGMENT */))
}

script$1l.render = render$1e;
script$1l.__file = "packages/grid/src/components/CellCommonRenderer/PriceDiscountTip.vue";

var script$1k = defineComponent({
    name: 'CellWarehouseInfoTips',
    components: { Tooltip },
    props: {
        cellParams: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        const params = reactive(props.cellParams);
        const baseUrl = process.env.VUE_APP_URL;
        // 获取仓库信息
        const getWarehouseInfoByIdApi = (id) => {
            return http({
                url: '/inventory/warehouse/v3/get-warehouse-delivery-info',
                withCredentials: true,
                baseURL: baseUrl,
                method: 'POST',
                headers: { 'Content-Type': 'application/json;chartset=utf-8' },
                params: { id },
            }).then((res) => {
                message.destroy();
                if (res && res.data && res.data.code === 0) {
                    return res.data.data;
                }
                else {
                    message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
                }
            });
        };
        // tooltips - 显示隐藏的回调
        let getWarehouseInfoTimer;
        const handleTipVisibleChange = (visible) => {
            if (visible) {
                getWarehouseInfoTimer && clearTimeout(getWarehouseInfoTimer);
                getWarehouseInfoTimer = setTimeout(async () => {
                    const warehouseInfo = await getWarehouseInfoByIdApi(params.data.warehouseId);
                    if (warehouseInfo) {
                        warehouseInfo.showDetailInfo =
                            warehouseInfo.shipDateList &&
                                warehouseInfo.shipDateList.length > 0;
                        params.warehouseInfo = warehouseInfo;
                        params.cutOffTimeInfo = getCutOffTimeInfo(warehouseInfo);
                    }
                    else {
                        params.warehouseInfo = null;
                        params.cutOffTimeInfo = null;
                    }
                }, 100);
            }
            params.props.visibleChange && params.props.visibleChange(visible, params);
        };
        // 接单时间格式化
        const getCutOffTimeInfo = (info) => {
            const noCutOffTime = '不发货';
            const timeStrObj = {
                workdayStr: info.workdayCutOffTime
                    ? info.workdayCutOffTime + '截单'
                    : noCutOffTime,
                saturdayStr: info.saturdayCutOffTime
                    ? info.saturdayCutOffTime + '截单'
                    : noCutOffTime,
                sundayStr: info.sundayCutOffTime
                    ? info.sundayCutOffTime + '截单'
                    : noCutOffTime,
                holidayStr: info.holidayCutOffTime
                    ? info.holidayCutOffTime + '截单'
                    : noCutOffTime, // 节假日
            };
            return timeStrObj;
        };
        return {
            params,
            handleTipVisibleChange,
        };
    },
});

const _hoisted_1$12 = { class: "sc-warehouse-info-cell" };
const _hoisted_2$P = {
  key: 0,
  class: "warehouse-cutOfftime-info"
};
const _hoisted_3$F = {
  key: 0,
  class: "cutOffTime-info"
};
const _hoisted_4$w = /*#__PURE__*/createElementVNode("label", null, [
  /*#__PURE__*/createElementVNode("em", null, "工作日"),
  /*#__PURE__*/createTextVNode(":")
], -1 /* HOISTED */);
const _hoisted_5$o = /*#__PURE__*/createElementVNode("label", null, [
  /*#__PURE__*/createElementVNode("em", null, "周六"),
  /*#__PURE__*/createTextVNode(":")
], -1 /* HOISTED */);
const _hoisted_6$i = /*#__PURE__*/createElementVNode("label", null, [
  /*#__PURE__*/createElementVNode("em", null, "周日"),
  /*#__PURE__*/createTextVNode(":")
], -1 /* HOISTED */);
const _hoisted_7$g = /*#__PURE__*/createElementVNode("label", null, [
  /*#__PURE__*/createElementVNode("em", null, "节假日"),
  /*#__PURE__*/createTextVNode(":")
], -1 /* HOISTED */);
const _hoisted_8$f = {
  key: 1,
  class: "cutOffTime-info"
};
const _hoisted_9$e = { class: "warehouse-info-warn" };
const _hoisted_10$c = ["data-warehouseName", "data-channelId"];
const _hoisted_11$c = ["data-warehouseName", "data-channelId"];

function render$1d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");

  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" 发货时效信息提示 "),
    createElementVNode("span", _hoisted_1$12, [
      (
        _ctx.params.props.onShowTip
          ? _ctx.params.props.onShowTip(_ctx.params)
          : _ctx.params.data.channelId != 3
      )
        ? (openBlock(), createBlock(_component_Tooltip, {
            key: 0,
            placement: _ctx.params.props.placement || 'right',
            overlayClassName: "sc-tooltip-light",
            onVisibleChange: _ctx.handleTipVisibleChange
          }, {
            title: withCtx(() => [
              createElementVNode("div", null, [
                (_ctx.params.warehouseInfo)
                  ? (openBlock(), createElementBlock("div", _hoisted_2$P, [
                      createElementVNode("p", null, toDisplayString(_ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value) + "发货时效 ", 1 /* TEXT */),
                      (_ctx.params.warehouseInfo.showDetailInfo)
                        ? (openBlock(), createElementBlock("div", _hoisted_3$F, [
                            createElementVNode("p", null, [
                              _hoisted_4$w,
                              createElementVNode("span", null, toDisplayString(_ctx.params.cutOffTimeInfo.workdayStr), 1 /* TEXT */)
                            ]),
                            createElementVNode("p", null, [
                              _hoisted_5$o,
                              createElementVNode("span", null, toDisplayString(_ctx.params.cutOffTimeInfo.saturdayStr), 1 /* TEXT */)
                            ]),
                            createElementVNode("p", null, [
                              _hoisted_6$i,
                              createElementVNode("span", null, toDisplayString(_ctx.params.cutOffTimeInfo.sundayStr), 1 /* TEXT */)
                            ]),
                            createElementVNode("p", null, [
                              _hoisted_7$g,
                              createElementVNode("span", null, toDisplayString(_ctx.params.cutOffTimeInfo.holidayStr), 1 /* TEXT */)
                            ])
                          ]))
                        : (openBlock(), createElementBlock("div", _hoisted_8$f, [
                            createElementVNode("p", null, toDisplayString(_ctx.params.warehouseInfo.defaultShipDateReminderMessage ||
                    '暂无具体发货日期'), 1 /* TEXT */)
                          ])),
                      createElementVNode("div", _hoisted_9$e, toDisplayString(_ctx.params.warehouseInfo.remark
                  ? '提醒：' + _ctx.params.warehouseInfo.remark
                  : ''), 1 /* TEXT */)
                    ]))
                  : createCommentVNode("v-if", true)
              ])
            ]),
            default: withCtx(() => [
              createElementVNode("div", {
                class: "text-ellipsis",
                "data-warehouseName": 
          _ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value
        ,
                "data-channelId": _ctx.params.data.channelId
              }, toDisplayString(_ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value), 9 /* TEXT, PROPS */, _hoisted_10$c)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["placement", "onVisibleChange"]))
        : (openBlock(), createElementBlock("div", {
            key: 1,
            class: "text-ellipsis",
            "data-warehouseName": 
        _ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value
      ,
            "data-channelId": _ctx.params.data.channelId
          }, toDisplayString(_ctx.params.props.text ? _ctx.params.props.text(_ctx.params) : _ctx.params.value), 9 /* TEXT, PROPS */, _hoisted_11$c))
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}

script$1k.render = render$1d;
script$1k.__file = "packages/grid/src/components/CellCommonRenderer/CellWarehouseInfoTips.vue";

var script$1j = defineComponent({
    name: 'CellImages',
    components: { 'a-tooltip': Tooltip },
    props: {
        cellParams: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const placement = computed(() => props.cellParams.props.placement);
        const values = computed(() => {
            const val = props.cellParams.value;
            if (val && typeof val === 'string')
                return [val];
            return val;
        });
        return {
            placement,
            values,
        };
    },
});

const _hoisted_1$11 = { class: "sc-images-cell" };
const _hoisted_2$O = ["src"];
const _hoisted_3$E = ["src"];

function render$1c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tooltip = resolveComponent("a-tooltip");

  return (openBlock(), createElementBlock("span", _hoisted_1$11, [
    (!_ctx.values || _ctx.values.length === 0)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode("-")
        ], 64 /* STABLE_FRAGMENT */))
      : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.values, (img, index) => {
          return (openBlock(), createBlock(_component_a_tooltip, {
            key: index,
            placement: _ctx.placement,
            overlayClassName: "sc-tooltip-light"
          }, {
            title: withCtx(() => [
              createElementVNode("img", {
                width: "230",
                src: img
              }, null, 8 /* PROPS */, _hoisted_2$O)
            ]),
            default: withCtx(() => [
              createElementVNode("img", {
                height: "20",
                src: img
              }, null, 8 /* PROPS */, _hoisted_3$E)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["placement"]))
        }), 128 /* KEYED_FRAGMENT */))
  ]))
}

script$1j.render = render$1c;
script$1j.__file = "packages/grid/src/components/CellCommonRenderer/CellImages.vue";

var script$1i = defineComponent({
    name: 'ScButtonDropdown',
    inheritAttrs: false,
    components: {
        DownOutlined,
        UpOutlined,
    },
    props: {
        menus: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: [Boolean],
            default: false,
        },
        placement: {
            type: String,
            default: 'topLeft',
        },
    },
    setup(props, { emit }) {
        const handleButtonClick = (e) => {
            emit('click', e);
        };
        const handleMenuClick = (e) => {
            console.log('click', e);
        };
        return { handleButtonClick, handleMenuClick };
    },
});

function render$1b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UpOutlined = resolveComponent("UpOutlined");
  const _component_DownOutlined = resolveComponent("DownOutlined");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_menu_divider = resolveComponent("a-menu-divider");
  const _component_a_menu_item = resolveComponent("a-menu-item");
  const _component_a_sub_menu = resolveComponent("a-sub-menu");
  const _component_a_menu = resolveComponent("a-menu");
  const _component_a_dropdown = resolveComponent("a-dropdown");

  return (openBlock(), createBlock(_component_a_dropdown, {
    disabled: _ctx.disabled,
    getPopupContainer: (node) => node.parentNode,
    placement: _ctx.placement
  }, {
    overlay: withCtx(() => [
      createVNode(_component_a_menu, null, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.menus, (item, i) => {
            return (openBlock(), createElementBlock(Fragment, { key: i }, [
              (item.isLine)
                ? (openBlock(), createBlock(_component_a_menu_divider, { key: 0 }))
                : (!item.children)
                  ? (openBlock(), createBlock(_component_a_menu_item, mergeProps({ key: 1 }, { ...item }, {
                      title: item.tips
                    }), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(item.title), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["title"]))
                  : (openBlock(), createBlock(_component_a_sub_menu, {
                      key: 2,
                      title: item.title
                    }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(item.children, (sub, j) => {
                          return (openBlock(), createElementBlock(Fragment, {
                            key: i + '_' + j
                          }, [
                            (sub.isLine)
                              ? (openBlock(), createBlock(_component_a_menu_divider, { key: 0 }))
                              : (openBlock(), createBlock(_component_a_menu_item, mergeProps({ key: 1 }, { ...sub }, {
                                  title: sub.tips
                                }), {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(sub.title), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["title"]))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: withCtx(() => [
      createVNode(_component_a_button, {
        clas: "sc-button",
        type: _ctx.$attrs.type,
        textContent: _ctx.$attrs.textContent,
        onClick: _ctx.handleButtonClick
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          (_ctx.placement.substring(0, 3) === 'top')
            ? (openBlock(), createBlock(_component_UpOutlined, { key: 0 }))
            : (openBlock(), createBlock(_component_DownOutlined, { key: 1 }))
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["type", "textContent", "onClick"])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled", "getPopupContainer", "placement"]))
}

script$1i.render = render$1b;
script$1i.__file = "packages/button/src/ButtonDropdown.vue";

var script$1h = defineComponent({
    name: 'ScButton',
    inheritAttrs: false,
    props: {
        tips: {
            type: String,
        },
        disabled: {
            type: [Boolean],
            default: false,
        },
        isDropdown: {
            type: [Boolean],
            default: false,
        },
    },
    setup() {
        return {};
    },
    components: { ButtonDropdown: script$1i },
});

function render$1a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");
  const _component_ButtonDropdown = resolveComponent("ButtonDropdown");
  const _component_a_tooltip = resolveComponent("a-tooltip");

  return (openBlock(), createBlock(_component_a_tooltip, {
    class: "sc-button",
    color: "white",
    title: _ctx.disabled ? _ctx.tips : undefined,
    overlayClassName: "sc-tooltip-color",
    getPopupContainer: (node) => node.parentNode
  }, {
    default: withCtx(() => [
      (!_ctx.isDropdown)
        ? (openBlock(), createBlock(_component_a_button, mergeProps({ key: 0 }, { ..._ctx.$attrs }, { disabled: _ctx.disabled }), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
          }, 16 /* FULL_PROPS */, ["disabled"]))
        : (openBlock(), createBlock(_component_ButtonDropdown, mergeProps({ key: 1 }, { ..._ctx.$attrs }, { disabled: _ctx.disabled }), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
          }, 16 /* FULL_PROPS */, ["disabled"]))
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title", "getPopupContainer"]))
}

script$1h.render = render$1a;
script$1h.__file = "packages/button/src/Button.vue";

script$1h.install = (Vue) => {
    Vue.component(script$1h.name, script$1h);
};

var script$1g = defineComponent({
  name: 'CellCommonRenderer',
  components: {
    Switch,
    Button,
    SCButton: script$1h,
    Tooltip,
    RadioGroup,
    'a-input': Input,
    'a-auto-complete': AutoComplete,
    'a-select': Select,
    'a-select-option': Select.Option,
    Popover,
    Popconfirm,
    Table,
    Textarea,
    Checkbox,
    FormOutlined,
    CellPopconfirm: script$1n,
    PackSpecificationTip: script$1m,
    PriceDiscountTip: script$1l,
    CellWarehouseInfoTips: script$1k,
    CellImages: script$1j,
    Cascader,
    DatePicker,
    VNodes: (_, { attrs }) => attrs.vnodes,
    Vnodes: {
      props: {
        vNode: [Array, String, Object, Number, Function],
      },
      render(ctx) {
        return ctx.vNode;
      },
    },
  },
  props: {
    cellProps: Object,
  },
  data() {
    return {
      type: 10,
      switchChecked: false,
      showPopover: false,
      textareaValue: '',
      iconInfo: {
        size: 12,
        color: '',
        code: '',
      },
      styleType: {
        border: 'sc-channel',
        bgtag: 'sc-state1',
        plain: 'sc-state',
      },
      popTop: 0,
      cellParams: {
        value: '',
        data: {
          productName: '',
          brandColor: '',
          brandName: '',
          shopModelId: '',
        },
        node: { rowPinned: false },
        colDef: {
          headerName: '',
        },
        tooltip: {
          placement: 'top',
          isWarn: () => true,
          valueGetter: () => [{}],
        },
        props: {
          type: '',
          btnGroup: [
            {
              btnText: '',
              iconCode: '',
              btnType: '',
              className: '',
              msg: '',
              disabled: (params) => {
                return params;
              },
              click: (params) => {
                return params;
              },
            },
          ],
          isMoreBtn: '',
          moreBtnList: [
            [
              {
                btnText: '',
                className: '',
                iconCode: '',
                msg: '',
                disabled: (params) => {
                  return params;
                },
                click: (params) => {
                  return params;
                },
                children: [
                  {
                    btnText: '',
                    iconCode: '',
                    className: '',
                    msg: '',
                    disabled: (params) => {
                      return params;
                    },
                    click: (params) => {
                      return params;
                    },
                  },
                ],
              },
            ],
          ],
          msg: '',
          checkedText: '',
          unCheckText: '',
          styleType: '',
          style: '',
          hideCopy: false,
          // hideTip: false,
          noLink: false,
          tipPlacement: 'top',
          disabled: (params) => {
            return params;
          },
          status: (params) => {
            return params;
          },
          text: (params) => {
            return params;
          },
          url: (params) => {
            return params;
          },
          textLength: (params) => {
            return params;
          },
          tipTable: (params) => {
            return params;
          },
          hideTip: (params) => {
            return params;
          },
          readStatus: (params) => {
            return params;
          },
          number: (params) => {
            return params;
          },
          dataSource: (params) => {
            return params;
          },
          columns: (params) => {
            return params;
          },
          title: (params) => {
            return params;
          },
          click: (params) => {
            return params;
          },
          vnode: (params) => {
            return params;
          },
        },
      },
      dataSource: [],
      multipleSelectVisible: false,
    };
  },

  computed: {
    computedButtons() {
      return this.cellParams.props.type === 'btnGroup'
        ? this.cellParams.props.moreBtnList?.filter((btns) =>
            btns.some((btn) => (btn.show ? btn.show(this.cellParams) : true)),
          ) ?? []
        : [];
    },
    bindProps() {
      return omit(this.cellParams.props, 'onChange');
    },
  },

  mounted() {
    if (this.cellProps) {
      this.cellParams = {
        props: {
          ...this.cellProps,
        },
      };
    }
    if (this.params) {
      this.cellParams = { ...this.params };
    }
    if (this.cellParams.props.type == 'switch') {
      this.switchChecked = this.cellParams.props.checked(this.cellParams);
    }
    if (
      this.cellParams.props.type == 'btnGroup' &&
      (typeof this.cellParams.props.isMoreBtn == 'function'
        ? this.cellParams.props.isMoreBtn(this.cellParams)
        : this.cellParams.props.isMoreBtn)
    ) {
      const el = document.querySelector('.main');
      el.addEventListener('scroll', this.popoverScroll);
    }
    if (this.cellParams.props.type == 'iconCell') {
      this.iconInfo =
        typeof this.cellParams.props.iconInfo == 'function'
          ? this.cellParams.props.iconInfo(this.cellParams)
          : this.cellParams.props.iconInfo;
    }
    // 气泡弹框类型
    if (this.cellParams.props.type == 'popconfirm') {
      // 文本域内容赋值
      if (this.cellParams.props.popTextarea) {
        this.cellParams.value =
          typeof this.cellParams.props.text == 'function'
            ? this.cellParams.props.text(this.cellParams).toString()
            : this.cellParams.props.text;
      }
    }

    // 点击单元格打开纠错弹框
    if (this.cellParams.props.type == 'mistakePopconfirm') {
      // 单元格点击事件
      this.cellParams.colDef.onCellClicked = (params) => {
        // 是否展示纠错按钮
        const showErrorCell =
          this.cellParams.props.showErrorCell &&
          this.cellParams.props.showErrorCell(params);
        if (!showErrorCell && this.cellParams.props.mistakeClick) {
          const ev = params.event;
          const trigger = this.cellParams.props.getTrigger
            ? this.cellParams.props.getTrigger(ev)
            : ev.target;
          this.setMistakePopconfirmOffset(trigger, params);
        }
        this.cellParams.props.onCellClicked &&
          this.cellParams.props.onCellClicked(params);
      };
    }
  },
  beforeUnmount() {
    const el = document.querySelector('.main');
    el?.removeEventListener('scroll', this.popoverScroll);
  },
  methods: {
    generateSelectReadonlyText(cellParams) {
      const options =
        typeof cellParams.props.optionDatas == 'function'
          ? cellParams.props.optionDatas(cellParams)
          : cellParams.props.optionDatas;
      const value = cellParams.props.value(cellParams);

      const result = (options || []).find((o) => {
        return o.value == value;
      });

      return (result?.name || result?.label) ?? '-';
    },
    inputChange(event) {
      const val = event.target.value;
      this.cellParams.value = val;
      this.cellParams.props.onChange &&
        this.cellParams.props.onChange(this.cellParams, val);
    },
    datePickerChange(mVal, val) {
      this.cellParams.value = val;
      this.cellParams.props.onChange &&
        this.cellParams.props.onChange(this.cellParams, val || undefined);
    },
    radioChange(event) {
      const val = event.target.value;
      this.cellParams.value = val;
      this.cellParams.setValue(val);
      this.cellParams.props.change &&
        this.cellParams.props.change(this.cellParams.value, this.cellParams);
    },
    switchChange() {
      if (this.cellParams.props.change(!this.switchChecked, this.cellParams)) {
        this.switchChecked = !this.switchChecked;
      }
    },
    seleteChange(val, arr) {
      this.cellParams.value = val;
      this.cellParams.props.onChange &&
        this.cellParams.props.onChange(val, this.cellParams, arr);
    },
    handleMultipleSelectAll() {
      const options = this.cellParams.props?.optionDatas?.();
      if (options) {
        const value = options.map((o) => o.value);
        this.cellParams.value = value;
        const { onSelect } = this.cellParams.props || {};
        onSelect && onSelect(this.cellParams, value);
      }
    },
    handleMultipleSelectClear() {
      this.cellParams.value = [];
      const { onSelect } = this.cellParams.props || {};
      onSelect && onSelect(this.cellParams, []);
    },
    handleMultipleSelectVisibleChange(visible) {
      this.multipleSelectVisible = visible;
    },
    handleMultipleSelectChange(val) {
      this.cellParams.value = val;
      const { onSelect } = this.cellParams.props || {};
      onSelect && onSelect(this.cellParams, val);
    },
    handleMultipleSelectFocus() {
      const { onFocus } = this.cellParams.props || {};
      onFocus && onFocus(this.cellParams);
    },
    deepCloneFieldNames(options) {
      const labelKey = this.cellParams.props?.fieldNames?.label || 'label';
      const valueKey = this.cellParams.props?.fieldNames?.value || 'value';
      const childrenKey =
        this.cellParams.props?.fieldNames?.children || 'children';
      const disabledKey =
        this.cellParams.props?.fieldNames?.disabled || 'disabled';
      const clonedOptions = [];
      (options || []).forEach((option) => {
        const childrenOptions = option[childrenKey];
        const hasChildren = childrenOptions && childrenOptions.length;
        clonedOptions.push({
          ...option,
          label: option[labelKey],
          value: option[valueKey],
          children: hasChildren
            ? this.deepCloneFieldNames(option[childrenKey])
            : undefined,
          disabled: option[disabledKey],
        });
      });
      return clonedOptions;
    },
    handleCascaderFocus() {
      const { onFocus } = this.cellParams.props || {};
      onFocus && onFocus(this.cellParams);
    },
    handleCascaderChange(val) {
      this.cellParams.value = val;
      const { onSelect } = this.cellParams.props || {};
      onSelect && onSelect(this.cellParams, val);
    },
    copyText(val) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', val);
      input.select();
      document.execCommand('copy');
      message.success('已复制到剪贴板');
      document.body.removeChild(input);
    },
    isShowCopy(params) {
      const val = params.props.text ? params.props.text(params) : params.value;
      return !params.data.isBlank && val && val != '-';
    },
    popoverScroll() {
      this.showPopover = false;
    },
    // 文本内容改变回调
    handleChangeText(e) {
      this.cellParams.value = e.target.value;
    },
    // 气泡弹框隐藏显示回调
    handelVisibleChange(visible) {
      this.cellParams.showEditIcon = visible;
      if (visible) {
        this.cellParams.isConfirm = false;
        const textValue =
          typeof this.cellParams.props.text == 'function'
            ? this.cellParams.props.text(this.cellParams).toString()
            : this.cellParams.props.text || this.cellParams.value;
        this.cellParams.value = textValue == '-' ? '' : textValue;
        if (this.cellParams.props.dataSource) {
          (async () => {
            const data = await this.cellParams.props.dataSource(
              this.cellParams,
            );
            this.dataSource.splice(0);
            this.dataSource.push(...data);
          })();
        }
      }
    },
    // 气泡弹框确定事件回调
    handelPopConfim() {
      this.cellParams.isConfirm = true;
      if (this.cellParams.props.confirm) {
        if (this.cellParams.props.confirm(this.cellParams) == false) {
          this.cellParams.showEditIcon = true;
        }
      }
    },
    // 气泡弹框取消事件回调
    handelPopCancel() {
      this.cellParams.isConfirm = false;
      if (this.cellParams.props.cancel) {
        this.cellParams.props.cancel(this.cellParams);
      }
    },
    // 纠错型号
    handleMistakePopconfirm(ev, params) {
      if (this.cellParams.props.mistakeClick) {
        const trigger = this.cellParams.props.getTrigger
          ? this.cellParams.props.getTrigger(ev)
          : ev.target.offsetParent;
        if (trigger) {
          this.setMistakePopconfirmOffset(trigger, params);
        }
      }
    },
    setMistakePopconfirmOffset(trigger, params) {
      const rect = trigger.getBoundingClientRect();
      const positionEleClass = this.cellParams.props.positionsEle || 'main';
      const positionEle = document.getElementsByClassName(positionEleClass)[0];
      let offset;
      if (positionEle) {
        const positionRect = positionEle.getBoundingClientRect();
        offset = {
          left: (rect.left || 0) - (positionRect.left || 0) + 'px',
          top:
            (rect.top || 0) -
            (positionRect.top || 0) +
            positionEle.scrollTop +
            'px',
        };
      } else {
        offset = {
          left: (rect.left || 0) + 'px',
          top: (rect.top || 0) + 'px',
        };
      }
      this.cellParams.props.mistakeClick(offset, params);
    },
  },
});

const _hoisted_1$10 = { class: "cell-style" };
const _hoisted_2$N = {
  key: 0,
  class: "cell-style-disable"
};
const _hoisted_3$D = {
  key: 1,
  class: "product-box",
  style: {"width":"100%"}
};
const _hoisted_4$v = {
  key: 2,
  class: "product-box",
  style: {"width":"100%"}
};
const _hoisted_5$n = ["title"];
const _hoisted_6$h = ["href", "title"];
const _hoisted_7$f = {
  key: 0,
  class: "status-dsc"
};
const _hoisted_8$e = { key: 10 };
const _hoisted_9$d = ["innerHTML"];
const _hoisted_10$b = { class: "btn-border" };
const _hoisted_11$b = { key: 0 };
const _hoisted_12$b = {
  key: 0,
  class: "btn-border"
};
const _hoisted_13$7 = ["innerHTML"];
const _hoisted_14$8 = /*#__PURE__*/createElementVNode("i", { class: "iconfont icon-shenglvehao" }, "", -1 /* HOISTED */);
const _hoisted_15$8 = {
  key: 1,
  class: "btn-none btn-normal"
};
const _hoisted_16$8 = {
  key: 12,
  class: "status-type-container"
};
const _hoisted_17$6 = { style: {"padding-left":"5px"} };
const _hoisted_18$4 = {
  key: 15,
  class: "text-copy sc-copy-box"
};
const _hoisted_19$4 = { key: 0 };
const _hoisted_20$3 = {
  class: "text-copy",
  style: {"display":"inline-block","min-width":"132px"}
};
const _hoisted_21$1 = { key: 0 };
const _hoisted_22$1 = ["href"];
const _hoisted_23$1 = ["onClick"];
const _hoisted_24$1 = { key: 1 };
const _hoisted_25$1 = { key: 1 };
const _hoisted_26$1 = { key: 0 };
const _hoisted_27$1 = { key: 1 };
const _hoisted_28$1 = ["href"];
const _hoisted_29$1 = {
  key: 16,
  class: "text-group"
};
const _hoisted_30$1 = ["onClick"];
const _hoisted_31$1 = ["innerHTML"];
const _hoisted_32$1 = {
  key: 18,
  class: "sc-pop-textarea"
};
const _hoisted_33$1 = {
  key: 0,
  class: "sc-pop-textarea-text"
};
const _hoisted_34$1 = {
  key: 0,
  class: "sc-popconfirm-title"
};
const _hoisted_35$1 = {
  key: 1,
  class: "sc-popconfirm-content"
};
const _hoisted_36$1 = { class: "sc-popconfirm-tips" };
const _hoisted_37$1 = {
  key: 2,
  class: "sc-popconfirm-content"
};
const _hoisted_38$1 = {
  class: "text-copy",
  style: {"display":"inline-block","min-width":"132px"}
};
const _hoisted_39$1 = { key: 0 };
const _hoisted_40$1 = ["href"];
const _hoisted_41$1 = ["onClick"];
const _hoisted_42$1 = { key: 1 };
const _hoisted_43$1 = {
  key: 3,
  class: "sc-popconfirm-content"
};
const _hoisted_44$1 = { key: 0 };
const _hoisted_45$1 = {
  key: 0,
  class: "mistake-popconfirm-cell"
};
const _hoisted_46$1 = {
  key: 1,
  class: "mistake-trigger text-copy"
};
const _hoisted_47$1 = { class: "mistake-trigger-text" };
const _hoisted_48$1 = {
  key: 1,
  class: "mistake-trigger-text"
};
const _hoisted_49$1 = {
  key: 0,
  class: "text-ellipsis"
};
const _hoisted_50$1 = ["innerHTML"];
const _hoisted_51$1 = {
  key: 0,
  class: "text-ellipsis"
};
const _hoisted_52$1 = ["innerHTML"];

function render$19(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_auto_complete = resolveComponent("a-auto-complete");
  const _component_DatePicker = resolveComponent("DatePicker");
  const _component_Switch = resolveComponent("Switch");
  const _component_RadioGroup = resolveComponent("RadioGroup");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_Button = resolveComponent("Button");
  const _component_Cascader = resolveComponent("Cascader");
  const _component_SCButton = resolveComponent("SCButton");
  const _component_Popover = resolveComponent("Popover");
  const _component_Table = resolveComponent("Table");
  const _component_vnodes = resolveComponent("vnodes");
  const _component_a_tooltip = resolveComponent("a-tooltip");
  const _component_Textarea = resolveComponent("Textarea");
  const _component_FormOutlined = resolveComponent("FormOutlined");
  const _component_Popconfirm = resolveComponent("Popconfirm");
  const _component_CellPopconfirm = resolveComponent("CellPopconfirm");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_PriceDiscountTip = resolveComponent("PriceDiscountTip");
  const _component_PackSpecificationTip = resolveComponent("PackSpecificationTip");
  const _component_CellWarehouseInfoTips = resolveComponent("CellWarehouseInfoTips");
  const _component_CellImages = resolveComponent("CellImages");

  return (openBlock(), createElementBlock("span", _hoisted_1$10, [
    (
        _ctx.cellParams.data.isDisable ||
          (_ctx.cellParams?.isDisable?.(_ctx.cellParams) &&
            !['btnGroup', 'textCopy'].includes(_ctx.cellParams.props.type))
      )
      ? (openBlock(), createElementBlock("span", _hoisted_2$N))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 品牌/系列 "),
    (_ctx.cellParams.props.type == 'brandName')
      ? (openBlock(), createElementBlock("span", _hoisted_3$D, [
          createElementVNode("span", {
            class: "sc-product-brand",
            style: normalizeStyle(
          `color:${_ctx.cellParams.data.brandColor};
              border-color:${_ctx.cellParams.data.brandColor}`
        )
          }, toDisplayString(_ctx.cellParams.data.brandName), 5 /* TEXT, STYLE */)
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'productName')
      ? (openBlock(), createElementBlock("span", _hoisted_4$v, [
          createVNode(_component_Tooltip, {
            title: `产品信息：${_ctx.cellParams.data.productName || '-'}`,
            placement: _ctx.cellParams.props.tipPlacement,
            trigger: "hover"
          }, {
            default: withCtx(() => [
              createElementVNode("span", {
                class: "sc-product-brand",
                style: normalizeStyle(
            `color:${_ctx.cellParams.data.brandColor};
              border-color:${_ctx.cellParams.data.brandColor}`
          )
              }, toDisplayString(_ctx.cellParams.data.brandName), 5 /* TEXT, STYLE */),
              (_ctx.cellParams.props.noLink)
                ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    title: _ctx.cellParams.data.productName,
                    class: "sc-product-name"
                  }, toDisplayString(_ctx.cellParams.data.productName), 9 /* TEXT, PROPS */, _hoisted_5$n))
                : (openBlock(), createElementBlock("a", {
                    key: 1,
                    class: "sc-product-name",
                    href: 
            _ctx.cellParams.props.url
              ? _ctx.cellParams.props.url(_ctx.cellParams)
              : '/product/detail/' + _ctx.cellParams.data.shopModelId
          ,
                    title: _ctx.cellParams.data.productName,
                    target: "_blank"
                  }, toDisplayString(_ctx.cellParams.data.productName), 9 /* TEXT, PROPS */, _hoisted_6$h))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title", "placement"])
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'input')
      ? (openBlock(), createElementBlock("span", {
          key: 3,
          onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"])),
          class: "sc-agGrid-input"
        }, [
          createVNode(_component_a_input, {
            bordered: false,
            "default-value": _ctx.cellParams.props.value(_ctx.cellParams),
            disabled: 
          _ctx.cellParams.props.disabled
            ? _ctx.cellParams.props.disabled(_ctx.cellParams)
            : false
        ,
            readonly: 
          _ctx.cellParams.props.readonly
            ? _ctx.cellParams.props.readonly(_ctx.cellParams)
            : false
        ,
            style: normalizeStyle(
          _ctx.cellParams.props.style ? _ctx.cellParams.props.style(_ctx.cellParams) : {}
        ),
            onBlur: _ctx.inputChange
          }, null, 8 /* PROPS */, ["default-value", "disabled", "readonly", "style", "onBlur"])
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'autoComplete')
      ? (openBlock(), createElementBlock("span", {
          key: 4,
          onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"])),
          class: "sc-agGrid-auto-complete"
        }, [
          createVNode(_component_a_auto_complete, {
            bordered: false,
            style: {"width":"100%"},
            "default-value": 
          (_ctx.cellParams.props.value && _ctx.cellParams.props.value(_ctx.cellParams)) ||
            _ctx.cellParams.value
        ,
            disabled: _ctx.cellParams.props.disabled(_ctx.cellParams),
            onBlur: _ctx.inputChange,
            filterOption: "",
            options: 
          typeof _ctx.cellParams.props.optionDatas == 'function'
            ? _ctx.cellParams.props.optionDatas(_ctx.cellParams)
            : _ctx.cellParams.props.optionDatas
        
          }, null, 8 /* PROPS */, ["default-value", "disabled", "onBlur", "options"])
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" date picker "),
    (_ctx.cellParams.props.type == 'datePicker')
      ? (openBlock(), createElementBlock("span", {
          key: 5,
          onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"])),
          class: "sc-agGrid-date-picker"
        }, [
          createVNode(_component_DatePicker, {
            bordered: false,
            style: {"width":"100%","height":"100%"},
            value: 
          (_ctx.cellParams.props.value && _ctx.cellParams.props.value(_ctx.cellParams)) ||
            _ctx.cellParams.value
        ,
            disabled: _ctx.cellParams.props.disabled(_ctx.cellParams),
            valueFormat: "YYYY-MM-DD",
            onChange: _ctx.datePickerChange
          }, null, 8 /* PROPS */, ["value", "disabled", "onChange"])
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 开关 "),
    (_ctx.cellParams.props.type == 'switch')
      ? (openBlock(), createElementBlock("span", {
          key: 6,
          onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["stop"]))
        }, [
          createVNode(_component_Tooltip, {
            title: 
          _ctx.cellParams.props.disabled(_ctx.cellParams)
            ? typeof _ctx.cellParams.props.msg === 'function'
              ? _ctx.cellParams.props.msg(_ctx.cellParams)
              : _ctx.cellParams.props.msg
            : null
        ,
            placement: _ctx.cellParams.props.tipPlacement,
            color: "#ffffff",
            overlayClassName: "sc-tip"
          }, {
            default: withCtx(() => [
              createVNode(_component_Switch, {
                "checked-children": _ctx.cellParams.props.checkedText,
                "un-checked-children": _ctx.cellParams.props.unCheckText,
                disabled: _ctx.cellParams.props.disabled(_ctx.cellParams),
                size: "small",
                checked: _ctx.switchChecked,
                onChange: _ctx.switchChange
              }, null, 8 /* PROPS */, ["checked-children", "un-checked-children", "disabled", "checked", "onChange"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title", "placement"])
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" Radio "),
    (_ctx.cellParams.props.type == 'radio')
      ? (openBlock(), createElementBlock("span", {
          key: 7,
          onClick: _cache[5] || (_cache[5] = withModifiers(() => {}, ["stop"]))
        }, [
          createVNode(_component_Tooltip, {
            title: 
          _ctx.cellParams.props.disabled(_ctx.cellParams) ? _ctx.cellParams.props.msg : null
        ,
            placement: _ctx.cellParams.props.tipPlacement,
            color: "#ffffff",
            overlayClassName: "sc-tip"
          }, {
            default: withCtx(() => [
              createVNode(_component_RadioGroup, {
                value: _ctx.cellParams.value,
                "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.cellParams.value) = $event)),
                options: _ctx.cellParams.props.options,
                onChange: _ctx.radioChange,
                disabled: _ctx.cellParams.props.disabled(_ctx.cellParams)
              }, null, 8 /* PROPS */, ["value", "options", "onChange", "disabled"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title", "placement"])
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 表单 "),
    (_ctx.cellParams.props.type == 'select')
      ? (openBlock(), createElementBlock("span", {
          key: 8,
          onClick: _cache[6] || (_cache[6] = withModifiers(() => {}, ["stop"])),
          class: "sc-agGrid-select"
        }, [
          withDirectives(createElementVNode("div", mergeProps({ class: "sc-select-readonly-text" }, { ..._ctx.cellParams.props }), toDisplayString(_ctx.generateSelectReadonlyText(_ctx.cellParams)), 17 /* TEXT, FULL_PROPS */), [
            [vShow, 
          _ctx.cellParams.props.readonly
            ? _ctx.cellParams.props.readonly(_ctx.cellParams)
            : false
        ]
          ]),
          withDirectives(createVNode(_component_a_select, mergeProps({
            maxTagTextLength: 10,
            maxTagCount: 2,
            showArrow: true,
            bordered: false,
            style: {"width":"100%"}
          }, { ..._ctx.bindProps }, {
            value: _ctx.cellParams.props.value(_ctx.cellParams),
            disabled: 
          _ctx.cellParams.props.disabled
            ? _ctx.cellParams.props.disabled(_ctx.cellParams)
            : false
        ,
            onChange: _ctx.seleteChange
          }), {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(typeof _ctx.cellParams.props.optionDatas == 'function'
            ? _ctx.cellParams.props.optionDatas(_ctx.cellParams)
            : _ctx.cellParams.props.optionDatas, (item) => {
                return (openBlock(), createBlock(_component_a_select_option, {
                  key: item.value,
                  value: item.value,
                  disabled: item.disabled,
                  class: normalizeClass(`sc-agGrid-select-option ${item.statusClass || ''}`)
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(item.label) + " ", 1 /* TEXT */),
                    (item.statusDsc)
                      ? (openBlock(), createElementBlock("span", _hoisted_7$f, toDisplayString(item.statusDsc), 1 /* TEXT */))
                      : createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "disabled", "class"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */, ["value", "disabled", "onChange"]), [
            [vShow, 
          _ctx.cellParams.props.readonly
            ? !_ctx.cellParams.props.readonly(_ctx.cellParams)
            : true
        ]
          ])
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type === 'multipleSelect')
      ? (openBlock(), createElementBlock("div", {
          key: 9,
          onClick: _cache[11] || (_cache[11] = withModifiers(() => {}, ["stop"])),
          class: "sc-agGrid-multiple-select"
        }, [
          createVNode(_component_a_select, {
            allowClear: "",
            style: {"width":"100%","height":"100%"},
            mode: "multiple",
            open: _ctx.multipleSelectVisible,
            size: _ctx.cellParams.props.size,
            placeholder: _ctx.cellParams.props.placeholder,
            options: 
          typeof _ctx.cellParams.props.optionDatas == 'function'
            ? _ctx.cellParams.props.optionDatas(_ctx.cellParams)
            : _ctx.cellParams.props.optionDatas
        ,
            maxTagCount: _ctx.cellParams.props.maxTagCount,
            maxTagTextLength: _ctx.cellParams.props.maxTagTextLength,
            maxTagPlaceholder: _ctx.cellParams.props.maxTagPlaceholder,
            value: 
          _ctx.cellParams.props.value
            ? _ctx.cellParams.props.value(_ctx.cellParams)
            : _ctx.cellParams.value
        ,
            disabled: 
          _ctx.cellParams.props.disabled
            ? _ctx.cellParams.props.disabled(_ctx.cellParams)
            : false
        ,
            onFocus: _ctx.handleMultipleSelectFocus,
            onChange: _ctx.handleMultipleSelectChange,
            onDropdownVisibleChange: _ctx.handleMultipleSelectVisibleChange
          }, {
            dropdownRender: withCtx(({ menuNode: menu }) => [
              createVNode(_component_v_nodes, { vnodes: menu }, null, 8 /* PROPS */, ["vnodes"]),
              createElementVNode("div", {
                class: "multi-select-bottom-renderer",
                onMousedown: _cache[10] || (_cache[10] = (e) => e.preventDefault())
              }, [
                createElementVNode("div", null, [
                  createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.handleMultipleSelectAll && _ctx.handleMultipleSelectAll(...args)))
                  }, "全选"),
                  (!!_ctx.cellParams.value?.length)
                    ? (openBlock(), createElementBlock("a", {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.handleMultipleSelectClear && _ctx.handleMultipleSelectClear(...args)))
                      }, " 清空 "))
                    : createCommentVNode("v-if", true)
                ]),
                createVNode(_component_Button, {
                  type: "primary",
                  size: "small",
                  onClick: _cache[9] || (_cache[9] = 
                () => {
                  _ctx.handleMultipleSelectVisibleChange(false);
                  _ctx.cellParams.props.onOk &&
                    _ctx.cellParams.props.onOk(_ctx.cellParams.value, _ctx.cellParams);
                }
              )
                }, {
                  default: withCtx(() => [
                    createTextVNode(" 确认 ")
                  ]),
                  _: 1 /* STABLE */
                })
              ], 32 /* HYDRATE_EVENTS */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["open", "size", "placeholder", "options", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "value", "disabled", "onFocus", "onChange", "onDropdownVisibleChange"])
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type === 'cascader')
      ? (openBlock(), createElementBlock("div", _hoisted_8$e, [
          createVNode(_component_Cascader, {
            style: {"width":"100%"},
            size: _ctx.cellParams.props.size,
            placeholder: _ctx.cellParams.props.placeholder || '',
            options: _ctx.deepCloneFieldNames(_ctx.cellParams.props.options),
            changeOnSelect: _ctx.cellParams.props.changeOnSelect,
            "expand-trigger": "hover",
            value: 
          _ctx.cellParams.props.value
            ? _ctx.cellParams.props.value(_ctx.cellParams)
            : _ctx.cellParams.value
        ,
            disabled: 
          _ctx.cellParams.props.disabled
            ? _ctx.cellParams.props.disabled(_ctx.cellParams)
            : false
        ,
            onFocus: _ctx.handleCascaderFocus,
            onChange: _ctx.handleCascaderChange
          }, null, 8 /* PROPS */, ["size", "placeholder", "options", "changeOnSelect", "value", "disabled", "onFocus", "onChange"])
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 按钮组 "),
    (_ctx.cellParams.props.type == 'btnGroup')
      ? (openBlock(), createElementBlock("div", {
          key: 11,
          class: "btn-group",
          onClick: _cache[13] || (_cache[13] = withModifiers(() => {}, ["stop"]))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.cellParams.props.btnGroup, (item, index) => {
            return (openBlock(), createElementBlock("span", { key: item }, [
              (item.visible ? item.visible(_ctx.cellParams) : true)
                ? (openBlock(), createBlock(_component_Tooltip, {
                    key: 0,
                    title: 
            (item.disabled && item.disabled(_ctx.cellParams)) ||
            (item.showTip && item.showTip(_ctx.cellParams))
              ? typeof item.msg === 'string'
                ? item.msg
                : item.msg(_ctx.cellParams)
              : null
          ,
                    placement: _ctx.cellParams.props.tipPlacement,
                    color: "#ffffff",
                    overlayClassName: "sc-tip"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_Button, {
                        size: "small",
                        class: normalizeClass(
              `${item.className || 'btn-normal'}
              ${
                item.disabled
                  ? item.disabled(_ctx.cellParams)
                    ? 'btn-disabled'
                    : ''
                  : ''
              }`
            ),
                        type: item.btnType || 'link',
                        disabled: item.disabled ? item.disabled(_ctx.cellParams) : false,
                        onClick: withModifiers($event => (item.click(_ctx.cellParams)), ["stop"])
                      }, {
                        icon: withCtx(() => [
                          (item.iconCode)
                            ? (openBlock(), createElementBlock("i", {
                                key: 0,
                                class: "iconfont",
                                style: {"vertical-align":"middle","font-size":"12px","padding":"0 5px"},
                                innerHTML: item.iconCode
                              }, null, 8 /* PROPS */, _hoisted_9$d))
                            : createCommentVNode("v-if", true)
                        ]),
                        default: withCtx(() => [
                          createTextVNode(" " + toDisplayString(item.btnText), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "type", "disabled", "onClick"]),
                      withDirectives(createElementVNode("span", _hoisted_10$b, null, 512 /* NEED_PATCH */), [
                        [vShow, 
              index <
                _ctx.cellParams.props.btnGroup.filter((v) =>
                  v.visible ? v.visible(_ctx.cellParams) : true,
                ).length -
                  1
            ]
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "placement"]))
                : createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          createCommentVNode(" 更多按钮 "),
          (_ctx.computedButtons.length)
            ? (openBlock(), createElementBlock("span", _hoisted_11$b, [
                (_ctx.cellParams.props.btnGroup?.length > 0)
                  ? (openBlock(), createElementBlock("span", _hoisted_12$b))
                  : createCommentVNode("v-if", true),
                createVNode(_component_Popover, {
                  overlayClassName: "btn-popover-content",
                  trigger: "click",
                  placement: "bottomRight",
                  align: {
            offset: [13, 1],
          },
                  visible: _ctx.showPopover,
                  "onUpdate:visible": _cache[12] || (_cache[12] = $event => ((_ctx.showPopover) = $event))
                }, {
                  content: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.computedButtons, (item) => {
                      return (openBlock(), createElementBlock("div", {
                        class: "more-btn btn-border-top",
                        key: item
                      }, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(item, (el) => {
                          return (openBlock(), createElementBlock(Fragment, { key: el }, [
                            (el.show ? el.show(_ctx.cellParams) : true)
                              ? (openBlock(), createBlock(_component_SCButton, {
                                  key: 0,
                                  class: normalizeClass(["more-btn-col", 
                    `${el.className || ''}
                      ${
                        el.disabled
                          ? el.disabled(_ctx.cellParams)
                            ? 'btn-disabled'
                            : ''
                          : ''
                      }`
                  ]),
                                  type: "text",
                                  disabled: (el.disabled && el.disabled(_ctx.cellParams)) || false,
                                  tips: (el.tips && el.tips(_ctx.cellParams)) || '',
                                  onClick: withModifiers($event => (
                    (_ctx.showPopover = false) ||
                      (el.click && el.click($event, _ctx.cellParams))
                  ), ["stop"])
                                }, {
                                  default: withCtx(() => [
                                    createElementVNode("i", {
                                      class: "iconfont",
                                      innerHTML: el.iconCode
                                    }, null, 8 /* PROPS */, _hoisted_13$7),
                                    createTextVNode(" " + toDisplayString(el.btnText), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "disabled", "tips", "onClick"]))
                              : createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_Button, {
                      style: {"text-align":"center"},
                      type: "text",
                      class: "btn-normal"
                    }, {
                      icon: withCtx(() => [
                        _hoisted_14$8
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["visible"])
              ]))
            : createCommentVNode("v-if", true),
          createCommentVNode("  v-if=\"item.visible ? item.visible(cellParams) : true\" "),
          (
          _ctx.cellParams.props?.btnGroup?.filter((v) =>
            v.visible ? v.visible(_ctx.cellParams) : true,
          ).length <= 0 &&
            !(typeof _ctx.cellParams.props.isMoreBtn == 'function'
              ? _ctx.cellParams.props.isMoreBtn(_ctx.cellParams)
              : _ctx.cellParams.props.isMoreBtn) &&
            _ctx.cellParams.props.showLine
        )
            ? (openBlock(), createElementBlock("span", _hoisted_15$8, "-"))
            : createCommentVNode("v-if", true)
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 状态类型 "),
    (_ctx.cellParams.props.type == 'statusType')
      ? (openBlock(), createElementBlock("div", _hoisted_16$8, [
          createElementVNode("span", {
            class: normalizeClass(
            `${_ctx.styleType[_ctx.cellParams.props.styleType]} 
          ${_ctx.styleType[_ctx.cellParams.props.styleType]}-${_ctx.cellParams.props.status(
              _ctx.cellParams,
            )}`
          )
          }, toDisplayString(_ctx.cellParams.props.text(_ctx.cellParams) || '-'), 3 /* TEXT, CLASS */)
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 查看状态//已读未读 "),
    (_ctx.cellParams.props.type == 'readStatus')
      ? (openBlock(), createElementBlock(Fragment, { key: 13 }, [
          createElementVNode("span", {
            class: "read-status",
            style: normalizeStyle(
          `background-color: 
          ${_ctx.cellParams.props.readStatus(_ctx.cellParams) ? '#64C33C' : '#E13438'};`
        )
          }, null, 4 /* STYLE */),
          createElementVNode("span", null, toDisplayString(_ctx.cellParams.props.readStatus(_ctx.cellParams) ? '已读' : '未读'), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 数字类型状态 "),
    (_ctx.cellParams.props.type == 'numberStatus')
      ? (openBlock(), createElementBlock(Fragment, { key: 14 }, [
          createElementVNode("span", {
            class: normalizeClass(["sc-bg-state", `sc-bg-${_ctx.cellParams.props.status(_ctx.cellParams)}`])
          }, toDisplayString(_ctx.cellParams.props.number(_ctx.cellParams)), 3 /* TEXT, CLASS */),
          createElementVNode("span", _hoisted_17$6, toDisplayString(_ctx.cellParams.props.text), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 单据号/型号/订货号等支持复制 "),
    (
        _ctx.cellParams.props.type == 'textCopy' &&
          (_ctx.cellParams.props.text || _ctx.cellParams.value)
      )
      ? (openBlock(), createElementBlock("span", _hoisted_18$4, [
          createCommentVNode(" // 固定行不格式化 "),
          (_ctx.cellParams.node && _ctx.cellParams.node.rowPinned)
            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(_ctx.cellParams.value), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createVNode(_component_Tooltip, {
                  placement: _ctx.cellParams.props.tipPlacement,
                  trigger: "hover",
                  color: 
            _ctx.cellParams.props.tipTable
              ? _ctx.cellParams.props.tipTable(_ctx.cellParams)
                ? '#fff'
                : ''
              : ''
          ,
                  overlayClassName: 
            `sc-copy-tip
          ${
            _ctx.cellParams.props.hideTip &&
            typeof _ctx.cellParams.props.hideTip == 'function' &&
            _ctx.cellParams.props.hideTip(_ctx.cellParams)
              ? ' sc-no-tip'
              : ''
          }
          ${
            _ctx.cellParams.props.tipTable && _ctx.cellParams.props.tipTable(_ctx.cellParams)
              ? ' sc-tip'
              : ''
          }
          ${
            _ctx.cellParams.props.tipWhite && _ctx.cellParams.props.tipWhite(_ctx.cellParams)
              ? ' sc-tip-white'
              : ''
          }`
          
                }, {
                  title: withCtx(() => [
                    (
                _ctx.cellParams.props.tipTable
                  ? _ctx.cellParams.props.tipTable(_ctx.cellParams)
                  : false
              )
                      ? (openBlock(), createElementBlock("span", _hoisted_19$4, [
                          createVNode(_component_Table, {
                            dataSource: _ctx.cellParams.props.dataSource(_ctx.cellParams),
                            columns: _ctx.cellParams.props.columns(_ctx.cellParams),
                            pagination: false,
                            scroll: {
                  x: true,
                  y:
                    _ctx.cellParams.props.dataSource(_ctx.cellParams).length > 10
                      ? 300
                      : '',
                }
                          }, {
                            text: withCtx(({ record }) => [
                              createElementVNode("span", _hoisted_20$3, [
                                (record.url)
                                  ? (openBlock(), createElementBlock("span", _hoisted_21$1, [
                                      createElementVNode("a", {
                                        href: record.url,
                                        target: "_blank"
                                      }, toDisplayString(record.text), 9 /* TEXT, PROPS */, _hoisted_22$1),
                                      createElementVNode("i", {
                                        class: "iconfont icon-fuzhi-copy",
                                        onClick: withModifiers($event => (_ctx.copyText(record.text)), ["stop"])
                                      }, "", 8 /* PROPS */, _hoisted_23$1)
                                    ]))
                                  : (openBlock(), createElementBlock("span", _hoisted_24$1, toDisplayString(record.text), 1 /* TEXT */))
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["dataSource", "columns", "scroll"])
                        ]))
                      : (openBlock(), createElementBlock("span", _hoisted_25$1, [
                          (_ctx.cellParams.props.title)
                            ? (openBlock(), createElementBlock("span", _hoisted_26$1, toDisplayString(_ctx.cellParams.props.title(_ctx.cellParams)), 1 /* TEXT */))
                            : (openBlock(), createElementBlock("span", _hoisted_27$1, toDisplayString(`${_ctx.cellParams.colDef.headerName}：${
                    _ctx.cellParams.props.text
                      ? _ctx.cellParams.props.text(_ctx.cellParams)
                      : _ctx.cellParams.value
                  }`), 1 /* TEXT */))
                        ]))
                  ]),
                  default: withCtx(() => [
                    (
              typeof _ctx.cellParams.props.url == 'function'
                ? _ctx.cellParams.props.url(_ctx.cellParams)
                : _ctx.cellParams.props.url
            )
                      ? (openBlock(), createElementBlock("a", {
                          key: 0,
                          href: _ctx.cellParams.props.url(_ctx.cellParams),
                          class: "sc-link sc-copy-text",
                          target: "_blank"
                        }, toDisplayString(_ctx.cellParams.props.text
                ? _ctx.cellParams.props.text(_ctx.cellParams)
                : _ctx.cellParams.value) + " " + toDisplayString(_ctx.cellParams.props.textLength
                ? _ctx.cellParams.props.textLength(_ctx.cellParams)
                : ''), 9 /* TEXT, PROPS */, _hoisted_28$1))
                      : (_ctx.cellParams.props.click)
                        ? (openBlock(), createElementBlock("span", {
                            key: 1,
                            style: normalizeStyle(_ctx.cellParams.props.style),
                            class: normalizeClass('sc-link-text sc-copy-text'),
                            onClick: _cache[14] || (_cache[14] = withModifiers($event => (_ctx.cellParams.props.click(_ctx.cellParams)), ["stop"]))
                          }, toDisplayString(_ctx.cellParams.props.text
                ? _ctx.cellParams.props.text(_ctx.cellParams)
                : _ctx.cellParams.value), 5 /* TEXT, STYLE */))
                        : (openBlock(), createElementBlock("span", {
                            key: 2,
                            style: normalizeStyle(_ctx.cellParams.props.style),
                            class: "sc-copy-text"
                          }, toDisplayString(_ctx.cellParams.props.text
                ? _ctx.cellParams.props.text(_ctx.cellParams)
                : _ctx.cellParams.value), 5 /* TEXT, STYLE */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["placement", "color", "overlayClassName"]),
                (
            typeof _ctx.cellParams.props.hideCopy == 'function'
              ? !_ctx.cellParams.props.hideCopy(_ctx.cellParams)
              : !_ctx.cellParams.props.hideCopy
          )
                  ? (openBlock(), createElementBlock("i", {
                      key: 0,
                      class: "iconfont icon-fuzhi-copy",
                      onClick: _cache[15] || (_cache[15] = withModifiers($event => (
            _ctx.copyText(
              _ctx.cellParams.props.text
                ? _ctx.cellParams.props.text(_ctx.cellParams)
                : _ctx.cellParams.value,
            )
          ), ["stop"]))
                    }, ""))
                  : createCommentVNode("v-if", true),
                (_ctx.cellParams.props.tag)
                  ? (openBlock(), createBlock(_component_Tooltip, {
                      key: 1,
                      trigger: "hover"
                    }, {
                      title: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.cellParams.props.tag.tip(_ctx.cellParams)), 1 /* TEXT */)
                      ]),
                      default: withCtx(() => [
                        createElementVNode("span", {
                          class: normalizeClass(
                `${_ctx.styleType[_ctx.cellParams.props.tag.styleType]} 
          ${
            _ctx.styleType[_ctx.cellParams.props.tag.styleType]
          }-${_ctx.cellParams.props.tag.status(_ctx.cellParams)}`
              ),
                          style: {"margin-left":"5px"}
                        }, toDisplayString(_ctx.cellParams.props.tag.text(_ctx.cellParams)), 3 /* TEXT, CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true),
                (_ctx.cellParams.props.vnode)
                  ? (openBlock(), createBlock(_component_vnodes, {
                      key: 2,
                      vNode: _ctx.cellParams.props.vnode(_ctx.cellParams)
                    }, null, 8 /* PROPS */, ["vNode"]))
                  : createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type === 'textGroup')
      ? (openBlock(), createElementBlock("span", _hoisted_29$1, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.cellParams.props.textGroup(_ctx.cellParams), (item, index) => {
            return (openBlock(), createElementBlock("span", {
              class: "link-text",
              key: index,
              onClick: withModifiers($event => (item.click($event, _ctx.cellParams)), ["stop"])
            }, toDisplayString(item.text || _ctx.cellParams.value), 9 /* TEXT, PROPS */, _hoisted_30$1))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" icon "),
    (_ctx.cellParams.props.type == 'iconCell')
      ? (openBlock(), createElementBlock("i", {
          key: 17,
          class: "iconfont",
          style: normalizeStyle(
          `font-size:${_ctx.iconInfo.size || 12}px;color:${_ctx.iconInfo.color || ''};`
        ),
          innerHTML: _ctx.iconInfo.code
        }, null, 12 /* STYLE, PROPS */, _hoisted_31$1))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 气泡对话框 "),
    (_ctx.cellParams.props.type == 'popconfirm')
      ? (openBlock(), createElementBlock("span", _hoisted_32$1, [
          createVNode(_component_a_tooltip, {
            ref: "popConfirmRef",
            overlayClassName: "sc-tooltip-light",
            title: 
          _ctx.cellParams.props.text
            ? _ctx.cellParams.props.text(_ctx.cellParams)
            : _ctx.cellParams.value
        
          }, {
            default: withCtx(() => [
              (!!_ctx.cellParams.props.popTextarea)
                ? (openBlock(), createElementBlock("span", _hoisted_33$1, toDisplayString(_ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          createVNode(_component_Popconfirm, {
            placement: "bottomLeft",
            arrowPointAtCenter: true,
            overlayClassName: 
          `sc-grid-popconfirm
          ${_ctx.cellParams.props.hideCancel ? ' popconfirm-hide-cancel' : ''}
          ${_ctx.cellParams.props.hideOk ? ' popconfirm-hide-ok' : ''}
          ${_ctx.cellParams.props.hideIcon ? ' popconfirm-hide-icon' : ''}`
        ,
            cancelText: _ctx.cellParams.props.cancelText || '取消',
            okText: _ctx.cellParams.props.okText || '确定',
            onCancel: _ctx.handelPopCancel,
            onConfirm: _ctx.handelPopConfim,
            onVisibleChange: _ctx.handelVisibleChange,
            overlayStyle: _ctx.cellParams.props.overlayStyle || {},
            visible: _ctx.cellParams.showEditIcon,
            "onUpdate:visible": _cache[16] || (_cache[16] = $event => ((_ctx.cellParams.showEditIcon) = $event))
          }, {
            title: withCtx(() => [
              (_ctx.cellParams.props.popTitle)
                ? (openBlock(), createElementBlock("div", _hoisted_34$1, toDisplayString(_ctx.cellParams.props.popTitle), 1 /* TEXT */))
                : createCommentVNode("v-if", true),
              createCommentVNode(" 文本域编辑 "),
              (!!_ctx.cellParams.props.popTextarea)
                ? (openBlock(), createElementBlock("div", _hoisted_35$1, [
                    createVNode(_component_Textarea, {
                      class: "sc-popconfirm-textarea",
                      value: _ctx.cellParams.value,
                      onChange: _ctx.handleChangeText,
                      placeholder: _ctx.cellParams.props.popTextarea.placeholder || '',
                      rows: "5"
                    }, null, 8 /* PROPS */, ["value", "onChange", "placeholder"]),
                    createElementVNode("div", _hoisted_36$1, toDisplayString(_ctx.cellParams.props.popTextarea.tips || ''), 1 /* TEXT */)
                  ]))
                : createCommentVNode("v-if", true),
              createCommentVNode(" 展示表格信息 "),
              (_ctx.cellParams.props.popContentTable)
                ? (openBlock(), createElementBlock("div", _hoisted_37$1, [
                    createVNode(_component_Table, {
                      dataSource: _ctx.dataSource,
                      columns: _ctx.cellParams.props.columns(_ctx.cellParams),
                      pagination: false,
                      bordered: ""
                    }, {
                      text: withCtx(({ record }) => [
                        createElementVNode("span", _hoisted_38$1, [
                          (record.url)
                            ? (openBlock(), createElementBlock("span", _hoisted_39$1, [
                                createElementVNode("a", {
                                  href: record.url,
                                  target: "_blank"
                                }, toDisplayString(record.text), 9 /* TEXT, PROPS */, _hoisted_40$1),
                                createElementVNode("i", {
                                  class: "iconfont icon-fuzhi-copy",
                                  onClick: withModifiers($event => (_ctx.copyText(record.text)), ["stop"])
                                }, "  ", 8 /* PROPS */, _hoisted_41$1)
                              ]))
                            : (openBlock(), createElementBlock("span", _hoisted_42$1, toDisplayString(record.text), 1 /* TEXT */))
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["dataSource", "columns"])
                  ]))
                : createCommentVNode("v-if", true),
              (_ctx.cellParams.props.popContent)
                ? (openBlock(), createElementBlock("div", _hoisted_43$1, toDisplayString(_ctx.cellParams.props.popContent), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ]),
            default: withCtx(() => [
              (!_ctx.cellParams.props.popTextarea)
                ? (openBlock(), createElementBlock("a", _hoisted_44$1, toDisplayString(_ctx.cellParams.props.text
            ? _ctx.cellParams.props.text(_ctx.cellParams)
            : _ctx.cellParams.value), 1 /* TEXT */))
                : createCommentVNode("v-if", true),
              (!!_ctx.cellParams.props.popTextarea)
                ? (openBlock(), createBlock(_component_FormOutlined, {
                    key: 1,
                    class: normalizeClass(["sc-grid-edit-icon", !!_ctx.cellParams.showEditIcon ? 'show-eidt-icon' : '']),
                    style: { fontSize: '16px' }
                  }, null, 8 /* PROPS */, ["class"]))
                : createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["overlayClassName", "cancelText", "okText", "onCancel", "onConfirm", "onVisibleChange", "overlayStyle", "visible"])
        ]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 下架 "),
    (_ctx.cellParams.props.type == 'cellPopconfirm')
      ? (openBlock(), createBlock(_component_CellPopconfirm, {
          key: 19,
          cellParams: _ctx.cellParams
        }, null, 8 /* PROPS */, ["cellParams"]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 复选框 "),
    (_ctx.cellParams.props.type == 'checkbox')
      ? (openBlock(), createElementBlock(Fragment, { key: 20 }, [
          (
          _ctx.cellParams.props.onShowTip && _ctx.cellParams.props.onShowTip(_ctx.cellParams)
        )
            ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
                key: 0,
                title: 
          _ctx.cellParams.props.tipTitle ||
            (_ctx.cellParams.props.tipTitleGetter &&
              _ctx.cellParams.props.tipTitleGetter(_ctx.cellParams))
        ,
                placement: _ctx.cellParams.props.tipPlacement || 'top',
                trigger: _ctx.cellParams.props.trigger || 'hover',
                overlayClassName: "sc-tooltip-light"
              }, { ..._ctx.cellParams.props.tooltipProps }), {
                default: withCtx(() => [
                  createVNode(_component_Checkbox, mergeProps({ ..._ctx.cellParams.props }, {
                    value: 
            (_ctx.cellParams.props.value && _ctx.cellParams.props.value(_ctx.cellParams)) ||
              _ctx.cellParams.value
          ,
                    name: _ctx.cellParams.field,
                    checked: 
            _ctx.cellParams.data[_ctx.cellParams.props.checkedField || 'checked']
          ,
                    "onUpdate:checked": _cache[17] || (_cache[17] = $event => ((
            _ctx.cellParams.data[_ctx.cellParams.props.checkedField || 'checked']
          ) = $event)),
                    disabled: 
            _ctx.cellParams.props.disChecked
              ? _ctx.cellParams.props.disChecked(_ctx.cellParams)
              : false
          
                  }), {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.cellParams.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */, ["value", "name", "checked", "disabled"])
                ]),
                _: 1 /* STABLE */
              }, 16 /* FULL_PROPS */, ["title", "placement", "trigger"]))
            : (openBlock(), createBlock(_component_Checkbox, mergeProps({ key: 1 }, { ..._ctx.cellParams.props }, {
                value: 
          (_ctx.cellParams.props.value && _ctx.cellParams.props.value(_ctx.cellParams)) ||
            _ctx.cellParams.value
        ,
                name: _ctx.cellParams.field,
                checked: 
          _ctx.cellParams.data[_ctx.cellParams.props.checkedField || 'checked']
        ,
                "onUpdate:checked": _cache[18] || (_cache[18] = $event => ((
          _ctx.cellParams.data[_ctx.cellParams.props.checkedField || 'checked']
        ) = $event)),
                disabled: 
          _ctx.cellParams.props.disChecked
            ? _ctx.cellParams.props.disChecked(_ctx.cellParams)
            : false
        
              }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.cellParams.value), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 16 /* FULL_PROPS */, ["value", "name", "checked", "disabled"]))
        ], 64 /* STABLE_FRAGMENT */))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 折扣、价格校验提示 "),
    (_ctx.cellParams.props.type == 'priceDiscountTip')
      ? (openBlock(), createBlock(_component_PriceDiscountTip, {
          key: 21,
          cellParams: _ctx.cellParams
        }, null, 8 /* PROPS */, ["cellParams"]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'packSpecificationTip')
      ? (openBlock(), createBlock(_component_PackSpecificationTip, {
          key: 22,
          cellParams: _ctx.cellParams
        }, null, 8 /* PROPS */, ["cellParams"]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 纠错型号 "),
    (_ctx.cellParams.props.type == 'mistakePopconfirm')
      ? (openBlock(), createElementBlock(Fragment, { key: 23 }, [
          (
          _ctx.cellParams.props.showErrorCell &&
            _ctx.cellParams.props.showErrorCell(_ctx.cellParams)
        )
            ? (openBlock(), createElementBlock("span", _hoisted_45$1, [
                createElementVNode("a", {
                  onClick: _cache[19] || (_cache[19] = withModifiers($event => (_ctx.handleMistakePopconfirm($event, _ctx.cellParams)), ["stop"]))
                }, "纠错"),
                createElementVNode("a", {
                  onClick: _cache[20] || (_cache[20] = withModifiers($event => (
            _ctx.cellParams.props.createModelClick &&
              _ctx.cellParams.props.createModelClick($event, _ctx.cellParams)
          ), ["stop"]))
                }, "新建")
              ]))
            : (openBlock(), createElementBlock("span", _hoisted_46$1, [
                (
            !_ctx.cellParams.props.onShowTip ||
              _ctx.cellParams.props.onShowTip(_ctx.cellParams)
          )
                  ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
                      key: 0,
                      title: 
            _ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value
          ,
                      placement: _ctx.cellParams.props.tipPlacement || 'top'
                    }, { ..._ctx.cellParams.props.tooltipProps }), {
                      default: withCtx(() => [
                        createElementVNode("span", _hoisted_47$1, toDisplayString(_ctx.cellParams.props.text
                ? _ctx.cellParams.props.text(_ctx.cellParams)
                : _ctx.cellParams.value), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 16 /* FULL_PROPS */, ["title", "placement"]))
                  : (openBlock(), createElementBlock("span", _hoisted_48$1, toDisplayString(_ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value), 1 /* TEXT */)),
                (_ctx.isShowCopy(_ctx.cellParams))
                  ? (openBlock(), createElementBlock("i", {
                      key: 2,
                      class: "iconfont icon-fuzhi-copy",
                      onClick: _cache[21] || (_cache[21] = withModifiers($event => (
            _ctx.copyText(
              _ctx.cellParams.props.text
                ? _ctx.cellParams.props.text(_ctx.cellParams)
                : _ctx.cellParams.value,
            )
          ), ["stop"]))
                    }, ""))
                  : createCommentVNode("v-if", true)
              ]))
        ], 64 /* STABLE_FRAGMENT */))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'tooltip')
      ? (openBlock(), createElementBlock(Fragment, { key: 24 }, [
          (
          !_ctx.cellParams.props.onShowTip || _ctx.cellParams.props.onShowTip(_ctx.cellParams)
        )
            ? (openBlock(), createBlock(_component_Tooltip, mergeProps({
                key: 0,
                title: 
          _ctx.cellParams.props.tipTitle ||
            (_ctx.cellParams.props.tipTitleGetter
              ? _ctx.cellParams.props.tipTitleGetter(_ctx.cellParams)
              : _ctx.cellParams.value)
        ,
                placement: _ctx.cellParams.props.tipPlacement || 'top',
                trigger: _ctx.cellParams.props.trigger || 'hover',
                overlayClassName: 
          _ctx.cellParams.props.tipTheme == 'light' ? 'sc-tooltip-light' : ''
        
              }, { ..._ctx.cellParams.props.tooltipProps }), {
                default: withCtx(() => [
                  (_ctx.cellParams.props.vnode)
                    ? (openBlock(), createElementBlock("span", _hoisted_49$1, [
                        createVNode(_component_vnodes, {
                          vNode: _ctx.cellParams.props.vnode(_ctx.cellParams)
                        }, null, 8 /* PROPS */, ["vNode"])
                      ]))
                    : (openBlock(), createElementBlock("span", {
                        key: 1,
                        class: "text-ellipsis",
                        innerHTML: 
            _ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value
          
                      }, null, 8 /* PROPS */, _hoisted_50$1))
                ]),
                _: 1 /* STABLE */
              }, 16 /* FULL_PROPS */, ["title", "placement", "trigger", "overlayClassName"]))
            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                (_ctx.cellParams.props.vnode)
                  ? (openBlock(), createElementBlock("span", _hoisted_51$1, [
                      createVNode(_component_vnodes, {
                        vNode: _ctx.cellParams.props.vnode(_ctx.cellParams)
                      }, null, 8 /* PROPS */, ["vNode"])
                    ]))
                  : (openBlock(), createElementBlock("span", {
                      key: 1,
                      class: "text-ellipsis",
                      innerHTML: 
            _ctx.cellParams.props.text
              ? _ctx.cellParams.props.text(_ctx.cellParams)
              : _ctx.cellParams.value
          
                    }, null, 8 /* PROPS */, _hoisted_52$1))
              ], 64 /* STABLE_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'warehouseInfoTips')
      ? (openBlock(), createBlock(_component_CellWarehouseInfoTips, {
          key: 25,
          cellParams: _ctx.cellParams
        }, null, 8 /* PROPS */, ["cellParams"]))
      : createCommentVNode("v-if", true),
    (_ctx.cellParams.props.type == 'image')
      ? (openBlock(), createBlock(_component_CellImages, {
          key: 26,
          cellParams: _ctx.cellParams
        }, null, 8 /* PROPS */, ["cellParams"]))
      : createCommentVNode("v-if", true)
  ]))
}

script$1g.render = render$19;
script$1g.__file = "packages/grid/src/components/CellCommonRenderer/CellCommonRenderer.vue";

var script$1f = defineComponent({
  name: 'CustomHeader',
  components: {
    'a-tooltip': markRaw(Tooltip),
    'a-checkbox': Checkbox,
    'a-button': Button,
  },
  data() {
    return {
      ascSort: null,
      descSort: null,
      noSort: null,
      checked: false,
    };
  },
  mounted() {
    if (this.params.enableSorting) {
      this.params.column.addEventListener('sortChanged', this.onSortChanged);
      this.onSortChanged();
      if (this.params.onBackendSorting || this.params.backendSorting) {
        this.setBackendSortingIcon();
      }
    }
    this.checked = this.params.checked;
  },
  methods: {
    onBackendSorting,
    // 点击显示菜单
    onMenuClicked() {
      if (this.params.column.colDef.filter) {
        this.params.column.colDef.menuTabs = [
          'generalMenuTab',
          'columnsMenuTab',
        ];
      }
      this.params.showColumnMenu(this.$refs.eMenu);
    },
    // 切换排序图标
    onSortChanged() {
      this.ascSort = this.descSort = this.noSort = 'inactive';
      if (this.params.column.isSortAscending()) {
        this.ascSort = 'active';
      } else if (this.params.column.isSortDescending()) {
        this.descSort = 'active';
      } else {
        this.noSort = 'active';
      }
    },
    // 点击表头排序
    onProgressSort(event) {
      if (this.params.enableSorting) {
        if (this.params.onBackendSorting) {
          // 后端排序方法
          const sort = this.doBackendSorting();
          const field =
            this.params.column.colDef.sortField ||
            this.params.column.colDef.field;
          this.params.onBackendSorting(sort, field);
        } else if (this.params.backendSorting) {
          // 后端排序属性
          const sort = this.doBackendSorting();
          const field =
            this.params.column.colDef.sortField ||
            this.params.column.colDef.field;
          this.onBackendSorting(sort, field);
        } else {
          // 前端排序
          this.params.progressSort(event.shiftKey);
          if (this.params.onSortChanged) {
            const order = this.params.column.getSort();
            this.params.onSortChanged(order, this.params);
          }
        }
      }
    },
    setBackendSortingIcon(sort = '') {
      const column = this.params.column;
      const field = column.colDef.sortField || column.colDef.field;
      const prototype = column.constructor.prototype;

      // 后端初始排序
      if (sort === '') sort = column.colDef.sort || null;
      column.backendSort = sort;
      // 单排序
      prototype.sortState = [];
      prototype.sortState.push({ [field]: sort });
      column.isSortAscending = () => column.backendSort === 'asc';
      column.isSortDescending = () => column.backendSort === 'desc';
    },
    doBackendSorting() {
      // 1. 排序轮询
      const sort = this.params.column.backendSort;
      const sortMap = this.params.column.colDef.sortingOrder || [
        'desc',
        'asc',
        null,
      ];
      let index = sortMap.indexOf(sort) + 1;
      index >= sortMap.length && (index = 0);
      // 2. 修改icon
      this.setBackendSortingIcon(sortMap[index]);
      this.onSortChanged();
      return sortMap[index];
    },
    // 点击过滤图标
    showParentFilter(event) {
      this.params.column.colDef.menuTabs = ['filterMenuTab'];
      this.params.showColumnMenu(event.target);
    },
    // checkbox改变回调
    onCheckedChange(event) {
      this.params.onCheckedChange && this.params.onCheckedChange(event);
    },
    expandAll() {
      this.params.api.expandAll();
    },
    collapseAll() {
      this.params.api.collapseAll();
    },
  },
});

const _hoisted_1$$ = /*#__PURE__*/createElementVNode("span", {
  class: "ag-icon ag-icon-menu",
  unselectable: "on",
  role: "presentation"
}, null, -1 /* HOISTED */);
const _hoisted_2$M = [
  _hoisted_1$$
];
const _hoisted_3$C = { class: "ag-header-cell-label" };
const _hoisted_4$u = {
  ref: "eText",
  class: "ag-header-cell-text",
  unselectable: "on"
};
const _hoisted_5$m = ["innerHTML"];
const _hoisted_6$g = /*#__PURE__*/createElementVNode("i", { class: "iconfont sc-explain-icon" }, "", -1 /* HOISTED */);
const _hoisted_7$e = /*#__PURE__*/createElementVNode("span", {
  class: "ag-icon ag-icon-asc",
  unselectable: "on",
  role: "presentation"
}, null, -1 /* HOISTED */);
const _hoisted_8$d = [
  _hoisted_7$e
];
const _hoisted_9$c = /*#__PURE__*/createElementVNode("span", {
  class: "ag-icon ag-icon-desc",
  unselectable: "on",
  role: "presentation"
}, null, -1 /* HOISTED */);
const _hoisted_10$a = [
  _hoisted_9$c
];
const _hoisted_11$a = /*#__PURE__*/createElementVNode("span", {
  class: "ag-icon ag-icon-none",
  unselectable: "on",
  role: "presentation"
}, null, -1 /* HOISTED */);
const _hoisted_12$a = [
  _hoisted_11$a
];
const _hoisted_13$6 = {
  key: 0,
  class: "ag-icon ag-icon-search iconfont",
  unselectable: "on",
  role: "presentation",
  innerHTML: ''
};
const _hoisted_14$7 = {
  key: 1,
  class: "ag-icon ag-icon-filter",
  unselectable: "on",
  role: "presentation"
};
const _hoisted_15$7 = {
  key: 4,
  class: "ag-header-icon ag-header-label-icon ag-tree-expand-collapse-icon sc-expand-collapse-buttons"
};
const _hoisted_16$7 = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont expand-all",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_17$5 = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont collapse-all",
  innerHTML: ''
}, null, -1 /* HOISTED */);

function render$18(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_tooltip = resolveComponent("a-tooltip");
  const _component_a_button = resolveComponent("a-button");

  return (openBlock(), createElementBlock("div", {
    class: "ag-cell-label-container sc-custom-header",
    onClick: _cache[5] || (_cache[5] = $event => (_ctx.onProgressSort($event)))
  }, [
    createCommentVNode(" 菜单 "),
    (_ctx.params.enableMenu)
      ? (openBlock(), createElementBlock("span", {
          key: 0,
          ref: "eMenu",
          class: "ag-header-icon ag-header-cell-menu-button",
          "aria-hidden": "true",
          onClick: _cache[0] || (_cache[0] = withModifiers($event => (_ctx.onMenuClicked($event)), ["stop"]))
        }, _hoisted_2$M, 512 /* NEED_PATCH */))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 表头文本 "),
    createElementVNode("div", _hoisted_3$C, [
      createElementVNode("span", _hoisted_4$u, [
        createCommentVNode(" 支持传入组件 "),
        createElementVNode("span", null, toDisplayString(_ctx.params.displayName), 1 /* TEXT */),
        (_ctx.params.showCheckbox)
          ? (openBlock(), createBlock(_component_a_checkbox, {
              key: 0,
              checked: _ctx.checked,
              "onUpdate:checked": _cache[1] || (_cache[1] = $event => ((_ctx.checked) = $event)),
              onChange: _cache[2] || (_cache[2] = $event => (_ctx.onCheckedChange($event))),
              onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["stop"]))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.params.checkboxText), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["checked"]))
          : createCommentVNode("v-if", true),
        createCommentVNode(" 问号 "),
        (_ctx.params.enableExplain)
          ? (openBlock(), createBlock(_component_a_tooltip, mergeProps({
              key: 1,
              zIndex: 99999,
              overlayClassName: "sc-tooltip-light"
            }, { ..._ctx.params.explainTipParams }), {
              title: withCtx(() => [
                createElementVNode("div", {
                  innerHTML: _ctx.params.explainTipHtml
                }, null, 8 /* PROPS */, _hoisted_5$m)
              ]),
              default: withCtx(() => [
                _hoisted_6$g
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */))
          : createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */),
      createCommentVNode(" 排序 "),
      (_ctx.params.enableSorting)
        ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass([_ctx.ascSort, "ag-header-icon ag-header-label-icon ag-sort-ascending-icon"]),
            ref: "eSortAsc",
            "aria-hidden": "true"
          }, _hoisted_8$d, 2 /* CLASS */))
        : createCommentVNode("v-if", true),
      (_ctx.params.enableSorting)
        ? (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass([_ctx.descSort, "ag-header-icon ag-header-label-icon ag-sort-descending-icon"]),
            ref: "eSortDesc",
            "aria-hidden": "true"
          }, _hoisted_10$a, 2 /* CLASS */))
        : createCommentVNode("v-if", true),
      (_ctx.params.enableSorting)
        ? (openBlock(), createElementBlock("span", {
            key: 2,
            class: normalizeClass([_ctx.noSort, "ag-header-icon ag-header-label-icon ag-sort-none-icon"]),
            ref: "eSortNone",
            "aria-hidden": "true"
          }, _hoisted_12$a, 2 /* CLASS */))
        : createCommentVNode("v-if", true),
      createCommentVNode(" 过滤 "),
      (!!_ctx.params.column.colDef.filter)
        ? (openBlock(), createElementBlock("span", {
            key: 3,
            ref: "eFilter",
            class: "ag-header-icon ag-header-label-icon ag-filter-icon",
            onClick: _cache[4] || (_cache[4] = withModifiers((...args) => (_ctx.showParentFilter && _ctx.showParentFilter(...args)), ["stop"]))
          }, [
            (_ctx.params.filterIcon && _ctx.params.filterIcon == 'search')
              ? (openBlock(), createElementBlock("i", _hoisted_13$6))
              : (openBlock(), createElementBlock("span", _hoisted_14$7))
          ], 512 /* NEED_PATCH */))
        : createCommentVNode("v-if", true),
      createCommentVNode(" 树表格展开收起 "),
      (_ctx.params.treeExpandOrCollapse)
        ? (openBlock(), createElementBlock("span", _hoisted_15$7, [
            createVNode(_component_a_tooltip, {
              placement: "top",
              title: "全部展开"
            }, {
              default: withCtx(() => [
                createVNode(_component_a_button, {
                  type: "text",
                  size: "small",
                  onClick: _ctx.expandAll
                }, {
                  default: withCtx(() => [
                    _hoisted_16$7
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_a_tooltip, {
              placement: "top",
              title: "全部收起"
            }, {
              default: withCtx(() => [
                createVNode(_component_a_button, {
                  type: "text",
                  size: "small",
                  onClick: _ctx.collapseAll
                }, {
                  default: withCtx(() => [
                    _hoisted_17$5
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : createCommentVNode("v-if", true)
    ])
  ]))
}

script$1f.render = render$18;
script$1f.__file = "packages/grid/src/components/CustomHeader.vue";

var script$1e = defineComponent({
  name: 'CustomFilter',
  components: {
    BasicFormItem: script$1v,
  },
  data() {
    return {
      item: { key: '' },
      itemData: {
        keywords: {},
        tags: {},
      },
    };
  },
  mounted() {
    const options = this.params.options || [];
    const column = this.params.column;
    const key = column.colDef.filterField || column.colDef.field;
    this.item = {
      key,
      type: this.params.type || 'MultipleSelect',
      width: '100%',
      props: {
        open: true,
        onOnOk: this.onConfrim,
      },
      options,
    };
  },
  computed: {
    optionsClass: function() {
      return (
        'sc-options-' + (this.params.options && this.params.options.length)
      );
    },
  },
  methods: {
    onBackendFilting,
    onConfrim() {
      this.onBackendFilting(this.itemData);
      this.params.api.hidePopupMenu();
    },
    updateFilter() {
      // this.params.filterChangedCallback();
    },

    doesFilterPass(params) {
      // return params.data.year >= 2010;
    },

    isFilterActive() {
      // return this.year === '2010';
    },

    // this example isn't using getModel() and setModel(),
    // so safe to just leave these empty. don't do this in your code!!!
    getModel() {
      //
    },

    setModel() {
      //
    },
  },
});

function render$17(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["sc-filter-item", _ctx.optionsClass])
  }, [
    (openBlock(), createBlock(_component_BasicFormItem, {
      key: _ctx.item.key,
      item: _ctx.item,
      value: _ctx.itemData.keywords[_ctx.item.key],
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.itemData.keywords[_ctx.item.key]) = $event)),
      tag: _ctx.itemData.tags[_ctx.item.key],
      "onUpdate:tag": _cache[1] || (_cache[1] = $event => ((_ctx.itemData.tags[_ctx.item.key]) = $event))
    }, null, 8 /* PROPS */, ["item", "value", "tag"]))
  ], 2 /* CLASS */))
}

script$1e.render = render$17;
script$1e.__file = "packages/grid/src/components/CustomFiter.vue";

var script$1d = defineComponent({
    name: 'CustomIndex',
    props: ['params'],
});

const _hoisted_1$_ = { class: "sc-custom-index" };
const _hoisted_2$L = /*#__PURE__*/createElementVNode("span", { class: "sc-custom-index-color-section" }, null, -1 /* HOISTED */);

function render$16(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tooltip = resolveComponent("a-tooltip");

  return (openBlock(), createElementBlock("div", _hoisted_1$_, [
    (_ctx.params.tip && _ctx.params.tip(_ctx.params))
      ? (openBlock(), createBlock(_component_a_tooltip, {
          key: 0,
          placement: "top",
          overlayClassName: "sc-tooltip-light",
          zIndex: 99999
        }, {
          title: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.params.tip(_ctx.params)), 1 /* TEXT */)
          ]),
          default: withCtx(() => [
            _hoisted_2$L
          ]),
          _: 1 /* STABLE */
        }))
      : createCommentVNode("v-if", true),
    createTextVNode(" " + toDisplayString(_ctx.params.valueFormatted), 1 /* TEXT */)
  ]))
}

script$1d.render = render$16;
script$1d.__file = "packages/grid/src/components/CustomIndex.vue";

var script$1c = {
    name: 'TreeNodeCellRenderer',
    components: {
        'a-select': Select,
    },
    props: {
        params: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            value: '',
            clickable: false,
            copyable: false,
            selectable: false,
            options: [],
            placeholder: '',
        };
    },
    beforeMount() {
        const { params } = this;
        const { props = {} } = params;
        this.value = params?.value;
        this.clickable = props.clickable;
        this.copyable = props.copyable;
        this.selectable = props.useSelect ? props.useSelect(params.data) : false;
        this.options = props.options || [];
        this.placeholder = props.placeholder;
    },
    computed: {
        selectedValue() {
            return this.params?.props?.value
                ? this.params?.props?.value(this.params?.data)
                : this.params?.props?.value;
        },
    },
    methods: {
        onClick() {
            this.params?.props?.onClick && this.params.props.onClick(this.params);
        },
        handleCopy(value) {
            copy(value);
        },
        handleSelect(selectedId) {
            this.params?.props?.onSelect
                ? this.params?.props?.onSelect(selectedId, this.params?.data)
                : null;
        },
        expandPart() {
            this.params.node.setExpanded(true);
            this.params.node.allChildrenCount;
            this.params.node.childrenAfterGroup?.forEach((c) => c.setExpanded(true));
        },
        collapsePart() {
            this.params.node.setExpanded(false);
            this.params.node.childrenAfterGroup?.forEach((c) => c.setExpanded(false));
        },
    },
};

const _hoisted_1$Z = { class: "basic-grid-tree-node-cell" };
const _hoisted_2$K = { key: 2 };
const _hoisted_3$B = {
  key: 3,
  class: "icons sc-expand-collapse-buttons"
};
const _hoisted_4$t = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont expand-all",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_5$l = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont collapse-all",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_6$f = { key: 4 };

function render$15(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_select = resolveComponent("a-select");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_tooltip = resolveComponent("a-tooltip");

  return (openBlock(), createElementBlock("span", _hoisted_1$Z, [
    ($data.selectable)
      ? (openBlock(), createBlock(_component_a_select, {
          key: 0,
          showSearch: "",
          maxTagTextLength: 10,
          maxTagCount: 2,
          showArrow: true,
          bordered: false,
          style: {"width":"100%"},
          placeholder: $data.placeholder,
          value: $options.selectedValue,
          options: $data.options,
          onChange: $options.handleSelect
        }, null, 8 /* PROPS */, ["placeholder", "value", "options", "onChange"]))
      : createCommentVNode("v-if", true),
    ($data.clickable)
      ? (openBlock(), createElementBlock("a", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClick && $options.onClick(...args)))
        }, toDisplayString($data.value), 1 /* TEXT */))
      : (openBlock(), createElementBlock("span", _hoisted_2$K, toDisplayString($data.value), 1 /* TEXT */)),
    (!$data.selectable && $props.params.node.allChildrenCount)
      ? (openBlock(), createElementBlock("span", _hoisted_3$B, [
          createVNode(_component_a_tooltip, {
            placement: "top",
            title: "局部展开"
          }, {
            default: withCtx(() => [
              createVNode(_component_a_button, {
                type: "text",
                size: "small",
                onClick: withModifiers($options.expandPart, ["stop"])
              }, {
                default: withCtx(() => [
                  _hoisted_4$t
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          }),
          createVNode(_component_a_tooltip, {
            placement: "top",
            title: "局部收起"
          }, {
            default: withCtx(() => [
              createVNode(_component_a_button, {
                type: "text",
                size: "small",
                onClick: withModifiers($options.collapsePart, ["stop"])
              }, {
                default: withCtx(() => [
                  _hoisted_5$l
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : createCommentVNode("v-if", true),
    ($data.copyable)
      ? (openBlock(), createElementBlock("span", _hoisted_6$f, [
          createTextVNode("   "),
          createElementVNode("i", {
            class: "iconfont icon-fuzhi-copy",
            onClick: _cache[1] || (_cache[1] = withModifiers($event => ($options.handleCopy($data.value)), ["stop"]))
          }, "  ")
        ]))
      : createCommentVNode("v-if", true)
  ]))
}

script$1c.render = render$15;
script$1c.__file = "packages/grid/src/components/CellCommonRenderer/TreeNodeCellRenderer.vue";

LicenseManager.setLicenseKey(
  'DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6',
);

const isFullRow = '__is_full_row__';
const stateConfig$1 = 'sc_baisc_grid_config';

var script$1b = defineComponent({
  name: 'BasicGrid',
  data() {
    return {
      rowHeightTimer: null,
      rowHeightTimerShow: false,
      isGridBarShow: false,
      isRefShow: false,
      isIconShow: false,
      selectedData: 0,
      checked: false,
      isRowSelectable: null,
      // rowData: null,
      localeText: { ...AG_GRID_LOCALE_CN },
      modules: AllModules,
      // gridOptions: {},
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        resizable: true,
      },
      fixParams: {},
      getRowHeight: null,
      isFullWidthRow: null,
      fullWidthCellRenderer: null,
      throttleValid: true,
      timeout: null,
      isScrollUp: false,
      lastedScrollTop: 0,
      isRedrawRunning: false,
      isBrekLoop: false,
      isSkipStep: true,
      cacheElements: {},
      scrollNext: 0,
      scrollAreaWidth: 0,
      tableBodyWidth: 0,
      tableViewWidth: 0,
      frameworkComponents: null,
      lineHeight: [24, 30, 40],
      arrIndex: 1,
      pageIndex: 1,
      pageSize: 100,
      totalCount: 0,
      pageSizeOptions: ['40', '60', '80', '100', '200'],
      painedTimerIds: new Set(),
      rightPinnedCols: [],
      totalRowDataTop: [],
      totalRowDataBottom: [],
      insertRowBtnTop: 0,
      insertRowBtnHide: true,
      insertRowNode: null,
      pinnedLeft: true,
      pinnedRight: false,
      isTreeFlatten: false,
    };
  },
  components: {
    'a-pagination': Pagination,
    AgGridVue,
    Scrollbar: script$1q,
    /* eslint-disable-next-line */
    CellCommonRenderer: script$1g,
  },
  emits: [
    'gridReady',
    'rowSelected',
    'pageChange',
    'rowDataChanged',
    'cellEditingStarted',
    'cellEditingStopped',
    'rowDragEnd',
    'rowGroupOpened',
  ],
  props: {
    isChangeRow: {
      type: Boolean,
      default: false,
    },
    isRenderTotal: {
      type: Boolean,
      default: false,
    },
    isCheckAllBox: {
      type: [Boolean],
      default: false,
    },
    isBorder: {
      type: [Boolean],
      default: false,
    },
    isShowSetButton: {
      type: [Boolean],
      default: false,
    },
    isTreeData: {
      type: Boolean,
      default: false,
    },
    suppressRowClickSelection: {
      type: Boolean,
      default: false,
    },
    autoGroupColumnDef: {
      type: Object,
      default: () => ({}),
    },
    gridOptions: {
      type: Object,
      default: () => ({}),
    },
    gridDefs: {
      type: Object,
      default: () => ({}),
    },
    headerHeight: {
      type: Number,
      default: 30,
    },
    totalData: {
      type: Array,
      default: () => [],
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Array,
      required: true,
      default: () => [],
    },
    rowBuffer: {
      type: Number,
      default: 10,
    },
    rowHeight: {
      type: Number,
      default: 30,
    },
    autoHeight: {
      type: [Boolean],
      default: false,
    },
    indexField: {
      type: String,
      default: 'id',
    },
    pageData: {
      type: Object,
      default: () => null,
    },
    disableByName: {
      type: String,
      default: 'isDisable',
    },
    iconBtns: {
      type: Array,
      default: () => [],
    },
    noRowsText: {
      type: String,
      default: '没有查到符合条件的数据',
    },
    rowSelectedNoBgColor: {
      type: [Boolean],
      default: false,
    },
    showQuickJumper: {
      type: [Boolean],
      default: false,
    },
    // '' | 'top', 'bottom'
    showTotalRow: {
      type: String,
      default: '',
    },
    totalRowData: {
      type: Object,
      default: () => null,
    },
    showInsertRowBtn: {
      type: Boolean,
      default: false,
    },
    isSavePageSize: {
      type: [Boolean],
      default: true,
    },
    rowModelType: {
      type: String,
      default: 'clientSide',
    },
    getGridContainer: {
      type: Function,
    },
    isServerSideGroup: {
      type: Function,
    },
    getServerSideGroupKey: {
      type: Function,
    },
    isServerSideGroupOpenByDefault: {
      type: Function,
    },
    relationSearchId: {
      type: String,
      default: '',
    },
  },
  beforeMount() {
    // 优先读取表格本地设置
    this.initGridConfig();
    this.frameworkComponents = {
      DefaultTooltip: script$1p,
      CustomHeader: script$1f,
      CustomFiter: script$1e,
      CustomIndex: script$1d,
      TreeNodeCellRenderer: script$1c,
    };
    // 行高
    this.getRowHeight = () => {
      if (this.autoHeight) return null;
      return this.rowHeightRef;
    };
    // checkbox选择
    // isDisable是否禁用复选框，默认不传值为false
    // 判断是否可以获得可选择,要求行内有数据而且数据check了
    this.isRowSelectable = (rowNode) => {
      return rowNode.data && !rowNode.data[this.disableByName];
    };
    // 获得项数(非禁用项)
    this.countSelectable = (rowData) => {
      return rowData.map((v) => ({ data: v })).filter(this.isRowSelectable)
        .length;
    };
    this.selectableCount = this.countSelectable(this.rowData);
    // 可编辑列样式-深度遍历
    this.deepLoop(this.columnDefs, this.gridDefs && this.gridDefs.headerGroup);
    this.isFullWidthRow = ({ rowNode }) => {
      const defaultInViewportNumber = ~~(
        (window.innerHeight * 1.5) /
        this.rowHeightRef
      );
      // true 默认显示为全宽行
      // 初始状态isFullRow未定义，
      return rowNode?.data?.[isFullRow] === undefined
        ? rowNode.rowIndex > defaultInViewportNumber
        : rowNode.data[isFullRow];
    };
    this.fullWidthCellRenderer = () => {
      // 插入全宽行样式
      const eDiv = document.createElement('div');
      eDiv.innerHTML = '<div class="list-full-row"></div>';
      return eDiv.firstChild;
    };
    this.setNoRowsToShow();
  },
  inject: {
    setKeywords: {
      from: 'setKeywords',
      default: () => () => null,
    },
  },
  computed: {
    computedAutoGroupColumnDef() {
      const autoGroupColumnDef = this.autoGroupColumnDef || {};
      const cellRendererParams = autoGroupColumnDef.cellRendererParams || {};
      const def = {
        ...autoGroupColumnDef,
        cellRendererParams: {
          ...cellRendererParams,
          innerRenderer: 'TreeNodeCellRenderer',
        },
        headerComponent: 'CustomHeader',
        headerComponentParams: {
          ...(autoGroupColumnDef.headerComponentParams ?? {}),
          treeExpandOrCollapse: this.isServerSideGroup ? false : true,
        },
      };
      return def;
    },
    computedGetRowId() {
      const getRowId = (params) => {
        return params.data[this.autoGroupColumnDef.field];
      };
      return this.autoGroupColumnDef && this.isTreeData
        ? getRowId
        : this.$props.getRowId || void 0;
    },
    computedRowData() {
      if (
        this.isTreeData &&
        this.rowModelType === 'clientSide' &&
        this.autoGroupColumnDef
      ) {
        const { field, childrenKey = 'children' } = this.autoGroupColumnDef;
        const flattenRowData = this.getRecursiveFlattenData(
          this.rowData,
          field,
          childrenKey,
        );
        return flattenRowData;
      } else {
        return this.rowData;
      }
    },
    rowDragManaged() {
      const autoGroupColumnDef = this.autoGroupColumnDef || {};
      if (autoGroupColumnDef.rowDrag) return false;
      return true;
    },
    suppressMoveWhenRowDragging() {
      const autoGroupColumnDef = this.autoGroupColumnDef || {};
      if (autoGroupColumnDef.rowDrag) return true;
      return false;
    },
  },
  mounted() {
    //接口api
    this.isRefShow = true;
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.$insertRowBtn = document.getElementById('insertRowBtn');
    this.$el.addEventListener('mouseenter', this.onMouseEnterTable);
  },
  watch: {
    isRefShow: {
      handler() {
        if (this.isRefShow) {
          this.isIconShow = this.findParent(this.$refs.gridRef);
        }
      },
      deep: true,
    },
    pageData: {
      handler() {
        this.initPageData();
      },
      deep: true,
    },
    rowData: {
      handler() {
        // 解决Grid配置或数据改变时
        // this.gridApi.setRowData(rd);
        this.throttle(this.onRedrawRows, 0);
      },
    },
    noRowsText: {
      handler() {
        this.setNoRowsToShow();
      },
    },
    totalRowData: {
      handler() {
        this.initTotalRowData();
      },
    },
  },
  methods: {
    deepLoop,
    getContextMenuItems,
    resetPinnedHeaderWidth,
    getMainMenuItems,
    resetColsWidth,
    sendToClipboard,
    getTotalRowData,
    setNoRowsToShow() {
      // 设置无数据文本
      this.noRowsText && (this.localeText.noRowsToShow = this.noRowsText);
    },
    initTotalRowData() {
      if (this.$props.showTotalRow) {
        const totalRowDatas = initTotalRowData(
          this.columnDefs,
          this.totalRowData,
          isFullRow,
          this.rowData,
        );
        this.frontTotalRowData = totalRowDatas[0];
        if (this.$props.showTotalRow === 'top') {
          this.totalRowDataTop = totalRowDatas;
        } else {
          this.totalRowDataBottom = totalRowDatas;
        }
      }
    },
    initShowCols() {
      const columnState = this.gridColumnApi.getColumnState();
      const state = initShowCols(this.columnDefs, this.rowData, columnState);
      state && this.gridColumnApi.applyColumnState({ state, applyOrder: true });
    },
    handleMouseEnterGrid() {
      this.isGridBarShow = true;
      this.rowHeightTimerShow = true;
      clearTimeout(this.rowHeightTimer);
    },
    handleMouseLeaveGrid() {
      this.isGridBarShow = false;
      this.rowHeightTimer = setTimeout(() => {
        this.rowHeightTimerShow = false;
      }, 500);
    },
    //设置全选
    checkedAll() {
      // this.checked = !this.checked;
      if (this.checked) {
        this.gridApi.selectAll();
      } else {
        this.gridApi.deselectAll();
      }
    },
    // checked是全选复选框是否是选中的状态
    //监测复选框选中的个数
    onSelectionChanged() {
      // this.gridApi.getSelectedRows()获取选中的行
      var selRows = this.gridApi.getSelectedRows();

      // selectedData选中行的行数
      this.selectedData = selRows.length;
      this.checked =
        this.selectedData > 0 &&
        this.selectedData === this.countSelectable(this.rowData);
    },
    // 当数据发生变化时，清除全选框的选中状态
    onRowDataChanged(params) {
      this.selectableCount = this.countSelectable(this.rowData);
      var selRows = this.gridApi.getSelectedRows();
      this.selectedData = selRows.length;
      if (
        this.selectedData === this.selectableCount &&
        this.selectableCount != 0
      ) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      // 初始化列权限
      this.initShowCols();
      this.initTotalRowData();
      this.$emit('rowDataChanged', params);
    },
    onRowSelected(params) {
      if (this.showTotalRow) {
        const selectedData = params.api.getSelectedRows();
        const totalRowDatas = this.getTotalRowData(
          this.columnDefs,
          selectedData,
          this.totalRowData || this.frontTotalRowData,
          isFullRow,
        );
        if (this.showTotalRow === 'top') {
          this.totalRowDataTop = totalRowDatas;
        } else {
          this.totalRowDataBottom = totalRowDatas;
        }
      }
      this.$emit('rowSelected', params);
    },
    // 删除选中行
    delRowNode() {
      var selRows = this.gridApi.getSelectedRows(); //获取选中的行
      if (selRows.length <= 0) {
        alert('请选中一行数据');
      }
      this.gridApi.updateRowData({ remove: selRows });
    },
    initGridConfig() {
      this.stateConfig = stateConfig$1 + (this.$attrs.id || '');
      const config = getState(this.stateConfig);
      this.rowHeightRef = config.rowHeight || this.rowHeight;
      this.arrIndex = this.lineHeight.findIndex((e) => e === this.rowHeightRef);
      let allColumns = this.autoGroupColumnDef
        ? [this.autoGroupColumnDef].concat(this.columnDefs)
        : this.columnDefs;
      if (
        config.columnState &&
        allColumns.length !== config.columnState.length
      ) {
        if (this.autoGroupColumnDef) {
          allColumns[0] = { filed: 'ag-Grid-AutoColumn' };
        }
        mergeColumnState(config.columnState, allColumns);
      }
      this.columnState = config.columnState;
      if (this.pageData) {
        const pageData = this.pageData;
        if (typeof pageData.pageIndex === 'number') {
          this.pageIndex = pageData.pageIndex;
        } else {
          pageData.pageIndex = this.pageIndex;
        }
        if (typeof pageData.pageSize === 'number') {
          this.pageSize = pageData.pageSize;
        } else {
          pageData.pageSize = this.pageSize;
        }
        this.isSavePageSize &&
          config.pageSize &&
          (pageData.pageSize = config.pageSize);
      }
    },
    initFixParams() {
      const dom = this.$el;
      this.fixParams = {
        mainDom: document.getElementsByClassName('main')[0],
        agGridDom: dom.getElementsByClassName('ag-theme-balham')[0],
        footDom: dom.getElementsByClassName('sc-footer')[0],
        fixDom: document.querySelector('.J-sc-affix'),
        totalDom: dom.querySelector('.sc-table-total'),
        agHeadDoms: dom.getElementsByClassName('ag-header'),
        agViewDoms: dom.getElementsByClassName('ag-body-viewport'),
      };
      if (!HTMLCollection.prototype.forEach) {
        HTMLCollection.prototype.forEach = Array.prototype.forEach;
      }
      if (!Array.prototype.findLastIndex) {
        Array.prototype.findLastIndex = function(cb) {
          for (let i = this.length - 1; i >= 0; i--) {
            if (cb(this[i], i)) return i;
          }
          return -1;
        };
      }
      if (this.fixParams.mainDom) {
        (
          (this.getGridContainer && this.getGridContainer()) ||
          this.fixParams.mainDom
        ).addEventListener('scroll', this.onMainScroll);
      }
      this.onMutationObserver();
    },
    doFixedHeader() {
      const scrollTop = this.fixParams.mainDom.scrollTop;
      this.isScrollUp = scrollTop < this.lastedScrollTop ? true : false;
      this.lastedScrollTop = scrollTop;
      // -1为解决无tag-bar时，total-bar上边框和mian下边框重叠
      const tagTop = this.fixParams.fixDom
        ? this.fixParams.fixDom.offsetHeight
        : 0;
      const totalTop = this.fixParams.totalDom
        ? this.fixParams.totalDom.offsetHeight
        : 0;
      const top = tagTop + totalTop;
      this.fixParams.totalDom &&
        (this.fixParams.totalDom.style.top = tagTop + 'px');
      this.fixParams.agHeadDoms.forEach((e) => {
        e.style.top = top + 'px';
      });
    },
    doFixedFooter() {
      if (!this.fixParams.footDom) return;
      const view = this.fixParams.agViewDoms[0].getBoundingClientRect();
      const height = this.fixParams.footDom.offsetHeight;
      const vh = document.body.clientHeight;
      if (view.bottom + height >= vh) {
        // footer在视窗外
        const width = this.fixParams.agGridDom.offsetWidth;
        this.fixParams.footDom.style.position = `sticky`;
        this.fixParams.footDom.style.width = `${width}px`;
      } else {
        // 还原footer
        this.fixParams.footDom.style.position = 'static';
        this.fixParams.footDom.style.width = '100%';
      }
    },
    onMutationObserver() {
      //监听表格高度变化，更新Footer高度
      const $tar = this.fixParams.agViewDoms[0];
      const option = {
        attributes: true, // 属性的变动
        attributeFilter: ['class', 'style'], // 观察特定属性
      };
      new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type == 'attributes') {
            // this.doFixedFooter();
            this.onMainScroll();
          }
        }
      }).observe($tar, option);
      // observer.disconnect();
    },
    onMainScroll() {
      this.doFixedHeader();
      this.throttle(this.onRedrawRows, 100);
    },
    throttle(fn, delay) {
      // 节流
      if (!this.throttleValid) return false;
      this.throttleValid = false;
      // 清除前一个还未执行的定时任务
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        fn();
        this.throttleValid = true;
      }, delay);
    },
    addEvent() {
      // 绑定固钉表格标题事件
      this.initFixParams();
    },
    onGridReady(params) {
      // 获取表格视图宽度
      this.saveGridConfig();
      this.addEvent();
      if (this.columnState)
        this.gridColumnApi.applyColumnState({
          state: this.columnState,
          applyOrder: true,
        });
      // 列载入完成后再绑定事件
      setTimeout(this.colsEvent, 100);
      // 取表格列dom
      this.fixParams.agColsDom = this.$el.getElementsByClassName(
        'ag-center-cols-container',
      )[0];
      this.fixParams.agFullDom = this.$el.getElementsByClassName(
        'ag-full-width-container',
      )[0];
      this.$emit('gridReady', params);
    },
    // 表格设置
    handleSetSideBar() {
      this.showSideBar = !this.showSideBar;
      if (this.showSideBar) {
        this.gridApi.setSideBar('columns');
        this.$nextTick(() => {
          const panel = document.querySelector(
            '.ag-side-bar .ag-pivot-mode-panel',
          );
          if (panel) {
            panel.innerHTML = '<i class="iconfont">&#xa19;</i> 列设置';
          }
        });
      } else {
        this.gridApi.setSideBarVisible(false);
      }
    },
    // 树形表格切换树结构与平铺展示
    handleToggleTreeFlatten() {
      this.isTreeFlatten = !this.isTreeFlatten;
      this.onRedrawRows();
    },
    // 改变行高
    onChangeRowHeight() {
      this.arrIndex = this.arrIndex == 2 ? 0 : ++this.arrIndex;
      this.rowHeightRef = this.lineHeight[this.arrIndex];
      this.gridApi.resetRowHeights();
      this.saveGridConfig();
      this.arrIndex === 0 && this.resetPinnedHeaderWidth();
    },
    onGridSizeChanged({ columnApi }) {
      // 计算表格宽度 给ScrollBar使用
      this.calcTableWidth(columnApi.columnModel);
    },
    onGridColumnsChanged({ columnApi }) {
      // 表格列改变时重新计算表格宽度
      this.calcTableWidth(columnApi.columnModel);
    },
    onBodyScroll({ direction, left }) {
      if (direction === 'horizontal') {
        this.scrollNext = (left * this.scrollAreaWidth) / this.tableBodyWidth;
        this.pinnedLeft = left !== 0;
        this.pinnedRight =
          Math.abs(this.tableBodyWidth - this.tableViewWidth - left) > 3;
      }
    },
    initPageData() {
      if (!this.pageData) return;
      this.pageData.pageIndex && (this.pageIndex = this.pageData.pageIndex);
      this.pageData.pageSize && (this.pageSize = this.pageData.pageSize);
      this.totalCount = this.pageData.totalCount || 0;
      this.pageSizeOptions =
        this.pageData.pageSizeOptions || this.pageSizeOptions;
      this.oldPageIndex = this.pageIndex;
      this.oldPageSize = this.pageSize;
    },
    findParent(dom) {
      let a = false;
      if (dom.parentNode) {
        if (dom.parentNode.className?.includes('ant-drawer-body')) {
          a = true;
        } else {
          return this.findParent(dom.parentNode);
        }
      }
      return a;
    },
    onPageChange(pageIndex, pageSize) {
      // 更改pageSize时修正pageIndex
      if (pageSize !== this.oldPageSize) {
        pageIndex =
          Math.floor(((pageIndex - 1) * this.oldPageSize) / pageSize) + 1;
      }
      pageIndex <= 0 && (pageIndex = 1);
      if (this.pageData) {
        const pageData = this.pageData;
        pageData.pageIndex = pageIndex;
        pageData.pageSize = pageSize;
      }
      let stop = false;
      this.$emit('pageChange', pageIndex, pageSize, (cb) => (stop = cb));
      // 回调阻止翻页和
      if (stop) {
        this.pageIndex = this.oldPageIndex;
        this.pageSize = this.oldPageSize;
        return;
      }
      this.fixParams.mainDom.scrollTop = 0;
      // 清除dom缓存
      this.cacheElements = {};
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.oldPageIndex = pageIndex;
      this.oldPageSize = pageSize;
      this.saveGridConfig();
    },
    getBeforeCol(column, rowIndex) {
      const nextCol = this.gridColumnApi.getDisplayedColBefore(column);
      if (nextCol && nextCol.colDef.editable && !nextCol.pinned) {
        return [rowIndex, nextCol];
      } else if (!nextCol) {
        // 下一行
        const beforeCol = this.gridColumnApi.getDisplayedCenterColumns().pop();
        return this.getNextCol(beforeCol, --rowIndex);
      }
      // 递归获取下一列
      return this.getNextCol(nextCol, rowIndex);
    },
    getNextCol(column, rowIndex) {
      const nextCol = this.gridColumnApi.getDisplayedColAfter(column);
      if (nextCol && nextCol.colDef.editable && !nextCol.pinned) {
        return [rowIndex, nextCol];
      } else if (!nextCol) {
        // 下一行
        const beforeCol = this.gridColumnApi.getDisplayedCenterColumns()[0];
        return this.getNextCol(beforeCol, ++rowIndex);
      }
      // 递归获取下一列
      return this.getNextCol(nextCol, rowIndex);
    },
    onCellKeyDown({ column, event, rowIndex }) {
      if (event.key === 'ArrowRight') {
        this.stopEditing();
        // 滚动条滚动到下一个可编辑列
        const nextCol = this.getNextCol(column, rowIndex);
        this.gridApi.ensureColumnVisible(nextCol[1]);
        // 单元格获取焦点
        this.gridApi.setFocusedCell(...nextCol);
      } else if (event.key === 'ArrowLeft') {
        const nextCol = this.getBeforeCol(column, rowIndex);
        this.gridApi.ensureColumnVisible(nextCol[1]);
        // 单元格获取焦点
        this.gridApi.setFocusedCell(...nextCol);
      }
    },
    onFirstDataRendered(params) {
      console.log(params);
    },
    onMouseEnterTable() {
      // 鼠标进入时重新计算单元格宽度
      this.calcTableWidth(this.gridColumnApi.columnModel);
    },
    calcTableWidth(col) {
      // 表格内容宽度
      this.tableBodyWidth = Math.round(col.bodyWidth);
      // 表格视窗宽度, 除数不能为0
      this.tableViewWidth = Math.round(col.flexViewportWidth || 100);
      if (Math.abs(this.tableBodyWidth - this.tableViewWidth) <= 4)
        this.tableBodyWidth = this.tableViewWidth;
      // 垂直滚动条宽度
      const agViewDom = this.$el.getElementsByClassName('ag-body-viewport')[0];
      const scrollWidth =
        agViewDom.scrollHeight > agViewDom.clientHeight ? 17 : 0;
      // 表格宽度，含左右固定区，scroll视窗宽度, 加垂直滚动条宽度
      const tableWdith =
        this.tableViewWidth +
        (col.leftWidth || 0) +
        (col.rightWidth || 0) +
        scrollWidth;
      // scroll内容宽度
      this.scrollAreaWidth = Math.round(
        (tableWdith * this.tableBodyWidth) / this.tableViewWidth,
      );
      const isLessCol = this.tableViewWidth > this.tableBodyWidth;
      const rightPinnedCols = this.resetColsWidth(isLessCol);
      if (rightPinnedCols.length) this.rightPinnedCols = rightPinnedCols;
    },
    onRedrawRows() {
      if (this.isRedrawRunning === true) return;
      this.isRedrawRunning = true;
      // 遍历所有节点
      const toRedrawRows = [];
      // 每次遍历全部node效率低,调整遍历步长。
      let step = 0;
      this.gridApi.forEachNode((node) => {
        // 初始状态isFullRow未定义，
        const nodeIsFullRow =
          node?.data?.[isFullRow] === undefined ? true : node.data[isFullRow];
        // 合并行的第一行不隐藏
        if (node?.data?.rowSpan > 1 && !nodeIsFullRow) return false;
        // 步长跳过本次循环
        if (++step % 5 !== 1 && this.isSkipStep) return false;
        // 每次遍历dom效率比较低,增加行dom缓存
        const element = this.getElementByNodeId(node.id);
        const isFull = this.isElementNotInViewport(element, this.isScrollUp);
        if (isFull !== nodeIsFullRow) {
          node.setData({ ...node?.data, [isFullRow]: isFull });
          toRedrawRows.push(node);
          // 清除行dom缓存
          delete this.cacheElements[node.id];
        }
        // 跳出循环
        if (this.isBrekLoop) return true;
      });
      // 重绘行
      if (toRedrawRows.length > 0) {
        setTimeout(() => {
          this.gridApi.redrawRows({ rowNodes: toRedrawRows });
        });
      }
      setTimeout(() => {
        this.isRedrawRunning = false;
      });
    },
    isElementNotInViewport(el, isScrollUp = false) {
      if (!el) return false;
      const gridContainer = this.getGridContainer && this.getGridContainer();
      const rect = el.getBoundingClientRect();
      const bufferTop = this.rowHeightRef * (isScrollUp ? this.rowBuffer : 1); // 上缓冲区
      const bufferBottom =
        this.rowHeightRef * (!isScrollUp ? this.rowBuffer : 1); // 下缓冲区
      if (gridContainer) {
        const containerRect = gridContainer.getBoundingClientRect();
        if (
          rect.top >
          containerRect.top + containerRect.height + bufferBottom * 2
        )
          this.isBrekLoop = true; // 大于2倍buffer
        if (rect.bottom > containerRect.top - bufferTop * 2)
          this.isSkipStep = false; // 小于2倍buffer
        return (
          rect.top >= containerRect.top + containerRect.height + bufferBottom ||
          rect.bottom <= containerRect.top - bufferTop
        );
      } else {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top > vh + bufferBottom * 2) this.isBrekLoop = true; // 大于2倍buffer
        if (rect.bottom > 0 - bufferTop * 2) this.isSkipStep = false; // 小于2倍buffer
        return rect.top >= vh + bufferBottom || rect.bottom <= 0 - bufferTop;
      }
    },
    getElementByNodeId(nodeId) {
      if (
        this.cacheElements[nodeId] &&
        this.cacheElements[nodeId].clientHeight > 0
      )
        return this.cacheElements[nodeId];
      const colsElements = this.fixParams.agColsDom.childNodes;
      const fullElements = this.fixParams.agFullDom.childNodes;
      const elements = [...colsElements, ...fullElements];
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        const attrId = el.getAttribute('row-id');
        if (nodeId == attrId) {
          // 行缓存dom, 每次重绘后dom会变
          return (this.cacheElements[nodeId] = el);
        }
      }
    },
    saveGridConfigImmediate(e) {
      this.columnState = this.gridColumnApi.getColumnState();
      this.calcTableWidth(this.gridColumnApi.columnModel);
      if (e && e.type === 'leftChanged') {
        //列隐藏列， 清除列设置
        const showCols = this.columnState.filter(
          (col) => !col.hide && col.pinned !== 'left',
        );
        if (showCols.length <= 1) this.columnState = null;
      }
      const data = {
        rowHeight: this.rowHeightRef,
        columnState: this.columnState,
        pageSize: this.pageSize,
        rightPinnedCols: this.rightPinnedCols,
      };
      setState(this.stateConfig, data);
    },
    saveGridConfig(e) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.$nextTick(function() {
          this.saveGridConfigImmediate(e);
        });
      }, 200);
    },
    stopEditing() {
      this.gridApi.stopEditing();
    },
    colsEvent() {
      this.gridColumnApi.getAllGridColumns().forEach((col) => {
        col.addEventListener('leftChanged', this.saveGridConfig);
        col.addEventListener('widthChanged', this.saveGridConfig);
        col.addEventListener('visibleChanged', this.saveGridConfig);
      });
      this.gridApi.addEventListener('columnPinned', this.saveGridConfig);
    },
    // 移入单元格事件回调
    onCellMouseOver(params) {
      if (!this.showInsertRowBtn) return;
      this.cellMouseOverTimer && clearTimeout(this.cellMouseOverTimer);
      const cellTarget = params.event.target;
      this.cellMouseOverTimer = setTimeout(() => {
        const nodeData = params.data;
        if (nodeData.isBlank) {
          this.insertRowBtnHide = true;
          this.insertRowBtnTop = 0;
          this.insertRowNode = null;
        } else {
          this.insertRowBtnHide = false;
          let rowTarget = cellTarget.parentNode;
          if (cellTarget.classList[0] && cellTarget.classList[0] != 'ag-cell') {
            rowTarget = this.$el.querySelectorAll(
              `div[row-index="${params.node.id}"]`,
            )[1];
          }
          const rowRect = rowTarget.getBoundingClientRect();
          const boxRect = this.$el.getBoundingClientRect();
          const boxTop = boxRect.top + 10;
          const rowSpanIndex = nodeData.rowSpanIndex;
          if (rowSpanIndex > 0) {
            const rowIndex = params.node.rowIndex - rowSpanIndex;
            const rowNode = params.api.getDisplayedRowAtIndex(rowIndex);
            const desRowHeight = rowNode
              ? math.accMul(rowSpanIndex, rowNode.rowHeight)
              : 0;
            this.insertRowBtnTop = rowRect.top - desRowHeight - boxTop;
            this.insertRowNode = rowNode;
            return;
          }
          this.insertRowBtnTop = rowRect.top - boxTop;
          this.insertRowNode = params.node;
        }
      }, 50);
    },
    // 移出表格事件回调
    onMouseLeaveTable() {
      if (!this.showInsertRowBtn) return;
      this.cellMouseOverTimer && clearTimeout(this.cellMouseOverTimer);
      this.insertRowBtnHide = true;
    },
    // 移入插入行按钮事件回调
    onInsertRowBtnMouseEnter() {
      this.insertRowBtnHide = false;
    },
    // 移出插入行按钮事件回调
    onInsertRowBtnMouseLeave() {
      this.insertRowBtnHide = true;
    },
    // 插入行按钮点击事件
    onInsertRowBtnClick(ev) {
      this.$emit('insertRowBtnClick', this.insertRowNode, ev);
    },
    onCellEditingStarted(ev) {
      this.$emit('cellEditingStarted', ev);
    },
    onCellEditingStopped(ev) {
      this.$emit('cellEditingStopped', ev);
    },
    onRowGroupOpened(ev) {
      setTimeout(() => {
        ev.api.redrawRows();
      });
      this.$emit('rowGroupOpened', ev);
    },
    onRowDragEnd(ev) {
      this.$emit('rowDragEnd', ev);
    },
    getDataPath(row) {
      if (this.isTreeData && this.rowModelType === 'clientSide') {
        if (this.isTreeFlatten) {
          return row.__data_path_list__.slice(-1);
        }
        return row.__data_path_list__;
      }
      return;
    },
    getRecursiveFlattenData(rowData, field, childrenKey, parentPathList) {
      const flattenList = [];
      rowData.forEach((row) => {
        const __data_path_list__ = [...(parentPathList || []), row[field]];
        flattenList.push({ ...row, __data_path_list__ });
        if (row[childrenKey]) {
          const subFlattenList = this.getRecursiveFlattenData(
            row[childrenKey],
            field,
            childrenKey,
            __data_path_list__,
          );
          flattenList.push(...subFlattenList);
        }
      });
      return flattenList;
    },
  },
  beforeUnmount() {
    this.saveGridConfigImmediate();
    this.$el.removeEventListener('mouseenter', this.onMouseEnterTable);
    // 移除事件监听
    if (this.fixParams.mainDom) {
      (
        (this.getGridContainer && this.getGridContainer()) ||
        this.fixParams.mainDom
      ).removeEventListener('scroll', this.onMainScroll);
    }
    // 移除列事件
    this.gridColumnApi.getAllGridColumns().forEach((col) => {
      col.removeEventListener('leftChanged', this.saveGridConfig);
      col.removeEventListener('widthChanged', this.saveGridConfig);
      col.removeEventListener('visibleChanged', this.saveGridConfig);
    });
    this.gridApi.removeEventListener('columnPinned', this.saveGridConfig);
  },
});

const _hoisted_1$Y = ["row-height"];
const _hoisted_2$J = { class: "sc-footer" };
const _hoisted_3$A = {
  key: 0,
  class: "footer-wrapper"
};
const _hoisted_4$s = {
  key: 0,
  class: "footer-selectall"
};
const _hoisted_5$k = { class: "number-show" };
const _hoisted_6$e = { class: "footer-content-right" };
const _hoisted_7$d = { class: "sc-table-btn" };
const _hoisted_8$c = ["title", "onClick"];
const _hoisted_9$b = ["innerHTML"];
const _hoisted_10$9 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "ਙ", -1 /* HOISTED */);
const _hoisted_11$9 = [
  _hoisted_10$9
];
const _hoisted_12$9 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_13$5 = [
  _hoisted_12$9
];
const _hoisted_14$6 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_15$6 = [
  _hoisted_14$6
];
const _hoisted_16$6 = /*#__PURE__*/createElementVNode("div", { id: "lastColStyle" }, null, -1 /* HOISTED */);
const _hoisted_17$4 = /*#__PURE__*/createElementVNode("i", { class: "insert-circle-icon" }, null, -1 /* HOISTED */);
const _hoisted_18$3 = /*#__PURE__*/createElementVNode("i", { class: "insert-triangle-icon" }, null, -1 /* HOISTED */);
const _hoisted_19$3 = [
  _hoisted_17$4,
  _hoisted_18$3
];

function render$14(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ag_grid_vue = resolveComponent("ag-grid-vue");
  const _component_scrollbar = resolveComponent("scrollbar");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_pagination = resolveComponent("a-pagination");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["sc-grid-wrapper", _ctx.isBorder ? 'sc-border-grid' : '']),
    "row-height": _ctx.lineHeight[_ctx.arrIndex],
    onClick: _cache[9] || (_cache[9] = withModifiers(() => {}, ["stop"])),
    ref: "gridRef",
    onMouseenter: _cache[10] || (_cache[10] = withModifiers((...args) => (_ctx.handleMouseEnterGrid && _ctx.handleMouseEnterGrid(...args)), ["stop"])),
    onMouseleave: _cache[11] || (_cache[11] = withModifiers((...args) => (_ctx.handleMouseLeaveGrid && _ctx.handleMouseLeaveGrid(...args)), ["stop"]))
  }, [
    (_ctx.$slots.totalStatistic)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["sc-table-total", _ctx.$slots.totalStatistic ? 'sc-has-total' : ''])
        }, [
          renderSlot(_ctx.$slots, "totalStatistic")
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    createCommentVNode(" rowSelection=\"multiple\"多选复选框 "),
    createVNode(_component_ag_grid_vue, mergeProps({
      class: ["ag-theme-balham sc-basic-grid", {
        'no-result-wrap': _ctx.rowData.length === 0,
        'sc-grid-selected-no-bg': _ctx.rowData.length !== 0 && _ctx.rowSelectedNoBgColor,
        'sc-grid-pinned-left': _ctx.pinnedLeft,
        'sc-grid-pinned-right': _ctx.pinnedRight,
        'sc-grid-tree-flatten': _ctx.isTreeFlatten,
      }],
      groupSelectsChildren: "",
      enableRangeSelection: true,
      enableFillHandle: true,
      singleClickEdit: true,
      suppressHorizontalScroll: true,
      enterMovesDown: true,
      enterMovesDownAfterEdit: true,
      animateRows: true,
      domLayout: "autoHeight",
      fillHandleDirection: "y",
      rowModelType: _ctx.rowModelType,
      rowSelection: "multiple",
      gridOptions: _ctx.gridOptions,
      onGridReady: _ctx.onGridReady,
      defaultColDef: _ctx.defaultColDef,
      columnDefs: _ctx.columnDefs,
      localeText: _ctx.localeText,
      modules: _ctx.modules,
      rowData: _ctx.computedRowData,
      getRowHeight: _ctx.getRowHeight,
      isFullWidthRow: _ctx.isFullWidthRow,
      isRowSelectable: _ctx.isRowSelectable,
      fullWidthCellRenderer: _ctx.fullWidthCellRenderer,
      onGridSizeChanged: _ctx.onGridSizeChanged,
      onGridColumnsChanged: _ctx.onGridColumnsChanged,
      onBodyScroll: _ctx.onBodyScroll,
      headerHeight: _ctx.headerHeight,
      tooltipShowDelay: 300,
      frameworkComponents: _ctx.frameworkComponents,
      onSelectionChanged: _ctx.onSelectionChanged,
      onRowDataUpdated: _ctx.onRowDataChanged,
      onRowSelected: _ctx.onRowSelected,
      getContextMenuItems: (e) => _ctx.getContextMenuItems(e, _ctx.relationSearchId),
      getMainMenuItems: _ctx.getMainMenuItems,
      sendToClipboard: _ctx.sendToClipboard,
      pinnedTopRowData: _ctx.totalRowDataTop,
      pinnedBottomRowData: _ctx.totalRowDataBottom,
      onCellMouseOver: _ctx.onCellMouseOver,
      onMouseleave: _ctx.onMouseLeaveTable,
      getServerSideGroupKey: _ctx.getServerSideGroupKey,
      isServerSideGroup: _ctx.isServerSideGroup,
      isServerSideGroupOpenByDefault: _ctx.isServerSideGroupOpenByDefault
    }, { ..._ctx.$props.gridDefs, ..._ctx.$attrs }, {
      stopEditingWhenCellsLoseFocus: true,
      onCellEditingStarted: _ctx.onCellEditingStarted,
      onCellEditingStopped: _ctx.onCellEditingStopped,
      rowDragManaged: _ctx.rowDragManaged,
      suppressMoveWhenRowDragging: _ctx.suppressMoveWhenRowDragging,
      onRowDragEnd: _ctx.onRowDragEnd,
      onRowGroupOpened: _ctx.onRowGroupOpened,
      treeData: _ctx.isTreeData,
      autoGroupColumnDef: _ctx.computedAutoGroupColumnDef,
      getDataPath: _ctx.getDataPath,
      getRowId: _ctx.computedGetRowId,
      suppressRowClickSelection: _ctx.suppressRowClickSelection
    }), null, 16 /* FULL_PROPS */, ["class", "rowModelType", "gridOptions", "onGridReady", "defaultColDef", "columnDefs", "localeText", "modules", "rowData", "getRowHeight", "isFullWidthRow", "isRowSelectable", "fullWidthCellRenderer", "onGridSizeChanged", "onGridColumnsChanged", "onBodyScroll", "headerHeight", "frameworkComponents", "onSelectionChanged", "onRowDataUpdated", "onRowSelected", "getContextMenuItems", "getMainMenuItems", "sendToClipboard", "pinnedTopRowData", "pinnedBottomRowData", "onCellMouseOver", "onMouseleave", "getServerSideGroupKey", "isServerSideGroup", "isServerSideGroupOpenByDefault", "onCellEditingStarted", "onCellEditingStopped", "rowDragManaged", "suppressMoveWhenRowDragging", "onRowDragEnd", "onRowGroupOpened", "treeData", "autoGroupColumnDef", "getDataPath", "getRowId", "suppressRowClickSelection"]),
    createElementVNode("div", _hoisted_2$J, [
      createVNode(_component_scrollbar, {
        isBarShow: _ctx.isGridBarShow,
        areaWidth: _ctx.scrollAreaWidth,
        scrollNext: _ctx.scrollNext
      }, null, 8 /* PROPS */, ["isBarShow", "areaWidth", "scrollNext"]),
      (
          _ctx.$slots.gridTools ||
            _ctx.isCheckAllBox ||
            _ctx.$slots.footer ||
            _ctx.pageData ||
            _ctx.iconBtns.length ||
            _ctx.isShowSetButton ||
            _ctx.isServerSideGroup ||
            !_ctx.isIconShow
        )
        ? (openBlock(), createElementBlock("div", _hoisted_3$A, [
            createCommentVNode(" 新增全选 "),
            createElementVNode("div", null, [
              (_ctx.isCheckAllBox)
                ? (openBlock(), createElementBlock("div", _hoisted_4$s, [
                    createVNode(_component_a_checkbox, {
                      checked: _ctx.checked,
                      "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.checked) = $event)),
                      onChange: _ctx.checkedAll
                    }, {
                      default: withCtx(() => [
                        createTextVNode("全选")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["checked", "onChange"]),
                    createTextVNode(" 已选中"),
                    createElementVNode("span", _hoisted_5$k, toDisplayString(this.selectedData), 1 /* TEXT */),
                    createTextVNode("条 "),
                    createCommentVNode(" <a-button @click=\"delRowNode\">删除</a-button> ")
                  ]))
                : createCommentVNode("v-if", true),
              renderSlot(_ctx.$slots, "footer", {
                slotData: this.selectedData
              })
            ]),
            createElementVNode("div", _hoisted_6$e, [
              (_ctx.pageData && _ctx.pageData?.totalCount >= 20)
                ? (openBlock(), createBlock(_component_a_pagination, {
                    key: 0,
                    "show-size-changer": "",
                    current: _ctx.pageIndex,
                    "onUpdate:current": _cache[1] || (_cache[1] = $event => ((_ctx.pageIndex) = $event)),
                    pageSize: _ctx.pageSize,
                    "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => ((_ctx.pageSize) = $event)),
                    "show-total": (total) => `共 ${total} 条`,
                    pageSizeOptions: _ctx.pageSizeOptions,
                    total: _ctx.totalCount,
                    onChange: _ctx.onPageChange,
                    onShowSizeChange: _ctx.onPageChange,
                    showQuickJumper: _ctx.showQuickJumper,
                    "show-less-items": ""
                  }, null, 8 /* PROPS */, ["current", "pageSize", "show-total", "pageSizeOptions", "total", "onChange", "onShowSizeChange", "showQuickJumper"]))
                : createCommentVNode("v-if", true),
              createElementVNode("div", _hoisted_7$d, [
                renderSlot(_ctx.$slots, "gridTools"),
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.iconBtns, (btn, index) => {
                  return (openBlock(), createElementBlock("span", {
                    class: "option-btn-icon",
                    key: index,
                    title: btn.title,
                    onClick: btn.onClick
                  }, [
                    createElementVNode("i", {
                      class: "iconfont",
                      innerHTML: btn.icon
                    }, null, 8 /* PROPS */, _hoisted_9$b)
                  ], 8 /* PROPS */, _hoisted_8$c))
                }), 128 /* KEYED_FRAGMENT */)),
                (_ctx.isShowSetButton || _ctx.isServerSideGroup)
                  ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: "option-btn-icon",
                      title: "表格列设置",
                      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.handleSetSideBar && _ctx.handleSetSideBar(...args)))
                    }, _hoisted_11$9))
                  : createCommentVNode("v-if", true),
                createCommentVNode(" <span\r\n              class=\"option-btn-icon\"\r\n              :title=\"isTreeFlatten ? '树形展示' : '平铺展示'\"\r\n              @click=\"handleToggleTreeFlatten\"\r\n              v-if=\"isTreeData && !isServerSideGroup\"\r\n            >\r\n              <i class=\"iconfont\">\r\n                {{ isTreeFlatten ? '&#xe637;' : '&#xe636;' }}\r\n              </i>\r\n            </span> "),
                (!_ctx.autoHeight && !_ctx.isServerSideGroup && !_ctx.isIconShow)
                  ? (openBlock(), createElementBlock("span", {
                      key: 1,
                      class: "option-btn-icon",
                      title: "调整行高",
                      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.onChangeRowHeight && _ctx.onChangeRowHeight(...args)))
                    }, _hoisted_13$5))
                  : createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    (_ctx.isIconShow && _ctx.rowHeightTimerShow)
      ? (openBlock(), createElementBlock("span", {
          key: 1,
          title: "调整行高",
          onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.onChangeRowHeight && _ctx.onChangeRowHeight(...args))),
          class: "option-btn-icon set-row-height-hover"
        }, _hoisted_15$6))
      : createCommentVNode("v-if", true),
    _hoisted_16$6,
    (_ctx.showInsertRowBtn)
      ? (openBlock(), createElementBlock("div", {
          key: 2,
          id: "insertRowBtn",
          style: normalizeStyle({
        top: _ctx.insertRowBtnTop + 'px',
        display: _ctx.insertRowBtnHide ? 'none' : 'block',
      }),
          onMouseenter: _cache[6] || (_cache[6] = (...args) => (_ctx.onInsertRowBtnMouseEnter && _ctx.onInsertRowBtnMouseEnter(...args))),
          onMouseleave: _cache[7] || (_cache[7] = (...args) => (_ctx.onInsertRowBtnMouseLeave && _ctx.onInsertRowBtnMouseLeave(...args))),
          onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.onInsertRowBtnClick && _ctx.onInsertRowBtnClick(...args)))
        }, _hoisted_19$3, 36 /* STYLE, HYDRATE_EVENTS */))
      : createCommentVNode("v-if", true)
  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1$Y))
}

script$1b.render = render$14;
script$1b.__file = "packages/grid/src/BasicGrid.vue";

LicenseManager.setLicenseKey(
  'DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6',
);
var script$1a = {
  name: 'AgGridTable',
  data() {
    return {
      // rowData: null,
      localeText: { ...AG_GRID_LOCALE_CN },
      modules: AllModules,
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        resizable: true,
      },
      autoGroupColumnDef: null,
      groupDefaultExpanded: null,
      frameworkComponents: null,
      getDataPath: null,
      rowClassRules: null,
      bodyWidth: 0,
      bodyHeight: 0,
      // immutableStore: null,
      isScrolling: false,
      fixParams: {},
      table: {},
      oGrid: null,
      getRowHeight: null,
      getRowNodeId: null,
      isFullWidthRow: null,
      fullWidthCellRenderer: null,
      throttleValid: true,
      timeout: null,
      isScrollUp: false,
      lastedScrollTop: 0,
      painedTimerIds: new Set(),
      rightPinnedCols: [],
      isInit: true,
      pinnedLeft: true,
      pinnedRight: false,
    };
  },
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: {
    gridOptions: {
      type: Object,
      default: () => ({}),
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Array,
      required: true,
    },
    isListTable: {
      type: Boolean,
      default: true,
    },
    detailField: {
      type: String,
    },
    indexField: {
      type: String,
      required: true,
    },
    calcTableWidth: {
      type: Function,
    },
    changeLeftScroll: {
      type: Function,
    },
    deepField: {
      type: String,
      default: '',
    },
    noRowsText: {
      type: String,
      default: '没有查到符合条件的数据',
    },
    rowSelectedNoBgColor: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    setKeywords: {
      from: 'setKeywords',
      default: () => () => null,
    },
  },
  watch: {
    noRowsText: {
      handler() {
        this.setNoRowsToShow();
      },
    },
    rowData: {
      handler(rd) {
        // this.gridApi.setRowData(rd);
        nextTick().then(() => {
          // 初始化列权限
          this.initShowCols();
          this.$emit('rowDataChanged');
        });
      },
    },
  },
  beforeMount() {
    // 优先读取表格本地设置
    this.initGridConfig();
    // 行样式
    this.rowClassRules = {
      'is-subline': (params) => {
        return params.data && params.data[this.deepField] > 0;
      },
      'is-lastline': (params) => {
        return params.data && params.data[this.$parent.isLastRow];
      },
      'is-rootline': (params) => {
        return params.data && params.data[this.deepField] == 0;
      },
      'is-detail': (params) => {
        return params.data && params.data[this.$parent.isDetailRow];
      },
      'is-loading': (params) => {
        return params.data[this.$parent.isLoadingRow];
      },
      'is-noborder': (params) => {
        return params.data && params.data[this.$parent.isNoBorderRow];
      },
      'is-partselected': (params) => {
        return params.data && params.data[this.$parent.isPartSelectedRow];
      },
    };
    this.deepLoop(this.columnDefs);
    this.$emit('initColsWidth', this.columnDefs);
    // 行高
    this.getRowHeight = (params) => {
      return params.data[this.$parent.isDetailRow]
        ? this.$parent.detailRowHeight
        : this.$parent.listRowHeight;
    };
    this.isFullWidthRow = ({ rowNode }) => {
      // listTable 详情数据全空行
      // detailTable 列表数据全空行
      return rowNode.data[this.$parent.isFullRow] || false;
    };
    this.fullWidthCellRenderer = () => {
      // 插入全宽行样式, 添加事件监听addEvent
      const cssClass = this.isListTable ? 'list-full-row' : 'detail-full-row';
      const eDiv = document.createElement('div');
      eDiv.innerHTML = '<div class="' + cssClass + '"></div>';
      return eDiv.firstChild;
    };
    this.frameworkComponents = {
      DefaultTooltip: script$1p,
      CustomHeader: script$1f,
      CustomFiter: script$1e,
    };
    this.getRowNodeId = (data) => {
      return data[this.indexField];
    };
    // this.immutableStore = [...this.tableData];
    this.setNoRowsToShow();
  },
  mounted() {
    //接口api
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    deepLoop,
    getContextMenuItems,
    getMainMenuItems,
    resetPinnedHeaderWidth,
    resetColsWidth,
    sendToClipboard,
    setNoRowsToShow() {
      // 设置无数据文本
      this.noRowsText && (this.localeText.noRowsToShow = this.noRowsText);
    },
    initGridConfig() {
      const grid = this.isListTable ? 'list' : 'detail';
      const config = getState(this.$parent.stateConfig);
      this.columnState = config[grid + 'ColumnState'];
    },
    initShowCols() {
      const columnState = this.gridColumnApi.getColumnState();
      const state = initShowCols(this.columnDefs, this.rowData, columnState);
      state && this.gridColumnApi.applyColumnState({ state, applyOrder: true });
    },
    initFixParams() {
      const dom = this.$parent.$el;
      this.fixParams = {
        mainDom: document.getElementsByClassName('main')[0],
        agGridDom: this.$el,
        footDom: dom.getElementsByClassName('sc-footer')[0],
        fixDom: document.querySelector('.J-sc-affix'),
        totalDom: dom.querySelector('.sc-table-total'),
        agHeadDoms: dom.getElementsByClassName('ag-header'),
        agViewDoms: dom.getElementsByClassName('ag-body-viewport'),
      };
      if (!HTMLCollection.prototype.forEach) {
        HTMLCollection.prototype.forEach = Array.prototype.forEach;
      }
      if (!Array.prototype.findLastIndex) {
        Array.prototype.findLastIndex = function(cb) {
          for (let i = this.length - 1; i >= 0; i--) {
            if (cb(this[i], i)) return i;
          }
          return -1;
        };
      }
      if (this.fixParams.mainDom) {
        this.fixParams.mainDom.addEventListener('scroll', this.onMainScroll);
      }
      this.onMutationObserver();
    },
    doFixedHeader() {
      const scrollTop = this.fixParams.mainDom.scrollTop;
      this.isScrollUp = scrollTop < this.lastedScrollTop ? true : false;
      this.lastedScrollTop = scrollTop;
      // -1为解决无tag-bar时，total-bar上边框和mian下边框重叠
      const tagTop = this.fixParams.fixDom
        ? this.fixParams.fixDom.clientHeight - 1
        : -1;
      const totalTop = this.fixParams.totalDom
        ? this.fixParams.totalDom.clientHeight
        : 0;
      const top = tagTop + totalTop;
      this.fixParams.fixDom && (this.fixParams.fixDom.style.zIndex = 2);
      this.fixParams.totalDom &&
        ((this.fixParams.totalDom.style.zIndex = 4),
        (this.fixParams.totalDom.style.top = tagTop + 'px'));
      this.fixParams.agHeadDoms.forEach((e) => {
        e.style.top = top + 'px';
      });
    },
    doFixedFooter() {
      if (!this.fixParams.footDom) return;
      const view = this.fixParams.agViewDoms[0].getBoundingClientRect();
      const height = this.fixParams.footDom.offsetHeight;
      const vh = document.body.clientHeight;
      if (view.bottom + height >= vh) {
        // footer在视窗外
        const width = this.fixParams.agGridDom.offsetWidth;
        this.fixParams.footDom.style.position = `fixed`;
        this.fixParams.footDom.parentElement.style.paddingBottom =
          height - 1 + 'px';
        this.fixParams.footDom.style.width = `${width}px`;
      } else {
        // 还原footer
        this.fixParams.footDom.style.position = 'static';
        this.fixParams.footDom.parentElement.style.paddingBottom = '';
        this.fixParams.footDom.style.width = '100%';
      }
    },
    onMutationObserver() {
      //监听表格宽度变化，更新Footer高度
      const $tar = this.fixParams.agViewDoms[0];
      const option = {
        attributes: true, // 属性的变动
        attributeFilter: ['class', 'style'], // 观察特定属性
      };
      new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type == 'attributes') {
            // this.doFixedFooter();
            this.onMainScroll();
          }
        }
      }).observe($tar, option);
      // observer.disconnect();
    },
    onFullRowMouseOver(e) {
      if (['list-full-row', 'detail-full-row'].includes(e.target.className)) {
        // 切换表格显示层
        this.table.cBody.style.zIndex = 0;
        this.table.oBody.style.zIndex = 1;
      }
    },
    onTableKeyDown(e) {
      // 表格切换表头快捷键
      if (e.key === '[') {
        // 切换列表头显示
        this.table.cHeader.style.zIndex = 3;
        this.table.oHeader.style.zIndex = 2;
      } else if (e.key === ']') {
        // 切换详情表头显示
        this.table.cHeader.style.zIndex = 2;
        this.table.oHeader.style.zIndex = 3;
      }
    },
    onTableMouseDown() {
      if (this.table.cHeader.style.zIndex === 3) return;
      // 切换表头显示
      this.table.cHeader.style.zIndex = 3;
      this.table.oHeader.style.zIndex = 2;
      this.$parent.tableMessage(!this.isListTable);
      // 清除oTable的选择、范围选择、编辑状态
      if (this.oGrid) {
        // this.oGrid.gridApi.deselectAll();
        this.oGrid.gridApi.clearRangeSelection();
        this.oGrid.gridApi.stopEditing();
      }
    },
    onMainScroll() {
      this.doFixedHeader();
      this.throttle(this.$parent.onRedrawDetailRows, 100);
    },
    throttle(fn, delay) {
      // 节流
      if (!this.throttleValid) return false;
      this.throttleValid = false;
      // 清除前一个还未执行的定时任务
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        fn();
        this.throttleValid = true;
      }, delay);
    },
    addEvent() {
      this.oGrid = !this.isListTable
        ? this.$parent.$refs.gridRef
        : this.$parent.$refs.gridDetailRef;
      const cTable = this.$el;
      const oTable = this.oGrid.$el;
      this.table = {
        cTable,
        oTable,
        cHeader: cTable.getElementsByClassName('ag-header')[0],
        oHeader: oTable.getElementsByClassName('ag-header')[0],
        cBody: cTable.getElementsByClassName('ag-body-viewport')[0],
        oBody: oTable.getElementsByClassName('ag-body-viewport')[0],
      };
      // 绑定表格切换事件
      this.table.cBody.addEventListener('mouseover', this.onFullRowMouseOver);
      this.table.cBody.addEventListener('mousedown', this.onTableMouseDown);
      // 绑定固钉表格标题事件
      if (this.isListTable === false) return;
      document.addEventListener('keydown', this.onTableKeyDown);
      // 初始列表前置
      this.table.cBody.style.zIndex = 1;
      this.table.oBody.style.zIndex = 0;
      this.onTableMouseDown();
      // 初始化固钉层参数
      this.initFixParams();
    },
    onGridReady(params) {
      this.addEvent(); // 添加原型方法需要先执行
      // 本地列设置初始显示
      if (this.columnState) {
        this.gridColumnApi.applyColumnState({
          state: this.columnState,
          applyOrder: true,
        });
      }
      // 列载入完成后再绑定列监听事件
      setTimeout(this.colsEvent, 100);

      this.fixParams.agColsDom = this.$el.getElementsByClassName(
        'ag-center-cols-container',
      )[0];
      this.fixParams.agFullDom = this.$el.getElementsByClassName(
        'ag-full-width-container',
      )[0];

      // 获取表格视图宽度
      if (this.isListTable === true) {
        this.calcTableWidth(params.columnApi.columnModel);
      }
    },
    onGridSizeChanged({ columnApi }) {
      // 更新表格视图宽度
      if (this.isListTable === true) {
        this.isInit && this.$emit('updateColsWidth', 'init');
        this.isInit = false;
        this.calcTableWidth(columnApi.columnModel);
      }
    },
    onBodyScroll({ direction, left, columnApi }) {
      // 前置显示的表
      const zIndex = this.table.cBody.style.zIndex;
      if (direction === 'horizontal' && zIndex === '1') {
        const oView = this.table.oTable.querySelectorAll('[ref=eViewport]')[0];
        const cWidth = columnApi.columnModel.bodyWidth;
        const oWidth = oView.scrollWidth;
        const oLeft = Math.round(left * (oWidth / cWidth));
        // 同步滚动oTable表
        oView.scrollLeft = oLeft;
        this.changeLeftScroll(left);
        const viewportRight = columnApi.columnModel.viewportRight;
        this.pinnedLeft = left !== 0;
        this.pinnedRight = Math.abs(cWidth - viewportRight) > 3;
      }
    },
    saveGridConfig(e) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.$nextTick(function() {
          this.$emit('updateColsWidth', e.type);
          this.calcTableWidth(this.gridColumnApi.columnModel);
        });
      }, 200);
    },
    colsEvent() {
      this.gridColumnApi.getColumns().forEach((col) => {
        col.addEventListener('leftChanged', this.saveGridConfig);
        col.addEventListener('widthChanged', this.saveGridConfig);
        col.addEventListener('visibleChanged', this.saveGridConfig);
      });
    },
  },
  beforeUnmount() {
    if (this.fixParams.mainDom) {
      this.fixParams.mainDom.removeEventListener('scroll', this.onMainScroll);
    }
    this.table.cBody.removeEventListener('mouseover', this.onFullRowMouseOver);
    this.table.cBody.removeEventListener('mousedown', this.onTableMouseDown);
    document.removeEventListener('keydown', this.onTableKeyDown);
    // 移除列事件
    this.gridColumnApi.getColumns().forEach((col) => {
      col.removeEventListener('leftChanged', this.saveGridConfig);
      col.removeEventListener('widthChanged', this.saveGridConfig);
      col.removeEventListener('visibleChanged', this.saveGridConfig);
    });
  },
};

function render$13(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ag_grid_vue = resolveComponent("ag-grid-vue");

  return (openBlock(), createBlock(_component_ag_grid_vue, {
    class: normalizeClass(["ag-theme-balham sc-dual-grid", {
      'no-result-wrap': $props.rowData.length === 0,
      'sc-grid-selected-no-bg': $props.rowData.length !== 0 && $props.rowSelectedNoBgColor,
      'sc-grid-pinned-left': $data.pinnedLeft,
      'sc-grid-pinned-right': $data.pinnedRight,
    }]),
    enableRangeSelection: true,
    singleClickEdit: true,
    suppressHorizontalScroll: true,
    enterMovesDown: true,
    enterMovesDownAfterEdit: true,
    animateRows: true,
    domLayout: "autoHeight",
    fillHandleDirection: "y",
    rowModelType: "clientSide",
    rowSelection: "single",
    gridOptions: $props.gridOptions,
    onGridReady: $options.onGridReady,
    defaultColDef: $data.defaultColDef,
    columnDefs: $props.columnDefs,
    localeText: $data.localeText,
    modules: $data.modules,
    rowData: $props.rowData,
    rowClassRules: $data.rowClassRules,
    getRowHeight: $data.getRowHeight,
    getRowNodeId: $data.getRowNodeId,
    isFullWidthRow: $data.isFullWidthRow,
    fullWidthCellRenderer: $data.fullWidthCellRenderer,
    onBodyScroll: $options.onBodyScroll,
    onGridSizeChanged: $options.onGridSizeChanged,
    tooltipShowDelay: 300,
    frameworkComponents: $data.frameworkComponents,
    getContextMenuItems: $options.getContextMenuItems,
    getMainMenuItems: $options.getMainMenuItems,
    sendToClipboard: $options.sendToClipboard,
    stopEditingWhenCellsLoseFocus: true
  }, null, 8 /* PROPS */, ["class", "gridOptions", "onGridReady", "defaultColDef", "columnDefs", "localeText", "modules", "rowData", "rowClassRules", "getRowHeight", "getRowNodeId", "isFullWidthRow", "fullWidthCellRenderer", "onBodyScroll", "onGridSizeChanged", "frameworkComponents", "getContextMenuItems", "getMainMenuItems", "sendToClipboard"]))
}

script$1a.render = render$13;
script$1a.__file = "packages/grid/src/components/AgGridTable.vue";

var script$19 = defineComponent({
  name: 'DualGrid',
  components: {
    'a-pagination': Pagination,
    AgGridTable: script$1a,
    Scrollbar: script$1q,
    /* eslint-disable-next-line */
    CellCommonRenderer: script$1g,
  },
  props: {
    isRenderTotal: {
      type: [Boolean],
      default: false,
    },
    indexField: {
      type: String,
      required: true,
    },
    deepField: {
      type: String,
      default: '',
    },
    gridDefs: {
      type: Array,
      default: () => [{}, {}],
    },
    totalData: {
      type: Array,
      default: () => [{}],
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Array,
      required: true,
    },
    rowBuffer: {
      type: Number,
      default: 10,
    },
    rowQueue: {
      type: Number,
      default: 5,
    },
    headerHeight: {
      type: Number,
      default: 30,
    },
    pageData: {
      type: Object,
      default: () => null,
    },
    getDetailData: {
      type: Function,
      default: () => null,
    },
    gridOptions1: {
      type: Object,
      default: () => ({}),
    },
    gridOptions2: {
      type: Object,
      default: () => ({}),
    },
    isCheckAllBox: {
      type: Boolean,
      default: false,
    },
    isShowSetButton: {
      type: [Boolean],
      default: false,
    },
    disableByName: {
      type: String,
      default: 'isDisable',
    },
    iconBtns: {
      type: Array,
      default: () => [],
    },
    noRowsText: {
      type: String,
      default: '',
    },
    isSavePageSize: {
      type: [Boolean],
      default: true,
    },
  },
  setup(props, { emit, attrs }) {
    const gridOptionsList = reactive(props.gridOptions1);
    const gridOptionsDetail = reactive(props.gridOptions2);
    const [columnDefs1, columnDefs2] = reactive(props.columnDefs);
    const [gridDefs1, gridDefs2] = reactive(props.gridDefs);
    const isAutoToggle = {}; // 已经执行的自动折叠的行
    const cacheElements = {}; // 行节点dom缓存
    const disableCallback = {}; // 禁止选择回调
    const stateConfig = 'sc_dual_grid_config' + (attrs.id || '');
    const indexField2 = '__detail_id__';
    const detailField = '__children__';
    const isFullRow = '__is_full__';
    const isSelectedRow = '__is_selected__';
    const isPartSelectedRow = '__is_part_selected__';
    const isDetailRow = '__is_detail__';
    const isShowDetailRows = '__is_show_detail__';
    const isLastRow = '__is_last__';
    const isNoBorderRow = '__is_no_border__';
    const blankField = '__blank_col__';
    const minWidthBlank = 24; // 空白列最小宽度
    // 使用的老项目的key和值，老项目中值多一个双引号，没有双引号，老项目会报错
    const changeHeader = {
      key: 'changeheaderlog',
      dontShowAgain: 'true',
      list: {
        data: '"danju"',
        msg: '单据',
      },
      detail: {
        data: '"mingxi"',
        msg: '明细',
      },
    };
    const hasCheckbox = [false, false];
    const partSelectedData = {};
    if (!Array.prototype.findLastIndex) {
      Array.prototype.findLastIndex = function(cb) {
        for (let i = this.length - 1; i >= 0; i--) {
          if (cb(this[i], i)) return i;
        }
        return -1;
      };
    }

    // 计算列宽,插入空白列
    const initColsWidth = () => {
      let colsWidth1 = 0;
      let colsWidth2 = 0;
      columnDefs1.map((col) => {
        col.checkboxSelection && (hasCheckbox[0] = true);
        !col.pinned && (colsWidth1 += col.width);
      });
      columnDefs2.map((col) => {
        col.checkboxSelection && (hasCheckbox[1] = true);
        !col.pinned && (colsWidth2 += col.width);
      });
      const colsWidth = colsWidth1 - colsWidth2;
      const colBlank = {
        field: blankField,
        headerName: '',
        width: minWidthBlank,
        suppressColumnsToolPanel: true,
        suppressMovable: true,
        suppressMenu: true,
        suppressAutoSize: true,
        suppressSizeToFit: true,
      };
      // 空白列最小宽度24
      const width = Math.abs(colsWidth) + minWidthBlank;
      if (colsWidth > 0) {
        columnDefs1.push(colBlank);
        columnDefs2.push({ ...colBlank, width });
      } else if (colsWidth < 0) {
        columnDefs2.push(colBlank);
        columnDefs1.push({ ...colBlank, width });
      }
    };

    // 表格设置
    let showSideBar = false;
    const handleSetSideBar = () => {
      showSideBar = !showSideBar;
      if (showSideBar) {
        gridOptionsList.api.setSideBar('columns');
        nextTick(() => {
          const panel = document.querySelector(
            '.ag-side-bar .ag-pivot-mode-panel',
          );
          if (panel) {
            panel.innerHTML = '<i class="iconfont">&#xa19;</i> 列设置';
          }
        });
      } else {
        gridOptionsList.api.setSideBarVisible(false);
      }
    };

    const getBlankWidth = (colsWidth1, viewWidth1, colsWidth2, viewWidth2) => {
      // 内容/视窗比率
      const rate1 = colsWidth1 / viewWidth1;
      const rate2 = colsWidth2 / viewWidth2;
      if (rate1 > rate2) {
        return [
          minWidthBlank,
          ((colsWidth1 + minWidthBlank) * viewWidth2) / viewWidth1 - colsWidth2,
        ];
      }
      return [
        ((colsWidth2 + minWidthBlank) * viewWidth1) / viewWidth2 - colsWidth1,
        minWidthBlank,
      ];
    };

    let runTimer = 0;
    const updateColsWidth = (type) => {
      const currTimer = new Date().getTime();
      if (currTimer - runTimer < 100) return;
      runTimer = currTimer;
      const columnApi1 = gridRef.value.gridColumnApi;
      const columnApi2 = gridDetailRef.value.gridColumnApi;
      const columnState1 = columnApi1.getColumnState();
      const columnState2 = columnApi2.getColumnState();
      const viewWidth1 = Math.round(columnApi1.columnModel.flexViewportWidth);
      const viewWidth2 = Math.round(columnApi2.columnModel.flexViewportWidth);
      let index = 0;
      index = columnState1.findLastIndex((col) => col.colId === blankField);
      let blankWidth1 = index >= 0 && columnState1[index].width;
      index = columnState2.findLastIndex((col) => col.colId === blankField);
      let blankWidth2 = index >= 0 && columnState2[index].width;
      const colsWidth1 = Math.round(
        columnApi1.columnModel.bodyWidth - blankWidth1,
      );
      const colsWidth2 = Math.round(
        columnApi2.columnModel.bodyWidth - blankWidth2,
      );
      // width2 = (colsWidth1 + width1) *viewWidth2 /viewWidth1  -colsWidth2
      // 空白列最小宽度24, colsWidth > 4 忽略小于4px的误差
      // const width = Math.abs(colsWidth);
      [blankWidth1, blankWidth2] = getBlankWidth(
        colsWidth1,
        viewWidth1,
        colsWidth2,
        viewWidth2,
      );
      columnApi1.setColumnWidth(blankField, blankWidth1);
      columnApi2.setColumnWidth(blankField, blankWidth2);
      // widthChanged 事件后执行
      if (type === 'widthChanged') {
        //列隐藏列， 清除列设置
        if (columnState1.filter((col) => !col.hide).length <= 1)
          columnState1.splice(0);
        if (columnState2.filter((col) => !col.hide).length <= 1)
          columnState2.splice(0);
      }
      const state = getState(stateConfig);
      const data = {
        ...state,
        listColumnState: columnState1,
        detailColumnState: columnState2,
      };
      setState(stateConfig, data);
    };

    // 行高map
    const lineHeight = [
      [28, 24],
      [40, 30],
      [48, 40],
    ];
    // 行高
    const gridRef = ref(null);
    const gridDetailRef = ref(null);
    const config = getState(stateConfig);
    const isShowDetail = ref(config.isShowDetail || false);
    const listRowHeight = ref(config.listRowHeight || 40);
    const detailRowHeight = ref(config.detailRowHeight || 30);
    const arrIndex = ref(
      lineHeight.findIndex((e) => e[0] === listRowHeight.value),
    );
    const initPageData = () => {
      if (!props.pageData) return;
      const pageData = props.pageData;
      !pageData.pageIndex && (pageData.pageIndex = 1);
      !pageData.pageSize && (pageData.pageSize = 100);
      props.isSavePageSize &&
        config.pageSize &&
        (pageData.pageSize = config.pageSize);
    };
    initPageData();

    // 保存网格设置
    const saveGridConfig = (pageSize = 0) => {
      const state = getState(stateConfig);
      const data = {
        ...state,
        isShowDetail: isShowDetail.value,
        listRowHeight: listRowHeight.value,
        detailRowHeight: detailRowHeight.value,
      };
      if (pageSize > 0) data.pageSize = pageSize;
      setState(stateConfig, data);
    };

    // 列表全宽行
    const getListFullRowData = (detailRowId) => {
      return {
        [props.indexField]: detailRowId,
        [isFullRow]: true,
        [isDetailRow]: true,
        [props.disableByName]: true, // 传一个字段禁用选择
      };
    };
    const getDetailFullRowData = (listRowId) => {
      return {
        [indexField2]: listRowId,
        [isFullRow]: true,
        [props.disableByName]: true,
      };
    };

    // 清除缓存数据
    const clearAllCache = () => {
      // 重置滚动条位置
      if (gridRef.value && gridRef.value.fixParams.mainDom)
        gridRef.value.fixParams.mainDom.scrollTop = 0;
      // 重置自动折叠状态
      Object.keys(isAutoToggle).map((key) => {
        delete isAutoToggle[key];
      });
      // 清除rowDom缓存
      Object.keys(cacheElements).map((key) => {
        delete cacheElements[key];
      });
      // 清除禁止回调列表
      Object.keys(disableCallback).map((key) => {
        delete disableCallback[key];
      });
      // 清除部分选择列表
      Object.keys(partSelectedData).map((key) => {
        delete partSelectedData[key];
      });
    };

    // 判断某个原生DOM元素是否不在屏幕可见区内
    // let isBrekLoop = false; // node遍历跳出
    // let isSkipStep = false; //node遍历记步跳过
    const isElementNotInViewport = (
      el,
      isScrollUp = false,
      isDetailRow = true,
    ) => {
      if (!el) return false;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const rect = el.getBoundingClientRect();
      const bufferTop =
        detailRowHeight.value *
        (isScrollUp ? (isDetailRow ? props.rowBuffer : 0) : 1); // 上缓冲区
      const bufferBottom =
        detailRowHeight.value * (!isScrollUp ? props.rowBuffer : 1); // 下缓冲区
      // if (rect.top > vh + bufferBottom * 2) isBrekLoop = true; // 大于2倍buffer
      // if (rect.bottom < 0 - bufferTop * 2) isSkipStep = true; // 小于2倍buffer
      const headerRect = gridRef.value.fixParams.agHeadDoms[0].getBoundingClientRect();
      return (
        rect.top >= vh + bufferBottom ||
        rect.top <= headerRect.bottom - bufferTop
      );
    };
    const getElementByNodeId = (nodeId) => {
      if (cacheElements[nodeId] && cacheElements[nodeId].clientHeight > 0)
        return cacheElements[nodeId];
      const fixParams = gridDetailRef.value.fixParams;
      if (fixParams.agColsDom === undefined) return false;
      const colsElements = fixParams.agColsDom.childNodes;
      const fullElements = fixParams.agFullDom.childNodes;
      const elements = [...colsElements, ...fullElements];
      // const elements = gridDetailRef.value.$el.getElementsByClassName('ag-row');
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        const attrId = el.getAttribute('row-id');
        if (nodeId == attrId) {
          // 行缓存dom, 每次重绘后dom会变
          return (cacheElements[nodeId] = el);
        }
      }
    };

    // 表格重绘中
    const isRedrawRunning = ref(false);
    // 插入详情行数据, 参数：列表node
    const insertDetailRows = async (node) => {
      // 行dom已经不在视窗缓冲区内，跳出
      if (isElementNotInViewport(getElementByNodeId(node.id))) return;
      isRedrawRunning.value = true;
      const parentId = node.id;
      // 无缓存取API接口数据
      let detailRowsData = [];
      if (node.data[detailField]?.length > 0) {
        detailRowsData = node.data[detailField];
      } else {
        const detail = await props.getDetailData([parentId]);
        detailRowsData = detail && detail[parentId];
        if (!Array.isArray(detailRowsData) || detailRowsData.length === 0) {
          isRedrawRunning.value = false;
          return;
        }
      }
      detailRowsData.forEach((dd, i) => {
        dd[indexField2] = parentId + '_' + i;
        dd[isFullRow] = true;
        dd[isDetailRow] = true;
        dd[isNoBorderRow] = node.data[isLastRow] === true;
        dd[isLastRow] = i === detailRowsData.length - 1;
        // 依据父单状态初始化明细单选择状态
        hasCheckbox[1] &&
          dd[isSelectedRow] === undefined &&
          (dd[isSelectedRow] = node.isSelected());
      });
      // 更新列表children字段缓存数据
      node.setData({
        ...node.data,
        [detailField]: detailRowsData,
        [isShowDetailRows]: true,
      });
      isAutoToggle[node.id] = true;
      // 插入明细表数据行
      const detailApi = gridOptionsDetail.api;
      detailApi.applyTransaction({
        add: detailRowsData,
        addIndex: node.rowIndex + 1,
      });
      // 插入列表全宽行
      const listApi = gridOptionsList.api;
      const listFullRowsData = detailRowsData.map((dd) =>
        getListFullRowData(dd[indexField2]),
      );
      listApi.applyTransaction({
        add: listFullRowsData,
        addIndex: node.rowIndex + 1,
      });
      isRedrawRunning.value = false;
      nextTick(gridRef.value.onMainScroll);
    };
    // 移除详情行数据, 参数：列表node
    const removeDetailRows = (node) => {
      const detailRowsData = node.data[detailField];
      if (detailRowsData.length === 0) return;
      const listApi = gridOptionsList.api;
      // 判断rowNode是否存在
      const listNode = listApi.getRowNode(detailRowsData[0][indexField2]);
      if (!listNode) return;
      isRedrawRunning.value = true;
      const listFullRowsData = detailRowsData.map((dd) => {
        // 移除行会改变行选择状态
        hasCheckbox[1] &&
          dd[isSelectedRow] &&
          (disableCallback[dd[indexField2]] = true);
        // 清除行dom缓存
        delete cacheElements[dd[indexField2]];
        return getListFullRowData(dd[indexField2]);
      });
      // 更新列表isShowDetailRows字段
      node.setData({ ...node.data, [isShowDetailRows]: false });
      isAutoToggle[node.id] = true;
      // 移除列表全宽行
      listApi.applyTransaction({ remove: listFullRowsData });
      // 移除明细表数据行
      const detailApi = gridOptionsDetail.api;
      detailApi.applyTransaction({ remove: detailRowsData });

      isRedrawRunning.value = false;
    };

    // 展开折叠单组详情行
    const onToggleRow = ({ node }) => {
      const isShow = !node.data[isShowDetailRows];
      //显示明细行
      if (isShow) {
        insertDetailRows(node);
      } else {
        removeDetailRows(node);
        gridRef.value.resetPinnedHeaderWidth();
        gridDetailRef.value.resetPinnedHeaderWidth();
      }
    };

    const parentIds = []; // 批量加载行节点队列
    let requestQueueRunning = false;
    const requestQueueDetailData = async () => {
      if (requestQueueRunning || parentIds.length === 0) return;
      requestQueueRunning = true;
      const detailDatas = await props.getDetailData(parentIds);
      if (detailDatas) {
        // 更新rowData
        Object.keys(detailDatas).map((parentId) => {
          const node = gridOptionsList.api.getRowNode(parentId);
          if (!node) return;
          node.setData({
            ...node.data,
            [detailField]: detailDatas[parentId],
            [isShowDetailRows]: false,
          });
          insertDetailRows(node);
        });
        parentIds.length = 0;
        requestQueueRunning = false;
      }
    };

    //自动展开详情行
    const doAutoToggleRow = (nodeId) => {
      // 当前行已执行了自动展开
      if (!isShowDetail.value || isAutoToggle[nodeId]) return;
      const node = gridOptionsList.api.getRowNode(nodeId);
      if (!node.data[isShowDetailRows]) {
        // 无缓存数据，请求队列
        if (node.data[detailField].length === 0) {
          parentIds.push(node.id);
          if (parentIds.length >= props.rowQueue) {
            requestQueueDetailData();
          } else {
            nextTick(requestQueueDetailData);
          }
        } else {
          // 有缓存数据，直接插入
          insertDetailRows(node);
        }
      }
    };

    // 详情表虚拟Dom
    const onRedrawDetailRows = () => {
      // 是否向上滚动
      const isScrollUp = gridRef.value.isScrollUp || false;
      if (isRedrawRunning.value === true) return;
      // 遍历所有节点
      const detailApi = gridOptionsDetail.api;
      const toRedrawRows = [];
      const toRedrawListRows = [];
      // 每次遍历全部node效率低,调整遍历步长。
      // let step = 0;
      detailApi.forEachNode((node) => {
        // 2倍Buffer后的虚拟行,不遍历，跳出循环
        // if (isBrekLoop) return true;
        // 2倍Buffer前的虚拟行，步长5，跳过本次循环，
        // if (++step % 5 !== 1 && isSkipStep) return false;
        // 每次遍历dom效率比较低,增加行dom缓存
        const element = getElementByNodeId(node.id);
        if (!element) return;
        const isFull = isElementNotInViewport(element, isScrollUp);
        // 详情行
        if (node.data[isDetailRow]) {
          //进入和离开视窗的详情行，状态有变化需要重绘。
          if (isFull !== node.data[isFullRow]) {
            node.setData({ ...node.data, [isFullRow]: isFull });
            toRedrawRows.push(node);
          }
        } else {
          // 列表行
          if (!isFull) {
            // 视窗内，执行自动切换折叠状态
            const _isFull = isElementNotInViewport(element, isScrollUp, false);
            if (!isScrollUp || (!_isFull && isScrollUp)) {
              doAutoToggleRow(node.id);
            }
          }
          const listNode = gridOptionsList.api.getRowNode(node.id);
          //进入和离开视窗的详情行，状态有变化需要重绘。
          if (isFull !== listNode.data[isFullRow]) {
            listNode.setData({ ...listNode.data, [isFullRow]: isFull });
            toRedrawListRows.push(listNode);
          }
        }
        // 设置明细行的选择状态
        if (
          hasCheckbox[1] &&
          node.data[isSelectedRow] &&
          node.data[isSelectedRow] !== node.isSelected()
        ) {
          disableCallback[node.id] = true;
          node.setSelected(node.data[isSelectedRow]);
        }
        // 清除行dom缓存
        delete cacheElements[node.id];
      });
      // isBrekLoop = false;
      // isSkipStep = false;
      // 重绘行
      if (toRedrawRows.length > 0) {
        setTimeout(() => {
          detailApi.redrawRows({ rowNodes: toRedrawRows });
        });
      }
      if (toRedrawListRows.length > 0) {
        setTimeout(() => {
          gridOptionsList.api.redrawRows({ rowNodes: toRedrawListRows });
        });
      }
    };
    // 表格消息提示
    const tableMessage = (isShowDetail) => {
      const loc = !isShowDetail ? changeHeader.list : changeHeader.detail;
      const localData = localStorage.getItem(changeHeader.key);
      // 点击不再提示，退出；
      if (localData === changeHeader.dontShowAgain || localData === loc.data)
        return;
      localStorage.setItem(changeHeader.key, loc.data);
      const onClose = () => {
        localStorage.setItem(changeHeader.key, changeHeader.dontShowAgain);
        message.destroy();
      };
      const content = `已经切换到${loc.msg}表头，您可以通过 "[" 或 "]" 键进行表头切换。 `;
      const closeNode = h('a', { onclick: onClose }, ' 不再提示');
      const contNode = h('span', [content, closeNode]);
      message.info(contNode, 2);
    };
    // 切换表头
    const toggleTableHeader = (isShowDetail) => {
      if (isShowDetail) {
        gridRef.value.table.cHeader.style.zIndex = 2;
        gridRef.value.table.oHeader.style.zIndex = 3;
      } else {
        gridRef.value.table.cHeader.style.zIndex = 3;
        gridRef.value.table.oHeader.style.zIndex = 2;
      }
      tableMessage(isShowDetail);
    };
    // 执行切换折叠所有行操作，实际只重绘了视窗内的行
    const toggleAllRow = (isShowDetail) => {
      toggleTableHeader(isShowDetail);
      Object.keys(isAutoToggle).map((key) => {
        isAutoToggle[key] = false;
      });
      if (isShowDetail) {
        onRedrawDetailRows();
      } else {
        //隐藏全部行
        const listFullRowsData = [];
        const detailRowsData = [];
        const listApi = gridOptionsList.api;
        listApi.forEachNode((node) => {
          const data = node.data;
          // 列表全宽行 或 没有显示明细行的跳过
          if (!data[isShowDetailRows]) return false;
          const detailRowData = node.data[detailField];
          if (detailRowData.length === 0) return;
          detailRowsData.push(...detailRowData);
          detailRowData.map((dd) => {
            // 移除行会改变行选择状态
            hasCheckbox[1] &&
              dd[isSelectedRow] &&
              (disableCallback[dd[indexField2]] = true);
            // 清除行dom缓存
            delete cacheElements[dd[indexField2]];
            listFullRowsData.push(getListFullRowData(dd[indexField2]));
          });
          // 更新列表isShowDetailRows字段
          node.setData({ ...node.data, [isShowDetailRows]: false });
        });

        // 移除列表全宽行
        listApi.applyTransaction({ remove: listFullRowsData });
        // 移除明细表数据行
        const detailApi = gridOptionsDetail.api;
        detailApi.applyTransaction({ remove: detailRowsData });
      }
      gridRef.value.resetPinnedHeaderWidth();
      gridDetailRef.value.resetPinnedHeaderWidth();
    };

    // 点击展开折叠所有详情行
    let isToggleAllRunning = false;
    const onToggleAllRow = () => {
      if (isToggleAllRunning) return;
      isToggleAllRunning = true;
      isShowDetail.value = !isShowDetail.value;
      toggleAllRow(isShowDetail.value);
      saveGridConfig();
      setTimeout(() => {
        isToggleAllRunning = false;
      });
    };

    // 改变行高
    const onChangeRowHeight = () => {
      arrIndex.value = arrIndex.value == 2 ? 0 : ++arrIndex.value;
      listRowHeight.value = lineHeight[arrIndex.value][0];
      detailRowHeight.value = lineHeight[arrIndex.value][1];
      gridOptionsList.api.resetRowHeights();
      gridOptionsDetail.api.resetRowHeights();
      if (arrIndex.value === 0) {
        gridRef.value.resetPinnedHeaderWidth();
        gridDetailRef.value.resetPinnedHeaderWidth();
      }
      saveGridConfig();
    };

    // 表格主体宽度 - 表格视图宽度
    const tableBodyWidth = ref(0);
    const tableViewWidth = ref(0);
    const scrollAreaWidth = ref(100);
    let runCalcTimer = 0;
    const calcTableWidth = (col) => {
      const currTimer = new Date().getTime();
      if (!col.flexViewportWidth && currTimer - runCalcTimer < 100) return;
      runCalcTimer = currTimer;
      // 表格内容宽度
      tableBodyWidth.value = Math.round(col.bodyWidth);
      // 表格视窗宽度, 除数不能为0
      tableViewWidth.value = Math.round(col.flexViewportWidth);
      // 表格未加载无法取到宽度，退出
      if (!tableViewWidth.value) return;
      if (Math.abs(tableBodyWidth.value - tableViewWidth.value) <= 4)
        tableBodyWidth.value = tableViewWidth.value;
      // 表格宽度，含左右固定区，scroll视窗宽度
      const tableWdith =
        tableViewWidth.value + (col.leftWidth || 0) + (col.rightWidth || 0);
      // scroll内容宽度
      scrollAreaWidth.value = Math.round(
        (tableWdith * tableBodyWidth.value) / tableViewWidth.value,
      );
      const isLessCol = tableViewWidth.value > tableBodyWidth.value;
      gridRef.value.resetColsWidth(isLessCol);
      gridDetailRef.value.resetColsWidth(isLessCol);
    };

    // 表格水平滚动条位置
    const scrollNext = ref(0);
    const changeLeftScroll = (left) => {
      scrollNext.value = (left * scrollAreaWidth.value) / tableBodyWidth.value;
    };
    // 分页
    const pageIndex = computed({
      get: () => props.pageData.pageIndex,
      set: (v) => emit('update:pageData', { ...props.pageData, pageIndex: v }),
    });
    const pageSize = computed({
      get: () => props.pageData.pageSize,
      set: (v) => emit('update:pageData', { ...props.pageData, pageSize: v }),
    });
    const totalCount = computed(() => props.pageData.totalCount || 0);
    const defPageSizeOptions = ['40', '60', '80', '100', '200'];
    const pageSizeOptions = computed(
      () => props.pageData.pageSizeOptions || defPageSizeOptions,
    );
    const onPageChange = (pageIndex, pageSize) => {
      if (props.pageData) {
        const pageData = props.pageData;
        pageData.pageIndex = pageIndex;
        pageData.pageSize = pageSize;
      }
      saveGridConfig(pageSize);
      emit('pageChange', pageIndex, pageSize);
    };
    // 列表行数据
    const listRowData = computed(() => {
      const data = props.rowData;
      data.forEach((d, i) => {
        const nextDeep = (data[i + 1] || 0) && data[i + 1][props.deepField];
        d[detailField] = [];
        d[isShowDetailRows] = false;
        d[isFullRow] = true;
        d[isLastRow] = nextDeep == 0;
      });
      nextTick(clearAllCache);
      nextTick(onRedrawDetailRows);
      return data;
    });
    // 详情表行数据
    const detailRowData = computed(() => {
      const data = props.rowData;
      const rowData = [];
      data.forEach((d) => {
        // 详情表-插入占位行
        rowData.push(getDetailFullRowData(d[props.indexField]));
      });
      return rowData;
    });
    // 选择全选
    const checked = ref(false);
    const selectedData = ref(0);
    // 全选
    const checkedAll = () => {
      // this.checked = !this.checked;
      if (checked.value) {
        gridOptionsList.api.selectAll();
        gridOptionsDetail.api.selectAll();
        // gridOptions.api.selectAll();
      } else {
        // gridOptions.api.deselectAll();
        gridOptionsList.api.deselectAll();
        gridOptionsDetail.api.deselectAll();
      }
    };
    const isRowSelectable = (rowNode) => {
      return rowNode.data && !rowNode.data[props.disableByName];
    };
    // 获得项数(非禁用项)
    const countSelectable = (rowData) => {
      return rowData.map((v) => ({ data: v })).filter(isRowSelectable).length;
    };
    // 当数据发生变化时，清除全选框的选中状态
    const onRowDataChanged = () => {
      const selectableCount = countSelectable(listRowData.value);
      const selRows = gridOptionsList.api.getSelectedRows();
      selectedData.value = selRows.length;
      if (selectedData.value > 0 && selectedData.value === selectableCount) {
        checked.value = true;
      } else {
        checked.value = false;
      }
    };
    //监测复选框选中的个数
    const onSelectionChanged = () => {
      // getSelectedRows()获取选中的行
      const selRows = gridOptionsList.api.getSelectedRows();
      // selectedData选中行的行数
      selectedData.value = selRows.length;
      checked.value =
        selectedData.value > 0 &&
        selectedData.value === countSelectable(listRowData.value);
    };

    // 列表和明细表联动
    const onParentRowSelected = ({ node, ...e }) => {
      emit('rowSelected', e);
      // 无复选框
      if (!hasCheckbox[1]) return;
      // 禁止回调
      if (disableCallback[node.id]) {
        delete disableCallback[node.id];
        return;
      }
      // 无明细行
      if (node.data[detailField].length === 0) return;
      const isSelected = node.isSelected();
      node.data[detailField].forEach((dd) => {
        if (dd[isSelectedRow] !== isSelected) {
          dd[isSelectedRow] = isSelected;
          const detailNode = gridOptionsDetail.api.getRowNode(dd[indexField2]);
          if (detailNode) {
            detailNode.setData({
              ...detailNode.data,
              [isSelectedRow]: isSelected,
            });
            disableCallback[detailNode.id] = true;
            detailNode.setSelected(isSelected);
          }
        }
      });
      node.setData({ ...node.data });
    };

    // 明细表复选回调事件，联动父表状态
    const onChildRowSelected = ({ node, ...e }) => {
      if (!hasCheckbox[1]) return;
      if (disableCallback[node.id]) {
        delete disableCallback[node.id];
        return;
      }
      const listNodeId = node.data[indexField2].split('_')[0];
      const listNode = gridOptionsList.api.getRowNode(listNodeId);
      const isSelected = node.isSelected();
      node.data[isSelectedRow] = isSelected;
      // 计算父单可选状态,
      let sameLength = 0;
      listNode.data[detailField].forEach((dd) => {
        // 更新当前操作行状态
        if (dd[indexField2] == node.data[indexField2])
          dd[isSelectedRow] = isSelected;
        // 更新部分选择数据
        if (dd[isSelectedRow] === true) {
          partSelectedData[dd[indexField2]] = dd;
          sameLength++;
        } else {
          delete partSelectedData[dd[indexField2]];
        }
      });
      // 1. 父单子单状态不同
      // 2. 取消选择 或 子单全选，
      if (
        listNode.selected !== isSelected &&
        (isSelected === false ||
          sameLength === listNode.data[detailField].length)
      ) {
        disableCallback[listNode.id] = true;
        listNode.setSelected(isSelected);
        // 父表暂不需要这个字段
        // listNode.data[isSelectedRow] = isSelected;
      }
      // 父表部分选择状态
      if (sameLength > 0 && sameLength < listNode.data[detailField].length) {
        listNode.data[isPartSelectedRow] = true;
      } else {
        listNode.data[isPartSelectedRow] = false;
        listNode.data[detailField].map((dd) => {
          delete partSelectedData[dd[indexField2]];
        });
      }
      emit('detailRowSelected', e, Object.values(partSelectedData));
      // 更新行数据
      node.setData({ ...node.data });
      listNode.setData({ ...listNode.data });
    };

    return {
      gridRef,
      gridDetailRef,
      gridDefs1,
      gridDefs2,
      columnDefs1,
      columnDefs2,
      indexField2,
      gridOptionsList,
      gridOptionsDetail,
      AgGridTable: script$1a,
      onToggleAllRow,
      onToggleRow,
      onRedrawDetailRows,
      calcTableWidth,
      tableBodyWidth,
      tableViewWidth,
      scrollAreaWidth,
      scrollNext,
      changeLeftScroll,
      listRowHeight,
      detailRowHeight,
      onChangeRowHeight,
      pageIndex,
      pageSize,
      totalCount,
      pageSizeOptions,
      onPageChange,
      isShowDetail,
      listRowData,
      detailRowData,
      isFullRow,
      isDetailRow,
      checked,
      checkedAll,
      onRowDataChanged,
      onSelectionChanged,
      selectedData,
      isRowSelectable,
      isLastRow,
      isNoBorderRow,
      isPartSelectedRow,
      initColsWidth,
      updateColsWidth,
      blankField,
      stateConfig,
      onParentRowSelected,
      onChildRowSelected,
      handleSetSideBar,
      tableMessage,
    };
  },
});

const _hoisted_1$X = { style: {"height":"auto","position":"relative"} };
const _hoisted_2$I = { class: "sc-footer" };
const _hoisted_3$z = { class: "footer-wrapper" };
const _hoisted_4$r = {
  key: 0,
  class: "footer-selectall"
};
const _hoisted_5$j = { class: "number-show" };
const _hoisted_6$d = { class: "footer-content-right" };
const _hoisted_7$c = { class: "sc-table-btn" };
const _hoisted_8$b = ["title", "onClick"];
const _hoisted_9$a = ["innerHTML"];
const _hoisted_10$8 = ["title"];
const _hoisted_11$8 = { class: "iconfont" };
const _hoisted_12$8 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "ਙ", -1 /* HOISTED */);
const _hoisted_13$4 = [
  _hoisted_12$8
];
const _hoisted_14$5 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_15$5 = [
  _hoisted_14$5
];
const _hoisted_16$5 = /*#__PURE__*/createElementVNode("div", { id: "lastColStyle-isListTable" }, null, -1 /* HOISTED */);
const _hoisted_17$3 = /*#__PURE__*/createElementVNode("div", { id: "lastColStyle-isDetailTable" }, null, -1 /* HOISTED */);

function render$12(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AgGridTable = resolveComponent("AgGridTable");
  const _component_scrollbar = resolveComponent("scrollbar");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_pagination = resolveComponent("a-pagination");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.deepField ? 'sc-tree-grid' : ''),
    onClick: _cache[6] || (_cache[6] = withModifiers(() => {}, ["stop"]))
  }, [
    createElementVNode("div", {
      class: normalizeClass(["sc-table-total", _ctx.$slots.totalStatistic ? 'sc-has-total' : ''])
    }, [
      renderSlot(_ctx.$slots, "totalStatistic")
    ], 2 /* CLASS */),
    createElementVNode("div", _hoisted_1$X, [
      createVNode(_component_AgGridTable, mergeProps({
        style: {"width":"100%","position":"relative"},
        ref: "gridRef",
        id: "isListTable",
        gridOptions: _ctx.gridOptionsList,
        indexField: _ctx.indexField,
        deepField: _ctx.deepField,
        rowData: _ctx.listRowData,
        columnDefs: _ctx.columnDefs1,
        isListTable: true,
        calcTableWidth: _ctx.calcTableWidth,
        changeLeftScroll: _ctx.changeLeftScroll,
        onRowClicked: _ctx.onToggleRow,
        onSelectionChanged: _ctx.onSelectionChanged,
        onRowDataUpdated: _ctx.onRowDataChanged
      }, { ..._ctx.gridDefs1 }, {
        isRowSelectable: _ctx.isRowSelectable,
        onUpdateColsWidth: _ctx.updateColsWidth,
        onRowSelected: _ctx.onParentRowSelected
      }), null, 16 /* FULL_PROPS */, ["gridOptions", "indexField", "deepField", "rowData", "columnDefs", "calcTableWidth", "changeLeftScroll", "onRowClicked", "onSelectionChanged", "onRowDataUpdated", "isRowSelectable", "onUpdateColsWidth", "onRowSelected"]),
      createVNode(_component_AgGridTable, mergeProps({
        style: {"width":"100%","position":"absolute","top":"0"},
        ref: "gridDetailRef",
        id: "isDetailTable",
        gridOptions: _ctx.gridOptionsDetail,
        indexField: _ctx.indexField2,
        rowData: _ctx.detailRowData,
        columnDefs: _ctx.columnDefs2,
        isListTable: false,
        calcTableWidth: _ctx.calcTableWidth,
        changeLeftScroll: _ctx.changeLeftScroll,
        noRowsText: _ctx.noRowsText
      }, { ..._ctx.gridDefs2 }, {
        isCheckAllBox: false,
        isRowSelectable: _ctx.isRowSelectable,
        suppressRowClickSelection: true,
        onInitColsWidth: _ctx.initColsWidth,
        onUpdateColsWidth: _ctx.updateColsWidth,
        onRowSelected: _ctx.onChildRowSelected
      }), null, 16 /* FULL_PROPS */, ["gridOptions", "indexField", "rowData", "columnDefs", "calcTableWidth", "changeLeftScroll", "noRowsText", "isRowSelectable", "onInitColsWidth", "onUpdateColsWidth", "onRowSelected"])
    ]),
    createElementVNode("div", _hoisted_2$I, [
      createVNode(_component_scrollbar, {
        areaWidth: _ctx.scrollAreaWidth,
        scrollNext: _ctx.scrollNext
      }, null, 8 /* PROPS */, ["areaWidth", "scrollNext"]),
      createElementVNode("div", _hoisted_3$z, [
        createElementVNode("div", null, [
          (_ctx.isCheckAllBox)
            ? (openBlock(), createElementBlock("div", _hoisted_4$r, [
                createVNode(_component_a_checkbox, {
                  checked: _ctx.checked,
                  "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.checked) = $event)),
                  onChange: _ctx.checkedAll
                }, {
                  default: withCtx(() => [
                    createTextVNode("全选")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["checked", "onChange"]),
                createTextVNode(" 已选中"),
                createElementVNode("span", _hoisted_5$j, toDisplayString(_ctx.selectedData), 1 /* TEXT */),
                createTextVNode("条 ")
              ]))
            : createCommentVNode("v-if", true),
          renderSlot(_ctx.$slots, "footer", {
            slotData: this.selectedData
          })
        ]),
        createElementVNode("div", _hoisted_6$d, [
          (_ctx.pageData)
            ? (openBlock(), createBlock(_component_a_pagination, {
                key: 0,
                "show-size-changer": "",
                current: _ctx.pageIndex,
                "onUpdate:current": _cache[1] || (_cache[1] = $event => ((_ctx.pageIndex) = $event)),
                pageSize: _ctx.pageSize,
                "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => ((_ctx.pageSize) = $event)),
                pageSizeOptions: _ctx.pageSizeOptions,
                total: _ctx.totalCount,
                "show-total": (total) => `共 ${total} 条`,
                onChange: _ctx.onPageChange,
                onShowSizeChange: _ctx.onPageChange,
                isCheckAllBox: true,
                "show-less-items": ""
              }, {
                buildOptionText: withCtx((props) => [
                  createElementVNode("span", null, toDisplayString(props.value) + " 条/页", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["current", "pageSize", "pageSizeOptions", "total", "show-total", "onChange", "onShowSizeChange"]))
            : createCommentVNode("v-if", true),
          createElementVNode("div", _hoisted_7$c, [
            renderSlot(_ctx.$slots, "gridTools"),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.iconBtns, (btn, index) => {
              return (openBlock(), createElementBlock("span", {
                class: "option-btn-icon",
                key: index,
                title: btn.title,
                onClick: btn.onClick
              }, [
                createElementVNode("i", {
                  class: "iconfont",
                  innerHTML: btn.icon
                }, null, 8 /* PROPS */, _hoisted_9$a)
              ], 8 /* PROPS */, _hoisted_8$b))
            }), 128 /* KEYED_FRAGMENT */)),
            (_ctx.columnDefs2.length > 1)
              ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  class: "option-btn-icon",
                  onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.onToggleAllRow && _ctx.onToggleAllRow(...args))),
                  title: _ctx.isShowDetail ? '收起明细' : '展开明细'
                }, [
                  createElementVNode("i", _hoisted_11$8, toDisplayString(_ctx.isShowDetail ? '' : ''), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_10$8))
              : createCommentVNode("v-if", true),
            (_ctx.isShowSetButton)
              ? (openBlock(), createElementBlock("span", {
                  key: 1,
                  class: "option-btn-icon",
                  title: "表格列设置",
                  onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.handleSetSideBar && _ctx.handleSetSideBar(...args)))
                }, _hoisted_13$4))
              : createCommentVNode("v-if", true),
            createElementVNode("span", {
              class: "option-btn-icon",
              title: "调整行高",
              onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.onChangeRowHeight && _ctx.onChangeRowHeight(...args)))
            }, _hoisted_15$5)
          ])
        ])
      ])
    ]),
    _hoisted_16$5,
    _hoisted_17$3
  ], 2 /* CLASS */))
}

script$19.render = render$12;
script$19.__file = "packages/grid/src/DualGrid.vue";

LicenseManager.setLicenseKey(
  'DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6',
);
const stateConfig = 'sc_inner_grid_config';
var script$18 = defineComponent({
  name: 'InnerGrid',
  data() {
    return {
      isGridBarShow: false,
      rowHeightTimer: null,
      rowHeightTimerShow: false,
      isRefShow: false,
      isIconShow: false,
      selectedData: 0,
      // rowData: null,
      localeText: { ...AG_GRID_LOCALE_CN },
      modules: AllModules,
      isRowSelectable: null,
      // gridOptions: {},
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        resizable: true,
      },
      getRowHeight: null,
      scrollNext: 0,
      scrollAreaWidth: 0,
      tableBodyWidth: 0,
      tableViewWidth: 0,
      frameworkComponents: null,
      lineHeight: [24, 30, 40],
      arrIndex: 1,
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      pageSizeOptions: ['20', '40', '60', '80', '100', '200'],
      painedTimerIds: new Set(),
      rightPinnedCols: [],
      totalRowDataTop: [],
      totalRowDataBottom: [],
      rowClassRules: null,
      pinnedLeft: true,
      pinnedRight: false,
    };
  },
  components: {
    'a-pagination': Pagination,
    AgGridVue,
    Scrollbar: script$1q,
    /* eslint-disable-next-line */
    CellCommonRenderer: script$1g,
  },
  emits: ['rowSelected', 'pageChange', 'rowDataChanged'],
  props: {
    isChangeRow: {
      type: [Boolean],
      default: false,
    },
    gridOptions: {
      type: Object,
      default: () => ({}),
    },
    gridDefs: {
      type: Object,
      default: () => ({}),
    },
    headerHeight: {
      type: Number,
      default: 30,
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Array,
      required: true,
    },
    rowHeight: {
      type: Number,
      default: 30,
    },
    autoHeight: {
      type: [Boolean],
      default: false,
    },
    indexField: {
      type: String,
      default: 'id',
    },
    pageData: {
      type: Object,
      default: () => null,
    },
    isRenderTotal: {
      type: [Boolean],
      default: false,
    },
    isRenderTools: {
      type: [Boolean],
      default: true,
    },
    isBorder: {
      type: [Boolean],
      default: false,
    },
    isShowSetButton: {
      type: [Boolean],
      default: false,
    },
    maxHeight: {
      type: String,
      default: '400px',
    },
    height: {
      type: String,
      default: 'initial',
    },
    disableByName: {
      type: String,
      default: 'isDisable',
    },
    iconBtns: {
      type: Array,
      default: () => [],
    },
    noRowsText: {
      type: String,
      default: '没有查到符合条件的数据',
    },
    rowSelectedNoBgColor: {
      type: Boolean,
      default: false,
    },
    // '' | 'top', 'bottom'
    showTotalRow: {
      type: String,
      default: '',
    },
    totalRowData: {
      type: Object,
      default: () => null,
    },
    isSavePageSize: {
      type: [Boolean],
      default: true,
    },
    isCheckAllBox: {
      type: [Boolean],
      default: false,
    },
    relationSearchId: {
      type: String,
      default: '',
    },
  },
  inject: {
    setKeywords: {
      from: 'setKeywords',
      default: () => () => null,
    },
  },
  beforeMount() {
    // 优先读取表格本地设置
    this.initGridConfig();
    this.frameworkComponents = {
      DefaultTooltip: script$1p,
      CustomHeader: script$1f,
      CustomFiter: script$1e,
    };
    // 行高
    this.getRowHeight = () => {
      if (this.autoHeight) return null;
      return this.rowHeightRef;
    };
    this.setNoRowsToShow();
    this.rowClassRules = {
      'is-errline': ({ data }) => data.isErrorRow,
      'is-warnline': ({ data }) => data.isWarnRow,
    };
    this.isRowSelectable = (rowNode) => {
      return rowNode.data && !rowNode.data[this.disableByName];
    };
    // 获得项数(非禁用项)
    this.countSelectable = (rowData) => {
      return rowData.map((v) => ({ data: v })).filter(this.isRowSelectable)
        .length;
    };
  },
  mounted() {
    this.isRefShow = true;
    //接口api
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.$el.addEventListener('mouseenter', this.onMouseEnterTable);
  },
  watch: {
    isRefShow: {
      handler() {
        if (this.isRefShow) {
          this.isIconShow = this.findParent(this.$refs.gridRef);
        }
      },
      deep: true,
    },
    pageData: {
      handler() {
        this.initPageData();
      },
      deep: true,
    },
    noRowsText: {
      handler() {
        this.setNoRowsToShow();
      },
    },
    totalRowData: {
      handler() {
        this.initTotalRowData();
      },
    },
    // 解决Grid配置或数据改变时
    // rowData: {
    //   handler(rd) {
    //     this.gridApi.setRowData(rd);
    //   },
    // },
    // 多个表格共用一个组件时，重新加载本地存储
    '$attrs.id': {
      handler() {
        this.initGridConfig();
      },
    },
  },
  methods: {
    handleMouseEnterGrid() {
      this.isGridBarShow = true;
      this.rowHeightTimerShow = true;
      clearTimeout(this.rowHeightTimer);
    },
    handleMouseLeaveGrid() {
      this.isGridBarShow = false;
      this.rowHeightTimer = setTimeout(() => {
        this.rowHeightTimerShow = false;
      }, 500);
    },
    findParent(dom) {
      let a = false;
      if (dom.parentNode) {
        if (dom.parentNode.className?.includes('ant-drawer-body')) {
          a = true;
        } else {
          return this.findParent(dom.parentNode);
        }
      }
      return a;
    },
    deepLoop,
    getContextMenuItems,
    getMainMenuItems,
    resetPinnedHeaderWidth,
    resetColsWidth,
    sendToClipboard,
    getTotalRowData,
    initTotalRowData() {
      if (this.$props.showTotalRow) {
        const totalRowDatas = initTotalRowData(
          this.columnDefs,
          this.totalRowData,
          '',
          this.rowData,
        );
        // 缓存总数据
        this.frontTotalRowData = totalRowDatas[0];
        if (this.$props.showTotalRow === 'top') {
          this.totalRowDataTop = totalRowDatas;
        } else {
          this.totalRowDataBottom = totalRowDatas;
        }
      }
    },
    initShowCols() {
      const columnState = this.gridColumnApi.getColumnState();
      const state = initShowCols(this.columnDefs, this.rowData, columnState);
      state && this.gridColumnApi.applyColumnState({ state, applyOrder: true });
    },
    setNoRowsToShow() {
      // 设置无数据文本
      this.noRowsText && (this.localeText.noRowsToShow = this.noRowsText);
    },
    initGridConfig() {
      this.stateConfig = stateConfig + (this.$attrs.id || '');
      const config = getState(this.stateConfig);
      this.rowHeightRef = config.rowHeight || this.rowHeight;
      this.arrIndex = this.lineHeight.findIndex((e) => e === this.rowHeightRef);
      this.columnState = config.columnState;
      // 可编辑列样式-深度遍历
      this.deepLoop(
        this.columnDefs,
        this.gridDefs && this.gridDefs.headerGroup,
      );
      if (this.pageData) {
        const pageData = this.pageData;
        if (typeof pageData.pageIndex === 'number') {
          this.pageIndex = pageData.pageIndex;
        } else {
          pageData.pageIndex = this.pageIndex;
        }
        if (typeof pageData.pageSize === 'number') {
          this.pageSize = pageData.pageSize;
        } else {
          pageData.pageSize = this.pageSize;
        }
        this.isSavePageSize &&
          config.pageSize &&
          (pageData.pageSize = config.pageSize);
      }
    },
    initParmas() {
      if (!HTMLCollection.prototype.forEach) {
        HTMLCollection.prototype.forEach = Array.prototype.forEach;
      }
      if (!Array.prototype.findLastIndex) {
        Array.prototype.findLastIndex = function(cb) {
          if (!this) return -1;
          for (let i = this.length - 1; i >= 0; i--) {
            if (cb(this[i], i)) return i;
          }
          return -1;
        };
      }
    },
    onGridReady(params) {
      this.initParmas();
      // 获取表格视图宽度
      this.calcTableWidth(params.columnApi.columnModel);
      if (this.columnState)
        this.gridColumnApi.applyColumnState({
          state: this.columnState,
          applyOrder: true,
        });
      // 列载入完成后再绑定事件
      setTimeout(this.colsEvent, 100);
      const styleElem = document.createElement('style');
      styleElem.innerText = `.sc-inner-grid .ag-root-wrapper-body.ag-layout-normal { max-height:  ${this.maxHeight} }`;
      document.getElementById('app').append(styleElem);
    },
    // 改变行高
    onChangeRowHeight() {
      this.arrIndex = this.arrIndex == 2 ? 0 : ++this.arrIndex;
      this.rowHeightRef = this.lineHeight[this.arrIndex];
      this.gridApi.resetRowHeights();
      this.arrIndex === 0 && this.resetPinnedHeaderWidth();
      this.saveGridConfig();
    },
    onGridSizeChanged({ columnApi }) {
      // 计算表格宽度 给ScrollBar使用
      this.calcTableWidth(columnApi.columnModel);
    },
    onBodyScroll({ direction, left }) {
      if (direction === 'horizontal') {
        this.scrollNext = (left * this.scrollAreaWidth) / this.tableBodyWidth;
        this.pinnedLeft = left !== 0;
        this.pinnedRight =
          Math.abs(this.tableBodyWidth - this.tableViewWidth - left) > 3;
      }
    },
    initPageData() {
      if (!this.pageData) return;
      this.pageData.pageIndex && (this.pageIndex = this.pageData.pageIndex);
      this.pageData.pageSize && (this.pageSize = this.pageData.pageSize);
      this.totalCount = this.pageData.totalCount || 0;
      this.pageSizeOptions =
        this.pageData.pageSizeOptions || this.pageSizeOptions;
      this.oldPageIndex = this.pageIndex;
      this.oldPageSize = this.pageSize;
    },
    onPageChange(pageIndex, pageSize) {
      // 更改pageSize时修正pageIndex
      if (pageSize !== this.oldPageSize) {
        pageIndex =
          Math.floor(((pageIndex - 1) * this.oldPageSize) / pageSize) + 1;
      }
      pageIndex <= 0 && (pageIndex = 1);
      if (this.pageData) {
        const pageData = this.pageData;
        pageData.pageIndex = pageIndex;
        pageData.pageSize = pageSize;
      }
      let stop = false;
      this.$emit('pageChange', pageIndex, pageSize, (cb) => (stop = cb));
      // 回调阻止翻页和
      if (stop) {
        this.pageIndex = this.oldPageIndex;
        this.pageSize = this.oldPageSize;
        return;
      }
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.oldPageIndex = pageIndex;
      this.oldPageSize = pageSize;
      this.saveGridConfig();
    },
    //设置全选
    checkedAll() {
      // this.checked = !this.checked;
      if (this.checked) {
        this.gridApi.selectAll();
      } else {
        this.gridApi.deselectAll();
      }
    },
    // checked是全选复选框是否是选中的状态
    //监测复选框选中的个数
    onSelectionChanged() {
      // this.gridApi.getSelectedRows()获取选中的行
      var selRows = this.gridApi.getSelectedRows();

      // selectedData选中行的行数
      this.selectedData = selRows.length;
      this.checked =
        this.selectedData > 0 &&
        this.selectedData === this.countSelectable(this.rowData);
    },
    onRowSelected(params) {
      if (this.showTotalRow) {
        const selectedData = params.api.getSelectedRows();
        var selRows = this.gridApi.getSelectedRows();
        this.selectedData = selRows.length;
        const totalRowDatas = getTotalRowData(
          this.columnDefs,
          selectedData,
          this.totalRowData || this.frontTotalRowData,
        );
        if (this.showTotalRow === 'top') {
          this.totalRowDataTop = totalRowDatas;
        } else {
          this.totalRowDataBottom = totalRowDatas;
        }
      }
      this.$emit('rowSelected', params);
    },
    onRowDataChanged(params) {
      // 当数据发生变化时，清除全选框的选中状态
      this.selectableCount = this.countSelectable(this.rowData);
      var selRows = this.gridApi.getSelectedRows();
      this.selectedData = selRows.length;
      if (
        this.selectedData === this.selectableCount &&
        this.selectableCount != 0
      ) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      // 初始化列权限
      this.initShowCols();
      this.initTotalRowData();
      this.$emit('rowDataChanged', params);
    },
    onMouseEnterTable() {
      // 鼠标进入时重新计算单元格宽度
      this.calcTableWidth(this.gridColumnApi.columnModel);
    },
    calcTableWidth(col) {
      // 表格内容宽度
      this.tableBodyWidth = Math.round(col.bodyWidth);
      // 表格视窗宽度, 除数不能为0
      this.tableViewWidth = Math.round(col.flexViewportWidth || 100);
      if (Math.abs(this.tableBodyWidth - this.tableViewWidth) <= 4)
        this.tableBodyWidth = this.tableViewWidth;
      // 垂直滚动条宽度
      const agViewDom = this.$el.getElementsByClassName('ag-body-viewport')[0];
      const scrollWidth =
        agViewDom.scrollHeight > agViewDom.clientHeight ? 17 : 0;
      // 表格宽度，含左右固定区，scroll视窗宽度, 加垂直滚动条宽度
      const tableWdith =
        this.tableViewWidth +
        (col.leftWidth || 0) +
        (col.rightWidth || 0) +
        scrollWidth;
      // scroll内容宽度
      this.scrollAreaWidth = Math.round(
        (tableWdith * this.tableBodyWidth) / this.tableViewWidth,
      );
      const isLessCol = this.tableViewWidth > this.tableBodyWidth;
      const rightPinnedCols = this.resetColsWidth(isLessCol);
      if (rightPinnedCols.length) this.rightPinnedCols = rightPinnedCols;
    },
    // 表格设置
    handleSetSideBar() {
      this.showSideBar = !this.showSideBar;
      if (this.showSideBar) {
        this.gridApi.setSideBar('columns');
        this.$nextTick(() => {
          const panel = document.querySelector(
            '.ag-side-bar .ag-pivot-mode-panel',
          );
          if (panel) {
            panel.innerHTML = '<i class="iconfont">&#xa19;</i> 列设置';
          }
        });
      } else {
        this.gridApi.setSideBarVisible(false);
      }
    },
    saveGridConfigImmediate(e) {
      this.calcTableWidth(this.gridColumnApi.columnModel);
      this.columnState = this.gridColumnApi.getColumnState();
      if (e && e.type === 'leftChanged') {
        //列隐藏列， 清除列设置
        const showCols = this.columnState.filter(
          (col) => !col.hide && col.pinned !== 'left',
        );
        if (showCols.length <= 1) this.columnState = null;
      }
      const data = {
        rowHeight: this.rowHeightRef,
        columnState: this.columnState,
        pageSize: this.pageSize,
        rightPinnedCols: this.rightPinnedCols,
      };
      setState(this.stateConfig, data);
    },
    saveGridConfig(e) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.$nextTick(function() {
          this.saveGridConfigImmediate();
        });
      }, 200);
    },
    colsEvent() {
      this.calcTableWidth(this.gridColumnApi.columnModel);
      this.gridColumnApi.getColumns().forEach((col) => {
        col.addEventListener('leftChanged', this.saveGridConfig);
        col.addEventListener('widthChanged', this.saveGridConfig);
        col.addEventListener('visibleChanged', this.saveGridConfig);
      });
      this.gridApi.addEventListener('columnPinned', this.saveGridConfig);
    },
  },
  beforeUnmount() {
    this.saveGridConfigImmediate();
    this.$el.removeEventListener('mouseenter', this.onMouseEnterTable);
    // 移除列事件
    this.gridColumnApi.getColumns().forEach((col) => {
      col.removeEventListener('leftChanged', this.saveGridConfig);
      col.removeEventListener('widthChanged', this.saveGridConfig);
      col.removeEventListener('visibleChanged', this.saveGridConfig);
    });
    this.gridApi.removeEventListener('columnPinned', this.saveGridConfig);
  },
});

const _hoisted_1$W = { class: "sc-table-total" };
const _hoisted_2$H = { class: "sc-inner-footer" };
const _hoisted_3$y = {
  key: 0,
  class: "footer-wrapper"
};
const _hoisted_4$q = {
  key: 0,
  class: "footer-selectall"
};
const _hoisted_5$i = { class: "number-show" };
const _hoisted_6$c = { class: "footer-content-right" };
const _hoisted_7$b = {
  key: 1,
  class: "sc-table-btn"
};
const _hoisted_8$a = ["title", "onClick"];
const _hoisted_9$9 = ["innerHTML"];
const _hoisted_10$7 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "ਙ", -1 /* HOISTED */);
const _hoisted_11$7 = [
  _hoisted_10$7
];
const _hoisted_12$7 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_13$3 = [
  _hoisted_12$7
];
const _hoisted_14$4 = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_15$4 = [
  _hoisted_14$4
];
const _hoisted_16$4 = /*#__PURE__*/createElementVNode("div", { id: "lastColStyle" }, null, -1 /* HOISTED */);

function render$11(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ag_grid_vue = resolveComponent("ag-grid-vue");
  const _component_scrollbar = resolveComponent("scrollbar");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_pagination = resolveComponent("a-pagination");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["sc-grid-wrapper", {
      'sc-grid-fixed-height': _ctx.height !== 'initial',
      'sc-border-grid': _ctx.isBorder,
    }]),
    ref: "gridRef",
    onClick: _cache[6] || (_cache[6] = withModifiers(() => {}, ["stop"])),
    onMouseenter: _cache[7] || (_cache[7] = withModifiers((...args) => (_ctx.handleMouseEnterGrid && _ctx.handleMouseEnterGrid(...args)), ["stop"])),
    onMouseleave: _cache[8] || (_cache[8] = withModifiers((...args) => (_ctx.handleMouseLeaveGrid && _ctx.handleMouseLeaveGrid(...args)), ["stop"]))
  }, [
    createElementVNode("div", null, [
      createElementVNode("div", _hoisted_1$W, [
        renderSlot(_ctx.$slots, "totalStatistic")
      ])
    ]),
    createVNode(_component_ag_grid_vue, mergeProps({
      class: ["ag-theme-balham sc-inner-grid", {
        'no-result-wrap': _ctx.rowData.length === 0,
        'sc-grid-selected-no-bg': _ctx.rowData.length !== 0 && _ctx.rowSelectedNoBgColor,
        'sc-grid-pinned-left': _ctx.pinnedLeft,
        'sc-grid-pinned-right': _ctx.pinnedRight,
      }],
      enableRangeSelection: true,
      enableFillHandle: true,
      singleClickEdit: true,
      suppressHorizontalScroll: true,
      rowMultiSelectWithClick: true,
      enterMovesDown: true,
      enterMovesDownAfterEdit: true,
      animateRows: true,
      fillHandleDirection: "y",
      rowModelType: "clientSide",
      rowSelection: "multiple",
      gridOptions: _ctx.gridOptions,
      onGridReady: _ctx.onGridReady,
      defaultColDef: _ctx.defaultColDef,
      columnDefs: _ctx.columnDefs,
      localeText: _ctx.localeText,
      modules: _ctx.modules,
      rowData: _ctx.rowData,
      getRowHeight: _ctx.getRowHeight,
      isRowSelectable: _ctx.isRowSelectable,
      onGridSizeChanged: _ctx.onGridSizeChanged,
      onBodyScroll: _ctx.onBodyScroll,
      onRowSelected: _ctx.onRowSelected,
      onRowDataUpdated: _ctx.onRowDataChanged,
      onSelectionChanged: _ctx.onSelectionChanged,
      getContextMenuItems: (e) => _ctx.getContextMenuItems(e, _ctx.relationSearchId),
      sendToClipboard: _ctx.sendToClipboard,
      headerHeight: _ctx.headerHeight,
      tooltipShowDelay: 300,
      frameworkComponents: _ctx.frameworkComponents,
      getMainMenuItems: _ctx.getMainMenuItems,
      rowClassRules: _ctx.rowClassRules
    }, { ..._ctx.$props.gridDefs, ..._ctx.$attrs }, {
      style: { maxHeight: _ctx.maxHeight, height: _ctx.height },
      pinnedTopRowData: _ctx.totalRowDataTop,
      pinnedBottomRowData: _ctx.totalRowDataBottom,
      stopEditingWhenCellsLoseFocus: true
    }), null, 16 /* FULL_PROPS */, ["class", "gridOptions", "onGridReady", "defaultColDef", "columnDefs", "localeText", "modules", "rowData", "getRowHeight", "isRowSelectable", "onGridSizeChanged", "onBodyScroll", "onRowSelected", "onRowDataUpdated", "onSelectionChanged", "getContextMenuItems", "sendToClipboard", "headerHeight", "frameworkComponents", "getMainMenuItems", "rowClassRules", "style", "pinnedTopRowData", "pinnedBottomRowData"]),
    createElementVNode("div", _hoisted_2$H, [
      createVNode(_component_scrollbar, {
        isBarShow: _ctx.isGridBarShow,
        areaWidth: _ctx.scrollAreaWidth,
        scrollNext: _ctx.scrollNext
      }, null, 8 /* PROPS */, ["isBarShow", "areaWidth", "scrollNext"]),
      (
          _ctx.$slots.gridTools ||
            _ctx.isCheckAllBox ||
            _ctx.$slots.footer ||
            _ctx.pageData ||
            _ctx.iconBtns.length ||
            _ctx.isShowSetButton ||
            !_ctx.isIconShow
        )
        ? (openBlock(), createElementBlock("div", _hoisted_3$y, [
            createCommentVNode(" 新增全选 "),
            createElementVNode("div", null, [
              (_ctx.isCheckAllBox)
                ? (openBlock(), createElementBlock("div", _hoisted_4$q, [
                    createVNode(_component_a_checkbox, {
                      checked: _ctx.checked,
                      "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.checked) = $event)),
                      onChange: _ctx.checkedAll
                    }, {
                      default: withCtx(() => [
                        createTextVNode("全选")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["checked", "onChange"]),
                    createTextVNode(" 已选中"),
                    createElementVNode("span", _hoisted_5$i, toDisplayString(this.selectedData), 1 /* TEXT */),
                    createTextVNode("条 "),
                    createCommentVNode(" <a-button @click=\"delRowNode\">删除</a-button> ")
                  ]))
                : createCommentVNode("v-if", true),
              renderSlot(_ctx.$slots, "footer", {
                slotData: this.selectedData
              })
            ]),
            createElementVNode("div", _hoisted_6$c, [
              (_ctx.pageData && _ctx.pageData?.totalCount >= 20)
                ? (openBlock(), createBlock(_component_a_pagination, {
                    key: 0,
                    "show-size-changer": "",
                    current: _ctx.pageIndex,
                    "onUpdate:current": _cache[1] || (_cache[1] = $event => ((_ctx.pageIndex) = $event)),
                    pageSize: _ctx.pageSize,
                    "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => ((_ctx.pageSize) = $event)),
                    "show-total": (total) => `共 ${total} 条`,
                    pageSizeOptions: _ctx.pageSizeOptions,
                    total: _ctx.totalCount,
                    onChange: _ctx.onPageChange,
                    onShowSizeChange: _ctx.onPageChange,
                    "show-less-items": ""
                  }, null, 8 /* PROPS */, ["current", "pageSize", "show-total", "pageSizeOptions", "total", "onChange", "onShowSizeChange"]))
                : createCommentVNode("v-if", true),
              (_ctx.isRenderTools)
                ? (openBlock(), createElementBlock("div", _hoisted_7$b, [
                    renderSlot(_ctx.$slots, "gridTools"),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.iconBtns, (btn, index) => {
                      return (openBlock(), createElementBlock("span", {
                        class: "option-btn-icon",
                        key: index,
                        title: btn.title,
                        onClick: btn.onClick
                      }, [
                        createElementVNode("i", {
                          class: "iconfont",
                          innerHTML: btn.icon
                        }, null, 8 /* PROPS */, _hoisted_9$9)
                      ], 8 /* PROPS */, _hoisted_8$a))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_ctx.isShowSetButton)
                      ? (openBlock(), createElementBlock("span", {
                          key: 0,
                          class: "option-btn-icon",
                          title: "表格列设置",
                          onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.handleSetSideBar && _ctx.handleSetSideBar(...args)))
                        }, _hoisted_11$7))
                      : createCommentVNode("v-if", true),
                    (!_ctx.autoHeight && !_ctx.isIconShow)
                      ? (openBlock(), createElementBlock("span", {
                          key: 1,
                          class: "option-btn-icon",
                          title: "调整行高",
                          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.onChangeRowHeight && _ctx.onChangeRowHeight(...args)))
                        }, _hoisted_13$3))
                      : createCommentVNode("v-if", true)
                  ]))
                : createCommentVNode("v-if", true)
            ])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    (_ctx.isIconShow && _ctx.rowHeightTimerShow)
      ? (openBlock(), createElementBlock("span", {
          key: 0,
          title: "调整行高",
          onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.onChangeRowHeight && _ctx.onChangeRowHeight(...args))),
          class: "option-btn-icon set-row-height-hover"
        }, _hoisted_15$4))
      : createCommentVNode("v-if", true),
    _hoisted_16$4
  ], 34 /* CLASS, HYDRATE_EVENTS */))
}

script$18.render = render$11;
script$18.__file = "packages/grid/src/InnerGrid.vue";

script$1b.install = (Vue) => {
    Vue.component(script$1b.name, script$1b);
    Vue.component(script$19.name, script$19);
    Vue.component(script$18.name, script$18);
};
function getWidth(basic) {
    // padding=12
    return basic + 12 * 2;
}
const GridColumnWidths = {
    /**
     * 人名
     */
    personName: getWidth(64),
    /**
     * 单据流水号，编码2位+年月日6位+时分4位+流水号4位（例：SO23091517030001）
     */
    flowNo: getWidth(111),
    /**
     * 业务名称：比如物料就是物料名称，客户就是客户名称
     */
    businessName: getWidth(180),
    /**
     * 时间日期：2023-09-15 17:09:01
     */
    dateTime: getWidth(140),
    /**
     * 状态列
     */
    status: getWidth(70),
};

const useModal = (props, emit) => {
    const visibleRef = computed({
        get: () => props.visible,
        set: (val) => emit('update:visible', val),
    });
    const okBtn = {
        text: props.okText,
        type: 'primary',
        onClick: () => ((visibleRef.value = false), emit('ok')),
    };
    const cancelBtn = {
        text: props.cancelText,
        onClick: () => ((visibleRef.value = false), emit('cancel')),
    };
    const modalBtns = ref([]);
    okBtn.text && modalBtns.value.push(okBtn);
    props.btns && modalBtns.value.push(...props.btns);
    cancelBtn.text && modalBtns.value.push(cancelBtn);
    return {
        visibleRef,
        modalBtns,
    };
};
// SearchForm
const useSearchForm$1 = (props) => {
    const rowData = ref([]);
    const handleSearch = async ({ keywords }) => {
        keywords.pageIndex = 1;
        keywords.pageSize = 200;
        rowData.value = (await props.onSearch(keywords)) || [];
    };
    return {
        rowData,
        handleSearch,
    };
};
const useInnerGrid = (props, emit, visibleRef, modalBtns) => {
    const selectedValueRef = ref([]); // 选中行
    const existedRef = ref(0); // 主表已存在的数据
    const okBtnDisabled = computed(() => selectedValueRef.value.length === 0); // 确定按钮禁用
    const okBtnLoading = ref(false);
    // 单选模式和多选模式
    const isMultiSelect = computed(() => {
        const index = props.columnDefs.findIndex((e) => e.checkboxSelection);
        return index > -1 ? true : false;
    });
    // 表格初始设置
    const gridDefs = {
        getRowNodeId: (data) => data[props.indexField],
        rowMultiSelectWithClick: isMultiSelect.value,
    };
    const gridOptions = reactive({ api: {}, columnApi: {} });
    // 表格初始选择
    const onRowDataChanged = (params) => {
        selectedValueRef.value = JSON.parse(JSON.stringify(props.value));
        selectedValueRef.value.map((data) => {
            const node = params.api.getRowNode(data[props.indexField]);
            node && node.setSelected(true);
        });
        existedRef.value = 0;
    };
    const onRowSelected = ({ data, node }) => {
        const selected = node.isSelected();
        const index = selectedValueRef.value.findIndex((e) => e[props.indexField] === node[props.indexField]);
        if (selected) {
            existedRef.value = 0;
            !isMultiSelect.value && selectedValueRef.value.splice(0);
            index === -1 && selectedValueRef.value.push(data);
        }
        else {
            index !== -1 && selectedValueRef.value.splice(index, 1);
        }
    };
    // 重写表单确定方法
    const handleOk = () => {
        const cb = (res, data) => {
            res && props.close(visibleRef);
            okBtnLoading.value = false;
            if (data && data.length) {
                existedRef.value = 0;
                const ids = data.map((d) => d[props.indexField]);
                selectedValueRef.value.map((data) => {
                    const node = gridOptions.api.getRowNode(data[props.indexField]);
                    if (node) {
                        node.setSelected(false);
                        const index = ids.findIndex((id) => id === data[props.indexField]);
                        index > -1 &&
                            (node.setData({
                                ...node.data,
                                isWarnRow: true,
                                isDisable: true,
                            }),
                                (existedRef.value += 1));
                    }
                });
                selectedValueRef.value = [];
                return false;
            }
        };
        okBtnLoading.value = true;
        emit('submit', selectedValueRef.value, cb, props.tableName);
    };
    // 重写确定方法和状态
    modalBtns.value[0].onClick = handleOk;
    modalBtns.value[0].disabled = okBtnDisabled;
    modalBtns.value[0].loading = okBtnLoading;
    return {
        gridDefs,
        gridOptions,
        onRowSelected,
        selectedValueRef,
        onRowDataChanged,
        existedRef,
    };
};

var script$17 = defineComponent({
    name: 'ScModalConfirm',
    components: {
        'a-alert': Alert,
        Modal: script$1N,
        InnerGrid: script$18,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes;
        },
    },
    props: {
        visible: {
            type: [Boolean],
            default: true,
        },
        icon: {
            type: [Object, String],
            default: 'warning',
        },
        content: {
            type: [String, Object],
            default: '',
        },
        okText: {
            type: String,
            default: '确定',
        },
        cancelText: {
            type: String,
            default: '取消',
        },
        title: {
            type: String,
            default: '提示',
        },
        width: {
            type: String,
        },
        btns: {
            type: Array,
        },
        // alert
        message: {
            type: [String, Object],
            default: '',
        },
        alertProps: {
            type: Object,
            default: () => ({}),
        },
        // 表格
        columnDefs: {
            type: Array,
        },
        rowData: {
            type: Array,
            default: () => [],
        },
        tableProps: {
            type: Object,
            default: () => ({}),
        },
    },
    // emits: ['update:visible', 'ok', 'cancel'],
    setup(props, { emit }) {
        const isVNode = (content) => {
            return typeof content == 'object' && content.__v_isVNode;
        };
        const { visibleRef, modalBtns } = useModal(props, emit);
        // 点击事件，仅在目标为A时触发
        const handleClick = (event, item) => {
            if (item.onClick &&
                event &&
                event.target &&
                event.target.nodeName === 'A') {
                item.onClick(event);
            }
        };
        const enterHandler = () => {
            emit('ok');
        };
        return {
            visibleRef,
            modalBtns,
            isVNode,
            handleClick,
            enterHandler,
        };
    },
});

const _hoisted_1$V = { class: "title-text" };
const _hoisted_2$G = ["innerHTML"];
const _hoisted_3$x = ["innerHTML"];

function render$10(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_a_alert = resolveComponent("a-alert");
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, {
    class: normalizeClass(!_ctx.columnDefs && 'sc-fn-modal'),
    title: _ctx.columnDefs && _ctx.title,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => ((_ctx.visibleRef) = $event)),
    btns: _ctx.modalBtns,
    width: _ctx.width,
    onEnter: _ctx.enterHandler
  }, createSlots({
    default: withCtx(() => [
      (_ctx.message)
        ? (openBlock(), createBlock(_component_a_alert, mergeProps({
            key: 0,
            "show-icon": false,
            banner: "",
            style: {"margin-top":"-10px","margin-bottom":"10px"}
          }, { ..._ctx.alertProps }), {
            message: withCtx(() => [
              createElementVNode("div", {
                innerHTML: _ctx.message.text || _ctx.message,
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.handleClick($event, _ctx.message)))
              }, null, 8 /* PROPS */, _hoisted_2$G)
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */))
        : createCommentVNode("v-if", true),
      (_ctx.columnDefs)
        ? (openBlock(), createBlock(_component_InnerGrid, mergeProps({
            key: 1,
            columnDefs: _ctx.columnDefs,
            rowData: _ctx.rowData,
            maxHeight: '300px'
          }, { ..._ctx.tableProps }), null, 16 /* FULL_PROPS */, ["columnDefs", "rowData"]))
        : createCommentVNode("v-if", true),
      (_ctx.content)
        ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
            (_ctx.isVNode(_ctx.content))
              ? (openBlock(), createBlock(_component_v_nodes, {
                  key: 0,
                  vnodes: _ctx.content
                }, null, 8 /* PROPS */, ["vnodes"]))
              : (openBlock(), createElementBlock("span", {
                  key: 1,
                  innerHTML: _ctx.content.text || _ctx.content,
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.handleClick($event, _ctx.content)))
                }, null, 8 /* PROPS */, _hoisted_3$x))
          ], 64 /* STABLE_FRAGMENT */))
        : createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (!_ctx.columnDefs)
      ? {
          name: "title",
          fn: withCtx(() => [
            (_ctx.isVNode(_ctx.icon))
              ? (openBlock(), createBlock(_component_v_nodes, {
                  key: 0,
                  vnodes: _ctx.icon
                }, null, 8 /* PROPS */, ["vnodes"]))
              : (openBlock(), createElementBlock("span", {
                  key: 1,
                  class: normalizeClass('sc-' + _ctx.icon)
                }, null, 2 /* CLASS */)),
            createElementVNode("span", _hoisted_1$V, toDisplayString(_ctx.title), 1 /* TEXT */)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "title", "visible", "btns", "width", "onEnter"]))
}

script$17.render = render$10;
script$17.__file = "packages/modal/src/ModalConfirm.vue";

const $modal = (props = {}) => {
    const dom = document.createElement('div');
    document.body.appendChild(dom);
    const app = createApp(script$1t, {
        close: () => {
            app.unmount();
            document.body.removeChild(dom);
        },
        ...props,
    });
    app.mount(dom);
};
// TODO:表格包体积过大的问题，后续修复
const $modalTable = (props = {}) => {
    return new Promise((resolve, reject) => {
        const dom = document.createElement('div');
        document.body.appendChild(dom);
        const close = () => {
            app.unmount();
            document.body.removeChild(dom);
        };
        props = rewriteProps(props, close, resolve, reject);
        props.visible = true; // 覆盖组件中默认值false
        props.close = close; // 覆盖组件内默认的close方法
        props.onOk = undefined; // 删除ok事件，使用submit事件
        const app = createApp(script$W, props);
        app.use(antd).mount(dom);
    });
};
const $modalConfirm = (props = {}) => {
    return new Promise((resolve, reject) => {
        const dom = document.createElement('div');
        document.body.appendChild(dom);
        const close = () => {
            app.unmount();
            document.body.removeChild(dom);
        };
        props = rewriteProps(props, close, resolve, reject);
        props.onSubmit = undefined; // 删除submit事件，使用ok事件
        const app = createApp(script$17, props);
        app.mount(dom);
    });
};
const $modalForm = (props = {}) => {
    return new Promise((resolve, reject) => {
        const dom = document.createElement('div');
        document.body.appendChild(dom);
        const close = () => {
            app.unmount();
            document.body.removeChild(dom);
        };
        props = rewriteProps(props, close, resolve, reject);
        props.visible = true; // 覆盖组件中默认值false
        props.close = close; // 覆盖组件内默认的close方法
        delete props.onOk; // 删除ok事件，使用submit事件
        const app = createApp(script$1u, props);
        app.use(antd).mount(dom);
    });
};
const $notification = (props = {}) => {
    !props.key && (props.key = new Date().getTime().toString());
    // 描述
    typeof props.description === 'string' &&
        (props.description = h('div', { innerHTML: props.description }));
    // 关闭按钮
    const btns = [];
    if (!props.btn) {
        const btn1 = h('a', {
            onClick: (e) => (e.stopPropagation(), notification.close(props.key)),
        }, props.closeText);
        if (props.viewBtn) {
            const btn2 = h('a', {
                href: props.viewBtn.href,
                target: props.viewBtn.target || '_blank',
                onClick: (e) => (e.stopPropagation(),
                    props.viewBtn &&
                        props.viewBtn.close &&
                        notification.close(props.key)),
            }, props.viewBtn.text);
            btns.push(btn2);
        }
        props.closeText && btns.push(btn1);
        props.btn = h('div', btns);
    }
    const icon = props.icon || 'success';
    props.icon = undefined; // 覆盖antd的icon属性
    notification[icon](props);
};
// btns处理,默认关闭弹窗， 返回false不关闭
const rewriteProps = (props, close, resolve, reject) => {
    const newProps = {};
    if (props.btns) {
        const btns = [];
        props.btns.map((btn) => {
            btns.push({
                ...btn,
                onClick: () => {
                    (btn.onClick && btn.onClick()) !== false && close();
                    resolve && resolve(btn.text);
                },
            });
        });
        newProps.btns = btns;
    }
    newProps.onCancel = () => {
        (props.onCancel && props.onCancel()) !== false && close();
        reject && reject(false);
    };
    // Modal.confirm 有该属性
    newProps.onOk = () => {
        (props.onOk && props.onOk()) !== false && close();
        resolve && resolve(true);
    };
    // Modal.table 和 Modal.form 有该属性
    newProps.onSubmit = async (val, cb) => {
        (props.onSubmit &&
            (await props.onSubmit(val, (d) => cb(false, d)))) !== false &&
            close();
        resolve && resolve(val);
    };
    return { ...props, ...newProps };
};

var script$16 = defineComponent({
    name: 'ScDrawer',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        width: {
            type: [String, Number],
            default: 256,
        },
        height: {
            type: [String, Number],
            default: 256,
        },
        placement: {
            type: String,
            default: 'right',
        },
        containerClass: {
            type: String,
        },
        keyboard: {
            type: Boolean,
            default: true,
        },
        beforeClose: Function,
    },
    setup(props, context) {
        const placement = ref(props.placement);
        const pathname = window.location.pathname + '&scDrawer' + placement.value;
        const state = getState(pathname);
        // 视窗宽度
        let viewWidth = document.body.clientWidth - 50;
        const viewHeight = document.body.clientHeight;
        const widthRef = ref(placement.value == 'bottom'
            ? 0
            : Math.min(state.width ||
                (typeof props.width === 'number'
                    ? transferWidth(props.width)
                    : props.width), viewWidth));
        const target = () => drawerRef.value.parentNode;
        const targetOffset = ref(0);
        targetOffset.value = window.innerHeight / 4;
        const heightRef = ref(Math.min(state.height || props.height, viewHeight));
        const leftRef = ref(0);
        const visibleRef = ref(props.visible);
        let dom;
        const drag = {
            isDragging: false,
            x: 0,
            y: 0,
            w: 0,
            h: 0,
        };
        const drawerRef = ref();
        const anchorChange = (id) => {
            const panels = drawerRef.value?.querySelector(`${id} .ant-collapse-header .sc-collapse-main-header`);
            panels.style.backgroundColor = 'rgba(0,112,221,0.1)';
            let timer = setTimeout(() => {
                panels.style.backgroundColor = '#fff';
                clearTimeout(timer);
            }, 600);
        };
        function startDrag(e) {
            viewWidth = document.body.clientWidth - 50;
            dom = e.target;
            if (dom.className === 'ant-drawer-content-wrapper') {
                if (placement.value == 'bottom') {
                    drag.y = e.clientY;
                    drag.h = dom.clientHeight;
                }
                else {
                    drag.x = e.clientX;
                    drag.w = dom.clientWidth;
                }
                drag.isDragging = true;
            }
            e.stopPropagation();
        }
        const anchorList = ref([]);
        const unwatch = watch(() => props.visible, (v) => {
            if (v) {
                const targetNode = drawerRef.value?.querySelector('.ant-collapse');
                if (targetNode) {
                    const config = { childList: true };
                    const callback = function () {
                        anchorList.value = [];
                        const panels = drawerRef.value?.querySelectorAll('.sc-collapse-panel');
                        panels?.forEach((item, index) => {
                            item.id = '';
                            const text = item.querySelector('.sc-collapse-main-header')
                                ?.textContent;
                            if (!item.id) {
                                item.id = `sc-collapse-panel${new Date().getTime()}${index}`;
                            }
                            anchorList.value.push({ title: text, href: `#${item.id}` });
                        });
                        drawerRef.value.parentNode.scrollBy(0, 1);
                        drawerRef.value.parentNode.scrollBy(0, -1);
                    };
                    callback();
                    // 创建一个观察器实例并传入回调函数
                    const observer = new MutationObserver(callback);
                    // 以上述配置开始观察目标节点
                    observer.observe(targetNode, config);
                    unwatch();
                }
            }
        }, {
            flush: 'post',
        });
        function onDrag(e) {
            if (drag.isDragging === false) {
                return;
            }
            if (placement.value == 'bottom') {
                let hd = drag.h - (e.clientY - drag.y);
                // 拖拽时不能超出视窗
                if (hd > viewHeight) {
                    hd = viewHeight;
                }
                dom.style.height = hd + 'px';
                heightRef.value = hd;
            }
            else {
                let wd = drag.w - (e.clientX - drag.x);
                // 拖拽时不能超出视窗
                if (wd > viewWidth) {
                    wd = viewWidth;
                }
                dom.style.width = wd + 'px';
                widthRef.value = wd;
            }
            e.stopPropagation();
        }
        function stopDrag() {
            drag.isDragging = false;
            setState(pathname, { width: widthRef.value, height: heightRef.value });
        }
        function closeDrawerByCondition(condition) {
            if (condition) {
                drag.isDragging = false;
                visibleRef.value = false;
                context.emit('update:visible', visibleRef.value);
            }
        }
        function closeDrawer() {
            if (drag.isDragging)
                return;
            if (typeof props.beforeClose === 'function') {
                const ret = props.beforeClose();
                if (ret.then) {
                    ret.then((condition) => {
                        closeDrawerByCondition(condition);
                    });
                }
                else {
                    closeDrawerByCondition(ret);
                }
                return;
            }
            drag.isDragging = false;
            visibleRef.value = false;
            context.emit('update:visible', visibleRef.value);
        }
        // 底部滑出框尺寸、位置设置
        const setOffset = () => {
            const container = props.containerClass
                ? document.getElementsByClassName(props.containerClass)[0]
                : document.body;
            const rect = container.getBoundingClientRect();
            widthRef.value = rect.width;
            leftRef.value = rect.left;
        };
        const addDragEvent = (val) => {
            if (placement.value == 'bottom') {
                setOffset();
            }
            // 更新值
            visibleRef.value = val;
            context.emit('update:visible', visibleRef.value);
            // visibleChange时触发事件
            const eventName = val ? 'open' : 'close';
            context.emit(eventName);
            //绑定事件
            const domLayout = document.getElementsByClassName('layout')[0];
            if (val === true) {
                document.addEventListener('mousedown', startDrag);
                document.addEventListener('mousemove', onDrag);
                document.addEventListener('mouseup', stopDrag);
                domLayout.addEventListener('mouseup', closeDrawer, { capture: true });
            }
            else {
                // 注销事件
                document.removeEventListener('mousedown', startDrag);
                document.removeEventListener('mousemove', onDrag);
                document.removeEventListener('mouseup', stopDrag);
                domLayout && domLayout.removeEventListener('mouseup', closeDrawer);
            }
        };
        watch(() => props.visible, addDragEvent);
        onMounted(() => {
            if (placement.value == 'bottom') {
                setOffset();
            }
            addDragEvent(props.visible);
        });
        return {
            visibleRef,
            widthRef,
            heightRef,
            leftRef,
            closeDrawer,
            target,
            targetOffset,
            drawerRef,
            anchorList,
            anchorChange,
        };
    },
});

const _hoisted_1$U = { ref: "drawerRef" };
const _hoisted_2$F = {
  key: 0,
  class: "sc-drawer-footer"
};
const _hoisted_3$w = { class: "drawer-btn-group" };
const _hoisted_4$p = {
  key: 1,
  class: "sc-drawer-anchor"
};

function render$$(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_anchor_link = resolveComponent("a-anchor-link");
  const _component_a_anchor = resolveComponent("a-anchor");
  const _component_a_drawer = resolveComponent("a-drawer");

  return (openBlock(), createBlock(_component_a_drawer, {
    class: normalizeClass(["sc-drawer", {
      'sc-drawer-has-footer': !!_ctx.$slots.footer,
      'sc-drawer-no-title': !_ctx.$slots.title,
      'sc-drawer-left-anchor': _ctx.anchorList.length >= 3,
    }]),
    mask: false,
    style: normalizeStyle(
      _ctx.placement == 'bottom'
        ? { width: _ctx.widthRef + 'px', left: _ctx.leftRef + 'px' }
        : {}
    ),
    width: _ctx.widthRef,
    height: _ctx.heightRef,
    visible: _ctx.visibleRef,
    placement: _ctx.placement,
    keyboard: _ctx.keyboard,
    onClose: _ctx.closeDrawer
  }, {
    title: withCtx(() => [
      renderSlot(_ctx.$slots, "title")
    ]),
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$U, [
        renderSlot(_ctx.$slots, "default")
      ], 512 /* NEED_PATCH */),
      (_ctx.$slots.footer)
        ? (openBlock(), createElementBlock("div", _hoisted_2$F, [
            createElementVNode("div", _hoisted_3$w, [
              renderSlot(_ctx.$slots, "footer")
            ])
          ]))
        : createCommentVNode("v-if", true),
      (_ctx.anchorList.length >= 3)
        ? (openBlock(), createElementBlock("div", _hoisted_4$p, [
            createVNode(_component_a_anchor, {
              getContainer: _ctx.target,
              targetOffset: 20
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.anchorList, (item) => {
                  return (openBlock(), createBlock(_component_a_anchor_link, {
                    onClick: [
                      _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
                      $event => (_ctx.anchorChange(item.href))
                    ],
                    key: item.href,
                    href: item.href,
                    title: item.title
                  }, null, 8 /* PROPS */, ["onClick", "href", "title"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getContainer"])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "style", "width", "height", "visible", "placement", "keyboard", "onClose"]))
}

script$16.render = render$$;
script$16.__file = "packages/drawer/Drawer.vue";

script$16.install = (Vue) => {
    Vue.component(script$16.name, script$16);
};

var script$15 = defineComponent({
    name: 'ScCollapse',
    props: {
        collapses: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        return {};
    },
});

function render$_(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_collapse_panel = resolveComponent("a-collapse-panel");
  const _component_a_collapse = resolveComponent("a-collapse");

  return (openBlock(), createBlock(_component_a_collapse, mergeProps({ class: "sc-collapse sc-collapse-before" }, { ..._ctx.$props, ..._ctx.$attrs }), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.collapses, (item, index) => {
        return (openBlock(), createBlock(_component_a_collapse_panel, mergeProps({
          key: index.toString()
        }, { ..._ctx.$props, ..._ctx.$attrs }), {
          extra: withCtx(() => [
            renderSlot(_ctx.$slots, "extra", {
              record: item,
              index: index
            })
          ]),
          header: withCtx(() => [
            renderSlot(_ctx.$slots, "header", {
              record: item,
              index: index
            })
          ]),
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {
              record: item,
              index: index
            })
          ]),
          _: 2 /* DYNAMIC */
        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}

script$15.render = render$_;
script$15.__file = "packages/collapse/OldCollapse.vue";

function computeVmIndex(vnodes, element) {
    return Object.values(vnodes).indexOf(element);
}
function computeIndexes(slots, children, isTransition, footerOffset) {
    if (!slots) {
        return [];
    }
    const elmFromNodes = Object.values(slots);
    const footerIndex = children.length - footerOffset;
    const rawIndexes = [...children].map((elt, idx) => idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt));
    return rawIndexes;
}
const eventsListened = ['Start', 'Add', 'Remove', 'Update', 'End'];
const eventsToEmit = ['Choose', 'Unchoose', 'Sort', 'Filter', 'Clone'];
const readonlyProperties = ['Move', ...eventsListened, ...eventsToEmit].map((evt) => 'on' + evt);
let draggingElement = null;
const props = {
    options: Object,
    list: {
        type: Array,
        required: false,
        default: null,
    },
    noTransitionOnDrag: {
        type: Boolean,
        default: false,
    },
    clone: {
        type: Function,
        default: (original) => {
            return original;
        },
    },
    tag: {
        type: String,
        default: 'div',
    },
    move: {
        type: Function,
        default: null,
    },
    componentData: {
        type: Object,
        required: false,
        default: null,
    },
    component: {
        type: String,
        default: null,
    },
    modelValue: {
        type: Array,
        required: false,
        default: null,
    },
};
var script$14 = defineComponent({
    name: 'SCDraggable',
    inheritAttrs: false,
    emits: [
        'update:modelValue',
        'move',
        'change',
        ...eventsListened.map((s) => s.toLowerCase()),
        ...eventsToEmit.map((s) => s.toLowerCase()),
    ],
    props,
    data() {
        return {
            transitionMode: false,
            noneFunctionalComponentMode: false,
            headerOffset: 0,
            footerOffset: 0,
            innerSortable: {},
            visibleIndexes: [],
            context: {},
        };
    },
    created() {
        if (this.list !== null && this.modelValue !== null) {
            throw new Error('list props are mutually exclusive! Please set one.');
        }
    },
    mounted() {
        const optionsAdded = {};
        eventsListened.forEach((elt) => {
            optionsAdded['on' + elt] = this.delegateAndEmit.call(this, elt);
        });
        eventsToEmit.forEach((elt) => {
            optionsAdded['on' + elt] = this.emit.bind(this, elt);
        });
        const attributes = Object.keys(this.$attrs).reduce((res, key) => {
            res[camelize(key)] = this.$attrs[key];
            return res;
        }, {});
        const options = Object.assign({}, attributes, optionsAdded, {
            onMove: (evt, originalEvent) => {
                return this.onDragMove(evt, originalEvent);
            },
        });
        !('draggable' in options) && (options.draggable = '>*');
        const targetDomElement = this.$el.nodeType === 1 ? this.$el : this.$el.parentElement;
        this.innerSortable = new Sortable(targetDomElement, options);
        targetDomElement.__draggable_component__ = this;
        this.computeIndexes();
    },
    beforeUnmount() {
        if (this.innerSortable !== undefined)
            this.innerSortable.destroy();
    },
    computed: {
        realList() {
            return this.list ? this.list : this.modelValue;
        },
    },
    watch: {
        $attrs: {
            handler(newOptionValue) {
                this.updateOptions(newOptionValue);
            },
            deep: true,
        },
        realList() {
            this.computeIndexes();
        },
    },
    methods: {
        emit(evtName, evtData) {
            this.$nextTick(() => this.$emit(evtName.toLowerCase(), evtData));
        },
        delegateAndEmit(evtName) {
            return (evtData) => {
                if (this.realList !== null) {
                    this['onDrag' + evtName](evtData);
                }
                this.emit.call(this, evtName, evtData);
            };
        },
        getTag() {
            return this.component ? resolveComponent(this.component) : this.tag;
        },
        updateOptions(newOptionValue) {
            for (var property in newOptionValue) {
                const value = camelize(property);
                if (readonlyProperties.indexOf(value) === -1) {
                    this.innerSortable.option(value, newOptionValue[property]);
                }
            }
        },
        getChildrenNodes() {
            return this.$el.children;
        },
        computeIndexes() {
            this.$nextTick(() => {
                this.visibleIndexes = computeIndexes(this.getChildrenNodes(), this.$el.children, this.transitionMode, this.footerOffset);
            });
        },
        getUnderlyingVm(htmlElt) {
            const index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
            if (index === -1) {
                //Edge case during move callback: related element might be
                //an element different from collection
                return null;
            }
            const element = this.realList[index];
            return { index, element };
        },
        emitChanges(evt) {
            this.$nextTick(() => {
                this.$emit('change', evt);
            });
        },
        alterList(onList) {
            if (this.list) {
                onList(this.list);
                return;
            }
            const newList = [...this.modelValue];
            onList(newList);
            this.$emit('update:modelValue', newList);
        },
        spliceList(start, count, element) {
            const spliceList = (list) => list.splice(...arguments);
            this.alterList(spliceList);
        },
        updatePosition(oldIndex, newIndex) {
            const updatePosition = (list) => list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
            this.alterList(updatePosition);
        },
        getVmIndex(domIndex) {
            const indexes = this.visibleIndexes;
            const numberIndexes = indexes.length;
            return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
        },
        getComponent() {
            return this.$slots.default
                ? this.$slots.default()[0]['componentInstance']
                : null;
        },
        resetTransitionData(index) {
            if (!this.noTransitionOnDrag || !this.transitionMode) {
                return;
            }
            var nodes = this.getChildrenNodes();
            nodes[index].data = null;
            const transitionContainer = this.getComponent();
            transitionContainer.children = [];
            transitionContainer.kept = undefined;
        },
        onDragStart(evt) {
            this.context = this.getUnderlyingVm(evt.item);
            if (!this.context)
                return;
            evt.item._underlying_vm_ = this.clone(this.context.element);
            draggingElement = evt.item;
        },
        onDragAdd(evt) {
            const element = evt.item._underlying_vm_;
            if (element === undefined) {
                return;
            }
            removeNode(evt.item);
            const newIndex = this.getVmIndex(evt.newIndex);
            this.spliceList(newIndex, 0, element);
            this.computeIndexes();
            const added = { element, newIndex };
            this.emitChanges({ added });
        },
        onDragRemove(evt) {
            insertNodeAt(this.$el, evt.item, evt.oldIndex);
            if (evt.pullMode === 'clone') {
                removeNode(evt.clone);
                return;
            }
            if (!this.context)
                return;
            const oldIndex = this.context.index;
            this.spliceList(oldIndex, 1);
            const removed = { element: this.context.element, oldIndex };
            this.resetTransitionData(oldIndex);
            this.emitChanges({ removed });
        },
        onDragUpdate(evt) {
            removeNode(evt.item);
            insertNodeAt(evt.from, evt.item, evt.oldIndex);
            const oldIndex = this.context?.index;
            const newIndex = this.getVmIndex(evt.newIndex);
            this.updatePosition(oldIndex, newIndex);
            const moved = { element: this.context?.element, oldIndex, newIndex };
            this.emitChanges({ moved });
        },
        updateProperty(evt, propertyName) {
            ({}.hasOwnProperty.call(void 0, propertyName) &&
                (evt[propertyName] += this.headerOffset));
        },
        onDragMove(evt, originalEvent) {
            const onMove = this.move;
            if (!onMove || !this.realList) {
                return true;
            }
            const relatedContext = this.getRelatedContextFromMoveEvent(evt);
            const draggedContext = this.context || {};
            const futureIndex = this.computeFutureIndex(relatedContext, evt);
            Object.assign(draggedContext, { futureIndex });
            const sendEvt = Object.assign({}, evt, {
                relatedContext,
                draggedContext,
            });
            return onMove(sendEvt, originalEvent);
        },
        onDragEnd() {
            this.computeIndexes();
            draggingElement = null;
        },
        getTrargetedComponent(htmElement) {
            return htmElement.__draggable_component__;
        },
        getRelatedContextFromMoveEvent({ to, related }) {
            const component = this.getTrargetedComponent(to);
            if (!component) {
                return { component };
            }
            const list = component.realList;
            const context = { list, component };
            if (to !== related && list && component.getUnderlyingVm) {
                const destination = component.getUnderlyingVm(related);
                if (destination) {
                    return Object.assign(destination, context);
                }
            }
            return context;
        },
        computeFutureIndex(relatedContext, evt) {
            const domChildren = [...evt.to.children].filter((el) => el.style['display'] !== 'none');
            if (domChildren.length === 0)
                return 0;
            const currentDOMIndex = domChildren.indexOf(evt.related);
            const currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
            const draggedInList = domChildren.indexOf(draggingElement) !== -1;
            return draggedInList || !evt.willInsertAfter
                ? currentIndex
                : currentIndex + 1;
        },
    },
});

function render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", mergeProps({
    class: ["sc-draggable", { disabled: _ctx.$attrs.disabled }]
  }, { ..._ctx.$attrs }), [
    renderSlot(_ctx.$slots, "default")
  ], 16 /* FULL_PROPS */))
}

script$14.render = render$Z;
script$14.__file = "packages/draggable/Draggable.vue";

script$14.install = (Vue) => {
    Vue.component(script$14.name, script$14);
};

var script$13 = defineComponent({
    name: 'AdvancedSearch',
    components: {
        BasicFormItem: script$1v,
        Draggable: script$14,
    },
    props: {
        keywords: {
            type: Object,
            required: true,
        },
        tags: {
            type: Object,
            required: true,
        },
        sort: {
            type: Array,
            required: true,
        },
        searchItems: {
            type: Array,
            required: true,
        },
        updateKeywords: {
            type: Function,
            required: true,
        },
        collectKeywords: {
            type: Function,
            required: true,
        },
        doToggleDrawer: {
            type: Function,
            required: true,
        },
        noSaveBtn: {
            type: Boolean,
            default: false,
        },
        isEditModle: {
            type: Boolean,
            default: false,
        },
        newKeyClass: {
            type: String,
            default: '',
        },
        updateNewKeyClass: {
            type: Function,
            default: () => null,
        },
    },
    setup(props, { emit }) {
        // 表单项-搜索关键词
        const formData = reactive({
            keywords: computed(() => props.keywords),
            tags: computed(() => props.tags),
        });
        const getIsTop = (key, istop) => {
            const sort = props.sort.find((it) => it.key === key);
            return sort ? sort.istop : istop;
        };
        // 表单验证
        const formRef = ref();
        // 更新搜索关键词-并提交搜索-关闭抽屉
        const handleSearchSubmit = () => {
            formRef.value
                .validate()
                .then(() => {
                props.updateKeywords(formData);
                props.doToggleDrawer();
            })
                .catch((error) => {
                const msgs = error.errorFields.map((err) => err.errors.toString());
                message.warn([...new Set(msgs)].toString());
            });
        };
        // 取消搜索
        const handleCancel = () => {
            props.doToggleDrawer();
        };
        // 显示或隐藏搜索项
        const handleClick = (key, istop) => {
            const sort = props.sort || [];
            const index = sort.findIndex((it) => it.key === key);
            if (index >= 0) {
                sort.splice(index, 1, { ...props.sort[index], istop });
            }
            else {
                sort.push({ key, istop });
            }
            emit('update:sort', sort);
        };
        const doShowItem = (key) => {
            handleClick(key, true);
        };
        return {
            formRef,
            formData,
            handleSearchSubmit,
            handleCancel,
            handleClick,
            getIsTop,
            doShowItem,
        };
    },
});

const _hoisted_1$T = { class: "sc-drawer-footer" };
const _hoisted_2$E = { class: "drawer-btn-group" };

function render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_row = resolveComponent("a-row");
  const _component_Draggable = resolveComponent("Draggable");
  const _component_a_form = resolveComponent("a-form");

  return (openBlock(), createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formData.keywords,
    "label-col": { style: { width: '100px' } },
    class: "sc-advanced-search"
  }, {
    default: withCtx(() => [
      createVNode(_component_Draggable, {
        list: _ctx.searchItems,
        disabled: !_ctx.isEditModle
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.searchItems, (item) => {
            return (openBlock(), createBlock(_component_a_row, {
              key: item.key
            }, {
              default: withCtx(() => [
                createVNode(_component_a_col, {
                  span: _ctx.isEditModle ? 22 : 24
                }, {
                  default: withCtx(() => [
                    createVNode(_component_BasicFormItem, {
                      item: item,
                      value: _ctx.formData.keywords[item.key],
                      "onUpdate:value": $event => ((_ctx.formData.keywords[item.key]) = $event),
                      tag: _ctx.formData.tags[item.key],
                      "onUpdate:tag": $event => ((_ctx.formData.tags[item.key]) = $event),
                      doShowItem: _ctx.doShowItem,
                      newKeyClass: _ctx.newKeyClass,
                      updateNewKeyClass: _ctx.updateNewKeyClass,
                      onSubmit: _ctx.handleSearchSubmit
                    }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value", "tag", "onUpdate:tag", "doShowItem", "newKeyClass", "updateNewKeyClass", "onSubmit"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["span"]),
                withDirectives(createVNode(_component_a_col, {
                  span: _ctx.isEditModle ? 2 : 0,
                  class: "action"
                }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(_component_a_button, {
                      type: "link",
                      onClick: $event => {
              item.istop = true;
              _ctx.handleClick(item.key, true);
            }
                    }, {
                      default: withCtx(() => [
                        createTextVNode("显示")
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                      [vShow, !_ctx.getIsTop(item.key, item.istop)]
                    ]),
                    withDirectives(createVNode(_component_a_button, {
                      class: "muted",
                      type: "link",
                      onClick: $event => {
              item.istop = false;
              _ctx.handleClick(item.key, false);
            }
                    }, {
                      default: withCtx(() => [
                        createTextVNode("隐藏")
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                      [vShow, _ctx.getIsTop(item.key, item.istop)]
                    ])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["span"]), [
                  [vShow, _ctx.isEditModle]
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["list", "disabled"]),
      createElementVNode("div", _hoisted_1$T, [
        createElementVNode("div", _hoisted_2$E, [
          createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleSearchSubmit
          }, {
            default: withCtx(() => [
              createTextVNode("搜索")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          createVNode(_component_a_button, { onClick: _ctx.handleCancel }, {
            default: withCtx(() => [
              createTextVNode("取消")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model"]))
}

script$13.render = render$Y;
script$13.__file = "packages/search-bar/src/AdvancedSearch.vue";

var script$12 = defineComponent({
    name: 'GroupSearch',
    components: { BasicFormItem: script$1v, DownOutlined },
    props: [
        'keywords',
        'tags',
        'searchItems',
        'updateKeywords',
        'collects',
        'groupType',
    ],
    setup(props) {
        // 普通搜索关键词
        const formData = reactive({
            keywords: computed(() => props.keywords),
            tags: computed(() => props.tags),
        });
        // 提交搜索-并更新本地搜索关键词
        const handleSearchSubmit = () => {
            props.updateKeywords(formData);
        };
        // 选择框当前值
        const collectsIndex = ref(0);
        // 合并搜索表单
        const searchGroupItems = computed(() => {
            const it = [];
            if (!props.groupType)
                return it;
            props.searchItems.map((e) => {
                if (e.groupType === props.groupType) {
                    if (e.type === 'CheckboxGroup') {
                        it.push({ ...e, type: 'SelectMultiple' });
                    }
                    else if (e.type === 'RadioGroup' || e.type === 'RadioButtonGroup') {
                        it.push({ ...e, type: 'Select' });
                    }
                    else {
                        it.push(e);
                    }
                }
            });
            return it;
        });
        const selectValue = ref(searchGroupItems.value[0] ? searchGroupItems.value[0].label || '' : '');
        const itemRef = ref({ ...searchGroupItems.value[0], label: '' });
        const handleChangeGroup = ({ key, item }) => {
            selectValue.value = item.value;
            // emit('onSelectChange', key);
            if (searchGroupItems.value) {
                const item = searchGroupItems.value.find((it) => it.key === key);
                if (item)
                    itemRef.value = { ...item, label: '' };
            }
        };
        return {
            formData,
            BasicFormItem: script$1v,
            searchGroupItems,
            handleChangeGroup,
            handleSearchSubmit,
            collectsIndex,
            selectValue,
            itemRef,
        };
    },
});

function render$X(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DownOutlined = resolveComponent("DownOutlined");
  const _component_a_menu_item = resolveComponent("a-menu-item");
  const _component_a_menu = resolveComponent("a-menu");
  const _component_a_dropdown = resolveComponent("a-dropdown");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_input_group = resolveComponent("a-input-group");
  const _component_a_form_item = resolveComponent("a-form-item");

  return (_ctx.searchGroupItems.length >= 1)
    ? (openBlock(), createBlock(_component_a_form_item, {
        key: 0,
        class: "sc-search-group"
      }, {
        default: withCtx(() => [
          createVNode(_component_a_input_group, { compact: "" }, {
            default: withCtx(() => [
              createVNode(_component_a_dropdown, { overlayClassName: "sc-search-group-dropdown" }, createSlots({
                default: withCtx(() => [
                  createElementVNode("a", {
                    class: "ant-dropdown-link",
                    onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
                  }, [
                    (_ctx.searchGroupItems.length > 1)
                      ? (openBlock(), createBlock(_component_DownOutlined, {
                          key: 0,
                          class: "pre-icon"
                        }))
                      : createCommentVNode("v-if", true),
                    createTextVNode(" " + toDisplayString(_ctx.selectValue), 1 /* TEXT */)
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, [
                (_ctx.searchGroupItems.length > 1)
                  ? {
                      name: "overlay",
                      fn: withCtx(() => [
                        createVNode(_component_a_menu, { onClick: _ctx.handleChangeGroup }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.searchGroupItems, (item) => {
                              return (openBlock(), createBlock(_component_a_menu_item, {
                                value: item.label,
                                key: item.key
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(item.label), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024 /* DYNAMIC_SLOTS */),
              (_ctx.itemRef)
                ? (openBlock(), createBlock(_component_BasicFormItem, {
                    key: _ctx.itemRef.key,
                    item: _ctx.itemRef,
                    value: _ctx.formData.keywords[_ctx.itemRef.key],
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.formData.keywords[_ctx.itemRef.key]) = $event)),
                    tag: _ctx.formData.tags[_ctx.itemRef.key],
                    "onUpdate:tag": _cache[2] || (_cache[2] = $event => ((_ctx.formData.tags[_ctx.itemRef.key]) = $event)),
                    onSubmit: _ctx.handleSearchSubmit
                  }, null, 8 /* PROPS */, ["item", "value", "tag", "onSubmit"]))
                : createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
    : createCommentVNode("v-if", true)
}

script$12.render = render$X;
script$12.__file = "packages/search-bar/src/SearchGroup.vue";

var script$11 = defineComponent({
    name: 'SearchBar',
    components: { BasicFormItem: script$1v, SearchGroup: script$12 },
    props: [
        'keywords',
        'tags',
        'sort',
        'searchItems',
        'updateKeywords',
        'collectKeywords',
        'doToggleDrawer',
        'collects',
        'noSaveInput',
        'isShowAllSearch',
        'isHideAdvancedSearch',
        'newKeyClass',
        'updateNewKeyClass',
        'isInline',
        'labelLength',
        'btnConfig',
        'collectsIndex',
    ],
    setup(props, { emit }) {
        // 普通搜索关键词
        const formData = reactive({
            keywords: computed(() => props.keywords),
            tags: computed(() => props.tags),
        });
        const btnConfigRef = computed(() => ({
            btn1: {
                type: 'primary',
                text: '搜索',
            },
            btn2: {
                type: 'default',
                text: '清空',
            },
            ...props.btnConfig,
        }));
        const formClassRef = computed(() => props.isInline
            ? 'sc-is-inline-form'
            : ' sc-label-width' + props.labelLength);
        // 排序和本地设置
        const searchSort = reactive(props.sort || []);
        const getIsTop = (key) => {
            const sort = searchSort.find((it) => it.key === key);
            return sort ? sort.istop : undefined;
        };
        // 表单验证
        const formRef = ref();
        // 提交搜索-并更新本地搜索关键词
        const handleSearchSubmit = () => {
            formRef.value
                .validate()
                .then(() => {
                // 清除常用检索条件
                collectsIndexRef.value = undefined;
                props.updateKeywords(formData);
            })
                .catch((error) => {
                const msgs = error.errorFields.map((err) => err.errors.toString());
                message.warn([...new Set(msgs)].join('、'));
            });
        };
        // 选择框当前值
        const collectsIndexRef = computed({
            get: () => props.collectsIndex,
            set: (val) => {
                emit('update:collectsIndex', val);
            },
        });
        // 清空所有搜索条件
        const handleClearAllSelect = () => {
            const keywords = { ...props.keywords };
            const tags = { ...props.tags };
            props.searchItems.map((item) => {
                item.unclosableTag ||
                    (delete keywords[item.key], delete tags[item.key]);
            });
            // 清除常用检索条件
            collectsIndexRef.value = undefined;
            props.updateKeywords({ keywords, tags }, false);
            props.updateNewKeyClass(false);
        };
        // 切换常用搜索
        const handleChangeSelect = (val) => {
            const { keywords, tags } = val !== undefined ? props.collects[val] : { keywords: {}, tags: {} };
            props.updateKeywords({ keywords, tags }, true, true);
        };
        // 展开高级搜索
        const isShowAllSearchRef = ref(props.isShowAllSearch || false);
        const handleToggleShow = (val) => {
            isShowAllSearchRef.value = val;
            emit('update:isShowAllSearch', val);
        };
        const getContainer = (triggerNode) => triggerNode.parentNode;
        // 搜索组列表
        const searchGroups = computed(() => {
            const groups = [];
            props.searchItems.map((e) => {
                if (e.groupType && groups.indexOf(e.groupType) === -1)
                    groups.push(e.groupType);
            });
            return groups;
        });
        // 普通搜索表单
        const searchBarItems = computed(() => {
            const it = [];
            props.searchItems.map((e) => {
                const top = getIsTop(e.key);
                const isTop = top !== undefined ? top : e.istop;
                if (isTop) {
                    if (e.type === 'CheckboxGroup') {
                        it.push({ ...e, type: 'SelectMultiple' });
                    }
                    else if (e.type === 'RadioGroup' || e.type === 'RadioButtonGroup') {
                        it.push({ ...e, type: 'Select' });
                    }
                    else {
                        it.push(e);
                    }
                }
            });
            return it;
        });
        // 监听高级搜索项的变化
        watch(() => searchBarItems.value.length, (val) => {
            if (val === 0) {
                isShowAllSearchRef.value = false;
                emit('update:isShowAllSearch', false);
            }
        });
        return {
            formData,
            searchBarItems,
            searchGroups,
            formClassRef,
            isShowAllSearchRef,
            handleSearchSubmit,
            handleChangeSelect,
            handleClearAllSelect,
            handleToggleShow,
            collectsIndexRef,
            btnConfigRef,
            formRef,
            getContainer,
        };
    },
});

const _hoisted_1$S = { class: "ant-row ant-form-item sc-search-submit" };

function render$W(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchGroup = resolveComponent("SearchGroup");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_a_form = resolveComponent("a-form");

  return (openBlock(), createBlock(_component_a_form, {
    layout: "inline",
    class: normalizeClass(_ctx.formClassRef),
    ref: "formRef",
    model: _ctx.formData.keywords
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.searchGroups, (group, index) => {
        return (openBlock(), createBlock(_component_SearchGroup, {
          key: index,
          keywords: _ctx.keywords,
          tags: _ctx.tags,
          collects: _ctx.collects,
          groupType: group,
          searchItems: _ctx.searchItems,
          updateKeywords: _ctx.updateKeywords,
          class: normalizeClass(_ctx.isInline ? 'sc-group-is-inline' : '')
        }, null, 8 /* PROPS */, ["keywords", "tags", "collects", "groupType", "searchItems", "updateKeywords", "class"]))
      }), 128 /* KEYED_FRAGMENT */)),
      withDirectives(createElementVNode("div", {
        class: normalizeClass(["ant-form-inline", _ctx.isInline ? 'sc-form-is-inline' : 'sc-form-inline'])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.searchBarItems, (item) => {
          return (openBlock(), createBlock(_component_BasicFormItem, {
            key: item.key,
            item: item,
            newKeyClass: _ctx.newKeyClass,
            updateNewKeyClass: _ctx.updateNewKeyClass,
            value: _ctx.formData.keywords[item.key],
            "onUpdate:value": $event => ((_ctx.formData.keywords[item.key]) = $event),
            tag: _ctx.formData.tags[item.key],
            "onUpdate:tag": $event => ((_ctx.formData.tags[item.key]) = $event),
            onSubmit: _ctx.handleSearchSubmit
          }, null, 8 /* PROPS */, ["item", "newKeyClass", "updateNewKeyClass", "value", "onUpdate:value", "tag", "onUpdate:tag", "onSubmit"]))
        }), 128 /* KEYED_FRAGMENT */)),
        renderSlot(_ctx.$slots, "extr")
      ], 2 /* CLASS */), [
        [vShow, _ctx.isShowAllSearchRef || _ctx.isInline]
      ]),
      createElementVNode("div", _hoisted_1$S, [
        createVNode(_component_a_form_item, {
          colon: false,
          label: !_ctx.isInline && _ctx.isShowAllSearchRef ? ' ' : ''
        }, {
          default: withCtx(() => [
            createVNode(_component_a_button, {
              type: _ctx.btnConfigRef.btn1.type,
              onClick: _ctx.handleSearchSubmit
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.btnConfigRef.btn1.text), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["type", "onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        (!_ctx.isInline)
          ? (openBlock(), createBlock(_component_a_form_item, { key: 0 }, {
              default: withCtx(() => [
                createVNode(_component_a_button, {
                  type: _ctx.btnConfigRef.btn2.type,
                  onClick: _ctx.handleClearAllSelect
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.btnConfigRef.btn2.text), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["type", "onClick"])
              ]),
              _: 1 /* STABLE */
            }))
          : createCommentVNode("v-if", true),
        (!_ctx.noSaveInput)
          ? (openBlock(), createBlock(_component_a_form_item, { key: 1 }, {
              default: withCtx(() => [
                createVNode(_component_a_select, {
                  class: "sc-select sc-save-select",
                  placeholder: "常用搜索条件",
                  value: _ctx.collectsIndexRef,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.collectsIndexRef) = $event)),
                  onChange: _ctx.handleChangeSelect,
                  allowClear: true,
                  getPopupContainer: _ctx.getContainer
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.collects, (item, index) => {
                      return (openBlock(), createBlock(_component_a_select_option, {
                        value: index,
                        key: index,
                        title: item.tabName
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.tabName), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "title"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value", "onChange", "getPopupContainer"])
              ]),
              _: 1 /* STABLE */
            }))
          : createCommentVNode("v-if", true),
        renderSlot(_ctx.$slots, "submitExtr")
      ]),
      (!_ctx.isHideAdvancedSearch)
        ? (openBlock(), createBlock(_component_a_form_item, {
            key: 0,
            class: "fr sc-right"
          }, {
            default: withCtx(() => [
              withDirectives(createVNode(_component_a_button, {
                type: "link",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.handleToggleShow(!_ctx.isShowAllSearchRef)))
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.isShowAllSearchRef ? '普通搜索' : '高级搜索'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 512 /* NEED_PATCH */), [
                [vShow, _ctx.searchBarItems.length > 0]
              ]),
              createElementVNode("span", {
                class: "advanced-btn-icon iconfont",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.doToggleDrawer && _ctx.doToggleDrawer(...args)))
              }, "ਙ")
            ]),
            _: 1 /* STABLE */
          }))
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "model"]))
}

script$11.render = render$W;
script$11.__file = "packages/search-bar/src/SearchBar.vue";

var script$10 = defineComponent({
    name: 'SearchSave',
    components: { BasicFormItem: script$1v, Modal },
    props: [
        'title',
        'visible',
        'keywords',
        'modalFormItems',
        'okText',
        'cancelText',
    ],
    setup(props, { emit }) {
        // 普通搜索关键词
        const formData = reactive({});
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        const formRef = ref();
        // 确认-保存关键词
        const handleOk = () => {
            formRef.value.validate().then(() => {
                visibleRef.value = false;
                emit('ok', JSON.parse(JSON.stringify(formData)));
                formRef.value.resetFields();
            });
        };
        const handleCancel = () => {
            formRef.value.resetFields();
            visibleRef.value = false;
        };
        return {
            visibleRef,
            formData,
            formRef,
            handleOk,
            handleCancel,
        };
    },
});

function render$V(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_a_button = resolveComponent("a-button");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, {
    title: _ctx.title,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
    centered: true,
    destroyOnClose: true,
    class: "sc-modal"
  }, {
    footer: withCtx(() => [
      createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.handleCancel
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.cancelText), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        disabled: !_ctx.formData.title || _ctx.formData.title.length < 2,
        onClick: _ctx.handleOk
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.okText), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    default: withCtx(() => [
      createVNode(_component_a_form, {
        model: _ctx.formData,
        "label-col": { span: 5 },
        "wrapper-col": { span: 19 },
        ref: "formRef"
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modalFormItems, (item) => {
            return (openBlock(), createBlock(_component_BasicFormItem, {
              key: item.key,
              item: item,
              value: _ctx.formData[item.key],
              "onUpdate:value": $event => ((_ctx.formData[item.key]) = $event)
            }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "visible"]))
}

script$10.render = render$V;
script$10.__file = "packages/search-bar/src/SearchSave.vue";

var script$$ = defineComponent({
    name: 'SearchBar',
    components: {},
    props: {
        keywords: {
            type: Object,
            required: true,
        },
        tags: {
            type: Object,
            required: true,
        },
        searchItems: {
            type: Array,
            required: true,
        },
        collectKeywords: {
            type: Function,
            default: () => null,
        },
        updateKeywords: {
            type: Function,
            default: () => null,
        },
        noSaveBtn: {
            type: Boolean,
            default: false,
        },
        noClearBtn: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            default: 0,
        },
        deleteTag: {
            type: Function,
            default: () => null,
        },
        closable: {
            type: Boolean,
            required: false,
        },
        collectsIndex: {
            type: Number,
        },
    },
    setup(props, { emit }) {
        // 页面文字
        const pageText = {
            pageTitle: '检索项：',
            openTag: ' 展开 ',
            retractTag: ' 收起 ',
            btnSave: '保存',
            btnClear: '清除',
            nothing: '无',
        };
        // 是否展开
        const isOpen = ref([]);
        // 搜索关键词 - 计算属性 过滤无效空值
        const tagItems = computed(() => {
            const rlt = [];
            props.searchItems.map((e) => {
                const valueKey = props.keywords[e.key] !== undefined;
                const valueText = Array.isArray(props.tags[e.key])
                    ? props.tags[e.key].join('，')
                    : props.tags[e.key];
                if (valueKey && valueText) {
                    rlt.push({
                        key: e.key,
                        value: e.label ? e.label + '：' + valueText : valueText,
                        closable: !e.unclosableTag && props.closable,
                    });
                }
            });
            // 如果有支付方式，需要放在最后一个显示
            if (props.tags.paymentType) {
                let index = rlt.findIndex((r) => r.key === 'paymentType');
                if (index !== -1) {
                    let [paymentTypeTag] = rlt.splice(index, 1);
                    rlt.push(paymentTypeTag);
                }
            }
            return rlt;
        });
        // 显示保存和清除按钮
        const showSaveBtn = computed(() => {
            return Object.values(props.tags).filter((e) => e).length > 0
                ? true
                : false;
        });
        // 删除标签 tagItems
        const handleDeleteTag = (key) => {
            const keywords = { ...props.keywords };
            const tags = { ...props.tags };
            delete keywords[key];
            delete tags[key];
            props.updateKeywords({ keywords, tags });
            props.deleteTag({ keywords, tags }, props.index);
        };
        // 清除标签
        const handleClearAllTags = () => {
            const keywords = { ...props.keywords };
            const tags = { ...props.tags };
            props.searchItems.map((e) => {
                if (!e.unclosableTag) {
                    delete keywords[e.key];
                    delete tags[e.key];
                }
            });
            props.updateKeywords({ keywords, tags });
            props.deleteTag({ keywords, tags }, props.index);
            // 清空常用检索条件选项
            emit('update:collectsIndex', undefined);
        };
        function bytesLength(str) {
            let count = str.length;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                if (char >= 65 && char <= 90) {
                    count += 0.15;
                }
                else if (char > 255) {
                    count++;
                }
            }
            return count;
        }
        const getTagsClassName = (isOpen, val) => {
            const cname = isOpen ? 'show-all' : '';
            return cname + (val.length > 500 ? ' overLength' : '');
        };
        return {
            ...pageText,
            isOpen,
            tagItems,
            handleDeleteTag,
            handleClearAllTags,
            showSaveBtn,
            bytesLength,
            getTagsClassName,
        };
    },
});

const _hoisted_1$R = { class: "J-sc-affix" };
const _hoisted_2$D = { class: "sc-search-tags" };
const _hoisted_3$v = ["onClick"];
const _hoisted_4$o = ["onClick"];

function render$U(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tag = resolveComponent("a-tag");
  const _component_a_button = resolveComponent("a-button");

  return (openBlock(), createElementBlock("div", _hoisted_1$R, [
    createElementVNode("div", _hoisted_2$D, [
      createTextVNode(toDisplayString(_ctx.pageTitle) + " ", 1 /* TEXT */),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tagItems, (item, index) => {
        return (openBlock(), createBlock(_component_a_tag, {
          key: item.key,
          closable: item.closable,
          class: normalizeClass(_ctx.bytesLength(item.value) > 34 ? 'sc-tag-cursor' : ''),
          onClose: $event => (_ctx.handleDeleteTag(item.key))
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              class: normalizeClass(_ctx.getTagsClassName(_ctx.isOpen[index], item.value)),
              onClick: $event => (_ctx.isOpen[index] = !_ctx.isOpen[index])
            }, toDisplayString(item.value), 11 /* TEXT, CLASS, PROPS */, _hoisted_3$v),
            (_ctx.bytesLength(item.value) > 34)
              ? (openBlock(), createElementBlock("a", {
                  key: 0,
                  onClick: $event => (_ctx.isOpen[index] = !_ctx.isOpen[index])
                }, toDisplayString(_ctx.isOpen[index] ? _ctx.retractTag : _ctx.openTag), 9 /* TEXT, PROPS */, _hoisted_4$o))
              : createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["closable", "class", "onClose"]))
      }), 128 /* KEYED_FRAGMENT */)),
      withDirectives(createElementVNode("span", null, [
        (!_ctx.noSaveBtn)
          ? (openBlock(), createBlock(_component_a_button, {
              key: 0,
              type: "link",
              size: "small",
              class: "muted",
              onClick: _ctx.collectKeywords
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.btnSave), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : createCommentVNode("v-if", true),
        (!_ctx.noClearBtn)
          ? (openBlock(), createBlock(_component_a_button, {
              key: 1,
              type: "link",
              size: "small",
              class: "muted",
              onClick: _ctx.handleClearAllTags
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.btnClear), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */), [
        [vShow, _ctx.showSaveBtn]
      ]),
      withDirectives(createVNode(_component_a_tag, null, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.nothing), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 512 /* NEED_PATCH */), [
        [vShow, !_ctx.showSaveBtn]
      ])
    ])
  ]))
}

script$$.render = render$U;
script$$.__file = "packages/search-bar/src/SearchTags.vue";

script$11.install = (Vue) => {
    Vue.component(script$12.name, script$12);
    Vue.component(script$11.name, script$11);
    Vue.component(script$$.name, script$$);
    Vue.component(script$10.name, script$10);
    Vue.component(script$13.name, script$13);
};

var script$_ = defineComponent({
    name: 'ScNoData',
    props: {
        tipTitle: {
            type: String,
            default: '暂无数据',
        },
        width: {
            type: String,
            default: '100%',
        },
        height: {
            type: String,
            default: '100%',
        },
    },
    setup() {
        return {};
    },
});

const _hoisted_1$Q = { class: "no-data-tip-word" };

function render$T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: "sc-no-data-wrapper",
    style: normalizeStyle({ width: _ctx.width, height: _ctx.height })
  }, [
    createElementVNode("div", _hoisted_1$Q, toDisplayString(_ctx.tipTitle), 1 /* TEXT */)
  ], 4 /* STYLE */))
}

script$_.render = render$T;
script$_.__file = "packages/no-data/src/NoData.vue";

script$_.install = (Vue) => {
    Vue.component(script$_.name, script$_);
};

var script$Z = defineComponent({
    name: 'SearchCriteria',
    components: {
        Collapse: script$15,
        SearchTags: script$$,
        Draggable: script$14,
        NoData: script$_,
    },
    emits: ['update:collects'],
    props: {
        collects: {
            type: Array,
            default: () => [],
        },
        tabs: {
            type: Array,
            default: () => [],
        },
        deleteCollect: {
            type: Function,
            required: true,
        },
        updateKeywords: {
            type: Function,
            required: true,
        },
        updateKeywordsByIndex: {
            type: Function,
            required: true,
        },
        isEditModle: {
            type: Boolean,
            default: false,
        },
        isShowTab: {
            type: Boolean,
            default: false,
        },
        searchItems: {
            type: Array,
            required: true,
        },
    },
    setup(props, { emit }) {
        const collapseActiveKeys = ref([]);
        watch(() => props.collects, () => {
            collapseActiveKeys.value = [
                ...Object.keys(props.collects).map(() => ['0']),
            ];
        }, { immediate: true, deep: true });
        const closable = computed(() => (props.isEditModle ? true : false));
        // 拖动
        const endHandler = (e) => {
            //
        };
        // 删除单个搜索项
        const deleteSearch = (index) => {
            props.deleteCollect(index);
        };
        // 搜索
        const handleSearch = (keywords, tags, key) => {
            if (keywords && tags)
                props.updateKeywords({ keywords, tags }, true, true, key);
        };
        // 获取焦点
        let oldVal = '';
        const handleFocus = (e) => {
            oldVal = e.target.value;
        };
        // 失去焦点
        const handleSubmit = (e, index) => {
            const val = e.target.value;
            if (val.length < 2 || val.length > 7) {
                message.warn(e.target.placeholder);
                const collect = props.collects[index];
                collect[e.target.name] = oldVal;
                e.target.focus();
            }
            else if (e.type === 'keypress') {
                e.target.blur();
            }
        };
        return {
            closable,
            deleteSearch,
            handleSearch,
            collapseActiveKeys,
            handleFocus,
            handleSubmit,
            endHandler,
        };
    },
});

const _hoisted_1$P = {
  key: 0,
  class: "search-criteria"
};
const _hoisted_2$C = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_3$u = { key: 1 };
const _hoisted_4$n = { style: {"min-width":"200px"} };
const _hoisted_5$h = { style: {"margin":"0px"} };

function render$S(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_col = resolveComponent("a-col");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_row = resolveComponent("a-row");
  const _component_SearchTags = resolveComponent("SearchTags");
  const _component_Collapse = resolveComponent("Collapse");
  const _component_Draggable = resolveComponent("Draggable");
  const _component_NoData = resolveComponent("NoData");

  return (_ctx.collects && _ctx.collects.length)
    ? (openBlock(), createElementBlock("div", _hoisted_1$P, [
        createCommentVNode(" <a-row class=\"sc-tags-row\">\r\n      <a-col :span=\"2\">序号</a-col>\r\n      <a-col :span=\"7\" :offset=\"1\">常用检索项名称</a-col>\r\n      <a-col :span=\"6\" :offset=\"1\" v-show=\"isShowTab\">标签页名称</a-col>\r\n      <a-col :span=\"7\" :offset=\"isShowTab ? 0 : 7\"> 操作 </a-col>\r\n    </a-row> "),
        createVNode(_component_Draggable, {
          list: _ctx.collects,
          onUpdate: _ctx.endHandler,
          disabled: !_ctx.isEditModle
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.collects, (item, i) => {
              return (openBlock(), createBlock(_component_a_row, {
                key: i,
                class: "row-item-collapse"
              }, {
                default: withCtx(() => [
                  (_ctx.isEditModle && _ctx.collapseActiveKeys[i].length)
                    ? (openBlock(), createBlock(_component_a_col, {
                        key: 0,
                        span: 1,
                        class: "iconfont-item"
                      }, {
                        default: withCtx(() => [
                          _hoisted_2$C
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : createCommentVNode("v-if", true),
                  createVNode(_component_a_col, { span: 24 }, {
                    default: withCtx(() => [
                      createVNode(_component_Collapse, {
                        bordered: false,
                        collapses: [item],
                        class: normalizeClass(`collapse-item${i}`),
                        activeKey: _ctx.collapseActiveKeys[i],
                        "onUpdate:activeKey": $event => ((_ctx.collapseActiveKeys[i]) = $event),
                        expandIconPosition: "right"
                      }, {
                        header: withCtx(({record}) => [
                          createVNode(_component_a_row, { class: "sc-collapse-header" }, {
                            default: withCtx(() => [
                              createVNode(_component_a_col, { span: 1 }),
                              createCommentVNode(" <a-col :span=\"2\">{{ i + 1 }}</a-col> "),
                              createCommentVNode(" <a-col :span=\"14\" :offset=\"1\">\r\n            <a-input\r\n              name=\"title\"\r\n              v-model:value=\"record.title\"\r\n              v-if=\"isEditModle && !record.isInitial\"\r\n              @focus=\"handleFocus\"\r\n              @blur=\"handleSubmit($event, index)\"\r\n              @keypress.enter.stop=\"handleSubmit($event, index)\"\r\n              :maxlength=\"20\"\r\n              placeholder=\"请输入检索项名称，在2-20个字符之间\"\r\n            />\r\n            <span v-else>{{ record.title }}</span>\r\n          </a-col> "),
                              createCommentVNode(" :offset=\"1\" "),
                              (_ctx.isShowTab)
                                ? (openBlock(), createBlock(_component_a_col, {
                                    key: 0,
                                    span: 14
                                  }, {
                                    default: withCtx(() => [
                                      (_ctx.isEditModle && !record.isInitial)
                                        ? (openBlock(), createBlock(_component_a_input, {
                                            key: 0,
                                            onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"])),
                                            name: "tabName",
                                            value: record.tabName,
                                            "onUpdate:value": $event => ((record.tabName) = $event),
                                            onFocus: _ctx.handleFocus,
                                            onBlur: $event => (_ctx.handleSubmit($event, i)),
                                            onKeypress: withKeys(withModifiers($event => (_ctx.handleSubmit($event, i)), ["stop"]), ["enter"]),
                                            maxlength: 7,
                                            placeholder: "请输入标签页名称，在2-7个字符之间"
                                          }, null, 8 /* PROPS */, ["value", "onUpdate:value", "onFocus", "onBlur", "onKeypress"]))
                                        : (openBlock(), createElementBlock("span", _hoisted_3$u, toDisplayString(record.tabName ? record.tabName : record.title), 1 /* TEXT */))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : createCommentVNode("v-if", true),
                              createVNode(_component_a_col, {
                                span: 8,
                                offset: _ctx.isShowTab ? 0 : 8
                              }, {
                                default: withCtx(() => [
                                  createElementVNode("div", _hoisted_4$n, [
                                    createElementVNode("span", {
                                      onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"]))
                                    }, [
                                      createVNode(_component_a_checkbox, {
                                        checked: record.isTab,
                                        "onUpdate:checked": $event => ((record.isTab) = $event)
                                      }, {
                                        default: withCtx(() => [
                                          createTextVNode("显示为页签")
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["checked", "onUpdate:checked"])
                                    ]),
                                    withDirectives(createVNode(_component_a_button, {
                                      onClick: withModifiers($event => (
                          _ctx.handleSearch(record.keywords, record.tags, record.key)
                        ), ["stop"]),
                                      type: "link"
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode("搜索")
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                      [vShow, !_ctx.isEditModle || !record.isInitial]
                                    ]),
                                    createCommentVNode(" <a-button\r\n              v-show=\"isShowTab && isEditModle && !record.isInitial\"\r\n              @click.stop=\"record.isTab = !record.isTab\"\r\n              type=\"link\"\r\n              :style=\"{ color: record.isTab ? '#ccc' : '#1890ff' }\"\r\n              >{{ record.isTab ? '移除标签' : '设为标签' }}</a-button\r\n            > "),
                                    withDirectives(createVNode(_component_a_button, {
                                      onClick: withModifiers($event => (_ctx.deleteSearch(i)), ["stop"]),
                                      type: "link",
                                      style: {"color":"#ff4d4f"}
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode("删除")
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                      [vShow, _ctx.isEditModle && !record.isInitial]
                                    ])
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["offset"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        default: withCtx(({record}) => [
                          createElementVNode("p", _hoisted_5$h, [
                            createVNode(_component_SearchTags, {
                              keywords: record.keywords,
                              tags: record.tags,
                              searchItems: _ctx.searchItems,
                              closable: _ctx.closable,
                              deleteTag: _ctx.updateKeywordsByIndex,
                              noClearBtn: true,
                              noSaveBtn: true,
                              index: i
                            }, null, 8 /* PROPS */, ["keywords", "tags", "searchItems", "closable", "deleteTag", "index"])
                          ])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["collapses", "class", "activeKey", "onUpdate:activeKey"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["list", "onUpdate", "disabled"])
      ]))
    : (openBlock(), createBlock(_component_NoData, {
        key: 1,
        tipTitle: "暂无常用搜索项，请至页面检索项保存添加",
        height: '250px'
      }))
}

script$Z.render = render$S;
script$Z.__file = "packages/search-form/src/SearchCriteria.vue";

var script$Y = defineComponent({
    name: 'ScTab',
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        return {};
    },
});

function render$R(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tab_pane = resolveComponent("a-tab-pane");
  const _component_a_tabs = resolveComponent("a-tabs");

  return (openBlock(), createBlock(_component_a_tabs, mergeProps({
    type: "editable-card",
    class: "sc-tabs",
    "hide-add": ""
  }, { ..._ctx.$props, ..._ctx.$attrs }), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab) => {
        return (openBlock(), createBlock(_component_a_tab_pane, mergeProps({
          key: tab.key,
          closable: tab.closable
        }, { ..._ctx.$props, ..._ctx.$attrs }), {
          tab: withCtx(() => [
            createTextVNode(toDisplayString(tab.tabName) + " ", 1 /* TEXT */),
            createElementVNode("span", {
              class: normalizeClass('tab-number ' + tab.countColor)
            }, toDisplayString(tab.tabCount && tab.tabCount > 99 ? '99+' : tab.tabCount || ''), 3 /* TEXT, CLASS */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["closable"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */))
}

script$Y.render = render$R;
script$Y.__file = "packages/tab/Tab.vue";

script$Y.install = (Vue) => {
    Vue.component(script$Y.name, script$Y);
};

var script$X = defineComponent({
    name: 'SearchForm',
    inheritAttrs: false,
    components: {
        SearchBar: script$11,
        AdvancedSearch: script$13,
        SearchTags: script$$,
        Drawer: script$16,
        SearchSave: script$10,
        SearchCriteria: script$Z,
        Tab: script$Y,
    },
    emits: ['onSearch', 'update:keywords'],
    props: {
        advanceSearchItems: {
            type: Array,
            required: true,
        },
        tabs: {
            type: Array,
            default: () => [],
        },
        isShowTab: {
            type: [Boolean],
            default: true,
        },
        tabOnPageHeader: {
            type: [Boolean],
            default: true,
        },
        isShowAllSearch: {
            type: [Boolean],
            default: false,
        },
        isHideAdvancedSearch: {
            type: [Boolean],
            defalut: false,
        },
        isHideTags: {
            type: [Boolean],
            defalut: false,
        },
        isInline: {
            type: [Boolean],
            default: false,
        },
        noSaveBtn: {
            type: [Boolean],
            default: false,
        },
        noClearBtn: {
            type: [Boolean],
            default: false,
        },
        isSearchFromQuery: {
            type: [Boolean],
            default: false,
        },
        labelLength: {
            type: Number,
            default: 4,
        },
        keywords: {
            type: Object,
            default: () => ({}),
        },
        /**
         * 参数： key:string 当前表单项的key;  keywords:IKeywords
         *
         *  当前表单项focus 事件keywords= {当前表单项的key:undefinded} | {级联表单项的key:value}
         *  当前表单项search事件keywords= {当前表单项的key:value}
         *  通过 keywords {当前表单项的key: undefinded || value} 判断是否时search事件请求
         *
         * 返回：表单选项数组IItemOption[]
         */
        getOptions: {
            type: Function,
            default: () => [],
        },
        /**
         * 参数：key: string,当前表单项的key; value: string[] 文本域的值
         * 返回：下拉多选值数组 (number| string)[]
         */
        getTextAreaValue: {
            type: Function,
            default: () => [],
        },
        btnConfig: {
            type: Object,
            default: () => null,
        },
    },
    setup(props, { emit, attrs }) {
        // 给后端标识为存储的检索项
        const collectField = '_searchOptions';
        // 本地数据读取
        const arrtsId = attrs.id || '';
        const stateSearchSort = 'sc_search_sort' + arrtsId;
        const stateSearchConfig = 'sc_search_config' + arrtsId;
        const stateTags = 'sc_tags' + arrtsId;
        const stateKeywords = 'sc_keywords' + arrtsId;
        const stateCollects = 'sc_collects' + arrtsId;
        const saveSort = (val) => setState(stateSearchSort, val);
        const saveConfig = (val) => setState(stateSearchConfig, val);
        const setTags = (val) => setState(stateTags, val);
        const saveKeywords = (val) => setState(stateKeywords, val);
        const saveCollects = (val) => setState(stateCollects, val);
        const getTags = () => (props.noSaveBtn ? {} : getState(stateTags) || {});
        const readKeywords = () => props.noSaveBtn ? {} : getState(stateKeywords) || {};
        const readCollects = () => props.noSaveBtn ? [] : getState(stateCollects) || [];
        // 页面文字
        const pageText = {
            btnReflash: '刷新',
            modalTitle: '保存自定义检索项',
        };
        // Modal表单
        const modalFormItems = [
            {
                dataIndex: 'title',
                key: 'title',
                type: 'Input',
                label: '检索项名称',
                placeholder: '请输入检索项名称，在2-20个字符之间',
                maxlength: 20,
                rules: [
                    {
                        required: true,
                        transform: (val) => val.trim(),
                        message: '请输入检索项名称',
                    },
                    {
                        min: 2,
                        max: 20,
                        message: '长度在2-20个字符之间',
                    },
                ],
            },
        ];
        // 搜索关键词 后面加map的是给搜索项使用 解除了和searchBar的tags 和 keywords 关联
        const state = reactive({
            keywords: {},
            collects: [],
            tags: {},
            keywordsMap: {},
            tagsMap: {},
            sort: [],
            config: {
                isShowTab: false,
            },
        });
        // 读取本地搜索关键词, 不保存时不读取本地数据
        onBeforeMount(() => {
            state.keywords = readKeywords();
            state.collects = readCollects();
            state.tags = getTags();
            state.keywordsMap = { ..._.cloneDeep(readKeywords()) };
            state.tagsMap = { ..._.cloneDeep(getTags()) };
            state.sort = getState(stateSearchSort) || [];
            state.config = {
                isShowAllSearch: props.isShowAllSearch,
                ...getState(stateSearchConfig),
                isShowTab: props.isShowTab,
            };
        });
        // 移除 表单新关键词高亮
        const newKeyClass = ref('');
        const updateNewKeyClass = (isNew) => {
            return (newKeyClass.value = isNew ? 'sc-new-keywords' : '');
        };
        // 选项卡切换联动, tab的所有keywords 都在搜索keywords中时切换
        const toggleTabs = (keywords, key) => {
            if (key) {
                state.config.tabActiveKey = key;
            }
            else {
                const words = omit(keywords, '_searchOptions');
                if (collectPanels.value.length === 0)
                    return;
                let activeKey = collectPanels.value[0].key;
                collectPanels.value.map((tab) => {
                    let isEqual = false;
                    if (tab.keywords) {
                        let arr = Object.keys(tab.keywords);
                        arr = arr.filter((d) => d !== '_searchOptions');
                        for (let i = 0; i < arr.length; i++) {
                            const k = arr[i];
                            if (tab.keywords && tab.keywords[k] == words[k]) {
                                isEqual = true;
                            }
                            else {
                                isEqual = false;
                                break;
                            }
                        }
                    }
                    isEqual && (activeKey = tab.key);
                });
                state.config.tabActiveKey = activeKey;
            }
        };
        const isMultiple = (type) => ['InputGroup', 'MultipleSelect', 'RangePicker'].indexOf(type) >= 0;
        // 解构keywords,部分组件需要返回多个字段
        const ArrayToKeywords = (keywords) => {
            const getKeywordsValue = (key, type) => {
                if (!Array.isArray(keywords[key]) || keywords[key].length === 0)
                    return undefined;
                if (type === 'MultipleSelect') {
                    const valueIds = keywords[key].filter((it) => typeof it === 'number');
                    const valueNames = keywords[key].filter((it) => typeof it === 'string');
                    return [valueIds, valueNames];
                }
                else if (type === 'RangePicker') {
                    if (!keywords[key][0] || !keywords[key][1])
                        return undefined;
                    return [
                        keywords[key][0] + ' 00:00:00',
                        keywords[key][1] + ' 23:59:59',
                    ];
                }
                return keywords[key];
            };
            const newKeywords = {};
            props.advanceSearchItems.map((item) => {
                const newValues = getKeywordsValue(item.key, item.type);
                item.newKeys &&
                    isMultiple(item.type) &&
                    item.newKeys.map((newKey, index) => {
                        newValues !== undefined && (newKeywords[newKey] = newValues[index]);
                    });
            });
            return newKeywords;
        };
        const isEmpty = (val) => {
            if (typeof val === 'string') {
                return !val.trim();
            }
            if (Array.isArray(val)) {
                return !val.length;
            }
            return false;
        };
        /**
         * 更新搜索关键词
         * isSearch 是否执行搜索操作 默认true
         * isCollect 是否来自保存检索项，
         */
        const updateKeywords = ({ keywords, tags }, isSearch = true, isCollect = false, activeKey) => {
            // 更新搜索关键词，添加
            keywords = { ...keywords, [collectField]: isCollect };
            tags = { ...tags };
            // 过滤空字符串等无效值
            Object.keys(tags).map((k) => {
                if (isEmpty(tags[k])) {
                    delete tags[k];
                    delete keywords[k];
                }
            });
            state.keywords = keywords;
            state.tags = tags;
            if (isSearch) {
                nextTick(() => {
                    state.tagsMap = { ..._.cloneDeep(tags) };
                    state.keywordsMap = { ..._.cloneDeep(keywords) };
                    // 执行搜索前，清除高亮样式
                    updateNewKeyClass(false);
                    const newKeywords = ArrayToKeywords(keywords);
                    // 清除空值等无效值
                    const isEmpty = (val) => val === undefined || val === null || val.toString() === '';
                    const searchKeywords = { ...keywords, ...newKeywords };
                    Object.keys(searchKeywords).forEach((key) => {
                        if (isEmpty(searchKeywords[key]))
                            delete searchKeywords[key];
                    });
                    // Tab选项卡联动
                    toggleTabs(searchKeywords, activeKey);
                    // TODO执行提交搜索
                    emit('onSearch', { keywords: searchKeywords, tags }, setKeywords);
                });
            }
        };
        // 检索项下拉选择
        const collectsIndex = ref();
        // 初始执行搜索事件
        onMounted(() => {
            if (props.isSearchFromQuery) {
                // url带参跳入query
                const keywords = getQueryKeywords();
                if (Object.keys(keywords).length > 0) {
                    state.keywords = keywords;
                    state.tags = keywords;
                }
            }
            // 初始数据载入成功后，自动执行搜索
            updateKeywords({ keywords: state.keywords, tags: state.tags }, true);
            eventBus.on(`search:${attrs.id}`, ({ keywords, tags, key }) => {
                if (props.advanceSearchItems) {
                    let searchKey = '';
                    let multiple = false;
                    for (let i = 0; i < props.advanceSearchItems.length; i += 1) {
                        let data = props.advanceSearchItems[i];
                        if (key === data.key) {
                            searchKey = data.key;
                            multiple = isMultiple(data.type);
                            break;
                        }
                        if (key + 's' === data.key) {
                            searchKey = data.key;
                            multiple = isMultiple(data.type);
                            break;
                        }
                        if (key + 'List' === data.key) {
                            searchKey = data.key;
                            multiple = isMultiple(data.type);
                            break;
                        }
                        if (key + 'sIncludeParent' === data.key) {
                            searchKey = data.key;
                            multiple = isMultiple(data.type);
                            break;
                        }
                    }
                    if (!searchKey) {
                        return;
                    }
                    const value = multiple
                        ? [keywords[key]]
                        : keywords[key];
                    keywords = {
                        ...state.keywords,
                        ...{ [searchKey]: value },
                    };
                    tags = { ...state.tags, ...{ [searchKey]: tags[key] } };
                    updateKeywords({
                        keywords: keywords,
                        tags: tags,
                    }, true);
                }
                // 初始数据载入成功后，自动执行搜索
            });
        });
        onUnmounted(() => {
            eventBus.off(`search:${attrs.id}`);
        });
        // 父组件中通过ref调用该方法设置keywords
        const setKeywords = ({ keywords, tags }, isSearch = true, isReplace = false) => {
            if (!isReplace) {
                keywords = { ...state.keywords, ...keywords };
                tags = { ...state.tags, ...tags };
            }
            updateKeywords({ keywords, tags }, isSearch);
        };
        const getKeywords = () => {
            return { keywords: state.keywords, tags: state.tags };
        };
        const newSaveKeywords = (val) => {
            emit('update:keywords', val);
            saveKeywords(val);
        };
        if (!props.noSaveBtn) {
            // 监视变化-更新本地搜索条件数据
            watch(() => state.keywordsMap, newSaveKeywords, { deep: true });
            watch(() => state.collects, saveCollects, { deep: true });
            watch(() => state.tagsMap, setTags, { deep: true });
        }
        watch(() => state.sort, saveSort, { deep: true });
        watch(() => state.config, saveConfig, { deep: true });
        // modal 状态对话框
        const visibleModal = ref(false);
        const modalConfig = reactive({
            title: '保存自定义检索项',
            okText: '确定',
            cancelText: '取消',
            modalFormItems,
            handleModalOk: (data) => {
                const collectItem = {
                    title: data.title,
                    isTab: false,
                    tabName: data.title,
                    orderDate: data.orderDate,
                    keywords: state.keywordsMap,
                    tags: state.tagsMap,
                };
                // PUSH state.collects
                state.collects.push(collectItem);
                state.collects = state.collects.map((d, i) => {
                    return {
                        ...d,
                        key: i.toString() + '_col_',
                    };
                });
                message.success('保存检索项成功！');
            },
            doToggleModal: () => {
                visibleModal.value = true;
            },
        });
        // 收藏自定义检索项
        const collectKeywords = () => {
            // 打开对话框-本地持久化
            modalConfig.doToggleModal();
            // 提交到服务器
        };
        //删除自定义检索项
        const deleteCollect = (index) => {
            // DEL state.collects
            state.collects.splice(index, 1);
        };
        // 设置默认搜索条件
        const setDefault = (index) => {
            // DEL state.collects
            state.collects.splice(index, 1);
        };
        // 抽屉状态
        const showDrawer = ref(false);
        // 关闭抽屉
        const doToggleDrawer = () => {
            showDrawer.value = !showDrawer.value;
        };
        // 是否是编辑模式
        const isEditModle = ref(false);
        // 通过索引更新collects
        const updateKeywordsByIndex = ({ keywords, tags }, index) => {
            state.collects[index].keywords = { ...keywords };
            state.collects[index].tags = { ...tags };
        };
        // 标签栏
        const collectPanels = computed(() => {
            // 搜索条件保存值
            const tabsArr = [];
            state.collects.map((v, i) => {
                if (v.isTab)
                    tabsArr.push({
                        key: v.key || i.toString() + '_col_',
                        tabName: v.tabName || '',
                        // tabCount: 0,
                        closable: true,
                        keywords: v.keywords,
                        tags: v.tags,
                    });
            });
            const isEmpty = (val) => val === undefined ||
                val === null ||
                val.toString() === '' ||
                val.length === 0;
            const isHaveAll = !!props.tabs.filter((d) => Object.keys(d.keywords).filter((o) => isEmpty(d.keywords?.[o]))
                .length === Object.keys(d.keywords).length).length;
            const all = state.collects.filter((d) => d.isTab).length && !isHaveAll
                ? [
                    {
                        key: 'all_col_',
                        tabName: '全部',
                        closable: false,
                        keywords: {},
                        tags: {},
                    },
                ]
                : [];
            return [...props.tabs, ...all, ...tabsArr];
        });
        // 系统标签页
        const tabCollects = computed(() => {
            // 搜索条件保存值
            const tabsArr = [];
            props.tabs.map((v) => {
                tabsArr.push({
                    title: v.tabName,
                    tabName: v.tabName,
                    isTab: true,
                    keywords: v.keywords,
                    tags: v.tags || {},
                    isInitial: true,
                });
            });
            return tabsArr;
        });
        onBeforeMount(() => {
            // 初始载入tab标签页
            props.isShowTab &&
                state.config.tabActiveKey &&
                props.tabs &&
                props.tabs.map((tab) => {
                    tab.key === state.config.tabActiveKey &&
                        doDisableItems(tab.disableItems);
                });
        });
        // 禁止items显示,并且禁止删除tag
        const doDisableItems = (items) => {
            props.advanceSearchItems.forEach((item) => {
                // 命中配置的key
                if (items && Object.keys(items).indexOf(item.key) >= 0) {
                    item.unclosableTag = items[item.key]; // 设置是否禁止删除tag
                    item.props
                        ? (item.props.disabled = items[item.key]) // 有props属性时,设置显示items
                        : (item.props = { disabled: items[item.key] }); //无props属性时,设置显示items
                }
            });
        };
        // 标签页tabs切换，替换当前检索项
        const collectPanelChange = (activeKey) => {
            let { key, keywords, tags, disableItems } = collectPanels.value.find((it) => it.key === activeKey) || {};
            // 替换当前检索项
            !tags && (tags = {});
            if (keywords)
                updateKeywords({
                    keywords: { ...keywords },
                    tags: { ...tags },
                }, true, true, activeKey);
            // 取消表单中高亮效果
            // updateNewKeyClass(false);
            // 禁止items显示
            disableItems && doDisableItems(disableItems);
            // 更新下拉检索项
            let index;
            state.collects.map((d, i) => {
                if (d.key === activeKey) {
                    index = i;
                }
            });
            collectsIndex.value = index;
        };
        // 表格上的tabs切换
        const filterTabsChange = (activeKey) => {
            const panel = collectPanels.value.find((it) => it.key === activeKey);
            if (!panel)
                return;
            // 合并到当前检索项
            const keywords = { ...state.keywords, ...panel.keywords };
            const tags = { ...state.tags, ...panel.tags };
            if (keywords && tags)
                updateKeywords({ keywords, tags }, true, true);
            // 取消表单中高亮效果
            updateNewKeyClass(false);
            // 禁止items显示
            panel.disableItems && doDisableItems(panel.disableItems);
            // 更新下拉检索项
            let index;
            state.collects.map((d, i) => {
                if (d.key === activeKey) {
                    index = i;
                }
            });
            collectsIndex.value = index;
        };
        //  标签栏删除/添加
        const collectEdit = (targetKey, action) => {
            if (action !== 'add') {
                state.collects = state.collects.map((d) => {
                    if (d.key === targetKey) {
                        d.isTab = false;
                    }
                    return d;
                });
            }
        };
        //级联缓存
        const cacheKeywords = {};
        const isChanged = (key, oKeywords) => {
            let rlt = !_.isEqual(cacheKeywords[key], oKeywords);
            if (rlt)
                cacheKeywords[key] = { ..._.cloneDeep(oKeywords) };
            return rlt;
        };
        // 级联事件，获取新的options
        provide('getOptions', (key, cascader, value) => {
            if (typeof cascader === 'string')
                cascader = [cascader];
            // 级联选项的前置keywords条件
            const oKeywords = {};
            cascader.map((k) => (oKeywords[k] = state.keywords[k]));
            // cascader中包含当前组件key的处理,
            if (cascader.indexOf(key) >= 0)
                delete oKeywords[key];
            // search事件,当前组件的value值
            if (value)
                oKeywords[key] = value;
            return isChanged(key, oKeywords) && props.getOptions(key, oKeywords);
        });
        // 依据级联属性cascader（父数组）生成级联子数组childrenCascader
        const childrenCascader = {};
        const createChildrenCascader = () => {
            const cascaderItems = props.advanceSearchItems.filter((item) => item.cascader);
            cascaderItems.map((item) => {
                const cascader = Array.isArray(item.cascader)
                    ? item.cascader
                    : [item.cascader];
                cascader.map((casKey) => casKey &&
                    casKey !== item.key &&
                    (childrenCascader[casKey] || (childrenCascader[casKey] = [])) &&
                    childrenCascader[casKey].push(item.key));
            });
        };
        createChildrenCascader();
        // 级联事件，清除已选值
        provide('childrenCascader', childrenCascader);
        provide('clearSelected', (key, childrenCascaderKeys) => {
            childrenCascaderKeys.map((k) => {
                delete state.keywords[k];
                delete state.tags[k];
            });
        });
        // 获取下拉多选组件，过滤后文本域值
        provide('getTextAreaValue', (key, value) => {
            return props.getTextAreaValue(key, value);
        });
        return {
            ...pageText,
            state,
            visibleModal,
            ...modalConfig,
            updateKeywords,
            collectKeywords,
            deleteCollect,
            showDrawer,
            doToggleDrawer,
            activeKey3: ref('1'),
            setDefault,
            isEditModle,
            updateKeywordsByIndex,
            collectPanels,
            collectPanelChange,
            filterTabsChange,
            collectEdit,
            newKeyClass,
            updateNewKeyClass,
            setKeywords,
            getKeywords,
            collectsIndex,
            tabCollects,
        };
    },
});

const _hoisted_1$O = { class: "sc-search-form" };
const _hoisted_2$B = /*#__PURE__*/createElementVNode("h3", { class: "drawer-title" }, "编辑搜索项", -1 /* HOISTED */);

function render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchBar = resolveComponent("SearchBar");
  const _component_SearchTags = resolveComponent("SearchTags");
  const _component_Tab = resolveComponent("Tab");
  const _component_AdvancedSearch = resolveComponent("AdvancedSearch");
  const _component_a_tab_pane = resolveComponent("a-tab-pane");
  const _component_SearchCriteria = resolveComponent("SearchCriteria");
  const _component_a_tabs = resolveComponent("a-tabs");
  const _component_a_button = resolveComponent("a-button");
  const _component_Drawer = resolveComponent("Drawer");
  const _component_SearchSave = resolveComponent("SearchSave");

  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" 普通搜索 "),
    createElementVNode("div", _hoisted_1$O, [
      createVNode(_component_SearchBar, {
        keywords: _ctx.state.keywords,
        tags: _ctx.state.tags,
        collects: _ctx.state.collects,
        sort: _ctx.state.sort,
        isShowAllSearch: _ctx.state.config.isShowAllSearch,
        "onUpdate:isShowAllSearch": _cache[0] || (_cache[0] = $event => ((_ctx.state.config.isShowAllSearch) = $event)),
        searchItems: _ctx.advanceSearchItems,
        updateKeywords: _ctx.updateKeywords,
        collectKeywords: _ctx.collectKeywords,
        doToggleDrawer: _ctx.doToggleDrawer,
        isHideAdvancedSearch: _ctx.isHideAdvancedSearch,
        newKeyClass: _ctx.newKeyClass,
        updateNewKeyClass: _ctx.updateNewKeyClass,
        isInline: _ctx.isInline,
        noSaveInput: _ctx.noSaveBtn,
        labelLength: _ctx.labelLength,
        btnConfig: _ctx.btnConfig,
        collectsIndex: _ctx.collectsIndex,
        "onUpdate:collectsIndex": _cache[1] || (_cache[1] = $event => ((_ctx.collectsIndex) = $event))
      }, {
        extr: withCtx(() => [
          renderSlot(_ctx.$slots, "expand")
        ]),
        submitExtr: withCtx(() => [
          renderSlot(_ctx.$slots, "submitExpand")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["keywords", "tags", "collects", "sort", "isShowAllSearch", "searchItems", "updateKeywords", "collectKeywords", "doToggleDrawer", "isHideAdvancedSearch", "newKeyClass", "updateNewKeyClass", "isInline", "noSaveInput", "labelLength", "btnConfig", "collectsIndex"])
    ]),
    createCommentVNode(" 搜索关键词tags"),
    (!_ctx.isHideTags)
      ? (openBlock(), createBlock(_component_SearchTags, {
          key: 0,
          noSaveBtn: _ctx.noSaveBtn,
          keywords: _ctx.state.keywordsMap,
          tags: _ctx.state.tagsMap,
          searchItems: _ctx.advanceSearchItems,
          updateKeywords: _ctx.updateKeywords,
          collectKeywords: _ctx.collectKeywords,
          doToggleModal: _ctx.doToggleModal,
          collectsIndex: _ctx.collectsIndex,
          "onUpdate:collectsIndex": _cache[2] || (_cache[2] = $event => ((_ctx.collectsIndex) = $event)),
          closable: ""
        }, null, 8 /* PROPS */, ["noSaveBtn", "keywords", "tags", "searchItems", "updateKeywords", "collectKeywords", "doToggleModal", "collectsIndex"]))
      : createCommentVNode("v-if", true),
    createCommentVNode(" 搜索关键词tags"),
    (!_ctx.tabOnPageHeader)
      ? withDirectives((openBlock(), createBlock(_component_Tab, {
          key: 1,
          size: "small",
          tabs: _ctx.collectPanels,
          activeKey: _ctx.state.config.tabActiveKey,
          "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => ((_ctx.state.config.tabActiveKey) = $event)),
          onChange: _ctx.filterTabsChange
        }, null, 8 /* PROPS */, ["tabs", "activeKey", "onChange"])), [
          [vShow, _ctx.state.config.isShowTab]
        ])
      : createCommentVNode("v-if", true),
    createCommentVNode(" 搜索标签页 "),
    (_ctx.tabOnPageHeader)
      ? withDirectives((openBlock(), createBlock(_component_Tab, {
          key: 2,
          tabs: _ctx.collectPanels,
          activeKey: _ctx.state.config.tabActiveKey,
          "onUpdate:activeKey": _cache[4] || (_cache[4] = $event => ((_ctx.state.config.tabActiveKey) = $event)),
          onChange: _ctx.collectPanelChange,
          onEdit: _ctx.collectEdit
        }, null, 8 /* PROPS */, ["tabs", "activeKey", "onChange", "onEdit"])), [
          [vShow, _ctx.state.config.isShowTab]
        ])
      : createCommentVNode("v-if", true),
    createCommentVNode(" 高级搜索抽屉 "),
    (!_ctx.isHideAdvancedSearch)
      ? (openBlock(), createBlock(_component_Drawer, {
          key: 3,
          class: normalizeClass(["sc-search-form-drawer", _ctx.activeKey3 === '1' ? 'sc-drawer-has-footer' : '']),
          visible: _ctx.showDrawer,
          "onUpdate:visible": _cache[10] || (_cache[10] = $event => ((_ctx.showDrawer) = $event))
        }, {
          title: withCtx(() => [
            _hoisted_2$B,
            createVNode(_component_a_button, {
              style: {"margin-top":"-3px"},
              type: "link",
              onClick: _cache[9] || (_cache[9] = $event => (_ctx.state.config.isEditModle = !_ctx.state.config.isEditModle))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.state.config.isEditModle ? '取消编辑' : '编辑'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: withCtx(() => [
            createVNode(_component_a_tabs, {
              type: "card",
              animated: true,
              activeKey: _ctx.activeKey3,
              "onUpdate:activeKey": _cache[8] || (_cache[8] = $event => ((_ctx.activeKey3) = $event))
            }, {
              default: withCtx(() => [
                createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "搜索项设置"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_AdvancedSearch, {
                      keywords: _ctx.state.keywords,
                      tags: _ctx.state.tags,
                      sort: _ctx.state.sort,
                      "onUpdate:sort": _cache[5] || (_cache[5] = $event => ((_ctx.state.sort) = $event)),
                      searchItems: _ctx.advanceSearchItems,
                      updateKeywords: _ctx.updateKeywords,
                      collectKeywords: _ctx.collectKeywords,
                      doToggleDrawer: _ctx.doToggleDrawer,
                      isEditModle: _ctx.state.config.isEditModle,
                      newKeyClass: _ctx.newKeyClass,
                      updateNewKeyClass: _ctx.updateNewKeyClass
                    }, null, 8 /* PROPS */, ["keywords", "tags", "sort", "searchItems", "updateKeywords", "collectKeywords", "doToggleDrawer", "isEditModle", "newKeyClass", "updateNewKeyClass"])
                  ]),
                  _: 1 /* STABLE */
                }),
                (!_ctx.noSaveBtn)
                  ? (openBlock(), createBlock(_component_a_tab_pane, {
                      key: "2",
                      tab: "常用搜索条件",
                      "force-render": ""
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_SearchCriteria, {
                          collects: _ctx.state.collects,
                          "onUpdate:collects": _cache[6] || (_cache[6] = $event => ((_ctx.state.collects) = $event)),
                          searchItems: _ctx.advanceSearchItems,
                          isEditModle: _ctx.state.config.isEditModle,
                          updateKeywordsByIndex: _ctx.updateKeywordsByIndex,
                          deleteCollect: _ctx.deleteCollect,
                          updateKeywords: _ctx.updateKeywords,
                          isShowTab: _ctx.state.config.isShowTab
                        }, null, 8 /* PROPS */, ["collects", "searchItems", "isEditModle", "updateKeywordsByIndex", "deleteCollect", "updateKeywords", "isShowTab"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true),
                (!_ctx.tabOnPageHeader)
                  ? (openBlock(), createBlock(_component_a_tab_pane, {
                      key: "3",
                      tab: "系统标签页",
                      "force-render": ""
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_SearchCriteria, {
                          collects: _ctx.tabCollects,
                          "onUpdate:collects": _cache[7] || (_cache[7] = $event => ((_ctx.tabCollects) = $event)),
                          searchItems: _ctx.advanceSearchItems,
                          isEditModle: false,
                          updateKeywords: _ctx.updateKeywords,
                          isShowTab: _ctx.state.config.isShowTab
                        }, null, 8 /* PROPS */, ["collects", "searchItems", "updateKeywords", "isShowTab"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["activeKey"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class", "visible"]))
      : createCommentVNode("v-if", true),
    createVNode(_component_SearchSave, {
      class: "sc-search-save",
      visible: _ctx.visibleModal,
      "onUpdate:visible": _cache[11] || (_cache[11] = $event => ((_ctx.visibleModal) = $event)),
      title: _ctx.modalTitle,
      okText: _ctx.okText,
      cancelText: _ctx.cancelText,
      onOk: _ctx.handleModalOk,
      keywords: _ctx.state.keywords,
      modalFormItems: _ctx.modalFormItems
    }, null, 8 /* PROPS */, ["visible", "title", "okText", "cancelText", "onOk", "keywords", "modalFormItems"])
  ], 64 /* STABLE_FRAGMENT */))
}

script$X.render = render$Q;
script$X.__file = "packages/search-form/SearchForm.vue";

script$X.install = (Vue) => {
    Vue.component(script$X.name, script$X);
    Vue.component(script$Z.name, script$Z);
};

var script$W = defineComponent({
    name: 'ScModalTable',
    components: { SearchForm: script$X, Modal: script$1N, InnerGrid: script$18 },
    props: {
        visible: {
            type: [Boolean],
            default: true,
        },
        okText: {
            type: String,
            default: '添加',
        },
        cancelText: {
            type: String,
            default: '取消',
        },
        title: {
            type: String,
            default: '添加数据',
        },
        width: {
            type: [Number, String],
            default: 800,
        },
        btns: {
            type: Array,
        },
        // 表唯一索引id
        indexField: {
            type: String,
            default: 'id',
        },
        // 表数据名
        tableName: {
            type: String,
            default: 'modalTable',
        },
        columnDefs: {
            type: Array,
            requested: true,
        },
        // 选中行
        value: {
            type: Array,
            default: () => [],
        },
        tableProps: {
            type: Object,
            default: () => ({}),
        },
        searchItems: {
            type: Array,
            default: () => [],
        },
        searchProps: {
            type: Object,
            default: () => ({}),
        },
        onSearch: {
            type: Function,
            default: () => [],
        },
        // 组件内关闭弹窗
        close: {
            type: Function,
            default: (e) => (e.value = false),
        },
    },
    setup(props, { emit }) {
        const { visibleRef, modalBtns } = useModal(props, emit);
        const serachForm = useSearchForm$1(props);
        const innerGrid = useInnerGrid(props, emit, visibleRef, modalBtns);
        const checked = ref(false);
        return {
            zhCN,
            visibleRef,
            modalBtns,
            ...serachForm,
            ...innerGrid,
            checked,
        };
    },
});

function render$P(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchForm = resolveComponent("SearchForm");
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_a_config_provider = resolveComponent("a-config-provider");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, {
    class: "my-modal-table",
    title: _ctx.title,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visibleRef) = $event)),
    btns: _ctx.modalBtns,
    width: _ctx.width
  }, {
    footer: withCtx(() => [
      createVNode(_component_a_checkbox, {
        checked: _ctx.checked,
        "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.checked) = $event))
      }, {
        default: withCtx(() => [
          createTextVNode("是否启用")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["checked"])
    ]),
    default: withCtx(() => [
      createVNode(_component_a_config_provider, { locale: _ctx.zhCN }, {
        default: withCtx(() => [
          createVNode(_component_SearchForm, mergeProps({
            advanceSearchItems: _ctx.searchItems,
            onOnSearch: _ctx.handleSearch,
            isHideAdvancedSearch: "",
            isHideTags: "",
            isInline: "",
            noSaveBtn: "",
            ref: "searchFormRef"
          }, { ..._ctx.searchProps }), null, 16 /* FULL_PROPS */, ["advanceSearchItems", "onOnSearch"]),
          withDirectives(createElementVNode("span", { class: "my-is-selected" }, toDisplayString('已选中 ' + _ctx.selectedValueRef.length + ' 条数据'), 513 /* TEXT, NEED_PATCH */), [
            [vShow, !_ctx.value.length]
          ]),
          withDirectives(createElementVNode("span", { class: "my-is-warning" }, toDisplayString('共有 ' + _ctx.existedRef + ' 条数据已存在，已标黄显示'), 513 /* TEXT, NEED_PATCH */), [
            [vShow, _ctx.existedRef]
          ]),
          createVNode(_component_InnerGrid, mergeProps({
            id: _ctx.tableName,
            indexField: _ctx.indexField,
            gridDefs: _ctx.gridDefs,
            gridOptions: _ctx.gridOptions,
            columnDefs: _ctx.columnDefs,
            rowData: _ctx.rowData,
            onRowSelected: _ctx.onRowSelected,
            onRowDataChanged: _ctx.onRowDataChanged
          }, { ..._ctx.tableProps }), null, 16 /* FULL_PROPS */, ["id", "indexField", "gridDefs", "gridOptions", "columnDefs", "rowData", "onRowSelected", "onRowDataChanged"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["locale"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "visible", "btns", "width"]))
}

script$W.render = render$P;
script$W.__file = "packages/modal/src/ModalTable.vue";

script$1N.install = (Vue) => {
    Vue.component(script$1N.name, script$1N);
    Vue.component(script$W.name, script$W);
    Vue.component(script$17.name, script$17);
};
script$1N.table = $modalTable;
script$1N.confirm = $modalConfirm;
script$1N.form = $modalForm;
script$1N.notification = $notification;

const baseUrl$7 = process.env.VUE_APP_URL;
var script$V = defineComponent({
    name: 'AddressAutoFill',
    props: {
        maxlength: {
            type: Number,
            default: 120,
        },
        placeholder: {
            type: String,
            default: '粘贴文本，可自动识别姓名，电话和地址。如：北京市朝阳区xx街道xx大厦xx楼xx室，李明，139****8888',
        },
    },
    emits: ['onSubmit'],
    setup(props, { emit }) {
        const addressText = ref('');
        const onSubmit = () => {
            let addressDetailFormData = new FormData();
            addressDetailFormData.append('addressDetail', addressText.value);
            http({
                url: '/user/deliver-address/parse-address',
                method: 'POST',
                baseURL: baseUrl$7,
                data: addressDetailFormData,
                withCredentials: true,
            }).then((result) => {
                const { data: { code, data, message: message$1 }, } = result || {};
                code === 0
                    ? emit('onSubmit', data)
                    : message.error(message$1 || '系统错误，请稍后重试...');
            });
        };
        return {
            addressText,
            onSubmit,
        };
    },
});

const _hoisted_1$N = { class: "address-auto-fill" };
const _hoisted_2$A = ["placeholder", "maxlength"];
const _hoisted_3$t = { class: "btn-group" };
const _hoisted_4$m = { class: "operation-btn" };

function render$O(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");

  return (openBlock(), createElementBlock("div", _hoisted_1$N, [
    withDirectives(createElementVNode("textarea", {
      name: "",
      id: "",
      cols: "40",
      rows: "3",
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.addressText) = $event)),
      maxlength: _ctx.maxlength
    }, null, 8 /* PROPS */, _hoisted_2$A), [
      [vModelText, _ctx.addressText]
    ]),
    createElementVNode("div", _hoisted_3$t, [
      createElementVNode("span", null, toDisplayString(_ctx.addressText.length) + " /" + toDisplayString(_ctx.maxlength), 1 /* TEXT */),
      createElementVNode("div", _hoisted_4$m, [
        createVNode(_component_a_button, {
          size: "small",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.addressText = ''))
        }, {
          default: withCtx(() => [
            createTextVNode("清空")
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_a_button, {
          class: "submit",
          size: "small",
          type: "primary",
          onClick: _ctx.onSubmit
        }, {
          default: withCtx(() => [
            createTextVNode("提交")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ]))
}

script$V.render = render$O;
script$V.__file = "packages/address-auto-fill/src/AddressAutoFill.vue";

script$V.install = (Vue) => {
    Vue.component(script$V.name, script$V);
};

var script$U = defineComponent({
    name: 'ScAddAddressInfoModal',
    components: {
        Modal: script$1N,
        BasicFormItem: script$1v,
        AddressAutoFill: script$V,
    },
    props: {
        visible: {
            type: [Boolean],
            default: false,
        },
        title: {
            type: String,
            default: '新增地址',
        },
        props: {
            type: Object,
            default: () => ({}),
        },
        nameLabel: {
            type: String,
            default: '姓名',
        },
        formState: {
            type: Object,
            default: () => ({}),
        },
        showDefaultCheck: {
            type: [Boolean],
            default: true,
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 表单数据
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => {
                emit('update:formState', val);
            },
        });
        const inputValidator = async (rule) => {
            const field = rule.field;
            if (rule.required && !formStateRef.value[field]) {
                return Promise.reject(rule.label + '不能为空');
            }
            else if (field == 'mobile' &&
                formStateRef.value[field] &&
                !isMobile(formStateRef.value[field])) {
                return Promise.reject('请输入正确的手机号码格式');
            }
            else if (field == 'phone' &&
                formStateRef.value[field] &&
                !isPhone(formStateRef.value[field])) {
                return Promise.reject('请输入正确的固定电话');
            }
            else {
                return Promise.resolve();
            }
        };
        // 表单验证
        const rules = {
            name: [
                {
                    required: true,
                    label: props.nameLabel || '姓名',
                    validator: inputValidator,
                },
                {
                    max: 20,
                    message: props.nameLabel || '姓名' + '不能超过20个字符，请精简字数',
                },
            ],
            mobile: {
                label: '手机号码',
                trigger: 'blur',
                validator: inputValidator,
            },
            localArea: {
                required: true,
                label: '所在地区',
                trigger: 'change',
                validator: () => {
                    if (!formStateRef.value.localArea ||
                        formStateRef.value.localArea.length == 0) {
                        return Promise.reject('请选择省/市/县（区）');
                    }
                    else {
                        return Promise.resolve();
                    }
                },
            },
            addressDetail: [
                {
                    required: true,
                    label: '详细地址',
                    validator: inputValidator,
                },
                {
                    max: 64,
                    message: '详细地址请勿超过64个字符',
                },
            ],
            zipCode: [
                {
                    label: '邮编',
                    validator: inputValidator,
                },
                {
                    pattern: VALIDATOR.pattern.postcode,
                    message: VALIDATOR.message.postcode,
                    trigger: 'blur',
                },
            ],
            phone: {
                label: '固定电话',
                trigger: 'blur',
                validator: inputValidator,
            },
            addressAlias: [
                {
                    label: '',
                    validator: inputValidator,
                },
                {
                    max: 30,
                    message: '地址别名请勿超过30个字符',
                },
            ],
        };
        // 表单项
        const formItems = reactive([
            {
                dataIndex: 'name',
                key: 'name',
                type: 'Input',
                value: formStateRef.value.name,
                label: props.nameLabel || '姓名',
            },
            {
                dataIndex: 'mobile',
                key: 'mobile',
                type: 'Input',
                value: formStateRef.value.mobile,
                label: '手机号码',
                labelWidth: '80px',
                placeholder: '请输入手机号码',
            },
            {
                dataIndex: 'localArea',
                key: 'localArea',
                tagKey: 'location',
                type: 'Cascader',
                value: formStateRef.value.localArea,
                label: '所在地区',
                placeholder: '请选择省/市/县（区）',
                span: 24,
                props: {
                    isCityPicker: true,
                    changeOnSelect: true,
                    getPopupContainer: (target) => {
                        return target.parentNode;
                    },
                },
            },
            {
                dataIndex: 'addressDetail',
                key: 'addressDetail',
                type: 'Input',
                value: formStateRef.value.addressDetail,
                label: '详细地址',
                placeholder: '请输入详细地址',
                span: 24,
            },
            {
                dataIndex: 'zipCode',
                key: 'zipCode',
                type: 'Input',
                value: formStateRef.value.zipCode,
                label: '邮编',
            },
            {
                dataIndex: 'phone',
                key: 'phone',
                type: 'Input',
                value: formStateRef.value.phone,
                label: '固定电话',
                labelWidth: '80px',
                placeholder: '格式为: 012-12345678',
            },
            {
                dataIndex: 'addressAlias',
                key: 'addressAlias',
                type: 'Input',
                value: formStateRef.value.addressAlias,
                label: '地址别名',
            },
        ]);
        // 智能地址填写
        const handleAddressAutoFill = (info) => {
            Object.assign(formStateRef.value, info);
            formStateRef.value.addressDetail = info.detail;
            let location = '';
            if (info.provinceCode) {
                formStateRef.value.localArea = [info.provinceCode];
                location += info.province;
                if (info.cityCode) {
                    formStateRef.value.localArea[1] = info.cityCode;
                    location += '-' + info.city;
                    if (info.districtCode) {
                        formStateRef.value.localArea[2] = info.districtCode;
                        location += '-' + info.district;
                    }
                }
            }
            formStateRef.value.location = location;
            formStateRef.value.name = info.name.trim().trim('\n');
            formItems.forEach((item) => {
                item.value = formStateRef.value[item.key];
            });
        };
        // 提交
        const addressInfoForm = ref();
        const handleOk = () => {
            addressInfoForm.value
                .validate()
                .then(() => {
                emit('submit', formStateRef.value);
            })
                .catch((error) => {
                const msgs = error.errorFields.map((err) => err.errors.toString());
                message.warn([...new Set(msgs)].join('、'));
            });
        };
        return {
            visibleRef,
            formItems,
            formStateRef,
            rules,
            handleAddressAutoFill,
            addressInfoForm,
            handleOk,
        };
    },
});

const _hoisted_1$M = { class: "address-info-modal-content" };
const _hoisted_2$z = { class: "intelligence-identification" };
const _hoisted_3$s = /*#__PURE__*/createElementVNode("div", { class: "address-auto-label" }, "智能地址填写", -1 /* HOISTED */);
const _hoisted_4$l = /*#__PURE__*/createElementVNode("span", { style: {"color":"#999","margin-left":"10px"} }, " 设置后系统将在下单时自动选中该收货地址 ", -1 /* HOISTED */);

function render$N(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AddressAutoFill = resolveComponent("AddressAutoFill");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_row = resolveComponent("a-row");
  const _component_a_form = resolveComponent("a-form");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, {
    class: "sc-add-address-info-modal",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visibleRef) = $event)),
    title: _ctx.$props.title,
    width: "560px",
    onOk: _ctx.handleOk
  }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$M, [
        createElementVNode("div", _hoisted_2$z, [
          _hoisted_3$s,
          createVNode(_component_AddressAutoFill, { onOnSubmit: _ctx.handleAddressAutoFill }, null, 8 /* PROPS */, ["onOnSubmit"])
        ]),
        createVNode(_component_a_form, {
          ref: "addressInfoForm",
          class: "address-info-form",
          rules: _ctx.rules,
          model: _ctx.formStateRef
        }, {
          default: withCtx(() => [
            createVNode(_component_a_row, { justify: "space-between" }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItems, (item, index) => {
                  return (openBlock(), createBlock(_component_a_col, {
                    key: index,
                    span: item.span || 12
                  }, {
                    default: withCtx(() => [
                      (openBlock(), createBlock(_component_BasicFormItem, {
                        item: item,
                        key: item.key,
                        name: item.key,
                        value: _ctx.formStateRef[item.key],
                        "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event),
                        tag: _ctx.formStateRef[item.tagKey || ''],
                        "onUpdate:tag": $event => ((_ctx.formStateRef[item.tagKey || '']) = $event),
                        "label-in-value": "",
                        labelAlign: "right",
                        colon: false,
                        labelCol: { style: { width: item.labelWidth || '65px' } }
                      }, null, 8 /* PROPS */, ["item", "name", "value", "onUpdate:value", "tag", "onUpdate:tag", "labelCol"]))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["span"]))
                }), 128 /* KEYED_FRAGMENT */)),
                (_ctx.$props.showDefaultCheck)
                  ? (openBlock(), createBlock(_component_a_col, { key: 0 }, {
                      default: withCtx(() => [
                        createVNode(_component_a_form_item, { wrapperCol: { style: { marginLeft: '75px' } } }, {
                          default: withCtx(() => [
                            createVNode(_component_a_checkbox, {
                              checked: _ctx.formStateRef.defaultedDeliver,
                              "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.formStateRef.defaultedDeliver) = $event))
                            }, {
                              default: withCtx(() => [
                                createTextVNode(" 设置为默认地址 "),
                                _hoisted_4$l
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["checked"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["rules", "model"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "title", "onOk"]))
}

script$U.render = render$N;
script$U.__file = "packages/add-address-info-modal/src/AddAddressInfoModal.vue";

script$U.install = (Vue) => {
    Vue.component(script$U.name, script$U);
};

const baseUrl$6 = process.env.VUE_APP_URL;
const urls$7 = {
    roleInfoUrl: '/approval/employee/list-role-info',
    employeeInfoUrl: '/approval/employee/list-common-employee-info',
    employeeInfoUrlV2: '/approval/employee/v2/list-common-employee-info',
    departmentInfoUrl: '/approval/approval-flow/get-department-tree',
    approvalChainInfoUrl: '/approval/approval-center/list-used-common-approval-chain',
    approvalInfo: '/approval/approval-center/get-apply-approval-info',
    approvalChainDel: '/approval/approval-center/delete-common-approval-chain',
    approvalDetail: '/approval/approval-center/v2/get-approval-detail', // 审批详情
};
// 获取大区列表
const fetchDepartmentList = () => {
    return http({
        url: urls$7.departmentInfoUrl,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'GET',
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return (res.data.data || []) && (res.data.data[0].children || []);
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};
// 获取城市列表
const fetchRoleList = () => {
    return http({
        url: urls$7.roleInfoUrl,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'GET',
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || [];
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};
const fetchEmployeeList = (param) => {
    return http({
        url: urls$7.employeeInfoUrlV2,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'POST',
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return ((res.data.data || []) && res.data.data.data) || [];
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};
const fetchApprovalChainList = (params) => {
    return http({
        url: urls$7.approvalChainInfoUrl,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'GET',
        params: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || [];
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};
const fetchApprovalInfo = (params) => {
    return http({
        url: urls$7.approvalInfo,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'GET',
        params: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data.shopFlowInfo || {};
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};
const setApprovalChainDel = (params) => {
    return http({
        url: urls$7.approvalChainDel,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'POST',
        headers: { contentType: 'application/x-www-form-urlencoded' },
        params: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};
const fetchApprovalDetail = (params) => {
    return http({
        url: urls$7.approvalDetail,
        withCredentials: true,
        baseURL: baseUrl$6,
        method: 'GET',
        params: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || {};
        }
        else {
            message.error(res.message || '系统错误，请稍后重试...');
        }
    });
};

var script$T = defineComponent({
    name: 'ScApprovalChainModal',
    components: { Modal: script$1N, InnerGrid: script$18 },
    props: {
        // 弹窗开启关闭
        visible: {
            type: [Boolean],
            default: false,
        },
        // 选中值
        value: {
            type: Array,
            default: () => [],
        },
        // 表格索引字段, 必填
        indexField: {
            type: String,
            default: 'chainId',
        },
        // 常用审批链参数
        params: {
            type: Object,
            default: () => ({
                flowId: 0,
                initiatorId: 0,
                initiatorName: '',
                finalApproverName: '',
                finalApproverId: 0,
            }),
        },
    },
    setup(props, context) {
        const { value, visible } = toRefs(props);
        // 选择按钮
        const onClickBtnSelect = (e) => {
            context.emit('submit', [e.data]);
            context.emit('update:visible', false);
        };
        // 删除按钮
        const onClickBtnRemove = async ({ data, node }) => {
            await setApprovalChainDel({ id: data.chainId });
            // 删除行
            node.gridApi.applyTransaction({ remove: [data] });
            message.info('删除成功');
        };
        const columnDefs = [
            {
                field: 'chain',
                headerName: '常用审批链',
                width: 600,
            },
            {
                field: 'count',
                headerName: '使用频次',
                flex: 1,
            },
            {
                field: '',
                headerName: '操作',
                flex: 1,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'btnGroup',
                        btnGroup: [
                            {
                                btnText: '使用',
                                click: onClickBtnSelect,
                            },
                            {
                                btnText: '删除',
                                btnType: 'danger',
                                click: onClickBtnRemove,
                            },
                        ],
                    },
                },
            },
        ];
        const rowData = ref([]);
        const getApprovalChainList = async () => {
            const getNames = (arr, char) => {
                const ext = arr.length > 3 ? '...' : '';
                return (arr
                    .slice(0, 3)
                    .map((n) => n.realName)
                    .join(char) + ext);
            };
            const params = props.params;
            const data = await fetchApprovalChainList(params);
            const flow = data.shopFlowApplyRecordDtos || [];
            console.log(flow);
            rowData.value = flow.map((e) => {
                const approver = e.applyRecordChainContentDto.approverChainContentDtos || [];
                const cc = e.applyRecordChainContentDto.ccContentDtos || [];
                approver.forEach((n) => (n.realName = n.name));
                cc.forEach((n) => (n.realName = n.name));
                const appNames = getNames(approver, ' → ');
                const ccNames = getNames(cc, '、');
                const chain = `${params.initiatorName}(发起人) → ${appNames} → ${params.finalApproverName} (最终审批人) | 抄送：${ccNames}`;
                return {
                    chainId: e.id,
                    count: e.count,
                    chain: chain,
                    process: {
                        initiator: [
                            { realName: params.initiatorName, userId: flow.userId },
                        ],
                        approver,
                        final: [
                            {
                                userId: params.finalApproverId,
                                realName: params.finalApproverName,
                            },
                        ],
                        cc,
                    },
                };
            });
        };
        watch(() => props.params.flowId, (val) => {
            if (!val)
                return;
            if (!props.params.flowId)
                return;
            getApprovalChainList();
        }, { immediate: true });
        // 表格
        const innerGrid = useInnerGrid$1(columnDefs, visible, value, props.indexField, false, context);
        return { ...innerGrid, rowData };
    },
});

const _hoisted_1$L = { class: "sc-approval-chain-modal" };

function render$M(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createElementBlock("div", _hoisted_1$L, [
    createVNode(_component_Modal, mergeProps({
      visible: _ctx.visibleRef,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
      width: "850px"
    }, { ..._ctx.$attrs }, { onOk: _ctx.handleOk }), {
      default: withCtx(() => [
        createVNode(_component_InnerGrid, {
          columnDefs: _ctx.columnDefs,
          rowData: _ctx.rowData,
          gridDefs: _ctx.gridDefs,
          onRowSelected: _ctx.onRowSelected,
          onRowDataChanged: _ctx.onRowDataChanged,
          maxHeight: "270px",
          ref: "gridRef",
          indexField: _ctx.indexField
        }, null, 8 /* PROPS */, ["columnDefs", "rowData", "gridDefs", "onRowSelected", "onRowDataChanged", "indexField"])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["visible", "onOk"])
  ]))
}

script$T.render = render$M;
script$T.__file = "packages/approval-chain-modal/src/ApprovalChainModal.vue";

script$T.install = (Vue) => {
    Vue.component(script$T.name, script$T);
};

var script$S = defineComponent({
    name: 'ScSteps',
    components: { ClockCircleFilled, EllipsisOutlined, CheckOutlined },
    props: {
        current: {
            type: Number,
            default: 1,
        },
        type: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const currentRef = computed(() => props.current);
        const labelPlacementRef = computed(() => {
            return props.type === 'navigation' ? 'horizontal' : 'vertical';
        });
        const isIcon = computed(() => {
            return props.type === 'navigation' ? false : true;
        });
        return { currentRef, labelPlacementRef, isIcon };
    },
});

function render$L(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ClockCircleFilled = resolveComponent("ClockCircleFilled");
  const _component_CheckOutlined = resolveComponent("CheckOutlined");
  const _component_EllipsisOutlined = resolveComponent("EllipsisOutlined");
  const _component_a_step = resolveComponent("a-step");
  const _component_a_steps = resolveComponent("a-steps");

  return (openBlock(), createBlock(_component_a_steps, mergeProps({ class: "sc-steps" }, { ..._ctx.$props }, {
    current: _ctx.currentRef,
    "onUpdate:current": _cache[0] || (_cache[0] = $event => ((_ctx.currentRef) = $event)),
    labelPlacement: _ctx.labelPlacementRef,
    size: "small"
  }), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.datas, (item, index) => {
        return (openBlock(), createBlock(_component_a_step, {
          key: index,
          title: item.title,
          "sub-title": item.subTitle,
          description: item.time,
          disabled: ""
        }, createSlots({ _: 2 /* DYNAMIC */ }, [
          (_ctx.isIcon)
            ? {
                name: "icon",
                fn: withCtx(() => [
                  (index === _ctx.currentRef)
                    ? (openBlock(), createBlock(_component_ClockCircleFilled, { key: 0 }))
                    : (index < _ctx.currentRef)
                      ? (openBlock(), createBlock(_component_CheckOutlined, { key: 1 }))
                      : (openBlock(), createBlock(_component_EllipsisOutlined, { key: 2 }))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "sub-title", "description"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["current", "labelPlacement"]))
}

script$S.render = render$L;
script$S.__file = "packages/steps/src/Steps.vue";

script$S.install = (Vue) => {
    Vue.component(script$S.name, script$S);
};

const _hoisted_1$K = ["title"];
var script$R = /*#__PURE__*/ defineComponent({
    __name: 'Avatar',
    props: {
        uuid: { type: String, required: false },
        name: { type: String, required: false },
        size: { type: null, required: false, default: 35 }
    },
    setup(__props) {
        const props = __props;
        const style = computed(() => ({
            width: `${props.size}px`,
            height: `${props.size}px`,
        }));
        const src = computed(() => {
            if (props.uuid) {
                if (props.uuid.startsWith('http')) {
                    return props.uuid;
                }
                return preview(props.uuid);
            }
            return '';
        });
        const firstLetter = computed(() => {
            if (props.name) {
                return props.name.charAt(0);
            }
            return '';
        });
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("div", {
                class: "sc-user-avatar",
                title: props.name
            }, [
                createVNode(unref(Avatar), {
                    style: normalizeStyle(unref(style)),
                    src: unref(src),
                    size: __props.size,
                    shape: "square"
                }, {
                    default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(firstLetter)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["style", "src", "size"])
            ], 8 /* PROPS */, _hoisted_1$K));
        };
    }
});

script$R.__file = "packages/avatar/src/Avatar.vue";

script$R.install = (Vue) => {
    Vue.component(script$R.name, script$R);
};

var script$Q = defineComponent({
    name: 'ScTimeline',
    components: {
        Avatar: script$R,
        ClockCircleOutlined,
        ToTopOutlined,
        CheckCircleOutlined,
        EllipsisOutlined,
        MinusCircleOutlined,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        string: {
            type: String,
            default: '',
        },
        boolean: {
            type: [Boolean],
            default: false,
        },
        object: {
            type: Object,
            default: () => ({}),
        },
        function: {
            type: Object,
            default: () => null,
        },
    },
    setup(props, { emit }) {
        const statusColorMap = {
            start: 'green',
            finish: 'green',
            process: 'green',
            error: 'red',
            wait: 'blue',
        };
        return { statusColorMap };
    },
});

const _hoisted_1$J = { class: "sc-timeline" };
const _hoisted_2$y = { class: "sc-timeline-box" };

function render$K(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckCircleOutlined = resolveComponent("CheckCircleOutlined");
  const _component_ClockCircleOutlined = resolveComponent("ClockCircleOutlined");
  const _component_ToTopOutlined = resolveComponent("ToTopOutlined");
  const _component_EllipsisOutlined = resolveComponent("EllipsisOutlined");
  const _component_MinusCircleOutlined = resolveComponent("MinusCircleOutlined");
  const _component_Avatar = resolveComponent("Avatar");
  const _component_a_timeline_item = resolveComponent("a-timeline-item");
  const _component_a_timeline = resolveComponent("a-timeline");

  return (openBlock(), createElementBlock("div", _hoisted_1$J, [
    createVNode(_component_a_timeline, null, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
          return (openBlock(), createBlock(_component_a_timeline_item, {
            key: index,
            color: item.status
          }, {
            dot: withCtx(() => [
              (item.status === 'finish')
                ? (openBlock(), createBlock(_component_CheckCircleOutlined, { key: 0 }))
                : createCommentVNode("v-if", true),
              (item.status === 'process')
                ? (openBlock(), createBlock(_component_ClockCircleOutlined, { key: 1 }))
                : createCommentVNode("v-if", true),
              (item.status === 'start')
                ? (openBlock(), createBlock(_component_ToTopOutlined, { key: 2 }))
                : createCommentVNode("v-if", true),
              (item.status === 'wait')
                ? (openBlock(), createBlock(_component_EllipsisOutlined, { key: 3 }))
                : createCommentVNode("v-if", true),
              (item.status === 'error')
                ? (openBlock(), createBlock(_component_MinusCircleOutlined, { key: 4 }))
                : createCommentVNode("v-if", true)
            ]),
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2$y, [
                (item.children)
                  ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(item.children, (child, key) => {
                      return (openBlock(), createBlock(_component_Avatar, mergeProps({
                        class: "sc-timeline-child",
                        isHorizontal: ""
                      }, { ...child }, { key: key }), null, 16 /* FULL_PROPS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  : (openBlock(), createBlock(_component_Avatar, mergeProps({
                      key: 1,
                      isHorizontal: ""
                    }, { ...item }), null, 16 /* FULL_PROPS */))
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}

script$Q.render = render$K;
script$Q.__file = "packages/timeline/src/Timeline.vue";

script$Q.install = (Vue) => {
    Vue.component(script$Q.name, script$Q);
};

var script$P = defineComponent({
    name: 'ScApprovalDetail',
    components: { Steps: script$S, Timeline: script$Q, BasicFormItem: script$1v },
    props: {
        flowId: {
            type: Number,
            default: 0,
        },
        referenceNo: {
            type: String,
            default: '',
        },
        // 当前节点[{id,userId}]
        value: {
            type: Array,
            default: () => [],
        },
        showSubmitForm: {
            type: [Boolean],
            default: true,
        },
    },
    setup(props, { emit }) {
        const StatusKey = {
            Wait: 0,
            Process: 10,
            Resolve: 20,
            Reject: 30,
            Cancel: 40,
        };
        const statusMap = {
            [StatusKey.Wait]: ['未审批', 'wait'],
            [StatusKey.Process]: ['审批中', 'process'],
            [StatusKey.Resolve]: ['审批通过', 'finish'],
            [StatusKey.Reject]: ['审批拒绝', 'error'],
            [StatusKey.Cancel]: ['审批撤销', 'cancel'],
        };
        const valueRef = computed({
            get: () => props.value,
            set: (val) => {
                emit('update:value', val);
            },
        });
        // 当前节点
        const currentRef = ref(0);
        const processStepRef = ref([]);
        const processTimelineRef = ref([]);
        // 未审批，发起人可以撤销
        const isShowCancelButtonRef = ref(false);
        // 审批中，审批人可以审批
        const isShowSubmitButtonRef = ref(false);
        // 登入用户
        const loginUser = getUserInfo();
        // 总审批状态
        const approvalRemarkRef = ref('');
        // 倒序排序
        const compare = (k) => (a, b) => b[k] - a[k];
        // 正序排序
        const order = (k) => (a, b) => a[k] - b[k];
        // 抄送信息
        const getCcNode = (cc) => {
            const isSend = cc[0] && cc[0].noticeStatus === 20;
            const state = isSend ? '已抄送' : '未抄送';
            const status = isSend ? 'finish' : 'wait';
            return {
                label: '抄送人',
                title: `共${cc.length}人`,
                state,
                desc: cc.map((e) => e.userName || e.realName).toString() || '-',
                status,
                avatar: false,
            };
        };
        // 审批人信息
        const getApproverNodes = (ap, isApproval = true) => {
            // 0未审批  10审批中 20审批通过 30审批拒绝 40审批撤销
            if (isApproval) {
                ap = ap.filter((e) => e.status > 0);
            }
            // 倒序显示
            ap = ap.sort(compare('sequence'));
            return ap.map((e) => {
                const state = statusMap[e.status][0] || '-';
                const status = statusMap[e.status][1] || '-';
                return {
                    title: e.userName || e.realName || '-',
                    state,
                    time: e.updatedAt.replace('T', ' '),
                    desc: e.comment,
                    status,
                };
            });
        };
        // 审批人信息
        const getApproverSteps = (ap, index) => {
            // 0未审批  10审批中 20审批通过 30审批拒绝 40审批撤销
            // 审批中 currentRef ，包含发起人节点 sequence+1  -审批结束，
            index > -1
                ? ((valueRef.value = [{ id: ap[index].id, userId: ap[index].userId }]),
                    (currentRef.value = ap[index].sequence + 1))
                : ((valueRef.value = []), (currentRef.value = ap.length + 1));
            return ap.sort(order('sequence')).map((e) => {
                const status = statusMap[e.status][1] || '-';
                const title = statusMap[e.status][0] || '-';
                return {
                    title,
                    subTitle: e.userName || e.realName || '-',
                    time: e.status ? e.updatedAt.replace('T', ' ') : '',
                    status,
                };
            });
        };
        // 自由审批模式
        const initFreeApproval = (node, initiator) => {
            const cc = node.applyNodeCcs || [];
            const approver = node.applyNodeApprovers || [];
            // 审批中的节点，未包含发起人
            const currIndex = approver.findIndex((e) => e.status === 10);
            // 节点类型(5会签  10或签  15依次)
            processTimelineRef.value = [
                ...getApproverNodes(approver),
                getCcNode(cc),
                initiator,
            ];
            processStepRef.value = [
                {
                    title: initiator.state,
                    subTitle: initiator.title,
                    time: initiator.time,
                    status: initiator.status,
                },
                ...getApproverSteps(approver, currIndex),
            ];
        };
        // 固定审批模式
        const initFixedApproval = (nodes, initiator) => {
            // 审批中的节点，未包含发起人
            const index = nodes.findIndex((e) => e.status === 10);
            // 审批中 currentRef ，包含发起人节点  -审批结束，
            index > -1
                ? ((valueRef.value = nodes[index].applyNodeApprovers.map((e) => ({
                    id: e.id,
                    userId: e.userId,
                }))),
                    (currentRef.value = nodes[index].sequence + 1))
                : ((valueRef.value = []), (currentRef.value = nodes.length + 1));
            // step
            const steps = nodes.sort(order('sequence')).map((e) => {
                const status = statusMap[e.status][1] || '-';
                const title = statusMap[e.status][0] || '-';
                return {
                    title,
                    subTitle: e.userName || e.alias || '-',
                    time: e.status ? e.updatedAt.replace('T', ' ') : '',
                    status,
                };
            });
            processStepRef.value = [
                {
                    title: initiator.state,
                    subTitle: initiator.title,
                    time: initiator.time,
                    status: initiator.status,
                },
                ...steps,
            ];
            // 倒序显示
            nodes = nodes.filter((e) => e.status > 0).sort(compare('sequence'));
            processTimelineRef.value = nodes.map((node) => {
                const cc = node.applyNodeCcs || [];
                const approver = node.applyNodeApprovers || [];
                // 节点类型(5会签  10或签  15依次) dto.type
                return {
                    status: statusMap[node.status][1],
                    children: [...getApproverNodes(approver), getCcNode(cc)],
                };
            });
            // 发起人
            processTimelineRef.value.push(initiator);
        };
        watch(() => props.referenceNo, async (val) => {
            if (!val || !props.flowId)
                return;
            const params = {
                flowId: props.flowId,
                referenceNo: val,
                btnShowFlag: true,
            };
            const data = await fetchApprovalDetail(params);
            const dto = data.applyDto || {};
            const nodes = dto.applyNodeDtos || [];
            // 0未审批  10审批中 20审批通过 30审批拒绝 40审批撤销
            // 发起人和创建人 显示撤销审批按钮
            isShowCancelButtonRef.value =
                loginUser &&
                    (loginUser.id === dto.initiatorId || loginUser.id === dto.createBy) &&
                    dto.status === 10
                    ? true
                    : false;
            const title = dto.initiatorType === 20
                ? `${dto.createdName} (代${dto.initiatorName})`
                : dto.initiatorName;
            const initiator = {
                title,
                state: '发起审批',
                time: dto.createdAt.replace('T', ' '),
                desc: '',
                status: 'start',
            };
            if (dto.flowType === 10) {
                initFreeApproval(nodes[0], initiator);
            }
            else if (dto.flowType === 20) {
                initFixedApproval(nodes, initiator);
            }
        }, { immediate: true });
        // 提交审核
        const handleSubmit = (resolve) => {
            // 获取 当前用户和approvalId
            const approver = valueRef.value.find((e) => e.userId === loginUser.id) || {};
            const data = {
                status: resolve ? StatusKey.Resolve : StatusKey.Reject,
                userId: loginUser.id,
                approverId: approver.id,
                opinion: approvalRemarkRef.value,
            };
            emit('submit', resolve, data);
        };
        const handleClose = () => {
            emit('close');
        };
        const handleCancel = () => {
            emit('cancel');
        };
        watch(() => valueRef.value, (val) => {
            // 当前审批节点用户
            loginUser &&
                loginUser.id &&
                (isShowSubmitButtonRef.value =
                    val.findIndex((e) => e.userId === loginUser.id) > -1);
        });
        // 审批表单
        const formItem = reactive({
            key: 'remark',
            label: '审批意见',
            type: 'TextArea',
            placeholder: '请填写审批意见',
            width: '400px',
            maxlength: 200,
        });
        return {
            currentRef,
            processStepRef,
            processTimelineRef,
            handleSubmit,
            handleClose,
            handleCancel,
            isShowCancelButtonRef,
            isShowSubmitButtonRef,
            approvalRemarkRef,
            formItem,
        };
    },
});

const _hoisted_1$I = { class: "sc-approval-detail" };

function render$J(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Steps = resolveComponent("Steps");
  const _component_Timeline = resolveComponent("Timeline");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_space = resolveComponent("a-space");
  const _component_a_row = resolveComponent("a-row");

  return (openBlock(), createElementBlock("div", _hoisted_1$I, [
    createVNode(_component_Steps, {
      datas: _ctx.processStepRef,
      current: _ctx.currentRef
    }, null, 8 /* PROPS */, ["datas", "current"]),
    createVNode(_component_Timeline, { items: _ctx.processTimelineRef }, null, 8 /* PROPS */, ["items"]),
    (_ctx.showSubmitForm)
      ? (openBlock(), createBlock(_component_a_row, {
          key: 0,
          type: "flex"
        }, {
          default: withCtx(() => [
            (_ctx.isShowSubmitButtonRef)
              ? (openBlock(), createBlock(_component_a_col, {
                  key: 0,
                  span: 24,
                  style: {"margin-bottom":"20px"}
                }, {
                  default: withCtx(() => [
                    createVNode(_component_a_form, null, {
                      default: withCtx(() => [
                        createVNode(_component_BasicFormItem, {
                          item: _ctx.formItem,
                          value: _ctx.approvalRemarkRef,
                          "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.approvalRemarkRef) = $event))
                        }, null, 8 /* PROPS */, ["item", "value"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true),
            createVNode(_component_a_col, { flex: "61px" }),
            createVNode(_component_a_col, { flex: "auto" }, {
              default: withCtx(() => [
                createVNode(_component_a_space, null, {
                  default: withCtx(() => [
                    (_ctx.isShowSubmitButtonRef)
                      ? (openBlock(), createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          onClick: _cache[1] || (_cache[1] = $event => (_ctx.handleSubmit(true)))
                        }, {
                          default: withCtx(() => [
                            createTextVNode("同意")
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : createCommentVNode("v-if", true),
                    (_ctx.isShowSubmitButtonRef)
                      ? (openBlock(), createBlock(_component_a_button, {
                          key: 1,
                          danger: "",
                          onClick: _cache[2] || (_cache[2] = $event => (_ctx.handleSubmit(false)))
                        }, {
                          default: withCtx(() => [
                            createTextVNode("拒绝")
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : createCommentVNode("v-if", true),
                    (_ctx.isShowCancelButtonRef)
                      ? (openBlock(), createBlock(_component_a_button, {
                          key: 2,
                          danger: "",
                          onClick: _ctx.handleCancel
                        }, {
                          default: withCtx(() => [
                            createTextVNode("撤销")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]))
                      : createCommentVNode("v-if", true),
                    createCommentVNode(" <a-button @click=\"handleClose\">关闭</a-button> ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : createCommentVNode("v-if", true)
  ]))
}

script$P.render = render$J;
script$P.__file = "packages/approval-detail/src/ApprovalDetail.vue";

var script$O = defineComponent({
    name: 'ScApprovalPrint',
    props: {
        flowId: {
            type: Number,
            default: 0,
        },
        referenceNo: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit }) {
        const StatusKey = {
            Wait: 0,
            Process: 10,
            Resolve: 20,
            Reject: 30,
            Cancel: 40,
        };
        const statusMap = {
            [StatusKey.Wait]: ['未审批', 'wait'],
            [StatusKey.Process]: ['审批中', 'process'],
            [StatusKey.Resolve]: ['审批通过', 'finish'],
            [StatusKey.Reject]: ['审批拒绝', 'error'],
            [StatusKey.Cancel]: ['审批撤销', 'cancel'],
        };
        // 当前节点
        const flowTypeRef = ref(0);
        const approvalListRef = ref([]);
        // 正序排序
        const order = (k) => (a, b) => a[k] - b[k];
        // 审批人信息
        const getApproverList = (ap, nodeName) => {
            // 0未审批  10审批中 20审批通过 30审批拒绝 40审批撤销
            return ap.sort(order('sequence')).map((e, i) => {
                const statusText = statusMap[e.status][0] || '-';
                const nodeInfo = i === 0 ? { nodeName, rowSpan: ap.length } : {};
                return {
                    ...nodeInfo,
                    userName: e.userName || '-',
                    time: e.status ? e.updatedAt.replace('T', ' ') : '',
                    statusText,
                    comment: e.comment || '-',
                };
            });
        };
        // 审批模式
        const initApprovalList = (nodes) => {
            approvalListRef.value.splice(0);
            nodes.map((node) => {
                const nodeName = node.alias || '-';
                const children = getApproverList(node.applyNodeApprovers, nodeName);
                approvalListRef.value.push(...children);
            });
        };
        watch(() => props.referenceNo, async (val) => {
            if (!val || !props.flowId)
                return;
            const params = {
                flowId: props.flowId,
                referenceNo: val,
                btnShowFlag: true,
            };
            const data = await fetchApprovalDetail(params);
            const dto = data.applyDto || {};
            const nodes = dto.applyNodeDtos || [];
            flowTypeRef.value = dto.flowType;
            initApprovalList(nodes);
            nextTick(() => emit('load', approvalListRef.value));
        }, { immediate: true });
        return {
            approvalListRef,
            flowTypeRef,
        };
    },
});

const _hoisted_1$H = { class: "sc-approval-print w1" };
const _hoisted_2$x = {
  key: 0,
  width: "120"
};
const _hoisted_3$r = /*#__PURE__*/createElementVNode("col", { width: "100" }, null, -1 /* HOISTED */);
const _hoisted_4$k = /*#__PURE__*/createElementVNode("col", { width: "100" }, null, -1 /* HOISTED */);
const _hoisted_5$g = /*#__PURE__*/createElementVNode("col", { width: "140" }, null, -1 /* HOISTED */);
const _hoisted_6$b = /*#__PURE__*/createElementVNode("tr", null, [
  /*#__PURE__*/createElementVNode("th", {
    colspan: "5",
    class: "center blod"
  }, "审批记录")
], -1 /* HOISTED */);
const _hoisted_7$a = {
  key: 0,
  class: "center"
};
const _hoisted_8$9 = /*#__PURE__*/createElementVNode("th", { class: "center" }, "审批人", -1 /* HOISTED */);
const _hoisted_9$8 = /*#__PURE__*/createElementVNode("th", { class: "center" }, "审批状态", -1 /* HOISTED */);
const _hoisted_10$6 = /*#__PURE__*/createElementVNode("th", { class: "center" }, "审批时间", -1 /* HOISTED */);
const _hoisted_11$6 = /*#__PURE__*/createElementVNode("th", { class: "center" }, "审批意见", -1 /* HOISTED */);
const _hoisted_12$6 = ["rowspan"];

function render$I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("table", _hoisted_1$H, [
    createElementVNode("colgroup", null, [
      (_ctx.flowTypeRef === 20)
        ? (openBlock(), createElementBlock("col", _hoisted_2$x))
        : createCommentVNode("v-if", true),
      _hoisted_3$r,
      _hoisted_4$k,
      _hoisted_5$g
    ]),
    createElementVNode("tbody", null, [
      _hoisted_6$b,
      createElementVNode("tr", null, [
        (_ctx.flowTypeRef === 20)
          ? (openBlock(), createElementBlock("th", _hoisted_7$a, "节点名称"))
          : createCommentVNode("v-if", true),
        _hoisted_8$9,
        _hoisted_9$8,
        _hoisted_10$6,
        _hoisted_11$6
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.approvalListRef, (item, index) => {
        return (openBlock(), createElementBlock("tr", { key: index }, [
          (_ctx.flowTypeRef === 20 && item.nodeName)
            ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: "center",
                rowspan: item.rowSpan
              }, toDisplayString(item.nodeName), 9 /* TEXT, PROPS */, _hoisted_12$6))
            : createCommentVNode("v-if", true),
          createElementVNode("td", null, toDisplayString(item.userName), 1 /* TEXT */),
          createElementVNode("td", null, toDisplayString(item.statusText), 1 /* TEXT */),
          createElementVNode("td", null, toDisplayString(item.time), 1 /* TEXT */),
          createElementVNode("td", null, toDisplayString(item.comment), 1 /* TEXT */)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}

script$O.render = render$I;
script$O.__file = "packages/approval-detail/src/ApprovalPrint.vue";

script$P.install = (Vue) => {
    Vue.component(script$P.name, script$P);
};

const changeArrayOrder = (arr, target, newIndexOfTarget) => {
    const newArr = arr.filter((e) => e.id !== target.id);
    newArr.splice(newIndexOfTarget, 0, { ...target });
    return newArr;
};
const getIdGenerator = () => {
    let num = 0;
    return () => {
        return num++;
    };
};
const throttle = (callback, limit) => {
    let waiting = false;
    return (...args) => {
        if (waiting) {
            return;
        }
        callback(...args);
        waiting = true;
        setTimeout(() => {
            waiting = false;
        }, limit);
        return;
    };
};
const draggableItemIdGenrator = getIdGenerator();
const toDraggableItems = (arr) => {
    return arr.map((e) => ({
        id: draggableItemIdGenrator(),
        data: e,
    }));
};
const toOriginalArray = (arr) => {
    return arr.map((e) => e.data);
};
const itemCurrentlyDragging = ref();
const containerIdCurrentlyDraggedOver = ref();
let transitioning = false;
const containerIdGenerator = getIdGenerator();
const useDraggableContainer = (originalItems, originalModel, context) => {
    const id = containerIdGenerator();
    const items = ref(toDraggableItems(originalItems.value));
    // update 初始值
    watch(originalItems, () => {
        items.value = toDraggableItems(originalItems.value);
    }, { deep: true });
    // update v-model when dropped
    watch(itemCurrentlyDragging, () => {
        if (itemCurrentlyDragging.value) {
            return;
        }
        context.emit('update:' + originalModel, toOriginalArray(items.value));
    });
    // case when an item is being dragged to another container
    watch(containerIdCurrentlyDraggedOver, () => {
        if (containerIdCurrentlyDraggedOver.value === id) {
            return;
        }
        items.value = items.value.filter((item) => item.id !==
            (itemCurrentlyDragging.value && itemCurrentlyDragging.value.id));
    });
    // when an item is moved to an empty container
    const onDragOver = () => {
        if (transitioning ||
            !itemCurrentlyDragging.value ||
            containerIdCurrentlyDraggedOver.value === id) {
            return;
        }
        if (items.value.length > 0) {
            return;
        }
        containerIdCurrentlyDraggedOver.value = id;
        items.value = [itemCurrentlyDragging.value];
    };
    // handle event emitted from draggableItem
    const onItemDragOver = ({ position }) => {
        if (transitioning || !itemCurrentlyDragging.value) {
            return;
        }
        items.value = changeArrayOrder(items.value, itemCurrentlyDragging.value, position);
    };
    return {
        id,
        items,
        onDragOver,
        onItemDragOver,
    };
};
const useDraggableItem = (item, position, containerId, context, direction = 'vertical') => {
    const key = direction === 'vertical'
        ? ['top', 'height', 'clientY']
        : ['left', 'width', 'clientX'];
    const draggableItemEl = ref();
    const isDragging = ref((item.value.id || null) ===
        (itemCurrentlyDragging.value && itemCurrentlyDragging.value.id)
        ? true
        : false);
    const middleXY = ref();
    onMounted(async () => {
        const box = draggableItemEl.value.getBoundingClientRect();
        middleXY.value = box[key[0]] + box[key[1]] / 2;
    });
    onUpdated(() => {
        const box = draggableItemEl.value.getBoundingClientRect();
        middleXY.value = box[key[0]] + box[key[1]] / 2;
    });
    const onDragStart = () => {
        itemCurrentlyDragging.value = item.value;
        containerIdCurrentlyDraggedOver.value = containerId.value;
        isDragging.value = true;
    };
    const onDragEnd = () => {
        itemCurrentlyDragging.value = undefined;
    };
    const onDragOver = throttle((e) => {
        if (item.value.id ===
            (itemCurrentlyDragging.value && itemCurrentlyDragging.value.id)) {
            return;
        }
        if (containerIdCurrentlyDraggedOver.value !== containerId.value) {
            containerIdCurrentlyDraggedOver.value = containerId.value;
        }
        const offset = middleXY.value - e[key[2]];
        context.emit('itemDragOver', {
            position: offset > 0 ? position.value : position.value + 1,
        });
    }, 50);
    const onDelete = () => {
        itemCurrentlyDragging.value = item.value;
        containerIdCurrentlyDraggedOver.value = -1;
        setTimeout(() => {
            itemCurrentlyDragging.value = undefined;
            containerIdCurrentlyDraggedOver.value = containerId.value;
        }, 50);
    };
    const transitionStart = () => {
        transitioning = true;
    };
    const transitionEnd = () => {
        transitioning = false;
    };
    watch(itemCurrentlyDragging, () => {
        if (itemCurrentlyDragging.value) {
            return;
        }
        isDragging.value = false;
    });
    return {
        draggableItemEl,
        isDragging,
        onDragStart,
        onDragOver,
        onDragEnd,
        transitionStart,
        transitionEnd,
        onDelete,
    };
};

var script$N = defineComponent({
    name: 'ScApproverItem',
    props: {
        node: {
            type: Object,
            default: () => ({}),
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        position: {
            type: Number,
            default: 0,
        },
        containerId: {
            type: Number,
            default: 0,
        },
        create: {
            type: [Boolean],
            default: false,
        },
        chain: {
            type: [Boolean],
            default: false,
        },
        multiple: {
            type: [Boolean],
            default: true,
        },
        draggable: {
            type: [Boolean],
            default: true,
        },
        closable: {
            type: [Boolean],
            default: true,
        },
        fieldName: {
            type: Object,
        },
    },
    components: {
        Avatar: script$R,
        CloseOutlined,
        ArrowRightOutlined,
    },
    setup(props, context) {
        const { item, position, containerId } = toRefs(props);
        const draggableItem = useDraggableItem(item, position, containerId, context, 'horizontal');
        const onCreate = () => {
            context.emit('create');
        };
        const dashedRef = computed(() => {
            let dashed = false;
            if (props.create || props.chain) {
                dashed = true;
            }
            return dashed;
        });
        const iconRef = computed(() => {
            let icon = h(UserOutlined);
            if (props.create) {
                icon = props.multiple ? h(PlusOutlined) : h(RetweetOutlined);
            }
            if (props.chain) {
                icon = h(LinkOutlined);
            }
            return icon;
        });
        const titleRef = computed(() => {
            let title = '';
            if (props.create) {
                title = props.multiple ? ' ' : '代他人提交';
            }
            if (props.chain) {
                title = '常用审批链';
            }
            return title;
        });
        return {
            ...draggableItem,
            onCreate,
            dashedRef,
            iconRef,
            titleRef,
        };
    },
});

const _hoisted_1$G = ["draggable"];
const _hoisted_2$w = {
  key: 1,
  class: "sc-approver-arrow"
};
const _hoisted_3$q = ["draggable"];
const _hoisted_4$j = {
  key: 1,
  class: "sc-approver-arrow"
};

function render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  const _component_CloseOutlined = resolveComponent("CloseOutlined");
  const _component_ArrowRightOutlined = resolveComponent("ArrowRightOutlined");

  return (_ctx.draggable)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["sc-approver-item", { isDragging: _ctx.isDragging, draggable: _ctx.draggable }]),
        "on:transitionStart": _cache[1] || (_cache[1] = (...args) => (_ctx.transitionStart && _ctx.transitionStart(...args))),
        "on:transitionEnd": _cache[2] || (_cache[2] = (...args) => (_ctx.transitionEnd && _ctx.transitionEnd(...args))),
        onDragover: _cache[3] || (_cache[3] = withModifiers((...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent","stop"])),
        onDragstart: _cache[4] || (_cache[4] = withModifiers((...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)), ["stop"])),
        onDragend: _cache[5] || (_cache[5] = withModifiers((...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)), ["stop"])),
        draggable: _ctx.draggable,
        ref: "draggableItemEl"
      }, [
        (_ctx.create || _ctx.chain)
          ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              (_ctx.create)
                ? (openBlock(), createBlock(_component_Avatar, {
                    key: 0,
                    dashed: true,
                    title: _ctx.titleRef,
                    icon: _ctx.iconRef,
                    onClick: _ctx.onCreate
                  }, null, 8 /* PROPS */, ["title", "icon", "onClick"]))
                : createCommentVNode("v-if", true),
              (_ctx.chain)
                ? (openBlock(), createBlock(_component_Avatar, {
                    key: 1,
                    dashed: true,
                    title: _ctx.titleRef,
                    icon: _ctx.iconRef,
                    onClick: _ctx.onCreate
                  }, null, 8 /* PROPS */, ["title", "icon", "onClick"]))
                : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createVNode(_component_Avatar, mergeProps({ ..._ctx.item.data }, { fieldName: _ctx.fieldName }), null, 16 /* FULL_PROPS */, ["fieldName"]),
              (_ctx.closable)
                ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: "sc-approver-close",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, [
                    createVNode(_component_CloseOutlined)
                  ]))
                : createCommentVNode("v-if", true),
              (_ctx.draggable)
                ? (openBlock(), createElementBlock("em", _hoisted_2$w, [
                    createVNode(_component_ArrowRightOutlined)
                  ]))
                : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1$G))
    : (openBlock(), createElementBlock("div", {
        key: 1,
        class: "sc-approver-item",
        draggable: _ctx.draggable,
        ref: "draggableItemEl"
      }, [
        (_ctx.create || _ctx.chain)
          ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              (_ctx.create)
                ? (openBlock(), createBlock(_component_Avatar, {
                    key: 0,
                    dashed: true,
                    title: _ctx.titleRef,
                    icon: _ctx.iconRef,
                    onClick: _ctx.onCreate
                  }, null, 8 /* PROPS */, ["title", "icon", "onClick"]))
                : createCommentVNode("v-if", true),
              (_ctx.chain)
                ? (openBlock(), createBlock(_component_Avatar, {
                    key: 1,
                    dashed: true,
                    title: _ctx.titleRef,
                    icon: _ctx.iconRef,
                    onClick: _ctx.onCreate
                  }, null, 8 /* PROPS */, ["title", "icon", "onClick"]))
                : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createVNode(_component_Avatar, mergeProps({ ..._ctx.item.data }, { fieldName: _ctx.fieldName }), null, 16 /* FULL_PROPS */, ["fieldName"]),
              (_ctx.closable)
                ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: "sc-approver-close",
                    onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, [
                    createVNode(_component_CloseOutlined)
                  ]))
                : createCommentVNode("v-if", true),
              (_ctx.draggable)
                ? (openBlock(), createElementBlock("em", _hoisted_4$j, [
                    createVNode(_component_ArrowRightOutlined)
                  ]))
                : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ], 8 /* PROPS */, _hoisted_3$q))
}

script$N.render = render$H;
script$N.__file = "packages/approver/src/components/ApproverItem.vue";

var script$M = defineComponent({
    name: 'ScApprover',
    props: {
        title: {
            type: String,
            default: '',
        },
        nodes: {
            type: Array,
            default: () => [],
        },
        create: {
            type: [Boolean],
            default: true,
        },
        chain: {
            type: [Boolean],
            default: false,
        },
        multiple: {
            type: [Boolean],
            default: true,
        },
        draggable: {
            type: [Boolean],
            default: true,
        },
        closable: {
            type: [Boolean],
            default: true,
        },
        fieldName: {
            type: Object,
            default: () => ({ title: 'title', char: 'char', src: 'src' }),
        },
    },
    components: {
        ApproverItem: script$N,
    },
    setup(props, context) {
        const { nodes } = toRefs(props);
        const draggableContainer = useDraggableContainer(nodes, 'nodes', context);
        const onCreateNode = () => {
            context.emit('create');
        };
        const onApprovalChain = () => {
            context.emit('chain');
        };
        return { ...draggableContainer, onCreateNode, onApprovalChain };
    },
});

const _hoisted_1$F = { class: "sc-approver" };

function render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ApproverItem = resolveComponent("ApproverItem");

  return (openBlock(), createElementBlock("div", _hoisted_1$F, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
      return (openBlock(), createBlock(_component_ApproverItem, {
        item: item,
        key: item.id,
        containerId: _ctx.id,
        position: index,
        fieldName: _ctx.fieldName,
        onItemDragOver: _ctx.onItemDragOver,
        onDragenter: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
        draggable: _ctx.draggable,
        closable: item.data.closable !== false && _ctx.closable
      }, null, 8 /* PROPS */, ["item", "containerId", "position", "fieldName", "onItemDragOver", "draggable", "closable"]))
    }), 128 /* KEYED_FRAGMENT */)),
    (_ctx.create)
      ? (openBlock(), createBlock(_component_ApproverItem, {
          key: 0,
          create: _ctx.create,
          multiple: _ctx.multiple,
          onCreate: _ctx.onCreateNode,
          draggable: false,
          class: "sc-approver-click"
        }, null, 8 /* PROPS */, ["create", "multiple", "onCreate"]))
      : createCommentVNode("v-if", true),
    (_ctx.chain)
      ? (openBlock(), createBlock(_component_ApproverItem, {
          key: 1,
          chain: _ctx.chain,
          onCreate: _ctx.onApprovalChain,
          draggable: false,
          class: "sc-approver-click"
        }, null, 8 /* PROPS */, ["chain", "onCreate"]))
      : createCommentVNode("v-if", true)
  ]))
}

script$M.render = render$G;
script$M.__file = "packages/approver/src/Approver.vue";

script$M.install = (Vue) => {
    Vue.component(script$M.name, script$M);
};

function filterOption(keyword, option) {
    return (option.children[0].children.toLowerCase().indexOf(keyword.toLowerCase()) >=
        0);
}
const departmentList = ref([]);
const roleList = ref([]);
const rowData = ref([]);
async function getDepartmentList() {
    const data = await fetchDepartmentList();
    departmentList.value = data;
}
async function getRoleList() {
    const data = await fetchRoleList();
    roleList.value = data;
}
async function getEmployeeInfoList(param) {
    const data = await fetchEmployeeList(param);
    data.forEach((e, i) => {
        if (e.roleDtoList && e.roleDtoList.length) {
            e.indexNo = i + 1;
            e.roleNameStr = e.roleDtoList.map((e) => e.name).join(',');
        }
    });
    rowData.value = data;
}
const useSearchForm = () => {
    getRoleList();
    getDepartmentList();
    const advanceSearchItems = reactive([
        {
            key: 'departmentId',
            type: 'TreeSelect',
            label: '部门',
            placeholder: '员工所在部门',
            options: departmentList,
            istop: true,
            width: '130px',
            props: {
                allowClear: true,
                showSearch: true,
                treeNodeFilterProp: 'title',
                class: 'departmentId-tree',
            },
        },
        {
            key: 'roleId',
            label: '角色',
            type: 'Select',
            width: '130px',
            istop: true,
            placeholder: '全部角色',
            options: roleList,
            props: {
                allowClear: true,
                showSearch: true,
                filterOption,
            },
        },
        {
            key: 'employeeName',
            type: 'Input',
            label: '员工姓名',
            placeholder: `请输入登录名/姓名`,
            width: '130px',
            istop: true,
        },
    ]);
    const onSearch = (val) => {
        const { keywords } = val;
        delete keywords._searchOptions;
        keywords.roleId == -1 ? null : keywords.roleId;
        keywords.pageIndex = 1;
        keywords.pageSize = 200;
        getEmployeeInfoList(keywords);
    };
    return {
        advanceSearchItems,
        onSearch,
        rowData,
    };
};

var script$L = defineComponent({
    name: 'ScEmployeeCard',
    props: {
        title: {
            type: String,
            default: '',
        },
        closable: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }) {
        return {};
    },
});

const _hoisted_1$E = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont icon-persion",
  "data-extend": "icon-geren",
  innerHTML: ''
}, null, -1 /* HOISTED */);

function render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tooltip = resolveComponent("a-tooltip");
  const _component_a_tag = resolveComponent("a-tag");

  return (openBlock(), createBlock(_component_a_tag, {
    class: "sc-employee-item",
    closable: _ctx.closable
  }, createSlots({
    icon: withCtx(() => [
      _hoisted_1$E
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.title.length < 5)
      ? {
          name: "default",
          fn: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.title), 1 /* TEXT */)
          ]),
          key: "0"
        }
      : {
          name: "default",
          fn: withCtx(() => [
            createVNode(_component_a_tooltip, {
              class: "sc-employee-card",
              placement: "top",
              title: _ctx.title
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.title), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"])
          ]),
          key: "1"
        }
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["closable"]))
}

script$L.render = render$F;
script$L.__file = "packages/employee-modal/src/components/EmployeeCard.vue";

var script$K = defineComponent({
    name: 'ScEmployeeModal',
    components: { Modal: script$1N, SearchForm: script$X, InnerGrid: script$18, EmployeeCard: script$L },
    props: {
        // 弹窗开启关闭
        visible: {
            type: [Boolean],
            default: false,
        },
        // 选中的员工值，双向绑定
        value: {
            type: Array,
            default: () => [],
        },
        // 表格索引字段
        indexField: {
            type: String,
            default: 'userId',
        },
        // 员工卡片显示列数，默认1列，最多2列
        isSingleColumn: {
            type: [Boolean],
            default: true,
        },
        // 单选多选模式
        isMultiSelect: {
            type: [Boolean],
            default: true,
        },
    },
    setup(props, context) {
        const { value, visible } = toRefs(props);
        // 表单
        const searchForm = useSearchForm();
        // 表格
        const columnDefs = [
            {
                field: 'indexNo',
                headerName: '序号',
            },
            {
                field: 'realName',
                headerName: '姓名',
                flex: 1,
            },
            {
                field: 'roleNameStr',
                headerName: '角色',
                flex: 1,
            },
            {
                field: 'departmentName',
                headerName: '部门',
                flex: 1,
            },
        ];
        const innerGrid = useInnerGrid$1(columnDefs, visible, value, props.indexField, props.isMultiSelect, context);
        return { ...searchForm, ...innerGrid };
    },
});

const _hoisted_1$D = { class: "sc-employee-modal" };
const _hoisted_2$v = { class: "sc-employee-box" };
const _hoisted_3$p = { class: "sc-employee-num" };

function render$E(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchForm = resolveComponent("SearchForm");
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_divider = resolveComponent("a-divider");
  const _component_EmployeeCard = resolveComponent("EmployeeCard");
  const _component_a_row = resolveComponent("a-row");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createElementBlock("div", _hoisted_1$D, [
    createVNode(_component_Modal, mergeProps({
      visible: _ctx.visibleRef,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
      width: _ctx.isSingleColumn ? '820px' : '944px'
    }, { ..._ctx.$attrs }, { onOk: _ctx.handleOk }), {
      default: withCtx(() => [
        createVNode(_component_a_row, {
          type: "flex",
          align: "top"
        }, {
          default: withCtx(() => [
            createVNode(_component_a_col, {
              flex: "634px",
              class: "sc-employee-table"
            }, {
              default: withCtx(() => [
                createVNode(_component_SearchForm, {
                  isShowTab: false,
                  isHideAdvancedSearch: true,
                  isInline: true,
                  isShowAllSearch: true,
                  noSaveBtn: true,
                  isHideTags: true,
                  advanceSearchItems: _ctx.advanceSearchItems,
                  onOnSearch: _ctx.onSearch
                }, null, 8 /* PROPS */, ["advanceSearchItems", "onOnSearch"]),
                createVNode(_component_InnerGrid, {
                  columnDefs: _ctx.columnDefs,
                  rowData: _ctx.rowData,
                  gridDefs: _ctx.gridDefs,
                  onRowSelected: _ctx.onRowSelected,
                  onRowDataChanged: _ctx.onRowDataChanged,
                  maxHeight: "330px",
                  ref: "gridRef",
                  indexField: _ctx.indexField
                }, null, 8 /* PROPS */, ["columnDefs", "rowData", "gridDefs", "onRowSelected", "onRowDataChanged", "indexField"])
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_a_col, {
              flex: "auto",
              class: "sc-employee-selected"
            }, {
              default: withCtx(() => [
                createVNode(_component_a_divider, { type: "vertical" }),
                createElementVNode("div", _hoisted_2$v, [
                  createElementVNode("div", _hoisted_3$p, " 已选择 " + toDisplayString(_ctx.selectedValueRef.length) + " 人 ", 1 /* TEXT */),
                  createElementVNode("div", {
                    class: normalizeClass(["sc-employee-items", _ctx.isSingleColumn ? 'is-single' : 'is-diallel'])
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedValueRef, (item, index) => {
                      return (openBlock(), createBlock(_component_EmployeeCard, {
                        closable: item.closable,
                        key: index,
                        title: item.realName,
                        onClose: $event => (_ctx.onClose(item[_ctx.indexField]))
                      }, null, 8 /* PROPS */, ["closable", "title", "onClose"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["visible", "width", "onOk"])
  ]))
}

script$K.render = render$E;
script$K.__file = "packages/employee-modal/src/EmployeeModal.vue";

script$K.install = (Vue) => {
    Vue.component(script$K.name, script$K);
};

var script$J = defineComponent({
    name: 'ScApprovalProcess',
    components: {
        Approver: script$M,
        EmployeeModal: script$K,
        ApprovalChainModal: script$T,
    },
    props: {
        labelCol: {
            type: [String, Number],
            default: '100px',
        },
        wrapperCol: {
            type: [String, Number],
            default: 'auto',
        },
        value: {
            type: Object,
            default: () => ({}),
        },
        flowId: {
            type: Number,
            default: 0,
        },
        referenceNo: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit }) {
        const isMultiSelectRef = ref(true);
        const valueRef = computed({
            get: () => props.value,
            set: (val) => {
                emit('update:value', val);
            },
        });
        // 自由模式
        const apporvalProcessFree = [
            {
                title: '发起人',
                type: 'initiator',
                draggable: false,
                closable: false,
                multiple: false,
                create: true,
                chain: true,
            },
            {
                title: '中间审批人',
                type: 'approver',
            },
            {
                title: '最终审批人',
                type: 'final',
                draggable: false,
                closable: false,
                multiple: false,
                create: false,
            },
            {
                title: '抄送人',
                type: 'cc',
                draggable: false,
            },
        ];
        const apporvalProcessFixed = [
            {
                title: '发起人',
                type: 'initiator',
                draggable: false,
                closable: false,
                multiple: false,
                create: true,
                chain: false,
            },
        ];
        const apporvalProcess = [];
        // 选择员工雇员
        const visibleRef = ref(false);
        const modalTitleRef = ref('');
        const modalValueRef = ref([]);
        const currRef = ref('initiator');
        const openEmployeeModal = (type, isMultiSelect) => {
            visibleRef.value = true;
            isMultiSelectRef.value = isMultiSelect === undefined;
            modalValueRef.value = valueRef.value[type];
            const process = apporvalProcess.find((e) => e.type === type);
            modalTitleRef.value = '选择' + ((process && process.title) || '员工');
            currRef.value = type;
        };
        // 选择员工
        const onEmployeeSelected = (value) => {
            // 代他人发起，显示代发
            const extra = currRef.value === 'initiator' ? '(代发)' : '';
            valueRef.value[currRef.value] = value.map((e) => ({
                realName: e.realName + extra,
                userId: e.userId,
                closable: e.closable,
            }));
        };
        const fieldName = {
            title: 'realName',
            src: 'src',
        };
        // 常用审批链弹窗
        const chainModalVisibleRef = ref(false);
        const chainModalTitleRef = ref('');
        const chainModalParamsRef = ref({
            flowId: 0,
            initiatorId: 0,
            initiatorName: '',
            finalApproverName: '',
            finalApproverId: 0,
        });
        const openApprovalChainModal = () => {
            chainModalVisibleRef.value = true;
            chainModalTitleRef.value = '常用审批链';
        };
        // 去重
        const unique = (arr) => {
            let res = new Set();
            return arr.filter((item) => {
                if (res.has(item.userId)) {
                    return false;
                }
                else {
                    res.add(item.userId);
                    return true;
                }
            });
        };
        // 选择审批链
        const onChainSelected = (value) => {
            const flowType = valueRef.value.flowType;
            if (value[0]) {
                const cc = unique([
                    ...valueRef.value.cc.filter((v) => v.closable === false),
                    ...value[0].process.cc,
                ]);
                valueRef.value = { ...value[0].process, flowType, cc };
            }
        };
        // 自由模式
        const initFreeApproval = (data) => {
            if (data.flowNodeDtos && data.flowNodeDtos[0]) {
                const { finalApproverId, finalApproverName, flowNodeCcDtos, flowNodeApproverDtos, } = data.flowNodeDtos[0];
                const { id, realName } = getUserInfo();
                apporvalProcess.push(...apporvalProcessFree);
                chainModalParamsRef.value = {
                    flowId: props.flowId,
                    initiatorId: id,
                    initiatorName: realName,
                    finalApproverName,
                    finalApproverId,
                };
                const cc = (flowNodeCcDtos || []).map((e) => ({
                    userId: e.userId,
                    realName: e.realname,
                    closable: false,
                }));
                // 去掉最终审批人-以及顺序
                const approver = (flowNodeApproverDtos || []).map((e) => ({
                    userId: e.userId,
                    realName: e.realname,
                }));
                return {
                    initiator: [{ userId: id, realName, closable: false }],
                    approver,
                    final: [{ userId: finalApproverId, realName: finalApproverName }],
                    cc,
                    flowType: data.flowType,
                };
            }
            return {};
        };
        // 固定模式
        const initFixedApproval = (data) => {
            if (data.flowNodeDtos && data.flowNodeDtos[0]) {
                const { id, realName } = getUserInfo();
                apporvalProcess.splice(0);
                apporvalProcess.push(...apporvalProcessFixed);
                return {
                    initiator: [{ userId: id, realName, closable: false }],
                    approver: [],
                    final: [],
                    cc: [],
                    flowType: data.flowType,
                };
            }
            return {};
        };
        // 通过flowId 初始化数据
        watch(() => props.flowId, (flowId) => {
            flowId &&
                fetchApprovalInfo({ flowId }).then((data) => {
                    if (data.status === 20) {
                        if (data.flowType === 10) {
                            valueRef.value = initFreeApproval(data);
                        }
                        else if (data.flowType === 20) {
                            valueRef.value = initFixedApproval(data);
                        }
                    }
                });
        }, { immediate: true });
        return {
            valueRef,
            visibleRef,
            modalValueRef,
            modalTitleRef,
            isMultiSelectRef,
            openEmployeeModal,
            fieldName,
            onEmployeeSelected,
            apporvalProcess,
            openApprovalChainModal,
            chainModalVisibleRef,
            chainModalTitleRef,
            onChainSelected,
            chainModalParamsRef,
        };
    },
});

const _hoisted_1$C = { class: "sc-approval-process" };

function render$D(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_col = resolveComponent("a-col");
  const _component_Approver = resolveComponent("Approver");
  const _component_a_row = resolveComponent("a-row");
  const _component_EmployeeModal = resolveComponent("EmployeeModal");
  const _component_ApprovalChainModal = resolveComponent("ApprovalChainModal");

  return (openBlock(), createElementBlock("div", _hoisted_1$C, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.apporvalProcess, (p, index) => {
      return (openBlock(), createBlock(_component_a_row, {
        key: index,
        type: "flex"
      }, {
        default: withCtx(() => [
          createVNode(_component_a_col, {
            flex: _ctx.labelCol,
            class: "sc-approval-label"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(p.title), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["flex"]),
          createVNode(_component_a_col, { flex: _ctx.wrapperCol }, {
            default: withCtx(() => [
              createVNode(_component_Approver, {
                nodes: _ctx.valueRef[p.type],
                "onUpdate:nodes": $event => ((_ctx.valueRef[p.type]) = $event),
                onCreate: $event => (_ctx.openEmployeeModal(p.type, p.multiple)),
                onChain: _ctx.openApprovalChainModal,
                fieldName: _ctx.fieldName,
                draggable: p.draggable,
                closable: p.closable,
                create: p.create,
                chain: p.chain,
                multiple: p.multiple
              }, null, 8 /* PROPS */, ["nodes", "onUpdate:nodes", "onCreate", "onChain", "fieldName", "draggable", "closable", "create", "chain", "multiple"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["flex"])
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */)),
    (_ctx.visibleRef)
      ? (openBlock(), createBlock(_component_EmployeeModal, {
          key: 0,
          visible: _ctx.visibleRef,
          "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
          title: _ctx.modalTitleRef,
          value: _ctx.modalValueRef,
          isMultiSelect: _ctx.isMultiSelectRef,
          isSingleColumn: !_ctx.isMultiSelectRef,
          onSubmit: _ctx.onEmployeeSelected
        }, null, 8 /* PROPS */, ["visible", "title", "value", "isMultiSelect", "isSingleColumn", "onSubmit"]))
      : createCommentVNode("v-if", true),
    (_ctx.chainModalVisibleRef)
      ? (openBlock(), createBlock(_component_ApprovalChainModal, {
          key: 1,
          visible: _ctx.chainModalVisibleRef,
          "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.chainModalVisibleRef) = $event)),
          title: _ctx.chainModalTitleRef,
          params: _ctx.chainModalParamsRef,
          onSubmit: _ctx.onChainSelected
        }, null, 8 /* PROPS */, ["visible", "title", "params", "onSubmit"]))
      : createCommentVNode("v-if", true)
  ]))
}

script$J.render = render$D;
script$J.__file = "packages/approval-process/src/ApprovalProcess.vue";

script$J.install = (Vue) => {
    Vue.component(script$J.name, script$J);
};

if (!Array.prototype.remove) {
    Array.prototype.remove = function (o) {
        const index = this.indexOf(o);
        if (index > -1) {
            this.splice(index, 1);
        }
    };
}
var script$I = defineComponent({
    name: 'ScCityPicker',
    components: { MultipleCascader: script$1A },
    props: {
        string: {
            type: String,
            default: '',
        },
        boolean: {
            type: [Boolean],
            default: false,
        },
        array: {
            type: Array,
            default: () => [],
        },
        citiesValue: {
            type: Object,
            default: () => ({}),
        },
        function: {
            type: Object,
            default: () => null,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    setup(props, { emit }) {
        const areaTreeData = ref([]);
        let areaData = [];
        let cityData = [];
        const areaValueRef = ref([]);
        const cityValueRef = computed(() => {
            nextTick(updateAreaTreeData);
            return props.value;
        });
        const indeValueRef = ref([]);
        const initAreaData = async () => {
            // areaData = await fetchBigAreaList();
            cityData = await fetchCitiesList();
            initAreaTreeData();
            updateAreaTreeData();
        };
        onBeforeMount(initAreaData);
        const isChecked = (codes) => {
            for (let i = 0; i < codes.length; i++) {
                if (cityValueRef.value.includes(codes[i]))
                    return true;
            }
            return false;
        };
        // 初始化大区-省份-城市结构数
        // 输出areaTreeData
        const initAreaTreeData = () => {
            areaData.forEach((area) => {
                area.code = area.id;
                area.checked = false;
                area.indeterminate = false;
                area.children.forEach((province) => {
                    province.value = province.code;
                    province.checked = false;
                    province.indeterminate = false;
                });
            });
            areaTreeData.value = areaData;
            const province = {};
            const cities = {};
            cityData.map((city) => {
                city.checked = false;
                city.indeterminate = false;
                city.value = city.code;
                if (city.level === 2) {
                    if (!province[city.parentCode])
                        province[city.parentCode] = [];
                    province[city.parentCode].push(city);
                }
                else if (city.level === 3) {
                    if (!cities[city.parentCode])
                        cities[city.parentCode] = [];
                    cities[city.parentCode].push(city);
                }
            });
            Object.keys(province).map((code) => {
                province[code].forEach((city) => {
                    city.children = cities[city.code];
                });
            });
            areaTreeData.value.forEach((area) => {
                area.children.forEach((prov) => {
                    prov.children = province[prov.code];
                });
            });
        };
        const updateAreaTreeData = () => {
            if (!areaTreeData.value || !cityValueRef.value)
                return;
            initAreaCheckedValue();
            const deepForEach = (arr, parentsCode) => {
                arr.forEach((item) => {
                    item.checked = isChecked([...parentsCode, item.code]);
                    item.indeterminate = indeValueRef.value.includes(item.code);
                    item.children &&
                        deepForEach(item.children, [...parentsCode, item.code]);
                });
            };
            areaTreeData.value.forEach((item) => {
                item.checked = areaValueRef.value.includes(item.code);
                item.indeterminate = indeValueRef.value.includes(item.code);
                item.children && deepForEach(item.children, [item.code]);
            });
            emit('update:value', cityValueRef.value);
            emit('update:citiesValue', treeCities());
        };
        // 过滤删除自己和子集城市
        const arrayFilter = (data, code, pow) => {
            const num = Math.pow(100, pow);
            const codeMin = Math.floor(code / num) * num;
            const codeMax = codeMin + num;
            return data.filter((e) => e < codeMin || e >= codeMax);
        };
        // 计算选中值所在的省市
        // pow = 2: 省, 1: 市
        const indeCalc = (pow) => {
            const num = Math.pow(100, pow);
            const isCity = (d) => d % 10000 > 0 && d % 100 === 0;
            const isCounty = (d) => d % 100 > 0;
            const dataFilter = pow === 2
                ? cityValueRef.value.filter((e) => isCity(e))
                : cityValueRef.value.filter((e) => isCounty(e));
            return [...new Set(dataFilter.map((e) => Math.floor(e / num) * num))];
        };
        // 初始化大区的选择和半选状态
        // 输出 areaValueRef indeValueRef
        const initAreaCheckedValue = () => {
            areaValueRef.value.length = 0;
            // 半选的城市
            const indeArr = indeCalc(1);
            // 半选的省份
            const indeArr2 = [
                ...new Set([
                    ...indeCalc(2),
                    ...indeArr.map((e) => Math.floor(e / 10000) * 10000),
                ]),
            ];
            indeValueRef.value = [...indeArr2, ...indeArr];
            const isProvince = (d) => d % 10000 === 0;
            const dataProvince = cityValueRef.value.filter((e) => isProvince(e));
            const indeProvince = indeValueRef.value.filter((e) => isProvince(e));
            let areaIndeter = [];
            for (let i = 0; i < areaData.length; i++) {
                const area = areaData[i];
                let len = 0;
                for (let j = 0; j < area.children.length; j++) {
                    const item = area.children[j];
                    if (dataProvince.includes(item.code)) {
                        areaIndeter.push(item.parentCode);
                        len++;
                    }
                    else if (indeProvince.includes(item.code)) {
                        areaIndeter.push(item.parentCode);
                    }
                }
                if (len === area.children.length) {
                    areaValueRef.value.push(area.id);
                }
            }
            areaIndeter = areaIndeter.filter((e) => !areaValueRef.value.includes(e));
            if (areaIndeter.length > 0)
                indeValueRef.value.unshift(...areaIndeter);
        };
        // 返回结构化选中城市数据
        const treeCities = () => {
            const getNameByCode = (d) => {
                const city = cityData.find((it) => it.code === d);
                return city && city.name;
            };
            const isProvince = (d) => d % 10000 === 0;
            // 非严格判断, 严格判断还有限制 (d % 10000 > 0)
            const isCity = (d) => d % 100 === 0;
            const isCounty = (d) => d % 100 > 0;
            const tree = {};
            cityValueRef.value.map((e) => {
                // 判断是否省份
                if (isProvince(e)) {
                    tree[e] = { code: e, level: 1, name: getNameByCode(e) };
                    return;
                }
                // 判断是否城市; 省份数据上面已经消return了。
                if (isCity(e)) {
                    const i = Math.floor(e / 10000) * 10000;
                    if (!tree[i])
                        tree[i] = {
                            code: i,
                            level: 1,
                            name: getNameByCode(i),
                            children: {},
                        };
                    tree[i]['children'][e] = {
                        code: e,
                        level: 2,
                        name: getNameByCode(e),
                    };
                    return;
                }
                //是否县城
                if (isCounty(e)) {
                    const i = Math.floor(e / 10000) * 10000;
                    const j = Math.floor(e / 100) * 100;
                    if (!tree[i])
                        tree[i] = {
                            code: i,
                            level: 1,
                            name: getNameByCode(i),
                            children: {},
                        };
                    if (!tree[i]['children'][j])
                        tree[i]['children'][j] = {
                            code: j,
                            level: 2,
                            name: getNameByCode(j),
                            children: {},
                        };
                    tree[i]['children'][j]['children'][e] = {
                        code: e,
                        level: 3,
                        name: getNameByCode(e),
                    };
                }
            });
            return tree;
        };
        const onChangeBigArea = (area, event) => {
            const checked = event && event.target && event.target.checked;
            const id = event && event.target && event.target.value;
            const cities = area.children.map((it) => it.code);
            area.indeterminate = false;
            // 删除所有children - cities
            // 清除所有children 的 indeterminate
            area.children.forEach((item) => {
                item.checked = checked;
                item.indeterminate = false;
                const filter = arrayFilter(cityValueRef.value, item.code, 2);
                cityValueRef.value.length = 0;
                cityValueRef.value.push(...filter);
                indeValueRef.value = arrayFilter(indeValueRef.value, item.code, 2);
            });
            // 插入和删除city
            if (checked) {
                indeValueRef.value.remove(id);
                areaValueRef.value.push(id);
                const filter = cities.filter((it) => !cityValueRef.value.includes(it));
                cityValueRef.value.push(...filter);
            }
            else {
                areaValueRef.value.remove(id);
                const filter = cityValueRef.value.filter((it) => !cities.includes(it));
                cityValueRef.value.length = 0;
                cityValueRef.value.push(...filter);
            }
            updateAreaTreeData();
        };
        const onChangeCity = () => {
            updateAreaTreeData();
        };
        return {
            areaTreeData,
            indeValueRef,
            areaValueRef,
            cityValueRef,
            onChangeBigArea,
            onChangeCity,
        };
    },
});

const _hoisted_1$B = { class: "sc-city-picker" };
const _hoisted_2$u = { class: "area" };

function render$C(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_col = resolveComponent("a-col");
  const _component_MultipleCascader = resolveComponent("MultipleCascader");
  const _component_a_row = resolveComponent("a-row");

  return (openBlock(), createElementBlock("div", _hoisted_1$B, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.areaTreeData, (area) => {
      return (openBlock(), createBlock(_component_a_row, {
        type: "flex",
        align: "middle",
        key: area.code,
        class: "sc-city-picker-row"
      }, {
        default: withCtx(() => [
          createVNode(_component_a_col, { span: 4 }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2$u, [
                createVNode(_component_a_checkbox, {
                  checked: area.checked,
                  "onUpdate:checked": $event => ((area.checked) = $event),
                  indeterminate: area.indeterminate,
                  value: area.code,
                  onChange: $event => (_ctx.onChangeBigArea(area, $event))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(area.name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["checked", "onUpdate:checked", "indeterminate", "value", "onChange"])
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */),
          (openBlock(true), createElementBlock(Fragment, null, renderList(area.children, (province, index) => {
            return (openBlock(), createBlock(_component_a_col, {
              span: 4,
              key: index,
              type: "flex"
            }, {
              default: withCtx(() => [
                createVNode(_component_MultipleCascader, {
                  value: _ctx.cityValueRef,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.cityValueRef) = $event)),
                  options: [province],
                  onChange: _ctx.onChangeCity,
                  multiple: true,
                  checkAll: true
                }, null, 8 /* PROPS */, ["value", "options", "onChange"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}

script$I.render = render$C;
script$I.__file = "packages/city-picker/src/CityPicker.vue";

script$I.install = (Vue) => {
    Vue.component(script$I.name, script$I);
};

const stopPropagation = e => e.stopPropagation();
var script$H = defineComponent({
  name: 'ScCollapse',
  components: {
    Collapse
  },
  props: {
    bordered: {
      type: [Boolean],
      default: true
    },
    accordion: {
      type: [Boolean],
      default: false
    },
    destroyInactivePanel: {
      type: [Boolean],
      default: false
    },
    panels: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: [Boolean],
      default: false
    },
    isBigTitle: {
      type: [Boolean],
      default: false
    },
    isArrowed: {
      type: [Boolean],
      default: false
    },
    column: {
      type: Number,
      default: 1
    }
  },
  setup(props, {
    emit,
    slots
  }) {
    const collapsePanelNode = props.panels.map((panel, key) => {
      const slots = {
        header: () => createVNode("div", {
          "class": "sc-collapse-header"
        }, [createVNode("span", {
          "class": "sc-collapse-main-header"
        }, [panel.header]), createVNode("span", {
          "class": "sc-collapse-sub-header"
        }, [panel.subHeader]), createVNode("div", {
          "class": "sc-collapse-header-btn"
        }, [panel && panel.buttons && panel.buttons.map(item => {
          return withDirectives(createVNode(resolveComponent("a-button"), {
            "onClick": e => {
              item.onClick && item.onClick(item);
              e.stopPropagation();
            },
            "className": item.className || '',
            "type": item.type
          }, {
            default: () => [createVNode("i", {
              "class": "iconfont",
              "innerHTML": item.icon
            }, null), item.text]
          }), [[vShow, item.show && item.show()]]);
        })]), createVNode("div", {
          "class": "blank-placeholder",
          "onClick": stopPropagation
        }, null)]),
        extra: () => createVNode(Fragment, null, null)
      };
      return createVNode(Collapse.Panel, {
        "key": panel.key || key.toString(),
        "class": panel.header ? '' : ' sc-collapse-no-header',
        "collapsible": props.disabled || panel.disabled || false ? 'disabled' : ''
      }, {
        default: () => [createVNode(panel.component, panel.props, null)],
        ...slots
      });
    });
    const activeKeyRef = computed({
      get: () => props.activeKey,
      set: val => {
        emit('update:activeKey', val);
      }
    });
    const onChange = val => {
      emit('change', val);
    };
    return () => createVNode(Collapse, {
      "class": 'sc-collapse' + (props.isArrowed ? ' sc-collapse-showArrow' : '') + (props.isBigTitle ? ' sc-collapse-big-header' : '') + (props.column >= 2 && props.column <= 6 ? ' sc-collapse-cols cols-' + props.column : ''),
      'activeKey': activeKeyRef.value,
      "onUpdate:activeKey": $event => activeKeyRef.value = $event,
      "bordered": props.bordered || false,
      "accordion": props.accordion,
      "expandIconPosition": props.isArrowed ? 'left' : 'right',
      "destroyInactivePanel": props.accordion,
      "onChange": onChange
    }, {
      default: () => [collapsePanelNode, slots.default && slots.default()]
    });
  }
});

script$H.__file = "packages/collapse/Collapse.vue";

var script$G = defineComponent({
    name: 'ScCollapsePanel',
    props: {
        header: {
            type: String,
            default: '',
        },
        subHeader: {
            type: String,
            default: '',
        },
        key: {
            type: String,
            default: '',
        },
        buttons: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        return {};
    },
});

const _hoisted_1$A = { class: "sc-collapse-header" };
const _hoisted_2$t = { class: "sc-collapse-main-header" };
const _hoisted_3$o = { class: "sc-collapse-sub-header" };
const _hoisted_4$i = ["innerHTML"];

function render$B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");
  const _component_a_collapse_panel = resolveComponent("a-collapse-panel");

  return (openBlock(), createBlock(_component_a_collapse_panel, mergeProps({
    class: ["sc-collapse-panel", _ctx.header ? '' : ' sc-collapse-no-header']
  }, {
      ..._ctx.$props,
      ..._ctx.$attrs,
      ..._ctx.$slots,
      header: undefined,
      extra: undefined,
    }), {
    header: withCtx(() => [
      createElementVNode("div", _hoisted_1$A, [
        createElementVNode("span", _hoisted_2$t, toDisplayString(_ctx.header), 1 /* TEXT */),
        createElementVNode("span", _hoisted_3$o, toDisplayString(_ctx.subHeader), 1 /* TEXT */),
        createElementVNode("div", {
          class: "sc-collapse-header-btn",
          onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.buttons, (item, index) => {
            return withDirectives((openBlock(), createBlock(_component_a_button, {
              key: index,
              onClick: item.onClick,
              type: item.type,
              class: normalizeClass(item.className || '')
            }, {
              default: withCtx(() => [
                (item.icon)
                  ? (openBlock(), createElementBlock("i", {
                      key: 0,
                      class: "iconfont",
                      innerHTML: item.icon
                    }, null, 8 /* PROPS */, _hoisted_4$i))
                  : createCommentVNode("v-if", true),
                createTextVNode(toDisplayString(item.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "type", "class"])), [
              [vShow, item.show && item.show()]
            ])
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        renderSlot(_ctx.$slots, "extra"),
        createElementVNode("div", {
          class: "blank-placeholder",
          onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"]))
        })
      ])
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["class"]))
}

script$G.render = render$B;
script$G.__file = "packages/collapse/CollapsePanel.vue";

script$H.install = (Vue) => {
    Vue.component(script$H.name, script$H);
    Vue.component(script$G.name, script$G);
};

/**
 * 四种颜色选择器组件
 * FkColorPicker, PopuColorPicker, ChromeColorPicker, EleColorPicker
 */
var script$F = defineComponent({
    name: 'ScColorPicker',
    components: { FkColorPicker },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: '#0070cc',
        },
        placement: {
            type: String,
            default: 'bottom',
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = ref(props.visible || false);
        // 颜色值
        const colorRef = computed({
            get: () => props.color,
            set: (val) => {
                emit('update:color', val);
            },
        });
        // 点击颜色块显示/隐藏弹框
        const handleVisible = () => {
            visibleRef.value = !visibleRef.value;
        };
        // 关闭弹框
        const hideColorPicker = () => {
            visibleRef.value = false;
        };
        onMounted(() => {
            // 点击空白关闭弹框
            document.addEventListener('click', hideColorPicker);
            emit('change', colorRef.value);
        });
        // 颜色块显示颜色
        const showColorRef = ref(colorRef.value);
        // 颜色改变回调
        const handleChange = (color) => {
            showColorRef.value = color.hex;
            emit('change', color);
        };
        // 颜色值复制添加提示
        const handleClick = (ev) => {
            if (ev.target.className == 'copy-btn') {
                message.success('颜色值复制成功');
            }
            ev.stopPropagation();
        };
        return {
            visibleRef,
            colorRef,
            showColorRef,
            handleVisible,
            handleChange,
            handleClick,
        };
    },
});

const _hoisted_1$z = { class: "sc-color-picker" };

function render$A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FkColorPicker = resolveComponent("FkColorPicker");

  return (openBlock(), createElementBlock("div", _hoisted_1$z, [
    createElementVNode("div", {
      class: normalizeClass(`color-block placement-${_ctx.$props.placement || 'bottom'}`),
      onClick: [
        _cache[1] || (_cache[1] = (...args) => (_ctx.handleVisible && _ctx.handleVisible(...args))),
        _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"]))
      ]
    }, [
      createElementVNode("span", {
        class: "color-block-inner",
        style: normalizeStyle({ backgroundColor: _ctx.showColorRef })
      }, null, 4 /* STYLE */),
      withDirectives(createVNode(_component_FkColorPicker, {
        color: _ctx.colorRef,
        "onUpdate:color": _cache[0] || (_cache[0] = $event => ((_ctx.colorRef) = $event)),
        onClick: _ctx.handleClick,
        onChange: _ctx.handleChange
      }, null, 8 /* PROPS */, ["color", "onClick", "onChange"]), [
        [vShow, _ctx.visibleRef]
      ])
    ], 2 /* CLASS */)
  ]))
}

script$F.render = render$A;
script$F.__file = "packages/color-picker/src/ColorPicker.vue";

script$F.install = (Vue) => {
    Vue.component(script$F.name, script$F);
};

// 授信状态
var ECreditStatus;
(function (ECreditStatus) {
    ECreditStatus[ECreditStatus["close"] = 0] = "close";
    ECreditStatus[ECreditStatus["open"] = 10] = "open";
})(ECreditStatus || (ECreditStatus = {}));
// 余额开通状态
var EBalanceStatus;
(function (EBalanceStatus) {
    EBalanceStatus[EBalanceStatus["close"] = 0] = "close";
    EBalanceStatus[EBalanceStatus["open"] = 10] = "open";
})(EBalanceStatus || (EBalanceStatus = {}));

const baseUrl$5 = process.env.VUE_APP_URL;
const urls$6 = {
    getCompanyListUrl: '/order/user/fuzzy-list-company-info',
    getCompanyInformationUrl: '/order/operation/manual-order/get-company-info',
    getSalesAndBusinessUrl: '/user/shop-company/get-sales-and-business',
    batchUpdateSalesUrl: '/user/shop-company/batch-update-sales',
    batchUpdateBusinessUrl: '/user/shop-company/batch-update-business',
};
const getCompanyList = (param) => {
    return http({
        url: urls$6.getCompanyListUrl,
        withCredentials: true,
        baseURL: baseUrl$5,
        method: 'GET',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        params: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 获取客户信息
const getCompanyInformation = (param) => {
    return http({
        url: urls$6.getCompanyInformationUrl,
        withCredentials: true,
        baseURL: baseUrl$5,
        method: 'GET',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        params: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 获取销售/商务列表数据
const getSalesAndBusiness = () => {
    return http({
        url: urls$6.getSalesAndBusinessUrl,
        withCredentials: true,
        baseURL: baseUrl$5,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 修改销售
const batchUpdateSales = (param, callback) => {
    return http({
        url: urls$6.batchUpdateSalesUrl,
        withCredentials: true,
        baseURL: baseUrl$5,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            message.success('修改销售成功');
            callback && callback();
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 修改商务
const batchUpdateBusiness = (param, callback) => {
    return http({
        url: urls$6.batchUpdateBusinessUrl,
        withCredentials: true,
        baseURL: baseUrl$5,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            message.success('修改商务成功');
            callback && callback();
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};

const baseUrl$4 = process.env.VUE_APP_URL;
const urls$5 = {
    fsUpload: '/fs/upload?appName=order-web',
    addCompany: '/user/shop-company/quick-add-company-account',
    searchCompany: '/user/invoice/blur-search-company-by-company-name',
    getValidateCompany: '/user/company/validate-company-name-exists',
    getInvoiceInfo: '/user/invoice/get-invoice-info-by-company-name',
    checkMobile: '/user/shop-user/validate-user',
};
// 上传营业执照
const uploadBusinessLicense = (param) => {
    return http({
        url: urls$5.fsUpload,
        withCredentials: true,
        baseURL: baseUrl$4,
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryLQRO3VkrvkJzSqMs',
            processData: false,
            contentType: false,
        },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 搜索客户
const searchCompany = (param, callback) => {
    return http({
        url: urls$5.searchCompany,
        withCredentials: true,
        baseURL: baseUrl$4,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            callback && callback();
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 创建新客户
const createCompanyConfirm = (param, callback) => {
    return http({
        url: urls$5.addCompany,
        withCredentials: true,
        baseURL: baseUrl$4,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            callback && callback();
            return res.data.data;
        }
        else {
            if (res.data.message === '移动电话已存在!') {
                message.error('联系方式已存在');
            }
            else if (res.data.code == 9006 ||
                res.data.message === '公司名已存在!') {
                message.error('该客户已注册，请更换其他客户名或关闭弹窗后直接查询');
            }
            else {
                message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
            }
        }
    });
};
//调企查查，获取公司信息
const getCompanyInfo = (param, callback) => {
    return http({
        url: urls$5.getValidateCompany,
        withCredentials: true,
        baseURL: baseUrl$4,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        params: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            callback && callback();
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
//调企查查，获取公司信息
const getInvoiceInfo = (param, callback) => {
    return http({
        url: urls$5.getInvoiceInfo,
        withCredentials: true,
        baseURL: baseUrl$4,
        method: 'POST',
        params: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            callback && callback();
            return res.data.data;
        }
    });
};
//调企查查，获取公司信息
const checkMobile = (param) => {
    return http({
        url: urls$5.checkMobile,
        withCredentials: true,
        baseURL: baseUrl$4,
        method: 'POST',
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            // 0 未占用， 2 被占用
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};

var script$E = defineComponent({
    name: 'InvoiceForm',
    components: { BasicFormItem: script$1v, UploadOutlined },
    props: {
        formState: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => {
                emit('update:formState', val);
            },
        });
        // 表单项
        const invoiceFormItems = reactive([
            {
                key: 'name',
                type: 'Input',
                label: '单位名称',
                placeholder: '请输入客户名称',
                maxlength: 50,
                rules: {
                    max: 50,
                    message: '单位名称过长，不要超过50个字！',
                },
                props: {
                    readonly: true,
                    onChange: (val) => {
                        emit('onSubmit', { name: val });
                    },
                },
            },
            {
                key: 'bankAccount',
                type: 'Input',
                label: '开户账号',
                placeholder: '请输入开户账号',
                maxlength: 30,
            },
            {
                key: 'taxRegistrationNo',
                type: 'Input',
                label: '税号',
                placeholder: '请输入税号',
                maxlength: 18,
            },
            {
                dataIndex: 'registerAddress',
                key: 'registerAddress',
                type: 'Input',
                label: '注册地址',
                placeholder: '请输入地址',
                maxlength: 100,
            },
            {
                dataIndex: 'bankName',
                key: 'bankName',
                type: 'Input',
                label: '开户银行',
                placeholder: '请输入开户银行',
                maxlength: 30,
            },
            {
                dataIndex: 'registerAddressPhone',
                key: 'registerAddressPhone',
                type: 'Input',
                label: '注册电话',
                placeholder: '请输入电话，如：012-12345678',
                maxlength: 20,
            },
        ]);
        const fileList = ref([]); // 文件列表
        const previewUrl = ref(''); // 预览路径
        // 上传营业执照
        const customRequest = async (options) => {
            let params = new FormData();
            params.append('file', options.file);
            const res = await uploadBusinessLicense(params);
            if (res) {
                message.success('上传成功');
                previewUrl.value = '/fs/open?uuid=' + res;
                fileList.value = [options.file];
            }
            formStateRef.value.file = res;
        };
        watch(() => props.formState, () => {
            Object.assign(formStateRef.value, props.formState);
            invoiceFormItems.forEach((item) => {
                item.value = props.formState[item.key];
            });
        }, { deep: true });
        // 上传文件限制
        const acceptType = 'image/jpeg,image/png,image/gif';
        const beforeUpload = (file) => {
            if (file.type && acceptType.indexOf(file.type) == -1) {
                message.error('仅支持JPG,GIF,PNG格式的图片');
                return false;
            }
            else if (file.size && file.size > 5 * 1024 * 1024) {
                message.error('图片大小不能超过5M');
                return false;
            }
        };
        return {
            invoiceFormItems,
            fileList,
            previewUrl,
            customRequest,
            formStateRef,
            beforeUpload,
            acceptType,
        };
    },
});

const _hoisted_1$y = { class: "upload-business-license" };
const _hoisted_2$s = /*#__PURE__*/createElementVNode("span", { class: "upload-text-tips" }, " 图片大小不超过5M,支持JPG,GIF,PNG ", -1 /* HOISTED */);
const _hoisted_3$n = /*#__PURE__*/createElementVNode("span", { class: "preview-btn" }, "预览", -1 /* HOISTED */);

function render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_col = resolveComponent("a-col");
  const _component_upload_outlined = resolveComponent("upload-outlined");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_upload = resolveComponent("a-upload");
  const _component_a_image = resolveComponent("a-image");
  const _component_a_tooltip = resolveComponent("a-tooltip");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_row = resolveComponent("a-row");

  return (openBlock(), createBlock(_component_a_row, { justify: "space-between" }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.invoiceFormItems, (item, index) => {
        return (openBlock(), createBlock(_component_a_col, {
          span: 12,
          key: index
        }, {
          default: withCtx(() => [
            (openBlock(), createBlock(_component_BasicFormItem, {
              item: item,
              key: item.key,
              value: _ctx.formStateRef[item.key],
              "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event),
              labelAlign: "right",
              colon: false,
              labelCol: { span: 6 }
            }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value"]))
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */))
      }), 128 /* KEYED_FRAGMENT */)),
      createVNode(_component_a_col, {
        span: 24,
        key: "upload"
      }, {
        default: withCtx(() => [
          createVNode(_component_a_form_item, {
            label: "营业执照",
            labelCol: { span: 3 },
            labelAlign: "right",
            colon: false
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$y, [
                createVNode(_component_a_upload, {
                  class: "sc-upload",
                  "file-list": _ctx.fileList,
                  showUploadList: false,
                  name: "file",
                  accept: _ctx.acceptType,
                  customRequest: _ctx.customRequest,
                  beforeUpload: _ctx.beforeUpload
                }, {
                  default: withCtx(() => [
                    createVNode(_component_a_button, null, {
                      default: withCtx(() => [
                        createVNode(_component_upload_outlined),
                        createTextVNode("上传文件")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["file-list", "accept", "customRequest", "beforeUpload"]),
                _hoisted_2$s,
                (_ctx.fileList.length > 0)
                  ? (openBlock(), createBlock(_component_a_tooltip, {
                      key: 0,
                      overlayClassName: "sc-tooltip-light"
                    }, {
                      title: withCtx(() => [
                        createVNode(_component_a_image, {
                          width: "100px",
                          src: _ctx.previewUrl
                        }, null, 8 /* PROPS */, ["src"])
                      ]),
                      default: withCtx(() => [
                        _hoisted_3$n
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}

script$E.render = render$z;
script$E.__file = "packages/create-company/src/InvoiceForm.vue";

var script$D = defineComponent({
    name: 'InvoiceForm',
    components: { BasicFormItem: script$1v },
    props: {
        formState: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => {
                emit('update:formState', val);
            },
        });
        const companyNameList = ref([]); // 客户列表
        const salesNameList = ref([]); // 销售列表
        const businessNameList = ref([]); // 商务列表
        // 手机是否被占用
        const handleChangeMobile = async (e) => {
            const mobile = e.target.value || '';
            let data;
            const index = companyFormItems.findIndex((it) => it.key === 'mobile');
            mobile.length === 11 && (data = await checkMobile({ mobile }));
            const isExists = (mobile.length === 11 && data !== 0) || undefined;
            const help = isExists &&
                '该号码已绑定其他账号，若继续使用，关联账号只能使用公司名称登录!';
            const status = isExists && 'error';
            companyFormItems[index]['help'] = help;
            companyFormItems[index]['validateStatus'] = status;
        };
        // 表单项
        const companyFormItems = reactive([
            {
                key: 'companyName',
                type: 'ScSelect',
                label: '客户名称',
                placeholder: '请输入客户名称',
                options: companyNameList.value,
                rules: {
                    required: true,
                    message: '客户名称不能为空',
                },
                props: {
                    isInput: true,
                    search: async (val) => {
                        if (val.length > 3) {
                            companyNameList.value.splice(0);
                            const data = await searchCompany(JSON.stringify({ companyName: val }));
                            if (data) {
                                data.forEach((item) => {
                                    companyNameList.value.push({
                                        id: item.name,
                                        name: item.name,
                                    });
                                });
                            }
                        }
                    },
                    change: (val, isblur) => {
                        if (val) {
                            const nameExist = !isblur;
                            emit('updateFormState', { val, nameExist });
                        }
                    },
                },
            },
            {
                key: 'companyTypeCode',
                type: 'Select',
                label: '公司类型',
                placeholder: '请选择公司类型',
                options: [
                    { id: '-1', name: '无类型' },
                    { id: '0', name: 'OEM' },
                    { id: '5', name: '系统集成商' },
                    { id: '10', name: '传统分销' },
                    { id: '15', name: '二级分销' },
                    { id: '20', name: '机电市场' },
                    { id: '25', name: '五金门店' },
                    { id: '30', name: '小三箱' },
                    { id: '35', name: 'OEM类盘厂' },
                    { id: '40', name: '配电类盘厂' },
                    { id: '45', name: 'EU' },
                ],
            },
            {
                key: 'realName',
                type: 'Input',
                label: '联系人',
                placeholder: '请输入联系人名称',
                maxlength: 30,
            },
            {
                key: 'salesId',
                type: 'Select',
                label: '负责销售',
                placeholder: '暂无销售',
                options: salesNameList.value,
            },
            {
                key: 'mobile',
                type: 'Input',
                label: '手机号',
                placeholder: '请输入11位手机号',
                maxlength: 20,
                rules: {
                    pattern: VALIDATOR.pattern.mobile,
                    message: VALIDATOR.message.mobile,
                },
                props: {
                    onChange: handleChangeMobile,
                },
            },
            {
                key: 'businessId',
                type: 'Select',
                label: '负责商务',
                placeholder: '暂无商务',
                options: businessNameList.value,
            },
        ]);
        // 获取销售/商务列表数据
        const getSalesAndBusinessList = async () => {
            const res = await getSalesAndBusiness();
            if (res) {
                salesNameList.value = [{ id: '0', name: '暂无销售' }];
                res[1].forEach((item) => {
                    salesNameList.value.push({
                        id: '' + item.userId,
                        name: item.realName,
                    });
                });
                businessNameList.value = [{ id: '0', name: '暂无商务' }];
                res[2].forEach((item) => {
                    businessNameList.value.push({
                        id: '' + item.userId,
                        name: item.realName,
                    });
                });
                companyFormItems[3].options = salesNameList.value;
                companyFormItems[5].options = businessNameList.value;
                // 获取当前用户
                const userInfo = getUserInfo();
                if (userInfo) {
                    const userId = userInfo.id.toString();
                    let index = -1;
                    // 初始化salesId
                    !formStateRef.value.salesId &&
                        ((index = salesNameList.value.findIndex((u) => u.id === userId)),
                            index > -1 && (formStateRef.value.salesId = userId));
                    // 初始化businessId
                    !formStateRef.value.businessId &&
                        ((index = businessNameList.value.findIndex((u) => u.id === userId)),
                            index > -1 && (formStateRef.value.businessId = userId));
                }
            }
        };
        getSalesAndBusinessList();
        return { companyFormItems, formStateRef };
    },
});

function render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_row = resolveComponent("a-row");

  return (openBlock(), createBlock(_component_a_row, { justify: "space-between" }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.companyFormItems, (item, index) => {
        return (openBlock(), createBlock(_component_a_col, {
          span: 12,
          key: index
        }, {
          default: withCtx(() => [
            (openBlock(), createBlock(_component_BasicFormItem, {
              item: item,
              key: item.key,
              value: _ctx.formStateRef[item.key],
              "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event),
              "label-in-value": "",
              labelAlign: "right",
              colon: false,
              labelCol: { span: 6 },
              required: item.key == 'companyName',
              rules: item.rules
            }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value", "required", "rules"]))
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}

script$D.render = render$y;
script$D.__file = "packages/create-company/src/CompanyForm.vue";

const initFormState = {
    companyName: null,
    companyTypeCode: null,
    realName: '',
    mobile: '',
    salesId: null,
    businessId: null,
    name: '',
    bankAccount: '',
    bankName: '',
    taxRegistrationNo: '',
    registerAddress: '',
    registerAddressPhone: '',
    file: '', // 营业执照
};
var script$C = defineComponent({
    name: 'CreateCompany',
    components: {
        Collapse: script$H,
        CollapsePanel: script$G,
        CompanyForm: script$D,
        InvoiceForm: script$E,
    },
    props: {
        visible: {
            type: [Boolean],
            default: false,
        },
        formState: {
            type: Object,
            default: () => initFormState,
        },
    },
    setup(props, { emit }) {
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        const showInvoiceForm = ref(false);
        const formRef = ref();
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => {
                emit('update:formState', val);
            },
        });
        const initInvoiceInfo = {
            bankAccount: '',
            bankName: '',
            taxRegistrationNo: '',
            registerAddress: '',
            registerAddressPhone: '',
            file: '', // 营业执照
        };
        const handelShowInvoiceForm = () => {
            showInvoiceForm.value = true;
        };
        // 查询增值税发票信息
        const updateInvoiceInfo = async (companyName) => {
            // 未命中的名称不查询发票
            if ((companyName || '').trim() == '')
                return;
            showInvoiceForm.value = true;
            // 查询发票信息
            const invoiceInfo = await getInvoiceInfo({
                companyName: companyName,
            });
            if (invoiceInfo) {
                Object.assign(formStateRef.value, invoiceInfo);
            }
            else {
                Object.assign(formStateRef.value, {
                    bankAccount: '',
                    taxRegistrationNo: '',
                    registerAddress: '',
                    bankName: '',
                    registerAddressPhone: '',
                });
            }
        };
        const updateFormState = async ({ val, nameExist }) => {
            if (!val || formStateRef.value.name == val)
                return;
            Object.assign(formStateRef.value, initInvoiceInfo, { name: val });
            const data = await getCompanyInfo({
                companyName: val,
            });
            if (data == 1) {
                Modal.warning({
                    title: '该客户已被移入回收站，是否进入回收站恢复？',
                    onOk: () => {
                        window.location.href =
                            '/user/shop-company/recycle-bin-company-list?name=' + val;
                    },
                    onCancel: () => {
                        formStateRef.value.companyName = '';
                    },
                });
            }
            else if (data == 0) {
                message.error('该客户已注册，请更换其他客户名或关闭弹窗后直接查询');
                updateInvoiceInfo(val);
            }
            else if (data == 2) {
                updateInvoiceInfo(val);
            }
        };
        const handleOk = () => {
            formRef.value
                .validate()
                .then(async (val) => {
                const apiParams = cloneDeep({
                    ...initFormState,
                    ...formStateRef.value,
                });
                !apiParams.mobile && (apiParams.mobile = '');
                if (!apiParams.name) {
                    apiParams.name = apiParams.companyName;
                    formStateRef.value.name = apiParams.companyName;
                }
                const res = await createCompanyConfirm(JSON.stringify(apiParams));
                if (res) {
                    message.success('创建成功');
                    visibleRef.value = false;
                    emit('ok', { ...formStateRef.value, companyId: res });
                    formRef.value.resetFields();
                }
            })
                .catch((error) => {
                console.log('error', error);
            });
        };
        // 弹框关闭后重置表单
        const handleCancel = () => {
            formRef.value.resetFields();
        };
        return {
            formRef,
            visibleRef,
            showInvoiceForm,
            handelShowInvoiceForm,
            InvoiceForm: script$E,
            CompanyForm: script$D,
            formStateRef,
            handleOk,
            updateFormState,
            handleCancel,
        };
    },
});

const _hoisted_1$x = { class: "company-form-wrap" };
const _hoisted_2$r = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_3$m = { class: "invoice-form-wrap" };

function render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompanyForm = resolveComponent("CompanyForm");
  const _component_CollapsePanel = resolveComponent("CollapsePanel");
  const _component_Collapse = resolveComponent("Collapse");
  const _component_InvoiceForm = resolveComponent("InvoiceForm");
  const _component_a_form = resolveComponent("a-form");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createBlock(_component_a_modal, {
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[3] || (_cache[3] = $event => ((_ctx.visibleRef) = $event)),
    title: "创建新客户",
    class: "sc-create-company",
    width: "740px",
    destroyOnClose: "",
    maskClosable: false,
    onCancel: _ctx.handleCancel,
    onOk: _ctx.handleOk
  }, {
    default: withCtx(() => [
      createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formStateRef
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$x, [
            createVNode(_component_Collapse, {
              activeKey: ['0'],
              disabled: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_CollapsePanel, {
                  header: "",
                  key: "0"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_CompanyForm, {
                      formState: _ctx.formStateRef,
                      "onUpdate:formState": _cache[0] || (_cache[0] = $event => ((_ctx.formStateRef) = $event)),
                      onUpdateFormState: _ctx.updateFormState
                    }, null, 8 /* PROPS */, ["formState", "onUpdateFormState"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          (!_ctx.showInvoiceForm)
            ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "more-new-information",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.handelShowInvoiceForm && _ctx.handelShowInvoiceForm(...args)))
              }, [
                _hoisted_2$r,
                createTextVNode("其他信息 ")
              ]))
            : createCommentVNode("v-if", true),
          withDirectives(createElementVNode("div", _hoisted_3$m, [
            createVNode(_component_Collapse, {
              activeKey: ['0'],
              disabled: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_CollapsePanel, {
                  header: "增值税信息",
                  key: "0",
                  disabled: ""
                }, {
                  default: withCtx(() => [
                    createVNode(_component_InvoiceForm, {
                      formState: _ctx.formStateRef,
                      "onUpdate:formState": _cache[2] || (_cache[2] = $event => ((_ctx.formStateRef) = $event))
                    }, null, 8 /* PROPS */, ["formState"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ], 512 /* NEED_PATCH */), [
            [vShow, _ctx.showInvoiceForm]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "onCancel", "onOk"]))
}

script$C.render = render$x;
script$C.__file = "packages/create-company/src/CreateCompany.vue";

script$C.install = (Vue) => {
    Vue.component(script$C.name, script$C);
};

const urls$4 = {
    orderList: '/order/operation/v4/list',
    pricePackage: '/price/package-price/index?packageId=',
    editCredit: '/credit/credit/edit?id=',
    addCredit: '/credit/credit/pre-add?companyId=',
    toReceive: '/credit/credit/user-detail?creditId=',
    preUpdateCompany: '/user/shop-company/pre-update-company?customerId=',
    manualRecharge: '/account/operator-balance/manual-recharge?companyId=', // 去充值
};
/**
 * 参数说明:
 * companyId: String|Number, 默认选中的客户,非必传
 *
 * 回调:
 * change: (option) => {}, 客户名称改变回调
 * salesChange: (option) => {}, 负责销售改变回调
 * businessChange: (option) => {}, 负责商务改变回调
 */
var script$B = defineComponent({
    name: 'CompanyInformation',
    props: {
        companyId: {
            type: [String, Number],
        },
    },
    components: {
        ScSelect: script$1x,
        Popconfirm: script$1o,
        CreateCompany: script$C,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes;
        },
    },
    setup(props, { emit }) {
        const selectValue = ref(); // 选中客户名称
        const newCompanyName = ref(''); // 新客户名称
        const companyList = ref([{}]); // 客户名称列表
        const companyInfo = ref({}); // 客户信息
        const showPricePackageCount = ref(false); // 是否展示价格套餐个数
        const showSalesSelect = ref(false); // 是否展示销售下拉框
        const showBusinessSelect = ref(false); // 是否展示商务下拉框
        const salesNameList = ref([]); // 销售列表
        const businessNameList = ref([]); // 商务列表
        const selectSalesValue = ref(); // 选中销售
        const selectBusinessValue = ref(); // 选中商务
        const noSales = { value: -1, label: '暂无销售' };
        const noBusiness = { value: -1, label: '暂无商务' };
        let selectSalesValueState = noSales; // 存储选中销售
        let selectBusinessValueState = noBusiness; // 存储选中商务
        const showModal = ref(false);
        // 下拉框渲染节点固定在触发器的父元素中
        const getPopupContainer = (triggerNode) => {
            return triggerNode.parentNode;
        };
        // 第一次无下拉选项时显示新建公司
        const handleFocus = () => {
            if (JSON.stringify(companyList.value) === '[{}]') {
                companyList.value = [];
                nextTick(() => (hideDropdown.value = true));
            }
        };
        // 模糊查询客户名称
        let searchTimer;
        const handleSearch = (val) => {
            hideDropdown.value = false;
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            searchTimer = setTimeout(async () => {
                const res = await getCompanyList({ companyName: val });
                newCompanyName.value = val.trim();
                if (res) {
                    companyList.value = res.map((item) => {
                        if (item.name === val) {
                            newCompanyName.value = '';
                        }
                        return {
                            value: item.id,
                            label: item.name + (item.status === 25 ? ' (已禁用)' : ''),
                            disabled: item.status === 25,
                        };
                    });
                }
            }, 200);
        };
        // 获取客户信息
        const getCompanyInfo = async (companyId, initRender) => {
            const hide = message.loading('加载中...', 0);
            const res = await getCompanyInformation({ companyId });
            if (res) {
                if (initRender) {
                    selectValue.value = {
                        label: res.companyName,
                        value: res.companyId,
                    };
                }
                companyInfo.value = res;
                showPricePackageCount.value = false;
                showSalesSelect.value = false;
                showBusinessSelect.value = false;
                companyInfo.value.salesName =
                    companyInfo.value.salesName || noSales.label;
                companyInfo.value.businessName =
                    companyInfo.value.businessName || noBusiness.label;
                salesNameList.value.forEach((item) => {
                    if (companyInfo.value.salesName == item.label) {
                        selectSalesValue.value = item;
                        selectSalesValueState = item;
                    }
                });
                businessNameList.value.forEach((item) => {
                    if (companyInfo.value.businessName == item.label) {
                        selectBusinessValue.value = item;
                        selectBusinessValueState = item;
                    }
                });
                // 格式化金额数据item.realName
                companyInfo.value.creditArrearageText = math.toThousands({
                    num: math.accDiv(res.creditArrearage || 0, 100),
                    cent: 2,
                });
                companyInfo.value.creditAvailableText = math.toThousands({
                    num: math.accDiv(res.creditAvailable || 0, 100),
                    cent: 2,
                });
                companyInfo.value.balanceAvailableText = math.toThousands({
                    num: math.accDiv(res.balanceAvailable || 0, 100),
                    cent: 2,
                });
                nextTick(() => {
                    // 价格套餐
                    if (companyInfo.value.pricePackageDtos &&
                        companyInfo.value.pricePackageDtos.length > 0) {
                        const priceWrap = document.getElementsByClassName('price-packages-list')[0];
                        const priceWrapRect = priceWrap.getBoundingClientRect();
                        const priceItems = document.querySelectorAll('.price-packages-list a');
                        let priceItemWidth = 0;
                        priceItems.forEach((item) => {
                            const itemRect = item.getBoundingClientRect();
                            priceItemWidth += itemRect.width;
                        });
                        if (priceItemWidth > priceWrapRect.width) {
                            showPricePackageCount.value = true;
                        }
                    }
                });
                // 返回客户信息
                emit('change', companyInfo.value);
            }
            hide();
        };
        // 客户选中后回调
        const handleSelect = (option) => {
            newCompanyName.value = '';
            getCompanyInfo(option.value);
        };
        // 价格套餐提示信息列表表头数组
        const pricePackagesCols = [
            {
                title: '序号',
                dataIndex: 'id',
                align: 'center',
                key: 'id',
                width: 40,
                customRender: ({ index }) => {
                    return index + 1;
                },
            },
            {
                title: '价格套餐',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                ellipsis: true,
                slots: { customRender: 'name' },
            },
        ];
        // 编辑销售
        const handleEditSales = () => {
            showSalesSelect.value = true;
        };
        // 编辑商务
        const handleEditBusiness = () => {
            showBusinessSelect.value = true;
        };
        // 获取销售/商务列表数据
        const getSalesAndBusinessList = async () => {
            const res = await getSalesAndBusiness();
            if (res) {
                salesNameList.value = [noSales];
                res[1].forEach((item) => {
                    salesNameList.value.push({
                        value: item.userId,
                        label: item.realName,
                    });
                });
                businessNameList.value = [noBusiness];
                res[2].forEach((item) => {
                    businessNameList.value.push({
                        value: item.userId,
                        label: item.realName,
                    });
                });
            }
        };
        getSalesAndBusinessList();
        // 失去焦点保存销售
        const handleSaveSales = () => {
            if (!selectValue.value ||
                selectSalesValue.value.value === selectSalesValueState.value) {
                return;
            }
            selectSalesValueState = selectSalesValue.value;
            companyInfo.value.salesName = selectSalesValue.value.label;
            batchUpdateSales(JSON.stringify({
                salesId: selectSalesValue.value.value,
                companyIds: [selectValue.value.value],
            }), () => emit('salesChange', selectSalesValue.value));
        };
        // 失去焦点保存商务
        const handleSaveBusiness = () => {
            if (!selectValue.value ||
                selectBusinessValue.value.value === selectBusinessValueState.value) {
                return;
            }
            selectBusinessValueState = selectBusinessValue.value;
            companyInfo.value.businessName = selectBusinessValue.value.label;
            batchUpdateBusiness(JSON.stringify({
                businessId: selectBusinessValue.value.value,
                companyIds: [selectValue.value.value],
            }), () => emit('businessChange', selectBusinessValue.value));
        };
        // 刷新账户信息
        const handleRefreshAccountInfo = () => {
            if (selectValue.value) {
                getCompanyInfo(selectValue.value.value);
            }
        };
        onMounted(() => {
            // 点击空白处隐藏销售/商务选择框
            document.addEventListener('click', (ev) => {
                if (ev.target.classList &&
                    ev.target.classList.value.indexOf('charge-person-select') == -1) {
                    showSalesSelect.value = false;
                    showBusinessSelect.value = false;
                }
            });
        });
        watch(() => props.companyId, () => {
            if (props.companyId) {
                getCompanyInfo(props.companyId, true);
            }
        });
        // 点击下拉创建客户时立即关闭下拉框
        const hideDropdown = ref(false);
        // 创建新客户
        const companyFormState = ref({});
        const addNewCompany = (ev, newName) => {
            hideDropdown.value = true;
            companyFormState.value.companyName = newName || null;
            companyFormState.value.name = newName || null;
            showModal.value = true;
            setTimeout(() => {
                hideDropdown.value = false;
            }, 500);
        };
        // 客户创建成功
        const handleOk = (params) => {
            console.log(params);
            if (params.companyId) {
                getCompanyInfo(params.companyId, true);
            }
        };
        // 历史订单跳转
        const toHistoryOrderList = () => {
            var date = new Date();
            const startTime = formatterDate(date, { days: -365 });
            const endTime = formatterDate(date);
            const historyUrl = `${urls$4.orderList}?customerName=${companyInfo.value.companyName}&startTime=${startTime}&endTime=${endTime}`;
            window.open(historyUrl, '_blank');
        };
        return {
            urls: urls$4,
            ECreditStatus,
            EBalanceStatus,
            selectValue,
            companyList,
            newCompanyName,
            getPopupContainer,
            handleFocus,
            handleSearch,
            handleSelect,
            hideDropdown,
            showModal,
            addNewCompany,
            companyFormState,
            companyInfo,
            showPricePackageCount,
            pricePackageCountVisible: ref(false),
            pricePackagesCols,
            showSalesSelect,
            showBusinessSelect,
            handleEditSales,
            handleEditBusiness,
            salesNameList,
            businessNameList,
            selectSalesValue,
            selectBusinessValue,
            handleRefreshAccountInfo,
            handleOk,
            toHistoryOrderList,
            handleSaveSales,
            handleSaveBusiness,
        };
    },
});

const _hoisted_1$w = { class: "sc-company-information" };
const _hoisted_2$q = { class: "select-company-wrap" };
const _hoisted_3$l = /*#__PURE__*/createElementVNode("div", { class: "select-company-label" }, [
  /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, ""),
  /*#__PURE__*/createElementVNode("span", null, "客户名称")
], -1 /* HOISTED */);
const _hoisted_4$h = { class: "select-company-input" };
const _hoisted_5$f = { key: 0 };
const _hoisted_6$a = /*#__PURE__*/createElementVNode("div", null, "点击即创建客户", -1 /* HOISTED */);
const _hoisted_7$9 = { class: "add-new-company-tips" };
const _hoisted_8$8 = {
  key: 0,
  class: "company-info-wrap"
};
const _hoisted_9$7 = { class: "company-basic-info" };
const _hoisted_10$5 = { class: "company-info-header" };
const _hoisted_11$5 = ["href"];
const _hoisted_12$5 = { class: "company-info-content basic-info-content" };
const _hoisted_13$2 = { class: "company-info-item" };
const _hoisted_14$3 = /*#__PURE__*/createElementVNode("label", null, "联系人：", -1 /* HOISTED */);
const _hoisted_15$3 = {
  key: 0,
  class: "delixi-label"
};
const _hoisted_16$3 = { class: "company-info-item" };
const _hoisted_17$2 = { class: "charge-person-item" };
const _hoisted_18$2 = /*#__PURE__*/createElementVNode("label", null, "负责销售：", -1 /* HOISTED */);
const _hoisted_19$2 = { key: 0 };
const _hoisted_20$2 = { class: "charge-person-name" };
const _hoisted_21 = { class: "charge-person-item" };
const _hoisted_22 = /*#__PURE__*/createElementVNode("label", null, "负责商务：", -1 /* HOISTED */);
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { class: "charge-person-name" };
const _hoisted_25 = { class: "company-info-item" };
const _hoisted_26 = /*#__PURE__*/createElementVNode("label", null, "公司类型：", -1 /* HOISTED */);
const _hoisted_27 = { class: "company-info-item" };
const _hoisted_28 = /*#__PURE__*/createElementVNode("label", null, "价格套餐：", -1 /* HOISTED */);
const _hoisted_29 = {
  key: 0,
  class: "price-packages"
};
const _hoisted_30 = { class: "price-packages-list" };
const _hoisted_31 = ["href"];
const _hoisted_32 = { class: "customer-tas-layer" };
const _hoisted_33 = ["href"];
const _hoisted_34 = { key: 1 };
const _hoisted_35 = /*#__PURE__*/createElementVNode("div", { class: "company-info-divider" }, [
  /*#__PURE__*/createElementVNode("span", { class: "circel-top" }),
  /*#__PURE__*/createElementVNode("span", { class: "circel-bottom" })
], -1 /* HOISTED */);
const _hoisted_36 = { class: "company-account-info" };
const _hoisted_37 = { class: "company-info-header" };
const _hoisted_38 = { class: "company-info-content account-info-content" };
const _hoisted_39 = { class: "company-info-item" };
const _hoisted_40 = /*#__PURE__*/createElementVNode("label", null, "授信状态：", -1 /* HOISTED */);
const _hoisted_41 = { key: 0 };
const _hoisted_42 = /*#__PURE__*/createElementVNode("span", { class: "con" }, "已授信", -1 /* HOISTED */);
const _hoisted_43 = ["href"];
const _hoisted_44 = { key: 1 };
const _hoisted_45 = /*#__PURE__*/createElementVNode("span", { class: "con" }, "未授信", -1 /* HOISTED */);
const _hoisted_46 = ["href"];
const _hoisted_47 = { key: 2 };
const _hoisted_48 = /*#__PURE__*/createElementVNode("span", { class: "con" }, "冻结", -1 /* HOISTED */);
const _hoisted_49 = ["href"];
const _hoisted_50 = {
  key: 0,
  class: "company-info-item"
};
const _hoisted_51 = /*#__PURE__*/createElementVNode("label", null, "欠款金额：", -1 /* HOISTED */);
const _hoisted_52 = { class: "con" };
const _hoisted_53 = ["href"];
const _hoisted_54 = {
  key: 1,
  class: "company-info-item"
};
const _hoisted_55 = /*#__PURE__*/createElementVNode("label", null, "可用额度：", -1 /* HOISTED */);
const _hoisted_56 = { class: "company-info-item" };
const _hoisted_57 = /*#__PURE__*/createElementVNode("label", null, "可用余额：", -1 /* HOISTED */);
const _hoisted_58 = { key: 0 };
const _hoisted_59 = { class: "con" };
const _hoisted_60 = ["href"];
const _hoisted_61 = { key: 1 };
const _hoisted_62 = /*#__PURE__*/createElementVNode("span", { class: "con" }, "未开通", -1 /* HOISTED */);
const _hoisted_63 = ["href"];
const _hoisted_64 = /*#__PURE__*/createElementVNode("div", { class: "company-info-wrap no-company-info" }, [
  /*#__PURE__*/createElementVNode("img", { src: "data:image/png;base64,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" }),
  /*#__PURE__*/createElementVNode("div", { class: "no-company-text" }, "请输入客户名称查询客户信息")
], -1 /* HOISTED */);

function render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_a_divider = resolveComponent("a-divider");
  const _component_ScSelect = resolveComponent("ScSelect");
  const _component_a_select = resolveComponent("a-select");
  const _component_a_table = resolveComponent("a-table");
  const _component_Popconfirm = resolveComponent("Popconfirm");
  const _component_CreateCompany = resolveComponent("CreateCompany");

  return (openBlock(), createElementBlock("div", _hoisted_1$w, [
    createCommentVNode(" 选择客户名称 "),
    createElementVNode("div", _hoisted_2$q, [
      _hoisted_3$l,
      createElementVNode("div", _hoisted_4$h, [
        createVNode(_component_ScSelect, {
          value: _ctx.selectValue,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.selectValue) = $event)),
          options: _ctx.companyList,
          getPopupContainer: _ctx.getPopupContainer,
          "show-search": "",
          defaultActiveFirstOption: "",
          placeholder: "输入客户名称",
          "filter-option": false,
          "not-found-content": null,
          "show-arrow": false,
          labelInValue: true,
          focus: _ctx.handleFocus,
          search: _ctx.handleSearch,
          select: _ctx.handleSelect,
          dropdownClassName: 
            _ctx.hideDropdown
              ? 'hide-company-drop'
              : !!_ctx.newCompanyName
              ? 'show-add-company-drop'
              : ''
          ,
          onBlur: _cache[2] || (_cache[2] = $event => (_ctx.newCompanyName = ''))
        }, {
          dropdownRender: withCtx(({ menuNode: menu }) => [
            createVNode(_component_v_nodes, { vnodes: menu }, null, 8 /* PROPS */, ["vnodes"]),
            (!!_ctx.newCompanyName)
              ? (openBlock(), createElementBlock("div", _hoisted_5$f, [
                  (_ctx.companyList.length > 0)
                    ? (openBlock(), createBlock(_component_a_divider, { key: 0 }))
                    : createCommentVNode("v-if", true),
                  createElementVNode("div", {
                    class: "add-company-wrap",
                    onClick: _cache[0] || (_cache[0] = $event => (_ctx.addNewCompany($event, _ctx.newCompanyName)))
                  }, [
                    createElementVNode("div", null, toDisplayString(_ctx.newCompanyName) + " (新客户)", 1 /* TEXT */),
                    _hoisted_6$a
                  ])
                ]))
              : createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value", "options", "getPopupContainer", "focus", "search", "select", "dropdownClassName"])
      ]),
      createElementVNode("div", _hoisted_7$9, [
        createTextVNode(" 如需创建新的客户，您可以 "),
        createElementVNode("a", {
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.addNewCompany($event)))
        }, "创建新客户")
      ])
    ]),
    createCommentVNode(" 客户信息 "),
    (_ctx.selectValue && _ctx.selectValue.value)
      ? (openBlock(), createElementBlock("div", _hoisted_8$8, [
          createCommentVNode(" 基本信息 "),
          createElementVNode("div", _hoisted_9$7, [
            createElementVNode("div", _hoisted_10$5, [
              createElementVNode("h2", null, [
                createElementVNode("a", {
                  href: 
                `/user/customer/customer-index?companyId=${_ctx.companyInfo.companyId}`
              ,
                  target: "_blank"
                }, toDisplayString(_ctx.companyInfo.companyName || '-'), 9 /* TEXT, PROPS */, _hoisted_11$5)
              ]),
              createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.toHistoryOrderList && _ctx.toHistoryOrderList(...args))),
                class: "sc-href"
              }, "历史订单")
            ]),
            createElementVNode("div", _hoisted_12$5, [
              createElementVNode("div", _hoisted_13$2, [
                _hoisted_14$3,
                createElementVNode("div", null, [
                  createTextVNode(toDisplayString(_ctx.companyInfo.realName || '-') + " " + toDisplayString(_ctx.companyInfo.mobile || '-') + " ", 1 /* TEXT */),
                  (_ctx.companyInfo.delixiSalesSign)
                    ? (openBlock(), createElementBlock("span", _hoisted_15$3, " 德力西备案客户 "))
                    : createCommentVNode("v-if", true)
                ])
              ]),
              createElementVNode("div", _hoisted_16$3, [
                createElementVNode("div", null, [
                  createElementVNode("div", _hoisted_17$2, [
                    _hoisted_18$2,
                    createCommentVNode(" <i class=\"iconfont tit-icon\">&#xe919;</i> "),
                    (!_ctx.showSalesSelect)
                      ? (openBlock(), createElementBlock("span", _hoisted_19$2, [
                          createElementVNode("span", _hoisted_20$2, toDisplayString(_ctx.companyInfo.salesName || '暂无销售'), 1 /* TEXT */),
                          createElementVNode("i", {
                            class: "iconfont modify-btn",
                            onClick: _cache[5] || (_cache[5] = withModifiers((...args) => (_ctx.handleEditSales && _ctx.handleEditSales(...args)), ["stop"]))
                          }, "")
                        ]))
                      : (openBlock(), createElementBlock("div", {
                          key: 1,
                          class: "charge-person-select",
                          onClick: _cache[7] || (_cache[7] = withModifiers(() => {}, ["stop"]))
                        }, [
                          createVNode(_component_a_select, {
                            value: _ctx.selectSalesValue,
                            "onUpdate:value": _cache[6] || (_cache[6] = $event => ((_ctx.selectSalesValue) = $event)),
                            getPopupContainer: _ctx.getPopupContainer,
                            options: _ctx.salesNameList,
                            optionFilterProp: "label",
                            "show-search": "",
                            defaultActiveFirstOption: "",
                            "not-found-content": null,
                            labelInValue: true,
                            onBlur: _ctx.handleSaveSales
                          }, null, 8 /* PROPS */, ["value", "getPopupContainer", "options", "onBlur"])
                        ]))
                  ]),
                  createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    (!_ctx.showBusinessSelect)
                      ? (openBlock(), createElementBlock("span", _hoisted_23, [
                          createElementVNode("span", _hoisted_24, toDisplayString(_ctx.companyInfo.businessName || '暂无商务'), 1 /* TEXT */),
                          createElementVNode("i", {
                            class: "iconfont modify-btn",
                            onClick: _cache[8] || (_cache[8] = withModifiers((...args) => (_ctx.handleEditBusiness && _ctx.handleEditBusiness(...args)), ["stop"]))
                          }, "")
                        ]))
                      : (openBlock(), createElementBlock("div", {
                          key: 1,
                          class: "charge-person-select",
                          onClick: _cache[10] || (_cache[10] = withModifiers(() => {}, ["stop"]))
                        }, [
                          createVNode(_component_a_select, {
                            value: _ctx.selectBusinessValue,
                            "onUpdate:value": _cache[9] || (_cache[9] = $event => ((_ctx.selectBusinessValue) = $event)),
                            getPopupContainer: _ctx.getPopupContainer,
                            options: _ctx.businessNameList,
                            optionFilterProp: "label",
                            "show-search": "",
                            defaultActiveFirstOption: "",
                            "not-found-content": null,
                            labelInValue: true,
                            onBlur: _ctx.handleSaveBusiness
                          }, null, 8 /* PROPS */, ["value", "getPopupContainer", "options", "onBlur"])
                        ]))
                  ])
                ])
              ]),
              createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                createElementVNode("div", null, toDisplayString(_ctx.companyInfo.companyTypeName || '-'), 1 /* TEXT */)
              ]),
              createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                (
                _ctx.companyInfo.pricePackageDtos &&
                  _ctx.companyInfo.pricePackageDtos.length > 0
              )
                  ? (openBlock(), createElementBlock("div", _hoisted_29, [
                      createElementVNode("span", _hoisted_30, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.companyInfo.pricePackageDtos, (item, index) => {
                          return (openBlock(), createElementBlock("a", {
                            key: index,
                            href: _ctx.urls.pricePackage + item.id,
                            target: "_blank"
                          }, toDisplayString(item.name + (index < _ctx.companyInfo.pricePackageDtos.length - 1 ? '，' : '')), 9 /* TEXT, PROPS */, _hoisted_31))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      (_ctx.showPricePackageCount)
                        ? (openBlock(), createBlock(_component_Popconfirm, {
                            key: 0,
                            visible: _ctx.pricePackageCountVisible,
                            "onUpdate:visible": _cache[12] || (_cache[12] = $event => ((_ctx.pricePackageCountVisible) = $event)),
                            overlayStyle: { width: '300px' },
                            hideBtn: true,
                            popTitle: '价格套餐'
                          }, {
                            content: withCtx(() => [
                              createElementVNode("div", _hoisted_32, [
                                createVNode(_component_a_table, {
                                  dataSource: _ctx.companyInfo.pricePackageDtos,
                                  columns: _ctx.pricePackagesCols,
                                  pagination: false,
                                  showHeader: false,
                                  rowKey: 'id',
                                  tableLayout: "fixed",
                                  bordered: ""
                                }, {
                                  name: withCtx(({ record }) => [
                                    createElementVNode("a", {
                                      href: _ctx.urls.pricePackage + record.id,
                                      target: "_blank"
                                    }, toDisplayString(record.name), 9 /* TEXT, PROPS */, _hoisted_33)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["dataSource", "columns"])
                              ])
                            ]),
                            trigger: withCtx(() => [
                              createElementVNode("span", {
                                class: "customer-tags-count",
                                onClick: _cache[11] || (_cache[11] = $event => (_ctx.pricePackageCountVisible = true))
                              }, " (" + toDisplayString(_ctx.companyInfo.pricePackageDtos.length) + ") ", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["visible"]))
                        : createCommentVNode("v-if", true)
                    ]))
                  : (openBlock(), createElementBlock("div", _hoisted_34, "-"))
              ])
            ])
          ]),
          createCommentVNode(" 分割线 "),
          _hoisted_35,
          createCommentVNode(" 账户信息 "),
          createElementVNode("div", _hoisted_36, [
            createElementVNode("div", _hoisted_37, [
              createElementVNode("h2", null, [
                createTextVNode(" 账户信息 "),
                createElementVNode("i", {
                  class: "iconfont refresh-account-info",
                  title: "点击刷新账户信息",
                  onClick: _cache[13] || (_cache[13] = (...args) => (_ctx.handleRefreshAccountInfo && _ctx.handleRefreshAccountInfo(...args)))
                }, "  ")
              ])
            ]),
            createElementVNode("div", _hoisted_38, [
              createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                (_ctx.companyInfo.creditStatus == _ctx.ECreditStatus.open)
                  ? (openBlock(), createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      createElementVNode("a", {
                        class: "sc-href",
                        href: _ctx.urls.editCredit + _ctx.companyInfo.creditId,
                        target: "_blank"
                      }, " 操作 ", 8 /* PROPS */, _hoisted_43)
                    ]))
                  : (_ctx.companyInfo.creditStatus == _ctx.ECreditStatus.close)
                    ? (openBlock(), createElementBlock("div", _hoisted_44, [
                        _hoisted_45,
                        createElementVNode("a", {
                          class: "sc-href",
                          href: _ctx.urls.addCredit + _ctx.companyInfo.companyId,
                          target: "_blank"
                        }, " 去授信 ", 8 /* PROPS */, _hoisted_46)
                      ]))
                    : (openBlock(), createElementBlock("div", _hoisted_47, [
                        _hoisted_48,
                        createElementVNode("a", {
                          class: "sc-href",
                          href: _ctx.urls.editCredit + _ctx.companyInfo.creditId,
                          target: "_blank"
                        }, " 去解冻 ", 8 /* PROPS */, _hoisted_49)
                      ]))
              ]),
              (_ctx.companyInfo.creditStatus == _ctx.ECreditStatus.open)
                ? (openBlock(), createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    createElementVNode("div", null, [
                      createElementVNode("span", _hoisted_52, "￥" + toDisplayString(_ctx.companyInfo.creditArrearageText), 1 /* TEXT */),
                      ((_ctx.companyInfo.creditArrearage || 0) / 100 > 0)
                        ? (openBlock(), createElementBlock("a", {
                            key: 0,
                            class: "sc-href",
                            href: _ctx.urls.toReceive + _ctx.companyInfo.creditId,
                            target: "_blank"
                          }, " 去收款 ", 8 /* PROPS */, _hoisted_53))
                        : createCommentVNode("v-if", true)
                    ])
                  ]))
                : createCommentVNode("v-if", true),
              (_ctx.companyInfo.creditStatus == _ctx.ECreditStatus.open)
                ? (openBlock(), createElementBlock("div", _hoisted_54, [
                    _hoisted_55,
                    createElementVNode("div", null, "￥" + toDisplayString(_ctx.companyInfo.creditAvailableText), 1 /* TEXT */)
                  ]))
                : createCommentVNode("v-if", true),
              createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                (_ctx.companyInfo.balanceStatus == _ctx.EBalanceStatus.open)
                  ? (openBlock(), createElementBlock("div", _hoisted_58, [
                      createElementVNode("span", _hoisted_59, "￥" + toDisplayString(_ctx.companyInfo.balanceAvailableText), 1 /* TEXT */),
                      createElementVNode("a", {
                        class: "sc-href",
                        href: _ctx.urls.manualRecharge + _ctx.companyInfo.companyId,
                        target: "_blank"
                      }, " 去充值 ", 8 /* PROPS */, _hoisted_60)
                    ]))
                  : (openBlock(), createElementBlock("div", _hoisted_61, [
                      _hoisted_62,
                      createElementVNode("a", {
                        class: "sc-href",
                        href: _ctx.urls.preUpdateCompany + _ctx.companyInfo.companyId,
                        target: "_blank"
                      }, " 去开通 ", 8 /* PROPS */, _hoisted_63)
                    ]))
              ])
            ])
          ])
        ]))
      : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createCommentVNode(" 未选择客户名称时客户信息展示效果 "),
          _hoisted_64
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
    (_ctx.showModal)
      ? (openBlock(), createBlock(_component_CreateCompany, {
          key: 2,
          visible: _ctx.showModal,
          "onUpdate:visible": _cache[14] || (_cache[14] = $event => ((_ctx.showModal) = $event)),
          formState: _ctx.companyFormState,
          "onUpdate:formState": _cache[15] || (_cache[15] = $event => ((_ctx.companyFormState) = $event)),
          onOk: _ctx.handleOk
        }, null, 8 /* PROPS */, ["visible", "formState", "onOk"]))
      : createCommentVNode("v-if", true)
  ]))
}

script$B.render = render$w;
script$B.__file = "packages/company-information/src/CompanyInformation.vue";

script$B.install = (Vue) => {
    Vue.component(script$B.name, script$B);
};

const baseUrl$3 = process.env.VUE_APP_URL;
const urls$3 = {
    getCategory: '/product/public/category/list-category-tree',
    getBrand: '/product/public/brand/list',
    getSeries: '/product/public/series/list-series-by-brand-id',
    getProduct: '/product/public/product/list-by-series-ids',
    uploadLogo: '/product/brand/upload-images',
    listCloudModel: '/product/internal/model/list-cloud-model-by-brand-and-material-no',
    addModel: '/product/model/manual-add-model-channel',
    addBrand: '/product/brand/add-brand',
    addSeries: '/product/series/add-series',
};
// 品类
const getCategoryApi = () => {
    return http({
        url: urls$3.getCategory,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'GET',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 品牌
const getBrandApi = () => {
    return http({
        url: urls$3.getBrand,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'GET',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || [];
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 系列
const getSeriesApi = (brandId) => {
    return http({
        url: urls$3.getSeries + '?brandId=' + brandId,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'GET',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || [];
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 产品
const getProductApi = (params) => {
    return http({
        url: urls$3.getProduct,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || [];
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 单位
const units = [
    '个',
    '只',
    'PCS',
    '包',
    '台',
    '把',
    '支',
    '卷',
    '套',
    '双',
    '根',
    '米',
    '件',
    '副',
    '片',
    '盘',
    '盒',
    '条',
];
const getUnits = () => {
    const unitOptions = [];
    units.forEach((unit) => {
        unitOptions.push({
            id: unit,
            name: unit,
            value: unit,
            label: unit,
        });
    });
    return unitOptions;
};
const uploadLogoApi = (param) => {
    return http({
        url: urls$3.uploadLogo,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryLQRO3VkrvkJzSqMs',
            processData: false,
            contentType: false,
        },
        data: param,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 创建型号
const addModelApi = (params) => {
    return http({
        url: urls$3.addModel,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 添加品牌
const addBrandApi = (params) => {
    return http({
        url: urls$3.addBrand,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 添加系列
const addSeriesApi = (params) => {
    return http({
        url: urls$3.addSeries,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 云产品库型号查询
const listCloudModelApi = (params) => {
    return http({
        url: urls$3.listCloudModel,
        withCredentials: true,
        baseURL: baseUrl$3,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data) {
            return res.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};

// 表单相关字段定义常量
const DOMESTIC_KEY$1 = 'domestic', // 类型
BRAND_NAME_KEY$1 = 'name', // 品牌名称
ENGLISH_NAME_KEY = 'englishName', // 英文名称
BRAND_COLOR_KEY = 'brandColor', // 品牌颜色
BRAND_LOGO_KEY = 'brandLogo', // 品牌logo
BRAND_DESC_KEY = 'description'; // 品牌描述
var script$A = defineComponent({
    name: 'ScCreateBrand',
    components: { BasicFormItem: script$1v, Modal: script$1N, ColorPicker: script$F },
    props: {
        visible: {
            type: [Boolean],
            default: false,
        },
        brandId: {
            type: [String, Number],
        },
        formState: {
            type: Object,
            default: () => ({ [DOMESTIC_KEY$1]: 0 }),
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 表单ref
        const formRef = ref();
        // 表单数据
        // const formStateRef = computed({
        //   get: () => props.formState,
        //   set: (val) => {
        //     emit('update:formState', val);
        //   },
        // });
        const formStateRef = ref(props.formState);
        // 表单项数组
        const formItemsRef = reactive([
            {
                key: DOMESTIC_KEY$1,
                type: 'RadioGroup',
                label: '类型',
                options: [
                    { id: 0, name: '国际品牌' },
                    { id: 1, name: '国内品牌' },
                ],
            },
            {
                key: BRAND_NAME_KEY$1,
                type: 'Input',
                label: '品牌名称',
                placeholder: '请输入品牌名称',
                rules: [
                    {
                        required: true,
                        transform: (value) => value && value.trim(),
                        message: '品牌名称不能为空',
                    },
                    {
                        min: 1,
                        max: 64,
                        transform: (value) => value && value.trim(),
                        message: '品牌名称过长，最多输入64个字',
                    },
                ],
            },
            {
                key: ENGLISH_NAME_KEY,
                type: 'Input',
                label: '英文名称',
                placeholder: '请输入品牌英文名称',
                rules: [
                    {
                        max: 64,
                        transform: (value) => value && value.trim(),
                        message: '英文名称过长，最多输入64个字符',
                    },
                ],
            },
        ]);
        const descriptionItem = reactive({
            key: BRAND_DESC_KEY,
            type: 'TextArea',
            label: '品牌描述',
            placeholder: '请输入品牌描述',
        });
        const handelColorChange = (color) => {
            formStateRef.value[BRAND_COLOR_KEY] = color.hex;
        };
        const fileList = ref([]); // 文件列表
        // 上传营业执照
        const customRequest = async (options) => {
            let params = new FormData();
            params.append('file', options.file);
            const res = await uploadLogoApi(params);
            if (res) {
                message.success('上传成功');
                formStateRef.value[BRAND_LOGO_KEY] = res[0].path;
                fileList.value = [options.file];
            }
            emit('updateFormState', { file: res });
        };
        // 上传文件限制
        const acceptType = 'image/jpg,image/jpeg,image/png';
        const beforeUpload = (file) => {
            console.log(file);
            if (file.type && acceptType.indexOf(file.type) == -1) {
                message.error('仅支持JPG,PNG格式的图片');
                return false;
            }
            else if (file.size && file.size > 1024 * 1024) {
                message.error('图片大小不能超过1M');
                return false;
            }
        };
        // 提交
        const handleOk = () => {
            formRef.value
                .validate()
                .then(async () => {
                const res = await addBrandApi(formStateRef.value);
                if (res) {
                    message.success('添加品牌成功');
                    emit('success', formStateRef.value);
                    visibleRef.value = false;
                }
            })
                .catch((error) => {
                console.log('error', error);
            });
        };
        return {
            formRef,
            visibleRef,
            formStateRef,
            formItemsRef,
            descriptionItem,
            handleOk,
            handelColorChange,
            customRequest,
            fileList,
            acceptType,
            beforeUpload,
            BRAND_LOGO_KEY,
        };
    },
});

const _hoisted_1$v = /*#__PURE__*/createElementVNode("div", { class: "sc-form-desc" }, " 主题色用于商城页面对应品牌名称展示时使用 ", -1 /* HOISTED */);
const _hoisted_2$p = { class: "upload-logo-wrap" };
const _hoisted_3$k = {
  key: 0,
  class: "image-box"
};
const _hoisted_4$g = {
  key: 0,
  class: "change-log-btn"
};
const _hoisted_5$e = /*#__PURE__*/createElementVNode("div", { class: "sc-form-desc" }, " Logo尺寸为36*100px，大小不超过1M，支持JPG，PNG格式 ", -1 /* HOISTED */);

function render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_col = resolveComponent("a-col");
  const _component_ColorPicker = resolveComponent("ColorPicker");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_image = resolveComponent("a-image");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_upload = resolveComponent("a-upload");
  const _component_a_row = resolveComponent("a-row");
  const _component_a_form = resolveComponent("a-form");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, {
    title: "添加品牌",
    class: "sc-create-brand",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visibleRef) = $event)),
    width: "550px",
    onOk: _ctx.handleOk
  }, {
    default: withCtx(() => [
      createVNode(_component_a_form, {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
        colon: false,
        ref: "formRef",
        model: _ctx.formStateRef
      }, {
        default: withCtx(() => [
          createVNode(_component_a_row, { justify: "space-between" }, {
            default: withCtx(() => [
              createVNode(_component_a_col, { span: 22 }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItemsRef, (item) => {
                    return (openBlock(), createBlock(_component_BasicFormItem, {
                      key: item.key,
                      item: item,
                      value: _ctx.formStateRef[item.key],
                      "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event)
                    }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }),
              createVNode(_component_a_col, { span: 22 }, {
                default: withCtx(() => [
                  createVNode(_component_a_form_item, {
                    label: "品牌主题色",
                    labelCol: { span: 6 },
                    colon: false
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_ColorPicker, { onChange: _ctx.handelColorChange }, null, 8 /* PROPS */, ["onChange"]),
                      _hoisted_1$v
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              createVNode(_component_a_col, { span: 22 }, {
                default: withCtx(() => [
                  createVNode(_component_a_form_item, {
                    label: "品牌Logo",
                    labelCol: { span: 6 },
                    colon: false
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_2$p, [
                        (_ctx.formStateRef[_ctx.BRAND_LOGO_KEY])
                          ? (openBlock(), createElementBlock("div", _hoisted_3$k, [
                              createVNode(_component_a_image, {
                                src: _ctx.formStateRef[_ctx.BRAND_LOGO_KEY],
                                alt: "品牌logo加载失败"
                              }, null, 8 /* PROPS */, ["src"])
                            ]))
                          : createCommentVNode("v-if", true),
                        createVNode(_component_a_upload, {
                          class: "sc-upload",
                          "file-list": _ctx.fileList,
                          showUploadList: false,
                          name: "file",
                          accept: _ctx.acceptType,
                          customRequest: _ctx.customRequest,
                          beforeUpload: _ctx.beforeUpload
                        }, {
                          default: withCtx(() => [
                            (_ctx.formStateRef[_ctx.BRAND_LOGO_KEY])
                              ? (openBlock(), createElementBlock("a", _hoisted_4$g, "更换"))
                              : (openBlock(), createBlock(_component_a_button, {
                                  key: 1,
                                  class: "add-logo-btn"
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode("添加")
                                  ]),
                                  _: 1 /* STABLE */
                                }))
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["file-list", "accept", "customRequest", "beforeUpload"])
                      ]),
                      _hoisted_5$e
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              createVNode(_component_a_col, { span: 22 }, {
                default: withCtx(() => [
                  (openBlock(), createBlock(_component_BasicFormItem, {
                    key: _ctx.descriptionItem.key,
                    item: _ctx.descriptionItem,
                    value: _ctx.formStateRef[_ctx.descriptionItem.key],
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.formStateRef[_ctx.descriptionItem.key]) = $event))
                  }, null, 8 /* PROPS */, ["item", "value"]))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "onOk"]))
}

script$A.render = render$v;
script$A.__file = "packages/create-model/src/CreateBrand.vue";

var script$z = defineComponent({
    name: 'ScCreateSeries',
    components: { BasicFormItem: script$1v, Modal: script$1N },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        brandList: {
            type: Array,
            default: () => [],
        },
        formState: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 表单ref
        const formRef = ref();
        // 表单数据
        // const formStateRef = computed({
        //   get: () => props.formState,
        //   set: (val) => {
        //     emit('update:formState', val);
        //   },
        // });
        const formStateRef = ref(props.formState);
        // 品牌列表
        const brandListRef = ref(props.brandList);
        const brandItem = reactive({
            key: 'brandId',
            type: 'Select',
            label: '品牌',
            placeholder: '请选择品牌',
            options: brandListRef.value,
            rules: [
                {
                    required: true,
                    message: '品牌不能为空',
                },
            ],
            props: {
                showSearch: true,
                filterOption: (inputValue, option) => {
                    return option.children[0].children.indexOf(inputValue) != -1;
                },
            },
        });
        // 表单项数组
        const formItemsRef = reactive([
            brandItem,
            {
                key: 'name',
                type: 'Input',
                label: '系列',
                placeholder: '请输入系列名称',
                rules: [
                    {
                        required: true,
                        transform: (value) => value && value.trim(),
                        message: '系列不能为空',
                    },
                    {
                        min: 1,
                        max: 16,
                        transform: (value) => value && value.trim(),
                        message: '系列名称过长，最多输入16个字',
                    },
                ],
            },
            {
                key: 'spg',
                type: 'Input',
                label: '系列组',
                placeholder: '请输入系列组名称',
                rules: [
                    {
                        max: 16,
                        transform: (value) => value && value.trim(),
                        message: '系列组过长，最多输入16个字',
                    },
                ],
            },
            {
                key: 'description',
                type: 'TextArea',
                label: '描述',
                placeholder: '请输入系列描述',
            },
        ]);
        // 提交
        const handleOk = async () => {
            formRef.value
                .validate()
                .then(async () => {
                const res = await addSeriesApi(formStateRef.value);
                if (res) {
                    message.success('添加系列成功');
                    emit('success', formStateRef.value);
                    visibleRef.value = false;
                }
            })
                .catch((error) => {
                console.log('error', error);
            });
        };
        return {
            visibleRef,
            formStateRef,
            formItemsRef,
            handleOk,
            formRef,
        };
    },
});

function render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, mergeProps({
    title: "添加系列",
    class: "sc-create-series",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
    width: "500px"
  }, { ..._ctx.$props, ..._ctx.$attrs }, { onOk: _ctx.handleOk }), {
    default: withCtx(() => [
      createVNode(_component_a_form, {
        labelCol: { span: 6 },
        "wrapper-col": { span: 12 },
        colon: false,
        ref: "formRef",
        model: _ctx.formStateRef
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItemsRef, (item) => {
            return (openBlock(), createBlock(_component_BasicFormItem, {
              key: item.key,
              item: item,
              value: _ctx.formStateRef[item.key],
              "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event)
            }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["visible", "onOk"]))
}

script$z.render = render$u;
script$z.__file = "packages/create-model/src/CreateSeries.vue";

// 表单相关字段定义常量
const CATEGORY_KEY = 'categoryId', // 分类
CATEGORY_NAME_KEY = 'categoryName', BRAND_KEY = 'brandId', // 品牌
BRAND_NAME_KEY = 'brandName', SERIES_KEY = 'seriesId', // 系列
SERIES_NAME_KEY = 'seriesName', PRODUCT_KEY = 'productId', // 产品
PRODUCT_NAME_KEY = 'productName', MODEL_KEY = 'modelName', // 型号
MATERIAL_NO_KEY = 'materialNo', //订货号
MARKEY_PRICE_KEY = 'marketPriceYuan', // 市场价
UNIT_KEY = 'unit', // 单位
DOMESTIC_KEY = 'domestic', // 属地
DISCONTINUE_KEY = 'discontinue'; // 停产
var script$y = defineComponent({
    name: 'ScCreateModel',
    components: {
        BasicFormItem: script$1v,
        ScModal: script$1N,
        CreateBrand: script$A,
        CreateSeries: script$z,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        formState: {
            type: Object,
            default: () => ({
                [DOMESTIC_KEY]: 0,
                [DISCONTINUE_KEY]: 'false',
                [UNIT_KEY]: '个',
            }),
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 单位数组
        const unitOptions = ref([...getUnits()]);
        // 表单ref
        const formRef = ref();
        const initFormState = {
            [DOMESTIC_KEY]: 0,
            [DISCONTINUE_KEY]: 'false',
            [UNIT_KEY]: '个',
        };
        // 表单数据
        const formStateRef = ref(props.formState);
        watch(() => props.formState, () => {
            formStateRef.value = cloneDeep({
                ...initFormState,
                ...props.formState,
            });
        }, { deep: true });
        const filterOption = (inputValue, option) => {
            return option.children[0].children.indexOf(inputValue) != -1;
        };
        /** 分类 */
        const categoryOptions = ref([]);
        function setSelectable(data) {
            data.forEach((item) => {
                // 只支持选择第四级分类
                if (item.level !== 3) {
                    item.selectable = false;
                }
                if (item.children && item.children.length) {
                    setSelectable(item.children);
                }
            });
        }
        // 获取分类列表
        async function getCategoryList() {
            const data = await getCategoryApi();
            if (data) {
                setSelectable(data);
                categoryOptions.value.push(...data);
            }
        }
        getCategoryList();
        // 分类表单项
        const categoryItem = reactive({
            key: CATEGORY_KEY,
            tagKey: CATEGORY_NAME_KEY,
            cascader: [BRAND_KEY, SERIES_KEY, PRODUCT_KEY],
            type: 'TreeSelect',
            label: '分类',
            placeholder: '其他',
            options: categoryOptions.value,
            props: {
                showSearch: true,
                treeNodeFilterProp: 'title',
                dropdownStyle: { maxHeight: '400px', overflow: 'auto', zIndex: 99999 },
            },
        });
        // 添加品牌
        const showBrandModal = ref(false);
        const addNewBrand = () => {
            showBrandModal.value = true;
        };
        // 添加系列
        const showSeriesModal = ref(false);
        const addNewSeries = () => {
            showSeriesModal.value = true;
        };
        /** 品牌 */
        const brandList = ref([]);
        // 品牌表单项 `如需增加新品牌，请<a onclick="addNewBrand()">点击此处</a>`
        const brandItem = reactive({
            tagKey: BRAND_NAME_KEY,
            key: BRAND_KEY,
            type: 'Select',
            label: '品牌',
            placeholder: '其他',
            desc: h('span', [
                '如需增加新品牌，请',
                h('a', { onclick: addNewBrand }, ' 点击此处'),
            ]),
            options: brandList.value,
            props: {
                showSearch: true,
                focus: getBrandList,
                filterOption: filterOption,
            },
        });
        // 获取品牌列表数据
        async function getBrandList() {
            const data = await getBrandApi();
            if (data) {
                brandList.value.splice(0);
                brandList.value.push(...data);
            }
        }
        getBrandList();
        /** 系列 */
        const seriesList = ref([]);
        // 系列表单项
        const seriesItem = reactive({
            tagKey: SERIES_NAME_KEY,
            key: SERIES_KEY,
            cascader: [BRAND_KEY],
            type: 'Select',
            label: '系列',
            placeholder: '其他',
            desc: h('span', [
                '如需增加新系列，请',
                h('a', { onclick: addNewSeries }, ' 点击此处'),
            ]),
            options: seriesList.value,
            props: {
                showSearch: true,
                filterOption: filterOption,
            },
        });
        // 获取系列列表数据
        async function getSeriesList(brandId) {
            const data = await getSeriesApi(brandId || '');
            if (data) {
                seriesList.value.splice(0);
                seriesList.value.push(...data);
            }
        }
        getSeriesList();
        /** 产品 */
        // originProducts:用来存储对应产品项相关数据
        const originProducts = ref({});
        const productList = ref([]);
        // 产品表单项
        const productItem = reactive({
            tagKey: PRODUCT_NAME_KEY,
            key: PRODUCT_KEY,
            cascader: [BRAND_KEY, SERIES_KEY],
            type: 'Select',
            label: '产品名称',
            placeholder: '其他',
            options: productList.value,
            props: {
                showSearch: true,
                filterOption: filterOption,
                change: (val) => {
                    if (originProducts.value[val]) {
                        formStateRef.value[CATEGORY_KEY] =
                            originProducts.value[val][CATEGORY_KEY];
                        formStateRef.value[CATEGORY_NAME_KEY] =
                            originProducts.value[val].categoryName;
                        categoryItem.props && (categoryItem.props.disabled = true);
                    }
                    else {
                        formStateRef.value[CATEGORY_KEY] = null;
                        categoryItem.props && (categoryItem.props.disabled = false);
                    }
                },
            },
        });
        // 获取产品列表数据
        async function getProductList(seriesId) {
            const data = await getProductApi(JSON.stringify(seriesId ? [seriesId] : []));
            if (data) {
                productList.value.splice(0);
                originProducts.value = {};
                productList.value.push(...data.map((item) => {
                    originProducts.value[item.id] = item;
                    return {
                        id: item.id,
                        name: item.name,
                        value: item.id,
                        label: item.name,
                    };
                }));
            }
        }
        getProductList();
        // 市场价表单项
        const marketPriceItem = reactive({
            key: MARKEY_PRICE_KEY,
            type: 'Input',
            maxlength: 10,
            label: '市场价',
            placeholder: '请输入市场价',
            rules: [
                {
                    required: true,
                    message: '市场价不能为空',
                },
                {
                    pattern: VALIDATOR.pattern.money,
                    message: VALIDATOR.message.money,
                },
                {
                    type: 'number',
                    min: 0.01,
                    max: 9999999.99,
                    validator: VALIDATOR.validate.ranger,
                    message: '市场价有效范围0.01~9,999,999.99',
                },
            ],
        });
        // 表单项数组
        const formItemsRef = reactive([
            brandItem,
            seriesItem,
            productItem,
            categoryItem,
            {
                key: MODEL_KEY,
                type: 'Input',
                label: '型号',
                placeholder: '请输入型号',
                rules: [
                    {
                        required: true,
                        message: '型号不能为空',
                    },
                    { min: 1, max: 100, message: '长度在1 ~ 100之间' },
                ],
                props: {
                    onChange: () => {
                        formStateRef.value[MATERIAL_NO_KEY] = formStateRef.value[MODEL_KEY];
                    },
                },
            },
            {
                key: MATERIAL_NO_KEY,
                type: 'Input',
                label: '订货号',
                placeholder: '请输入订货号',
                rules: [
                    {
                        required: true,
                        message: '订货号不能为空',
                    },
                    { min: 1, max: 128, message: '长度在1 ~ 128之间' },
                ],
            },
            marketPriceItem,
            {
                key: UNIT_KEY,
                type: 'Select',
                label: '单位',
                placeholder: '请选择单位',
                rules: [
                    {
                        required: true,
                        message: '单位不能为空',
                    },
                ],
                options: unitOptions.value,
            },
            {
                key: DOMESTIC_KEY,
                type: 'RadioGroup',
                label: '属地',
                placeholder: '请选择属地',
                options: [
                    { id: 1, name: '国产' },
                    { id: 0, name: '进口' },
                ],
            },
            {
                key: DISCONTINUE_KEY,
                type: 'RadioGroup',
                label: '停产',
                placeholder: '请选择停产',
                options: [
                    { id: 'true', name: '是' },
                    { id: 'false', name: '否' },
                ],
            },
        ]);
        // 提交
        const handleOk = async () => {
            formRef.value
                .validate()
                .then(async () => {
                // 默认期货上架, channelIds的值为3
                formStateRef.value.channelIds = [3];
                formStateRef.value[MARKEY_PRICE_KEY] &&
                    (formStateRef.value.marketPrice = math.accMul(formStateRef.value[MARKEY_PRICE_KEY], 100));
                const handleAddModelApi = async () => {
                    const res = await addModelApi(formStateRef.value);
                    const { code, data } = res;
                    if (code === 0 && data) {
                        message.success('添加成功，型号已成功添加到我的型号库中');
                        visibleRef.value = false;
                        emit('success', formStateRef.value, data); // 型号创建成功后会返回shopModelId,该字段在组件之外会用到,所以也需要暴露出来
                        formStateRef.value = cloneDeep(initFormState);
                        categoryItem.props && (categoryItem.props.disabled = false);
                    }
                };
                const cloudBrandId = (originProducts.value[formStateRef.value[PRODUCT_KEY]] &&
                    originProducts.value[formStateRef.value[PRODUCT_KEY]]
                        .cloudBrandId) ||
                    0;
                if (cloudBrandId) {
                    const res = await listCloudModelApi(JSON.stringify({
                        brandId: formStateRef.value.brandId,
                        cloudBrandId: cloudBrandId,
                        materialNo: formStateRef.value.materialNo,
                    }));
                    if (res.code == 0) {
                        handleAddModelApi();
                    }
                    else if (res.code == 4102) {
                        Modal.confirm({
                            title: '提示',
                            content: `【${formStateRef.value.brandName}】品牌中订货号【${formStateRef.value.materialNo}】已存在，请修改后重试`,
                        });
                    }
                    else {
                        message.error(res.message || '系统错误，请稍后重试...');
                    }
                }
                else {
                    handleAddModelApi();
                }
            })
                .catch((error) => {
                console.log('error', error);
            });
        };
        // 挂载到父级弹框中
        const getContainer = () => {
            return document.getElementsByClassName('sc-create-model')[0];
        };
        // 级联获取options
        const getOptions = (key, oKeywords) => {
            if (key === SERIES_KEY)
                return getSeriesList(oKeywords[BRAND_KEY]);
            if (key === PRODUCT_KEY)
                return getProductList(oKeywords[SERIES_KEY]);
            return [];
        };
        //级联缓存
        const cacheKeywords = {};
        const isChanged = (key, oKeywords) => {
            let rlt = !_.isEqual(cacheKeywords[key], oKeywords);
            if (rlt)
                cacheKeywords[key] = { ..._.cloneDeep(oKeywords) };
            return rlt;
        };
        // 级联事件，获取新的options
        provide('getOptions', (key, cascader, value) => {
            if (typeof cascader === 'string')
                cascader = [cascader];
            // 级联选项的前置keywords条件
            const oKeywords = {};
            cascader.map((k) => (oKeywords[k] = formStateRef.value[k]));
            // cascader中包含当前组件key的处理,
            if (cascader.indexOf(key) >= 0)
                delete oKeywords[key];
            // search事件,当前组件的value值
            if (value)
                oKeywords[key] = value;
            return isChanged(key, oKeywords) && getOptions(key, oKeywords);
        });
        // 依据级联属性cascader（父数组）生成级联子数组childrenCascader
        const childrenCascader = {};
        const createChildrenCascader = () => {
            const cascaderItems = formItemsRef.filter((item) => item.cascader);
            cascaderItems.map((item) => {
                const cascader = Array.isArray(item.cascader)
                    ? item.cascader
                    : [item.cascader];
                cascader.map((casKey) => casKey &&
                    casKey !== item.key &&
                    (childrenCascader[casKey] || (childrenCascader[casKey] = [])) &&
                    childrenCascader[casKey].push(item.key));
            });
        };
        createChildrenCascader();
        // 级联事件，清除已选值
        provide('childrenCascader', childrenCascader);
        provide('clearSelected', (key, childrenCascaderKeys) => {
            childrenCascaderKeys.map((k) => {
                delete formStateRef.value[k];
            });
            categoryItem.props && (categoryItem.props.disabled = false);
        });
        return {
            formRef,
            visibleRef,
            formStateRef,
            formItemsRef,
            handleOk,
            brandList,
            showBrandModal,
            showSeriesModal,
            getContainer,
        };
    },
});

function render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_CreateBrand = resolveComponent("CreateBrand");
  const _component_CreateSeries = resolveComponent("CreateSeries");
  const _component_ScModal = resolveComponent("ScModal");

  return (openBlock(), createBlock(_component_ScModal, mergeProps({
    class: "sc-create-model",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => ((_ctx.visibleRef) = $event)),
    width: "740px"
  }, { ..._ctx.$props, ..._ctx.$attrs }, {
    okText: "添加",
    onOk: _ctx.handleOk
  }), {
    default: withCtx(() => [
      createVNode(_component_a_form, {
        class: "sc-create-model-form",
        labelCol: { span: 6 },
        "wrapper-col": { span: 18 },
        colon: false,
        ref: "formRef",
        model: _ctx.formStateRef
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItemsRef, (item) => {
            return (openBlock(), createBlock(_component_BasicFormItem, {
              key: item.key,
              item: item,
              value: _ctx.formStateRef[item.key],
              "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event),
              tag: _ctx.formStateRef[item.tagKey],
              "onUpdate:tag": $event => ((_ctx.formStateRef[item.tagKey]) = $event)
            }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value", "tag", "onUpdate:tag"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"]),
      (_ctx.showBrandModal)
        ? (openBlock(), createBlock(_component_CreateBrand, {
            key: 0,
            visible: _ctx.showBrandModal,
            "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.showBrandModal) = $event)),
            getContainer: _ctx.getContainer
          }, null, 8 /* PROPS */, ["visible", "getContainer"]))
        : createCommentVNode("v-if", true),
      (_ctx.showSeriesModal)
        ? (openBlock(), createBlock(_component_CreateSeries, {
            key: 1,
            visible: _ctx.showSeriesModal,
            "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.showSeriesModal) = $event)),
            formState: { brandId: _ctx.formStateRef.brandId },
            brandList: _ctx.brandList,
            getContainer: _ctx.getContainer
          }, null, 8 /* PROPS */, ["visible", "formState", "brandList", "getContainer"]))
        : createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["visible", "onOk"]))
}

script$y.render = render$t;
script$y.__file = "packages/create-model/src/CreateModel.vue";

script$y.install = (Vue) => {
    Vue.component(script$y.name, script$y);
    Vue.component(script$A.name, script$A);
    Vue.component(script$z.name, script$z);
};

const curmbProps = {
    title: {
        type: String,
        default: '',
    },
    currentUrl: {
        type: String,
        default: '',
    },
};
var script$x = defineComponent({
    name: 'Crumb',
    props: curmbProps,
    setup(props) {
        const title = ref(props.title);
        if (props.currentUrl) {
            http({
                method: 'post',
                baseURL: process.env.VUE_APP_URL,
                withCredentials: true,
                url: '/acl/resource/describe-navigation-bar-info',
                params: { url: props.currentUrl },
            }).then((res) => {
                if (res.status === 200) {
                    if (res.data.code === 0) {
                        title.value = res.data.data.title;
                        window.document.title = title.value;
                    }
                }
            });
        }
        return {
            title,
        };
    },
});

const _hoisted_1$u = { class: "main-crumb" };
const _hoisted_2$o = { class: "main-crumb-title" };
const _hoisted_3$j = { class: "main-crumb-btns" };

function render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$u, [
    createElementVNode("span", _hoisted_2$o, toDisplayString(_ctx.title), 1 /* TEXT */),
    createElementVNode("div", _hoisted_3$j, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]))
}

script$x.render = render$s;
script$x.__file = "packages/crumb/crumb.vue";

script$x.install = (Vue) => {
    Vue.component(script$x.name, script$x);
};

const customInputGroupProps = {
    selectOps: {
        type: Array,
        default: [],
    },
    width: {
        type: String,
        default: '270px',
    },
    selectInputVal: {
        type: Object,
        default: {},
    },
};
var script$w = defineComponent({
    name: 'CustomInputGroup',
    components: {
        MultiSelect: script$1G,
        CaretDownFilled,
        [Dropdown.name]: Dropdown,
    },
    props: customInputGroupProps,
    setup(props, { emit }) {
        const pathname = window.location.pathname;
        const localSelect = getState(pathname + '&CustomInputGroup');
        const selectValue = ref(localSelect ? localSelect.id : props.selectOps[0].id);
        const selectName = ref(localSelect ? localSelect.name : props.selectOps[0].name);
        const isShowInput = ref(true);
        const childOps = ref([]);
        const multiSelectIds = ref([]);
        const inpusValue = ref();
        const selectItem = ref(props.selectOps[0]);
        watch(selectValue, (val) => {
            const selected = props.selectOps.find((item) => item.id === val);
            if (selected && selected.childOps) {
                childOps.value.splice(0);
                childOps.value.push(...selected.childOps);
            }
            isShowInput.value = !(selected && selected.childOps);
            selectName.value = selected.name;
            inpusValue.value = isShowInput.value ? '' : [];
            multiSelectIds.value.splice(0);
            setState(pathname + '&CustomInputGroup', {
                id: selectValue.value,
                name: selectName.value,
            });
            selectItem.value = { ...selected };
        });
        watch(props, (val) => {
            const selected = props.selectOps.find((item) => item.id === selectValue.value);
            if (selected && selected.childOps) {
                childOps.value.splice(0);
                childOps.value.push(...selected.childOps);
            }
            isShowInput.value = !(selected && selected.childOps);
            selectName.value = selected.name;
            selectItem.value = { ...selected };
            inpusValue.value =
                val.selectInputVal[selectValue.value] ||
                    (isShowInput.value ||
                        (selectItem.value.type && selectItem.value.type == 'single')
                        ? null
                        : []);
        });
        const onSelectedChange = (val) => {
            inpusValue.value = val.id;
            emit('onValueChange', {
                [selectValue.value]: val.id,
                selectValues: val.name,
            }, selectValue.value);
        };
        const onSingleChange = (value, option) => {
            emit('onValueChange', {
                [selectValue.value]: value,
                selectValues: option.name,
            }, selectValue.value);
        };
        const onInpusChange = (e) => {
            emit('onValueChange', { [selectValue.value]: e.target.value }, selectValue.value);
        };
        const onSearch = (val) => {
            emit('onInputChange', { [selectValue.value]: val });
        };
        const onChange = ({ item, key }) => {
            selectName.value = item.value;
            selectValue.value = key;
            emit('onSelectChange', { [selectValue.value]: key });
        };
        return {
            selectItem,
            selectValue,
            isShowInput,
            childOps,
            inpusValue,
            multiSelectIds,
            onSingleChange,
            onSelectedChange,
            onInpusChange,
            selectName,
            onChange,
            onSearch,
            ...props,
        };
    },
});

function render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CaretDownFilled = resolveComponent("CaretDownFilled");
  const _component_a_menu_item = resolveComponent("a-menu-item");
  const _component_a_menu = resolveComponent("a-menu");
  const _component_a_dropdown = resolveComponent("a-dropdown");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_MultiSelect = resolveComponent("MultiSelect");
  const _component_a_input_group = resolveComponent("a-input-group");

  return (openBlock(), createElementBlock("div", {
    class: "wrapper",
    style: normalizeStyle({ width: _ctx.width })
  }, [
    createVNode(_component_a_input_group, { class: "group" }, {
      default: withCtx(() => [
        createVNode(_component_a_dropdown, {
          getPopupContainer: 
          (triggerNode) => {
            return triggerNode.parentNode || _ctx.document.body;
          }
        ,
          class: "group-one",
          dropdownClassName: "drop-menu"
        }, {
          overlay: withCtx(() => [
            createVNode(_component_a_menu, { onClick: _ctx.onChange }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectOps, (item) => {
                  return (openBlock(), createBlock(_component_a_menu_item, {
                    key: item.id,
                    value: item.name
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]),
          default: withCtx(() => [
            createElementVNode("a", {
              class: "ant-dropdown-link",
              onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
            }, [
              createVNode(_component_CaretDownFilled),
              createTextVNode(" " + toDisplayString(_ctx.selectName), 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["getPopupContainer"]),
        (_ctx.isShowInput)
          ? (openBlock(), createBlock(_component_a_input, {
              key: 0,
              class: "group-two",
              placeholder: '请输入' + _ctx.selectName,
              value: _ctx.inpusValue,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.inpusValue) = $event)),
              onInput: _ctx.onInpusChange,
              allowClear: ""
            }, null, 8 /* PROPS */, ["placeholder", "value", "onInput"]))
          : (_ctx.selectItem.type && _ctx.selectItem.type == 'single')
            ? (openBlock(), createBlock(_component_a_select, {
                key: 1,
                class: "group-two-select",
                placeholder: '请选择' + _ctx.selectName,
                allowClear: "",
                "show-search": "",
                onChange: _ctx.onSingleChange,
                value: _ctx.inpusValue,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.inpusValue) = $event))
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.childOps, (item) => {
                    return (openBlock(), createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(item.name), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["placeholder", "onChange", "value"]))
            : (openBlock(), createBlock(_component_MultiSelect, {
                key: 2,
                class: "group-two",
                allowClear: "",
                optionData: _ctx.childOps,
                mode: "multiple",
                isSelectAll: "",
                isClear: "",
                placeholder: '请选择' + _ctx.selectName,
                value: _ctx.inpusValue,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.inpusValue) = $event)),
                maxTagCount: 1,
                maxTagTextLength: 4,
                onOnOk: _ctx.onSelectedChange,
                onSearch: _ctx.onSearch
              }, null, 8 /* PROPS */, ["optionData", "placeholder", "value", "onOnOk", "onSearch"]))
      ]),
      _: 1 /* STABLE */
    })
  ], 4 /* STYLE */))
}

script$w.render = render$r;
script$w.__file = "packages/custom-input-group/CustomInputGroup.vue";

script$w.install = (Vue) => {
    Vue.component(script$w.name, script$w);
};

var script$v = defineComponent({
    name: 'ScDescriptionsDataList',
    components: {
        InfoCircleOutlined,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes;
        },
    },
    props: {
        column: {
            type: Number,
            default: 1,
        },
        labelLength: {
            type: Number,
            default: 3,
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        const isString = (content) => typeof content === 'string';
        const isVNode = (content) => typeof content == 'object' && content.__v_isVNode;
        return {
            isString,
            isVNode,
        };
    },
    methods: {
        contentClick(s) {
            copy(String(s ?? ''));
        },
        showComparisonValue(item) {
            return (item.comparisonValue !== undefined &&
                !Object.is(item.value, item.comparisonValue));
        },
    },
});

const _hoisted_1$t = { class: "content-text" };
const _hoisted_2$n = ["onClick"];
const _hoisted_3$i = ["innerHTML"];
const _hoisted_4$f = ["onClick"];
const _hoisted_5$d = { class: "comparison" };
const _hoisted_6$9 = ["innerHTML"];
const _hoisted_7$8 = /*#__PURE__*/createElementVNode("span", null, /*#__PURE__*/toDisplayString(')'), -1 /* HOISTED */);

function render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InfoCircleOutlined = resolveComponent("InfoCircleOutlined");
  const _component_a_popover = resolveComponent("a-popover");
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_a_col = resolveComponent("a-col");

  return (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.datas, (item, index) => {
    return (openBlock(), createBlock(_component_a_col, {
      key: index,
      span: 24 / (item.column || _ctx.column),
      gutter: 16
    }, {
      default: withCtx(() => [
        createElementVNode("span", {
          class: "label",
          style: normalizeStyle({ width: (item.labelLength || _ctx.labelLength) * 24 + 'px' })
        }, [
          createTextVNode(toDisplayString(item.label) + " ", 1 /* TEXT */),
          (_ctx.isString(item.tooltip))
            ? (openBlock(), createBlock(_component_a_popover, { key: 0 }, {
                content: withCtx(() => [
                  createTextVNode(toDisplayString(item.tooltip), 1 /* TEXT */)
                ]),
                default: withCtx(() => [
                  createVNode(_component_InfoCircleOutlined)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            : (_ctx.isVNode(item.tooltip))
              ? (openBlock(), createBlock(_component_v_nodes, {
                  key: 1,
                  vnodes: item.tooltip
                }, null, 8 /* PROPS */, ["vnodes"]))
              : createCommentVNode("v-if", true)
        ], 4 /* STYLE */),
        createElementVNode("span", _hoisted_1$t, [
          createElementVNode("span", {
            title: "点击复制",
            onClick: $event => (_ctx.contentClick(item.value))
          }, [
            createElementVNode("span", {
              innerHTML: item.value
            }, null, 8 /* PROPS */, _hoisted_3$i)
          ], 8 /* PROPS */, _hoisted_2$n),
          (_ctx.showComparisonValue(item))
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                title: "点击复制",
                onClick: $event => (_ctx.contentClick(item.comparisonValue))
              }, [
                createElementVNode("span", _hoisted_5$d, [
                  createElementVNode("span", null, toDisplayString('('), 1 /* TEXT */),
                  createElementVNode("span", {
                    class: "value",
                    innerHTML: `${item.comparisonValue}`
                  }, null, 8 /* PROPS */, _hoisted_6$9),
                  _hoisted_7$8
                ])
              ], 8 /* PROPS */, _hoisted_4$f))
            : createCommentVNode("v-if", true),
          createVNode(_component_v_nodes, {
            vnodes: item.vNode
          }, null, 8 /* PROPS */, ["vnodes"])
        ])
      ]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["span"]))
  }), 128 /* KEYED_FRAGMENT */))
}

script$v.render = render$q;
script$v.__file = "packages/descriptions/src/DescriptionsDataList.vue";

var script$u = defineComponent({
    name: 'ScDescriptions',
    components: {
        RightOutlined,
        DescriptionsDataList: script$v,
    },
    props: {
        column: {
            type: Number,
            default: 1,
        },
        labelLength: {
            type: Number,
            default: 3,
        },
        datas: {
            type: Array,
            default: () => [],
        },
        moreOptionsIndex: {
            type: Number,
            default: 0,
        },
    },
    setup(props) {
        const moreOptionsSliceToEndVisible = ref(false);
        const changeMoreOptionsSliceToEndVisible = () => {
            moreOptionsSliceToEndVisible.value = !moreOptionsSliceToEndVisible.value;
        };
        const sliceDatas = computed(() => {
            if (props.moreOptionsIndex > 0) {
                return {
                    moreOptionsSliceToIndex: props.datas.slice(0, props.moreOptionsIndex),
                    moreOptionsSliceToEnd: props.datas.slice(props.moreOptionsIndex),
                };
            }
            return {
                moreOptionsSliceToIndex: [],
                moreOptionsSliceToEnd: [],
            };
        });
        return {
            sliceDatas,
            moreOptionsSliceToEndVisible,
            changeMoreOptionsSliceToEndVisible,
        };
    },
    methods: {
        contentClick(s) {
            copy(String(s ?? ''));
        },
    },
});

const _hoisted_1$s = /*#__PURE__*/createElementVNode("span", { class: "mr" }, "更多信息", -1 /* HOISTED */);
const _hoisted_2$m = { class: "displays" };

function render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DescriptionsDataList = resolveComponent("DescriptionsDataList");
  const _component_a_row = resolveComponent("a-row");
  const _component_RightOutlined = resolveComponent("RightOutlined");
  const _component_a_col = resolveComponent("a-col");

  return (_ctx.moreOptionsIndex === 0)
    ? (openBlock(), createBlock(_component_a_row, {
        key: 0,
        class: "sc-descriptions"
      }, {
        default: withCtx(() => [
          createVNode(_component_DescriptionsDataList, {
            datas: _ctx.datas,
            labelLength: _ctx.labelLength,
            column: _ctx.column
          }, null, 8 /* PROPS */, ["datas", "labelLength", "column"])
        ]),
        _: 1 /* STABLE */
      }))
    : (openBlock(), createBlock(_component_a_row, {
        key: 1,
        class: "sc-descriptions"
      }, {
        default: withCtx(() => [
          createVNode(_component_DescriptionsDataList, {
            datas: _ctx.sliceDatas.moreOptionsSliceToIndex,
            labelLength: _ctx.labelLength,
            column: _ctx.column
          }, null, 8 /* PROPS */, ["datas", "labelLength", "column"]),
          createVNode(_component_a_col, { span: 24 }, {
            default: withCtx(() => [
              createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.changeMoreOptionsSliceToEndVisible && _ctx.changeMoreOptionsSliceToEndVisible(...args))),
                class: "sc-descriptions-more-info"
              }, [
                _hoisted_1$s,
                createElementVNode("span", null, [
                  createVNode(_component_RightOutlined, {
                    rotate: _ctx.moreOptionsSliceToEndVisible ? 90 : 180
                  }, null, 8 /* PROPS */, ["rotate"])
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          withDirectives(createElementVNode("div", _hoisted_2$m, [
            createVNode(_component_DescriptionsDataList, {
              datas: _ctx.sliceDatas.moreOptionsSliceToEnd,
              labelLength: _ctx.labelLength,
              column: _ctx.column
            }, null, 8 /* PROPS */, ["datas", "labelLength", "column"])
          ], 512 /* NEED_PATCH */), [
            [vShow, _ctx.moreOptionsSliceToEndVisible === true]
          ])
        ]),
        _: 1 /* STABLE */
      }))
}

script$u.render = render$p;
script$u.__file = "packages/descriptions/src/Descriptions.vue";

script$u.install = (Vue) => {
    Vue.component(script$u.name, script$u);
};

var script$t = defineComponent({
    name: 'ScDescriptionsForm',
    components: {
        BasicFormItem: script$1v,
    },
    props: {
        formItems: {
            type: Array,
            default: () => [],
            // 传入以下item属性，切换其他状态
            // item.textStatus:{text:{},edit:{}}
        },
        formState: {
            type: Object,
            default: () => ({ keywords: {}, tags: {} }),
        },
        labelAlign: {
            type: String,
            default: 'left',
        },
        labelLength: {
            type: Number,
            default: 4,
        },
        colon: {
            type: [Boolean],
            default: false,
        },
        // 是否显示编辑按钮
        editable: {
            type: [Boolean],
            default: true,
        },
        // 默认状态, 文本
        editStatus: {
            type: [Boolean],
            default: false,
        },
        // false ,不spin提示; true只显示icon不显示文本; string,显示loadding和文本值
        loadding: {
            type: [Boolean, String],
            default: 'loadding...',
        },
    },
    setup(props, { emit, attrs }) {
        // label宽度
        const labelColRef = computed(() => ({
            style: { width: 18 + props.labelLength * 12 + 'px' },
        }));
        // 表单ref
        const formRef = ref();
        // 表单数据
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => {
                emit('update:formState', val);
            },
        });
        // loading
        const spinningRef = ref(false);
        const tipRef = ref('');
        // 表单原始值
        let formStateOrigin = ref({ keywords: {}, tags: {} });
        // 开启文本状态
        const editStatusRef = ref(props.editStatus);
        const handleActiveEdit = (val, isHandle = false) => {
            // 清空表单验证提示
            formRef.value.clearValidate();
            // 开启编辑-暂存原始值
            val && (formStateOrigin.value = _.cloneDeep(props.formState));
            // 切换表单项状态
            props.formItems.forEach((item) => {
                if (!item.notEdit)
                    item.isText = !val;
                if (item.textStatus) {
                    const key = val ? 'edit' : 'text';
                    const model = item.textStatus[key];
                    if (model) {
                        model.isText !== undefined && (item.isText = model.isText);
                        model.isHide !== undefined && (item.isHide = model.isHide);
                        model.column !== undefined && (item.column = model.column);
                        model.disabled !== undefined &&
                            (item.props
                                ? (item.props.disabled = model.disabled)
                                : (item.props = { disabled: model.disabled }));
                    }
                }
            });
            editStatusRef.value = val;
            // true 编辑模式， false 文本模式
            emit('update:editStatus', val);
            emit('activeEdit', val, attrs.id, isHandle);
        };
        onMounted(() => handleActiveEdit(editStatusRef.value));
        // 监听编辑状态 **表单项更新没有监听到，以后再处理**
        watch(() => props.editStatus, handleActiveEdit);
        // 提交
        const handleSubmitForm = () => {
            formRef.value
                .validate()
                .then(() => {
                spinningRef.value = !!props.loadding;
                tipRef.value =
                    typeof props.loadding === 'string' ? props.loadding : '';
                const callback = (cb) => {
                    cb && handleActiveEdit(false, true); // **监听会重复执行该方法**
                    spinningRef.value = false;
                };
                emit('submit', toRaw(formStateRef.value), callback, attrs.id);
            })
                .catch((error) => {
                console.log('error', error);
            });
        };
        const handleCancelForm = () => {
            // 取消编辑时还原初始值
            formStateRef.value.keywords = formStateOrigin.value.keywords;
            formStateRef.value.tags = formStateOrigin.value.tags;
            formRef.value.clearValidate();
            handleActiveEdit(false, true);
            emit('cancel', toRaw(formStateRef.value), attrs.id);
        };
        return {
            tipRef,
            spinningRef,
            formRef,
            formStateRef,
            toRaw,
            handleActiveEdit,
            handleSubmitForm,
            handleCancelForm,
            editStatusRef,
            labelColRef,
        };
    },
});

const _hoisted_1$r = /*#__PURE__*/createElementVNode("i", { class: "iconfont sc-descriptions-form-icon" }, "", -1 /* HOISTED */);

function render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_spin = resolveComponent("a-spin");
  const _component_a_form = resolveComponent("a-form");

  return (openBlock(), createBlock(_component_a_form, {
    class: normalizeClass(["sc-descriptions-form", 'sc-descriptions-form-' + (_ctx.editStatusRef ? 'isedit' : 'istext')]),
    labelAlign: _ctx.labelAlign,
    labelCol: _ctx.labelColRef,
    colon: _ctx.colon,
    ref: "formRef",
    model: _ctx.formStateRef.keywords
  }, {
    default: withCtx(() => [
      (_ctx.editable)
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["sc-descriptions-form-button", { 'sc-descriptions-form-loadding': _ctx.spinningRef }])
          }, [
            (!_ctx.editStatusRef)
              ? (openBlock(), createBlock(_component_a_button, {
                  key: 0,
                  type: "link",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.handleActiveEdit(true, true)))
                }, {
                  icon: withCtx(() => [
                    _hoisted_1$r
                  ]),
                  default: withCtx(() => [
                    createTextVNode(" 编辑")
                  ]),
                  _: 1 /* STABLE */
                }))
              : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createVNode(_component_a_button, {
                    type: "link",
                    onClick: _ctx.handleSubmitForm
                  }, {
                    default: withCtx(() => [
                      createTextVNode("保存")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"]),
                  createVNode(_component_a_button, {
                    type: "text",
                    onClick: _ctx.handleCancelForm
                  }, {
                    default: withCtx(() => [
                      createTextVNode("取消")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ], 64 /* STABLE_FRAGMENT */))
          ], 2 /* CLASS */))
        : createCommentVNode("v-if", true),
      createVNode(_component_a_spin, {
        tip: _ctx.tipRef,
        spinning: _ctx.spinningRef
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItems, (item) => {
            return (openBlock(), createBlock(_component_BasicFormItem, {
              key: item.key,
              item: item,
              value: _ctx.formStateRef.keywords[item.key],
              "onUpdate:value": $event => ((_ctx.formStateRef.keywords[item.key]) = $event),
              tag: _ctx.formStateRef.tags[item.key],
              "onUpdate:tag": $event => ((_ctx.formStateRef.tags[item.key]) = $event),
              isCols: "",
              isSingleEdit: false
            }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value", "tag", "onUpdate:tag"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["tip", "spinning"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "labelAlign", "labelCol", "colon", "model"]))
}

script$t.render = render$o;
script$t.__file = "packages/descriptions-form/src/DescriptionsForm.vue";

script$t.install = (Vue) => {
    Vue.component(script$t.name, script$t);
};

/**
 * props
 * panels: 面板数组 ICollapsePanel[]
 * formState: 表单数据
 * rowConfig、colConfig: antd栅格组件默认配置
 * showPrefixIcon: 是否显示前缀图标，默认false
 */
var script$s = defineComponent({
    name: 'ScDetailPageForm',
    components: { Collapse: script$H, CollapsePanel: script$G, BasicFormItem: script$1v },
    props: {
        panels: {
            type: Array,
            default: () => [],
        },
        formState: {
            type: Object,
            default: () => ({}),
        },
        rowConfig: {
            type: Object,
            default: () => ({}),
        },
        colConfig: {
            type: Object,
            default: () => ({}),
        },
        showPrefixIcon: {
            type: [Boolean],
            default: false,
        },
    },
    setup(props, { emit }) {
        // 表单数据
        const formStateRef = computed({
            get: () => props.formState,
            set: (val) => {
                emit('update:formState', val);
            },
        });
        // 面板
        const activeKeys = ref([]);
        const collapsePanels = computed({
            get: () => props.panels,
            set: (val) => {
                emit('update:panels', val);
            },
        });
        collapsePanels.value.forEach((item) => {
            activeKeys.value.push(item.key);
        });
        return {
            activeKeys,
            formStateRef,
            collapsePanels,
        };
    },
});

const _hoisted_1$q = { class: "ant-form-item-no-colon" };
const _hoisted_2$l = ["innerHTML"];
const _hoisted_3$h = ["innerHTML"];
const _hoisted_4$e = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont show-tip-icon",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_5$c = ["onClick"];

function render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tooltip = resolveComponent("a-tooltip");
  const _component_a_col = resolveComponent("a-col");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_row = resolveComponent("a-row");
  const _component_CollapsePanel = resolveComponent("CollapsePanel");
  const _component_Collapse = resolveComponent("Collapse");
  const _component_a_form = resolveComponent("a-form");

  return (openBlock(), createBlock(_component_a_form, {
    class: "sc-detail-page-form",
    model: _ctx.formStateRef
  }, {
    default: withCtx(() => [
      createVNode(_component_Collapse, { activeKey: _ctx.activeKeys }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.collapsePanels, (collapsePanel) => {
            return (openBlock(), createBlock(_component_CollapsePanel, mergeProps({
              key: collapsePanel.key
            }, { ...collapsePanel.props }), {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(collapsePanel.detailRows, (rowItem, index) => {
                  return (openBlock(), createBlock(_component_a_row, mergeProps({
                    type: "flex",
                    key: index,
                    class: 
            `ant-form-item ${
              typeof rowItem.class == 'function'
                ? rowItem.class()
                : rowItem.class
            }`
          
                  }, { ..._ctx.$props.rowConfig }), {
                    default: withCtx(() => [
                      createCommentVNode(" 左侧label标签 "),
                      createVNode(_component_a_col, mergeProps({ class: "ant-form-item-label form-item-icon-label" }, { ..._ctx.$props.colConfig }, {
                        style: { width: rowItem.width || '' }
                      }), {
                        default: withCtx(() => [
                          createElementVNode("label", _hoisted_1$q, [
                            createCommentVNode(" 前缀图标 "),
                            (_ctx.$props.showPrefixIcon || rowItem.prefixIcon)
                              ? (openBlock(), createElementBlock("i", {
                                  key: 0,
                                  class: "iconfont label-prefix-icon",
                                  innerHTML: rowItem.prefixIcon
                                }, null, 8 /* PROPS */, _hoisted_2$l))
                              : createCommentVNode("v-if", true),
                            createTextVNode(" " + toDisplayString(rowItem.label) + " ", 1 /* TEXT */),
                            createCommentVNode(" 提示说明图标 "),
                            (rowItem.showTipsIcon)
                              ? (openBlock(), createBlock(_component_a_tooltip, mergeProps({
                                  key: 1,
                                  overlayClassName: "sc-tooltip-light"
                                }, { ...rowItem.labelTipsProps }), {
                                  title: withCtx(() => [
                                    createElementVNode("div", {
                                      innerHTML: 
                      rowItem.labelTipsProps && rowItem.labelTipsProps.title
                    
                                    }, null, 8 /* PROPS */, _hoisted_3$h)
                                  ]),
                                  default: withCtx(() => [
                                    _hoisted_4$e
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                              : createCommentVNode("v-if", true),
                            createCommentVNode(" 刷新图标 "),
                            (rowItem.showRefreshIcon)
                              ? (openBlock(), createBlock(_component_a_tooltip, {
                                  key: 2,
                                  overlayClassName: "sc-tooltip-light"
                                }, {
                                  title: withCtx(() => [
                                    createElementVNode("div", null, "点击刷新" + toDisplayString(rowItem.label) + "信息", 1 /* TEXT */)
                                  ]),
                                  default: withCtx(() => [
                                    createElementVNode("i", {
                                      class: "iconfont refresh-icon",
                                      innerHTML: '',
                                      onClick: $event => (rowItem.refeshClick && rowItem.refeshClick())
                                    }, null, 8 /* PROPS */, _hoisted_5$c)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              : createCommentVNode("v-if", true)
                          ])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["style"]),
                      createCommentVNode(" 右侧表单项：支持传入表单项formItems、 也支持传入插槽slotName "),
                      (rowItem.formItems)
                        ? (openBlock(), createBlock(_component_a_col, {
                            key: 0,
                            span: 20
                          }, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(rowItem.formItems, (item) => {
                                return (openBlock(), createBlock(_component_BasicFormItem, {
                                  item: item,
                                  key: item.key,
                                  tag: _ctx.formStateRef[item.tagKey],
                                  "onUpdate:tag": $event => ((_ctx.formStateRef[item.tagKey]) = $event),
                                  value: _ctx.formStateRef[item.key],
                                  "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event)
                                }, null, 8 /* PROPS */, ["item", "tag", "onUpdate:tag", "value", "onUpdate:value"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        : createCommentVNode("v-if", true),
                      (rowItem.slotName)
                        ? (openBlock(), createBlock(_component_a_col, {
                            key: 1,
                            span: 20
                          }, {
                            default: withCtx(() => [
                              renderSlot(_ctx.$slots, rowItem.slotName)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        : createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["activeKey"])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["model"]))
}

script$s.render = render$n;
script$s.__file = "packages/detail-page-form/src/DetailPageForm.vue";

script$s.install = (Vue) => {
    Vue.component(script$s.name, script$s);
};

const baseUrl$2 = process.env.VUE_APP_URL;
const urls$2 = {
    submitShelfInfo: '/product/scm/add-scm-list',
    submitCloudShelfInfo: '/product/scm/add-cloud-model-and-scm',
    editShelfInfo: '/product/v2/shop-model/list-sm-on-shelf-info',
    addCloudModelInfo: '/product/shop-model/add-cloud-model-sales-info',
};
// 获取上架信息列表数据
const getEditShelfInfo = (params, isCloud) => {
    message.loading('数据加载中...');
    return http({
        url: isCloud ? urls$2.addCloudModelInfo : urls$2.editShelfInfo,
        withCredentials: true,
        baseURL: baseUrl$2,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        message.destroy();
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};
// 提交上架信息
const submitShelfInfo = (params, isCloud) => {
    return http({
        url: isCloud ? urls$2.submitCloudShelfInfo : urls$2.submitShelfInfo,
        withCredentials: true,
        baseURL: process.env.VUE_APP_URL,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data || true;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};

// 渠道信息
const channelMap = {
    1: '现货',
    2: '调仓',
    3: '期货',
};
var script$r = defineComponent({
    name: 'ScEditShelfInformation',
    components: {
        InnerGrid: script$18,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        isCloud: {
            type: Boolean,
            default: false,
        },
        shopModelIds: {
            type: Array,
            required: true,
        },
    },
    setup(props, { emit }) {
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 表格初始设置
        const gridDefs = {
            animateRows: true,
            rowMultiSelectWithClick: false,
            // editType: 'fullRow',
            suppressRowTransform: true, // 允许网格跨行
        };
        const gridOptions = reactive({
            api: {},
            columnApi: {},
        });
        // 全局表单数据
        const formState = ref({
            indeterminate: false,
            checkAll: false,
            channelIds: [],
            offRemark: '',
            allDeliveryTime: '',
        });
        // 合并行
        const rowSpanConf = {
            rowSpan: (params) => {
                return params.data.rowSpan || 1;
            },
            cellStyle: (params) => {
                return params.colDef.rowSpan && params.data.rowSpan > 1
                    ? {
                        height: `calc(${params.data.rowSpan * 100}% + ${params.data
                            .rowSpan - 1}px) !important`,
                    }
                    : null;
            },
            cellClassRules: {
                'cell-row-span': (params) => {
                    return params.colDef.rowSpan && params.data.rowSpan > 1;
                },
            },
        };
        // 表格数据
        const rowDataRef = ref([]);
        // 各渠道复选框总个数(不包含禁用)
        const checkboxCountArr = [0, 0, 0];
        // 各渠道复选框选中个数
        const checkedCountArr = [0, 0, 0];
        // 修改最小起购量
        let isUpdate = true;
        const leastSaleCountCellChanged = (params) => {
            if (!isUpdate) {
                isUpdate = true;
                return;
            }
            const leastSaleCount = parseInt(params.newValue);
            if (isNaN(leastSaleCount)) {
                message.warning('最小起购量不能为空，请重新输入');
                params.data.leastSaleCount = params.oldValue;
                isUpdate = false;
                params.node.setDataValue('leastSaleCount', params.oldValue);
                return;
            }
            if (leastSaleCount == 0) {
                message.warning('最小起购量不能为0，请重新输入');
                params.data.leastSaleCount = params.oldValue;
                isUpdate = false;
                params.node.setDataValue('leastSaleCount', params.oldValue);
                return;
            }
            const leastPackCount = parseInt(params.data.leastPackCount);
            const cloudLeastSaleCount = parseInt(params.data.cloudLeastSaleCount || 1);
            if (leastSaleCount > 999999) {
                message.warning('最小起购数量最大为999999');
                isUpdate = false;
                params.node.setDataValue('leastSaleCount', 999999);
            }
            else if (leastSaleCount % leastPackCount != 0 ||
                leastSaleCount < leastPackCount) {
                message.warning('最小起购量需为单位包装量的整数倍');
            }
            else if (!props.isCloud && leastSaleCount % cloudLeastSaleCount) {
                message.warning('最小起购量需为云仓最小起购量的整数倍，当前云仓最小起购量' +
                    cloudLeastSaleCount);
            }
        };
        // 修改单位包装量
        const leastPackCountCellChanged = (params) => {
            if (!isUpdate) {
                isUpdate = true;
                return;
            }
            const leastPackCount = parseInt(params.newValue);
            if (isNaN(leastPackCount)) {
                message.warning('单位包装量不能为空，请重新输入');
                params.data.leastPackCount = params.oldValue;
                isUpdate = false;
                params.node.setDataValue('leastPackCount', params.oldValue);
                return;
            }
            if (leastPackCount == 0) {
                message.warning('单位包装量不能为0，请重新输入');
                params.data.leastPackCount = params.oldValue;
                isUpdate = false;
                params.node.setDataValue('leastPackCount', params.oldValue);
                return;
            }
            const leastSaleCount = parseInt(params.data.leastSaleCount);
            const cloudLeastPackCount = parseInt(params.data.cloudLeastPackCount || 1);
            if (leastPackCount > 999999) {
                message.warning('单位包装数量最大为999999');
                isUpdate = false;
                params.node.setDataValue('leastPackCount', 999999);
            }
            else if (!props.isCloud && leastPackCount % cloudLeastPackCount > 0) {
                message.warning('单位包装量需为云仓单位包装量的整数倍，当前云仓单位包装量' +
                    cloudLeastPackCount);
            }
            else if (leastSaleCount % leastPackCount != 0 ||
                leastSaleCount < leastPackCount) {
                message.warning('最小起购量需为单位包装量的整数倍');
            }
        };
        // baiscTable列设置
        const columnDefs = ref([
            {
                suppressColumnsToolPanel: true,
                field: 'name',
                headerName: '型号',
                width: 150,
                flex: 1,
                tooltipComponent: 'DefaultTooltip',
                tooltipField: 'materialNo',
                ...rowSpanConf,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'textCopy',
                        text: (params) => {
                            return params.data.materialNo || '-';
                        },
                    },
                },
            },
            {
                field: 'materialNo',
                headerName: '订货号',
                width: 150,
                flex: 1,
                tooltipComponent: 'DefaultTooltip',
                tooltipField: 'materialNo',
                ...rowSpanConf,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'textCopy',
                        text: (params) => {
                            return params.data.materialNo || '-';
                        },
                    },
                },
            },
            {
                field: 'marketPriceYuan',
                headerName: '市场价(元)',
                width: 100,
                type: 'rightAligned',
                ...rowSpanConf,
            },
            {
                field: 'deliveryTime',
                headerName: '期货货期',
                width: 100,
                editable: true,
                cellClass: 'sc-fill-cell',
                ...rowSpanConf,
                onCellValueChanged: (params) => {
                    rowDataRef.value.filter((item) => {
                        return item.id != params.data.id;
                    });
                },
            },
            {
                field: 'channelName',
                headerName: '渠道',
                width: 90,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'checkbox',
                        checkedField: 'checked',
                        value: (params) => params.data.channelId,
                        disChecked: (params) => {
                            return params.data.onShelf;
                        },
                        onChange: (ev) => {
                            const channelId = ev.target.value;
                            const checked = ev.target.checked;
                            // 修改对应渠道列表复选框选中个数
                            if (checked) {
                                checkedCountArr[channelId - 1]++;
                            }
                            else {
                                checkedCountArr[channelId - 1]--;
                            }
                            // 更新全局渠道选中情况
                            formState.value.channelIds.splice(0);
                            for (let i = 0; i < checkedCountArr.length; i++) {
                                if (checkedCountArr[i] > 0 &&
                                    checkedCountArr[i] == checkboxCountArr[i]) {
                                    const cId = i + 1;
                                    formState.value.channelIds.push(cId);
                                }
                            }
                        },
                        onShowTip: (params) => {
                            return params.data.onShelf;
                        },
                        tipTitle: '此渠道已上架',
                        tooltipProps: {
                            zIndex: 999999,
                        },
                    },
                },
            },
            {
                field: 'leastPackCount',
                headerName: '单位包装数量',
                type: 'rightAligned',
                editable: true,
                cellClass: 'sc-fill-cell ag-right-aligned-cell',
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'tooltip',
                        tipTheme: 'light',
                        onShowTip: (params) => {
                            return (!props.isCloud &&
                                params.data.cloudLeastPackCount &&
                                params.data.cloudLeastSaleCount);
                        },
                        tipTitleGetter: (params) => {
                            return `云仓包装量${params.data.cloudLeastPackCount}，起订量${params.data.cloudLeastSaleCount}`;
                        },
                        tooltipProps: {
                            zIndex: 999999,
                        },
                    },
                },
                onCellValueChanged: leastPackCountCellChanged,
            },
            {
                field: 'leastSaleCount',
                headerName: '最小起购数量',
                headerComponent: 'CustomHeader',
                headerComponentParams: {
                    enableExplain: true,
                    explainTipHtml: '最小起购量为单位包装量的整数倍',
                },
                width: 135,
                type: 'rightAligned',
                editable: true,
                cellClass: 'sc-fill-cell ag-right-aligned-cell',
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'tooltip',
                        tipTheme: 'light',
                        onShowTip: (params) => {
                            return (!props.isCloud &&
                                params.data.cloudLeastPackCount &&
                                params.data.cloudLeastSaleCount);
                        },
                        tipTitleGetter: (params) => {
                            return `云仓包装量${params.data.cloudLeastPackCount}，起订量${params.data.cloudLeastSaleCount}`;
                        },
                        tooltipProps: {
                            zIndex: 999999,
                        },
                    },
                },
                onCellValueChanged: leastSaleCountCellChanged,
            },
            {
                field: 'operation',
                headerName: '操作',
                width: 80,
                ...rowSpanConf,
                cellRenderer: (params) => {
                    params.eGridCell.addEventListener('click', (ev) => {
                        if (ev.target.classList &&
                            ev.target.classList.value.indexOf('delete-btn')) {
                            const newRowData = rowDataRef.value.filter((item) => {
                                return item.id != params.data.id;
                            });
                            rowDataRef.value.splice(0);
                            rowDataRef.value.push(...newRowData);
                            gridOptions.api.setRowData(rowDataRef.value);
                        }
                    });
                    return `<a class="btn-danger delete-btn">删除</a>`; // 用于字体垂直居中
                },
            },
        ]);
        const formRef = ref();
        const CHANNEL_IDS = [1, 2, 3];
        // 获取表格数据
        const getRowData = async () => {
            checkboxCountArr.splice(0, 3, 0, 0, 0);
            checkedCountArr.splice(0, 3, 0, 0, 0);
            formState.value.channelIds.splice(0);
            formState.value.offRemark = '';
            formState.value.allDeliveryTime = '';
            rowDataRef.value.splice(0);
            const data = await getEditShelfInfo(JSON.stringify(props.shopModelIds || []), props.isCloud || false);
            if (data) {
                data.forEach((item) => {
                    !item.marketPriceYuan &&
                        (item.marketPriceYuan = (Math.ceil(item.marketPrice) / 100).toFixed(2));
                    item.deliveryTime = item.deliveryTime || '预计2~8周';
                    const channelIdMap = {};
                    if (item.channelModelUnits) {
                        item.channelModelUnits.forEach((channelItem) => {
                            const channelId = channelItem.channelId;
                            channelIdMap[channelId] = true;
                        });
                    }
                    else {
                        item.channelModelUnits = [];
                    }
                    CHANNEL_IDS.forEach((channelId) => {
                        if (!channelIdMap[channelId]) {
                            item.channelModelUnits.push({
                                channelId: channelId,
                                onShelf: false,
                                cloudLeastPackCount: null,
                                cloudLeastSaleCount: null,
                                packUnit: item.unit || '个',
                                leastPackCount: 1,
                                leastSaleCount: 1,
                            });
                        }
                    });
                    item.channelModelUnits.sort((a, b) => a.channelId - b.channelId);
                    item.channelModelUnits.forEach((channelItem, channelIndex) => {
                        const channelId = channelItem.channelId;
                        channelItem.channelName = channelMap[channelId];
                        channelItem.packUnit = channelItem.packUnit || item.unit || '个';
                        channelItem.rowDataId = item.id + '_' + channelId;
                        if (channelItem.leastPackCount % channelItem.cloudLeastPackCount >
                            0) {
                            channelItem.leastPackCount = channelItem.cloudLeastPackCount;
                            channelItem.leastSaleCount = channelItem.cloudLeastSaleCount;
                        }
                        if (channelIndex == 0) {
                            channelItem.rowSpan = item.channelModelUnits.length;
                        }
                        else {
                            channelItem.rowSpan = 1;
                        }
                        const newItem = Object.assign(_.cloneDeep(item), channelItem);
                        rowDataRef.value.push(newItem);
                        // 获取每个渠道checkbox个数
                        if (!channelItem.onShelf) {
                            checkboxCountArr[channelId - 1] =
                                checkboxCountArr[channelId - 1] + 1;
                        }
                    });
                });
                gridOptions.api.setRowData(rowDataRef.value);
            }
        };
        // 监听shopModelIds变化更新列表数据
        watch(() => visibleRef.value, () => {
            if (visibleRef.value) {
                nextTick(() => {
                    getRowData();
                });
            }
        }, { deep: true });
        // 全局修改期货货期
        const updateAllDeliveryTime = (ev) => {
            if (rowDataRef.value) {
                for (let i = 0; i < rowDataRef.value.length; i++) {
                    rowDataRef.value[i].deliveryTime = ev.target.value || '-';
                }
                gridOptions.api.setRowData(rowDataRef.value);
            }
        };
        // 全选
        const onCheckAllChange = (e) => {
            const channelIds = [1, 2, 3];
            Object.assign(formState.value, {
                channelIds: e.target.checked ? channelIds : [],
                indeterminate: false,
            });
            // 调用check的change事件
            channelIds.map((cid) => {
                handleChannelChange({
                    target: { value: cid, checked: e.target.checked },
                });
            });
        };
        watch(() => formState.value.channelIds, (val) => {
            formState.value.indeterminate = !!val.length && val.length < 3;
            formState.value.checkAll = val.length === 3;
        }, { deep: true });
        // 全局选择渠道
        const handleChannelChange = (ev) => {
            var channelId = ev.target.value;
            if (rowDataRef.value) {
                // 更新列表复选框
                for (let i = 0; i < rowDataRef.value.length; i++) {
                    if (channelId == rowDataRef.value[i].channelId) {
                        if (!rowDataRef.value[i].onShelf) {
                            rowDataRef.value[i].checked = ev.target.checked;
                        }
                    }
                }
                gridOptions.api.setRowData(rowDataRef.value);
                // 列表复选框选中个数
                checkedCountArr[channelId - 1] = ev.target.checked
                    ? checkboxCountArr[channelId - 1]
                    : 0;
            }
        };
        // 提交上架
        const handleOk = (ev) => {
            ev.stopPropagation();
            gridOptions.api.stopEditing();
            setTimeout(async () => {
                const submitMap = {};
                for (let i = 0; i < rowDataRef.value.length; i++) {
                    // rowDataRef.value[i].offRemark = formState.value.offRemark;
                    const item = rowDataRef.value[i];
                    let msg = '【' + item.name + '】型号 ';
                    if (item.channelId == 1) {
                        msg += '【现货】渠道';
                    }
                    else if (item.channelId == 2) {
                        msg += '【调仓】渠道';
                    }
                    else {
                        msg += '【期货】渠道';
                    }
                    if (item.leastPackCount > 999999) {
                        message.warning(msg + '单位包装数量最大为999999');
                        return;
                    }
                    if (item.leastSaleCount > 999999) {
                        message.warning(msg + '单位包装数量最大为999999');
                        return;
                    }
                    if (item.leastSaleCount % item.leastPackCount != 0 ||
                        item.leastSaleCount < item.leastPackCount) {
                        message.warning(msg + '最小起购量需为单位包装量的整数倍');
                        return;
                    }
                    if (!props.isCloud &&
                        item.leastPackCount % item.cloudLeastPackCount) {
                        message.warning(msg +
                            '单位包装量需为云仓单位包装量的整数倍，当前云仓单位包装量' +
                            item.cloudLeastPackCount);
                        return;
                    }
                    if (!props.isCloud &&
                        item.leastSaleCount % item.cloudLeastSaleCount) {
                        message.warning('最小起购量需为云仓最小起购量的整数倍，当前云仓最小起购量' +
                            item.cloudLeastSaleCount);
                        return;
                    }
                    if (item.checked) {
                        if (submitMap[item.id]) {
                            submitMap[item.id].channelIdList.push(item.channelId);
                            submitMap[item.id].modelPackInfoDtoList.push({
                                channelId: item.channelId,
                                leastPackCount: item.leastPackCount,
                                leastSaleCount: item.leastSaleCount,
                                packUnit: item.packUnit,
                                shopModelId: item.id,
                            });
                        }
                        else {
                            submitMap[item.id] = {
                                brandId: item.brandId,
                                categoryId: item.categoryId,
                                channelIdList: [item.channelId],
                                cloudModelId: item.cloudModelId,
                                deliveryTime: item.deliveryTime,
                                materialNo: item.materialNo,
                                modelName: item.name,
                                modelPackInfoDtoList: [
                                    {
                                        channelId: item.channelId,
                                        leastPackCount: item.leastPackCount,
                                        leastSaleCount: item.leastSaleCount,
                                        packUnit: item.packUnit,
                                        shopModelId: item.id,
                                    },
                                ],
                                offRemark: formState.value.offRemark,
                                onSaleType: item.onSaleType,
                                productId: item.productId,
                                seriesId: item.seriesId,
                                shopModelId: item.id,
                                isCloud: props.isCloud,
                            };
                        }
                    }
                    // if (rowDataRef.value[i].checked) {
                    //   submitList.push(rowDataRef.value[i]);
                    // }
                }
                const submitList = Object.values(submitMap);
                if (submitList && submitList.length <= 0) {
                    message.warning('请选择上架信息');
                    return;
                }
                const res = await submitShelfInfo(JSON.stringify(submitList), props.isCloud);
                if (res) {
                    message.success('上架成功');
                    visibleRef.value = false;
                    emit('success', submitList);
                }
            }, 200);
        };
        // 键盘事件
        const cellKeyDown = (params) => {
            const field = params.colDef.field;
            let newValue = params.event.target.value;
            switch (field) {
                case 'leastPackCount':
                case 'leastSaleCount':
                    newValue = isNaN(parseInt(newValue)) ? '' : parseInt(newValue);
                    break;
            }
            params.event.target.value = newValue;
        };
        return {
            visibleRef,
            formState,
            columnDefs,
            gridDefs,
            rowDataRef,
            gridOptions,
            cellKeyDown,
            updateAllDeliveryTime,
            handleChannelChange,
            handleOk,
            onCheckAllChange,
            formRef,
        };
    },
});

const _hoisted_1$p = { class: "edit-shelf-form" };
const _hoisted_2$k = { class: "edit-shelf-grid" };

function render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_checkbox_group = resolveComponent("a-checkbox-group");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_form = resolveComponent("a-form");
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createBlock(_component_a_modal, {
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[4] || (_cache[4] = $event => ((_ctx.visibleRef) = $event)),
    title: "编辑上架信息",
    class: "sc-edit-shelf-information",
    width: "1100px",
    destroyOnClose: true,
    maskClosable: false,
    onOk: _ctx.handleOk,
    zIndex: 9999
  }, {
    default: withCtx(() => [
      createCommentVNode(" <a-alert :show-icon=\"false\" banner>\r\n      <template #message>\r\n        由于平台调整面价强制下架的型号，请先调整销售折扣后再操作上架，\r\n        <a href=\"/price/scale-update-discount/index\" target=\"_blank\">去调整</a>\r\n      </template>\r\n    </a-alert> "),
      createElementVNode("div", _hoisted_1$p, [
        createVNode(_component_a_form, {
          layout: "inline",
          model: _ctx.formState,
          colon: false,
          ref: _ctx.formRef
        }, {
          default: withCtx(() => [
            createVNode(_component_a_form_item, { label: "上架渠道" }, {
              default: withCtx(() => [
                createVNode(_component_a_checkbox, {
                  checked: _ctx.formState.checkAll,
                  "onUpdate:checked": _cache[0] || (_cache[0] = $event => ((_ctx.formState.checkAll) = $event)),
                  indeterminate: _ctx.formState.indeterminate,
                  onChange: _ctx.onCheckAllChange
                }, {
                  default: withCtx(() => [
                    createTextVNode("全选")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["checked", "indeterminate", "onChange"]),
                createVNode(_component_a_checkbox_group, {
                  value: _ctx.formState.channelIds,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.formState.channelIds) = $event))
                }, {
                  default: withCtx(() => [
                    createVNode(_component_a_checkbox, {
                      value: 1,
                      name: "channelId",
                      onChange: _ctx.handleChannelChange
                    }, {
                      default: withCtx(() => [
                        createTextVNode("现货")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onChange"]),
                    createVNode(_component_a_checkbox, {
                      value: 2,
                      name: "channelId",
                      onChange: _ctx.handleChannelChange
                    }, {
                      default: withCtx(() => [
                        createTextVNode("调仓")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onChange"]),
                    createVNode(_component_a_checkbox, {
                      value: 3,
                      name: "channelId",
                      onChange: _ctx.handleChannelChange
                    }, {
                      default: withCtx(() => [
                        createTextVNode("期货")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onChange"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_a_form_item, { label: "上架原因" }, {
              default: withCtx(() => [
                createVNode(_component_a_input, {
                  placeholder: "请输入上架原因",
                  value: _ctx.formState.offRemark,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.formState.offRemark) = $event)),
                  maxlength: 512
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_a_form_item, { label: "期货货期" }, {
              default: withCtx(() => [
                createVNode(_component_a_input, {
                  placeholder: "请输入期货货期",
                  value: _ctx.formState.allDeliveryTime,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.formState.allDeliveryTime) = $event)),
                  onChange: _ctx.updateAllDeliveryTime,
                  maxlength: 16
                }, null, 8 /* PROPS */, ["value", "onChange"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model"])
      ]),
      createElementVNode("div", _hoisted_2$k, [
        createVNode(_component_InnerGrid, {
          id: "editShelfInformationGrid",
          columnDefs: _ctx.columnDefs,
          rowData: _ctx.rowDataRef,
          headerHeight: 30,
          gridDefs: _ctx.gridDefs,
          maxHeight: '400px',
          gridOptions: _ctx.gridOptions,
          isRenderTotal: false,
          indexField: 'rowDataId',
          onCellKeyDown: _ctx.cellKeyDown
        }, null, 8 /* PROPS */, ["columnDefs", "rowData", "gridDefs", "gridOptions", "onCellKeyDown"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "onOk"]))
}

script$r.render = render$m;
script$r.__file = "packages/edit-shelf-information/src/EditShelfInformation.vue";

script$r.install = (Vue) => {
    Vue.component(script$r.name, script$r);
};

const baseUrl$1 = process.env.VUE_APP_URL;
const urls$1 = {
    getTemplateList: '/quotation/quotation/get-enabled-template',
};
// 获取自定义报价单模板列表数据
const getTemplateList = () => {
    return http({
        url: urls$1.getTemplateList,
        withCredentials: true,
        baseURL: baseUrl$1,
        method: 'GET',
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};

var script$q = defineComponent({
    name: 'ScExportQuotationModal',
    components: {
        Modal: script$1N,
        BasicFormItem: script$1v,
        DownOutlined,
    },
    props: {
        placement: {
            type: String,
            default: 'bottomLeft',
        },
        overlayClassName: {
            type: String,
            default: 'sc-export-quotation-dropdown-menu',
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = ref(false);
        const pathname = window.location.pathname;
        // 表单数据
        const formStateRef = ref({
            templateId: '',
            type: getState(pathname + '&exportQuotationType') || 1,
        });
        const customeTemplateUrl = '/quotation/custom-template/index';
        // 报价单模板配置提示
        window.refreshCustomTemplate = () => {
            Modal.confirm({
                title: '提示',
                icon: h(ExclamationCircleFilled),
                content: '您是否已在新打开的窗口中配置好报价单模板并保存成功？',
                centered: true,
                closable: true,
                okText: '重新配置',
                okButtonProps: {
                    type: 'primary',
                    ghost: true,
                },
                onOk: () => {
                    window.open(customeTemplateUrl);
                    window.refreshCustomTemplate();
                },
                cancelText: '已配置成功',
                cancelButtonProps: {
                    type: 'primary',
                },
                onCancel: () => {
                    setTemplateList();
                },
            });
        };
        // 选择模板表单项
        const templatesItem = reactive({
            dataIndex: 'templateId',
            key: 'templateId',
            type: 'Select',
            value: null,
            label: '选择模板',
            desc: `<span>如需添加自定义报价单模板 <a href="${customeTemplateUrl}" target="_blank" onclick="refreshCustomTemplate()">前往配置</a></span>`,
            options: [],
            extra: 'refresIcon',
            width: '190px',
        });
        // 表单项
        const formItems = reactive([
            templatesItem,
            {
                dataIndex: 'type',
                key: 'type',
                type: 'RadioGroup',
                label: '支持格式',
                options: [
                    { id: 1, name: 'PDF', value: 1 },
                    { id: 2, name: 'EXCEL', value: 2 },
                ],
                props: {
                    onChange: () => {
                        setState(pathname + '&exportQuotationType', formStateRef.value.type);
                    },
                },
            },
        ]);
        // 模板列表数据
        const setTemplateList = async (isRefresh) => {
            const data = await getTemplateList();
            templatesItem.options = [];
            if (data) {
                data.forEach((item) => {
                    templatesItem.options &&
                        templatesItem.options.push({
                            id: item.id,
                            name: item.name,
                            value: item.id,
                            label: item.name,
                        });
                });
                templatesItem.value = templatesItem.options[0].id;
                formStateRef.value.templateId = templatesItem.value;
                if (isRefresh) {
                    message.success('刷新成功');
                }
            }
        };
        setTemplateList();
        // 底部按钮组
        const modalBtns = reactive([
            {
                text: '导出',
                type: 'primary',
                onClick: () => {
                    visibleRef.value = false;
                    emit('export', formStateRef.value);
                },
            },
            {
                text: '预览',
                class: formStateRef.value.type && formStateRef.value.type === 2
                    ? 'excel-disabled-preview'
                    : '',
                onClick: () => {
                    if (formStateRef.value.type && formStateRef.value.type != 2) {
                        visibleRef.value = false;
                        emit('preview', formStateRef.value);
                    }
                    else {
                        message.warning('暂不支持excel文件在线浏览');
                    }
                },
            },
            {
                text: '取消',
            },
        ]);
        // 导出默认报价单
        const handleDefaultQuotation = () => {
            emit('exportDefault');
        };
        // 导出自定义报价单
        const handleTemplateQuotation = () => {
            visibleRef.value = true;
        };
        // 选择excel时禁用预览按钮并在点击时提示，如果用button的disable属性则触发不了click事件，所以用样式添加禁用效果，在click事件中拦截；
        watch(() => formStateRef.value.type, () => {
            modalBtns[1].class =
                formStateRef.value.type === 2 ? 'excel-disabled-preview' : '';
        });
        return {
            visibleRef,
            formItems,
            formStateRef,
            modalBtns,
            handleDefaultQuotation,
            handleTemplateQuotation,
            setTemplateList,
        };
    },
});

const _hoisted_1$o = { class: "export-quotation-content" };

function render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_menu_item = resolveComponent("a-menu-item");
  const _component_a_menu = resolveComponent("a-menu");
  const _component_DownOutlined = resolveComponent("DownOutlined");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_dropdown = resolveComponent("a-dropdown");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createElementBlock("span", null, [
    createVNode(_component_a_dropdown, {
      placement: _ctx.$props.placement,
      overlayClassName: _ctx.$props.overlayClassName,
      class: normalizeClass(
        `sc-export-quotation-btns ${
          _ctx.$props.placement && _ctx.$props.placement.indexOf('top') != -1
            ? 'ant-dropdown-top'
            : ''
        }`
      )
    }, {
      overlay: withCtx(() => [
        createVNode(_component_a_menu, null, {
          default: withCtx(() => [
            createVNode(_component_a_menu_item, {
              key: "2",
              onClick: _ctx.handleTemplateQuotation
            }, {
              default: withCtx(() => [
                createTextVNode("自定义报价单")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            createVNode(_component_a_menu_item, {
              key: "1",
              onClick: _ctx.handleDefaultQuotation
            }, {
              default: withCtx(() => [
                createTextVNode("默认报价单")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      default: withCtx(() => [
        createVNode(_component_a_button, null, {
          default: withCtx(() => [
            createTextVNode(" 导出报价单 "),
            createVNode(_component_DownOutlined)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["placement", "overlayClassName", "class"]),
    createVNode(_component_Modal, {
      class: "sc-export-quotation-modal",
      visible: _ctx.visibleRef,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visibleRef) = $event)),
      title: "导出报价单",
      width: "370px",
      btns: _ctx.modalBtns
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$o, [
          createVNode(_component_a_form, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItems, (item) => {
                return (openBlock(), createBlock(_component_BasicFormItem, {
                  item: item,
                  key: item.key,
                  value: _ctx.formStateRef[item.key],
                  "onUpdate:value": $event => ((_ctx.formStateRef[item.key]) = $event),
                  labelAlign: "right",
                  colon: false
                }, {
                  refresIcon: withCtx(() => [
                    createElementVNode("i", {
                      title: "点击刷新",
                      class: "iconfont refresh-icon",
                      innerHTML: '',
                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.setTemplateList(true)))
                    })
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "value", "onUpdate:value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "btns"])
  ]))
}

script$q.render = render$l;
script$q.__file = "packages/export-quotation-modal/src/ExportQuotationModal.vue";

script$q.install = (Vue) => {
    Vue.component(script$q.name, script$q);
};

const size = 250;
const scale = 2;
function isOutOfWindow(left, width) {
    return left + width + 10 > window.innerWidth;
}
function adjust(top, height) {
    let ret = Math.max(0, top);
    ret = Math.min(window.innerHeight - height, ret);
    return ret;
}
const vZoom = {
    mounted(el, binding) {
        let coverEl;
        let zoomEl;
        let zoomImage;
        el.addEventListener('mouseenter', (ev) => {
            // 遮罩
            coverEl = document.createElement('div');
            coverEl.style.backgroundColor = 'rgba(41,169,238,0.2)';
            coverEl.style.width = `${size}px`;
            coverEl.style.height = `${size}px`;
            coverEl.style.position = 'absolute';
            coverEl.style.pointerEvents = 'none';
            coverEl.style.left = '0';
            coverEl.style.top = '0';
            el.style.position = 'relative';
            el.appendChild(coverEl);
            // 缩放面板container
            const imgElement = el.querySelector('img');
            zoomEl = document.createElement('div');
            const elPosition = el.getBoundingClientRect();
            zoomEl.style.position = 'absolute';
            zoomEl.style.border = '1px solid #D9D9D9';
            zoomEl.style.width = `${size * scale}px`;
            zoomEl.style.height = `${size * scale}px`;
            const offset = binding.arg ?? 'right';
            let left = `${elPosition.x + elPosition.width + 16}px`;
            if (isOutOfWindow(elPosition.x + elPosition.width + 16, size * scale) ||
                offset === 'left') {
                left = `${elPosition.x - size * scale - 16}px`;
            }
            zoomEl.style.left = left;
            zoomEl.style.top = `${adjust(elPosition.y, size * scale)}px`;
            zoomEl.style.overflow = 'hidden';
            zoomEl.style.zIndex = '99999999';
            zoomEl.style.backgroundColor = 'white';
            // 缩放图片
            zoomImage = document.createElement('img');
            zoomImage.width = el.offsetWidth * scale;
            zoomImage.height = el.offsetHeight * scale;
            zoomImage.src = imgElement.src;
            zoomImage.style.position = 'absolute';
            zoomImage.style.left = '0';
            zoomImage.style.top = '0';
            zoomImage.style.objectFit = 'contain';
            zoomImage.style.backgroundColor = 'white';
            zoomEl.appendChild(zoomImage);
            document.body.appendChild(zoomEl);
            zoomEl.style.display = 'block';
        });
        el.addEventListener('mouseleave', () => {
            if (zoomEl) {
                document.body.removeChild(zoomEl);
            }
            if (coverEl) {
                el.removeChild(coverEl);
            }
        });
        el.addEventListener('mousemove', (ev) => {
            const x = Math.min(Math.max(ev.offsetX - size / 2, 0), el.offsetWidth - size);
            const y = Math.min(Math.max(ev.offsetY - size / 2, 0), el.offsetHeight - size);
            if (zoomImage) {
                zoomImage.style.transform = `translate(-${x * scale}px, -${y *
                    scale}px)`;
            }
            if (coverEl) {
                coverEl.style.transform = `translate(${x}px, ${y}px)`;
            }
        });
    },
};

const _hoisted_1$n = ["src"];
const _hoisted_2$j = ["src"];
// 默认值
var script$p = /*#__PURE__*/ defineComponent({
    __name: 'ImageGallery',
    props: {
        list: { type: Array, required: true, default: () => [] },
        loop: { type: Boolean, required: false, default: false },
        autoplay: { type: Boolean, required: false, default: false },
        hideThumbnail: { type: Boolean, required: false, default: false },
        navigation: { type: Boolean, required: false, default: false },
        pagination: { type: Boolean, required: false, default: true },
        zoomContainerOffset: { type: String, required: false, default: 'right' }
    },
    setup(__props) {
        const props = __props;
        const autoplayDefaultConfig = {
            delay: 2500,
            disableOnInteraction: false,
        };
        let thumbsSwiper = ref();
        const setThumbsSwiper = (swiper) => {
            thumbsSwiper.value = swiper;
        };
        const modules = [FreeMode, Navigation, Thumbs, Autoplay, Pagination$1];
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock(Fragment, null, [
                createVNode(unref(Swiper), {
                    style: {
                        '--swiper-navigation-color': '#fff',
                        '--swiper-pagination-color': '#fff',
                    },
                    loop: __props.loop,
                    spaceBetween: 10,
                    navigation: __props.navigation,
                    pagination: __props.pagination ? { clickable: true } : false,
                    thumbs: { swiper: unref(thumbsSwiper) },
                    modules: modules,
                    class: normalizeClass(["sc-image-gallery sc-image-gallery-preview", { 'sc-image-gallery-thumbnail-only': __props.hideThumbnail }]),
                    autoplay: __props.autoplay ? autoplayDefaultConfig : false
                }, {
                    default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.list, (l) => {
                            return withDirectives((openBlock(), createBlock(unref(SwiperSlide), { key: l }, {
                                default: withCtx(() => [
                                    createElementVNode("img", { src: l }, null, 8 /* PROPS */, _hoisted_1$n)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)), [
                                [unref(vZoom), void 0, props.zoomContainerOffset]
                            ]);
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["loop", "navigation", "pagination", "thumbs", "class", "autoplay"]),
                (!__props.hideThumbnail)
                    ? (openBlock(), createBlock(unref(Swiper), {
                        key: 0,
                        onSwiper: setThumbsSwiper,
                        loop: __props.loop,
                        spaceBetween: 10,
                        slidesPerView: 4,
                        freeMode: true,
                        watchSlidesProgress: true,
                        modules: modules,
                        class: "sc-image-gallery sc-image-gallery-thumbnail"
                    }, {
                        default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.list, (l) => {
                                return (openBlock(), createBlock(unref(SwiperSlide), { key: l }, {
                                    default: withCtx(() => [
                                        createElementVNode("img", { src: l }, null, 8 /* PROPS */, _hoisted_2$j)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["loop"]))
                    : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});

script$p.__file = "packages/image-gallery/src/ImageGallery.vue";

script$p.install = (Vue) => {
    Vue.component('ImageGallery', script$p);
};

const apiMenuAsideData = (baseUrl, selectedUrl) => {
    const url = selectedUrl
        ? `/acl/menu/describe-menu-info?url=${selectedUrl}`
        : '/acl/menu/describe-menu-info';
    return http({
        method: 'get',
        baseURL: baseUrl,
        withCredentials: true,
        url: url,
    }).then((res) => {
        if (res.data.code === 0) {
            return res.data;
        }
    });
};

const dataSource = [
    {
        title: 'Libraries',
        children: [
            {
                title: 'AntDesign',
                count: 10000,
            },
            {
                title: 'AntDesign UI',
                count: 10600,
            },
        ],
    },
    {
        title: 'Solutions',
        children: [
            {
                title: 'AntDesign UI FAQ',
                count: 60100,
            },
            {
                title: 'AntDesign FAQ',
                count: 30010,
            },
        ],
    },
    {
        title: 'Articles',
        children: [
            {
                title: 'AntDesign design language',
                count: 100000,
            },
        ],
    },
];
var script$o = defineComponent({
    name: 'SecondNav',
    components: {
        SearchOutlined,
    },
    setup() {
        const isDropDownShow = ref(false);
        const secondNavElem = ref(null);
        const secondNavItemElem = ref(null);
        const searchValue = ref('');
        const updateIsDropDownShow = () => {
            if (secondNavElem.value && secondNavItemElem.value) {
                isDropDownShow.value =
                    secondNavItemElem.value.clientHeight >
                        secondNavElem.value.clientHeight;
            }
        };
        const scrollDown = () => {
            if (secondNavElem.value) {
                secondNavElem.value.scrollTop = secondNavElem.value.scrollHeight;
            }
        };
        let resizeTimer = undefined;
        const onResize = () => {
            if (resizeTimer) {
                clearTimeout(resizeTimer);
            }
            resizeTimer = window.setTimeout(() => {
                updateIsDropDownShow();
            }, 200);
        };
        onMounted(() => {
            window.addEventListener('resize', onResize);
        });
        onUpdated(() => {
            updateIsDropDownShow();
        });
        return {
            scrollDown,
            secondNavElem,
            secondNavItemElem,
            searchValue,
            isDropDownShow,
            dataSource,
        };
    },
});

const _hoisted_1$m = {
  class: "second-nav",
  ref: "secondNavElem"
};
const _hoisted_2$i = { class: "search-container" };
const _hoisted_3$g = {
  class: "second-nav-item",
  ref: "secondNavItemElem"
};
const _hoisted_4$d = /*#__PURE__*/createElementVNode("i", { class: "iconfont" }, "", -1 /* HOISTED */);
const _hoisted_5$b = [
  _hoisted_4$d
];

function render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_outlined = resolveComponent("search-outlined");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_auto_complete = resolveComponent("a-auto-complete");

  return (openBlock(), createElementBlock("div", _hoisted_1$m, [
    createElementVNode("div", _hoisted_2$i, [
      createVNode(_component_a_auto_complete, {
        value: _ctx.searchValue,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.searchValue) = $event)),
        class: "certain-category-search",
        "dropdown-class-name": "certain-category-search-dropdown",
        "dropdown-match-select-width": false,
        "dropdown-style": { width: '300px' },
        size: "large",
        style: {"height":"30px"},
        options: _ctx.dataSource
      }, {
        default: withCtx(() => [
          createCommentVNode(" <template #options>\r\n          <a-select-opt-group v-for=\"group in dataSource\" :key=\"group.title\">\r\n            <template #label>\r\n              <span>\r\n                {{ group.title }}\r\n                <a\r\n                  style=\"float: right\"\r\n                  href=\"https://www.google.com/search?q=antd\"\r\n                  target=\"_blank\"\r\n                  rel=\"noopener noreferrer\"\r\n                >\r\n                  more\r\n                </a>\r\n              </span>\r\n            </template>\r\n            <a-select-option\r\n              v-for=\"opt in group.children\"\r\n              :key=\"opt.title\"\r\n              :value=\"opt.title\"\r\n            >\r\n              {{ opt.title }}\r\n              <span class=\"certain-search-item-count\"\r\n                >{{ opt.count }} people</span\r\n              >\r\n            </a-select-option>\r\n          </a-select-opt-group>\r\n          <a-select-option key=\"all\" disabled class=\"show-all\">\r\n            <a\r\n              href=\"https://www.google.com/search?q=ant-design-vue\"\r\n              target=\"_blank\"\r\n              rel=\"noopener noreferrer\"\r\n            >\r\n              View all results\r\n            </a>\r\n          </a-select-option>\r\n        </template> "),
          createVNode(_component_a_input, {
            placeholder: "搜索",
            size: "small",
            allowClear: ""
          }, {
            prefix: withCtx(() => [
              createVNode(_component_search_outlined, { class: "certain-category-icon" })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value", "options"])
    ]),
    createElementVNode("div", _hoisted_3$g, [
      renderSlot(_ctx.$slots, "default")
    ], 512 /* NEED_PATCH */),
    withDirectives(createElementVNode("div", {
      class: "drop-down",
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.scrollDown && _ctx.scrollDown(...args)))
    }, _hoisted_5$b, 512 /* NEED_PATCH */), [
      [vShow, _ctx.isDropDownShow]
    ])
  ], 512 /* NEED_PATCH */))
}

script$o.render = render$k;
script$o.__file = "packages/layout/menu-aside/second-nav/secondNav.vue";

const navHrefTransfer = (url) => {
    if (url &&
        process.env.NODE_ENV === 'production' &&
        process.env.CLIENT === 'electron') {
        // electron 环境下需要对url进行转换
        return location.href.split('#')[0] + url.slice(1);
    }
    return url;
};

const secondNavProps = {
    itemData: {
        type: Array,
        default: [],
    },
    cacheMenuInfo: {
        type: Array,
        default: [],
    },
    cacheMenuInfoCount: {
        type: Array,
        default: [],
    },
};
var script$n = defineComponent({
    name: 'SecondNavItem',
    props: secondNavProps,
    setup(props, context) {
        const { itemData, cacheMenuInfo, cacheMenuInfoCount } = toRefs(props);
        // 二级导航栏下拉菜单状态
        const updateStatus = (data) => {
            data.show = !data.show;
        };
        // 处理asideTip
        const handleAsideTip = (data) => {
            const cacheIndex = cacheMenuInfo.value.indexOf(data.url);
            if (cacheIndex !== -1 && cacheMenuInfoCount.value[cacheIndex] !== 0) {
                data.asideTips = true;
                data.asideTipsNum =
                    cacheMenuInfoCount.value[cacheIndex] > 99
                        ? '99+'
                        : cacheMenuInfoCount.value[cacheIndex].toString();
            }
        };
        // 递归处理数据
        const recursionHandleData = (data) => {
            if (!data) {
                return;
            }
            data.forEach((item) => {
                handleAsideTip(item);
                if (item.children) {
                    recursionHandleData(item.children);
                }
            });
        };
        onMounted(() => {
            watchEffect(() => {
                recursionHandleData(itemData.value);
            });
        });
        const handleSecondNavClick = () => {
            context.emit('secondNavClick');
        };
        return {
            itemData,
            updateStatus,
            navHrefTransfer,
            handleSecondNavClick,
        };
    },
});

const _hoisted_1$l = {
  key: 0,
  class: "line"
};
const _hoisted_2$h = { key: 1 };
const _hoisted_3$f = {
  key: 0,
  class: "normal select-tip"
};
const _hoisted_4$c = ["href"];
const _hoisted_5$a = {
  key: 1,
  style: {"padding-left":"16px"}
};
const _hoisted_6$8 = {
  key: 1,
  class: "normal select-tip"
};
const _hoisted_7$7 = ["onClick"];
const _hoisted_8$7 = ["href"];

function render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemData, (item) => {
    return (openBlock(), createElementBlock("div", {
      key: item.id
    }, [
      (item.menuName === 'line')
        ? (openBlock(), createElementBlock("div", _hoisted_1$l))
        : (openBlock(), createElementBlock("div", _hoisted_2$h, [
            (item.children.length < 1)
              ? (openBlock(), createElementBlock("div", _hoisted_3$f, [
                  (item.url)
                    ? (openBlock(), createElementBlock("a", {
                        key: 0,
                        class: normalizeClass(item.selected ? 'active' : ''),
                        href: _ctx.navHrefTransfer(item.url),
                        style: {"padding-left":"16px"},
                        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleSecondNavClick && _ctx.handleSecondNavClick(...args)))
                      }, [
                        createTextVNode(toDisplayString(item.menuName) + " ", 1 /* TEXT */),
                        withDirectives(createElementVNode("em", { class: "aside-tips" }, toDisplayString(item.asideTipsNum), 513 /* TEXT, NEED_PATCH */), [
                          [vShow, item.asideTips]
                        ])
                      ], 10 /* CLASS, PROPS */, _hoisted_4$c))
                    : (openBlock(), createElementBlock("span", _hoisted_5$a, toDisplayString(item.menuName), 1 /* TEXT */))
                ]))
              : (openBlock(), createElementBlock("div", _hoisted_6$8, [
                  createElementVNode("div", null, [
                    createElementVNode("i", {
                      class: normalizeClass(!item.show ? 'iconfont open-icon' : 'iconfont close-icon')
                    }, "  ", 2 /* CLASS */),
                    createElementVNode("span", {
                      onClick: $event => (_ctx.updateStatus(item))
                    }, toDisplayString(item.menuName), 9 /* TEXT, PROPS */, _hoisted_7$7),
                    withDirectives(createElementVNode("ul", null, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(item.children, (childrenItem) => {
                        return (openBlock(), createElementBlock("li", {
                          key: childrenItem.id
                        }, [
                          createElementVNode("a", {
                            class: normalizeClass(childrenItem.selected ? 'active' : ''),
                            href: _ctx.navHrefTransfer(childrenItem.url),
                            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.handleSecondNavClick && _ctx.handleSecondNavClick(...args)))
                          }, [
                            createElementVNode("span", null, toDisplayString(childrenItem.menuName), 1 /* TEXT */),
                            withDirectives(createElementVNode("em", { class: "aside-tips" }, toDisplayString(childrenItem.asideTipsNum), 513 /* TEXT, NEED_PATCH */), [
                              [vShow, childrenItem.asideTips]
                            ])
                          ], 10 /* CLASS, PROPS */, _hoisted_8$7)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [vShow, !item.show]
                    ])
                  ])
                ]))
          ]))
    ]))
  }), 128 /* KEYED_FRAGMENT */))
}

script$n.render = render$j;
script$n.__file = "packages/layout/menu-aside/second-nav-item/secondNavItem.vue";

const MenuAsideProps = {
    menuAsideData: {
        type: Array,
        default: () => [],
    },
    // 当前选择的MenuItem的id
    selectedMenuIdRef: {
        type: Number,
        default: 0,
    },
    // 二级导航的状态
    secondNavStatus: {
        type: Boolean,
        default: false,
    },
    cacheMenuInfo: {
        type: Array,
        default: () => [],
    },
    cacheMenuInfoCount: {
        type: Array,
        default: () => [],
    },
    clickAction: {
        type: Function,
    },
};
// updateSelectIndex根地址栏找到对应的一级导航id
const selectedMenuIdRef = ref(0);
const hoverMenuIdRef = ref(selectedMenuIdRef.value);
const menuNavIdRef = ref(selectedMenuIdRef.value);
const selectIndex = (path, d, menuAsideData) => {
    const treeNodes = menuAsideData;
    for (let i = 0; i < treeNodes.length; i++) {
        if (treeNodes[i].url != '' && path.startsWith(treeNodes[i].url)) {
            return i;
        }
    }
    return d;
};
const updateSelectIndex = (path, menuAsideData) => {
    const index = selectIndex(path, 0, menuAsideData);
    const id = menuAsideData[index].id;
    menuNavIdRef.value = id;
    hoverMenuIdRef.value = id;
};
const selectedSecondIndex = (index, path, menuAsideData) => {
    const treeNodes = menuAsideData;
    if (index == -1)
        return -1;
    const pNode = treeNodes[index];
    if (pNode == undefined)
        return -1;
    else if (pNode.children == undefined)
        return -1;
    else {
        for (let i = 0; i < pNode.children.length; i++) {
            let sonNode = pNode.children[i].children;
            if (sonNode) {
                for (let j = 0; j < sonNode.length; j++) {
                    if (sonNode[j].url == path)
                        return [i, j];
                }
            }
            if (pNode.children[i].url == path)
                return [i];
        }
    }
    return -1;
};
var script$m = defineComponent({
    name: 'MenuAside',
    components: {
        SecondNav: script$o,
        SecondNavItem: script$n,
        HomeFilled,
        Avatar: script$R,
    },
    data() {
        return {
            blockBoxList: [
                { blockBoxKey: '0', blockBoxName: 'top' },
                { blockBoxKey: '1', blockBoxName: 'middle' },
                { blockBoxKey: '2', blockBoxName: 'bottom' },
            ],
        };
    },
    props: MenuAsideProps,
    watch: {
        // 点击状态下的开关
        // #/status/switch 开关高亮
        // 点击详情
        // #/detail/collapse 折叠面板高亮
        // 点击状态
        // #/status/brand-name   开关高亮、品牌/系列高亮
        // 点击状态下的icon
        // #/status/icon-cell   icon、开关高亮
        // watch  updateSelectIndex传地址进去
        $route: {
            deep: true,
            immediate: true,
            handler(to, from = {}) {
                console.log('from', from.path, 'to', to.path);
                updateSelectIndex(`/${to.href}`, this.menuAsideData);
                const fIndex = selectIndex(`/${from.href}`, -1, this.menuAsideData);
                const tIndex = selectIndex(`/${to.href}`, -1, this.menuAsideData);
                // const value = updateSelectIndex(`/${to.href}`) || 0;
                this.menuNavDataRef = this.menuAsideData[tIndex]?.children;
                if (this.menuAsideData[fIndex] != undefined) {
                    const uNavData = this.menuAsideData[fIndex].children;
                    console.log('clear', from.href);
                    let uSelect = selectedSecondIndex(fIndex, `/${from.href}`, this.menuAsideData);
                    if (uSelect !== -1) {
                        if (uNavData[uSelect[0]] != undefined) {
                            uNavData[uSelect[0]].selected = false;
                            if (uSelect[1] !== undefined &&
                                uNavData[uSelect[0]].children?.[uSelect[1]]) {
                                uNavData[uSelect[0]].children[uSelect[1]].selected = false;
                            }
                        }
                    }
                }
                let selectC = selectedSecondIndex(tIndex, `/${to.href}`, this.menuAsideData);
                if (selectC != -1) {
                    this.menuNavDataRef[selectC[0]].selected = true;
                    if (selectC[1] !== undefined &&
                        this.menuNavDataRef[selectC[0]].children?.[selectC[1]]) {
                        this.menuNavDataRef[selectC[0]].children[selectC[1]].selected = true;
                    }
                }
            },
        },
    },
    setup(props) {
        const { menuAsideData, secondNavStatus, cacheMenuInfo, cacheMenuInfoCount, clickAction, } = toRefs(props);
        const route = useRoute();
        const hoverSecondNavStatusRef = ref(false); // 悬停二级菜单是否显示
        const secondNavShowRef = ref(secondNavStatus.value); // 二级菜单是否显示
        const menuNavDataRef = ref(menuAsideData.value[selectIndex(`/#${route.path}`, 0, props.menuAsideData)].children); // 当前选中一级菜单的二级菜单数据
        // normal元素类名
        const getClassName = (id) => {
            const select = menuNavIdRef.value === id ? 'select' : '';
            const active = hoverMenuIdRef.value === id ? 'active' : '';
            const block = (menuAsideData.value.find(m => m.id === id)?.menuName === '') ? 'block' : '';
            return `${select} ${active} ${block}`;
        };
        const isOuterLink = (item) => {
            return item.url && item.url.startsWith('http');
        };
        // 二级导航栏显示状态
        const updateSecondNavShow = () => {
            secondNavShowRef.value = !secondNavShowRef.value;
        };
        const handleSecondNavClick = () => {
            secondNavShowRef.value = true;
        };
        // 鼠标悬浮
        const onHoverMenuItem = (id) => {
            const index = menuAsideData.value.findIndex(m => m.id === id);
            if (menuAsideData.value[index] != null &&
                menuAsideData.value[index].menuName != '') {
                hoverMenuIdRef.value = id;
                menuNavDataRef.value = menuAsideData.value[index].children; // 将悬浮项子菜单的数据放进侧边栏中
                if (!secondNavShowRef.value) {
                    hoverSecondNavStatusRef.value = true; // 如果二级菜单是折叠状态，则展开悬停二级菜单
                }
                // 否则为鼠标离开时的情况
            }
            else {
                const value = selectIndex(`/#${route.path}`, 0, props.menuAsideData);
                hoverMenuIdRef.value = menuNavIdRef.value;
                menuNavDataRef.value = menuAsideData.value[value].children; // 将选中项放入侧边栏中
                hoverSecondNavStatusRef.value = false; // 强制关闭悬停二级菜单
            }
        };
        // 点击菜单
        const onClickMenuItem = (item) => {
            if (isOuterLink(item)) {
                return;
            }
            const { id, subMenuType } = item;
            secondNavShowRef.value = subMenuType !== '1';
            const index = menuAsideData.value.findIndex(m => m.id === id);
            if (menuAsideData.value[index] != null &&
                menuAsideData.value[index].menuName != '') {
                const clickAct = clickAction.value;
                menuNavIdRef.value = id;
                menuNavDataRef.value = menuAsideData.value[index].children;
                clickAct(index);
            }
        };
        // 菜单消息提示
        const isMenuInfo = (data) => {
            const cacheIndex = cacheMenuInfo.value.indexOf(data.url);
            if (cacheIndex !== -1) {
                if (cacheMenuInfoCount.value[cacheIndex] !== 0) {
                    return true;
                }
            }
            return false;
        };
        // 判断子菜单有没有消息提示
        const isHaveInfoTip = (data) => {
            let result = false;
            const recursionData = (data) => {
                if (data.children.length > 0) {
                    data.children.forEach((item) => {
                        const curResult = isMenuInfo(item);
                        if (curResult) {
                            result = curResult;
                        }
                        else {
                            recursionData(item);
                        }
                    });
                }
                else {
                    return;
                }
            };
            result = isMenuInfo(data);
            if (result) {
                return result;
            }
            else {
                recursionData(data);
            }
            return result;
        };
        onMounted(() => {
            menuAsideData.value.forEach((item) => {
                if (isHaveInfoTip(item)) {
                    item.asideTips = true;
                }
            });
            watch(props.cacheMenuInfoCount, () => {
                menuAsideData.value.forEach((item) => {
                    if (isHaveInfoTip(item)) {
                        item.asideTips = true;
                    }
                });
            });
        });
        return {
            menuAsideData,
            getClassName,
            secondNavShowRef,
            hoverSecondNavStatusRef,
            menuNavDataRef,
            cacheMenuInfo,
            cacheMenuInfoCount,
            updateSecondNavShow,
            onHoverMenuItem,
            onClickMenuItem,
            navHrefTransfer,
            isOuterLink,
            handleSecondNavClick,
        };
    },
});

const _hoisted_1$k = { class: "avatar" };
const _hoisted_2$g = { class: "menu-list" };
const _hoisted_3$e = ["onMouseenter", "onClick"];
const _hoisted_4$b = ["href", "target"];
const _hoisted_5$9 = ["innerHTML"];
const _hoisted_6$7 = { class: "aside-tips" };
const _hoisted_7$6 = /*#__PURE__*/createElementVNode("p", null, "公司1", -1 /* HOISTED */);
const _hoisted_8$6 = /*#__PURE__*/createElementVNode("p", null, "组织2", -1 /* HOISTED */);
const _hoisted_9$6 = { class: "switch-org" };

function render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  const _component_home_filled = resolveComponent("home-filled");
  const _component_a_popover = resolveComponent("a-popover");
  const _component_SecondNavItem = resolveComponent("SecondNavItem");
  const _component_SecondNav = resolveComponent("SecondNav");

  return (openBlock(), createElementBlock("div", {
    class: "menu-aside",
    onMouseleave: _cache[1] || (_cache[1] = $event => (_ctx.onHoverMenuItem(-1)))
  }, [
    createElementVNode("div", _hoisted_1$k, [
      createVNode(_component_Avatar, {
        name: "用户名称",
        uuid: "99bfaabd289e4fa589b863ee88fe6ef3"
      }),
      createCommentVNode(" <img src=\"\" alt=\"avatar\" title=\"头像\" /> ")
    ]),
    createElementVNode("ul", _hoisted_2$g, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.blockBoxList, ({ blockBoxKey, blockBoxName }) => {
        return (openBlock(), createElementBlock("div", {
          key: blockBoxKey,
          class: normalizeClass(`block-box block-box-${blockBoxName}`)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.menuAsideData.filter(
            (m) => m.blockType === blockBoxKey,
          ), (item) => {
            return (openBlock(), createElementBlock("div", {
              key: item.id
            }, [
              createElementVNode("li", {
                class: normalizeClass(_ctx.getClassName(item.id)),
                onMouseenter: $event => (_ctx.onHoverMenuItem(item.id)),
                onClick: $event => (_ctx.onClickMenuItem(item))
              }, [
                createElementVNode("a", {
                  href: _ctx.navHrefTransfer(item.url),
                  target: _ctx.isOuterLink(item) ? '_blank' : undefined
                }, [
                  createElementVNode("i", {
                    class: "iconfont",
                    innerHTML: item.icon
                  }, null, 8 /* PROPS */, _hoisted_5$9),
                  createElementVNode("span", null, toDisplayString(item.menuName), 1 /* TEXT */),
                  withDirectives(createElementVNode("em", _hoisted_6$7, null, 512 /* NEED_PATCH */), [
                    [vShow, item.asideTips]
                  ])
                ], 8 /* PROPS */, _hoisted_4$b)
              ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_3$e)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    createVNode(_component_a_popover, {
      trigger: "click",
      placement: "rightBottom"
    }, {
      content: withCtx(() => [
        _hoisted_7$6,
        _hoisted_8$6
      ]),
      default: withCtx(() => [
        createElementVNode("div", _hoisted_9$6, [
          createVNode(_component_home_filled)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    createElementVNode("div", {
      class: normalizeClass(['secondNavControl', _ctx.secondNavShowRef ? 'open' : 'close']),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.updateSecondNavShow && _ctx.updateSecondNavShow(...args)))
    }, null, 2 /* CLASS */),
    createVNode(_component_SecondNav, {
      class: normalizeClass([
        _ctx.secondNavShowRef ? 'openSecondNav' : 'closeSecondNav',
        _ctx.hoverSecondNavStatusRef ? 'hoverSecondNav' : 'null',
      ])
    }, {
      default: withCtx(() => [
        createVNode(_component_SecondNavItem, {
          itemData: _ctx.menuNavDataRef,
          cacheMenuInfo: _ctx.cacheMenuInfo,
          cacheMenuInfoCount: _ctx.cacheMenuInfoCount,
          onSecondNavClick: _ctx.handleSecondNavClick
        }, null, 8 /* PROPS */, ["itemData", "cacheMenuInfo", "cacheMenuInfoCount", "onSecondNavClick"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"])
  ], 32 /* HYDRATE_EVENTS */))
}

script$m.render = render$i;
script$m.__file = "packages/layout/menu-aside/menuAside.vue";

var script$l = defineComponent({
    components: {
        CloseOutlined,
    },
    setup() {
        const panes = ref([]);
        const activeKey = ref();
        const route = useRoute();
        const router = useRouter();
        const add = (target) => {
            const { path } = target;
            const index = panes.value.findIndex(p => p.path === path);
            if (index === -1) {
                panes.value.push({ ...target });
            }
        };
        const moveTo = (target) => {
            const { path } = target;
            activeKey.value = path;
        };
        const remove = (targetKey) => {
            let lastIndex = 0;
            panes.value.forEach((pane, i) => {
                if (pane.path === targetKey) {
                    lastIndex = i - 1;
                }
            });
            panes.value = panes.value.filter((pane) => pane.path !== targetKey);
            if (panes.value.length && activeKey.value === targetKey) {
                if (lastIndex >= 0) {
                    activeKey.value = panes.value[lastIndex].path;
                    router.replace(panes.value[lastIndex]);
                }
                else {
                    activeKey.value = panes.value[0].path;
                    router.replace(panes.value[0]);
                }
            }
        };
        watch(route, (target) => {
            if (target.matched.length === 0)
                return;
            add(target);
            moveTo(target);
        }, {
            deep: true,
            immediate: true
        });
        const onUnload = () => {
            localStorage.setItem('SC-NAV-TAB-PANES', JSON.stringify(panes.value));
        };
        onMounted(() => {
            try {
                const cachedPanesStr = localStorage.getItem('SC-NAV-TAB-PANES') || '[]';
                const cachedPanes = JSON.parse(cachedPanesStr) || [];
                cachedPanes.forEach(cp => {
                    add(cp);
                });
            }
            catch (error) {
                panes.value = [...panes.value];
            }
            window.addEventListener('unload', onUnload);
        });
        return {
            panes,
            activeKey,
            remove,
        };
    },
});

const _hoisted_1$j = { class: "sc-nav-tab" };

function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_close_outlined = resolveComponent("close-outlined");
  const _component_a_divider = resolveComponent("a-divider");
  const _component_router_link = resolveComponent("router-link");

  return (openBlock(), createElementBlock("nav", _hoisted_1$j, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.panes, (tag, i) => {
      return (openBlock(), createBlock(_component_router_link, {
        class: normalizeClass(["tab-item", { active: _ctx.activeKey === tag.path }]),
        key: tag.path,
        "data-path": tag.path,
        to: { path: tag.path, query: tag.query },
        title: tag?.meta?.title || tag.name
      }, {
        default: withCtx(() => [
          createElementVNode("p", null, toDisplayString(tag?.meta?.title || tag.name), 1 /* TEXT */),
          (_ctx.panes.length > 1)
            ? (openBlock(), createBlock(_component_close_outlined, {
                key: 0,
                onClick: withModifiers($event => (_ctx.remove(tag.path)), ["prevent","stop"])
              }, null, 8 /* PROPS */, ["onClick"]))
            : createCommentVNode("v-if", true),
          withDirectives(createVNode(_component_a_divider, { type: "vertical" }, null, 512 /* NEED_PATCH */), [
            [vShow, _ctx.activeKey !== tag.path && i !== _ctx.panes.length - 1]
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "data-path", "to", "title"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}

script$l.render = render$h;
script$l.__file = "packages/layout/main/nav-tab/nav-tab.vue";

var script$k = defineComponent({
    name: 'Main',
    components: {
        NavTab: script$l,
    },
});

const _hoisted_1$i = { class: "main-box" };
const _hoisted_2$f = { class: "main" };
const _hoisted_3$d = { class: "main-inner" };

function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_tab = resolveComponent("nav-tab");

  return (openBlock(), createElementBlock("div", _hoisted_1$i, [
    createVNode(_component_nav_tab),
    createElementVNode("main", _hoisted_2$f, [
      createElementVNode("div", _hoisted_3$d, [
        renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}

script$k.render = render$g;
script$k.__file = "packages/layout/main/main.vue";

var script$j = defineComponent({
    name: 'Footer',
});

const _hoisted_1$h = { class: "footer" };

function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$h))
}

script$j.render = render$f;
script$j.__file = "packages/layout/footer/footer.vue";

const LayoutProps = {
    secondNavStatus: {
        type: Boolean,
        default: true,
    },
    baseUrl: {
        type: String,
        default: '/',
    },
    selectedUrl: {
        type: String,
        default: '',
    },
    asideMenus: {
        type: Array,
        default: false,
        require: false,
    },
};
var script$i = defineComponent({
    name: 'Layout',
    components: {
        Main: script$k,
        Footer: script$j,
        MenuAside: script$m,
    },
    props: LayoutProps,
    setup(props) {
        // const { baseUrl, selectedUrl } = toRefs(props);
        const menuAsideDataRef = ref([]); // menu渲染数据
        ref([]); // 菜单信息
        const cacheMenuInfoRef = ref([]); // 缓存菜单信息
        const cacheMenuInfoCountRef = ref([]); // 缓存菜单信息数量
        const firstNavSelectIndex = ref(0); // 一级菜单选中状态
        provide('baseUrl', props.baseUrl);
        // menu待处理事项提示
        // const getMenuInfo = () => {
        //   menuInfoRef.value = (menuJson as any).info.data;
        //   menuInfoRef.value.forEach((item) => {
        //     cacheMenuInfoRef.value.push(item.menuUrl);
        //     cacheMenuInfoCountRef.value.push(item.unprocessedCount);
        //   });
        // };
        // getMenuInfo();
        // menu跳转链接
        const getMenuUrl = (data) => {
            if (!data) {
                return '';
            }
            if (data.url) {
                return data.url;
            }
            else {
                return getMenuUrl(data.children[0]);
            }
        };
        const clickAction = (index) => {
            firstNavSelectIndex.value = index;
        };
        // 处理props
        const handleProps = () => {
            if (menuAsideDataRef.value) {
                menuAsideDataRef.value.forEach((item) => {
                    item.url = getMenuUrl(item);
                });
                menuAsideDataRef.value.forEach((item, index) => {
                    if (item.selected) {
                        firstNavSelectIndex.value = index;
                    }
                });
            }
        };
        handleProps();
        // 获取menu数据
        // menuAsideDataRef.value一级导航的数据
        const getMenuAsideData = async () => {
            if (props.asideMenus) {
                menuAsideDataRef.value = props.asideMenus;
            }
            else {
                const res = await apiMenuAsideData(props.baseUrl, props.selectedUrl);
                if (res && res.code === 0) {
                    menuAsideDataRef.value = res.data.treeNodes;
                }
            }
        };
        getMenuAsideData();
        return {
            menuAsideDataRef,
            firstNavSelectIndex,
            cacheMenuInfoRef,
            cacheMenuInfoCountRef,
            clickAction,
        };
    },
});

const _hoisted_1$g = {
  key: 0,
  class: "layout"
};
const _hoisted_2$e = { class: "main-wrap" };

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MenuAside = resolveComponent("MenuAside");
  const _component_Main = resolveComponent("Main");
  const _component_Footer = resolveComponent("Footer");

  return (_ctx.menuAsideDataRef.length > 0)
    ? (openBlock(), createElementBlock("div", _hoisted_1$g, [
        createElementVNode("div", _hoisted_2$e, [
          createVNode(_component_MenuAside, {
            menuAsideData: _ctx.menuAsideDataRef,
            secondNavStatus: _ctx.secondNavStatus,
            selectedMenuItem: _ctx.firstNavSelectIndex,
            cacheMenuInfo: _ctx.cacheMenuInfoRef,
            cacheMenuInfoCount: _ctx.cacheMenuInfoCountRef,
            clickAction: _ctx.clickAction
          }, null, 8 /* PROPS */, ["menuAsideData", "secondNavStatus", "selectedMenuItem", "cacheMenuInfo", "cacheMenuInfoCount", "clickAction"]),
          createVNode(_component_Main, null, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
          }),
          createVNode(_component_Footer)
        ])
      ]))
    : createCommentVNode("v-if", true)
}

script$i.render = render$e;
script$i.__file = "packages/layout/layout.vue";

script$i.install = (Vue) => {
    Vue.component(script$i.name, script$i);
};

var script$h = defineComponent({
    name: 'ProductNameCellRender',
    components: { Tooltip },
    data() {
        return {
            isCloud: false,
            shelfText: '',
            activeModelLibrary: 1,
        };
    },
    beforeMount() {
        // 上架文描
        this.shelfText = '';
        this.isCloud = false;
        this.activeModelLibrary = this.params.props.getActiveModelLibrary();
        if (this.activeModelLibrary == 2) {
            if (!this.params.data.bHave) {
                this.shelfText = '添加并上架';
                this.isCloud = true;
            }
            else if (!this.params.data.onShelf) {
                this.shelfText = '上架';
            }
        }
        else if (!this.params.data.onShelf) {
            this.shelfText = '上架';
        }
    },
    methods: {
        // 去上架
        handleToAddShelf() {
            this.params.props.toAddShelf &&
                this.params.props.toAddShelf(this.isCloud
                    ? this.params.data.modelId
                    : this.params.data.shopModelId, this.isCloud);
        },
    },
});

const _hoisted_1$f = { class: "mistake-product-name" };
const _hoisted_2$d = ["href"];

function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");

  return (openBlock(), createElementBlock("div", _hoisted_1$f, [
    createVNode(_component_Tooltip, {
      title: `产品名称: ${_ctx.params.data.productName}`
    }, {
      default: withCtx(() => [
        createElementVNode("a", {
          class: "text-ellipsis sc-product-name",
          href: `/product/detail/${_ctx.params.data.shopModelId}`,
          target: "_blank"
        }, toDisplayString(_ctx.params.data.productName || '-'), 9 /* TEXT, PROPS */, _hoisted_2$d)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"]),
    (_ctx.shelfText)
      ? (openBlock(), createElementBlock("a", {
          key: 0,
          style: {"margin-left":"5px"},
          onClick: _cache[0] || (_cache[0] = withModifiers((...args) => (_ctx.handleToAddShelf && _ctx.handleToAddShelf(...args)), ["stop"]))
        }, toDisplayString(_ctx.shelfText), 1 /* TEXT */))
      : createCommentVNode("v-if", true)
  ]))
}

script$h.render = render$d;
script$h.__file = "packages/mistake-popconfirm/src/ProductNameCellRender.vue";

var script$g = defineComponent({
    name: 'ScMistakeInnerGrid',
    components: {
        InnerGrid: script$18,
        EditShelfInformation: script$r,
        /*eslint-disable */
        ProductNameCellRender: script$h,
        /* eslint-enable*/
    },
    props: {
        rowData: {
            type: Array,
            required: true,
        },
        multiMode: {
            type: Boolean,
            default: false,
        },
        activeModelLibrary: {
            type: [Number, String],
            default: 1,
        },
    },
    setup(props, { emit }) {
        // 表格数据
        const rowDataRef = ref([]);
        // 表格初始设置
        const gridDefs = {
            animateRows: false,
            rowMultiSelectWithClick: false,
        };
        const gridOptions = reactive({
            api: {},
            columnApi: {}, // 表格列Api
        });
        // 监听数据变化
        watch(() => props.rowData, () => {
            rowDataRef.value.splice(0);
            rowDataRef.value.push(...props.rowData);
            gridOptions.api.setRowData(rowDataRef.value);
        }, { deep: true });
        // 列配置
        const columnDefs = reactive([
            {
                field: 'checkbox',
                headerName: '',
                width: 45,
                minWidth: 45,
                cellClass: 'sc-table-checkout',
                pinned: 'left',
                resizable: false,
                suppressMenu: true,
                suppressColumnsToolPanel: true,
                headerCheckboxSelection: true,
                checkboxSelection: true,
                hide: !props.multiMode,
                valueFormatter: () => {
                    return undefined;
                },
            },
            {
                field: 'orderNum',
                headerName: '序号',
                minWidth: 50,
                width: 50,
                cellClass: 'ag-cell-align-center',
                resizable: false,
                suppressMenu: true,
                suppressColumnsToolPanel: true,
                pinned: 'left',
                valueGetter: (params) => {
                    return params.node.rowIndex + 1;
                },
            },
            {
                field: 'brandName',
                headerName: '品牌',
                minWidth: 100,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'brandName',
                    },
                },
            },
            {
                field: 'productName',
                headerName: '产品名称',
                minWidth: 150,
                cellClass: 'mistake-cell-flex',
                cellRendererFramework: 'ProductNameCellRender',
                cellRendererParams: {
                    props: {
                        getActiveModelLibrary: () => props.activeModelLibrary,
                        toAddShelf: (id, isCloud) => {
                            toAddShelf(id, isCloud);
                        },
                    },
                },
            },
            {
                field: 'categoryName',
                headerName: '品类',
                minWidth: 150,
                cellClass: 'mistake-cell-flex',
                hide: true,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'textCopy',
                        hideCopy: true,
                        text: (params) => {
                            return params.data.categoryName || '-';
                        },
                    },
                },
                sortable: true,
                unSortIcon: true,
            },
            {
                field: 'seriesName',
                headerName: '系列',
                minWidth: 150,
                cellClass: 'mistake-cell-flex',
                hide: true,
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'textCopy',
                        hideCopy: true,
                        text: (params) => {
                            return params.data.seriesName || '-';
                        },
                    },
                },
                sortable: true,
                unSortIcon: true,
            },
            {
                field: 'materialNo',
                headerName: '订货号',
                minWidth: 150,
                cellClass: 'mistake-cell-flex',
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'textCopy',
                        text: (params) => {
                            return params.data.materialNo || '-';
                        },
                    },
                },
                sortable: true,
                unSortIcon: true,
            },
            {
                field: 'modelName',
                headerName: '产品型号',
                minWidth: 150,
                cellClass: 'mistake-cell-flex',
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'textCopy',
                        text: (params) => {
                            return params.data.modelName || '-';
                        },
                    },
                },
                sortable: true,
                unSortIcon: true,
            },
            {
                field: 'inTransitInventoryQuantity',
                headerName: '在途库存',
                minWidth: 130,
                headerComponent: 'CustomHeader',
                headerComponentParams: {
                    enableExplain: true,
                    explainTipHtml: '供应商已发货，仓库还未清点的备货库存',
                },
                sortable: true,
                unSortIcon: true,
                type: 'rightAligned',
                valueGetter: (params) => {
                    return params.data.inTransitInventoryQuantity || 0;
                },
            },
            {
                field: 'cloudAvailableInventoryQuantity',
                headerName: '云仓可用',
                minWidth: 120,
                sortable: true,
                unSortIcon: true,
                type: 'rightAligned',
                valueGetter: (params) => {
                    return params.data.cloudAvailableInventoryQuantity || 0;
                },
            },
            {
                field: 'selfAvailableInventoryQuantity',
                headerName: '自营可用',
                minWidth: 130,
                width: 130,
                headerComponent: 'CustomHeader',
                headerComponentParams: {
                    enableExplain: true,
                    explainTipHtml: '自营现货库存+虚拟仓现货库存',
                },
                sortable: true,
                unSortIcon: true,
                type: 'rightAligned',
                valueGetter: (params) => {
                    return params.data.selfAvailableInventoryQuantity || 0;
                },
                pinned: 'right',
            },
        ]);
        // 监听是否勾选多选模式
        watch(() => props.multiMode, () => {
            nextTick(() => {
                gridOptions.columnApi.applyColumnState({
                    state: [
                        {
                            colId: 'checkbox',
                            hide: !props.multiMode,
                        },
                    ],
                });
                gridOptions.api.deselectAll();
            });
        });
        // 选中行回调
        const onSelectionChanged = (params) => {
            emit('selectedRowsChange', params);
        };
        // 上架
        const showEditShelfModal = ref(false);
        const shopModelIds = ref([]);
        const isCloudRef = ref(false); // true - 云型号为存入型号库
        const toAddShelf = async (id, isCloud = false) => {
            isCloudRef.value = isCloud;
            showEditShelfModal.value = true;
            shopModelIds.value.splice(0);
            shopModelIds.value.push(id);
        };
        // 挂载到纠错弹框中,避免触发关闭纠错弹框事件
        const getContainer = () => {
            return document.getElementsByClassName('mistake-table')[0];
        };
        // 上架成功
        const addShelfSuccess = (params) => {
            emit('addShelfSuccess', params);
        };
        // 排序后的回调 参数 rowNodes
        const postSort = () => {
            nextTick(() => {
                gridOptions.api.refreshCells();
            });
        };
        return {
            columnDefs,
            rowDataRef,
            gridDefs,
            gridOptions,
            showEditShelfModal,
            isCloudRef,
            shopModelIds,
            onSelectionChanged,
            getContainer,
            addShelfSuccess,
            postSort,
        };
    },
});

const _hoisted_1$e = { class: "mistake-table" };

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_EditShelfInformation = resolveComponent("EditShelfInformation");

  return (openBlock(), createElementBlock("div", _hoisted_1$e, [
    createVNode(_component_InnerGrid, {
      id: "mistakeInnerGrid",
      class: "sc-border-grid",
      columnDefs: _ctx.columnDefs,
      rowData: _ctx.rowDataRef,
      headerHeight: 30,
      gridDefs: _ctx.gridDefs,
      gridOptions: _ctx.gridOptions,
      style: { height: '100%' },
      isRenderTotal: false,
      rowSelection: _ctx.$props.multiMode ? 'multiple' : 'single',
      rowMultiSelectWithClick: _ctx.$props.multiMode,
      postSort: _ctx.postSort,
      onSelectionChanged: _ctx.onSelectionChanged,
      noRowsText: "暂无相关数据"
    }, null, 8 /* PROPS */, ["columnDefs", "rowData", "gridDefs", "gridOptions", "rowSelection", "rowMultiSelectWithClick", "postSort", "onSelectionChanged"]),
    createVNode(_component_EditShelfInformation, {
      visible: _ctx.showEditShelfModal,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.showEditShelfModal) = $event)),
      shopModelIds: _ctx.shopModelIds,
      "onUpdate:shopModelIds": _cache[1] || (_cache[1] = $event => ((_ctx.shopModelIds) = $event)),
      isCloud: _ctx.isCloudRef,
      "onUpdate:isCloud": _cache[2] || (_cache[2] = $event => ((_ctx.isCloudRef) = $event)),
      getContainer: _ctx.getContainer,
      onSuccess: _ctx.addShelfSuccess
    }, null, 8 /* PROPS */, ["visible", "shopModelIds", "isCloud", "getContainer", "onSuccess"])
  ]))
}

script$g.render = render$c;
script$g.__file = "packages/mistake-popconfirm/src/MistakeInnerGrid.vue";

const baseUrl = process.env.VUE_APP_URL;
const urls = {
    searchModel: '/order/operation/manual-order/search-model',
};
// 搜索型号
const searchModelApi = (params) => {
    return http({
        url: urls.searchModel,
        withCredentials: true,
        baseURL: baseUrl,
        method: 'POST',
        headers: { 'Content-Type': 'application/json;chartset=utf-8' },
        data: params,
    }).then((res) => {
        if (res && res.data && res.data.code === 0) {
            return res.data.data;
        }
        else {
            message.error((res.data && res.data.message) || '系统错误，请稍后重试...');
        }
    });
};

var script$f = defineComponent({
    name: 'ScMistakePopconfirm',
    components: {
        Popconfirm: script$1o,
        MistakeInnerGrid: script$g,
        CreateModel: script$y,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        offset: {
            type: Object,
            default: () => ({
                left: '0px',
                top: '0px',
            }),
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 弹框是否显示
        const offsetRef = computed({
            get: () => props.offset,
            set: (val) => {
                emit('update:offset', val);
            },
        });
        const searchValRef = ref('');
        // 型号库切换
        const activeModelLibrary = ref(1);
        // 多选模式切换
        const multiMode = ref(getState('mistakeMultiMode') || false);
        // 展开右侧筛选项
        const expandFilterSelect = ref(true);
        if (getState('mistakeExpandFilterSelect') === false) {
            expandFilterSelect.value = false;
        }
        // 筛选项
        const filterSelect = ref({
            brandNames: [],
            categoryNames: [],
        });
        // 品牌列表
        const brandList = ref([]);
        // 品类列表
        const categoryList = ref([]);
        // 列表数据
        const rowDataRef = ref([]);
        /**
         * 右侧筛选项
         */
        // 记住选项
        const selectLocalState = ref(getState('mistakeSelectState') || false);
        const setSelectLocalState = (ev) => {
            // 记住选项勾选状态缓存
            setState('mistakeSelectState', ev.target.checked);
            if (ev.target.checked) {
                setState('mistakeFilter', filterSelect.value);
            }
            else {
                removeState('mistakeFilter');
            }
        };
        // 查询数据
        const getSearchResult = async (val) => {
            if (val.trim() == '') {
                brandList.value.splice(0);
                categoryList.value.splice(0);
                rowDataRef.value.splice(0);
                return;
            }
            const searchParams = {
                pageSize: 50,
                pageIndex: 1,
                matchString: val.trim(),
                brandNames: filterSelect.value.brandNames,
                fourCategoryNames: filterSelect.value.categoryNames,
                cloudSign: activeModelLibrary.value == 2,
                newLinkageNav: true,
            };
            const data = await searchModelApi(JSON.stringify(searchParams));
            brandList.value.splice(0);
            categoryList.value.splice(0);
            rowDataRef.value.splice(0);
            if (data) {
                if (data.navigationMap) {
                    // 品牌
                    const brandMap = data.navigationMap.brand;
                    if (brandMap) {
                        Object.values(brandMap).forEach((item) => {
                            brandList.value.push(item);
                        });
                    }
                    // 品类
                    const categoryMap = data.navigationMap.category;
                    if (categoryMap) {
                        Object.values(categoryMap).forEach((item) => {
                            categoryList.value.push(item);
                        });
                    }
                }
                // 列表数据
                if (data.elasticSearchModelDtos) {
                    rowDataRef.value.push(...data.elasticSearchModelDtos);
                }
            }
        };
        // 更新缓存数据
        const updateState = () => {
            selectLocalState.value = getState('mistakeSelectState') || false;
            if (selectLocalState.value) {
                setState('mistakeFilter', filterSelect.value);
            }
            getSearchResult(searchValRef.value);
        };
        // 获取本地存储
        const localState = getState('mistakeFilter') || {};
        if (selectLocalState.value) {
            filterSelect.value.brandNames = localState.brandNames || [];
            filterSelect.value.categoryNames = localState.categoryNames || [];
            brandList.value.push(...localState.brandNames);
            categoryList.value.push(...localState.categoryNames);
        }
        // 型号库切换回调
        const changeActiveModelLibrary = () => {
            updateState();
        };
        const handleMultiMode = (ev) => {
            // 多选默认是勾选状态缓存
            setState('mistakeMultiMode', ev.target.checked);
        };
        // 全部品牌
        const selectAllBrand = () => {
            filterSelect.value.brandNames.splice(0);
            updateState();
        };
        // 品牌选项
        const selectBrandItem = (ev) => {
            updateState();
        };
        // 全部品类
        const selectAllCategory = () => {
            filterSelect.value.categoryNames.splice(0);
            updateState();
        };
        // 品类选项
        const selectCategoryItem = (ev) => {
            updateState();
        };
        // 右侧筛选项展开/收起
        const handleExpandFilter = () => {
            expandFilterSelect.value = !expandFilterSelect.value;
            // 多选默认是勾选状态缓存
            setState('mistakeExpandFilterSelect', expandFilterSelect.value);
            emit('handleExpandFilter', expandFilterSelect.value);
        };
        // 搜索
        let searchTimer;
        const handleSearch = (ev) => {
            if (searchTimer)
                clearTimeout(searchTimer);
            searchTimer = setTimeout(async () => {
                getSearchResult(ev.target.value);
            }, 500);
        };
        // 品牌展开/收起
        const expandAllBrands = ref(false);
        const handleExpandAllBrands = () => {
            expandAllBrands.value = !expandAllBrands.value;
        };
        // 纠错搜索框
        const searchInput = ref();
        // 纠错弹框显示/隐藏变化
        watch(() => visibleRef.value, () => {
            nextTick(() => {
                selectLocalState.value = getState('mistakeSelectState') || false;
                if (visibleRef.value) {
                    searchValRef.value = props.value || '';
                    // 自动聚焦
                    searchInput.value.focus();
                    if (selectLocalState.value) {
                        const localState = getState('mistakeFilter') || {};
                        filterSelect.value.brandNames = localState.brandNames || [];
                        filterSelect.value.categoryNames = localState.categoryNames || [];
                        brandList.value.push(...localState.brandNames);
                        categoryList.value.push(...localState.categoryNames);
                    }
                    if (searchValRef.value != '') {
                        getSearchResult(searchValRef.value || '');
                    }
                }
                else {
                    searchValRef.value = '';
                    getSearchResult('');
                    if (!selectLocalState.value) {
                        filterSelect.value.brandNames = [];
                        filterSelect.value.categoryNames = [];
                    }
                }
            });
        });
        // 创建型号
        const showCreateModel = ref(false);
        const toCreateModel = () => {
            showCreateModel.value = true;
        };
        // 型号创建成功回调
        const createModelSuccess = (formState) => {
            emit('createModelSuccess', formState);
        };
        // 选中数据
        const selectedData = ref([]);
        // 获取选中数据
        const selectedRowsChange = (params) => {
            // console.log(params);
            const selectedRows = params.api.getSelectedRows();
            selectedData.value.splice(0);
            if (selectedRows.length > 0) {
                selectedData.value.push(...selectedRows);
            }
            if (!multiMode.value && selectedRows.length > 0) {
                // 单选
                handleOk();
            }
        };
        // 提交
        const handleOk = () => {
            if (selectedData.value.length == 0) {
                message.warning('请先选择型号');
                visibleRef.value = true;
            }
            else {
                // valueRef.value = selectedData.value[0].modelName;
                visibleRef.value = false;
                emit('selectedRowsChange', selectedData.value, activeModelLibrary.value == 2);
            }
        };
        // 挂载到纠错弹框中,避免触发关闭纠错弹框事件
        const getContainer = () => {
            return document.getElementsByClassName('mistable-options-expand')[0];
        };
        // 上架成功
        const addShelfSuccess = (params) => {
            emit('addShelfSuccess', params, activeModelLibrary.value == 2);
        };
        // 渲染节点固定在触发器的父元素中
        const getPopupContainer = (triggerNode) => {
            return triggerNode.parentNode;
        };
        return {
            visibleRef,
            offsetRef,
            searchValRef,
            activeModelLibrary,
            multiMode,
            filterSelect,
            brandList,
            categoryList,
            selectLocalState,
            expandFilterSelect,
            searchInput,
            rowDataRef,
            expandAllBrands,
            showCreateModel,
            handleMultiMode,
            handleSearch,
            selectAllBrand,
            selectBrandItem,
            selectAllCategory,
            selectCategoryItem,
            setSelectLocalState,
            handleExpandFilter,
            selectedRowsChange,
            handleOk,
            changeActiveModelLibrary,
            handleExpandAllBrands,
            toCreateModel,
            getContainer,
            createModelSuccess,
            addShelfSuccess,
            getPopupContainer,
        };
    },
});

const _hoisted_1$d = { class: "sc-correct-mistake" };
const _hoisted_2$c = { class: "mistake-input-wrap" };
const _hoisted_3$c = /*#__PURE__*/createElementVNode("span", null, " 系统为您智能筛选出型号相近的产品供您选择，您也可以通过品牌、品类继续过滤查询。 ", -1 /* HOISTED */);
const _hoisted_4$a = { class: "mistake-container" };
const _hoisted_5$8 = { class: "mistake-table-wrap" };
const _hoisted_6$6 = { class: "mistake-options" };
const _hoisted_7$5 = { class: "mistable-options-tab" };
const _hoisted_8$5 = { class: "mistable-options-expand" };
const _hoisted_9$5 = /*#__PURE__*/createElementVNode("span", null, "添加型号", -1 /* HOISTED */);
const _hoisted_10$4 = [
  _hoisted_9$5
];
const _hoisted_11$4 = { class: "iconfont" };
const _hoisted_12$4 = { class: "mistake-filter" };
const _hoisted_13$1 = { class: "filter-select" };
const _hoisted_14$2 = /*#__PURE__*/createElementVNode("label", null, "品牌：", -1 /* HOISTED */);
const _hoisted_15$2 = { class: "filter-select" };
const _hoisted_16$2 = /*#__PURE__*/createElementVNode("label", null, "品类：", -1 /* HOISTED */);

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = resolveComponent("a-input");
  const _component_MistakeInnerGrid = resolveComponent("MistakeInnerGrid");
  const _component_a_radio_button = resolveComponent("a-radio-button");
  const _component_a_radio_group = resolveComponent("a-radio-group");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_CreateModel = resolveComponent("CreateModel");
  const _component_a_checkbox_group = resolveComponent("a-checkbox-group");
  const _component_Popconfirm = resolveComponent("Popconfirm");

  return withDirectives((openBlock(), createElementBlock("div", {
    class: "mistake-popconfirm-wrap",
    style: normalizeStyle({ left: _ctx.offsetRef.left, top: _ctx.offsetRef.top })
  }, [
    createVNode(_component_Popconfirm, {
      placement: "bottomLeft",
      overlayClassName: 'sc-mistake-popconfirm',
      visible: _ctx.visibleRef,
      "onUpdate:visible": _cache[10] || (_cache[10] = $event => ((_ctx.visibleRef) = $event)),
      "auto-adjust-overflow": false,
      "arrow-point-at-center": false,
      hideBtn: !_ctx.multiMode,
      onConfirm: _ctx.handleOk,
      getPopupContainer: _ctx.getPopupContainer
    }, {
      content: withCtx(() => [
        createElementVNode("div", _hoisted_1$d, [
          createElementVNode("div", _hoisted_2$c, [
            createVNode(_component_a_input, {
              id: "mistakeSearchInput",
              class: "mistake-input",
              value: _ctx.searchValRef,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.searchValRef) = $event)),
              onKeyup: _ctx.handleSearch,
              ref: "searchInput",
              autocomplete: "off"
            }, null, 8 /* PROPS */, ["value", "onKeyup"]),
            _hoisted_3$c
          ]),
          createElementVNode("div", _hoisted_4$a, [
            createElementVNode("div", _hoisted_5$8, [
              createVNode(_component_MistakeInnerGrid, {
                rowData: _ctx.rowDataRef,
                multiMode: _ctx.multiMode,
                activeModelLibrary: _ctx.activeModelLibrary,
                onSelectedRowsChange: _ctx.selectedRowsChange,
                onAddShelfSuccess: _ctx.addShelfSuccess
              }, null, 8 /* PROPS */, ["rowData", "multiMode", "activeModelLibrary", "onSelectedRowsChange", "onAddShelfSuccess"]),
              createElementVNode("div", _hoisted_6$6, [
                createElementVNode("div", _hoisted_7$5, [
                  createVNode(_component_a_radio_group, {
                    value: _ctx.activeModelLibrary,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.activeModelLibrary) = $event)),
                    class: "model-library-group",
                    onChange: _ctx.changeActiveModelLibrary
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_a_radio_button, { value: 1 }, {
                        default: withCtx(() => [
                          createTextVNode("型号库")
                        ]),
                        _: 1 /* STABLE */
                      }),
                      createVNode(_component_a_radio_button, { value: 2 }, {
                        default: withCtx(() => [
                          createTextVNode("云型号库")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value", "onChange"]),
                  createVNode(_component_a_checkbox, {
                    checked: _ctx.multiMode,
                    "onUpdate:checked": _cache[2] || (_cache[2] = $event => ((_ctx.multiMode) = $event)),
                    onChange: _ctx.handleMultiMode
                  }, {
                    default: withCtx(() => [
                      createTextVNode("多选模式")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["checked", "onChange"])
                ]),
                createElementVNode("div", _hoisted_8$5, [
                  createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.toCreateModel && _ctx.toCreateModel(...args))),
                    class: "add-model-btn"
                  }, _hoisted_10$4),
                  createVNode(_component_CreateModel, {
                    title: "新建型号【产品添加成功后默认期货上架】",
                    visible: _ctx.showCreateModel,
                    "onUpdate:visible": _cache[4] || (_cache[4] = $event => ((_ctx.showCreateModel) = $event)),
                    getContainer: _ctx.getContainer,
                    onSuccess: _ctx.createModelSuccess
                  }, null, 8 /* PROPS */, ["visible", "getContainer", "onSuccess"]),
                  createElementVNode("a", {
                    class: "filter-expand",
                    onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.handleExpandFilter && _ctx.handleExpandFilter(...args)))
                  }, [
                    createTextVNode(toDisplayString(_ctx.filterSelect.categoryNames.length +
                        _ctx.filterSelect.brandNames.length) + "个检索条件 ", 1 /* TEXT */),
                    createElementVNode("i", _hoisted_11$4, toDisplayString(_ctx.expandFilterSelect ? '' : ''), 1 /* TEXT */)
                  ])
                ])
              ])
            ]),
            withDirectives(createElementVNode("div", _hoisted_12$4, [
              createVNode(_component_a_checkbox, {
                class: "set-select-state",
                checked: _ctx.selectLocalState,
                "onUpdate:checked": _cache[6] || (_cache[6] = $event => ((_ctx.selectLocalState) = $event)),
                onChange: _ctx.setSelectLocalState
              }, {
                default: withCtx(() => [
                  createTextVNode("记住选项 ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["checked", "onChange"]),
              createElementVNode("div", _hoisted_13$1, [
                _hoisted_14$2,
                createElementVNode("div", null, [
                  createVNode(_component_a_checkbox, {
                    checked: _ctx.filterSelect.brandNames.length == 0,
                    onChange: _ctx.selectAllBrand
                  }, {
                    default: withCtx(() => [
                      createTextVNode("全部 ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["checked", "onChange"]),
                  createVNode(_component_a_checkbox_group, {
                    value: _ctx.filterSelect.brandNames,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => ((_ctx.filterSelect.brandNames) = $event)),
                    name: "brandGroup",
                    onChange: _ctx.selectBrandItem
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.expandAllBrands ||
                      _ctx.brandList.length < 6
                        ? _ctx.brandList
                        : _ctx.brandList.slice(0, 6), (item, index) => {
                        return (openBlock(), createBlock(_component_a_checkbox, {
                          key: index,
                          value: item
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(item), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value", "onChange"]),
                  (_ctx.brandList.length > 6)
                    ? (openBlock(), createElementBlock("a", {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.handleExpandAllBrands && _ctx.handleExpandAllBrands(...args)))
                      }, toDisplayString(_ctx.expandAllBrands ? '收起' : '更多'), 1 /* TEXT */))
                    : createCommentVNode("v-if", true)
                ])
              ]),
              createElementVNode("div", _hoisted_15$2, [
                _hoisted_16$2,
                createElementVNode("div", null, [
                  createVNode(_component_a_checkbox, {
                    checked: _ctx.filterSelect.categoryNames.length == 0,
                    onChange: _ctx.selectAllCategory
                  }, {
                    default: withCtx(() => [
                      createTextVNode("全部 ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["checked", "onChange"]),
                  createVNode(_component_a_checkbox_group, {
                    value: _ctx.filterSelect.categoryNames,
                    "onUpdate:value": _cache[9] || (_cache[9] = $event => ((_ctx.filterSelect.categoryNames) = $event)),
                    name: "brandGroup",
                    onChange: _ctx.selectCategoryItem
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.categoryList, (item, index) => {
                        return (openBlock(), createBlock(_component_a_checkbox, {
                          key: index,
                          value: item
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(item), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value", "onChange"])
                ])
              ])
            ], 512 /* NEED_PATCH */), [
              [vShow, _ctx.expandFilterSelect]
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "hideBtn", "onConfirm", "getPopupContainer"])
  ], 4 /* STYLE */)), [
    [vShow, !!_ctx.visibleRef]
  ])
}

script$f.render = render$b;
script$f.__file = "packages/mistake-popconfirm/src/MistakePopconfirm.vue";

script$f.install = (Vue) => {
    Vue.component(script$f.name, script$f);
};

script$1u.install = (Vue) => {
    Vue.component(script$1u.name, script$1u);
};

var script$e = defineComponent({
    name: 'ScPageFooter',
    props: {
        buttons: {
            type: Array,
            default: () => [],
        },
    },
    setup(props, { emit }) {
        const handleClick = (event, name) => {
            emit(name + 'ButtonClick', event);
        };
        const filterData = (align) => props.buttons.filter((item) => item.align === align);
        const leftButtonsRef = computed(() => filterData('left'));
        const centerButtonsRef = computed(() => filterData('center'));
        const rightButtonsRef = computed(() => filterData('right'));
        return { handleClick, leftButtonsRef, centerButtonsRef, rightButtonsRef };
    },
});

const _hoisted_1$c = { class: "sc-page-footer" };
const _hoisted_2$b = { class: "sc-footer-left sc-page-btn-group" };
const _hoisted_3$b = { class: "sc-footer-center sc-page-btn-group" };
const _hoisted_4$9 = { class: "sc-footer-right sc-page-btn-group" };

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");

  return (openBlock(), createElementBlock("div", _hoisted_1$c, [
    createElementVNode("div", _hoisted_2$b, [
      renderSlot(_ctx.$slots, "leftPrefix"),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.leftButtonsRef, (btn, index) => {
        return (openBlock(), createBlock(_component_a_button, {
          key: index,
          onClick: $event => (_ctx.handleClick($event, btn.name)),
          type: btn.type,
          size: btn.size
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(btn.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "type", "size"]))
      }), 128 /* KEYED_FRAGMENT */)),
      renderSlot(_ctx.$slots, "leftSuffix")
    ]),
    createElementVNode("div", _hoisted_3$b, [
      renderSlot(_ctx.$slots, "centerPrefix"),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.centerButtonsRef, (btn, index) => {
        return (openBlock(), createBlock(_component_a_button, {
          key: index,
          onClick: $event => (_ctx.handleClick($event, btn.name)),
          type: btn.type,
          size: btn.size
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(btn.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "type", "size"]))
      }), 128 /* KEYED_FRAGMENT */)),
      renderSlot(_ctx.$slots, "centerSuffix")
    ]),
    createElementVNode("div", _hoisted_4$9, [
      renderSlot(_ctx.$slots, "rightPrefix"),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.rightButtonsRef, (btn, index) => {
        return (openBlock(), createBlock(_component_a_button, {
          key: index,
          onClick: $event => (_ctx.handleClick($event, btn.name)),
          type: btn.type,
          size: btn.size
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(btn.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "type", "size"]))
      }), 128 /* KEYED_FRAGMENT */)),
      renderSlot(_ctx.$slots, "rightSuffix")
    ])
  ]))
}

script$e.render = render$a;
script$e.__file = "packages/page-footer/src/PageFooter.vue";

script$e.install = (Vue) => {
    Vue.component(script$e.name, script$e);
};

var script$d = defineComponent({
    name: 'ScPageHeader',
    props: {
        avatar: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        subTitle: {
            type: String,
            default: '',
        },
        buttons: {
            type: Array,
            default: () => [],
        },
        titleDesc: {
            type: Array,
            default: () => [],
        },
        subTitleForm: {
            type: Array,
            default: () => [],
        },
    },
    setup(props, { emit }) {
        const isAvatarIcon = computed(() => {
            return props.avatar.indexOf('/') === -1 ? true : false;
        });
        const handleClick = (event, name) => {
            emit(name + 'ButtonClick', event);
        };
        return { isAvatarIcon, handleClick };
    },
});

const _hoisted_1$b = { class: "sc-page-header" };
const _hoisted_2$a = {
  key: 0,
  class: "sc-page-header-avatar"
};
const _hoisted_3$a = ["innerHTML"];
const _hoisted_4$8 = ["src"];
const _hoisted_5$7 = { class: "sc-page-title" };
const _hoisted_6$5 = { class: "sc-title" };
const _hoisted_7$4 = { class: "sc-title-title" };
const _hoisted_8$4 = { class: "sc-subtitle" };
const _hoisted_9$4 = { class: "sc-subtitle-title" };
const _hoisted_10$3 = { key: 0 };
const _hoisted_11$3 = { class: "sc-title-desc" };
const _hoisted_12$3 = { class: "sc-page-btn-group" };

function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");

  return (openBlock(), createElementBlock("div", _hoisted_1$b, [
    (_ctx.avatar)
      ? (openBlock(), createElementBlock("span", _hoisted_2$a, [
          (_ctx.isAvatarIcon)
            ? (openBlock(), createElementBlock("i", {
                key: 0,
                class: "iconfont",
                innerHTML: _ctx.avatar
              }, null, 8 /* PROPS */, _hoisted_3$a))
            : (openBlock(), createElementBlock("img", {
                key: 1,
                src: _ctx.avatar
              }, null, 8 /* PROPS */, _hoisted_4$8))
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("h2", _hoisted_5$7, [
      createElementVNode("span", _hoisted_6$5, [
        renderSlot(_ctx.$slots, "title", {}, () => [
          createElementVNode("div", _hoisted_7$4, [
            createTextVNode(toDisplayString(_ctx.title) + " ", 1 /* TEXT */),
            renderSlot(_ctx.$slots, "titleExtra")
          ])
        ])
      ]),
      createElementVNode("span", _hoisted_8$4, [
        renderSlot(_ctx.$slots, "subTitle", {}, () => [
          createElementVNode("div", _hoisted_9$4, [
            (_ctx.subTitle)
              ? (openBlock(), createElementBlock("div", _hoisted_10$3, toDisplayString(_ctx.subTitle), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_11$3, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.titleDesc, (item, index) => {
                return (openBlock(), createElementBlock("p", {
                  class: normalizeClass([item.selfClass, 'sc-state1-' + item.type]),
                  key: index
                }, toDisplayString(item.label), 3 /* TEXT, CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.subTitleForm, (item) => {
              return (openBlock(), createElementBlock("div", {
                key: item.label
              }, [
                createElementVNode("span", null, toDisplayString(item.label + '：'), 1 /* TEXT */),
                createElementVNode("span", null, toDisplayString(item.value ? item.value : '-'), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    createElementVNode("div", _hoisted_12$3, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.buttons, (btn, index) => {
        return withDirectives((openBlock(), createBlock(_component_a_button, {
          key: index,
          onClick: $event => (_ctx.handleClick($event, btn.name)),
          type: btn.type
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(btn.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "type"])), [
          [vShow, btn.show ? btn.show() : true]
        ])
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}

script$d.render = render$9;
script$d.__file = "packages/page-header/src/PageHeader.vue";

script$d.install = (Vue) => {
    Vue.component(script$d.name, script$d);
};

var script$c = defineComponent({
    name: 'ScPage',
    setup() {
        const hasSlotSide = !!useSlots().side;
        const secondNavShowRef = ref(true);
        const isMounted = ref(false);
        const isInModal = ref(false);
        const scPageRef = ref();
        onMounted(() => {
            isMounted.value = true;
        });
        const updateSecondNavShow = () => {
            secondNavShowRef.value = !secondNavShowRef.value;
        };
        const findParent = (dom) => {
            let a = false;
            if (dom.parentNode) {
                if (dom.parentNode.className?.includes('ant-modal')) {
                    a = true;
                }
                else {
                    return findParent(dom.parentNode);
                }
            }
            return a;
        };
        watch(() => isMounted.value, () => {
            isInModal.value = findParent(scPageRef.value);
        });
        return {
            hasSlotSide,
            secondNavShowRef,
            updateSecondNavShow,
            isMounted,
            findParent,
            isInModal,
            scPageRef,
        };
    },
});

const _hoisted_1$a = { class: "sc-page-body" };
const _hoisted_2$9 = {
  key: 0,
  class: "sc-page-side"
};
const _hoisted_3$9 = {
  key: 0,
  class: "iconfont",
  innerHTML: ''
};
const _hoisted_4$7 = {
  key: 1,
  class: "iconfont",
  innerHTML: ''
};
const _hoisted_5$6 = { class: "sc-page-body-side" };
const _hoisted_6$4 = { class: "sc-page-body-main" };
const _hoisted_7$3 = {
  key: 0,
  class: "sc-page-body-main-top"
};
const _hoisted_8$3 = { class: "sc-page-body-main-bottom" };
const _hoisted_9$3 = { class: "sc-page-body-main-bottom-inset" };

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["sc-page", _ctx.hasSlotSide ? 'has-side' : '']),
    ref: "scPageRef"
  }, [
    renderSlot(_ctx.$slots, "header"),
    createElementVNode("div", _hoisted_1$a, [
      (_ctx.hasSlotSide)
        ? (openBlock(), createElementBlock("div", _hoisted_2$9, [
            (!_ctx.isInModal)
              ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(['secondNavControl', _ctx.secondNavShowRef ? 'open' : 'close']),
                  onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.updateSecondNavShow && _ctx.updateSecondNavShow(...args)))
                }, [
                  (_ctx.secondNavShowRef)
                    ? (openBlock(), createElementBlock("i", _hoisted_3$9))
                    : (openBlock(), createElementBlock("i", _hoisted_4$7))
                ], 2 /* CLASS */))
              : createCommentVNode("v-if", true),
            withDirectives(createElementVNode("div", _hoisted_5$6, [
              renderSlot(_ctx.$slots, "side")
            ], 512 /* NEED_PATCH */), [
              [vShow, _ctx.secondNavShowRef]
            ])
          ]))
        : createCommentVNode("v-if", true),
      createElementVNode("div", _hoisted_6$4, [
        (_ctx.hasSlotSide)
          ? (openBlock(), createElementBlock("div", _hoisted_7$3, [
              renderSlot(_ctx.$slots, "main-top")
            ]))
          : renderSlot(_ctx.$slots, "main-top", { key: 1 }),
        createElementVNode("div", _hoisted_8$3, [
          createElementVNode("div", _hoisted_9$3, [
            renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ]),
    renderSlot(_ctx.$slots, "footer")
  ], 2 /* CLASS */))
}

script$c.render = render$8;
script$c.__file = "packages/page/src/Page.vue";

script$c.install = (Vue) => {
    Vue.component(script$c.name, script$c);
};

var script$b = defineComponent({
    name: 'InvoiceProcess',
    props: {
        auditStatus: {
            type: Boolean,
            default: true,
        },
        sendStatus: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        return {};
    },
});

const _hoisted_1$9 = { class: "sc-invoice-process" };
const _hoisted_2$8 = { class: "verify-flow-chart" };
const _hoisted_3$8 = /*#__PURE__*/createStaticVNode("<div class=\"box-item bg-ks box-item-transfer\" style=\"position:absolute;left:5px;\"> 草稿 </div><div class=\"arrow-container\" style=\"left:66px;top:18px;\"><div class=\"arrow-text transfer-text\">推送</div><div class=\"straight-line transfer-line bg-ks\"></div><div class=\"arrow transfer-arrow gks-border\"></div></div><div class=\"box-item bg-ks box-item-transfer\" style=\"position:absolute;left:142px;\"> 待审核 </div><div class=\"arrow-container\" style=\"left:204px;top:18px;\"><div class=\"arrow-text transfer-text\">通过</div><div class=\"straight-line transfer-line bg-ks\"></div><div class=\"arrow transfer-arrow gks-border\"></div></div><div class=\"arrow-container\" style=\"left:156px;top:52px;width:20px;height:56px;\"><div class=\"arrow-text back transfer-text\">退回</div><div class=\"straight-line transfer-line bg-ks\" style=\"width:3px;height:50px;\"></div><div class=\"arrow direct-bottom transfer-arrow gks-border\"></div></div><div class=\"arrow-container\" style=\"left:170px;top:55px;width:20px;height:56px;\"><div class=\"arrow-text push transfer-text\">推送</div><div class=\"straight-line transfer-line bg-ks\" style=\"width:3px;height:50px;\"></div><div class=\"arrow direct-up transfer-arrow gks-border\"></div></div><div class=\"box-item bg-ks box-item-transfer\" style=\"position:absolute;left:142px;top:112px;\"> 已退回 </div>", 7);
const _hoisted_10$2 = [
  _hoisted_3$8
];
const _hoisted_11$2 = /*#__PURE__*/createStaticVNode("<div class=\"invoice-wait\"><div class=\"box-item bg-ks\" style=\"position:absolute;\">待开票</div><div class=\"arrow-container\" style=\"left:62px;top:18px;\"><div class=\"arrow-text\">开票</div><div class=\"straight-line bg-ks\"></div><div class=\"arrow gks-border\"></div></div></div>", 1);
const _hoisted_12$2 = /*#__PURE__*/createStaticVNode("<div class=\"box-item bg-ks box-item-transfer-send\" style=\"position:absolute;top:18px;left:3px;\"> 待寄送 </div><div class=\"arrow-container\" style=\"left:62px;top:18px;\"><div class=\"arrow-text transfer-text-send\">寄送</div><div class=\"straight-line transfer-line-send bg-ks\"></div><div class=\"arrow transfer-arrow-send gks-border\"></div></div>", 2);
const _hoisted_14$1 = [
  _hoisted_12$2
];
const _hoisted_15$1 = /*#__PURE__*/createElementVNode("div", { class: "completed" }, [
  /*#__PURE__*/createElementVNode("div", {
    class: "box-item bg-ks",
    style: {"position":"absolute","top":"18px","left":"3px"}
  }, " 已完成 ")
], -1 /* HOISTED */);
const _hoisted_16$1 = /*#__PURE__*/createElementVNode("div", { class: "to-back-line-vertical bg-ks" }, null, -1 /* HOISTED */);
const _hoisted_17$1 = /*#__PURE__*/createElementVNode("div", { class: "to-back-line-horizontal bg-ks" }, null, -1 /* HOISTED */);
const _hoisted_18$1 = /*#__PURE__*/createElementVNode("div", { class: "to-back-text" }, "退回", -1 /* HOISTED */);
const _hoisted_19$1 = /*#__PURE__*/createElementVNode("div", { class: "to-back-arrow gks-border" }, null, -1 /* HOISTED */);
const _hoisted_20$1 = [
  _hoisted_16$1,
  _hoisted_17$1,
  _hoisted_18$1,
  _hoisted_19$1
];

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$9, [
    createElementVNode("div", _hoisted_2$8, [
      createElementVNode("div", {
        class: normalizeClass(["specify", _ctx.auditStatus ? '' : 'off-box'])
      }, _hoisted_10$2, 2 /* CLASS */),
      _hoisted_11$2,
      createElementVNode("div", {
        class: normalizeClass(["send-specify", _ctx.sendStatus ? '' : 'off-box'])
      }, _hoisted_14$1, 2 /* CLASS */),
      _hoisted_15$1,
      createElementVNode("div", {
        class: normalizeClass(["to-back", _ctx.auditStatus ? '' : 'off-box'])
      }, _hoisted_20$1, 2 /* CLASS */)
    ])
  ]))
}

script$b.render = render$7;
script$b.__file = "packages/process/src/InvoiceProcess.vue";

script$b.install = (Vue) => {
    Vue.component(script$b.name, script$b);
};

const _hoisted_1$8 = {
    class: "specification-select",
    id: "specification-select"
};
const _hoisted_2$7 = { class: "left-title" };
const _hoisted_3$7 = ["id"];
const _hoisted_4$6 = ["id"];
const _hoisted_5$5 = { class: "select-list" };
const _hoisted_6$3 = {
    key: 0,
    class: "child-select-list"
};
const _hoisted_7$2 = { class: "more" };
const _hoisted_8$2 = ["onClick"];
const _hoisted_9$2 = ["onClick"];
// 默认值;
var script$a = /*#__PURE__*/ defineComponent({
    __name: 'SpecificationSelect',
    props: {
        list: { type: Array, required: true },
        value: { type: Object, required: true },
        resetSelected: { type: Boolean, required: false }
    },
    emits: ["change", "update:value"],
    setup(__props, { emit }) {
        const props = __props;
        const optionsChange = (value, checked, key) => {
            if (!key)
                return;
            const newValue = cloneDeep(props.value);
            if (!newValue[key]) {
                newValue[key] = [];
            }
            if (checked) {
                newValue[key] = [...newValue[key], value];
            }
            else {
                newValue[key] = newValue[key].filter((val) => val !== value);
            }
            emit('update:value', newValue);
            emit('change', newValue, key);
        };
        const onChildrenChange = (checkedValue, key, ids, parentId, parentKey) => {
            if (key) {
                const newValue = cloneDeep(props.value);
                const value = (newValue[key] ?? []).filter((id) => !ids?.includes(id));
                newValue[key] = [...value, ...checkedValue];
                if (checkedValue.length) {
                    newValue[parentKey] = [
                        ...(newValue[parentKey] || []),
                        ...(newValue[parentKey]?.includes(parentId)
                            ? []
                            : [parentId]),
                    ];
                }
                else {
                    newValue[parentKey] =
                        newValue[parentKey]?.filter((d) => d !== parentId) || [];
                }
                emit('update:value', newValue);
                emit('change', newValue, key);
            }
        };
        const isShowBtnArr = ref([]);
        const multiArr = ref([]);
        const getMoreBtn = (num, isNotRefresh) => {
            let a = false;
            nextTick(() => {
                const box = document.getElementById(`dropdown${num}`);
                a = box?.offsetHeight > 46;
                isShowBtnArr.value[num] = a;
            });
        };
        const viewMore = (num) => {
            multiArr.value[num] = !multiArr.value[num];
        };
        onMounted(() => {
            const observer = new ResizeObserver(() => {
                if (props.list.length) {
                    props.list.map((d, i) => {
                        getMoreBtn(i);
                    });
                }
            });
            const targetElement = document.getElementById('specification-select');
            observer.observe(targetElement);
        });
        watch(() => props.list, () => {
            if (props.list.length) {
                props.list.map((d, i) => {
                    getMoreBtn(i);
                });
            }
            if (props.resetSelected) {
                const newValue = cloneDeep(props.value);
                Object.keys(newValue).map((key) => {
                    const list = props.list
                        .find((d) => d.key === key)
                        ?.options?.map((n) => n.id);
                    newValue[key] = newValue[key].filter((d) => list?.includes(d));
                });
                emit('update:value', newValue);
            }
        }, { deep: true });
        return (_ctx, _cache) => {
            const _component_a_checkbox = resolveComponent("a-checkbox");
            const _component_a_checkbox_group = resolveComponent("a-checkbox-group");
            const _component_a_dropdown = resolveComponent("a-dropdown");
            return (openBlock(), createElementBlock("div", _hoisted_1$8, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(props.list, (v, i) => {
                    return (openBlock(), createElementBlock("div", {
                        key: v.key,
                        class: normalizeClass(["colum", i !== __props.list.length - 1 ? 'border' : '']),
                        id: "colum"
                    }, [
                        createElementVNode("div", _hoisted_2$7, toDisplayString(v.name), 1 /* TEXT */),
                        createElementVNode("div", {
                            class: "right-select",
                            style: normalizeStyle({
                                maxHeight: isShowBtnArr.value[i] && !multiArr.value[i] ? '35px' : '176px',
                                overflowY: isShowBtnArr.value[i] && !multiArr.value[i] ? 'hidden' : 'auto',
                            }),
                            id: `right-select${i}`,
                            ref_for: true,
                            ref: "rightSelect"
                        }, [
                            createElementVNode("div", {
                                class: "dropdown",
                                id: `dropdown${i}`
                            }, [
                                (openBlock(true), createElementBlock(Fragment, null, renderList(v.options, (n) => {
                                    return (openBlock(), createBlock(_component_a_dropdown, {
                                        getPopupContainer: (ele) => ele.parentElement,
                                        placement: "bottomLeft",
                                        key: n.id
                                    }, {
                                        overlay: withCtx(() => [
                                            (n.children?.length)
                                                ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
                                                    createVNode(_component_a_checkbox_group, {
                                                        onClick: _cache[0] || (_cache[0] = withModifiers(() => { }, ["stop"])),
                                                        value: n.key && props.value[n.key],
                                                        name: "checkBoxGroup",
                                                        options: n.children?.map((d) => {
                                                            return {
                                                                label: d.name,
                                                                value: d.id,
                                                            };
                                                        }),
                                                        onChange: (checkedValue) => onChildrenChange(checkedValue, n.key, n.children?.map((d) => d.id), n.id, v.key)
                                                    }, null, 8 /* PROPS */, ["value", "options", "onChange"])
                                                ]))
                                                : createCommentVNode("v-if", true)
                                        ]),
                                        default: withCtx(() => [
                                            createElementVNode("div", _hoisted_5$5, [
                                                createVNode(_component_a_checkbox, {
                                                    checked: v.key && props.value[v.key]?.includes(n.id),
                                                    onChange: (e) => optionsChange(n.id, e.target.checked, v.key)
                                                }, {
                                                    default: withCtx(() => [
                                                        createTextVNode(toDisplayString(n.name), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["checked", "onChange"])
                                            ])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["getPopupContainer"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 8 /* PROPS */, _hoisted_4$6)
                        ], 12 /* STYLE, PROPS */, _hoisted_3$7),
                        createElementVNode("div", _hoisted_7$2, [
                            (isShowBtnArr.value[i] && !multiArr.value[i])
                                ? (openBlock(), createElementBlock("div", {
                                    key: 0,
                                    onClick: ($event) => (viewMore(i))
                                }, [
                                    createTextVNode(" 更多 "),
                                    createVNode(unref(DownOutlined))
                                ], 8 /* PROPS */, _hoisted_8$2))
                                : createCommentVNode("v-if", true),
                            (isShowBtnArr.value[i] && multiArr.value[i])
                                ? (openBlock(), createElementBlock("div", {
                                    key: 1,
                                    onClick: ($event) => (viewMore(i))
                                }, [
                                    createTextVNode(" 收起 "),
                                    createVNode(unref(UpOutlined))
                                ], 8 /* PROPS */, _hoisted_9$2))
                                : createCommentVNode("v-if", true)
                        ])
                    ], 2 /* CLASS */));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});

script$a.__file = "packages/specification-select/src/SpecificationSelect.vue";

script$a.install = (Vue) => {
    Vue.component('SpecificationSelect', script$a);
};

const _hoisted_1$7 = ["onClick"];
var script$9 = /*#__PURE__*/ defineComponent({
    __name: 'ScBreadcrumbItem',
    props: {
        id: { type: Number, required: false },
        name: { type: String, required: false },
        key: { type: String, required: false },
        multiple: { type: Boolean, required: false },
        overlay: { type: Array, required: false },
        value: { type: Array, required: false }
    },
    emits: ["change", "close"],
    setup(__props, { emit }) {
        const props = __props;
        function findName(id) {
            return props.overlay?.find(item => item.id === id)?.name ?? props.name;
        }
        const hasOverlay = computed(() => props.overlay?.length);
        const nameToShow = computed(() => {
            if (props.value) {
                return props.value.map(findName).filter(Boolean).join('、');
            }
            else if (props.name) {
                return props.name;
            }
            console.error('[ScBreadcrumbItem]: item必须至少有key或者id name');
            return '';
        });
        const ids = computed(() => {
            return props.value ?? [props.id];
        });
        const visible = ref(false);
        function emitChange(value) {
            const payload = value ?? props.value ?? [props.id];
            const names = payload.map(findName);
            emit('change', payload, names);
        }
        function handleCheckboxChange({ target }, id) {
            if (props.value) {
                let payload = props.value;
                if (target.checked) {
                    payload = [...payload, id];
                }
                else {
                    payload = payload.filter(i => i !== id);
                }
                emit('change', payload, payload.map(findName));
            }
        }
        function handleClose() {
            visible.value = false;
            emit('close');
        }
        return (_ctx, _cache) => {
            return (unref(hasOverlay))
                ? (openBlock(), createBlock(unref(Dropdown), {
                    key: 0,
                    getPopupContainer: (ele) => ele.parentElement,
                    visible: visible.value,
                    "onUpdate:visible": _cache[3] || (_cache[3] = ($event) => ((visible).value = $event)),
                    placement: "bottomLeft",
                    overlayStyle: { paddingTop: '4px' },
                    overlayClassName: "breadcrumb-dropdown"
                }, {
                    overlay: withCtx(() => [
                        createVNode(unref(Menu), null, {
                            default: withCtx(() => [
                                (openBlock(true), createElementBlock(Fragment, null, renderList(props.overlay, (item) => {
                                    return (openBlock(), createBlock(unref(Menu).Item, {
                                        key: item.id,
                                        class: normalizeClass({ highlight: !__props.multiple && unref(ids)?.includes(item.id) })
                                    }, {
                                        default: withCtx(() => [
                                            (__props.multiple)
                                                ? (openBlock(), createElementBlock("div", {
                                                    key: 0,
                                                    onClick: _cache[2] || (_cache[2] = withModifiers(() => { }, ["stop"]))
                                                }, [
                                                    createVNode(unref(Checkbox), {
                                                        value: item.id,
                                                        checked: unref(ids)?.includes(item.id),
                                                        onChange: ($event) => (handleCheckboxChange($event, item.id))
                                                    }, {
                                                        default: withCtx(() => [
                                                            createTextVNode(toDisplayString(item.name), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "checked", "onChange"])
                                                ]))
                                                : (openBlock(), createElementBlock("div", {
                                                    key: 1,
                                                    class: "inner",
                                                    onClick: withModifiers(($event) => (emitChange([item.id])), ["stop"])
                                                }, toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_1$7))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    default: withCtx(() => [
                        createElementVNode("a", {
                            class: "sc-breadcrumb-label",
                            onClick: _cache[1] || (_cache[1] = withModifiers(($event) => (emitChange()), ["stop"]))
                        }, [
                            createElementVNode("div", null, toDisplayString(unref(nameToShow)), 1 /* TEXT */),
                            (__props.multiple)
                                ? (openBlock(), createElementBlock("i", {
                                    key: 0,
                                    class: "close",
                                    onClick: _cache[0] || (_cache[0] = withModifiers(($event) => (handleClose()), ["stop"]))
                                }, [
                                    createVNode(unref(CloseOutlined))
                                ]))
                                : createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getPopupContainer", "visible"]))
                : (openBlock(), createElementBlock("a", {
                    key: 1,
                    onClick: _cache[4] || (_cache[4] = withModifiers(($event) => (emitChange()), ["stop"]))
                }, toDisplayString(unref(nameToShow)), 1 /* TEXT */));
        };
    }
});

script$9.__file = "packages/breadcrumb/src/ScBreadcrumbItem.vue";

var script$8 = /*#__PURE__*/ defineComponent({
    __name: 'ScBreadcrumb',
    props: {
        items: { type: Array, required: true },
        value: { type: Object, required: true }
    },
    emits: ["update:items", "update:value", "change", "close"],
    setup(__props, { emit }) {
        const props = __props;
        function handleNavigationChange(payload, names, item, index) {
            const lastKey = props.items[index].key;
            const rawItems = cloneDeep(props.items);
            const newValue = cloneDeep(props.value);
            const newItems = item.multiple ? rawItems : rawItems.slice(0, index + 1);
            const removedItems = item.multiple ? [] : rawItems.slice(index + 1);
            if (lastKey) {
                newValue[lastKey] = payload;
            }
            else {
                newItems[newItems.length - 1].id = payload[0];
                newItems[newItems.length - 1].name = names[0];
            }
            removedItems.forEach(item => {
                if (item.key) {
                    Reflect.deleteProperty(newValue, item.key);
                }
            });
            emit('update:items', newItems);
            emit('update:value', newValue);
            emit('change', payload, item);
        }
        function handleClose(index) {
            const newItems = cloneDeep(props.items);
            const deleted = newItems.splice(index, 1);
            const newValue = cloneDeep(props.value);
            if (deleted[0].key) {
                Reflect.deleteProperty(newValue, deleted[0].key);
            }
            emit('update:items', newItems);
            emit('update:value', newValue);
            emit('close', index);
        }
        return (_ctx, _cache) => {
            return (openBlock(), createBlock(unref(Breadcrumb), {
                class: "sc-breadcrumb",
                separator: ">"
            }, {
                default: withCtx(() => [
                    createVNode(unref(BreadcrumbItem), null, {
                        default: withCtx(() => [
                            renderSlot(_ctx.$slots, "root")
                        ]),
                        _: 3 /* FORWARDED */
                    }),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (item, index) => {
                        return (openBlock(), createBlock(unref(BreadcrumbItem), {
                            key: item.key
                        }, {
                            default: withCtx(() => [
                                createVNode(script$9, mergeProps(item, {
                                    value: item.key ? props.value[item.key] : undefined,
                                    onChange: (ids, names) => handleNavigationChange(ids, names, item, index),
                                    onClose: ($event) => (handleClose(index))
                                }), null, 16 /* FULL_PROPS */, ["value", "onChange", "onClose"])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 3 /* FORWARDED */
            }));
        };
    }
});

script$8.__file = "packages/breadcrumb/src/ScBreadcrumb.vue";

script$8.install = (Vue) => {
    Vue.component(script$8.name, script$8);
};

// interface ColWidths {
//   [key: number]: number;
// }
var TextType;
(function (TextType) {
    TextType["ADVANCE"] = "\u666E\u901A\u641C\u7D22";
    TextType["NORMAL"] = "\u9AD8\u7EA7\u641C\u7D22";
})(TextType || (TextType = {}));
/**  1. 传参样例，记得插槽传组件过来；
 *   2. icon：如果用组件库的图标，要全局注册； 要不就用网络图，传url
 *   3. 插槽内布局样式，如果是多组件，样式外层自己调整；
 *   3. 如果想传进来的组件默认占比100%， 所有布局用一个容器包裹并给容器加类名 search-slot；不传则为组件默认宽度
 *   4. label宽度不传文字撑开；如果此情况下右侧input框未对齐，则传label宽度过来，普通搜索情况下label宽度用labelWidth_normal；高级搜索情况下，label宽用labelWidth
 *   5. 如果普通搜索数据项，在普通搜索和高级搜索下label宽度不同，给普通搜索数据项labelWidth_normal和labelWidth都传
 *   6. 传label宽度带单位传
 *   7.是否需要切换 isSwitch默认为true
 *
 */
var script$7 = defineComponent({
    name: 'SearchBar',
    props: {
        advanceOptions: {
            type: Object,
            options: {
                type: Array,
                default: () => [],
            },
            count: {
                type: Number,
                default: 4,
            },
            default: () => {
                return {};
            },
        },
        normalOptions: {
            type: Object,
            options: {
                type: Array,
                default: () => [],
            },
            count: {
                type: Number,
                default: 4,
            },
            default: () => {
                return {};
            },
        },
        isSwitch: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        'a-image': Image,
    },
    setup(props) {
        const isShowAdvance = ref(false);
        if (props.isSwitch) {
            isShowAdvance.value =
                JSON.parse(localStorage.getItem('/price/default-price/indexshowMoreConditionV4') || '{}') || false;
        }
        //高级搜索下，每个item根据每行显示个数的宽度，百分比
        const normalItemWidth = ref('20%');
        //高级搜索下，每个item根据每行显示个数的宽度，百分比
        const itemWidth = ref(25);
        const labelText = ref('');
        // 对象数组根据某个属性返回最大值
        // function findMax(options: Array<ListOption>, key: string) {
        //   const tempList: number[] = options.map((el) => el[key]);
        //   return Math.max(...tempList);
        // }
        labelText.value = TextType.ADVANCE;
        itemWidth.value = 100 / props.advanceOptions.count;
        normalItemWidth.value = props.normalOptions.itemWidth
            ? props.normalOptions.itemWidth
            : 100 / props.normalOptions.count + '%';
        function handleChange() {
            isShowAdvance.value = !isShowAdvance.value;
            if (isShowAdvance.value) {
                labelText.value = TextType.NORMAL;
            }
            else {
                labelText.value = TextType.ADVANCE;
            }
            localStorage.setItem('/price/default-price/indexshowMoreConditionV4', JSON.stringify(isShowAdvance.value));
        }
        return {
            isShowAdvance,
            itemWidth,
            normalItemWidth,
            handleChange,
            labelText,
        };
    },
});

const _hoisted_1$6 = { class: "search-form" };
const _hoisted_2$6 = { class: "normal-search-box" };
const _hoisted_3$6 = { class: "search-box" };
const _hoisted_4$5 = { style: {"padding-right":"2px"} };
const _hoisted_5$4 = /*#__PURE__*/createElementVNode("span", { style: {"font-weight":"600","margin-left":"2px"} }, ":", -1 /* HOISTED */);
const _hoisted_6$2 = { class: "slot-col" };
const _hoisted_7$1 = { class: "advance-search-box" };
const _hoisted_8$1 = { class: "top-container" };
const _hoisted_9$1 = { style: {"padding-right":"2px"} };
const _hoisted_10$1 = /*#__PURE__*/createElementVNode("span", { style: {"font-weight":"600","margin-left":"2px"} }, ":", -1 /* HOISTED */);
const _hoisted_11$1 = { class: "slot-col" };
const _hoisted_12$1 = { class: "bottom-btns" };

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_image = resolveComponent("a-image");

  return (openBlock(), createElementBlock("div", _hoisted_1$6, [
    withDirectives(createElementVNode("div", _hoisted_2$6, [
      createElementVNode("div", _hoisted_3$6, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.normalOptions.options, (item, index) => {
          return (openBlock(), createElementBlock("div", {
            class: "normal-item",
            key: index,
            style: normalizeStyle('width:' + _ctx.normalItemWidth)
          }, [
            (item.label)
              ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "label-col",
                  style: normalizeStyle({
              width: item.labelWidth_normal
                ? item.labelWidth_normal
                : 'fit-content',
            })
                }, [
                  createElementVNode("span", _hoisted_4$5, toDisplayString(item.label), 1 /* TEXT */),
                  (item.icon && item.icon.type)
                    ? (openBlock(), createBlock(resolveDynamicComponent(item.icon.type), normalizeProps(mergeProps({ key: 0 }, { ...item.icon })), null, 16 /* FULL_PROPS */))
                    : (item.icon && item.icon.src)
                      ? (openBlock(), createBlock(_component_a_image, normalizeProps(mergeProps({ key: 1 }, { ...item.icon })), null, 16 /* FULL_PROPS */))
                      : createCommentVNode("v-if", true),
                  _hoisted_5$4
                ], 4 /* STYLE */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_6$2, [
              renderSlot(_ctx.$slots, item.slotName)
            ])
          ], 4 /* STYLE */))
        }), 128 /* KEYED_FRAGMENT */)),
        renderSlot(_ctx.$slots, "btns")
      ]),
      (_ctx.isSwitch)
        ? (openBlock(), createElementBlock("span", {
            key: 0,
            style: {"color":"#0a82dc","cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
          }, "高级搜索"))
        : createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */), [
      [vShow, !_ctx.isShowAdvance]
    ]),
    withDirectives(createElementVNode("div", _hoisted_7$1, [
      createElementVNode("div", _hoisted_8$1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.advanceOptions.options, (item, index) => {
          return (openBlock(), createElementBlock("div", {
            class: "search-item",
            key: index,
            style: normalizeStyle({
            width: _ctx.itemWidth + '%',
            'padding-right':
              index % _ctx.advanceOptions.count == _ctx.advanceOptions.count - 1 ? 0 : '',
          })
          }, [
            (item.label)
              ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "label-col",
                  style: normalizeStyle({
              width: item.labelWidth ? item.labelWidth : 'fit-content',
            })
                }, [
                  createElementVNode("span", _hoisted_9$1, toDisplayString(item.label), 1 /* TEXT */),
                  (item.icon && item.icon.type)
                    ? (openBlock(), createBlock(resolveDynamicComponent(item.icon.type), normalizeProps(mergeProps({ key: 0 }, { ...item.icon })), null, 16 /* FULL_PROPS */))
                    : (item.icon && item.icon.src)
                      ? (openBlock(), createBlock(_component_a_image, normalizeProps(mergeProps({ key: 1 }, { ...item.icon })), null, 16 /* FULL_PROPS */))
                      : createCommentVNode("v-if", true),
                  _hoisted_10$1
                ], 4 /* STYLE */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_11$1, [
              renderSlot(_ctx.$slots, item.slotName)
            ])
          ], 4 /* STYLE */))
        }), 128 /* KEYED_FRAGMENT */)),
        createElementVNode("div", {
          class: "search-item",
          style: normalizeStyle({ width: _ctx.itemWidth + '%' })
        }, null, 4 /* STYLE */),
        createElementVNode("div", {
          class: "search-item",
          style: normalizeStyle({ width: _ctx.itemWidth + '%' })
        }, null, 4 /* STYLE */)
      ]),
      createElementVNode("div", _hoisted_12$1, [
        renderSlot(_ctx.$slots, "advance-btns"),
        (_ctx.isSwitch)
          ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: "search-mode",
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
            }, "普通搜索"))
          : createCommentVNode("v-if", true)
      ])
    ], 512 /* NEED_PATCH */), [
      [vShow, _ctx.isShowAdvance]
    ])
  ]))
}

script$7.render = render$6;
script$7.__file = "packages/search/search.vue";

script$7.install = (Vue) => {
    Vue.component(script$7.name, script$7);
};

var script$6 = defineComponent({
    name: 'ScSelectWarehouseModal',
    components: {
        Modal: script$1N,
        InnerGrid: script$18,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        modelInfo: {
            type: Object,
            default: () => ({}),
        },
        rowData: {
            type: Array,
            default: () => [],
        },
        props: {
            type: Object,
            default: () => ({}),
        },
        warehouseLabelMap: {
            type: Object,
            default: () => ({
                10: { name: '自营', class: 'sc-channel-spot' },
                20: { name: '云仓自营', class: 'sc-channel-spot' },
                30: { name: '火山湖发货', class: 'sc-channel-adjust' },
                35: { name: '云仓发货', class: 'sc-channel-adjust' },
                40: { name: '厂家发货', class: 'sc-channel-adjust' },
                50: { name: '第三方发货', class: 'sc-channel-adjust' },
                60: { name: '期货', class: 'sc-channel-future' },
            }),
        },
        showSelfPriceSign: {
            type: Boolean,
            default: false,
        },
        shopId: {
            type: Number,
            default: 0,
        },
        descHidden: {
            type: Boolean,
        },
    },
    setup(props, { emit }) {
        // 弹框是否显示
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        // 型号信息
        const modelInfoRef = computed({
            get: () => props.modelInfo,
            set: (val) => {
                emit('update:modelInfo', val);
            },
        });
        // 表格数据
        const rowDataRef = ref([]);
        // 表格初始设置
        const gridDefs = {
            animateRows: true,
            rowMultiSelectWithClick: false,
            getRowStyle: (params) => {
                if (params.node.rowPinned) {
                    return { background: '#f5f7f7', boxSizing: 'content-box' };
                }
            },
        };
        const gridOptions = reactive({
            api: {},
            columnApi: {},
        });
        // 数量仅支持输入正整数
        const onCellKeyDown = (params) => {
            const field = params.colDef.field;
            const value = params.event.target.value;
            let newValue = '';
            if (field == 'quantity') {
                newValue = writingFormat(value, {
                    decimals: 0,
                    isNegative: false,
                });
                if (newValue != value) {
                    setTimeout(() => {
                        params.event.target.value = newValue;
                    });
                }
            }
        };
        // 合计行处理
        const pinnedBottomRowData = { totalName: '合计购买数量', totalQuantity: 0 };
        const setPinnedBottomRowData = (totalQuantity) => {
            if (totalQuantity == undefined) {
                pinnedBottomRowData.totalQuantity = 0;
                rowDataRef.value.forEach((item) => {
                    pinnedBottomRowData.totalQuantity += parseInt(item.quantity || 0);
                });
            }
            else {
                pinnedBottomRowData.totalQuantity = totalQuantity;
            }
            gridOptions.api.setPinnedBottomRowData &&
                gridOptions.api.setPinnedBottomRowData([pinnedBottomRowData]);
        };
        //计算购买数量
        const caluteMaxPurchase = (data, totalQuantity, isLastWhouse) => {
            //非期货，库存小于起购量时，直接为0
            if (data.warehouseId &&
                (!data.availableQuantity ||
                    data.availableQuantity < data.leastSaleCount)) {
                return 0;
            }
            // 剩余合计数小于起购量时，直接为0
            if (totalQuantity < data.leastSaleCount) {
                if (isLastWhouse) {
                    pinnedBottomRowData.totalQuantity +=
                        data.leastSaleCount - totalQuantity;
                    gridOptions.api.setPinnedBottomRowData &&
                        gridOptions.api.setPinnedBottomRowData([pinnedBottomRowData]);
                }
                return isLastWhouse ? data.leastSaleCount : 0;
            }
            let purchaseNum = 0;
            //由该仓库库存计算
            const availablePurchase = math.accMul(parseInt(String(math.accDiv(data.availableQuantity, data.leastPackCount))), data.leastPackCount) || 0;
            //若是该仓库库存大于剩余总数；有总数计算一个推荐购买数量
            const totalQuantityPurchase = math.accMul(parseInt(String(math.accDiv(totalQuantity, data.leastPackCount))), data.leastPackCount) || 0;
            //期货和非期货
            if (data.warehouseId > 0) {
                if (data.availableQuantity <= totalQuantity) {
                    purchaseNum = availablePurchase;
                }
                else {
                    purchaseNum = totalQuantityPurchase;
                }
            }
            else {
                if (totalQuantity % data.leastPackCount > 0) {
                    purchaseNum = totalQuantityPurchase;
                }
                else {
                    purchaseNum = totalQuantity;
                }
            }
            return purchaseNum;
        };
        // 优先此仓
        const reSplitQuantity = (quantity, warehouseId) => {
            //除去优先拆仓的仓库数量外剩余的总合计数量   e.warehouseId=0是期货
            let totalQuantity = pinnedBottomRowData.totalQuantity -
                (!isNaN(Number(quantity)) ? Number(quantity) : 0);
            const validWhouseList = rowDataRef.value.filter((e) => e.warehouseId != warehouseId &&
                (e.availableQuantity >= e.leastSaleCount || !e.warehouseId));
            const lastWhouse = validWhouseList[validWhouseList.length - 1]; // 库存满足起购量的最后一仓
            const newTableData = JSON.parse(JSON.stringify(rowDataRef.value));
            newTableData.forEach((item) => {
                if (item.warehouseId !== warehouseId) {
                    if (totalQuantity <= 0) {
                        item.quantity = 0;
                    }
                    else {
                        //合计购买数量还有的情况下，若分配数量为0;按最大购买数量计算
                        const purchaseNum = caluteMaxPurchase(item, totalQuantity, lastWhouse && item.warehouseId == lastWhouse.warehouseId) || 0;
                        item.quantity = purchaseNum;
                    }
                    totalQuantity -= item.quantity;
                }
            });
            rowDataRef.value = [...newTableData];
        };
        // 列设置
        const warehouseLabelMapRef = computed(() => props.warehouseLabelMap);
        const columnDefs = ref([
            {
                field: 'warehouseLabel',
                headerName: '渠道',
                width: 90,
                cellRenderer: (params) => {
                    if (!params.node.rowPinned) {
                        const warehouseLabelObj = warehouseLabelMapRef.value[params.data.warehouseLabel];
                        const selfPriceSign = props.showSelfPriceSign && params.data.selfPrice === false
                            ? '*'
                            : '';
                        return `<span class="sc-channel ${warehouseLabelObj.class}">${warehouseLabelObj.name + selfPriceSign || '-'}</span>`;
                    }
                    else {
                        return params.data.totalName;
                    }
                },
            },
            {
                field: 'warehouseName',
                headerName: '发货仓库',
                width: 150,
                cellRenderer: (params) => {
                    if (params.node.rowPinned)
                        return undefined;
                    return `<span class="warehouse-name">${params.data.warehouseName ||
                        '-'}</span>`;
                },
            },
            {
                field: 'predictShippingDate',
                headerName: '发货时效',
                width: 350,
                flex: 1,
                wrapText: true,
                autoHeight: true,
                valueFormatter: (params) => {
                    if (params.node.rowPinned)
                        return undefined;
                    return params.data.predictShippingDate || '-';
                },
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'cellPopconfirm',
                        warningPop: true,
                    },
                    tooltip: {
                        align: 'auto',
                        warnTitleGetter: (params) => {
                            return params.data.remark ? `提醒：${params.data.remark}` : '';
                        },
                        isWarn: (params) => params.data.remark,
                    },
                },
            },
            {
                field: 'availableQuantity',
                headerName: '库存',
                type: 'rightAligned',
                width: 80,
                valueFormatter: (params) => {
                    if (params.node.rowPinned)
                        return undefined;
                    return params.data.channelId == 3
                        ? '-'
                        : math.toThousands({ num: params.data.availableQuantity || 0 }) +
                            (params.data.unit || '');
                },
            },
            {
                field: 'salesPrice',
                headerName: '促销价',
                type: 'rightAligned',
                width: 90,
                valueFormatter: (params) => {
                    if (params.node.rowPinned)
                        return undefined;
                    params.value = params.data.salesPrice || 0;
                    return params.data.salesPrice
                        ? '￥' + priceFormatter(params)
                        : '￥0.00';
                },
            },
            {
                field: 'quantity',
                headerName: '分配数量',
                type: 'rightAligned',
                cellClass: 'ag-right-aligned-cell',
                editable: (params) => {
                    if (params.node.rowPinned)
                        return false;
                    return true;
                },
                valueFormatter: (params) => {
                    if (params.node.rowPinned) {
                        // 合计行
                        return math.toThousands({ num: params.data.totalQuantity || 0 });
                    }
                    return math.toThousands({ num: params.data.quantity || 0 });
                },
                onCellValueChanged(params) {
                    message.destroy();
                    const record = params.data;
                    const key = 'quantity_warn_tip';
                    let newValue = writingFormat(params.newValue, {
                        decimals: 0,
                        isNegative: false,
                    });
                    if (newValue == '' || newValue == null) {
                        params.data.quantity = 0;
                        newValue = 0;
                    }
                    if (!isNaN(Number(newValue)) && Number(newValue) > 0) {
                        // 输入数量大于0需要满足包装规则
                        let maxPurchase = math.accMul(parseInt(String(math.accDiv(params.data.availableQuantity, record.leastPackCount))), record.leastPackCount) || 0; //仓库最大可购买数量
                        maxPurchase < record.leastSaleCount ? (maxPurchase = 0) : null; //仓库最大可购买数量,要大于起购量
                        //计算满足包装量的值
                        const validPurchase = math.accMul(parseInt(String(math.ceil(math.accDiv(newValue, record.leastPackCount), 0))), record.leastPackCount) || 0;
                        let correctValue = Math.max(validPurchase, record.leastSaleCount); //满足包装规则和起购量的值
                        let flag = false; //两个提示都存在时，需延迟提示后一个提示，否则只会显示最后一个提示
                        if (params.data.channelId != 3 && correctValue > maxPurchase) {
                            //超出最大购买数量时，更新为最大购买数量
                            message.warning({
                                content: '该仓库分配数量不能大于该仓库最大可购买数量',
                                key,
                            });
                            correctValue = maxPurchase;
                            flag = true;
                        }
                        pinnedBottomRowData.totalQuantity += correctValue - params.oldValue;
                        setPinnedBottomRowData(pinnedBottomRowData.totalQuantity);
                        if (pinnedBottomRowData.totalQuantity !=
                            modelInfoRef.value.totalQuantity) {
                            const config = {
                                content: '分配数量与原购买数量合计不一致，将自动修改最后一条明细数量',
                                key,
                            };
                            flag
                                ? setTimeout(() => {
                                    message.warning(config);
                                }, 2000)
                                : message.warning(config);
                        }
                        record.quantity = correctValue;
                        params.node.setData(record);
                    }
                    else {
                        //输入数量为0
                        const val = !isNaN(Number(newValue)) ? Number(newValue) : 0;
                        pinnedBottomRowData.totalQuantity += val - params.oldValue;
                        setPinnedBottomRowData(pinnedBottomRowData.totalQuantity);
                        if (pinnedBottomRowData.totalQuantity !=
                            modelInfoRef.value.totalQuantity) {
                            message.warning('分配数量与原购买数量合计不一致，将自动修改最后一条明细数量.');
                        }
                    }
                },
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'packSpecificationTip',
                        noCellTooltip: true,
                    },
                    tooltip: {
                        warnTitle: '该渠道有起订量和包装量限制',
                        isWarn: (params) => {
                            return (params.data.leastSaleCount > 1 || params.data.leastPackCount > 1);
                        },
                        useRecommendCount: (value, params) => {
                            // 使用提示值
                            params.node.setDataValue('quantity', value);
                        },
                        getRecommendQuantity: (params) => {
                            const data = params.data;
                            const quantity = data.quantity;
                            const availableQuantity = data.availableQuantity || 0;
                            const leastPackCount = data.leastPackCount;
                            const leastSaleCount = data.leastSaleCount;
                            let recommendQuantity = 0;
                            if (data.warehouseId && leastSaleCount > availableQuantity) {
                                recommendQuantity = 0;
                            }
                            else if (quantity < leastSaleCount) {
                                recommendQuantity = leastSaleCount;
                            }
                            else {
                                const availableRemainder = availableQuantity % leastPackCount;
                                const maxRecommendQuantity = availableRemainder == 0
                                    ? availableQuantity
                                    : availableQuantity - (leastPackCount - availableRemainder);
                                if (data.warehouseId && quantity >= maxRecommendQuantity) {
                                    recommendQuantity = maxRecommendQuantity;
                                }
                                else {
                                    const remainder = quantity % leastPackCount;
                                    recommendQuantity =
                                        remainder == 0
                                            ? quantity
                                            : quantity + (leastPackCount - remainder);
                                }
                            }
                            return recommendQuantity;
                        },
                    },
                },
            },
            {
                field: 'btnGroup',
                headerName: '快捷分配',
                width: 90,
                pinned: 'right',
                cellRendererFramework: 'CellCommonRenderer',
                cellRendererParams: {
                    props: {
                        type: 'btnGroup',
                        btnGroup: [
                            {
                                btnText: '优先此仓',
                                visible: (params) => !params.node.rowPinned,
                                click: (params) => {
                                    const record = params.data;
                                    const purchaseNum = caluteMaxPurchase(record, pinnedBottomRowData.totalQuantity) || 0;
                                    record.quantity = purchaseNum;
                                    if (purchaseNum == 0 &&
                                        pinnedBottomRowData.totalQuantity > 0) {
                                        if (record.warehouseId &&
                                            (!record.availableQuantity ||
                                                record.availableQuantity < record.leastSaleCount)) {
                                            message.warning('此仓库库存不足，已分配至其他仓库');
                                        }
                                        else {
                                            message.warning('输入数量不满足此仓库最小起购量，已分配至其他仓库');
                                        }
                                    }
                                    reSplitQuantity(record.quantity, record.warehouseId);
                                },
                            },
                        ],
                    },
                },
            },
        ]);
        // 监听shopModelIds变化更新列表数据
        watch(() => visibleRef.value, () => {
            if (visibleRef.value) {
                nextTick(() => {
                    rowDataRef.value.splice(0);
                    rowDataRef.value.push(...(props.rowData || []));
                    gridOptions.api.setRowData(rowDataRef.value);
                    setPinnedBottomRowData();
                });
            }
        }, { deep: true });
        // 确定
        const handleOk = () => {
            // 防止单元格编辑未结束直接点击确定按钮，而编辑内容未保存的问题
            setTimeout(() => {
                emit('submit', { rowData: rowDataRef.value, gridApi: gridOptions.api });
            }, 500);
        };
        return {
            visibleRef,
            modelInfoRef,
            columnDefs,
            rowDataRef,
            gridDefs,
            gridOptions,
            pinnedBottomRowData,
            handleOk,
            onCellKeyDown,
        };
    },
});

const _hoisted_1$5 = { class: "select-warehouse-info" };
const _hoisted_2$5 = { class: "select-warehouse-grid" };
const _hoisted_3$5 = { class: "select-warehouse-desc" };

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InnerGrid = resolveComponent("InnerGrid");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" 选择发货仓 "),
    createVNode(_component_Modal, mergeProps({
      class: "sc-select-warehouse-modal",
      visible: _ctx.visibleRef,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
      title: "选择发货仓",
      width: "900px",
      onOk: _ctx.handleOk
    }, { ..._ctx.$props.props }), {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$5, [
          createElementVNode("span", null, [
            createTextVNode(" 型号： "),
            createElementVNode("em", null, toDisplayString(_ctx.modelInfoRef.modelName || '-'), 1 /* TEXT */)
          ]),
          createElementVNode("span", null, [
            createTextVNode(" 订货号： "),
            createElementVNode("em", null, toDisplayString(_ctx.modelInfoRef.materialNo || '-'), 1 /* TEXT */)
          ])
        ]),
        createElementVNode("div", _hoisted_2$5, [
          createVNode(_component_InnerGrid, {
            columnDefs: _ctx.columnDefs,
            rowData: _ctx.rowDataRef,
            headerHeight: 30,
            gridDefs: _ctx.gridDefs,
            maxHeight: '400px',
            gridOptions: _ctx.gridOptions,
            isRenderTotal: false,
            indexField: 'rowDataId',
            autoHeight: true,
            pinnedBottomRowData: [_ctx.pinnedBottomRowData],
            onCellKeyDown: _ctx.onCellKeyDown
          }, null, 8 /* PROPS */, ["columnDefs", "rowData", "gridDefs", "gridOptions", "pinnedBottomRowData", "onCellKeyDown"])
        ]),
        createElementVNode("div", _hoisted_3$5, [
          (!_ctx.$props.descSlot && !_ctx.$props.descHidden)
            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(_ctx.$props.shopId == 9
            ? '锁库说明：仅自营和火山湖发货的仓库支持锁库'
            : '锁库说明：仅自营、云仓自营和云仓发货的仓库支持锁库'), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : createCommentVNode("v-if", true),
          renderSlot(_ctx.$slots, "desc")
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["visible", "onOk"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}

script$6.render = render$5;
script$6.__file = "packages/select-warehouse-modal/src/SelectWarehouseModal.vue";

script$6.install = (Vue) => {
    Vue.component(script$6.name, script$6);
};

// 自定义列表的表头数组
const customizeList = reactive([
    { title: '列名', dataIndex: 'colName' },
    {
        title: '显示列',
        dataIndex: 'showCol',
        slots: { customRender: 'showCol' },
        width: 60,
        align: 'center',
    },
    {
        title: '冻结列',
        dataIndex: 'fixedCol',
        slots: { customRender: 'fixedCol' },
        width: 60,
        align: 'center',
    },
    {
        title: '冻结方向',
        dataIndex: 'fixedDirection',
        slots: { customRender: 'fixedDirection' },
        width: 125,
        align: 'center',
    },
]);
// 接收参数
const thisProps$1 = {
    columns: {
        type: Array,
        default: () => [],
    },
    innerColumns: {
        type: Array,
        default: () => [],
    },
    changeColumns: {
        type: Function,
    },
};
// 使用到的组件
const usedComponents = {
    [Table.name]: Table,
    [Modal.name]: Modal,
    [Tabs.name]: Tabs,
    [Tabs.TabPane.name]: Tabs.TabPane,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [Radio.Group.name]: Radio.Group,
};
var script$5 = defineComponent({
    name: 'CustomizeModal',
    components: usedComponents,
    props: thisProps$1,
    setup(props, { emit }) {
        // 弹框是否显示
        const visible = ref(false);
        // tab选中值
        const activeKey = ref('1');
        // 自定义列表格数据
        const getInitData = (cols) => {
            const data = reactive([]);
            const initCols = _.cloneDeep(cols);
            initCols.forEach((item) => {
                item.colSpan = item.colSpan === undefined ? 1 : item.colSpan;
                const obj = {
                    colName: item.title,
                    showCol: item.colSpan > 0,
                    fixedCol: !!item.fixed,
                    fixedDirection: item.fixed === 'right' ? 'right' : 'left',
                    field: item.dataIndex || '',
                };
                data.push(obj);
            });
            return data;
        };
        // 初始默认自定义列表
        const defaultBillData = getInitData(props.columns);
        const defaultInnerData = getInitData(props.innerColumns);
        // 响应式自定义列表
        const billData = reactive([]);
        const innerData = reactive([]);
        // 获取记忆自定义配置
        const pathname = window.location.pathname;
        const localColsDataStr = window.localStorage.getItem(pathname + '&customizeCols');
        if (localColsDataStr) {
            const localColsData = JSON.parse(localColsDataStr);
            billData.push(...localColsData.billData);
            innerData.push(...localColsData.innerData);
        }
        else {
            billData.push(..._.cloneDeep(defaultBillData));
            innerData.push(..._.cloneDeep(defaultInnerData));
        }
        // 高级配置
        const localAdvancedStr = window.localStorage.getItem(pathname + '&advancedConfig');
        const advancedConfig = ref({
            enterType: 1,
            tabType: 2,
        });
        if (localAdvancedStr) {
            const localAdvancedConfig = JSON.parse(localAdvancedStr);
            advancedConfig.value = { ...localAdvancedConfig };
        }
        // 根据自定义列配置设置表头数组
        const setCustomCols = (cols, colsData) => {
            const newCols = [];
            const colsDataDto = {};
            colsData.forEach((item) => {
                const field = item.field;
                colsDataDto[field] = item;
            });
            cols.forEach((item) => {
                const field = item.dataIndex || '';
                const customItem = colsDataDto[field];
                if (!customItem.showCol) {
                    item.colSpan = 0;
                }
                else {
                    item.colSpan = 1;
                    item.fixed =
                        customItem.fixedCol && customItem.showCol
                            ? customItem.fixedDirection
                            : false;
                    newCols.push(item);
                }
            });
            return newCols;
        };
        // 更新表头数组
        const emitChangeColumns = () => {
            const newCols = setCustomCols(props.columns, billData);
            const newInnerCols = setCustomCols(props.innerColumns, innerData);
            emit('changeColumns', _.cloneDeep(newCols), _.cloneDeep(newInnerCols));
            // 记忆自定义配置
            window.localStorage.setItem(pathname + '&customizeCols', JSON.stringify({ billData, innerData }));
            // 记忆高级配置
            window.localStorage.setItem(pathname + '&advancedConfig', JSON.stringify(advancedConfig.value));
        };
        emitChangeColumns();
        // 显示自定义列弹框
        const showModal = () => {
            visible.value = true;
        };
        // 确认关闭弹框
        const handleOk = () => {
            visible.value = false;
            emitChangeColumns();
        };
        // 恢复默认
        const restoreDefaultCols = () => {
            billData.splice(0, billData.length);
            billData.push(..._.cloneDeep(defaultBillData));
            innerData.splice(0, innerData.length);
            innerData.push(..._.cloneDeep(defaultInnerData));
            visible.value = false;
            advancedConfig.value.enterType = 1;
            advancedConfig.value.tabType = 2;
            emitChangeColumns();
        };
        // 全部显示
        const showAllCols = () => {
            billData.forEach((item) => {
                item.showCol = true;
            });
            innerData.forEach((item) => {
                item.showCol = true;
            });
        };
        return {
            checkValue: ref([]),
            customizeList,
            visible,
            showModal,
            handleOk,
            activeKey,
            billData,
            innerData,
            restoreDefaultCols,
            showAllCols,
            advancedConfig,
        };
    },
});

const _hoisted_1$4 = { class: "sc-table-box" };
const _hoisted_2$4 = { class: "table-option" };
const _hoisted_3$4 = { class: "table-tools" };
const _hoisted_4$4 = /*#__PURE__*/createElementVNode("i", {
  class: "iconfont customer-iconfont",
  "data-extend": "#checkInventory",
  innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_5$3 = [
  _hoisted_4$4
];
const _hoisted_6$1 = /*#__PURE__*/createElementVNode("span", null, "|", -1 /* HOISTED */);

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_radio = resolveComponent("a-radio");
  const _component_a_radio_group = resolveComponent("a-radio-group");
  const _component_a_table = resolveComponent("a-table");
  const _component_a_tab_pane = resolveComponent("a-tab-pane");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_form = resolveComponent("a-form");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_tabs = resolveComponent("a-tabs");
  const _component_a_modal = resolveComponent("a-modal");

  return (openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("div", _hoisted_2$4, [
      createElementVNode("div", _hoisted_3$4, [
        renderSlot(_ctx.$slots, "tableTools"),
        createElementVNode("span", {
          class: "option-btn-icon customize-btn",
          title: "自定义列表项",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, _hoisted_5$3),
        createVNode(_component_a_modal, {
          visible: _ctx.visible,
          "onUpdate:visible": _cache[4] || (_cache[4] = $event => ((_ctx.visible) = $event)),
          title: "自定义列表",
          width: "600px",
          onOk: _ctx.handleOk,
          class: "customer-modal"
        }, {
          default: withCtx(() => [
            createVNode(_component_a_tabs, {
              type: "card",
              activeKey: _ctx.activeKey,
              "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => ((_ctx.activeKey) = $event)),
              tabBarGutter: 0
            }, {
              tabBarExtraContent: withCtx(() => [
                createVNode(_component_a_button, {
                  type: "link",
                  onClick: _ctx.restoreDefaultCols
                }, {
                  default: withCtx(() => [
                    createTextVNode("恢复默认")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _hoisted_6$1,
                createVNode(_component_a_button, {
                  type: "link",
                  onClick: _ctx.showAllCols
                }, {
                  default: withCtx(() => [
                    createTextVNode("全部显示")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              default: withCtx(() => [
                createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "单据列"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_a_table, {
                      columns: _ctx.customizeList,
                      "data-source": _ctx.billData,
                      pagination: false,
                      scroll: { x: false, y: 300 },
                      size: "small",
                      bordered: ""
                    }, {
                      showCol: withCtx(({ record }) => [
                        createVNode(_component_a_checkbox, {
                          checked: record.showCol,
                          "onUpdate:checked": $event => ((record.showCol) = $event)
                        }, null, 8 /* PROPS */, ["checked", "onUpdate:checked"])
                      ]),
                      fixedCol: withCtx(({ record }) => [
                        createCommentVNode(" <a-switch v-model:checked=\"record.fixedCol\" /> "),
                        createVNode(_component_a_checkbox, {
                          checked: record.fixedCol,
                          "onUpdate:checked": $event => ((record.fixedCol) = $event),
                          disabled: !record.showCol
                        }, null, 8 /* PROPS */, ["checked", "onUpdate:checked", "disabled"])
                      ]),
                      fixedDirection: withCtx(({ record }) => [
                        createVNode(_component_a_radio_group, {
                          name: "radioGroup",
                          value: record.fixedDirection,
                          "onUpdate:value": $event => ((record.fixedDirection) = $event),
                          disabled: !record.fixedCol || !record.showCol
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_a_radio, { value: "left" }, {
                              default: withCtx(() => [
                                createTextVNode("左")
                              ]),
                              _: 1 /* STABLE */
                            }),
                            createVNode(_component_a_radio, { value: "right" }, {
                              default: withCtx(() => [
                                createTextVNode("右")
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["columns", "data-source"])
                  ]),
                  _: 1 /* STABLE */
                }),
                (_ctx.innerColumns && _ctx.innerColumns.length > 0)
                  ? (openBlock(), createBlock(_component_a_tab_pane, {
                      key: "2",
                      tab: "明细列"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_a_table, {
                          columns: _ctx.customizeList,
                          "data-source": _ctx.innerData,
                          pagination: false,
                          scroll: { x: false, y: 300 },
                          size: "small",
                          bordered: ""
                        }, {
                          showCol: withCtx(({ record }) => [
                            createVNode(_component_a_checkbox, {
                              checked: record.showCol,
                              "onUpdate:checked": $event => ((record.showCol) = $event)
                            }, null, 8 /* PROPS */, ["checked", "onUpdate:checked"])
                          ]),
                          fixedCol: withCtx(({ record }) => [
                            createCommentVNode(" <a-switch v-model:checked=\"record.fixedCol\" /> "),
                            createVNode(_component_a_checkbox, {
                              checked: record.fixedCol,
                              "onUpdate:checked": $event => ((record.fixedCol) = $event),
                              disabled: !record.showCol
                            }, null, 8 /* PROPS */, ["checked", "onUpdate:checked", "disabled"])
                          ]),
                          fixedDirection: withCtx(({ record }) => [
                            createVNode(_component_a_radio_group, {
                              name: "radioGroup",
                              value: record.fixedDirection,
                              "onUpdate:value": $event => ((record.fixedDirection) = $event),
                              disabled: !record.fixedCol || !record.showCol
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_a_radio, { value: "left" }, {
                                  default: withCtx(() => [
                                    createTextVNode("左")
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                createVNode(_component_a_radio, { value: "right" }, {
                                  default: withCtx(() => [
                                    createTextVNode("右")
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onUpdate:value", "disabled"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["columns", "data-source"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true),
                createVNode(_component_a_tab_pane, {
                  key: "3",
                  tab: "高级配置"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_a_form, null, {
                      default: withCtx(() => [
                        createVNode(_component_a_form_item, {
                          label: "快捷键设置",
                          colon: false,
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                          labelAlign: "left"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_a_form_item, {
                              label: "Enter键",
                              colon: false,
                              "label-col": { span: 5 },
                              labelAlign: "left"
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_a_radio_group, {
                                  name: "enterType",
                                  value: _ctx.advancedConfig.enterType,
                                  "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.advancedConfig.enterType) = $event))
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_a_radio, { value: 1 }, {
                                      default: withCtx(() => [
                                        createTextVNode("向下换行")
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    createVNode(_component_a_radio, { value: 2 }, {
                                      default: withCtx(() => [
                                        createTextVNode("向右换行")
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["value"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            createVNode(_component_a_form_item, {
                              label: "Tab键",
                              colon: false,
                              "label-col": { span: 5 },
                              labelAlign: "left"
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_a_radio_group, {
                                  name: "tabType",
                                  value: _ctx.advancedConfig.tabType,
                                  "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.advancedConfig.tabType) = $event))
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_a_radio, { value: 1 }, {
                                      default: withCtx(() => [
                                        createTextVNode("向下换行")
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    createVNode(_component_a_radio, { value: 2 }, {
                                      default: withCtx(() => [
                                        createTextVNode("向右换行")
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["value"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["activeKey"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["visible", "onOk"])
      ])
    ]),
    renderSlot(_ctx.$slots, "table")
  ]))
}

script$5.render = render$4;
script$5.__file = "packages/table/customizeModal.vue";

const thisProps = {
    text: {
        type: [String, Number],
        default: '',
    },
    record: {
        type: Object,
        default: {},
    },
    name: {
        type: String,
        default: '',
    },
    rowClassName: {
        type: String,
    },
    align: {
        type: String,
        default: 'left',
    },
    disEditable: {
        type: Boolean,
        default: true,
    },
    data: {
        type: Array,
        default: [],
    },
    saveCallback: {
        type: Function,
        default: null,
    },
    focusCallback: {
        type: Function,
        default: null,
    },
    editKey: {
        type: [String, Number],
        default: 'id',
    },
};
var script$4 = defineComponent({
    name: 'EditableCell',
    props: thisProps,
    setup(props) {
        const editText = ref(props.text);
        watch(() => props.text, () => {
            editText.value = props.text;
        });
        const editCellObj = reactive({});
        // 获取记忆自定义配置
        const pathname = window.location.pathname;
        // 快捷键默认配置
        const advancedConfig = ref({
            enterType: 1,
            tabType: 2,
        });
        const updateAdvancedConfig = () => {
            const localAdvancedStr = window.localStorage.getItem(pathname + '&advancedConfig');
            if (localAdvancedStr) {
                const localAdvancedConfig = JSON.parse(localAdvancedStr);
                advancedConfig.value = { ...localAdvancedConfig };
            }
        };
        // 点击进入编辑状态
        const edit = (editKey, name) => {
            editCellObj[name] = _.cloneDeep(props.data.filter((item) => editKey === item[props.editKey])[0]);
            setTimeout(() => {
                document
                    .getElementsByClassName('editable-cell-input-wrapper')[0]
                    .getElementsByTagName('input')[0]
                    .focus();
            }, 5);
        };
        let isSaved = true;
        // 键盘事件
        const cellKeycodes = [9, 13, 37, 38, 39, 40];
        const cellKeyEvent = (ev) => {
            const keycode = ev.keyCode;
            // 非上、下、左、右、tab、enter键时拦截
            if (cellKeycodes.indexOf(keycode) == -1)
                return;
            isSaved = false;
            const thisCell = ev.target.parentNode.parentNode;
            const thisRow = thisCell.parentNode.parentNode;
            const name = thisCell.getAttribute('name');
            // 当前列的所有编辑框
            const columnCells = document.querySelectorAll(`.editable-cell[name="${name}"]`);
            let columnIndex = 0;
            for (let i = 0; i < columnCells.length; i++) {
                if (thisCell == columnCells[i]) {
                    columnIndex = i;
                    break;
                }
            }
            // 当前行的所有编辑框
            const editCells = thisRow.getElementsByClassName('editable-cell');
            let thisIndex = 0;
            for (let i = 0; i < editCells.length; i++) {
                if (thisCell == editCells[i]) {
                    thisIndex = i;
                }
            }
            // 向左/右切换到上/下一行有编辑框的行
            const changeRow = (type) => {
                // 当前表格的所有行
                const allRows = document.getElementsByClassName('editable-row');
                let rowIndex = 0;
                // 当前表格有编辑框的所有行
                const rows = [];
                for (let i = 0; i < allRows.length; i++) {
                    if (allRows[i].getElementsByClassName('editable-cell').length > 0) {
                        rows.push(allRows[i]);
                    }
                }
                // 当前行在有编辑框的所有行中的索引
                for (let i = 0; i < rows.length; i++) {
                    if (thisRow == rows[i]) {
                        rowIndex = i;
                        break;
                    }
                }
                // 切换到上一行/下一行
                const condition = type == 'left' ? rowIndex > 0 : rowIndex < rows.length - 1;
                const newRowIndex = type == 'left' ? rowIndex - 1 : rowIndex + 1;
                if (condition) {
                    const rowCells = rows[newRowIndex].getElementsByClassName('editable-cell');
                    const newCellIndex = type == 'left' ? rowCells.length - 1 : 0;
                    const newCell = rowCells[newCellIndex].getElementsByClassName('editable-cell-text-wrapper')[0];
                    delete editCellObj[name];
                    newCell.click();
                }
            };
            // 向上换行
            const keycodeOfup = () => {
                if (columnIndex > 0) {
                    const newCell = columnCells[columnIndex - 1].getElementsByClassName('editable-cell-text-wrapper')[0];
                    delete editCellObj[name];
                    newCell.click();
                }
            };
            // 向下换行
            const keycodeOfdown = () => {
                if (columnIndex < columnCells.length - 1) {
                    const newCell = columnCells[columnIndex + 1].getElementsByClassName('editable-cell-text-wrapper')[0];
                    delete editCellObj[name];
                    newCell.click();
                }
            };
            // 向左换行
            const keycodeOfLeft = () => {
                if (thisIndex > 0) {
                    const newCell = editCells[thisIndex - 1].getElementsByClassName('editable-cell-text-wrapper')[0];
                    delete editCellObj[name];
                    newCell.click();
                }
                else {
                    changeRow('left');
                }
            };
            // 向右换行
            const keycodeOfRight = () => {
                if (thisIndex < editCells.length - 1) {
                    const newCell = editCells[thisIndex + 1].getElementsByClassName('editable-cell-text-wrapper')[0];
                    delete editCellObj[name];
                    newCell.click();
                }
                else {
                    changeRow('right');
                }
            };
            switch (keycode) {
                case 38: // 上
                    keycodeOfup();
                    break;
                case 40: // 下
                    keycodeOfdown();
                    break;
                case 37: // 左
                    keycodeOfLeft();
                    break;
                case 39: // 右
                    keycodeOfRight();
                    break;
                case 9: // Tab
                    updateAdvancedConfig();
                    if (advancedConfig.value.tabType === 1) {
                        keycodeOfdown();
                    }
                    else {
                        keycodeOfRight();
                    }
                    break;
                case 13: // Enter
                    updateAdvancedConfig();
                    if (advancedConfig.value.enterType === 1) {
                        keycodeOfdown();
                    }
                    else {
                        keycodeOfRight();
                    }
                    break;
            }
            setTimeout(() => {
                isSaved = true;
            }, 5);
        };
        // 失焦保存
        const save = (ev, editKey, name) => {
            if (!isSaved)
                return;
            const value = ev.target.value;
            const oldValue = ev.target.getAttribute('data-old-val');
            if (value == oldValue) {
                delete editCellObj[name];
                return;
            }
            if (props.saveCallback) {
                const flag = props.saveCallback(ev, editText, editCellObj[name]);
                if ((flag == undefined || flag) && Array.isArray(props.data)) {
                    Object.assign(props.data.filter((item) => editKey === item[props.editKey])[0], editCellObj[name]);
                    delete editCellObj[name];
                }
            }
            else {
                delete editCellObj[name];
            }
        };
        // 阻止键盘默认事件
        const keyDownEvent = (ev) => {
            const keycode = ev.keyCode;
            if (keycode === 9) {
                ev.preventDefault();
            }
        };
        // 聚焦事件
        const focusEvent = (ev, record) => {
            const value = ev.target.value;
            ev.target.setAttribute('data-old-val', value);
            if (props.focusCallback) {
                props.focusCallback(ev, editText, record);
            }
            ev.target.select();
        };
        return {
            editCellObj,
            edit,
            save,
            cellKeyEvent,
            keyDownEvent,
            focusEvent,
            advancedConfig,
            editText,
        };
    },
});

const _hoisted_1$3 = ["name", "align"];
const _hoisted_2$3 = {
  key: 0,
  class: "editable-cell-input-wrapper"
};
const _hoisted_3$3 = ["align"];
const _hoisted_4$3 = ["align"];

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = resolveComponent("a-input");

  return (_ctx.disEditable)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "editable-cell",
        name: _ctx.name,
        align: _ctx.align
      }, [
        (_ctx.editCellObj[_ctx.name] && _ctx.editCellObj[_ctx.name][_ctx.editKey] == _ctx.record[_ctx.editKey])
          ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
              createVNode(_component_a_input, {
                value: _ctx.editText,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.editText) = $event)),
                onBlur: _cache[1] || (_cache[1] = $event => (_ctx.save($event, _ctx.record[_ctx.editKey], _ctx.name))),
                onKeydown: _cache[2] || (_cache[2] = $event => (_ctx.keyDownEvent($event))),
                onKeyup: _ctx.cellKeyEvent,
                onFocus: _cache[3] || (_cache[3] = $event => (_ctx.focusEvent($event, _ctx.record)))
              }, null, 8 /* PROPS */, ["value", "onKeyup"])
            ]))
          : (_ctx.$slots.editContent)
            ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: "editable-cell-text-wrapper",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.edit(_ctx.record[_ctx.editKey], _ctx.name)))
              }, [
                renderSlot(_ctx.$slots, "editContent", { editText: _ctx.editText })
              ]))
            : (openBlock(), createElementBlock("div", {
                key: 2,
                class: "editable-cell-text-wrapper",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.edit(_ctx.record[_ctx.editKey], _ctx.name)))
              }, toDisplayString(_ctx.editText), 1 /* TEXT */))
      ], 8 /* PROPS */, _hoisted_1$3))
    : (_ctx.$slots.editContent)
      ? (openBlock(), createElementBlock("div", {
          key: 1,
          align: _ctx.align
        }, [
          renderSlot(_ctx.$slots, "editContent", { editText: _ctx.editText })
        ], 8 /* PROPS */, _hoisted_3$3))
      : (openBlock(), createElementBlock("div", {
          key: 2,
          align: _ctx.align
        }, toDisplayString(_ctx.editText), 9 /* TEXT, PROPS */, _hoisted_4$3))
}

script$4.render = render$3;
script$4.__file = "packages/table/editableCell.vue";

script$5.install = (Vue) => {
    Vue.component(script$5.name, script$5);
    Vue.component(script$4.name, script$4);
};

var script$3 = defineComponent({
    name: 'ScTotalBar',
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        return { math };
    },
});

const _hoisted_1$2 = { class: "sc-total-bar sc-tips-search-result" };
const _hoisted_2$2 = ["innerHTML"];
const _hoisted_3$2 = {
  key: 1,
  class: "sc-total-count"
};
const _hoisted_4$2 = { key: 2 };
const _hoisted_5$2 = { key: 3 };

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$2, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.datas, (item, index) => {
      return (openBlock(), createElementBlock(Fragment, { key: index }, [
        (item.icon)
          ? (openBlock(), createElementBlock("i", {
              key: 0,
              class: "iconfont",
              innerHTML: item.icon
            }, null, 8 /* PROPS */, _hoisted_2$2))
          : createCommentVNode("v-if", true),
        (item.type === 'count')
          ? (openBlock(), createElementBlock("span", _hoisted_3$2, [
              createTextVNode(toDisplayString(item.label) + " ", 1 /* TEXT */),
              createElementVNode("em", null, toDisplayString(item.value), 1 /* TEXT */),
              createTextVNode(" " + toDisplayString(item.suffix), 1 /* TEXT */)
            ]))
          : (item.type === 'strong')
            ? (openBlock(), createElementBlock("span", _hoisted_4$2, [
                createTextVNode(toDisplayString(item.label) + "：", 1 /* TEXT */),
                createElementVNode("b", null, toDisplayString(item.value), 1 /* TEXT */),
                createTextVNode(" " + toDisplayString(item.suffix), 1 /* TEXT */)
              ]))
            : (openBlock(), createElementBlock("span", _hoisted_5$2, [
                createTextVNode(toDisplayString(item.label) + "：", 1 /* TEXT */),
                createElementVNode("b", null, toDisplayString(item.prefix) + toDisplayString(_ctx.math.toThousands({ num: item.value, cent: 2 })), 1 /* TEXT */),
                createTextVNode(" " + toDisplayString(item.suffix), 1 /* TEXT */)
              ]))
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}

script$3.render = render$2;
script$3.__file = "packages/total-bar/src/TotalBar.vue";

script$3.install = (Vue) => {
    Vue.component(script$3.name, script$3);
};

const _hoisted_1$1 = { class: "sc-tree-panel" };
const _hoisted_2$1 = {
    key: 0,
    class: "sc-tree-panel-header"
};
const _hoisted_3$1 = { class: "sc-expand-collapse-buttons" };
const _hoisted_4$1 = /*#__PURE__*/ createElementVNode("i", {
    class: "iconfont expand-all",
    innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_5$1 = /*#__PURE__*/ createElementVNode("i", {
    class: "iconfont collapse-all",
    innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_6 = { class: "sc-tree-panel-body" };
const _hoisted_7 = {
    key: 0,
    class: "sc-tree-panel-search"
};
const _hoisted_8 = { class: "sc-tree-panel-node" };
const _hoisted_9 = ["title"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
    key: 1,
    class: "sc-expand-collapse-buttons"
};
const _hoisted_12 = /*#__PURE__*/ createElementVNode("i", {
    class: "iconfont expand-all",
    innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ createElementVNode("i", {
    class: "iconfont collapse-all",
    innerHTML: ''
}, null, -1 /* HOISTED */);
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/ createElementVNode("i", { class: "iconfont node-button more-action" }, "", -1 /* HOISTED */);
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
var script$2 = /*#__PURE__*/ defineComponent({
    __name: 'TreePanel',
    props: {
        title: {
            type: String,
        },
        searchable: {
            type: Boolean,
        },
        searchPlaceholder: {
            type: String,
        },
        draggable: {
            type: Boolean,
        },
        data: {
            type: Array,
            default: () => [],
        },
        expandedKeys: {
            type: Array,
        },
        selectedKeys: {
            type: Array,
        },
        fieldNames: {
            type: Object,
            default: () => ({ children: 'children', title: 'title', key: 'key' }),
        },
        operations: {
            type: Object,
        },
        isOperationsHidden: {
            type: Function,
            default: () => false,
        },
    },
    emits: ["searchChange", "rootAddClick", "addClick", "copyClick", "editClick", "removeClick", "select", "drop", "update:data", "update:expandedKeys", "update:selectedKeys"],
    setup(__props, { emit }) {
        const props = __props;
        defineComponent({
            name: 'ScTreePanel',
        });
        const loop = (data, key, callback, parentKey) => {
            data.forEach((item, index, arr) => {
                const k = props.fieldNames?.key ?? 'key';
                if (item[k] === key) {
                    return callback(item, index, arr, parentKey);
                }
                if (item.children) {
                    return loop(item.children, key, callback, item[k]);
                }
            });
        };
        const addNodeKey = (data) => {
            data.forEach((item) => {
                if (!item.key) {
                    item.key = item[props.fieldNames?.key ?? 'key'];
                }
                if (item.children) {
                    addNodeKey(item.children);
                }
            });
        };
        // https://github.com/vueComponent/ant-design-vue/blob/2.x/components/vc-tree/src/util.js#L66
        watch(() => props.data, (newData) => {
            addNodeKey(newData);
        }, {
            immediate: true,
            deep: true,
        });
        const handleSearchChange = (value) => emit('searchChange', value);
        const handleRootAddClick = () => emit('rootAddClick');
        const handleAddClick = (node) => emit('addClick', node);
        const handleCopyClick = (node) => emit('copyClick', node);
        const handleEditClick = (node) => emit('editClick', node);
        const handleRemoveClick = (node) => emit('removeClick', node);
        const handleSelect = (keys, selectEvent) => {
            emit('update:selectedKeys', keys);
            emit('select', keys, selectEvent);
        };
        const showMoreActions = computed(() => {
            if (props.operations) {
                const { add, copy, edit, remove } = props.operations;
                return add && copy && edit && remove;
            }
            return false;
        });
        const onDragEnter = (info) => {
            console.log(info, 'drag enter', props);
            // expandedKeys 需要展开
            let expandedKeysMore = (typeof info.expandedKeys === 'string'
                ? [info.expandedKeys]
                : info.expandedKeys);
            let expandedKeysNew = [
                ...new Set([...(props.expandedKeys || [])].concat(expandedKeysMore)),
            ];
            emit('update:expandedKeys', expandedKeysNew);
        };
        const onExpand = (expandedKeys) => {
            emit('update:expandedKeys', expandedKeys);
        };
        const handleDrop = (info) => {
            const dropKey = info.node.key;
            const dragKey = info.dragNode.key;
            const dropPos = info.node.pos?.split('-') ?? [];
            const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
            const data = [...props.data];
            // Find dragObject
            let dragObj = {};
            loop(data, dragKey, (item, index, arr) => {
                arr?.splice(index, 1);
                dragObj = item;
            });
            if (!info.dropToGap) {
                // Drop on the content
                loop(data, dropKey, (item) => {
                    item.children = item.children || [];
                    /// where to insert 示例添加到头部，可以是随意位置
                    item.children.unshift(dragObj);
                });
            }
            else if ((info.node.children || []).length > 0 && info.node.expanded && dropPosition === 1) {
                loop(data, dropKey, (item) => {
                    item.children = item.children || [];
                    // where to insert 示例添加到头部，可以是随意位置
                    item.children.unshift(dragObj);
                });
            }
            else {
                let ar = [];
                let i = 0;
                loop(data, dropKey, (_item, index, arr) => {
                    ar = arr;
                    i = index;
                });
                if (dropPosition === -1) {
                    ar.splice(i, 0, dragObj);
                }
                else {
                    ar.splice(i + 1, 0, dragObj);
                }
            }
            let parentKey, order = 0;
            loop(data, dragKey, (item, index, arr, pKey) => {
                parentKey = pKey;
                order = index + 1;
            });
            const params = {
                key: dragKey,
                parentKey: parentKey,
                order,
            };
            emit('update:data', data);
            emit('drop', info, params);
        };
        const operations = computed(() => {
            const operations = {
                rootAdd: false,
                add: false,
                edit: false,
                remove: false,
            };
            Object.assign(operations, props.operations);
            return operations;
        });
        const searchValue = ref('');
        const getNodeTitle = (node) => {
            const titleKey = props.fieldNames?.title || 'title';
            return node[titleKey];
        };
        const findAllParentKeys = (arr, result = []) => {
            arr.map(({ children, key }) => {
                if (children && children?.length > 0) {
                    result.push(key);
                    findAllParentKeys(children, result);
                }
            });
            return result;
        };
        const expandAll = () => {
            const treeAllData = toRaw(props.data);
            const allParentKeys = findAllParentKeys(treeAllData);
            emit('update:expandedKeys', allParentKeys);
        };
        const collapseAll = () => {
            emit('update:expandedKeys', []);
        };
        const expandPart = (node) => {
            const allParentKeys = findAllParentKeys([node]);
            let newKeys = allParentKeys.concat(props.expandedKeys || []);
            newKeys = [...new Set(newKeys)];
            emit('update:expandedKeys', newKeys);
        };
        const collapsePart = (node) => {
            const allParentKeys = findAllParentKeys([node]);
            let newKeys = (props.expandedKeys || []).filter((k) => allParentKeys.indexOf(k) === -1);
            emit('update:expandedKeys', newKeys);
        };
        return (_ctx, _cache) => {
            const _component_a_button = resolveComponent("a-button");
            const _component_a_tooltip = resolveComponent("a-tooltip");
            const _component_a_input = resolveComponent("a-input");
            const _component_a_tree = resolveComponent("a-tree");
            return (openBlock(), createElementBlock("div", _hoisted_1$1, [
                (__props.title)
                    ? (openBlock(), createElementBlock("div", _hoisted_2$1, [
                        createElementVNode("span", null, [
                            createTextVNode(toDisplayString(__props.title) + " ", 1 /* TEXT */),
                            createElementVNode("span", _hoisted_3$1, [
                                createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "全部展开"
                                }, {
                                    default: withCtx(() => [
                                        createVNode(_component_a_button, {
                                            type: "text",
                                            size: "small",
                                            onClick: expandAll
                                        }, {
                                            default: withCtx(() => [
                                                _hoisted_4$1
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "全部收起"
                                }, {
                                    default: withCtx(() => [
                                        createVNode(_component_a_button, {
                                            type: "text",
                                            size: "small",
                                            onClick: collapseAll
                                        }, {
                                            default: withCtx(() => [
                                                _hoisted_5$1
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ])
                        ]),
                        createVNode(_component_a_tooltip, {
                            placement: "top",
                            title: unref(operations).rootAddTip
                        }, {
                            default: withCtx(() => [
                                (unref(operations).rootAdd)
                                    ? (openBlock(), createBlock(_component_a_button, {
                                        key: 0,
                                        type: "text",
                                        size: "small",
                                        onClick: _cache[0] || (_cache[0] = () => handleRootAddClick())
                                    }, {
                                        default: withCtx(() => [
                                            createVNode(unref(PlusOutlined))
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title"]),
                        renderSlot(_ctx.$slots, "titleExtra")
                    ]))
                    : createCommentVNode("v-if", true),
                createElementVNode("div", _hoisted_6, [
                    (__props.searchable)
                        ? (openBlock(), createElementBlock("div", _hoisted_7, [
                            createVNode(_component_a_input, {
                                "allow-clear": "",
                                size: "small",
                                placeholder: __props.searchPlaceholder || '搜索',
                                value: searchValue.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((searchValue).value = $event)),
                                onChange: _cache[2] || (_cache[2] = () => handleSearchChange(searchValue.value))
                            }, {
                                prefix: withCtx(() => [
                                    createVNode(unref(SearchOutlined))
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["placeholder", "value"])
                        ]))
                        : createCommentVNode("v-if", true),
                    createVNode(_component_a_tree, mergeProps({ blockNode: "" }, { ..._ctx.$attrs }, {
                        draggable: __props.draggable,
                        "tree-data": __props.data,
                        expandedKeys: __props.expandedKeys,
                        selectedKeys: __props.selectedKeys,
                        onSelect: handleSelect,
                        onDrop: handleDrop,
                        onDragenter: onDragEnter,
                        onExpand: onExpand
                    }), {
                        title: withCtx((node) => [
                            createElementVNode("div", _hoisted_8, [
                                createElementVNode("span", {
                                    class: "sc-tree-panel-node-title",
                                    title: getNodeTitle(node)
                                }, [
                                    renderSlot(_ctx.$slots, "prefix", { node: node }),
                                    (node.icon)
                                        ? (openBlock(), createElementBlock("i", {
                                            key: 0,
                                            class: "iconfont",
                                            innerHTML: node.icon
                                        }, null, 8 /* PROPS */, _hoisted_10))
                                        : createCommentVNode("v-if", true),
                                    createTextVNode(" " + toDisplayString(getNodeTitle(node)) + " ", 1 /* TEXT */),
                                    renderSlot(_ctx.$slots, "suffix", { node: node }),
                                    (node.children?.length)
                                        ? (openBlock(), createElementBlock("span", _hoisted_11, [
                                            createVNode(_component_a_tooltip, {
                                                placement: "top",
                                                title: "局部展开"
                                            }, {
                                                default: withCtx(() => [
                                                    createVNode(_component_a_button, {
                                                        type: "text",
                                                        size: "small",
                                                        onClick: withModifiers(($event) => (expandPart(node)), ["stop"])
                                                    }, {
                                                        default: withCtx(() => [
                                                            _hoisted_12
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */),
                                            createVNode(_component_a_tooltip, {
                                                placement: "top",
                                                title: "局部收起"
                                            }, {
                                                default: withCtx(() => [
                                                    createVNode(_component_a_button, {
                                                        type: "text",
                                                        size: "small",
                                                        onClick: withModifiers(($event) => (collapsePart(node)), ["stop"])
                                                    }, {
                                                        default: withCtx(() => [
                                                            _hoisted_13
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]))
                                        : createCommentVNode("v-if", true)
                                ], 8 /* PROPS */, _hoisted_9),
                                (!props.isOperationsHidden(node))
                                    ? (openBlock(), createElementBlock("span", {
                                        key: 0,
                                        class: "sc-tree-panel-node-buttons",
                                        onClick: _cache[3] || (_cache[3] = withModifiers(() => { }, ["stop"]))
                                    }, [
                                        createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: unref(operations).addTip
                                        }, {
                                            default: withCtx(() => [
                                                (unref(operations).add)
                                                    ? (openBlock(), createElementBlock("span", {
                                                        key: 0,
                                                        class: "node-button",
                                                        onClick: () => handleAddClick(node)
                                                    }, [
                                                        createVNode(unref(PlusOutlined))
                                                    ], 8 /* PROPS */, _hoisted_14))
                                                    : createCommentVNode("v-if", true)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]),
                                        createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: unref(operations).copyTip
                                        }, {
                                            default: withCtx(() => [
                                                (unref(operations).copy)
                                                    ? (openBlock(), createElementBlock("span", {
                                                        key: 0,
                                                        class: "node-button",
                                                        onClick: () => handleCopyClick(node)
                                                    }, [
                                                        createVNode(unref(CopyOutlined))
                                                    ], 8 /* PROPS */, _hoisted_15))
                                                    : createCommentVNode("v-if", true)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]),
                                        (unref(showMoreActions))
                                            ? (openBlock(), createBlock(unref(Dropdown), {
                                                key: 0,
                                                trigger: "click",
                                                "overlay-class-name": "sc-tree-panel-more-actions"
                                            }, {
                                                overlay: withCtx(() => [
                                                    createVNode(unref(Menu), null, {
                                                        default: withCtx(() => [
                                                            createVNode(unref(Menu).Item, null, {
                                                                default: withCtx(() => [
                                                                    (unref(operations).edit)
                                                                        ? (openBlock(), createElementBlock("span", {
                                                                            key: 0,
                                                                            class: "sc-tree-panel-more-actions-button",
                                                                            onClick: () => handleEditClick(node)
                                                                        }, [
                                                                            createVNode(unref(EditOutlined)),
                                                                            createTextVNode(" " + toDisplayString(unref(operations).editTip), 1 /* TEXT */)
                                                                        ], 8 /* PROPS */, _hoisted_17))
                                                                        : createCommentVNode("v-if", true)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */),
                                                            createVNode(unref(Menu).Item, null, {
                                                                default: withCtx(() => [
                                                                    (unref(operations).remove)
                                                                        ? (openBlock(), createElementBlock("span", {
                                                                            key: 0,
                                                                            onClick: () => handleRemoveClick(node),
                                                                            class: "sc-tree-panel-more-actions-button"
                                                                        }, [
                                                                            createVNode(unref(DeleteOutlined)),
                                                                            createTextVNode(" " + toDisplayString(unref(operations).removeTip), 1 /* TEXT */)
                                                                        ], 8 /* PROPS */, _hoisted_18))
                                                                        : createCommentVNode("v-if", true)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                default: withCtx(() => [
                                                    _hoisted_16
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                                createVNode(_component_a_tooltip, {
                                                    placement: "top",
                                                    title: unref(operations).editTip
                                                }, {
                                                    default: withCtx(() => [
                                                        (unref(operations).edit)
                                                            ? (openBlock(), createElementBlock("span", {
                                                                key: 0,
                                                                class: "node-button",
                                                                onClick: () => handleEditClick(node)
                                                            }, [
                                                                createVNode(unref(EditOutlined))
                                                            ], 8 /* PROPS */, _hoisted_19))
                                                            : createCommentVNode("v-if", true)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]),
                                                createVNode(_component_a_tooltip, {
                                                    placement: "top",
                                                    title: unref(operations).removeTip
                                                }, {
                                                    default: withCtx(() => [
                                                        (unref(operations).remove)
                                                            ? (openBlock(), createElementBlock("span", {
                                                                key: 0,
                                                                class: "node-button",
                                                                onClick: () => handleRemoveClick(node)
                                                            }, [
                                                                createVNode(unref(DeleteOutlined))
                                                            ], 8 /* PROPS */, _hoisted_20))
                                                            : createCommentVNode("v-if", true)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"])
                                            ], 64 /* STABLE_FRAGMENT */))
                                    ]))
                                    : createCommentVNode("v-if", true)
                            ])
                        ]),
                        _: 3 /* FORWARDED */
                    }, 16 /* FULL_PROPS */, ["draggable", "tree-data", "expandedKeys", "selectedKeys"])
                ])
            ]));
        };
    }
});

script$2.__file = "packages/tree-panel/src/TreePanel.vue";

script$2.install = (Vue) => {
    Vue.component(script$2.name, script$2);
};

var script$1 = defineComponent({
    name: 'ScTree',
    props: {
        string: {
            type: String,
            default: '',
        },
        boolean: {
            type: [Boolean],
            default: false,
        },
        datas: {
            type: Array,
            default: () => [],
        },
        object: {
            type: Object,
            default: () => ({}),
        },
        function: {
            type: Object,
            default: () => null,
        },
    },
    setup(props) {
        const deepClone = (datas) => {
            const items = [];
            datas.map((item) => {
                items.push({
                    key: item.id,
                    title: item.name,
                    children: deepClone(item.children),
                });
            });
            return items;
        };
        const treeData = computed(() => deepClone(props.datas));
        return { treeData };
    },
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tree = resolveComponent("a-tree");

  return (openBlock(), createBlock(_component_a_tree, mergeProps({ class: "sc-tree" }, { ..._ctx.$attrs }, { treeData: _ctx.treeData }), null, 16 /* FULL_PROPS */, ["treeData"]))
}

script$1.render = render$1;
script$1.__file = "packages/tree/src/Tree.vue";

script$1.install = (Vue) => {
    Vue.component(script$1.name, script$1);
};

/**
 * 参数说明:
 * visible: boolean, 是否显示弹框
 * uploadTipsList: string[], 提示信息数组(支持html)
 * uploadFormItems: IFormItem[], 其他表单项数组(参考BasicFormItem组件)
 * submitData: ISubmitData, 提交的数据
 * uploadProps: {}, 上传组件参数(参考antd上传组件-Upload)
 * 支持传入Modal组件相关参数(参考Modal组件)
 *
 */
var script = defineComponent({
    name: 'ScUploadModal',
    components: { BasicFormItem: script$1v, Modal: script$1N },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        uploadTipsList: {
            type: Array,
            default: () => [],
        },
        uploadFormItems: {
            type: Array,
            default: () => [],
        },
        submitData: {
            type: Object,
            default: () => ({}),
        },
        uploadProps: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        const visibleRef = computed({
            get: () => props.visible,
            set: (val) => {
                emit('update:visible', val);
            },
        });
        const submitDataRef = computed({
            get: () => props.submitData,
            set: (val) => {
                emit('update:submitData', val);
            },
        });
        // 文件列表
        const fileList = ref([]);
        // 表单项
        const formItems = reactive(props.uploadFormItems);
        // 提示信息
        const tipsList = ref(props.uploadTipsList);
        // beforeUpload 返回 false 后，手动上传文件。
        const beforeUpload = (file, callback) => {
            fileList.value = [file];
            submitDataRef.value.file = fileList.value[0];
            callback && callback(file);
            return false;
        };
        watch(() => visibleRef.value, () => {
            if (!visibleRef.value) {
                fileList.value = [];
                delete submitDataRef.value.file;
            }
        }, { deep: true });
        return {
            visibleRef,
            fileList,
            formItems,
            tipsList,
            submitDataRef,
            beforeUpload,
        };
    },
});

const _hoisted_1 = { class: "upload-input-wrap" };
const _hoisted_2 = ["title"];
const _hoisted_3 = { class: "upload-conditions" };
const _hoisted_4 = {
  key: 0,
  class: "upload-tips-wrap"
};
const _hoisted_5 = ["innerHTML"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = resolveComponent("a-input");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_upload = resolveComponent("a-upload");
  const _component_BasicFormItem = resolveComponent("BasicFormItem");
  const _component_a_form = resolveComponent("a-form");
  const _component_Modal = resolveComponent("Modal");

  return (openBlock(), createBlock(_component_Modal, mergeProps({
    class: "sc-upload-modal",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visibleRef) = $event)),
    width: "455px",
    getPopupContainer: (triggerNode) => triggerNode.parentNode
  }, { ..._ctx.$props, ..._ctx.$attrs }), {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1, [
        createVNode(_component_a_upload, mergeProps({ ..._ctx.uploadProps }, {
          "file-list": _ctx.fileList,
          "before-upload": 
          (file) => _ctx.beforeUpload(file, _ctx.uploadProps && _ctx.uploadProps.beforeUpload)
        ,
          showUploadList: false
        }), {
          default: withCtx(() => [
            createElementVNode("div", {
              class: "upload-input-box",
              title: _ctx.fileList.length > 0 ? _ctx.fileList[0].name : ''
            }, [
              createVNode(_component_a_input, {
                readonly: "",
                placeholder: "请选择文件",
                value: _ctx.fileList.length > 0 ? _ctx.fileList[0].name : ''
              }, null, 8 /* PROPS */, ["value"]),
              createVNode(_component_a_button, null, {
                default: withCtx(() => [
                  createTextVNode("选择文件")
                ]),
                _: 1 /* STABLE */
              })
            ], 8 /* PROPS */, _hoisted_2)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["file-list", "before-upload"])
      ]),
      createElementVNode("div", _hoisted_3, [
        createVNode(_component_a_form, null, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formItems, (item) => {
              return (openBlock(), createBlock(_component_BasicFormItem, {
                item: item,
                key: item.key,
                value: _ctx.submitDataRef[item.key],
                "onUpdate:value": $event => ((_ctx.submitDataRef[item.key]) = $event),
                labelAlign: "right",
                colon: false
              }, null, 8 /* PROPS */, ["item", "value", "onUpdate:value"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }),
        renderSlot(_ctx.$slots, "uploadConditions")
      ]),
      (_ctx.tipsList && _ctx.tipsList.length > 0)
        ? (openBlock(), createElementBlock("div", _hoisted_4, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tipsList, (item, index) => {
              return (openBlock(), createElementBlock("p", {
                key: index,
                innerHTML: index + 1 + '、' + item
              }, null, 8 /* PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["visible", "getPopupContainer"]))
}

script.render = render;
script.__file = "packages/upload-modal/src/UploadModal.vue";

script.install = (Vue) => {
    Vue.component(script.name, script);
};

const components = [
    script$x,
    script$i,
    script$1K,
    script$7,
    script$1D,
    script$1E,
    script$5,
    script$4,
    script$w,
    script$1b,
    script$19,
    script$18,
    script$p,
    script$16,
    script$14,
    script$10,
    script$$,
    script$11,
    script$13,
    script$1v,
    script$X,
    script$1g,
    script$u,
    script$S,
    script$b,
    // Profile,
    script$H,
    script$G,
    script$3,
    script$1,
    script$2,
    script$1z,
    script$1h,
    script$P,
    script$O,
    script$T,
    script$Q,
    script$J,
    script$K,
    script$R,
    script$M,
    script$1C,
    script$1y,
    script$t,
    script$s,
    script$1u,
    script$q,
    script$U,
    script$6,
    script$f,
    script$F,
    script$y,
    script$A,
    script$z,
    script$1B,
    script$1N,
    $modal,
    script,
    script$r,
    script$1o,
    script$B,
    script$C,
    script$I,
    script$c,
    script$d,
    script$e,
    script$_,
    script$V,
    script$1w,
    script$8,
];
const install = function (Vue) {
    components.forEach((component) => {
        Vue.component(component.name, component);
    });
};
var index = {
    install,
};

export { $modal, script$U as AddAddressInfoModal, script$V as AddressAutoFill, script$13 as AdvancedSearch, script$T as ApprovalChainModal, script$P as ApprovalDetail, script$O as ApprovalPrint, script$J as ApprovalProcess, script$M as Approver, script$R as Avatar, script$1M as BasicForm, script$1v as BasicFormItem, script$1b as BasicGrid, script$1h as Button, script$1B as Cascader, script$1g as CellCommonRenderer, script$1z as Checkbox, script$I as CityPicker, script$H as Collapse, script$G as CollapsePanel, script$F as ColorPicker, script$B as CompanyInformation, script$A as CreateBrand, script$C as CreateCompany, script$y as CreateModel, script$z as CreateSeries, script$x as Crumb, script$w as CustomInputGroup, script$5 as CustomizeModal, script$u as Descriptions, script$t as DescriptionsForm, script$s as DetailPageForm, script$14 as Draggable, script$16 as Drawer, script$19 as DualGrid, script$r as EditShelfInformation, script$4 as EditableCell, script$K as EmployeeModal, script$q as ExportQuotationModal, GridColumnWidths, script$p as ImageGallery, script$18 as InnerGrid, script$b as InvoiceProcess, script$i as Layout, script$f as MistakePopconfirm, script$1N as Modal, script$1u as ModalForm, script$1C as MultiInput, script$1E as MultiSearch, script$1D as MultiSelect, script$1K as NewRangePicker, script$11 as NewSearchBar, script$_ as NoData, script$c as Page, script$e as PageFooter, script$d as PageHeader, script$1o as Popconfirm, script$8 as ScBreadcrumb, script$7 as SearchBar, script$X as SearchForm, script$10 as SearchSave, script$$ as SearchTags, script$6 as SelectWarehouseModal, script$a as SpecificationSelect, script$S as Steps, script$Q as Timeline, script$3 as TotalBar, script$1 as Tree, script$2 as TreePanel, script$1y as Upload, script as UploadModal, VALIDATOR, script$1w as VnodeHtmlRenderer, index as default, formatter, getQueryKeywords, getState, getUserInfo, http, math, removeState, setState, setlistValue, useInnerGrid$1 as useInnerGrid, writingFormat };
